function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5906"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5906"] = parcelRequire;
}
parcelRequire.register("5Wgfu", function(module, exports) {
"use strict";

module.exports = (parcelRequire("91Z9E"));

});
parcelRequire.register("91Z9E", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $6933a5158fb8aa46$export$ffb0004e005737fa; }, function (v) { return $6933a5158fb8aa46$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $6933a5158fb8aa46$export$34b9dba7ce09269b; }, function (v) { return $6933a5158fb8aa46$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $6933a5158fb8aa46$export$25062201e9e25d76; }, function (v) { return $6933a5158fb8aa46$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6933a5158fb8aa46$export$ffb0004e005737fa;
var $6933a5158fb8aa46$export$34b9dba7ce09269b;
var $6933a5158fb8aa46$export$25062201e9e25d76;
"use strict";

var $aOChP = parcelRequire("aOChP");
var $6933a5158fb8aa46$var$k = Symbol.for("react.element"), $6933a5158fb8aa46$var$l = Symbol.for("react.fragment"), $6933a5158fb8aa46$var$m = Object.prototype.hasOwnProperty, $6933a5158fb8aa46$var$n = $aOChP.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $6933a5158fb8aa46$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $6933a5158fb8aa46$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$6933a5158fb8aa46$var$m.call(a, b) && !$6933a5158fb8aa46$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $6933a5158fb8aa46$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $6933a5158fb8aa46$var$n.current
    };
}
$6933a5158fb8aa46$export$ffb0004e005737fa = $6933a5158fb8aa46$var$l;
$6933a5158fb8aa46$export$34b9dba7ce09269b = $6933a5158fb8aa46$var$q;
$6933a5158fb8aa46$export$25062201e9e25d76 = $6933a5158fb8aa46$var$q;

});
parcelRequire.register("aOChP", function(module, exports) {
"use strict";

module.exports = (parcelRequire("iYrK1"));

});
parcelRequire.register("iYrK1", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $dd035970bb0a7189$export$dca3b0875bd9a954; }, function (v) { return $dd035970bb0a7189$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $dd035970bb0a7189$export$16fa2f45be04daa8; }, function (v) { return $dd035970bb0a7189$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $dd035970bb0a7189$export$ffb0004e005737fa; }, function (v) { return $dd035970bb0a7189$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $dd035970bb0a7189$export$e2c29f18771995cb; }, function (v) { return $dd035970bb0a7189$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $dd035970bb0a7189$export$221d75b3f55bb0bd; }, function (v) { return $dd035970bb0a7189$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $dd035970bb0a7189$export$5f8d39834fd61797; }, function (v) { return $dd035970bb0a7189$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $dd035970bb0a7189$export$74bf444e3cd11ea5; }, function (v) { return $dd035970bb0a7189$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $dd035970bb0a7189$export$ae55be85d98224ed; }, function (v) { return $dd035970bb0a7189$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $dd035970bb0a7189$export$e530037191fcd5d7; }, function (v) { return $dd035970bb0a7189$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $dd035970bb0a7189$export$fd42f52fd3ae1109; }, function (v) { return $dd035970bb0a7189$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $dd035970bb0a7189$export$c8a8987d4410bf2d; }, function (v) { return $dd035970bb0a7189$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $dd035970bb0a7189$export$d38cd72104c1f0e9; }, function (v) { return $dd035970bb0a7189$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $dd035970bb0a7189$export$7d1e3a5e95ceca43; }, function (v) { return $dd035970bb0a7189$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $dd035970bb0a7189$export$257a8862b851cb5b; }, function (v) { return $dd035970bb0a7189$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $dd035970bb0a7189$export$a8257692ac88316c; }, function (v) { return $dd035970bb0a7189$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $dd035970bb0a7189$export$488013bae63b21da; }, function (v) { return $dd035970bb0a7189$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $dd035970bb0a7189$export$7c73462e0d25e514; }, function (v) { return $dd035970bb0a7189$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $dd035970bb0a7189$export$7568632d0d33d16d; }, function (v) { return $dd035970bb0a7189$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $dd035970bb0a7189$export$88948ce120ea2619; }, function (v) { return $dd035970bb0a7189$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $dd035970bb0a7189$export$35808ee640e87ca7; }, function (v) { return $dd035970bb0a7189$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $dd035970bb0a7189$export$fae74005e78b1a27; }, function (v) { return $dd035970bb0a7189$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $dd035970bb0a7189$export$dc8fbce3eb94dc1e; }, function (v) { return $dd035970bb0a7189$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $dd035970bb0a7189$export$6a7bc4e911dc01cf; }, function (v) { return $dd035970bb0a7189$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $dd035970bb0a7189$export$6d9c69b0de29b591; }, function (v) { return $dd035970bb0a7189$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $dd035970bb0a7189$export$f680877a34711e37; }, function (v) { return $dd035970bb0a7189$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $dd035970bb0a7189$export$d5a552a76deda3c2; }, function (v) { return $dd035970bb0a7189$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $dd035970bb0a7189$export$aaabe4eda9ed9969; }, function (v) { return $dd035970bb0a7189$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $dd035970bb0a7189$export$e5c5a5f917a5871c; }, function (v) { return $dd035970bb0a7189$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $dd035970bb0a7189$export$1538c33de8887b59; }, function (v) { return $dd035970bb0a7189$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $dd035970bb0a7189$export$13e3392192263954; }, function (v) { return $dd035970bb0a7189$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $dd035970bb0a7189$export$b8f5890fc79d6aca; }, function (v) { return $dd035970bb0a7189$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $dd035970bb0a7189$export$60241385465d0a34; }, function (v) { return $dd035970bb0a7189$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $dd035970bb0a7189$export$306c0aa65ff9ec16; }, function (v) { return $dd035970bb0a7189$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $dd035970bb0a7189$export$7b286972b8d8ccbf; }, function (v) { return $dd035970bb0a7189$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $dd035970bb0a7189$export$83d89fbfd8236492; }, function (v) { return $dd035970bb0a7189$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd035970bb0a7189$export$dca3b0875bd9a954;
var $dd035970bb0a7189$export$16fa2f45be04daa8;
var $dd035970bb0a7189$export$ffb0004e005737fa;
var $dd035970bb0a7189$export$e2c29f18771995cb;
var $dd035970bb0a7189$export$221d75b3f55bb0bd;
var $dd035970bb0a7189$export$5f8d39834fd61797;
var $dd035970bb0a7189$export$74bf444e3cd11ea5;
var $dd035970bb0a7189$export$ae55be85d98224ed;
var $dd035970bb0a7189$export$e530037191fcd5d7;
var $dd035970bb0a7189$export$fd42f52fd3ae1109;
var $dd035970bb0a7189$export$c8a8987d4410bf2d;
var $dd035970bb0a7189$export$d38cd72104c1f0e9;
var $dd035970bb0a7189$export$7d1e3a5e95ceca43;
var $dd035970bb0a7189$export$257a8862b851cb5b;
var $dd035970bb0a7189$export$a8257692ac88316c;
var $dd035970bb0a7189$export$488013bae63b21da;
var $dd035970bb0a7189$export$7c73462e0d25e514;
var $dd035970bb0a7189$export$7568632d0d33d16d;
var $dd035970bb0a7189$export$88948ce120ea2619;
var $dd035970bb0a7189$export$35808ee640e87ca7;
var $dd035970bb0a7189$export$fae74005e78b1a27;
var $dd035970bb0a7189$export$dc8fbce3eb94dc1e;
var $dd035970bb0a7189$export$6a7bc4e911dc01cf;
var $dd035970bb0a7189$export$6d9c69b0de29b591;
var $dd035970bb0a7189$export$f680877a34711e37;
var $dd035970bb0a7189$export$d5a552a76deda3c2;
var $dd035970bb0a7189$export$aaabe4eda9ed9969;
var $dd035970bb0a7189$export$e5c5a5f917a5871c;
var $dd035970bb0a7189$export$1538c33de8887b59;
var $dd035970bb0a7189$export$13e3392192263954;
var $dd035970bb0a7189$export$b8f5890fc79d6aca;
var $dd035970bb0a7189$export$60241385465d0a34;
var $dd035970bb0a7189$export$306c0aa65ff9ec16;
var $dd035970bb0a7189$export$7b286972b8d8ccbf;
var $dd035970bb0a7189$export$83d89fbfd8236492;
"use strict";
var $dd035970bb0a7189$var$l = Symbol.for("react.element"), $dd035970bb0a7189$var$n = Symbol.for("react.portal"), $dd035970bb0a7189$var$p = Symbol.for("react.fragment"), $dd035970bb0a7189$var$q = Symbol.for("react.strict_mode"), $dd035970bb0a7189$var$r = Symbol.for("react.profiler"), $dd035970bb0a7189$var$t = Symbol.for("react.provider"), $dd035970bb0a7189$var$u = Symbol.for("react.context"), $dd035970bb0a7189$var$v = Symbol.for("react.forward_ref"), $dd035970bb0a7189$var$w = Symbol.for("react.suspense"), $dd035970bb0a7189$var$x = Symbol.for("react.memo"), $dd035970bb0a7189$var$y = Symbol.for("react.lazy"), $dd035970bb0a7189$var$z = Symbol.iterator;
function $dd035970bb0a7189$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $dd035970bb0a7189$var$z && a[$dd035970bb0a7189$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $dd035970bb0a7189$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $dd035970bb0a7189$var$C = Object.assign, $dd035970bb0a7189$var$D = {};
function $dd035970bb0a7189$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd035970bb0a7189$var$D;
    this.updater = e || $dd035970bb0a7189$var$B;
}
$dd035970bb0a7189$var$E.prototype.isReactComponent = {};
$dd035970bb0a7189$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$dd035970bb0a7189$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $dd035970bb0a7189$var$F() {}
$dd035970bb0a7189$var$F.prototype = $dd035970bb0a7189$var$E.prototype;
function $dd035970bb0a7189$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd035970bb0a7189$var$D;
    this.updater = e || $dd035970bb0a7189$var$B;
}
var $dd035970bb0a7189$var$H = $dd035970bb0a7189$var$G.prototype = new $dd035970bb0a7189$var$F;
$dd035970bb0a7189$var$H.constructor = $dd035970bb0a7189$var$G;
$dd035970bb0a7189$var$C($dd035970bb0a7189$var$H, $dd035970bb0a7189$var$E.prototype);
$dd035970bb0a7189$var$H.isPureReactComponent = !0;
var $dd035970bb0a7189$var$I = Array.isArray, $dd035970bb0a7189$var$J = Object.prototype.hasOwnProperty, $dd035970bb0a7189$var$K = {
    current: null
}, $dd035970bb0a7189$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $dd035970bb0a7189$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$dd035970bb0a7189$var$J.call(b, d) && !$dd035970bb0a7189$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $dd035970bb0a7189$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $dd035970bb0a7189$var$K.current
    };
}
function $dd035970bb0a7189$var$N(a, b) {
    return {
        $$typeof: $dd035970bb0a7189$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $dd035970bb0a7189$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $dd035970bb0a7189$var$l;
}
function $dd035970bb0a7189$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $dd035970bb0a7189$var$P = /\/+/g;
function $dd035970bb0a7189$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $dd035970bb0a7189$var$escape("" + a.key) : b.toString(36);
}
function $dd035970bb0a7189$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $dd035970bb0a7189$var$l:
                case $dd035970bb0a7189$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $dd035970bb0a7189$var$Q(h, 0) : d, $dd035970bb0a7189$var$I(c) ? (e = "", null != a && (e = a.replace($dd035970bb0a7189$var$P, "$&/") + "/"), $dd035970bb0a7189$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($dd035970bb0a7189$var$O(c) && (c = $dd035970bb0a7189$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($dd035970bb0a7189$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($dd035970bb0a7189$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $dd035970bb0a7189$var$Q(k, g);
        h += $dd035970bb0a7189$var$R(k, b, e, f, c);
    }
    else if (f = $dd035970bb0a7189$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $dd035970bb0a7189$var$Q(k, g++), h += $dd035970bb0a7189$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $dd035970bb0a7189$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $dd035970bb0a7189$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $dd035970bb0a7189$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $dd035970bb0a7189$var$U = {
    current: null
}, $dd035970bb0a7189$var$V = {
    transition: null
}, $dd035970bb0a7189$var$W = {
    ReactCurrentDispatcher: $dd035970bb0a7189$var$U,
    ReactCurrentBatchConfig: $dd035970bb0a7189$var$V,
    ReactCurrentOwner: $dd035970bb0a7189$var$K
};
$dd035970bb0a7189$export$dca3b0875bd9a954 = {
    map: $dd035970bb0a7189$var$S,
    forEach: function(a, b, e) {
        $dd035970bb0a7189$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $dd035970bb0a7189$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $dd035970bb0a7189$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$dd035970bb0a7189$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$dd035970bb0a7189$export$16fa2f45be04daa8 = $dd035970bb0a7189$var$E;
$dd035970bb0a7189$export$ffb0004e005737fa = $dd035970bb0a7189$var$p;
$dd035970bb0a7189$export$e2c29f18771995cb = $dd035970bb0a7189$var$r;
$dd035970bb0a7189$export$221d75b3f55bb0bd = $dd035970bb0a7189$var$G;
$dd035970bb0a7189$export$5f8d39834fd61797 = $dd035970bb0a7189$var$q;
$dd035970bb0a7189$export$74bf444e3cd11ea5 = $dd035970bb0a7189$var$w;
$dd035970bb0a7189$export$ae55be85d98224ed = $dd035970bb0a7189$var$W;
$dd035970bb0a7189$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $dd035970bb0a7189$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $dd035970bb0a7189$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$dd035970bb0a7189$var$J.call(b, f) && !$dd035970bb0a7189$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $dd035970bb0a7189$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$dd035970bb0a7189$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $dd035970bb0a7189$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $dd035970bb0a7189$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$dd035970bb0a7189$export$c8a8987d4410bf2d = $dd035970bb0a7189$var$M;
$dd035970bb0a7189$export$d38cd72104c1f0e9 = function(a) {
    var b = $dd035970bb0a7189$var$M.bind(null, a);
    b.type = a;
    return b;
};
$dd035970bb0a7189$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$dd035970bb0a7189$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $dd035970bb0a7189$var$v,
        render: a
    };
};
$dd035970bb0a7189$export$a8257692ac88316c = $dd035970bb0a7189$var$O;
$dd035970bb0a7189$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $dd035970bb0a7189$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $dd035970bb0a7189$var$T
    };
};
$dd035970bb0a7189$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $dd035970bb0a7189$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$dd035970bb0a7189$export$7568632d0d33d16d = function(a) {
    var b = $dd035970bb0a7189$var$V.transition;
    $dd035970bb0a7189$var$V.transition = {};
    try {
        a();
    } finally{
        $dd035970bb0a7189$var$V.transition = b;
    }
};
$dd035970bb0a7189$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$dd035970bb0a7189$export$35808ee640e87ca7 = function(a, b) {
    return $dd035970bb0a7189$var$U.current.useCallback(a, b);
};
$dd035970bb0a7189$export$fae74005e78b1a27 = function(a) {
    return $dd035970bb0a7189$var$U.current.useContext(a);
};
$dd035970bb0a7189$export$dc8fbce3eb94dc1e = function() {};
$dd035970bb0a7189$export$6a7bc4e911dc01cf = function(a) {
    return $dd035970bb0a7189$var$U.current.useDeferredValue(a);
};
$dd035970bb0a7189$export$6d9c69b0de29b591 = function(a, b) {
    return $dd035970bb0a7189$var$U.current.useEffect(a, b);
};
$dd035970bb0a7189$export$f680877a34711e37 = function() {
    return $dd035970bb0a7189$var$U.current.useId();
};
$dd035970bb0a7189$export$d5a552a76deda3c2 = function(a, b, e) {
    return $dd035970bb0a7189$var$U.current.useImperativeHandle(a, b, e);
};
$dd035970bb0a7189$export$aaabe4eda9ed9969 = function(a, b) {
    return $dd035970bb0a7189$var$U.current.useInsertionEffect(a, b);
};
$dd035970bb0a7189$export$e5c5a5f917a5871c = function(a, b) {
    return $dd035970bb0a7189$var$U.current.useLayoutEffect(a, b);
};
$dd035970bb0a7189$export$1538c33de8887b59 = function(a, b) {
    return $dd035970bb0a7189$var$U.current.useMemo(a, b);
};
$dd035970bb0a7189$export$13e3392192263954 = function(a, b, e) {
    return $dd035970bb0a7189$var$U.current.useReducer(a, b, e);
};
$dd035970bb0a7189$export$b8f5890fc79d6aca = function(a) {
    return $dd035970bb0a7189$var$U.current.useRef(a);
};
$dd035970bb0a7189$export$60241385465d0a34 = function(a) {
    return $dd035970bb0a7189$var$U.current.useState(a);
};
$dd035970bb0a7189$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $dd035970bb0a7189$var$U.current.useSyncExternalStore(a, b, e);
};
$dd035970bb0a7189$export$7b286972b8d8ccbf = function() {
    return $dd035970bb0a7189$var$U.current.useTransition();
};
$dd035970bb0a7189$export$83d89fbfd8236492 = "18.2.0";

});




parcelRequire.register("edP6V", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $a5a9ed1d43a3a911$export$ae55be85d98224ed; }, function (v) { return $a5a9ed1d43a3a911$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $a5a9ed1d43a3a911$export$d39a5bbd09211389; }, function (v) { return $a5a9ed1d43a3a911$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $a5a9ed1d43a3a911$export$882461b6382ed46c; }, function (v) { return $a5a9ed1d43a3a911$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $a5a9ed1d43a3a911$export$466bfc07425424d5; }, function (v) { return $a5a9ed1d43a3a911$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $a5a9ed1d43a3a911$export$cd75ccfd720a3cd4; }, function (v) { return $a5a9ed1d43a3a911$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $a5a9ed1d43a3a911$export$fa8d919ba61d84db; }, function (v) { return $a5a9ed1d43a3a911$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $a5a9ed1d43a3a911$export$757ceba2d55c277e; }, function (v) { return $a5a9ed1d43a3a911$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $a5a9ed1d43a3a911$export$b3890eb0ae9dca99; }, function (v) { return $a5a9ed1d43a3a911$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $a5a9ed1d43a3a911$export$502457920280e6be; }, function (v) { return $a5a9ed1d43a3a911$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $a5a9ed1d43a3a911$export$c78a37762a8d58e1; }, function (v) { return $a5a9ed1d43a3a911$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $a5a9ed1d43a3a911$export$dc54d992c10e8a18; }, function (v) { return $a5a9ed1d43a3a911$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $a5a9ed1d43a3a911$export$83d89fbfd8236492; }, function (v) { return $a5a9ed1d43a3a911$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $a5a9ed1d43a3a911$export$ae55be85d98224ed;
var $a5a9ed1d43a3a911$export$d39a5bbd09211389;
var $a5a9ed1d43a3a911$export$882461b6382ed46c;
var $a5a9ed1d43a3a911$export$466bfc07425424d5;
var $a5a9ed1d43a3a911$export$cd75ccfd720a3cd4;
var $a5a9ed1d43a3a911$export$fa8d919ba61d84db;
var $a5a9ed1d43a3a911$export$757ceba2d55c277e;
var $a5a9ed1d43a3a911$export$b3890eb0ae9dca99;
var $a5a9ed1d43a3a911$export$502457920280e6be;
var $a5a9ed1d43a3a911$export$c78a37762a8d58e1;
var $a5a9ed1d43a3a911$export$dc54d992c10e8a18;
var $a5a9ed1d43a3a911$export$83d89fbfd8236492;
"use strict";

var $aOChP = parcelRequire("aOChP");

var $c22GA = parcelRequire("c22GA");
function $a5a9ed1d43a3a911$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $a5a9ed1d43a3a911$var$da = new Set, $a5a9ed1d43a3a911$var$ea = {};
function $a5a9ed1d43a3a911$var$fa(a, b) {
    $a5a9ed1d43a3a911$var$ha(a, b);
    $a5a9ed1d43a3a911$var$ha(a + "Capture", b);
}
function $a5a9ed1d43a3a911$var$ha(a, b) {
    $a5a9ed1d43a3a911$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$a5a9ed1d43a3a911$var$da.add(b[a]);
}
var $a5a9ed1d43a3a911$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $a5a9ed1d43a3a911$var$ja = Object.prototype.hasOwnProperty, $a5a9ed1d43a3a911$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $a5a9ed1d43a3a911$var$la = {}, $a5a9ed1d43a3a911$var$ma = {};
function $a5a9ed1d43a3a911$var$oa(a) {
    if ($a5a9ed1d43a3a911$var$ja.call($a5a9ed1d43a3a911$var$ma, a)) return !0;
    if ($a5a9ed1d43a3a911$var$ja.call($a5a9ed1d43a3a911$var$la, a)) return !1;
    if ($a5a9ed1d43a3a911$var$ka.test(a)) return $a5a9ed1d43a3a911$var$ma[a] = !0;
    $a5a9ed1d43a3a911$var$la[a] = !0;
    return !1;
}
function $a5a9ed1d43a3a911$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $a5a9ed1d43a3a911$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $a5a9ed1d43a3a911$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $a5a9ed1d43a3a911$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $a5a9ed1d43a3a911$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $a5a9ed1d43a3a911$var$z[a] = new $a5a9ed1d43a3a911$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $a5a9ed1d43a3a911$var$z[b] = new $a5a9ed1d43a3a911$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $a5a9ed1d43a3a911$var$z[a] = new $a5a9ed1d43a3a911$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $a5a9ed1d43a3a911$var$z[a] = new $a5a9ed1d43a3a911$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $a5a9ed1d43a3a911$var$z[a] = new $a5a9ed1d43a3a911$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $a5a9ed1d43a3a911$var$z[a] = new $a5a9ed1d43a3a911$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $a5a9ed1d43a3a911$var$z[a] = new $a5a9ed1d43a3a911$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $a5a9ed1d43a3a911$var$z[a] = new $a5a9ed1d43a3a911$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $a5a9ed1d43a3a911$var$z[a] = new $a5a9ed1d43a3a911$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $a5a9ed1d43a3a911$var$ra = /[\-:]([a-z])/g;
function $a5a9ed1d43a3a911$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($a5a9ed1d43a3a911$var$ra, $a5a9ed1d43a3a911$var$sa);
    $a5a9ed1d43a3a911$var$z[b] = new $a5a9ed1d43a3a911$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($a5a9ed1d43a3a911$var$ra, $a5a9ed1d43a3a911$var$sa);
    $a5a9ed1d43a3a911$var$z[b] = new $a5a9ed1d43a3a911$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($a5a9ed1d43a3a911$var$ra, $a5a9ed1d43a3a911$var$sa);
    $a5a9ed1d43a3a911$var$z[b] = new $a5a9ed1d43a3a911$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $a5a9ed1d43a3a911$var$z[a] = new $a5a9ed1d43a3a911$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$a5a9ed1d43a3a911$var$z.xlinkHref = new $a5a9ed1d43a3a911$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $a5a9ed1d43a3a911$var$z[a] = new $a5a9ed1d43a3a911$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $a5a9ed1d43a3a911$var$ta(a, b, c, d) {
    var e = $a5a9ed1d43a3a911$var$z.hasOwnProperty(b) ? $a5a9ed1d43a3a911$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $a5a9ed1d43a3a911$var$qa(b, c, e, d) && (c = null), d || null === e ? $a5a9ed1d43a3a911$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $a5a9ed1d43a3a911$var$ua = $aOChP.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $a5a9ed1d43a3a911$var$va = Symbol.for("react.element"), $a5a9ed1d43a3a911$var$wa = Symbol.for("react.portal"), $a5a9ed1d43a3a911$var$ya = Symbol.for("react.fragment"), $a5a9ed1d43a3a911$var$za = Symbol.for("react.strict_mode"), $a5a9ed1d43a3a911$var$Aa = Symbol.for("react.profiler"), $a5a9ed1d43a3a911$var$Ba = Symbol.for("react.provider"), $a5a9ed1d43a3a911$var$Ca = Symbol.for("react.context"), $a5a9ed1d43a3a911$var$Da = Symbol.for("react.forward_ref"), $a5a9ed1d43a3a911$var$Ea = Symbol.for("react.suspense"), $a5a9ed1d43a3a911$var$Fa = Symbol.for("react.suspense_list"), $a5a9ed1d43a3a911$var$Ga = Symbol.for("react.memo"), $a5a9ed1d43a3a911$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $a5a9ed1d43a3a911$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $a5a9ed1d43a3a911$var$Ja = Symbol.iterator;
function $a5a9ed1d43a3a911$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $a5a9ed1d43a3a911$var$Ja && a[$a5a9ed1d43a3a911$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $a5a9ed1d43a3a911$var$A = Object.assign, $a5a9ed1d43a3a911$var$La;
function $a5a9ed1d43a3a911$var$Ma(a) {
    if (void 0 === $a5a9ed1d43a3a911$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $a5a9ed1d43a3a911$var$La = b && b[1] || "";
    }
    return "\n" + $a5a9ed1d43a3a911$var$La + a;
}
var $a5a9ed1d43a3a911$var$Na = !1;
function $a5a9ed1d43a3a911$var$Oa(a, b) {
    if (!a || $a5a9ed1d43a3a911$var$Na) return "";
    $a5a9ed1d43a3a911$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $a5a9ed1d43a3a911$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $a5a9ed1d43a3a911$var$Ma(a) : "";
}
function $a5a9ed1d43a3a911$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $a5a9ed1d43a3a911$var$Ma(a.type);
        case 16:
            return $a5a9ed1d43a3a911$var$Ma("Lazy");
        case 13:
            return $a5a9ed1d43a3a911$var$Ma("Suspense");
        case 19:
            return $a5a9ed1d43a3a911$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $a5a9ed1d43a3a911$var$Oa(a.type, !1), a;
        case 11:
            return a = $a5a9ed1d43a3a911$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $a5a9ed1d43a3a911$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $a5a9ed1d43a3a911$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $a5a9ed1d43a3a911$var$ya:
            return "Fragment";
        case $a5a9ed1d43a3a911$var$wa:
            return "Portal";
        case $a5a9ed1d43a3a911$var$Aa:
            return "Profiler";
        case $a5a9ed1d43a3a911$var$za:
            return "StrictMode";
        case $a5a9ed1d43a3a911$var$Ea:
            return "Suspense";
        case $a5a9ed1d43a3a911$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $a5a9ed1d43a3a911$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $a5a9ed1d43a3a911$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $a5a9ed1d43a3a911$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $a5a9ed1d43a3a911$var$Ga:
            return b = a.displayName || null, null !== b ? b : $a5a9ed1d43a3a911$var$Qa(a.type) || "Memo";
        case $a5a9ed1d43a3a911$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $a5a9ed1d43a3a911$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $a5a9ed1d43a3a911$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $a5a9ed1d43a3a911$var$Qa(b);
        case 8:
            return b === $a5a9ed1d43a3a911$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $a5a9ed1d43a3a911$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $a5a9ed1d43a3a911$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $a5a9ed1d43a3a911$var$Ua(a) {
    var b = $a5a9ed1d43a3a911$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $a5a9ed1d43a3a911$var$Va(a) {
    a._valueTracker || (a._valueTracker = $a5a9ed1d43a3a911$var$Ua(a));
}
function $a5a9ed1d43a3a911$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $a5a9ed1d43a3a911$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $a5a9ed1d43a3a911$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $a5a9ed1d43a3a911$var$Ya(a, b) {
    var c = b.checked;
    return $a5a9ed1d43a3a911$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $a5a9ed1d43a3a911$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $a5a9ed1d43a3a911$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a5a9ed1d43a3a911$var$ab(a, b) {
    b = b.checked;
    null != b && $a5a9ed1d43a3a911$var$ta(a, "checked", b, !1);
}
function $a5a9ed1d43a3a911$var$bb(a, b) {
    $a5a9ed1d43a3a911$var$ab(a, b);
    var c = $a5a9ed1d43a3a911$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $a5a9ed1d43a3a911$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $a5a9ed1d43a3a911$var$cb(a, b.type, $a5a9ed1d43a3a911$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $a5a9ed1d43a3a911$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $a5a9ed1d43a3a911$var$cb(a, b, c) {
    if ("number" !== b || $a5a9ed1d43a3a911$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $a5a9ed1d43a3a911$var$eb = Array.isArray;
function $a5a9ed1d43a3a911$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $a5a9ed1d43a3a911$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $a5a9ed1d43a3a911$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($a5a9ed1d43a3a911$var$p(91));
    return $a5a9ed1d43a3a911$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $a5a9ed1d43a3a911$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($a5a9ed1d43a3a911$var$p(92));
            if ($a5a9ed1d43a3a911$var$eb(c)) {
                if (1 < c.length) throw Error($a5a9ed1d43a3a911$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $a5a9ed1d43a3a911$var$Sa(c)
    };
}
function $a5a9ed1d43a3a911$var$ib(a, b) {
    var c = $a5a9ed1d43a3a911$var$Sa(b.value), d = $a5a9ed1d43a3a911$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $a5a9ed1d43a3a911$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $a5a9ed1d43a3a911$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $a5a9ed1d43a3a911$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $a5a9ed1d43a3a911$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $a5a9ed1d43a3a911$var$mb, $a5a9ed1d43a3a911$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $a5a9ed1d43a3a911$var$mb = $a5a9ed1d43a3a911$var$mb || document.createElement("div");
        $a5a9ed1d43a3a911$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $a5a9ed1d43a3a911$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $a5a9ed1d43a3a911$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $a5a9ed1d43a3a911$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $a5a9ed1d43a3a911$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($a5a9ed1d43a3a911$var$pb).forEach(function(a) {
    $a5a9ed1d43a3a911$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $a5a9ed1d43a3a911$var$pb[b] = $a5a9ed1d43a3a911$var$pb[a];
    });
});
function $a5a9ed1d43a3a911$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $a5a9ed1d43a3a911$var$pb.hasOwnProperty(a) && $a5a9ed1d43a3a911$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $a5a9ed1d43a3a911$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $a5a9ed1d43a3a911$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $a5a9ed1d43a3a911$var$tb = $a5a9ed1d43a3a911$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $a5a9ed1d43a3a911$var$ub(a, b) {
    if (b) {
        if ($a5a9ed1d43a3a911$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($a5a9ed1d43a3a911$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($a5a9ed1d43a3a911$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($a5a9ed1d43a3a911$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($a5a9ed1d43a3a911$var$p(62));
    }
}
function $a5a9ed1d43a3a911$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $a5a9ed1d43a3a911$var$wb = null;
function $a5a9ed1d43a3a911$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $a5a9ed1d43a3a911$var$yb = null, $a5a9ed1d43a3a911$var$zb = null, $a5a9ed1d43a3a911$var$Ab = null;
function $a5a9ed1d43a3a911$var$Bb(a) {
    if (a = $a5a9ed1d43a3a911$var$Cb(a)) {
        if ("function" !== typeof $a5a9ed1d43a3a911$var$yb) throw Error($a5a9ed1d43a3a911$var$p(280));
        var b = a.stateNode;
        b && (b = $a5a9ed1d43a3a911$var$Db(b), $a5a9ed1d43a3a911$var$yb(a.stateNode, a.type, b));
    }
}
function $a5a9ed1d43a3a911$var$Eb(a) {
    $a5a9ed1d43a3a911$var$zb ? $a5a9ed1d43a3a911$var$Ab ? $a5a9ed1d43a3a911$var$Ab.push(a) : $a5a9ed1d43a3a911$var$Ab = [
        a
    ] : $a5a9ed1d43a3a911$var$zb = a;
}
function $a5a9ed1d43a3a911$var$Fb() {
    if ($a5a9ed1d43a3a911$var$zb) {
        var a = $a5a9ed1d43a3a911$var$zb, b = $a5a9ed1d43a3a911$var$Ab;
        $a5a9ed1d43a3a911$var$Ab = $a5a9ed1d43a3a911$var$zb = null;
        $a5a9ed1d43a3a911$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$a5a9ed1d43a3a911$var$Bb(b[a]);
    }
}
function $a5a9ed1d43a3a911$var$Gb(a, b) {
    return a(b);
}
function $a5a9ed1d43a3a911$var$Hb() {}
var $a5a9ed1d43a3a911$var$Ib = !1;
function $a5a9ed1d43a3a911$var$Jb(a, b, c) {
    if ($a5a9ed1d43a3a911$var$Ib) return a(b, c);
    $a5a9ed1d43a3a911$var$Ib = !0;
    try {
        return $a5a9ed1d43a3a911$var$Gb(a, b, c);
    } finally{
        if ($a5a9ed1d43a3a911$var$Ib = !1, null !== $a5a9ed1d43a3a911$var$zb || null !== $a5a9ed1d43a3a911$var$Ab) $a5a9ed1d43a3a911$var$Hb(), $a5a9ed1d43a3a911$var$Fb();
    }
}
function $a5a9ed1d43a3a911$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $a5a9ed1d43a3a911$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($a5a9ed1d43a3a911$var$p(231, b, typeof c));
    return c;
}
var $a5a9ed1d43a3a911$var$Lb = !1;
if ($a5a9ed1d43a3a911$var$ia) try {
    var $a5a9ed1d43a3a911$var$Mb = {};
    Object.defineProperty($a5a9ed1d43a3a911$var$Mb, "passive", {
        get: function() {
            $a5a9ed1d43a3a911$var$Lb = !0;
        }
    });
    window.addEventListener("test", $a5a9ed1d43a3a911$var$Mb, $a5a9ed1d43a3a911$var$Mb);
    window.removeEventListener("test", $a5a9ed1d43a3a911$var$Mb, $a5a9ed1d43a3a911$var$Mb);
} catch (a) {
    $a5a9ed1d43a3a911$var$Lb = !1;
}
function $a5a9ed1d43a3a911$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $a5a9ed1d43a3a911$var$Ob = !1, $a5a9ed1d43a3a911$var$Pb = null, $a5a9ed1d43a3a911$var$Qb = !1, $a5a9ed1d43a3a911$var$Rb = null, $a5a9ed1d43a3a911$var$Sb = {
    onError: function(a) {
        $a5a9ed1d43a3a911$var$Ob = !0;
        $a5a9ed1d43a3a911$var$Pb = a;
    }
};
function $a5a9ed1d43a3a911$var$Tb(a, b, c, d, e, f, g, h, k) {
    $a5a9ed1d43a3a911$var$Ob = !1;
    $a5a9ed1d43a3a911$var$Pb = null;
    $a5a9ed1d43a3a911$var$Nb.apply($a5a9ed1d43a3a911$var$Sb, arguments);
}
function $a5a9ed1d43a3a911$var$Ub(a, b, c, d, e, f, g, h, k) {
    $a5a9ed1d43a3a911$var$Tb.apply(this, arguments);
    if ($a5a9ed1d43a3a911$var$Ob) {
        if ($a5a9ed1d43a3a911$var$Ob) {
            var l = $a5a9ed1d43a3a911$var$Pb;
            $a5a9ed1d43a3a911$var$Ob = !1;
            $a5a9ed1d43a3a911$var$Pb = null;
        } else throw Error($a5a9ed1d43a3a911$var$p(198));
        $a5a9ed1d43a3a911$var$Qb || ($a5a9ed1d43a3a911$var$Qb = !0, $a5a9ed1d43a3a911$var$Rb = l);
    }
}
function $a5a9ed1d43a3a911$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $a5a9ed1d43a3a911$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $a5a9ed1d43a3a911$var$Xb(a) {
    if ($a5a9ed1d43a3a911$var$Vb(a) !== a) throw Error($a5a9ed1d43a3a911$var$p(188));
}
function $a5a9ed1d43a3a911$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $a5a9ed1d43a3a911$var$Vb(a);
        if (null === b) throw Error($a5a9ed1d43a3a911$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $a5a9ed1d43a3a911$var$Xb(e), a;
                if (f === d) return $a5a9ed1d43a3a911$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($a5a9ed1d43a3a911$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($a5a9ed1d43a3a911$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($a5a9ed1d43a3a911$var$p(190));
    }
    if (3 !== c.tag) throw Error($a5a9ed1d43a3a911$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $a5a9ed1d43a3a911$var$Zb(a) {
    a = $a5a9ed1d43a3a911$var$Yb(a);
    return null !== a ? $a5a9ed1d43a3a911$var$$b(a) : null;
}
function $a5a9ed1d43a3a911$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $a5a9ed1d43a3a911$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $a5a9ed1d43a3a911$var$ac = $c22GA.unstable_scheduleCallback, $a5a9ed1d43a3a911$var$bc = $c22GA.unstable_cancelCallback, $a5a9ed1d43a3a911$var$cc = $c22GA.unstable_shouldYield, $a5a9ed1d43a3a911$var$dc = $c22GA.unstable_requestPaint, $a5a9ed1d43a3a911$var$B = $c22GA.unstable_now, $a5a9ed1d43a3a911$var$ec = $c22GA.unstable_getCurrentPriorityLevel, $a5a9ed1d43a3a911$var$fc = $c22GA.unstable_ImmediatePriority, $a5a9ed1d43a3a911$var$gc = $c22GA.unstable_UserBlockingPriority, $a5a9ed1d43a3a911$var$hc = $c22GA.unstable_NormalPriority, $a5a9ed1d43a3a911$var$ic = $c22GA.unstable_LowPriority, $a5a9ed1d43a3a911$var$jc = $c22GA.unstable_IdlePriority, $a5a9ed1d43a3a911$var$kc = null, $a5a9ed1d43a3a911$var$lc = null;
function $a5a9ed1d43a3a911$var$mc(a) {
    if ($a5a9ed1d43a3a911$var$lc && "function" === typeof $a5a9ed1d43a3a911$var$lc.onCommitFiberRoot) try {
        $a5a9ed1d43a3a911$var$lc.onCommitFiberRoot($a5a9ed1d43a3a911$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $a5a9ed1d43a3a911$var$oc = Math.clz32 ? Math.clz32 : $a5a9ed1d43a3a911$var$nc, $a5a9ed1d43a3a911$var$pc = Math.log, $a5a9ed1d43a3a911$var$qc = Math.LN2;
function $a5a9ed1d43a3a911$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($a5a9ed1d43a3a911$var$pc(a) / $a5a9ed1d43a3a911$var$qc | 0) | 0;
}
var $a5a9ed1d43a3a911$var$rc = 64, $a5a9ed1d43a3a911$var$sc = 4194304;
function $a5a9ed1d43a3a911$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $a5a9ed1d43a3a911$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $a5a9ed1d43a3a911$var$tc(h) : (f &= g, 0 !== f && (d = $a5a9ed1d43a3a911$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $a5a9ed1d43a3a911$var$tc(g) : 0 !== f && (d = $a5a9ed1d43a3a911$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $a5a9ed1d43a3a911$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $a5a9ed1d43a3a911$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $a5a9ed1d43a3a911$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $a5a9ed1d43a3a911$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $a5a9ed1d43a3a911$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $a5a9ed1d43a3a911$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $a5a9ed1d43a3a911$var$yc() {
    var a = $a5a9ed1d43a3a911$var$rc;
    $a5a9ed1d43a3a911$var$rc <<= 1;
    0 === ($a5a9ed1d43a3a911$var$rc & 4194240) && ($a5a9ed1d43a3a911$var$rc = 64);
    return a;
}
function $a5a9ed1d43a3a911$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $a5a9ed1d43a3a911$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $a5a9ed1d43a3a911$var$oc(b);
    a[b] = c;
}
function $a5a9ed1d43a3a911$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $a5a9ed1d43a3a911$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $a5a9ed1d43a3a911$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $a5a9ed1d43a3a911$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $a5a9ed1d43a3a911$var$C = 0;
function $a5a9ed1d43a3a911$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $a5a9ed1d43a3a911$var$Ec, $a5a9ed1d43a3a911$var$Fc, $a5a9ed1d43a3a911$var$Gc, $a5a9ed1d43a3a911$var$Hc, $a5a9ed1d43a3a911$var$Ic, $a5a9ed1d43a3a911$var$Jc = !1, $a5a9ed1d43a3a911$var$Kc = [], $a5a9ed1d43a3a911$var$Lc = null, $a5a9ed1d43a3a911$var$Mc = null, $a5a9ed1d43a3a911$var$Nc = null, $a5a9ed1d43a3a911$var$Oc = new Map, $a5a9ed1d43a3a911$var$Pc = new Map, $a5a9ed1d43a3a911$var$Qc = [], $a5a9ed1d43a3a911$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $a5a9ed1d43a3a911$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $a5a9ed1d43a3a911$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $a5a9ed1d43a3a911$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $a5a9ed1d43a3a911$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $a5a9ed1d43a3a911$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $a5a9ed1d43a3a911$var$Pc.delete(b.pointerId);
    }
}
function $a5a9ed1d43a3a911$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $a5a9ed1d43a3a911$var$Cb(b), null !== b && $a5a9ed1d43a3a911$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $a5a9ed1d43a3a911$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $a5a9ed1d43a3a911$var$Lc = $a5a9ed1d43a3a911$var$Tc($a5a9ed1d43a3a911$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $a5a9ed1d43a3a911$var$Mc = $a5a9ed1d43a3a911$var$Tc($a5a9ed1d43a3a911$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $a5a9ed1d43a3a911$var$Nc = $a5a9ed1d43a3a911$var$Tc($a5a9ed1d43a3a911$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $a5a9ed1d43a3a911$var$Oc.set(f, $a5a9ed1d43a3a911$var$Tc($a5a9ed1d43a3a911$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $a5a9ed1d43a3a911$var$Pc.set(f, $a5a9ed1d43a3a911$var$Tc($a5a9ed1d43a3a911$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $a5a9ed1d43a3a911$var$Vc(a) {
    var b = $a5a9ed1d43a3a911$var$Wc(a.target);
    if (null !== b) {
        var c = $a5a9ed1d43a3a911$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $a5a9ed1d43a3a911$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $a5a9ed1d43a3a911$var$Ic(a.priority, function() {
                        $a5a9ed1d43a3a911$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $a5a9ed1d43a3a911$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $a5a9ed1d43a3a911$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $a5a9ed1d43a3a911$var$wb = d;
            c.target.dispatchEvent(d);
            $a5a9ed1d43a3a911$var$wb = null;
        } else return b = $a5a9ed1d43a3a911$var$Cb(c), null !== b && $a5a9ed1d43a3a911$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $a5a9ed1d43a3a911$var$Zc(a, b, c) {
    $a5a9ed1d43a3a911$var$Xc(a) && c.delete(b);
}
function $a5a9ed1d43a3a911$var$$c() {
    $a5a9ed1d43a3a911$var$Jc = !1;
    null !== $a5a9ed1d43a3a911$var$Lc && $a5a9ed1d43a3a911$var$Xc($a5a9ed1d43a3a911$var$Lc) && ($a5a9ed1d43a3a911$var$Lc = null);
    null !== $a5a9ed1d43a3a911$var$Mc && $a5a9ed1d43a3a911$var$Xc($a5a9ed1d43a3a911$var$Mc) && ($a5a9ed1d43a3a911$var$Mc = null);
    null !== $a5a9ed1d43a3a911$var$Nc && $a5a9ed1d43a3a911$var$Xc($a5a9ed1d43a3a911$var$Nc) && ($a5a9ed1d43a3a911$var$Nc = null);
    $a5a9ed1d43a3a911$var$Oc.forEach($a5a9ed1d43a3a911$var$Zc);
    $a5a9ed1d43a3a911$var$Pc.forEach($a5a9ed1d43a3a911$var$Zc);
}
function $a5a9ed1d43a3a911$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $a5a9ed1d43a3a911$var$Jc || ($a5a9ed1d43a3a911$var$Jc = !0, $c22GA.unstable_scheduleCallback($c22GA.unstable_NormalPriority, $a5a9ed1d43a3a911$var$$c)));
}
function $a5a9ed1d43a3a911$var$bd(a) {
    function b(b) {
        return $a5a9ed1d43a3a911$var$ad(b, a);
    }
    if (0 < $a5a9ed1d43a3a911$var$Kc.length) {
        $a5a9ed1d43a3a911$var$ad($a5a9ed1d43a3a911$var$Kc[0], a);
        for(var c = 1; c < $a5a9ed1d43a3a911$var$Kc.length; c++){
            var d = $a5a9ed1d43a3a911$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $a5a9ed1d43a3a911$var$Lc && $a5a9ed1d43a3a911$var$ad($a5a9ed1d43a3a911$var$Lc, a);
    null !== $a5a9ed1d43a3a911$var$Mc && $a5a9ed1d43a3a911$var$ad($a5a9ed1d43a3a911$var$Mc, a);
    null !== $a5a9ed1d43a3a911$var$Nc && $a5a9ed1d43a3a911$var$ad($a5a9ed1d43a3a911$var$Nc, a);
    $a5a9ed1d43a3a911$var$Oc.forEach(b);
    $a5a9ed1d43a3a911$var$Pc.forEach(b);
    for(c = 0; c < $a5a9ed1d43a3a911$var$Qc.length; c++)d = $a5a9ed1d43a3a911$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $a5a9ed1d43a3a911$var$Qc.length && (c = $a5a9ed1d43a3a911$var$Qc[0], null === c.blockedOn);)$a5a9ed1d43a3a911$var$Vc(c), null === c.blockedOn && $a5a9ed1d43a3a911$var$Qc.shift();
}
var $a5a9ed1d43a3a911$var$cd = $a5a9ed1d43a3a911$var$ua.ReactCurrentBatchConfig, $a5a9ed1d43a3a911$var$dd = !0;
function $a5a9ed1d43a3a911$var$ed(a, b, c, d) {
    var e = $a5a9ed1d43a3a911$var$C, f = $a5a9ed1d43a3a911$var$cd.transition;
    $a5a9ed1d43a3a911$var$cd.transition = null;
    try {
        $a5a9ed1d43a3a911$var$C = 1, $a5a9ed1d43a3a911$var$fd(a, b, c, d);
    } finally{
        $a5a9ed1d43a3a911$var$C = e, $a5a9ed1d43a3a911$var$cd.transition = f;
    }
}
function $a5a9ed1d43a3a911$var$gd(a, b, c, d) {
    var e = $a5a9ed1d43a3a911$var$C, f = $a5a9ed1d43a3a911$var$cd.transition;
    $a5a9ed1d43a3a911$var$cd.transition = null;
    try {
        $a5a9ed1d43a3a911$var$C = 4, $a5a9ed1d43a3a911$var$fd(a, b, c, d);
    } finally{
        $a5a9ed1d43a3a911$var$C = e, $a5a9ed1d43a3a911$var$cd.transition = f;
    }
}
function $a5a9ed1d43a3a911$var$fd(a, b, c, d) {
    if ($a5a9ed1d43a3a911$var$dd) {
        var e = $a5a9ed1d43a3a911$var$Yc(a, b, c, d);
        if (null === e) $a5a9ed1d43a3a911$var$hd(a, b, d, $a5a9ed1d43a3a911$var$id, c), $a5a9ed1d43a3a911$var$Sc(a, d);
        else if ($a5a9ed1d43a3a911$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($a5a9ed1d43a3a911$var$Sc(a, d), b & 4 && -1 < $a5a9ed1d43a3a911$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $a5a9ed1d43a3a911$var$Cb(e);
                null !== f && $a5a9ed1d43a3a911$var$Ec(f);
                f = $a5a9ed1d43a3a911$var$Yc(a, b, c, d);
                null === f && $a5a9ed1d43a3a911$var$hd(a, b, d, $a5a9ed1d43a3a911$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $a5a9ed1d43a3a911$var$hd(a, b, d, null, c);
    }
}
var $a5a9ed1d43a3a911$var$id = null;
function $a5a9ed1d43a3a911$var$Yc(a, b, c, d) {
    $a5a9ed1d43a3a911$var$id = null;
    a = $a5a9ed1d43a3a911$var$xb(d);
    a = $a5a9ed1d43a3a911$var$Wc(a);
    if (null !== a) {
        if (b = $a5a9ed1d43a3a911$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $a5a9ed1d43a3a911$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $a5a9ed1d43a3a911$var$id = a;
    return null;
}
function $a5a9ed1d43a3a911$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($a5a9ed1d43a3a911$var$ec()){
                case $a5a9ed1d43a3a911$var$fc:
                    return 1;
                case $a5a9ed1d43a3a911$var$gc:
                    return 4;
                case $a5a9ed1d43a3a911$var$hc:
                case $a5a9ed1d43a3a911$var$ic:
                    return 16;
                case $a5a9ed1d43a3a911$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $a5a9ed1d43a3a911$var$kd = null, $a5a9ed1d43a3a911$var$ld = null, $a5a9ed1d43a3a911$var$md = null;
function $a5a9ed1d43a3a911$var$nd() {
    if ($a5a9ed1d43a3a911$var$md) return $a5a9ed1d43a3a911$var$md;
    var a, b = $a5a9ed1d43a3a911$var$ld, c = b.length, d, e = "value" in $a5a9ed1d43a3a911$var$kd ? $a5a9ed1d43a3a911$var$kd.value : $a5a9ed1d43a3a911$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $a5a9ed1d43a3a911$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $a5a9ed1d43a3a911$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $a5a9ed1d43a3a911$var$pd() {
    return !0;
}
function $a5a9ed1d43a3a911$var$qd() {
    return !1;
}
function $a5a9ed1d43a3a911$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $a5a9ed1d43a3a911$var$pd : $a5a9ed1d43a3a911$var$qd;
        this.isPropagationStopped = $a5a9ed1d43a3a911$var$qd;
        return this;
    }
    $a5a9ed1d43a3a911$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $a5a9ed1d43a3a911$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $a5a9ed1d43a3a911$var$pd);
        },
        persist: function() {},
        isPersistent: $a5a9ed1d43a3a911$var$pd
    });
    return b;
}
var $a5a9ed1d43a3a911$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $a5a9ed1d43a3a911$var$td = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$sd), $a5a9ed1d43a3a911$var$ud = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$sd, {
    view: 0,
    detail: 0
}), $a5a9ed1d43a3a911$var$vd = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$ud), $a5a9ed1d43a3a911$var$wd, $a5a9ed1d43a3a911$var$xd, $a5a9ed1d43a3a911$var$yd, $a5a9ed1d43a3a911$var$Ad = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $a5a9ed1d43a3a911$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $a5a9ed1d43a3a911$var$yd && ($a5a9ed1d43a3a911$var$yd && "mousemove" === a.type ? ($a5a9ed1d43a3a911$var$wd = a.screenX - $a5a9ed1d43a3a911$var$yd.screenX, $a5a9ed1d43a3a911$var$xd = a.screenY - $a5a9ed1d43a3a911$var$yd.screenY) : $a5a9ed1d43a3a911$var$xd = $a5a9ed1d43a3a911$var$wd = 0, $a5a9ed1d43a3a911$var$yd = a);
        return $a5a9ed1d43a3a911$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $a5a9ed1d43a3a911$var$xd;
    }
}), $a5a9ed1d43a3a911$var$Bd = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Ad), $a5a9ed1d43a3a911$var$Cd = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$Ad, {
    dataTransfer: 0
}), $a5a9ed1d43a3a911$var$Dd = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Cd), $a5a9ed1d43a3a911$var$Ed = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$ud, {
    relatedTarget: 0
}), $a5a9ed1d43a3a911$var$Fd = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Ed), $a5a9ed1d43a3a911$var$Gd = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a5a9ed1d43a3a911$var$Hd = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Gd), $a5a9ed1d43a3a911$var$Id = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $a5a9ed1d43a3a911$var$Jd = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Id), $a5a9ed1d43a3a911$var$Kd = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$sd, {
    data: 0
}), $a5a9ed1d43a3a911$var$Ld = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Kd), $a5a9ed1d43a3a911$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $a5a9ed1d43a3a911$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $a5a9ed1d43a3a911$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $a5a9ed1d43a3a911$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $a5a9ed1d43a3a911$var$Od[a]) ? !!b[a] : !1;
}
function $a5a9ed1d43a3a911$var$zd() {
    return $a5a9ed1d43a3a911$var$Pd;
}
var $a5a9ed1d43a3a911$var$Qd = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $a5a9ed1d43a3a911$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $a5a9ed1d43a3a911$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $a5a9ed1d43a3a911$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $a5a9ed1d43a3a911$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $a5a9ed1d43a3a911$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $a5a9ed1d43a3a911$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $a5a9ed1d43a3a911$var$Rd = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Qd), $a5a9ed1d43a3a911$var$Sd = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $a5a9ed1d43a3a911$var$Td = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Sd), $a5a9ed1d43a3a911$var$Ud = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $a5a9ed1d43a3a911$var$zd
}), $a5a9ed1d43a3a911$var$Vd = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Ud), $a5a9ed1d43a3a911$var$Wd = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a5a9ed1d43a3a911$var$Xd = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Wd), $a5a9ed1d43a3a911$var$Yd = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $a5a9ed1d43a3a911$var$Zd = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Yd), $a5a9ed1d43a3a911$var$$d = [
    9,
    13,
    27,
    32
], $a5a9ed1d43a3a911$var$ae = $a5a9ed1d43a3a911$var$ia && "CompositionEvent" in window, $a5a9ed1d43a3a911$var$be = null;
$a5a9ed1d43a3a911$var$ia && "documentMode" in document && ($a5a9ed1d43a3a911$var$be = document.documentMode);
var $a5a9ed1d43a3a911$var$ce = $a5a9ed1d43a3a911$var$ia && "TextEvent" in window && !$a5a9ed1d43a3a911$var$be, $a5a9ed1d43a3a911$var$de = $a5a9ed1d43a3a911$var$ia && (!$a5a9ed1d43a3a911$var$ae || $a5a9ed1d43a3a911$var$be && 8 < $a5a9ed1d43a3a911$var$be && 11 >= $a5a9ed1d43a3a911$var$be), $a5a9ed1d43a3a911$var$ee = String.fromCharCode(32), $a5a9ed1d43a3a911$var$fe = !1;
function $a5a9ed1d43a3a911$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $a5a9ed1d43a3a911$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $a5a9ed1d43a3a911$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $a5a9ed1d43a3a911$var$ie = !1;
function $a5a9ed1d43a3a911$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $a5a9ed1d43a3a911$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $a5a9ed1d43a3a911$var$fe = !0;
            return $a5a9ed1d43a3a911$var$ee;
        case "textInput":
            return a = b.data, a === $a5a9ed1d43a3a911$var$ee && $a5a9ed1d43a3a911$var$fe ? null : a;
        default:
            return null;
    }
}
function $a5a9ed1d43a3a911$var$ke(a, b) {
    if ($a5a9ed1d43a3a911$var$ie) return "compositionend" === a || !$a5a9ed1d43a3a911$var$ae && $a5a9ed1d43a3a911$var$ge(a, b) ? (a = $a5a9ed1d43a3a911$var$nd(), $a5a9ed1d43a3a911$var$md = $a5a9ed1d43a3a911$var$ld = $a5a9ed1d43a3a911$var$kd = null, $a5a9ed1d43a3a911$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $a5a9ed1d43a3a911$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $a5a9ed1d43a3a911$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $a5a9ed1d43a3a911$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$a5a9ed1d43a3a911$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $a5a9ed1d43a3a911$var$ne(a, b, c, d) {
    $a5a9ed1d43a3a911$var$Eb(d);
    b = $a5a9ed1d43a3a911$var$oe(b, "onChange");
    0 < b.length && (c = new $a5a9ed1d43a3a911$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $a5a9ed1d43a3a911$var$pe = null, $a5a9ed1d43a3a911$var$qe = null;
function $a5a9ed1d43a3a911$var$re(a) {
    $a5a9ed1d43a3a911$var$se(a, 0);
}
function $a5a9ed1d43a3a911$var$te(a) {
    var b = $a5a9ed1d43a3a911$var$ue(a);
    if ($a5a9ed1d43a3a911$var$Wa(b)) return a;
}
function $a5a9ed1d43a3a911$var$ve(a, b) {
    if ("change" === a) return b;
}
var $a5a9ed1d43a3a911$var$we = !1;
if ($a5a9ed1d43a3a911$var$ia) {
    var $a5a9ed1d43a3a911$var$xe;
    if ($a5a9ed1d43a3a911$var$ia) {
        var $a5a9ed1d43a3a911$var$ye = "oninput" in document;
        if (!$a5a9ed1d43a3a911$var$ye) {
            var $a5a9ed1d43a3a911$var$ze = document.createElement("div");
            $a5a9ed1d43a3a911$var$ze.setAttribute("oninput", "return;");
            $a5a9ed1d43a3a911$var$ye = "function" === typeof $a5a9ed1d43a3a911$var$ze.oninput;
        }
        $a5a9ed1d43a3a911$var$xe = $a5a9ed1d43a3a911$var$ye;
    } else $a5a9ed1d43a3a911$var$xe = !1;
    $a5a9ed1d43a3a911$var$we = $a5a9ed1d43a3a911$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $a5a9ed1d43a3a911$var$Ae() {
    $a5a9ed1d43a3a911$var$pe && ($a5a9ed1d43a3a911$var$pe.detachEvent("onpropertychange", $a5a9ed1d43a3a911$var$Be), $a5a9ed1d43a3a911$var$qe = $a5a9ed1d43a3a911$var$pe = null);
}
function $a5a9ed1d43a3a911$var$Be(a) {
    if ("value" === a.propertyName && $a5a9ed1d43a3a911$var$te($a5a9ed1d43a3a911$var$qe)) {
        var b = [];
        $a5a9ed1d43a3a911$var$ne(b, $a5a9ed1d43a3a911$var$qe, a, $a5a9ed1d43a3a911$var$xb(a));
        $a5a9ed1d43a3a911$var$Jb($a5a9ed1d43a3a911$var$re, b);
    }
}
function $a5a9ed1d43a3a911$var$Ce(a, b, c) {
    "focusin" === a ? ($a5a9ed1d43a3a911$var$Ae(), $a5a9ed1d43a3a911$var$pe = b, $a5a9ed1d43a3a911$var$qe = c, $a5a9ed1d43a3a911$var$pe.attachEvent("onpropertychange", $a5a9ed1d43a3a911$var$Be)) : "focusout" === a && $a5a9ed1d43a3a911$var$Ae();
}
function $a5a9ed1d43a3a911$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $a5a9ed1d43a3a911$var$te($a5a9ed1d43a3a911$var$qe);
}
function $a5a9ed1d43a3a911$var$Ee(a, b) {
    if ("click" === a) return $a5a9ed1d43a3a911$var$te(b);
}
function $a5a9ed1d43a3a911$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $a5a9ed1d43a3a911$var$te(b);
}
function $a5a9ed1d43a3a911$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $a5a9ed1d43a3a911$var$He = "function" === typeof Object.is ? Object.is : $a5a9ed1d43a3a911$var$Ge;
function $a5a9ed1d43a3a911$var$Ie(a, b) {
    if ($a5a9ed1d43a3a911$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$a5a9ed1d43a3a911$var$ja.call(b, e) || !$a5a9ed1d43a3a911$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $a5a9ed1d43a3a911$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $a5a9ed1d43a3a911$var$Ke(a, b) {
    var c = $a5a9ed1d43a3a911$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $a5a9ed1d43a3a911$var$Je(c);
    }
}
function $a5a9ed1d43a3a911$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $a5a9ed1d43a3a911$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $a5a9ed1d43a3a911$var$Me() {
    for(var a = window, b = $a5a9ed1d43a3a911$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $a5a9ed1d43a3a911$var$Xa(a.document);
    }
    return b;
}
function $a5a9ed1d43a3a911$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $a5a9ed1d43a3a911$var$Oe(a) {
    var b = $a5a9ed1d43a3a911$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $a5a9ed1d43a3a911$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $a5a9ed1d43a3a911$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $a5a9ed1d43a3a911$var$Ke(c, f);
                var g = $a5a9ed1d43a3a911$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $a5a9ed1d43a3a911$var$Pe = $a5a9ed1d43a3a911$var$ia && "documentMode" in document && 11 >= document.documentMode, $a5a9ed1d43a3a911$var$Qe = null, $a5a9ed1d43a3a911$var$Re = null, $a5a9ed1d43a3a911$var$Se = null, $a5a9ed1d43a3a911$var$Te = !1;
function $a5a9ed1d43a3a911$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $a5a9ed1d43a3a911$var$Te || null == $a5a9ed1d43a3a911$var$Qe || $a5a9ed1d43a3a911$var$Qe !== $a5a9ed1d43a3a911$var$Xa(d) || (d = $a5a9ed1d43a3a911$var$Qe, "selectionStart" in d && $a5a9ed1d43a3a911$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $a5a9ed1d43a3a911$var$Se && $a5a9ed1d43a3a911$var$Ie($a5a9ed1d43a3a911$var$Se, d) || ($a5a9ed1d43a3a911$var$Se = d, d = $a5a9ed1d43a3a911$var$oe($a5a9ed1d43a3a911$var$Re, "onSelect"), 0 < d.length && (b = new $a5a9ed1d43a3a911$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $a5a9ed1d43a3a911$var$Qe)));
}
function $a5a9ed1d43a3a911$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $a5a9ed1d43a3a911$var$We = {
    animationend: $a5a9ed1d43a3a911$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $a5a9ed1d43a3a911$var$Ve("Animation", "AnimationIteration"),
    animationstart: $a5a9ed1d43a3a911$var$Ve("Animation", "AnimationStart"),
    transitionend: $a5a9ed1d43a3a911$var$Ve("Transition", "TransitionEnd")
}, $a5a9ed1d43a3a911$var$Xe = {}, $a5a9ed1d43a3a911$var$Ye = {};
$a5a9ed1d43a3a911$var$ia && ($a5a9ed1d43a3a911$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $a5a9ed1d43a3a911$var$We.animationend.animation, delete $a5a9ed1d43a3a911$var$We.animationiteration.animation, delete $a5a9ed1d43a3a911$var$We.animationstart.animation), "TransitionEvent" in window || delete $a5a9ed1d43a3a911$var$We.transitionend.transition);
function $a5a9ed1d43a3a911$var$Ze(a) {
    if ($a5a9ed1d43a3a911$var$Xe[a]) return $a5a9ed1d43a3a911$var$Xe[a];
    if (!$a5a9ed1d43a3a911$var$We[a]) return a;
    var b = $a5a9ed1d43a3a911$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $a5a9ed1d43a3a911$var$Ye) return $a5a9ed1d43a3a911$var$Xe[a] = b[c];
    return a;
}
var $a5a9ed1d43a3a911$var$$e = $a5a9ed1d43a3a911$var$Ze("animationend"), $a5a9ed1d43a3a911$var$af = $a5a9ed1d43a3a911$var$Ze("animationiteration"), $a5a9ed1d43a3a911$var$bf = $a5a9ed1d43a3a911$var$Ze("animationstart"), $a5a9ed1d43a3a911$var$cf = $a5a9ed1d43a3a911$var$Ze("transitionend"), $a5a9ed1d43a3a911$var$df = new Map, $a5a9ed1d43a3a911$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $a5a9ed1d43a3a911$var$ff(a, b) {
    $a5a9ed1d43a3a911$var$df.set(a, b);
    $a5a9ed1d43a3a911$var$fa(b, [
        a
    ]);
}
for(var $a5a9ed1d43a3a911$var$gf = 0; $a5a9ed1d43a3a911$var$gf < $a5a9ed1d43a3a911$var$ef.length; $a5a9ed1d43a3a911$var$gf++){
    var $a5a9ed1d43a3a911$var$hf = $a5a9ed1d43a3a911$var$ef[$a5a9ed1d43a3a911$var$gf], $a5a9ed1d43a3a911$var$jf = $a5a9ed1d43a3a911$var$hf.toLowerCase(), $a5a9ed1d43a3a911$var$kf = $a5a9ed1d43a3a911$var$hf[0].toUpperCase() + $a5a9ed1d43a3a911$var$hf.slice(1);
    $a5a9ed1d43a3a911$var$ff($a5a9ed1d43a3a911$var$jf, "on" + $a5a9ed1d43a3a911$var$kf);
}
$a5a9ed1d43a3a911$var$ff($a5a9ed1d43a3a911$var$$e, "onAnimationEnd");
$a5a9ed1d43a3a911$var$ff($a5a9ed1d43a3a911$var$af, "onAnimationIteration");
$a5a9ed1d43a3a911$var$ff($a5a9ed1d43a3a911$var$bf, "onAnimationStart");
$a5a9ed1d43a3a911$var$ff("dblclick", "onDoubleClick");
$a5a9ed1d43a3a911$var$ff("focusin", "onFocus");
$a5a9ed1d43a3a911$var$ff("focusout", "onBlur");
$a5a9ed1d43a3a911$var$ff($a5a9ed1d43a3a911$var$cf, "onTransitionEnd");
$a5a9ed1d43a3a911$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$a5a9ed1d43a3a911$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$a5a9ed1d43a3a911$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$a5a9ed1d43a3a911$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$a5a9ed1d43a3a911$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$a5a9ed1d43a3a911$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$a5a9ed1d43a3a911$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$a5a9ed1d43a3a911$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$a5a9ed1d43a3a911$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$a5a9ed1d43a3a911$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $a5a9ed1d43a3a911$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $a5a9ed1d43a3a911$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($a5a9ed1d43a3a911$var$lf));
function $a5a9ed1d43a3a911$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $a5a9ed1d43a3a911$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $a5a9ed1d43a3a911$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $a5a9ed1d43a3a911$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $a5a9ed1d43a3a911$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($a5a9ed1d43a3a911$var$Qb) throw a = $a5a9ed1d43a3a911$var$Rb, $a5a9ed1d43a3a911$var$Qb = !1, $a5a9ed1d43a3a911$var$Rb = null, a;
}
function $a5a9ed1d43a3a911$var$D(a, b) {
    var c = b[$a5a9ed1d43a3a911$var$of];
    void 0 === c && (c = b[$a5a9ed1d43a3a911$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($a5a9ed1d43a3a911$var$pf(b, a, 2, !1), c.add(d));
}
function $a5a9ed1d43a3a911$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $a5a9ed1d43a3a911$var$pf(c, a, d, b);
}
var $a5a9ed1d43a3a911$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $a5a9ed1d43a3a911$var$sf(a) {
    if (!a[$a5a9ed1d43a3a911$var$rf]) {
        a[$a5a9ed1d43a3a911$var$rf] = !0;
        $a5a9ed1d43a3a911$var$da.forEach(function(b) {
            "selectionchange" !== b && ($a5a9ed1d43a3a911$var$mf.has(b) || $a5a9ed1d43a3a911$var$qf(b, !1, a), $a5a9ed1d43a3a911$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$a5a9ed1d43a3a911$var$rf] || (b[$a5a9ed1d43a3a911$var$rf] = !0, $a5a9ed1d43a3a911$var$qf("selectionchange", !1, b));
    }
}
function $a5a9ed1d43a3a911$var$pf(a, b, c, d) {
    switch($a5a9ed1d43a3a911$var$jd(b)){
        case 1:
            var e = $a5a9ed1d43a3a911$var$ed;
            break;
        case 4:
            e = $a5a9ed1d43a3a911$var$gd;
            break;
        default:
            e = $a5a9ed1d43a3a911$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$a5a9ed1d43a3a911$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $a5a9ed1d43a3a911$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $a5a9ed1d43a3a911$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $a5a9ed1d43a3a911$var$Jb(function() {
        var d = f, e = $a5a9ed1d43a3a911$var$xb(c), g = [];
        a: {
            var h = $a5a9ed1d43a3a911$var$df.get(a);
            if (void 0 !== h) {
                var k = $a5a9ed1d43a3a911$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $a5a9ed1d43a3a911$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $a5a9ed1d43a3a911$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $a5a9ed1d43a3a911$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $a5a9ed1d43a3a911$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $a5a9ed1d43a3a911$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $a5a9ed1d43a3a911$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $a5a9ed1d43a3a911$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $a5a9ed1d43a3a911$var$Vd;
                        break;
                    case $a5a9ed1d43a3a911$var$$e:
                    case $a5a9ed1d43a3a911$var$af:
                    case $a5a9ed1d43a3a911$var$bf:
                        k = $a5a9ed1d43a3a911$var$Hd;
                        break;
                    case $a5a9ed1d43a3a911$var$cf:
                        k = $a5a9ed1d43a3a911$var$Xd;
                        break;
                    case "scroll":
                        k = $a5a9ed1d43a3a911$var$vd;
                        break;
                    case "wheel":
                        k = $a5a9ed1d43a3a911$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $a5a9ed1d43a3a911$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $a5a9ed1d43a3a911$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $a5a9ed1d43a3a911$var$Kb(w, x), null != F && t.push($a5a9ed1d43a3a911$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $a5a9ed1d43a3a911$var$wb && (n = c.relatedTarget || c.fromElement) && ($a5a9ed1d43a3a911$var$Wc(n) || n[$a5a9ed1d43a3a911$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $a5a9ed1d43a3a911$var$Wc(n) : null, null !== n && (J = $a5a9ed1d43a3a911$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $a5a9ed1d43a3a911$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $a5a9ed1d43a3a911$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $a5a9ed1d43a3a911$var$ue(k);
                        u = null == n ? h : $a5a9ed1d43a3a911$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $a5a9ed1d43a3a911$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $a5a9ed1d43a3a911$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $a5a9ed1d43a3a911$var$vf(F))u++;
                            for(; 0 < w - u;)t = $a5a9ed1d43a3a911$var$vf(t), w--;
                            for(; 0 < u - w;)x = $a5a9ed1d43a3a911$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $a5a9ed1d43a3a911$var$vf(t);
                                x = $a5a9ed1d43a3a911$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $a5a9ed1d43a3a911$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $a5a9ed1d43a3a911$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $a5a9ed1d43a3a911$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $a5a9ed1d43a3a911$var$ve;
                else if ($a5a9ed1d43a3a911$var$me(h)) {
                    if ($a5a9ed1d43a3a911$var$we) na = $a5a9ed1d43a3a911$var$Fe;
                    else {
                        na = $a5a9ed1d43a3a911$var$De;
                        var xa = $a5a9ed1d43a3a911$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $a5a9ed1d43a3a911$var$Ee);
                if (na && (na = na(a, d))) {
                    $a5a9ed1d43a3a911$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $a5a9ed1d43a3a911$var$cb(h, "number", h.value);
            }
            xa = d ? $a5a9ed1d43a3a911$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($a5a9ed1d43a3a911$var$me(xa) || "true" === xa.contentEditable) $a5a9ed1d43a3a911$var$Qe = xa, $a5a9ed1d43a3a911$var$Re = d, $a5a9ed1d43a3a911$var$Se = null;
                    break;
                case "focusout":
                    $a5a9ed1d43a3a911$var$Se = $a5a9ed1d43a3a911$var$Re = $a5a9ed1d43a3a911$var$Qe = null;
                    break;
                case "mousedown":
                    $a5a9ed1d43a3a911$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $a5a9ed1d43a3a911$var$Te = !1;
                    $a5a9ed1d43a3a911$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($a5a9ed1d43a3a911$var$Pe) break;
                case "keydown":
                case "keyup":
                    $a5a9ed1d43a3a911$var$Ue(g, c, e);
            }
            var $a;
            if ($a5a9ed1d43a3a911$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $a5a9ed1d43a3a911$var$ie ? $a5a9ed1d43a3a911$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($a5a9ed1d43a3a911$var$de && "ko" !== c.locale && ($a5a9ed1d43a3a911$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $a5a9ed1d43a3a911$var$ie && ($a = $a5a9ed1d43a3a911$var$nd()) : ($a5a9ed1d43a3a911$var$kd = e, $a5a9ed1d43a3a911$var$ld = "value" in $a5a9ed1d43a3a911$var$kd ? $a5a9ed1d43a3a911$var$kd.value : $a5a9ed1d43a3a911$var$kd.textContent, $a5a9ed1d43a3a911$var$ie = !0)), xa = $a5a9ed1d43a3a911$var$oe(d, ba), 0 < xa.length && (ba = new $a5a9ed1d43a3a911$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $a5a9ed1d43a3a911$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $a5a9ed1d43a3a911$var$ce ? $a5a9ed1d43a3a911$var$je(a, c) : $a5a9ed1d43a3a911$var$ke(a, c)) d = $a5a9ed1d43a3a911$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $a5a9ed1d43a3a911$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $a5a9ed1d43a3a911$var$se(g, b);
    });
}
function $a5a9ed1d43a3a911$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $a5a9ed1d43a3a911$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $a5a9ed1d43a3a911$var$Kb(a, c), null != f && d.unshift($a5a9ed1d43a3a911$var$tf(a, f, e)), f = $a5a9ed1d43a3a911$var$Kb(a, b), null != f && d.push($a5a9ed1d43a3a911$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $a5a9ed1d43a3a911$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $a5a9ed1d43a3a911$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $a5a9ed1d43a3a911$var$Kb(c, f), null != k && g.unshift($a5a9ed1d43a3a911$var$tf(c, k, h))) : e || (k = $a5a9ed1d43a3a911$var$Kb(c, f), null != k && g.push($a5a9ed1d43a3a911$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $a5a9ed1d43a3a911$var$xf = /\r\n?/g, $a5a9ed1d43a3a911$var$yf = /\u0000|\uFFFD/g;
function $a5a9ed1d43a3a911$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($a5a9ed1d43a3a911$var$xf, "\n").replace($a5a9ed1d43a3a911$var$yf, "");
}
function $a5a9ed1d43a3a911$var$Af(a, b, c) {
    b = $a5a9ed1d43a3a911$var$zf(b);
    if ($a5a9ed1d43a3a911$var$zf(a) !== b && c) throw Error($a5a9ed1d43a3a911$var$p(425));
}
function $a5a9ed1d43a3a911$var$Bf() {}
var $a5a9ed1d43a3a911$var$Cf = null, $a5a9ed1d43a3a911$var$Df = null;
function $a5a9ed1d43a3a911$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $a5a9ed1d43a3a911$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $a5a9ed1d43a3a911$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $a5a9ed1d43a3a911$var$Hf = "function" === typeof Promise ? Promise : void 0, $a5a9ed1d43a3a911$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $a5a9ed1d43a3a911$var$Hf ? function(a) {
    return $a5a9ed1d43a3a911$var$Hf.resolve(null).then(a).catch($a5a9ed1d43a3a911$var$If);
} : $a5a9ed1d43a3a911$var$Ff;
function $a5a9ed1d43a3a911$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $a5a9ed1d43a3a911$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $a5a9ed1d43a3a911$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $a5a9ed1d43a3a911$var$bd(b);
}
function $a5a9ed1d43a3a911$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $a5a9ed1d43a3a911$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $a5a9ed1d43a3a911$var$Nf = Math.random().toString(36).slice(2), $a5a9ed1d43a3a911$var$Of = "__reactFiber$" + $a5a9ed1d43a3a911$var$Nf, $a5a9ed1d43a3a911$var$Pf = "__reactProps$" + $a5a9ed1d43a3a911$var$Nf, $a5a9ed1d43a3a911$var$uf = "__reactContainer$" + $a5a9ed1d43a3a911$var$Nf, $a5a9ed1d43a3a911$var$of = "__reactEvents$" + $a5a9ed1d43a3a911$var$Nf, $a5a9ed1d43a3a911$var$Qf = "__reactListeners$" + $a5a9ed1d43a3a911$var$Nf, $a5a9ed1d43a3a911$var$Rf = "__reactHandles$" + $a5a9ed1d43a3a911$var$Nf;
function $a5a9ed1d43a3a911$var$Wc(a) {
    var b = a[$a5a9ed1d43a3a911$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$a5a9ed1d43a3a911$var$uf] || c[$a5a9ed1d43a3a911$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $a5a9ed1d43a3a911$var$Mf(a); null !== a;){
                if (c = a[$a5a9ed1d43a3a911$var$Of]) return c;
                a = $a5a9ed1d43a3a911$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $a5a9ed1d43a3a911$var$Cb(a) {
    a = a[$a5a9ed1d43a3a911$var$Of] || a[$a5a9ed1d43a3a911$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $a5a9ed1d43a3a911$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($a5a9ed1d43a3a911$var$p(33));
}
function $a5a9ed1d43a3a911$var$Db(a) {
    return a[$a5a9ed1d43a3a911$var$Pf] || null;
}
var $a5a9ed1d43a3a911$var$Sf = [], $a5a9ed1d43a3a911$var$Tf = -1;
function $a5a9ed1d43a3a911$var$Uf(a) {
    return {
        current: a
    };
}
function $a5a9ed1d43a3a911$var$E(a) {
    0 > $a5a9ed1d43a3a911$var$Tf || (a.current = $a5a9ed1d43a3a911$var$Sf[$a5a9ed1d43a3a911$var$Tf], $a5a9ed1d43a3a911$var$Sf[$a5a9ed1d43a3a911$var$Tf] = null, $a5a9ed1d43a3a911$var$Tf--);
}
function $a5a9ed1d43a3a911$var$G(a, b) {
    $a5a9ed1d43a3a911$var$Tf++;
    $a5a9ed1d43a3a911$var$Sf[$a5a9ed1d43a3a911$var$Tf] = a.current;
    a.current = b;
}
var $a5a9ed1d43a3a911$var$Vf = {}, $a5a9ed1d43a3a911$var$H = $a5a9ed1d43a3a911$var$Uf($a5a9ed1d43a3a911$var$Vf), $a5a9ed1d43a3a911$var$Wf = $a5a9ed1d43a3a911$var$Uf(!1), $a5a9ed1d43a3a911$var$Xf = $a5a9ed1d43a3a911$var$Vf;
function $a5a9ed1d43a3a911$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $a5a9ed1d43a3a911$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $a5a9ed1d43a3a911$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $a5a9ed1d43a3a911$var$$f() {
    $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Wf);
    $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$H);
}
function $a5a9ed1d43a3a911$var$ag(a, b, c) {
    if ($a5a9ed1d43a3a911$var$H.current !== $a5a9ed1d43a3a911$var$Vf) throw Error($a5a9ed1d43a3a911$var$p(168));
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$H, b);
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Wf, c);
}
function $a5a9ed1d43a3a911$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($a5a9ed1d43a3a911$var$p(108, $a5a9ed1d43a3a911$var$Ra(a) || "Unknown", e));
    return $a5a9ed1d43a3a911$var$A({}, c, d);
}
function $a5a9ed1d43a3a911$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $a5a9ed1d43a3a911$var$Vf;
    $a5a9ed1d43a3a911$var$Xf = $a5a9ed1d43a3a911$var$H.current;
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$H, a);
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Wf, $a5a9ed1d43a3a911$var$Wf.current);
    return !0;
}
function $a5a9ed1d43a3a911$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($a5a9ed1d43a3a911$var$p(169));
    c ? (a = $a5a9ed1d43a3a911$var$bg(a, b, $a5a9ed1d43a3a911$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Wf), $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$H), $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$H, a)) : $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Wf);
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Wf, c);
}
var $a5a9ed1d43a3a911$var$eg = null, $a5a9ed1d43a3a911$var$fg = !1, $a5a9ed1d43a3a911$var$gg = !1;
function $a5a9ed1d43a3a911$var$hg(a) {
    null === $a5a9ed1d43a3a911$var$eg ? $a5a9ed1d43a3a911$var$eg = [
        a
    ] : $a5a9ed1d43a3a911$var$eg.push(a);
}
function $a5a9ed1d43a3a911$var$ig(a) {
    $a5a9ed1d43a3a911$var$fg = !0;
    $a5a9ed1d43a3a911$var$hg(a);
}
function $a5a9ed1d43a3a911$var$jg() {
    if (!$a5a9ed1d43a3a911$var$gg && null !== $a5a9ed1d43a3a911$var$eg) {
        $a5a9ed1d43a3a911$var$gg = !0;
        var a = 0, b = $a5a9ed1d43a3a911$var$C;
        try {
            var c = $a5a9ed1d43a3a911$var$eg;
            for($a5a9ed1d43a3a911$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $a5a9ed1d43a3a911$var$eg = null;
            $a5a9ed1d43a3a911$var$fg = !1;
        } catch (e) {
            throw null !== $a5a9ed1d43a3a911$var$eg && ($a5a9ed1d43a3a911$var$eg = $a5a9ed1d43a3a911$var$eg.slice(a + 1)), $a5a9ed1d43a3a911$var$ac($a5a9ed1d43a3a911$var$fc, $a5a9ed1d43a3a911$var$jg), e;
        } finally{
            $a5a9ed1d43a3a911$var$C = b, $a5a9ed1d43a3a911$var$gg = !1;
        }
    }
    return null;
}
var $a5a9ed1d43a3a911$var$kg = [], $a5a9ed1d43a3a911$var$lg = 0, $a5a9ed1d43a3a911$var$mg = null, $a5a9ed1d43a3a911$var$ng = 0, $a5a9ed1d43a3a911$var$og = [], $a5a9ed1d43a3a911$var$pg = 0, $a5a9ed1d43a3a911$var$qg = null, $a5a9ed1d43a3a911$var$rg = 1, $a5a9ed1d43a3a911$var$sg = "";
function $a5a9ed1d43a3a911$var$tg(a, b) {
    $a5a9ed1d43a3a911$var$kg[$a5a9ed1d43a3a911$var$lg++] = $a5a9ed1d43a3a911$var$ng;
    $a5a9ed1d43a3a911$var$kg[$a5a9ed1d43a3a911$var$lg++] = $a5a9ed1d43a3a911$var$mg;
    $a5a9ed1d43a3a911$var$mg = a;
    $a5a9ed1d43a3a911$var$ng = b;
}
function $a5a9ed1d43a3a911$var$ug(a, b, c) {
    $a5a9ed1d43a3a911$var$og[$a5a9ed1d43a3a911$var$pg++] = $a5a9ed1d43a3a911$var$rg;
    $a5a9ed1d43a3a911$var$og[$a5a9ed1d43a3a911$var$pg++] = $a5a9ed1d43a3a911$var$sg;
    $a5a9ed1d43a3a911$var$og[$a5a9ed1d43a3a911$var$pg++] = $a5a9ed1d43a3a911$var$qg;
    $a5a9ed1d43a3a911$var$qg = a;
    var d = $a5a9ed1d43a3a911$var$rg;
    a = $a5a9ed1d43a3a911$var$sg;
    var e = 32 - $a5a9ed1d43a3a911$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $a5a9ed1d43a3a911$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $a5a9ed1d43a3a911$var$rg = 1 << 32 - $a5a9ed1d43a3a911$var$oc(b) + e | c << e | d;
        $a5a9ed1d43a3a911$var$sg = f + a;
    } else $a5a9ed1d43a3a911$var$rg = 1 << f | c << e | d, $a5a9ed1d43a3a911$var$sg = a;
}
function $a5a9ed1d43a3a911$var$vg(a) {
    null !== a.return && ($a5a9ed1d43a3a911$var$tg(a, 1), $a5a9ed1d43a3a911$var$ug(a, 1, 0));
}
function $a5a9ed1d43a3a911$var$wg(a) {
    for(; a === $a5a9ed1d43a3a911$var$mg;)$a5a9ed1d43a3a911$var$mg = $a5a9ed1d43a3a911$var$kg[--$a5a9ed1d43a3a911$var$lg], $a5a9ed1d43a3a911$var$kg[$a5a9ed1d43a3a911$var$lg] = null, $a5a9ed1d43a3a911$var$ng = $a5a9ed1d43a3a911$var$kg[--$a5a9ed1d43a3a911$var$lg], $a5a9ed1d43a3a911$var$kg[$a5a9ed1d43a3a911$var$lg] = null;
    for(; a === $a5a9ed1d43a3a911$var$qg;)$a5a9ed1d43a3a911$var$qg = $a5a9ed1d43a3a911$var$og[--$a5a9ed1d43a3a911$var$pg], $a5a9ed1d43a3a911$var$og[$a5a9ed1d43a3a911$var$pg] = null, $a5a9ed1d43a3a911$var$sg = $a5a9ed1d43a3a911$var$og[--$a5a9ed1d43a3a911$var$pg], $a5a9ed1d43a3a911$var$og[$a5a9ed1d43a3a911$var$pg] = null, $a5a9ed1d43a3a911$var$rg = $a5a9ed1d43a3a911$var$og[--$a5a9ed1d43a3a911$var$pg], $a5a9ed1d43a3a911$var$og[$a5a9ed1d43a3a911$var$pg] = null;
}
var $a5a9ed1d43a3a911$var$xg = null, $a5a9ed1d43a3a911$var$yg = null, $a5a9ed1d43a3a911$var$I = !1, $a5a9ed1d43a3a911$var$zg = null;
function $a5a9ed1d43a3a911$var$Ag(a, b) {
    var c = $a5a9ed1d43a3a911$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $a5a9ed1d43a3a911$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $a5a9ed1d43a3a911$var$xg = a, $a5a9ed1d43a3a911$var$yg = $a5a9ed1d43a3a911$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $a5a9ed1d43a3a911$var$xg = a, $a5a9ed1d43a3a911$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $a5a9ed1d43a3a911$var$qg ? {
                id: $a5a9ed1d43a3a911$var$rg,
                overflow: $a5a9ed1d43a3a911$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $a5a9ed1d43a3a911$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $a5a9ed1d43a3a911$var$xg = a, $a5a9ed1d43a3a911$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $a5a9ed1d43a3a911$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $a5a9ed1d43a3a911$var$Eg(a) {
    if ($a5a9ed1d43a3a911$var$I) {
        var b = $a5a9ed1d43a3a911$var$yg;
        if (b) {
            var c = b;
            if (!$a5a9ed1d43a3a911$var$Cg(a, b)) {
                if ($a5a9ed1d43a3a911$var$Dg(a)) throw Error($a5a9ed1d43a3a911$var$p(418));
                b = $a5a9ed1d43a3a911$var$Lf(c.nextSibling);
                var d = $a5a9ed1d43a3a911$var$xg;
                b && $a5a9ed1d43a3a911$var$Cg(a, b) ? $a5a9ed1d43a3a911$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $a5a9ed1d43a3a911$var$I = !1, $a5a9ed1d43a3a911$var$xg = a);
            }
        } else {
            if ($a5a9ed1d43a3a911$var$Dg(a)) throw Error($a5a9ed1d43a3a911$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $a5a9ed1d43a3a911$var$I = !1;
            $a5a9ed1d43a3a911$var$xg = a;
        }
    }
}
function $a5a9ed1d43a3a911$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $a5a9ed1d43a3a911$var$xg = a;
}
function $a5a9ed1d43a3a911$var$Gg(a) {
    if (a !== $a5a9ed1d43a3a911$var$xg) return !1;
    if (!$a5a9ed1d43a3a911$var$I) return $a5a9ed1d43a3a911$var$Fg(a), $a5a9ed1d43a3a911$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$a5a9ed1d43a3a911$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $a5a9ed1d43a3a911$var$yg)) {
        if ($a5a9ed1d43a3a911$var$Dg(a)) throw $a5a9ed1d43a3a911$var$Hg(), Error($a5a9ed1d43a3a911$var$p(418));
        for(; b;)$a5a9ed1d43a3a911$var$Ag(a, b), b = $a5a9ed1d43a3a911$var$Lf(b.nextSibling);
    }
    $a5a9ed1d43a3a911$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($a5a9ed1d43a3a911$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $a5a9ed1d43a3a911$var$yg = $a5a9ed1d43a3a911$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $a5a9ed1d43a3a911$var$yg = null;
        }
    } else $a5a9ed1d43a3a911$var$yg = $a5a9ed1d43a3a911$var$xg ? $a5a9ed1d43a3a911$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $a5a9ed1d43a3a911$var$Hg() {
    for(var a = $a5a9ed1d43a3a911$var$yg; a;)a = $a5a9ed1d43a3a911$var$Lf(a.nextSibling);
}
function $a5a9ed1d43a3a911$var$Ig() {
    $a5a9ed1d43a3a911$var$yg = $a5a9ed1d43a3a911$var$xg = null;
    $a5a9ed1d43a3a911$var$I = !1;
}
function $a5a9ed1d43a3a911$var$Jg(a) {
    null === $a5a9ed1d43a3a911$var$zg ? $a5a9ed1d43a3a911$var$zg = [
        a
    ] : $a5a9ed1d43a3a911$var$zg.push(a);
}
var $a5a9ed1d43a3a911$var$Kg = $a5a9ed1d43a3a911$var$ua.ReactCurrentBatchConfig;
function $a5a9ed1d43a3a911$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $a5a9ed1d43a3a911$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $a5a9ed1d43a3a911$var$Mg = $a5a9ed1d43a3a911$var$Uf(null), $a5a9ed1d43a3a911$var$Ng = null, $a5a9ed1d43a3a911$var$Og = null, $a5a9ed1d43a3a911$var$Pg = null;
function $a5a9ed1d43a3a911$var$Qg() {
    $a5a9ed1d43a3a911$var$Pg = $a5a9ed1d43a3a911$var$Og = $a5a9ed1d43a3a911$var$Ng = null;
}
function $a5a9ed1d43a3a911$var$Rg(a) {
    var b = $a5a9ed1d43a3a911$var$Mg.current;
    $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Mg);
    a._currentValue = b;
}
function $a5a9ed1d43a3a911$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $a5a9ed1d43a3a911$var$Tg(a, b) {
    $a5a9ed1d43a3a911$var$Ng = a;
    $a5a9ed1d43a3a911$var$Pg = $a5a9ed1d43a3a911$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($a5a9ed1d43a3a911$var$Ug = !0), a.firstContext = null);
}
function $a5a9ed1d43a3a911$var$Vg(a) {
    var b = a._currentValue;
    if ($a5a9ed1d43a3a911$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $a5a9ed1d43a3a911$var$Og) {
            if (null === $a5a9ed1d43a3a911$var$Ng) throw Error($a5a9ed1d43a3a911$var$p(308));
            $a5a9ed1d43a3a911$var$Og = a;
            $a5a9ed1d43a3a911$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $a5a9ed1d43a3a911$var$Og = $a5a9ed1d43a3a911$var$Og.next = a;
    }
    return b;
}
var $a5a9ed1d43a3a911$var$Wg = null;
function $a5a9ed1d43a3a911$var$Xg(a) {
    null === $a5a9ed1d43a3a911$var$Wg ? $a5a9ed1d43a3a911$var$Wg = [
        a
    ] : $a5a9ed1d43a3a911$var$Wg.push(a);
}
function $a5a9ed1d43a3a911$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $a5a9ed1d43a3a911$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $a5a9ed1d43a3a911$var$Zg(a, d);
}
function $a5a9ed1d43a3a911$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $a5a9ed1d43a3a911$var$$g = !1;
function $a5a9ed1d43a3a911$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $a5a9ed1d43a3a911$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $a5a9ed1d43a3a911$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $a5a9ed1d43a3a911$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($a5a9ed1d43a3a911$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $a5a9ed1d43a3a911$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $a5a9ed1d43a3a911$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $a5a9ed1d43a3a911$var$Zg(a, c);
}
function $a5a9ed1d43a3a911$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $a5a9ed1d43a3a911$var$Cc(a, c);
    }
}
function $a5a9ed1d43a3a911$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $a5a9ed1d43a3a911$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $a5a9ed1d43a3a911$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $a5a9ed1d43a3a911$var$A({}, q, r);
                            break a;
                        case 2:
                            $a5a9ed1d43a3a911$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $a5a9ed1d43a3a911$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $a5a9ed1d43a3a911$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($a5a9ed1d43a3a911$var$p(191, e));
            e.call(d);
        }
    }
}
var $a5a9ed1d43a3a911$var$jh = (new $aOChP.Component).refs;
function $a5a9ed1d43a3a911$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $a5a9ed1d43a3a911$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $a5a9ed1d43a3a911$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $a5a9ed1d43a3a911$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $a5a9ed1d43a3a911$var$L(), e = $a5a9ed1d43a3a911$var$lh(a), f = $a5a9ed1d43a3a911$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $a5a9ed1d43a3a911$var$dh(a, f, e);
        null !== b && ($a5a9ed1d43a3a911$var$mh(b, a, e, d), $a5a9ed1d43a3a911$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $a5a9ed1d43a3a911$var$L(), e = $a5a9ed1d43a3a911$var$lh(a), f = $a5a9ed1d43a3a911$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $a5a9ed1d43a3a911$var$dh(a, f, e);
        null !== b && ($a5a9ed1d43a3a911$var$mh(b, a, e, d), $a5a9ed1d43a3a911$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $a5a9ed1d43a3a911$var$L(), d = $a5a9ed1d43a3a911$var$lh(a), e = $a5a9ed1d43a3a911$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $a5a9ed1d43a3a911$var$dh(a, e, d);
        null !== b && ($a5a9ed1d43a3a911$var$mh(b, a, d, c), $a5a9ed1d43a3a911$var$eh(b, a, d));
    }
};
function $a5a9ed1d43a3a911$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$a5a9ed1d43a3a911$var$Ie(c, d) || !$a5a9ed1d43a3a911$var$Ie(e, f) : !0;
}
function $a5a9ed1d43a3a911$var$ph(a, b, c) {
    var d = !1, e = $a5a9ed1d43a3a911$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $a5a9ed1d43a3a911$var$Vg(f) : (e = $a5a9ed1d43a3a911$var$Zf(b) ? $a5a9ed1d43a3a911$var$Xf : $a5a9ed1d43a3a911$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $a5a9ed1d43a3a911$var$Yf(a, e) : $a5a9ed1d43a3a911$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $a5a9ed1d43a3a911$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $a5a9ed1d43a3a911$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $a5a9ed1d43a3a911$var$nh.enqueueReplaceState(b, b.state, null);
}
function $a5a9ed1d43a3a911$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $a5a9ed1d43a3a911$var$jh;
    $a5a9ed1d43a3a911$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $a5a9ed1d43a3a911$var$Vg(f) : (f = $a5a9ed1d43a3a911$var$Zf(b) ? $a5a9ed1d43a3a911$var$Xf : $a5a9ed1d43a3a911$var$H.current, e.context = $a5a9ed1d43a3a911$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($a5a9ed1d43a3a911$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $a5a9ed1d43a3a911$var$nh.enqueueReplaceState(e, e.state, null), $a5a9ed1d43a3a911$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $a5a9ed1d43a3a911$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($a5a9ed1d43a3a911$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($a5a9ed1d43a3a911$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $a5a9ed1d43a3a911$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($a5a9ed1d43a3a911$var$p(284));
        if (!c._owner) throw Error($a5a9ed1d43a3a911$var$p(290, a));
    }
    return a;
}
function $a5a9ed1d43a3a911$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($a5a9ed1d43a3a911$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $a5a9ed1d43a3a911$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $a5a9ed1d43a3a911$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $a5a9ed1d43a3a911$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $a5a9ed1d43a3a911$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $a5a9ed1d43a3a911$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $a5a9ed1d43a3a911$var$Ha && $a5a9ed1d43a3a911$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $a5a9ed1d43a3a911$var$sh(a, b, c), d.return = a, d;
        d = $a5a9ed1d43a3a911$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $a5a9ed1d43a3a911$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $a5a9ed1d43a3a911$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $a5a9ed1d43a3a911$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $a5a9ed1d43a3a911$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $a5a9ed1d43a3a911$var$va:
                    return c = $a5a9ed1d43a3a911$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $a5a9ed1d43a3a911$var$sh(a, null, b), c.return = a, c;
                case $a5a9ed1d43a3a911$var$wa:
                    return b = $a5a9ed1d43a3a911$var$zh(b, a.mode, c), b.return = a, b;
                case $a5a9ed1d43a3a911$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($a5a9ed1d43a3a911$var$eb(b) || $a5a9ed1d43a3a911$var$Ka(b)) return b = $a5a9ed1d43a3a911$var$Ah(b, a.mode, c, null), b.return = a, b;
            $a5a9ed1d43a3a911$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $a5a9ed1d43a3a911$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $a5a9ed1d43a3a911$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $a5a9ed1d43a3a911$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($a5a9ed1d43a3a911$var$eb(c) || $a5a9ed1d43a3a911$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $a5a9ed1d43a3a911$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $a5a9ed1d43a3a911$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $a5a9ed1d43a3a911$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $a5a9ed1d43a3a911$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($a5a9ed1d43a3a911$var$eb(d) || $a5a9ed1d43a3a911$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $a5a9ed1d43a3a911$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $a5a9ed1d43a3a911$var$I && $a5a9ed1d43a3a911$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $a5a9ed1d43a3a911$var$I && $a5a9ed1d43a3a911$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $a5a9ed1d43a3a911$var$I && $a5a9ed1d43a3a911$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $a5a9ed1d43a3a911$var$Ka(h);
        if ("function" !== typeof l) throw Error($a5a9ed1d43a3a911$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($a5a9ed1d43a3a911$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $a5a9ed1d43a3a911$var$I && $a5a9ed1d43a3a911$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $a5a9ed1d43a3a911$var$I && $a5a9ed1d43a3a911$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $a5a9ed1d43a3a911$var$I && $a5a9ed1d43a3a911$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $a5a9ed1d43a3a911$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $a5a9ed1d43a3a911$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $a5a9ed1d43a3a911$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $a5a9ed1d43a3a911$var$Ha && $a5a9ed1d43a3a911$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $a5a9ed1d43a3a911$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $a5a9ed1d43a3a911$var$ya ? (d = $a5a9ed1d43a3a911$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $a5a9ed1d43a3a911$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $a5a9ed1d43a3a911$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $a5a9ed1d43a3a911$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $a5a9ed1d43a3a911$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $a5a9ed1d43a3a911$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($a5a9ed1d43a3a911$var$eb(f)) return n(a, d, f, h);
            if ($a5a9ed1d43a3a911$var$Ka(f)) return t(a, d, f, h);
            $a5a9ed1d43a3a911$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $a5a9ed1d43a3a911$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $a5a9ed1d43a3a911$var$Bh = $a5a9ed1d43a3a911$var$vh(!0), $a5a9ed1d43a3a911$var$Ch = $a5a9ed1d43a3a911$var$vh(!1), $a5a9ed1d43a3a911$var$Dh = {}, $a5a9ed1d43a3a911$var$Eh = $a5a9ed1d43a3a911$var$Uf($a5a9ed1d43a3a911$var$Dh), $a5a9ed1d43a3a911$var$Fh = $a5a9ed1d43a3a911$var$Uf($a5a9ed1d43a3a911$var$Dh), $a5a9ed1d43a3a911$var$Gh = $a5a9ed1d43a3a911$var$Uf($a5a9ed1d43a3a911$var$Dh);
function $a5a9ed1d43a3a911$var$Hh(a) {
    if (a === $a5a9ed1d43a3a911$var$Dh) throw Error($a5a9ed1d43a3a911$var$p(174));
    return a;
}
function $a5a9ed1d43a3a911$var$Ih(a, b) {
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Gh, b);
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Fh, a);
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Eh, $a5a9ed1d43a3a911$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $a5a9ed1d43a3a911$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $a5a9ed1d43a3a911$var$lb(b, a);
    }
    $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Eh);
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Eh, b);
}
function $a5a9ed1d43a3a911$var$Jh() {
    $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Eh);
    $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Fh);
    $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Gh);
}
function $a5a9ed1d43a3a911$var$Kh(a) {
    $a5a9ed1d43a3a911$var$Hh($a5a9ed1d43a3a911$var$Gh.current);
    var b = $a5a9ed1d43a3a911$var$Hh($a5a9ed1d43a3a911$var$Eh.current);
    var c = $a5a9ed1d43a3a911$var$lb(b, a.type);
    b !== c && ($a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Fh, a), $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Eh, c));
}
function $a5a9ed1d43a3a911$var$Lh(a) {
    $a5a9ed1d43a3a911$var$Fh.current === a && ($a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Eh), $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Fh));
}
var $a5a9ed1d43a3a911$var$M = $a5a9ed1d43a3a911$var$Uf(0);
function $a5a9ed1d43a3a911$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $a5a9ed1d43a3a911$var$Nh = [];
function $a5a9ed1d43a3a911$var$Oh() {
    for(var a = 0; a < $a5a9ed1d43a3a911$var$Nh.length; a++)$a5a9ed1d43a3a911$var$Nh[a]._workInProgressVersionPrimary = null;
    $a5a9ed1d43a3a911$var$Nh.length = 0;
}
var $a5a9ed1d43a3a911$var$Ph = $a5a9ed1d43a3a911$var$ua.ReactCurrentDispatcher, $a5a9ed1d43a3a911$var$Qh = $a5a9ed1d43a3a911$var$ua.ReactCurrentBatchConfig, $a5a9ed1d43a3a911$var$Rh = 0, $a5a9ed1d43a3a911$var$N = null, $a5a9ed1d43a3a911$var$O = null, $a5a9ed1d43a3a911$var$P = null, $a5a9ed1d43a3a911$var$Sh = !1, $a5a9ed1d43a3a911$var$Th = !1, $a5a9ed1d43a3a911$var$Uh = 0, $a5a9ed1d43a3a911$var$Vh = 0;
function $a5a9ed1d43a3a911$var$Q() {
    throw Error($a5a9ed1d43a3a911$var$p(321));
}
function $a5a9ed1d43a3a911$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$a5a9ed1d43a3a911$var$He(a[c], b[c])) return !1;
    return !0;
}
function $a5a9ed1d43a3a911$var$Xh(a, b, c, d, e, f) {
    $a5a9ed1d43a3a911$var$Rh = f;
    $a5a9ed1d43a3a911$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $a5a9ed1d43a3a911$var$Ph.current = null === a || null === a.memoizedState ? $a5a9ed1d43a3a911$var$Yh : $a5a9ed1d43a3a911$var$Zh;
    a = c(d, e);
    if ($a5a9ed1d43a3a911$var$Th) {
        f = 0;
        do {
            $a5a9ed1d43a3a911$var$Th = !1;
            $a5a9ed1d43a3a911$var$Uh = 0;
            if (25 <= f) throw Error($a5a9ed1d43a3a911$var$p(301));
            f += 1;
            $a5a9ed1d43a3a911$var$P = $a5a9ed1d43a3a911$var$O = null;
            b.updateQueue = null;
            $a5a9ed1d43a3a911$var$Ph.current = $a5a9ed1d43a3a911$var$$h;
            a = c(d, e);
        }while ($a5a9ed1d43a3a911$var$Th);
    }
    $a5a9ed1d43a3a911$var$Ph.current = $a5a9ed1d43a3a911$var$ai;
    b = null !== $a5a9ed1d43a3a911$var$O && null !== $a5a9ed1d43a3a911$var$O.next;
    $a5a9ed1d43a3a911$var$Rh = 0;
    $a5a9ed1d43a3a911$var$P = $a5a9ed1d43a3a911$var$O = $a5a9ed1d43a3a911$var$N = null;
    $a5a9ed1d43a3a911$var$Sh = !1;
    if (b) throw Error($a5a9ed1d43a3a911$var$p(300));
    return a;
}
function $a5a9ed1d43a3a911$var$bi() {
    var a = 0 !== $a5a9ed1d43a3a911$var$Uh;
    $a5a9ed1d43a3a911$var$Uh = 0;
    return a;
}
function $a5a9ed1d43a3a911$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $a5a9ed1d43a3a911$var$P ? $a5a9ed1d43a3a911$var$N.memoizedState = $a5a9ed1d43a3a911$var$P = a : $a5a9ed1d43a3a911$var$P = $a5a9ed1d43a3a911$var$P.next = a;
    return $a5a9ed1d43a3a911$var$P;
}
function $a5a9ed1d43a3a911$var$di() {
    if (null === $a5a9ed1d43a3a911$var$O) {
        var a = $a5a9ed1d43a3a911$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $a5a9ed1d43a3a911$var$O.next;
    var b = null === $a5a9ed1d43a3a911$var$P ? $a5a9ed1d43a3a911$var$N.memoizedState : $a5a9ed1d43a3a911$var$P.next;
    if (null !== b) $a5a9ed1d43a3a911$var$P = b, $a5a9ed1d43a3a911$var$O = a;
    else {
        if (null === a) throw Error($a5a9ed1d43a3a911$var$p(310));
        $a5a9ed1d43a3a911$var$O = a;
        a = {
            memoizedState: $a5a9ed1d43a3a911$var$O.memoizedState,
            baseState: $a5a9ed1d43a3a911$var$O.baseState,
            baseQueue: $a5a9ed1d43a3a911$var$O.baseQueue,
            queue: $a5a9ed1d43a3a911$var$O.queue,
            next: null
        };
        null === $a5a9ed1d43a3a911$var$P ? $a5a9ed1d43a3a911$var$N.memoizedState = $a5a9ed1d43a3a911$var$P = a : $a5a9ed1d43a3a911$var$P = $a5a9ed1d43a3a911$var$P.next = a;
    }
    return $a5a9ed1d43a3a911$var$P;
}
function $a5a9ed1d43a3a911$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $a5a9ed1d43a3a911$var$fi(a) {
    var b = $a5a9ed1d43a3a911$var$di(), c = b.queue;
    if (null === c) throw Error($a5a9ed1d43a3a911$var$p(311));
    c.lastRenderedReducer = a;
    var d = $a5a9ed1d43a3a911$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($a5a9ed1d43a3a911$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $a5a9ed1d43a3a911$var$N.lanes |= m;
                $a5a9ed1d43a3a911$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $a5a9ed1d43a3a911$var$He(d, b.memoizedState) || ($a5a9ed1d43a3a911$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $a5a9ed1d43a3a911$var$N.lanes |= f, $a5a9ed1d43a3a911$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $a5a9ed1d43a3a911$var$gi(a) {
    var b = $a5a9ed1d43a3a911$var$di(), c = b.queue;
    if (null === c) throw Error($a5a9ed1d43a3a911$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $a5a9ed1d43a3a911$var$He(f, b.memoizedState) || ($a5a9ed1d43a3a911$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $a5a9ed1d43a3a911$var$hi() {}
function $a5a9ed1d43a3a911$var$ii(a, b) {
    var c = $a5a9ed1d43a3a911$var$N, d = $a5a9ed1d43a3a911$var$di(), e = b(), f = !$a5a9ed1d43a3a911$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $a5a9ed1d43a3a911$var$Ug = !0);
    d = d.queue;
    $a5a9ed1d43a3a911$var$ji($a5a9ed1d43a3a911$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $a5a9ed1d43a3a911$var$P && $a5a9ed1d43a3a911$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $a5a9ed1d43a3a911$var$li(9, $a5a9ed1d43a3a911$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $a5a9ed1d43a3a911$var$R) throw Error($a5a9ed1d43a3a911$var$p(349));
        0 !== ($a5a9ed1d43a3a911$var$Rh & 30) || $a5a9ed1d43a3a911$var$ni(c, b, e);
    }
    return e;
}
function $a5a9ed1d43a3a911$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $a5a9ed1d43a3a911$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $a5a9ed1d43a3a911$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $a5a9ed1d43a3a911$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $a5a9ed1d43a3a911$var$oi(b) && $a5a9ed1d43a3a911$var$pi(a);
}
function $a5a9ed1d43a3a911$var$ki(a, b, c) {
    return c(function() {
        $a5a9ed1d43a3a911$var$oi(b) && $a5a9ed1d43a3a911$var$pi(a);
    });
}
function $a5a9ed1d43a3a911$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$a5a9ed1d43a3a911$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $a5a9ed1d43a3a911$var$pi(a) {
    var b = $a5a9ed1d43a3a911$var$Zg(a, 1);
    null !== b && $a5a9ed1d43a3a911$var$mh(b, a, 1, -1);
}
function $a5a9ed1d43a3a911$var$qi(a) {
    var b = $a5a9ed1d43a3a911$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $a5a9ed1d43a3a911$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $a5a9ed1d43a3a911$var$ri.bind(null, $a5a9ed1d43a3a911$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $a5a9ed1d43a3a911$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $a5a9ed1d43a3a911$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $a5a9ed1d43a3a911$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $a5a9ed1d43a3a911$var$si() {
    return $a5a9ed1d43a3a911$var$di().memoizedState;
}
function $a5a9ed1d43a3a911$var$ti(a, b, c, d) {
    var e = $a5a9ed1d43a3a911$var$ci();
    $a5a9ed1d43a3a911$var$N.flags |= a;
    e.memoizedState = $a5a9ed1d43a3a911$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $a5a9ed1d43a3a911$var$ui(a, b, c, d) {
    var e = $a5a9ed1d43a3a911$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $a5a9ed1d43a3a911$var$O) {
        var g = $a5a9ed1d43a3a911$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $a5a9ed1d43a3a911$var$Wh(d, g.deps)) {
            e.memoizedState = $a5a9ed1d43a3a911$var$li(b, c, f, d);
            return;
        }
    }
    $a5a9ed1d43a3a911$var$N.flags |= a;
    e.memoizedState = $a5a9ed1d43a3a911$var$li(1 | b, c, f, d);
}
function $a5a9ed1d43a3a911$var$vi(a, b) {
    return $a5a9ed1d43a3a911$var$ti(8390656, 8, a, b);
}
function $a5a9ed1d43a3a911$var$ji(a, b) {
    return $a5a9ed1d43a3a911$var$ui(2048, 8, a, b);
}
function $a5a9ed1d43a3a911$var$wi(a, b) {
    return $a5a9ed1d43a3a911$var$ui(4, 2, a, b);
}
function $a5a9ed1d43a3a911$var$xi(a, b) {
    return $a5a9ed1d43a3a911$var$ui(4, 4, a, b);
}
function $a5a9ed1d43a3a911$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $a5a9ed1d43a3a911$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $a5a9ed1d43a3a911$var$ui(4, 4, $a5a9ed1d43a3a911$var$yi.bind(null, b, a), c);
}
function $a5a9ed1d43a3a911$var$Ai() {}
function $a5a9ed1d43a3a911$var$Bi(a, b) {
    var c = $a5a9ed1d43a3a911$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $a5a9ed1d43a3a911$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a5a9ed1d43a3a911$var$Ci(a, b) {
    var c = $a5a9ed1d43a3a911$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $a5a9ed1d43a3a911$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a5a9ed1d43a3a911$var$Di(a, b, c) {
    if (0 === ($a5a9ed1d43a3a911$var$Rh & 21)) return a.baseState && (a.baseState = !1, $a5a9ed1d43a3a911$var$Ug = !0), a.memoizedState = c;
    $a5a9ed1d43a3a911$var$He(c, b) || (c = $a5a9ed1d43a3a911$var$yc(), $a5a9ed1d43a3a911$var$N.lanes |= c, $a5a9ed1d43a3a911$var$hh |= c, a.baseState = !0);
    return b;
}
function $a5a9ed1d43a3a911$var$Ei(a, b) {
    var c = $a5a9ed1d43a3a911$var$C;
    $a5a9ed1d43a3a911$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $a5a9ed1d43a3a911$var$Qh.transition;
    $a5a9ed1d43a3a911$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $a5a9ed1d43a3a911$var$C = c, $a5a9ed1d43a3a911$var$Qh.transition = d;
    }
}
function $a5a9ed1d43a3a911$var$Fi() {
    return $a5a9ed1d43a3a911$var$di().memoizedState;
}
function $a5a9ed1d43a3a911$var$Gi(a, b, c) {
    var d = $a5a9ed1d43a3a911$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a5a9ed1d43a3a911$var$Hi(a)) $a5a9ed1d43a3a911$var$Ii(b, c);
    else if (c = $a5a9ed1d43a3a911$var$Yg(a, b, c, d), null !== c) {
        var e = $a5a9ed1d43a3a911$var$L();
        $a5a9ed1d43a3a911$var$mh(c, a, d, e);
        $a5a9ed1d43a3a911$var$Ji(c, b, d);
    }
}
function $a5a9ed1d43a3a911$var$ri(a, b, c) {
    var d = $a5a9ed1d43a3a911$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a5a9ed1d43a3a911$var$Hi(a)) $a5a9ed1d43a3a911$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($a5a9ed1d43a3a911$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $a5a9ed1d43a3a911$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $a5a9ed1d43a3a911$var$Yg(a, b, e, d);
        null !== c && (e = $a5a9ed1d43a3a911$var$L(), $a5a9ed1d43a3a911$var$mh(c, a, d, e), $a5a9ed1d43a3a911$var$Ji(c, b, d));
    }
}
function $a5a9ed1d43a3a911$var$Hi(a) {
    var b = a.alternate;
    return a === $a5a9ed1d43a3a911$var$N || null !== b && b === $a5a9ed1d43a3a911$var$N;
}
function $a5a9ed1d43a3a911$var$Ii(a, b) {
    $a5a9ed1d43a3a911$var$Th = $a5a9ed1d43a3a911$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $a5a9ed1d43a3a911$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $a5a9ed1d43a3a911$var$Cc(a, c);
    }
}
var $a5a9ed1d43a3a911$var$ai = {
    readContext: $a5a9ed1d43a3a911$var$Vg,
    useCallback: $a5a9ed1d43a3a911$var$Q,
    useContext: $a5a9ed1d43a3a911$var$Q,
    useEffect: $a5a9ed1d43a3a911$var$Q,
    useImperativeHandle: $a5a9ed1d43a3a911$var$Q,
    useInsertionEffect: $a5a9ed1d43a3a911$var$Q,
    useLayoutEffect: $a5a9ed1d43a3a911$var$Q,
    useMemo: $a5a9ed1d43a3a911$var$Q,
    useReducer: $a5a9ed1d43a3a911$var$Q,
    useRef: $a5a9ed1d43a3a911$var$Q,
    useState: $a5a9ed1d43a3a911$var$Q,
    useDebugValue: $a5a9ed1d43a3a911$var$Q,
    useDeferredValue: $a5a9ed1d43a3a911$var$Q,
    useTransition: $a5a9ed1d43a3a911$var$Q,
    useMutableSource: $a5a9ed1d43a3a911$var$Q,
    useSyncExternalStore: $a5a9ed1d43a3a911$var$Q,
    useId: $a5a9ed1d43a3a911$var$Q,
    unstable_isNewReconciler: !1
}, $a5a9ed1d43a3a911$var$Yh = {
    readContext: $a5a9ed1d43a3a911$var$Vg,
    useCallback: function(a, b) {
        $a5a9ed1d43a3a911$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $a5a9ed1d43a3a911$var$Vg,
    useEffect: $a5a9ed1d43a3a911$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $a5a9ed1d43a3a911$var$ti(4194308, 4, $a5a9ed1d43a3a911$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $a5a9ed1d43a3a911$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $a5a9ed1d43a3a911$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $a5a9ed1d43a3a911$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $a5a9ed1d43a3a911$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $a5a9ed1d43a3a911$var$Gi.bind(null, $a5a9ed1d43a3a911$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $a5a9ed1d43a3a911$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $a5a9ed1d43a3a911$var$qi,
    useDebugValue: $a5a9ed1d43a3a911$var$Ai,
    useDeferredValue: function(a) {
        return $a5a9ed1d43a3a911$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $a5a9ed1d43a3a911$var$qi(!1), b = a[0];
        a = $a5a9ed1d43a3a911$var$Ei.bind(null, a[1]);
        $a5a9ed1d43a3a911$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $a5a9ed1d43a3a911$var$N, e = $a5a9ed1d43a3a911$var$ci();
        if ($a5a9ed1d43a3a911$var$I) {
            if (void 0 === c) throw Error($a5a9ed1d43a3a911$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $a5a9ed1d43a3a911$var$R) throw Error($a5a9ed1d43a3a911$var$p(349));
            0 !== ($a5a9ed1d43a3a911$var$Rh & 30) || $a5a9ed1d43a3a911$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $a5a9ed1d43a3a911$var$vi($a5a9ed1d43a3a911$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $a5a9ed1d43a3a911$var$li(9, $a5a9ed1d43a3a911$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $a5a9ed1d43a3a911$var$ci(), b = $a5a9ed1d43a3a911$var$R.identifierPrefix;
        if ($a5a9ed1d43a3a911$var$I) {
            var c = $a5a9ed1d43a3a911$var$sg;
            var d = $a5a9ed1d43a3a911$var$rg;
            c = (d & ~(1 << 32 - $a5a9ed1d43a3a911$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $a5a9ed1d43a3a911$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $a5a9ed1d43a3a911$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $a5a9ed1d43a3a911$var$Zh = {
    readContext: $a5a9ed1d43a3a911$var$Vg,
    useCallback: $a5a9ed1d43a3a911$var$Bi,
    useContext: $a5a9ed1d43a3a911$var$Vg,
    useEffect: $a5a9ed1d43a3a911$var$ji,
    useImperativeHandle: $a5a9ed1d43a3a911$var$zi,
    useInsertionEffect: $a5a9ed1d43a3a911$var$wi,
    useLayoutEffect: $a5a9ed1d43a3a911$var$xi,
    useMemo: $a5a9ed1d43a3a911$var$Ci,
    useReducer: $a5a9ed1d43a3a911$var$fi,
    useRef: $a5a9ed1d43a3a911$var$si,
    useState: function() {
        return $a5a9ed1d43a3a911$var$fi($a5a9ed1d43a3a911$var$ei);
    },
    useDebugValue: $a5a9ed1d43a3a911$var$Ai,
    useDeferredValue: function(a) {
        var b = $a5a9ed1d43a3a911$var$di();
        return $a5a9ed1d43a3a911$var$Di(b, $a5a9ed1d43a3a911$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $a5a9ed1d43a3a911$var$fi($a5a9ed1d43a3a911$var$ei)[0], b = $a5a9ed1d43a3a911$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $a5a9ed1d43a3a911$var$hi,
    useSyncExternalStore: $a5a9ed1d43a3a911$var$ii,
    useId: $a5a9ed1d43a3a911$var$Fi,
    unstable_isNewReconciler: !1
}, $a5a9ed1d43a3a911$var$$h = {
    readContext: $a5a9ed1d43a3a911$var$Vg,
    useCallback: $a5a9ed1d43a3a911$var$Bi,
    useContext: $a5a9ed1d43a3a911$var$Vg,
    useEffect: $a5a9ed1d43a3a911$var$ji,
    useImperativeHandle: $a5a9ed1d43a3a911$var$zi,
    useInsertionEffect: $a5a9ed1d43a3a911$var$wi,
    useLayoutEffect: $a5a9ed1d43a3a911$var$xi,
    useMemo: $a5a9ed1d43a3a911$var$Ci,
    useReducer: $a5a9ed1d43a3a911$var$gi,
    useRef: $a5a9ed1d43a3a911$var$si,
    useState: function() {
        return $a5a9ed1d43a3a911$var$gi($a5a9ed1d43a3a911$var$ei);
    },
    useDebugValue: $a5a9ed1d43a3a911$var$Ai,
    useDeferredValue: function(a) {
        var b = $a5a9ed1d43a3a911$var$di();
        return null === $a5a9ed1d43a3a911$var$O ? b.memoizedState = a : $a5a9ed1d43a3a911$var$Di(b, $a5a9ed1d43a3a911$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $a5a9ed1d43a3a911$var$gi($a5a9ed1d43a3a911$var$ei)[0], b = $a5a9ed1d43a3a911$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $a5a9ed1d43a3a911$var$hi,
    useSyncExternalStore: $a5a9ed1d43a3a911$var$ii,
    useId: $a5a9ed1d43a3a911$var$Fi,
    unstable_isNewReconciler: !1
};
function $a5a9ed1d43a3a911$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $a5a9ed1d43a3a911$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $a5a9ed1d43a3a911$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $a5a9ed1d43a3a911$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $a5a9ed1d43a3a911$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $a5a9ed1d43a3a911$var$Oi(a, b, c) {
    c = $a5a9ed1d43a3a911$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $a5a9ed1d43a3a911$var$Pi || ($a5a9ed1d43a3a911$var$Pi = !0, $a5a9ed1d43a3a911$var$Qi = d);
        $a5a9ed1d43a3a911$var$Mi(a, b);
    };
    return c;
}
function $a5a9ed1d43a3a911$var$Ri(a, b, c) {
    c = $a5a9ed1d43a3a911$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $a5a9ed1d43a3a911$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $a5a9ed1d43a3a911$var$Mi(a, b);
        "function" !== typeof d && (null === $a5a9ed1d43a3a911$var$Si ? $a5a9ed1d43a3a911$var$Si = new Set([
            this
        ]) : $a5a9ed1d43a3a911$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $a5a9ed1d43a3a911$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $a5a9ed1d43a3a911$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $a5a9ed1d43a3a911$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $a5a9ed1d43a3a911$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $a5a9ed1d43a3a911$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $a5a9ed1d43a3a911$var$ch(-1, 1), b.tag = 2, $a5a9ed1d43a3a911$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $a5a9ed1d43a3a911$var$Xi = $a5a9ed1d43a3a911$var$ua.ReactCurrentOwner, $a5a9ed1d43a3a911$var$Ug = !1;
function $a5a9ed1d43a3a911$var$Yi(a, b, c, d) {
    b.child = null === a ? $a5a9ed1d43a3a911$var$Ch(b, null, c, d) : $a5a9ed1d43a3a911$var$Bh(b, a.child, c, d);
}
function $a5a9ed1d43a3a911$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $a5a9ed1d43a3a911$var$Tg(b, e);
    d = $a5a9ed1d43a3a911$var$Xh(a, b, c, d, f, e);
    c = $a5a9ed1d43a3a911$var$bi();
    if (null !== a && !$a5a9ed1d43a3a911$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $a5a9ed1d43a3a911$var$$i(a, b, e);
    $a5a9ed1d43a3a911$var$I && c && $a5a9ed1d43a3a911$var$vg(b);
    b.flags |= 1;
    $a5a9ed1d43a3a911$var$Yi(a, b, d, e);
    return b.child;
}
function $a5a9ed1d43a3a911$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$a5a9ed1d43a3a911$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $a5a9ed1d43a3a911$var$cj(a, b, f, d, e);
        a = $a5a9ed1d43a3a911$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $a5a9ed1d43a3a911$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $a5a9ed1d43a3a911$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $a5a9ed1d43a3a911$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $a5a9ed1d43a3a911$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($a5a9ed1d43a3a911$var$Ie(f, d) && a.ref === b.ref) {
            if ($a5a9ed1d43a3a911$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($a5a9ed1d43a3a911$var$Ug = !0);
            else return b.lanes = a.lanes, $a5a9ed1d43a3a911$var$$i(a, b, e);
        }
    }
    return $a5a9ed1d43a3a911$var$dj(a, b, c, d, e);
}
function $a5a9ed1d43a3a911$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$fj, $a5a9ed1d43a3a911$var$gj), $a5a9ed1d43a3a911$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$fj, $a5a9ed1d43a3a911$var$gj), $a5a9ed1d43a3a911$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$fj, $a5a9ed1d43a3a911$var$gj);
            $a5a9ed1d43a3a911$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$fj, $a5a9ed1d43a3a911$var$gj), $a5a9ed1d43a3a911$var$gj |= d;
    $a5a9ed1d43a3a911$var$Yi(a, b, e, c);
    return b.child;
}
function $a5a9ed1d43a3a911$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $a5a9ed1d43a3a911$var$dj(a, b, c, d, e) {
    var f = $a5a9ed1d43a3a911$var$Zf(c) ? $a5a9ed1d43a3a911$var$Xf : $a5a9ed1d43a3a911$var$H.current;
    f = $a5a9ed1d43a3a911$var$Yf(b, f);
    $a5a9ed1d43a3a911$var$Tg(b, e);
    c = $a5a9ed1d43a3a911$var$Xh(a, b, c, d, f, e);
    d = $a5a9ed1d43a3a911$var$bi();
    if (null !== a && !$a5a9ed1d43a3a911$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $a5a9ed1d43a3a911$var$$i(a, b, e);
    $a5a9ed1d43a3a911$var$I && d && $a5a9ed1d43a3a911$var$vg(b);
    b.flags |= 1;
    $a5a9ed1d43a3a911$var$Yi(a, b, c, e);
    return b.child;
}
function $a5a9ed1d43a3a911$var$ij(a, b, c, d, e) {
    if ($a5a9ed1d43a3a911$var$Zf(c)) {
        var f = !0;
        $a5a9ed1d43a3a911$var$cg(b);
    } else f = !1;
    $a5a9ed1d43a3a911$var$Tg(b, e);
    if (null === b.stateNode) $a5a9ed1d43a3a911$var$jj(a, b), $a5a9ed1d43a3a911$var$ph(b, c, d), $a5a9ed1d43a3a911$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $a5a9ed1d43a3a911$var$Vg(l) : (l = $a5a9ed1d43a3a911$var$Zf(c) ? $a5a9ed1d43a3a911$var$Xf : $a5a9ed1d43a3a911$var$H.current, l = $a5a9ed1d43a3a911$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $a5a9ed1d43a3a911$var$qh(b, g, d, l);
        $a5a9ed1d43a3a911$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $a5a9ed1d43a3a911$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $a5a9ed1d43a3a911$var$Wf.current || $a5a9ed1d43a3a911$var$$g ? ("function" === typeof m && ($a5a9ed1d43a3a911$var$kh(b, c, m, d), k = b.memoizedState), (h = $a5a9ed1d43a3a911$var$$g || $a5a9ed1d43a3a911$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $a5a9ed1d43a3a911$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $a5a9ed1d43a3a911$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $a5a9ed1d43a3a911$var$Vg(k) : (k = $a5a9ed1d43a3a911$var$Zf(c) ? $a5a9ed1d43a3a911$var$Xf : $a5a9ed1d43a3a911$var$H.current, k = $a5a9ed1d43a3a911$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $a5a9ed1d43a3a911$var$qh(b, g, d, k);
        $a5a9ed1d43a3a911$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $a5a9ed1d43a3a911$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $a5a9ed1d43a3a911$var$Wf.current || $a5a9ed1d43a3a911$var$$g ? ("function" === typeof y && ($a5a9ed1d43a3a911$var$kh(b, c, y, d), n = b.memoizedState), (l = $a5a9ed1d43a3a911$var$$g || $a5a9ed1d43a3a911$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $a5a9ed1d43a3a911$var$kj(a, b, c, d, f, e);
}
function $a5a9ed1d43a3a911$var$kj(a, b, c, d, e, f) {
    $a5a9ed1d43a3a911$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $a5a9ed1d43a3a911$var$dg(b, c, !1), $a5a9ed1d43a3a911$var$$i(a, b, f);
    d = b.stateNode;
    $a5a9ed1d43a3a911$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $a5a9ed1d43a3a911$var$Bh(b, a.child, null, f), b.child = $a5a9ed1d43a3a911$var$Bh(b, null, h, f)) : $a5a9ed1d43a3a911$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $a5a9ed1d43a3a911$var$dg(b, c, !0);
    return b.child;
}
function $a5a9ed1d43a3a911$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $a5a9ed1d43a3a911$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $a5a9ed1d43a3a911$var$ag(a, b.context, !1);
    $a5a9ed1d43a3a911$var$Ih(a, b.containerInfo);
}
function $a5a9ed1d43a3a911$var$mj(a, b, c, d, e) {
    $a5a9ed1d43a3a911$var$Ig();
    $a5a9ed1d43a3a911$var$Jg(e);
    b.flags |= 256;
    $a5a9ed1d43a3a911$var$Yi(a, b, c, d);
    return b.child;
}
var $a5a9ed1d43a3a911$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $a5a9ed1d43a3a911$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $a5a9ed1d43a3a911$var$pj(a, b, c) {
    var d = b.pendingProps, e = $a5a9ed1d43a3a911$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$M, e & 1);
    if (null === a) {
        $a5a9ed1d43a3a911$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $a5a9ed1d43a3a911$var$qj(g, d, 0, null), a = $a5a9ed1d43a3a911$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $a5a9ed1d43a3a911$var$oj(c), b.memoizedState = $a5a9ed1d43a3a911$var$nj, a) : $a5a9ed1d43a3a911$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $a5a9ed1d43a3a911$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $a5a9ed1d43a3a911$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $a5a9ed1d43a3a911$var$wh(h, f) : (f = $a5a9ed1d43a3a911$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $a5a9ed1d43a3a911$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $a5a9ed1d43a3a911$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $a5a9ed1d43a3a911$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $a5a9ed1d43a3a911$var$rj(a, b) {
    b = $a5a9ed1d43a3a911$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $a5a9ed1d43a3a911$var$tj(a, b, c, d) {
    null !== d && $a5a9ed1d43a3a911$var$Jg(d);
    $a5a9ed1d43a3a911$var$Bh(b, a.child, null, c);
    a = $a5a9ed1d43a3a911$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $a5a9ed1d43a3a911$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $a5a9ed1d43a3a911$var$Li(Error($a5a9ed1d43a3a911$var$p(422))), $a5a9ed1d43a3a911$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $a5a9ed1d43a3a911$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $a5a9ed1d43a3a911$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $a5a9ed1d43a3a911$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $a5a9ed1d43a3a911$var$oj(g);
        b.memoizedState = $a5a9ed1d43a3a911$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $a5a9ed1d43a3a911$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($a5a9ed1d43a3a911$var$p(419));
        d = $a5a9ed1d43a3a911$var$Li(f, d, void 0);
        return $a5a9ed1d43a3a911$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($a5a9ed1d43a3a911$var$Ug || h) {
        d = $a5a9ed1d43a3a911$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $a5a9ed1d43a3a911$var$Zg(a, e), $a5a9ed1d43a3a911$var$mh(d, a, e, -1));
        }
        $a5a9ed1d43a3a911$var$uj();
        d = $a5a9ed1d43a3a911$var$Li(Error($a5a9ed1d43a3a911$var$p(421)));
        return $a5a9ed1d43a3a911$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $a5a9ed1d43a3a911$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $a5a9ed1d43a3a911$var$yg = $a5a9ed1d43a3a911$var$Lf(e.nextSibling);
    $a5a9ed1d43a3a911$var$xg = b;
    $a5a9ed1d43a3a911$var$I = !0;
    $a5a9ed1d43a3a911$var$zg = null;
    null !== a && ($a5a9ed1d43a3a911$var$og[$a5a9ed1d43a3a911$var$pg++] = $a5a9ed1d43a3a911$var$rg, $a5a9ed1d43a3a911$var$og[$a5a9ed1d43a3a911$var$pg++] = $a5a9ed1d43a3a911$var$sg, $a5a9ed1d43a3a911$var$og[$a5a9ed1d43a3a911$var$pg++] = $a5a9ed1d43a3a911$var$qg, $a5a9ed1d43a3a911$var$rg = a.id, $a5a9ed1d43a3a911$var$sg = a.overflow, $a5a9ed1d43a3a911$var$qg = b);
    b = $a5a9ed1d43a3a911$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $a5a9ed1d43a3a911$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $a5a9ed1d43a3a911$var$Sg(a.return, b, c);
}
function $a5a9ed1d43a3a911$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $a5a9ed1d43a3a911$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $a5a9ed1d43a3a911$var$Yi(a, b, d.children, c);
    d = $a5a9ed1d43a3a911$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $a5a9ed1d43a3a911$var$wj(a, c, b);
            else if (19 === a.tag) $a5a9ed1d43a3a911$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $a5a9ed1d43a3a911$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $a5a9ed1d43a3a911$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $a5a9ed1d43a3a911$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $a5a9ed1d43a3a911$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $a5a9ed1d43a3a911$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $a5a9ed1d43a3a911$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $a5a9ed1d43a3a911$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $a5a9ed1d43a3a911$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($a5a9ed1d43a3a911$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $a5a9ed1d43a3a911$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $a5a9ed1d43a3a911$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $a5a9ed1d43a3a911$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $a5a9ed1d43a3a911$var$lj(b);
            $a5a9ed1d43a3a911$var$Ig();
            break;
        case 5:
            $a5a9ed1d43a3a911$var$Kh(b);
            break;
        case 1:
            $a5a9ed1d43a3a911$var$Zf(b.type) && $a5a9ed1d43a3a911$var$cg(b);
            break;
        case 4:
            $a5a9ed1d43a3a911$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$M, $a5a9ed1d43a3a911$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $a5a9ed1d43a3a911$var$pj(a, b, c);
                $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$M, $a5a9ed1d43a3a911$var$M.current & 1);
                a = $a5a9ed1d43a3a911$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$M, $a5a9ed1d43a3a911$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $a5a9ed1d43a3a911$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$M, $a5a9ed1d43a3a911$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $a5a9ed1d43a3a911$var$ej(a, b, c);
    }
    return $a5a9ed1d43a3a911$var$$i(a, b, c);
}
var $a5a9ed1d43a3a911$var$Aj, $a5a9ed1d43a3a911$var$Bj, $a5a9ed1d43a3a911$var$Cj, $a5a9ed1d43a3a911$var$Dj;
$a5a9ed1d43a3a911$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$a5a9ed1d43a3a911$var$Bj = function() {};
$a5a9ed1d43a3a911$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $a5a9ed1d43a3a911$var$Hh($a5a9ed1d43a3a911$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $a5a9ed1d43a3a911$var$Ya(a, e);
                d = $a5a9ed1d43a3a911$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $a5a9ed1d43a3a911$var$A({}, e, {
                    value: void 0
                });
                d = $a5a9ed1d43a3a911$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $a5a9ed1d43a3a911$var$gb(a, e);
                d = $a5a9ed1d43a3a911$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $a5a9ed1d43a3a911$var$Bf);
        }
        $a5a9ed1d43a3a911$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($a5a9ed1d43a3a911$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($a5a9ed1d43a3a911$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $a5a9ed1d43a3a911$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$a5a9ed1d43a3a911$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $a5a9ed1d43a3a911$var$Ej(a, b) {
    if (!$a5a9ed1d43a3a911$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $a5a9ed1d43a3a911$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $a5a9ed1d43a3a911$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $a5a9ed1d43a3a911$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $a5a9ed1d43a3a911$var$S(b), null;
        case 1:
            return $a5a9ed1d43a3a911$var$Zf(b.type) && $a5a9ed1d43a3a911$var$$f(), $a5a9ed1d43a3a911$var$S(b), null;
        case 3:
            d = b.stateNode;
            $a5a9ed1d43a3a911$var$Jh();
            $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Wf);
            $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$H);
            $a5a9ed1d43a3a911$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $a5a9ed1d43a3a911$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $a5a9ed1d43a3a911$var$zg && ($a5a9ed1d43a3a911$var$Gj($a5a9ed1d43a3a911$var$zg), $a5a9ed1d43a3a911$var$zg = null));
            $a5a9ed1d43a3a911$var$Bj(a, b);
            $a5a9ed1d43a3a911$var$S(b);
            return null;
        case 5:
            $a5a9ed1d43a3a911$var$Lh(b);
            var e = $a5a9ed1d43a3a911$var$Hh($a5a9ed1d43a3a911$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $a5a9ed1d43a3a911$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($a5a9ed1d43a3a911$var$p(166));
                    $a5a9ed1d43a3a911$var$S(b);
                    return null;
                }
                a = $a5a9ed1d43a3a911$var$Hh($a5a9ed1d43a3a911$var$Eh.current);
                if ($a5a9ed1d43a3a911$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$a5a9ed1d43a3a911$var$Of] = b;
                    d[$a5a9ed1d43a3a911$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $a5a9ed1d43a3a911$var$D("cancel", d);
                            $a5a9ed1d43a3a911$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $a5a9ed1d43a3a911$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $a5a9ed1d43a3a911$var$lf.length; e++)$a5a9ed1d43a3a911$var$D($a5a9ed1d43a3a911$var$lf[e], d);
                            break;
                        case "source":
                            $a5a9ed1d43a3a911$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $a5a9ed1d43a3a911$var$D("error", d);
                            $a5a9ed1d43a3a911$var$D("load", d);
                            break;
                        case "details":
                            $a5a9ed1d43a3a911$var$D("toggle", d);
                            break;
                        case "input":
                            $a5a9ed1d43a3a911$var$Za(d, f);
                            $a5a9ed1d43a3a911$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $a5a9ed1d43a3a911$var$D("invalid", d);
                            break;
                        case "textarea":
                            $a5a9ed1d43a3a911$var$hb(d, f), $a5a9ed1d43a3a911$var$D("invalid", d);
                    }
                    $a5a9ed1d43a3a911$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $a5a9ed1d43a3a911$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $a5a9ed1d43a3a911$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $a5a9ed1d43a3a911$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $a5a9ed1d43a3a911$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $a5a9ed1d43a3a911$var$Va(d);
                            $a5a9ed1d43a3a911$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $a5a9ed1d43a3a911$var$Va(d);
                            $a5a9ed1d43a3a911$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $a5a9ed1d43a3a911$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $a5a9ed1d43a3a911$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$a5a9ed1d43a3a911$var$Of] = b;
                    a[$a5a9ed1d43a3a911$var$Pf] = d;
                    $a5a9ed1d43a3a911$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $a5a9ed1d43a3a911$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $a5a9ed1d43a3a911$var$D("cancel", a);
                                $a5a9ed1d43a3a911$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $a5a9ed1d43a3a911$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $a5a9ed1d43a3a911$var$lf.length; e++)$a5a9ed1d43a3a911$var$D($a5a9ed1d43a3a911$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $a5a9ed1d43a3a911$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $a5a9ed1d43a3a911$var$D("error", a);
                                $a5a9ed1d43a3a911$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $a5a9ed1d43a3a911$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $a5a9ed1d43a3a911$var$Za(a, d);
                                e = $a5a9ed1d43a3a911$var$Ya(a, d);
                                $a5a9ed1d43a3a911$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $a5a9ed1d43a3a911$var$A({}, d, {
                                    value: void 0
                                });
                                $a5a9ed1d43a3a911$var$D("invalid", a);
                                break;
                            case "textarea":
                                $a5a9ed1d43a3a911$var$hb(a, d);
                                e = $a5a9ed1d43a3a911$var$gb(a, d);
                                $a5a9ed1d43a3a911$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $a5a9ed1d43a3a911$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $a5a9ed1d43a3a911$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $a5a9ed1d43a3a911$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $a5a9ed1d43a3a911$var$ob(a, k) : "number" === typeof k && $a5a9ed1d43a3a911$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($a5a9ed1d43a3a911$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $a5a9ed1d43a3a911$var$D("scroll", a) : null != k && $a5a9ed1d43a3a911$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $a5a9ed1d43a3a911$var$Va(a);
                                $a5a9ed1d43a3a911$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $a5a9ed1d43a3a911$var$Va(a);
                                $a5a9ed1d43a3a911$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $a5a9ed1d43a3a911$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $a5a9ed1d43a3a911$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $a5a9ed1d43a3a911$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $a5a9ed1d43a3a911$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $a5a9ed1d43a3a911$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $a5a9ed1d43a3a911$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($a5a9ed1d43a3a911$var$p(166));
                c = $a5a9ed1d43a3a911$var$Hh($a5a9ed1d43a3a911$var$Gh.current);
                $a5a9ed1d43a3a911$var$Hh($a5a9ed1d43a3a911$var$Eh.current);
                if ($a5a9ed1d43a3a911$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$a5a9ed1d43a3a911$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $a5a9ed1d43a3a911$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $a5a9ed1d43a3a911$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $a5a9ed1d43a3a911$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$a5a9ed1d43a3a911$var$Of] = b, b.stateNode = d;
            }
            $a5a9ed1d43a3a911$var$S(b);
            return null;
        case 13:
            $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($a5a9ed1d43a3a911$var$I && null !== $a5a9ed1d43a3a911$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $a5a9ed1d43a3a911$var$Hg(), $a5a9ed1d43a3a911$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $a5a9ed1d43a3a911$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($a5a9ed1d43a3a911$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($a5a9ed1d43a3a911$var$p(317));
                        f[$a5a9ed1d43a3a911$var$Of] = b;
                    } else $a5a9ed1d43a3a911$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $a5a9ed1d43a3a911$var$S(b);
                    f = !1;
                } else null !== $a5a9ed1d43a3a911$var$zg && ($a5a9ed1d43a3a911$var$Gj($a5a9ed1d43a3a911$var$zg), $a5a9ed1d43a3a911$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($a5a9ed1d43a3a911$var$M.current & 1) ? 0 === $a5a9ed1d43a3a911$var$T && ($a5a9ed1d43a3a911$var$T = 3) : $a5a9ed1d43a3a911$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $a5a9ed1d43a3a911$var$S(b);
            return null;
        case 4:
            return $a5a9ed1d43a3a911$var$Jh(), $a5a9ed1d43a3a911$var$Bj(a, b), null === a && $a5a9ed1d43a3a911$var$sf(b.stateNode.containerInfo), $a5a9ed1d43a3a911$var$S(b), null;
        case 10:
            return $a5a9ed1d43a3a911$var$Rg(b.type._context), $a5a9ed1d43a3a911$var$S(b), null;
        case 17:
            return $a5a9ed1d43a3a911$var$Zf(b.type) && $a5a9ed1d43a3a911$var$$f(), $a5a9ed1d43a3a911$var$S(b), null;
        case 19:
            $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$M);
            f = b.memoizedState;
            if (null === f) return $a5a9ed1d43a3a911$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $a5a9ed1d43a3a911$var$Ej(f, !1);
                else {
                    if (0 !== $a5a9ed1d43a3a911$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $a5a9ed1d43a3a911$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $a5a9ed1d43a3a911$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$M, $a5a9ed1d43a3a911$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $a5a9ed1d43a3a911$var$B() > $a5a9ed1d43a3a911$var$Hj && (b.flags |= 128, d = !0, $a5a9ed1d43a3a911$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $a5a9ed1d43a3a911$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $a5a9ed1d43a3a911$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$a5a9ed1d43a3a911$var$I) return $a5a9ed1d43a3a911$var$S(b), null;
                    } else 2 * $a5a9ed1d43a3a911$var$B() - f.renderingStartTime > $a5a9ed1d43a3a911$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $a5a9ed1d43a3a911$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $a5a9ed1d43a3a911$var$B(), b.sibling = null, c = $a5a9ed1d43a3a911$var$M.current, $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$M, d ? c & 1 | 2 : c & 1), b;
            $a5a9ed1d43a3a911$var$S(b);
            return null;
        case 22:
        case 23:
            return $a5a9ed1d43a3a911$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($a5a9ed1d43a3a911$var$gj & 1073741824) && ($a5a9ed1d43a3a911$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $a5a9ed1d43a3a911$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($a5a9ed1d43a3a911$var$p(156, b.tag));
}
function $a5a9ed1d43a3a911$var$Jj(a, b) {
    $a5a9ed1d43a3a911$var$wg(b);
    switch(b.tag){
        case 1:
            return $a5a9ed1d43a3a911$var$Zf(b.type) && $a5a9ed1d43a3a911$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $a5a9ed1d43a3a911$var$Jh(), $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Wf), $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$H), $a5a9ed1d43a3a911$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $a5a9ed1d43a3a911$var$Lh(b), null;
        case 13:
            $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($a5a9ed1d43a3a911$var$p(340));
                $a5a9ed1d43a3a911$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$M), null;
        case 4:
            return $a5a9ed1d43a3a911$var$Jh(), null;
        case 10:
            return $a5a9ed1d43a3a911$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $a5a9ed1d43a3a911$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $a5a9ed1d43a3a911$var$Kj = !1, $a5a9ed1d43a3a911$var$U = !1, $a5a9ed1d43a3a911$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $a5a9ed1d43a3a911$var$V = null;
function $a5a9ed1d43a3a911$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $a5a9ed1d43a3a911$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $a5a9ed1d43a3a911$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $a5a9ed1d43a3a911$var$W(a, b, d);
    }
}
var $a5a9ed1d43a3a911$var$Oj = !1;
function $a5a9ed1d43a3a911$var$Pj(a, b) {
    $a5a9ed1d43a3a911$var$Cf = $a5a9ed1d43a3a911$var$dd;
    a = $a5a9ed1d43a3a911$var$Me();
    if ($a5a9ed1d43a3a911$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $a5a9ed1d43a3a911$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $a5a9ed1d43a3a911$var$dd = !1;
    for($a5a9ed1d43a3a911$var$V = b; null !== $a5a9ed1d43a3a911$var$V;)if (b = $a5a9ed1d43a3a911$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $a5a9ed1d43a3a911$var$V = a;
    else for(; null !== $a5a9ed1d43a3a911$var$V;){
        b = $a5a9ed1d43a3a911$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $a5a9ed1d43a3a911$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($a5a9ed1d43a3a911$var$p(163));
            }
        } catch (F) {
            $a5a9ed1d43a3a911$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $a5a9ed1d43a3a911$var$V = a;
            break;
        }
        $a5a9ed1d43a3a911$var$V = b.return;
    }
    n = $a5a9ed1d43a3a911$var$Oj;
    $a5a9ed1d43a3a911$var$Oj = !1;
    return n;
}
function $a5a9ed1d43a3a911$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $a5a9ed1d43a3a911$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $a5a9ed1d43a3a911$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $a5a9ed1d43a3a911$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $a5a9ed1d43a3a911$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $a5a9ed1d43a3a911$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$a5a9ed1d43a3a911$var$Of], delete b[$a5a9ed1d43a3a911$var$Pf], delete b[$a5a9ed1d43a3a911$var$of], delete b[$a5a9ed1d43a3a911$var$Qf], delete b[$a5a9ed1d43a3a911$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $a5a9ed1d43a3a911$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $a5a9ed1d43a3a911$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $a5a9ed1d43a3a911$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $a5a9ed1d43a3a911$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $a5a9ed1d43a3a911$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($a5a9ed1d43a3a911$var$Wj(a, b, c), a = a.sibling; null !== a;)$a5a9ed1d43a3a911$var$Wj(a, b, c), a = a.sibling;
}
function $a5a9ed1d43a3a911$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($a5a9ed1d43a3a911$var$Xj(a, b, c), a = a.sibling; null !== a;)$a5a9ed1d43a3a911$var$Xj(a, b, c), a = a.sibling;
}
var $a5a9ed1d43a3a911$var$X = null, $a5a9ed1d43a3a911$var$Yj = !1;
function $a5a9ed1d43a3a911$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$a5a9ed1d43a3a911$var$ak(a, b, c), c = c.sibling;
}
function $a5a9ed1d43a3a911$var$ak(a, b, c) {
    if ($a5a9ed1d43a3a911$var$lc && "function" === typeof $a5a9ed1d43a3a911$var$lc.onCommitFiberUnmount) try {
        $a5a9ed1d43a3a911$var$lc.onCommitFiberUnmount($a5a9ed1d43a3a911$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $a5a9ed1d43a3a911$var$U || $a5a9ed1d43a3a911$var$Mj(c, b);
        case 6:
            var d = $a5a9ed1d43a3a911$var$X, e = $a5a9ed1d43a3a911$var$Yj;
            $a5a9ed1d43a3a911$var$X = null;
            $a5a9ed1d43a3a911$var$Zj(a, b, c);
            $a5a9ed1d43a3a911$var$X = d;
            $a5a9ed1d43a3a911$var$Yj = e;
            null !== $a5a9ed1d43a3a911$var$X && ($a5a9ed1d43a3a911$var$Yj ? (a = $a5a9ed1d43a3a911$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $a5a9ed1d43a3a911$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $a5a9ed1d43a3a911$var$X && ($a5a9ed1d43a3a911$var$Yj ? (a = $a5a9ed1d43a3a911$var$X, c = c.stateNode, 8 === a.nodeType ? $a5a9ed1d43a3a911$var$Kf(a.parentNode, c) : 1 === a.nodeType && $a5a9ed1d43a3a911$var$Kf(a, c), $a5a9ed1d43a3a911$var$bd(a)) : $a5a9ed1d43a3a911$var$Kf($a5a9ed1d43a3a911$var$X, c.stateNode));
            break;
        case 4:
            d = $a5a9ed1d43a3a911$var$X;
            e = $a5a9ed1d43a3a911$var$Yj;
            $a5a9ed1d43a3a911$var$X = c.stateNode.containerInfo;
            $a5a9ed1d43a3a911$var$Yj = !0;
            $a5a9ed1d43a3a911$var$Zj(a, b, c);
            $a5a9ed1d43a3a911$var$X = d;
            $a5a9ed1d43a3a911$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$a5a9ed1d43a3a911$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $a5a9ed1d43a3a911$var$Nj(c, b, g) : 0 !== (f & 4) && $a5a9ed1d43a3a911$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $a5a9ed1d43a3a911$var$Zj(a, b, c);
            break;
        case 1:
            if (!$a5a9ed1d43a3a911$var$U && ($a5a9ed1d43a3a911$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $a5a9ed1d43a3a911$var$W(c, b, h);
            }
            $a5a9ed1d43a3a911$var$Zj(a, b, c);
            break;
        case 21:
            $a5a9ed1d43a3a911$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($a5a9ed1d43a3a911$var$U = (d = $a5a9ed1d43a3a911$var$U) || null !== c.memoizedState, $a5a9ed1d43a3a911$var$Zj(a, b, c), $a5a9ed1d43a3a911$var$U = d) : $a5a9ed1d43a3a911$var$Zj(a, b, c);
            break;
        default:
            $a5a9ed1d43a3a911$var$Zj(a, b, c);
    }
}
function $a5a9ed1d43a3a911$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $a5a9ed1d43a3a911$var$Lj);
        b.forEach(function(b) {
            var d = $a5a9ed1d43a3a911$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $a5a9ed1d43a3a911$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $a5a9ed1d43a3a911$var$X = h.stateNode;
                        $a5a9ed1d43a3a911$var$Yj = !1;
                        break a;
                    case 3:
                        $a5a9ed1d43a3a911$var$X = h.stateNode.containerInfo;
                        $a5a9ed1d43a3a911$var$Yj = !0;
                        break a;
                    case 4:
                        $a5a9ed1d43a3a911$var$X = h.stateNode.containerInfo;
                        $a5a9ed1d43a3a911$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $a5a9ed1d43a3a911$var$X) throw Error($a5a9ed1d43a3a911$var$p(160));
            $a5a9ed1d43a3a911$var$ak(f, g, e);
            $a5a9ed1d43a3a911$var$X = null;
            $a5a9ed1d43a3a911$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $a5a9ed1d43a3a911$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$a5a9ed1d43a3a911$var$ek(b, a), b = b.sibling;
}
function $a5a9ed1d43a3a911$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $a5a9ed1d43a3a911$var$dk(b, a);
            $a5a9ed1d43a3a911$var$fk(a);
            if (d & 4) {
                try {
                    $a5a9ed1d43a3a911$var$Qj(3, a, a.return), $a5a9ed1d43a3a911$var$Rj(3, a);
                } catch (t) {
                    $a5a9ed1d43a3a911$var$W(a, a.return, t);
                }
                try {
                    $a5a9ed1d43a3a911$var$Qj(5, a, a.return);
                } catch (t) {
                    $a5a9ed1d43a3a911$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $a5a9ed1d43a3a911$var$dk(b, a);
            $a5a9ed1d43a3a911$var$fk(a);
            d & 512 && null !== c && $a5a9ed1d43a3a911$var$Mj(c, c.return);
            break;
        case 5:
            $a5a9ed1d43a3a911$var$dk(b, a);
            $a5a9ed1d43a3a911$var$fk(a);
            d & 512 && null !== c && $a5a9ed1d43a3a911$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $a5a9ed1d43a3a911$var$ob(e, "");
                } catch (t) {
                    $a5a9ed1d43a3a911$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $a5a9ed1d43a3a911$var$ab(e, f);
                    $a5a9ed1d43a3a911$var$vb(h, g);
                    var l = $a5a9ed1d43a3a911$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $a5a9ed1d43a3a911$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $a5a9ed1d43a3a911$var$nb(e, q) : "children" === m ? $a5a9ed1d43a3a911$var$ob(e, q) : $a5a9ed1d43a3a911$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $a5a9ed1d43a3a911$var$bb(e, f);
                            break;
                        case "textarea":
                            $a5a9ed1d43a3a911$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $a5a9ed1d43a3a911$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $a5a9ed1d43a3a911$var$fb(e, !!f.multiple, f.defaultValue, !0) : $a5a9ed1d43a3a911$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$a5a9ed1d43a3a911$var$Pf] = f;
                } catch (t) {
                    $a5a9ed1d43a3a911$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $a5a9ed1d43a3a911$var$dk(b, a);
            $a5a9ed1d43a3a911$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($a5a9ed1d43a3a911$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $a5a9ed1d43a3a911$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $a5a9ed1d43a3a911$var$dk(b, a);
            $a5a9ed1d43a3a911$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $a5a9ed1d43a3a911$var$bd(b.containerInfo);
            } catch (t) {
                $a5a9ed1d43a3a911$var$W(a, a.return, t);
            }
            break;
        case 4:
            $a5a9ed1d43a3a911$var$dk(b, a);
            $a5a9ed1d43a3a911$var$fk(a);
            break;
        case 13:
            $a5a9ed1d43a3a911$var$dk(b, a);
            $a5a9ed1d43a3a911$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($a5a9ed1d43a3a911$var$gk = $a5a9ed1d43a3a911$var$B()));
            d & 4 && $a5a9ed1d43a3a911$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($a5a9ed1d43a3a911$var$U = (l = $a5a9ed1d43a3a911$var$U) || m, $a5a9ed1d43a3a911$var$dk(b, a), $a5a9ed1d43a3a911$var$U = l) : $a5a9ed1d43a3a911$var$dk(b, a);
            $a5a9ed1d43a3a911$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($a5a9ed1d43a3a911$var$V = a, m = a.child; null !== m;){
                    for(q = $a5a9ed1d43a3a911$var$V = m; null !== $a5a9ed1d43a3a911$var$V;){
                        r = $a5a9ed1d43a3a911$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $a5a9ed1d43a3a911$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $a5a9ed1d43a3a911$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $a5a9ed1d43a3a911$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $a5a9ed1d43a3a911$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $a5a9ed1d43a3a911$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $a5a9ed1d43a3a911$var$V = y) : $a5a9ed1d43a3a911$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $a5a9ed1d43a3a911$var$rb("display", g));
                            } catch (t) {
                                $a5a9ed1d43a3a911$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $a5a9ed1d43a3a911$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $a5a9ed1d43a3a911$var$dk(b, a);
            $a5a9ed1d43a3a911$var$fk(a);
            d & 4 && $a5a9ed1d43a3a911$var$bk(a);
            break;
        case 21:
            break;
        default:
            $a5a9ed1d43a3a911$var$dk(b, a), $a5a9ed1d43a3a911$var$fk(a);
    }
}
function $a5a9ed1d43a3a911$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($a5a9ed1d43a3a911$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($a5a9ed1d43a3a911$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($a5a9ed1d43a3a911$var$ob(e, ""), d.flags &= -33);
                    var f = $a5a9ed1d43a3a911$var$Vj(a);
                    $a5a9ed1d43a3a911$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $a5a9ed1d43a3a911$var$Vj(a);
                    $a5a9ed1d43a3a911$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($a5a9ed1d43a3a911$var$p(161));
            }
        } catch (k) {
            $a5a9ed1d43a3a911$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $a5a9ed1d43a3a911$var$ik(a, b, c) {
    $a5a9ed1d43a3a911$var$V = a;
    $a5a9ed1d43a3a911$var$jk(a, b, c);
}
function $a5a9ed1d43a3a911$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $a5a9ed1d43a3a911$var$V;){
        var e = $a5a9ed1d43a3a911$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $a5a9ed1d43a3a911$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $a5a9ed1d43a3a911$var$U;
                h = $a5a9ed1d43a3a911$var$Kj;
                var l = $a5a9ed1d43a3a911$var$U;
                $a5a9ed1d43a3a911$var$Kj = g;
                if (($a5a9ed1d43a3a911$var$U = k) && !l) for($a5a9ed1d43a3a911$var$V = e; null !== $a5a9ed1d43a3a911$var$V;)g = $a5a9ed1d43a3a911$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $a5a9ed1d43a3a911$var$kk(e) : null !== k ? (k.return = g, $a5a9ed1d43a3a911$var$V = k) : $a5a9ed1d43a3a911$var$kk(e);
                for(; null !== f;)$a5a9ed1d43a3a911$var$V = f, $a5a9ed1d43a3a911$var$jk(f, b, c), f = f.sibling;
                $a5a9ed1d43a3a911$var$V = e;
                $a5a9ed1d43a3a911$var$Kj = h;
                $a5a9ed1d43a3a911$var$U = l;
            }
            $a5a9ed1d43a3a911$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $a5a9ed1d43a3a911$var$V = f) : $a5a9ed1d43a3a911$var$lk(a, b, c);
    }
}
function $a5a9ed1d43a3a911$var$lk(a) {
    for(; null !== $a5a9ed1d43a3a911$var$V;){
        var b = $a5a9ed1d43a3a911$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $a5a9ed1d43a3a911$var$U || $a5a9ed1d43a3a911$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$a5a9ed1d43a3a911$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $a5a9ed1d43a3a911$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $a5a9ed1d43a3a911$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $a5a9ed1d43a3a911$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $a5a9ed1d43a3a911$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($a5a9ed1d43a3a911$var$p(163));
                }
                $a5a9ed1d43a3a911$var$U || b.flags & 512 && $a5a9ed1d43a3a911$var$Sj(b);
            } catch (r) {
                $a5a9ed1d43a3a911$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $a5a9ed1d43a3a911$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $a5a9ed1d43a3a911$var$V = c;
            break;
        }
        $a5a9ed1d43a3a911$var$V = b.return;
    }
}
function $a5a9ed1d43a3a911$var$hk(a) {
    for(; null !== $a5a9ed1d43a3a911$var$V;){
        var b = $a5a9ed1d43a3a911$var$V;
        if (b === a) {
            $a5a9ed1d43a3a911$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $a5a9ed1d43a3a911$var$V = c;
            break;
        }
        $a5a9ed1d43a3a911$var$V = b.return;
    }
}
function $a5a9ed1d43a3a911$var$kk(a) {
    for(; null !== $a5a9ed1d43a3a911$var$V;){
        var b = $a5a9ed1d43a3a911$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $a5a9ed1d43a3a911$var$Rj(4, b);
                    } catch (k) {
                        $a5a9ed1d43a3a911$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $a5a9ed1d43a3a911$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $a5a9ed1d43a3a911$var$Sj(b);
                    } catch (k) {
                        $a5a9ed1d43a3a911$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $a5a9ed1d43a3a911$var$Sj(b);
                    } catch (k) {
                        $a5a9ed1d43a3a911$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $a5a9ed1d43a3a911$var$W(b, b.return, k);
        }
        if (b === a) {
            $a5a9ed1d43a3a911$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $a5a9ed1d43a3a911$var$V = h;
            break;
        }
        $a5a9ed1d43a3a911$var$V = b.return;
    }
}
var $a5a9ed1d43a3a911$var$mk = Math.ceil, $a5a9ed1d43a3a911$var$nk = $a5a9ed1d43a3a911$var$ua.ReactCurrentDispatcher, $a5a9ed1d43a3a911$var$ok = $a5a9ed1d43a3a911$var$ua.ReactCurrentOwner, $a5a9ed1d43a3a911$var$pk = $a5a9ed1d43a3a911$var$ua.ReactCurrentBatchConfig, $a5a9ed1d43a3a911$var$K = 0, $a5a9ed1d43a3a911$var$R = null, $a5a9ed1d43a3a911$var$Y = null, $a5a9ed1d43a3a911$var$Z = 0, $a5a9ed1d43a3a911$var$gj = 0, $a5a9ed1d43a3a911$var$fj = $a5a9ed1d43a3a911$var$Uf(0), $a5a9ed1d43a3a911$var$T = 0, $a5a9ed1d43a3a911$var$qk = null, $a5a9ed1d43a3a911$var$hh = 0, $a5a9ed1d43a3a911$var$rk = 0, $a5a9ed1d43a3a911$var$sk = 0, $a5a9ed1d43a3a911$var$tk = null, $a5a9ed1d43a3a911$var$uk = null, $a5a9ed1d43a3a911$var$gk = 0, $a5a9ed1d43a3a911$var$Hj = Infinity, $a5a9ed1d43a3a911$var$vk = null, $a5a9ed1d43a3a911$var$Pi = !1, $a5a9ed1d43a3a911$var$Qi = null, $a5a9ed1d43a3a911$var$Si = null, $a5a9ed1d43a3a911$var$wk = !1, $a5a9ed1d43a3a911$var$xk = null, $a5a9ed1d43a3a911$var$yk = 0, $a5a9ed1d43a3a911$var$zk = 0, $a5a9ed1d43a3a911$var$Ak = null, $a5a9ed1d43a3a911$var$Bk = -1, $a5a9ed1d43a3a911$var$Ck = 0;
function $a5a9ed1d43a3a911$var$L() {
    return 0 !== ($a5a9ed1d43a3a911$var$K & 6) ? $a5a9ed1d43a3a911$var$B() : -1 !== $a5a9ed1d43a3a911$var$Bk ? $a5a9ed1d43a3a911$var$Bk : $a5a9ed1d43a3a911$var$Bk = $a5a9ed1d43a3a911$var$B();
}
function $a5a9ed1d43a3a911$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($a5a9ed1d43a3a911$var$K & 2) && 0 !== $a5a9ed1d43a3a911$var$Z) return $a5a9ed1d43a3a911$var$Z & -$a5a9ed1d43a3a911$var$Z;
    if (null !== $a5a9ed1d43a3a911$var$Kg.transition) return 0 === $a5a9ed1d43a3a911$var$Ck && ($a5a9ed1d43a3a911$var$Ck = $a5a9ed1d43a3a911$var$yc()), $a5a9ed1d43a3a911$var$Ck;
    a = $a5a9ed1d43a3a911$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $a5a9ed1d43a3a911$var$jd(a.type);
    return a;
}
function $a5a9ed1d43a3a911$var$mh(a, b, c, d) {
    if (50 < $a5a9ed1d43a3a911$var$zk) throw $a5a9ed1d43a3a911$var$zk = 0, $a5a9ed1d43a3a911$var$Ak = null, Error($a5a9ed1d43a3a911$var$p(185));
    $a5a9ed1d43a3a911$var$Ac(a, c, d);
    if (0 === ($a5a9ed1d43a3a911$var$K & 2) || a !== $a5a9ed1d43a3a911$var$R) a === $a5a9ed1d43a3a911$var$R && (0 === ($a5a9ed1d43a3a911$var$K & 2) && ($a5a9ed1d43a3a911$var$rk |= c), 4 === $a5a9ed1d43a3a911$var$T && $a5a9ed1d43a3a911$var$Dk(a, $a5a9ed1d43a3a911$var$Z)), $a5a9ed1d43a3a911$var$Ek(a, d), 1 === c && 0 === $a5a9ed1d43a3a911$var$K && 0 === (b.mode & 1) && ($a5a9ed1d43a3a911$var$Hj = $a5a9ed1d43a3a911$var$B() + 500, $a5a9ed1d43a3a911$var$fg && $a5a9ed1d43a3a911$var$jg());
}
function $a5a9ed1d43a3a911$var$Ek(a, b) {
    var c = a.callbackNode;
    $a5a9ed1d43a3a911$var$wc(a, b);
    var d = $a5a9ed1d43a3a911$var$uc(a, a === $a5a9ed1d43a3a911$var$R ? $a5a9ed1d43a3a911$var$Z : 0);
    if (0 === d) null !== c && $a5a9ed1d43a3a911$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $a5a9ed1d43a3a911$var$bc(c);
        if (1 === b) 0 === a.tag ? $a5a9ed1d43a3a911$var$ig($a5a9ed1d43a3a911$var$Fk.bind(null, a)) : $a5a9ed1d43a3a911$var$hg($a5a9ed1d43a3a911$var$Fk.bind(null, a)), $a5a9ed1d43a3a911$var$Jf(function() {
            0 === ($a5a9ed1d43a3a911$var$K & 6) && $a5a9ed1d43a3a911$var$jg();
        }), c = null;
        else {
            switch($a5a9ed1d43a3a911$var$Dc(d)){
                case 1:
                    c = $a5a9ed1d43a3a911$var$fc;
                    break;
                case 4:
                    c = $a5a9ed1d43a3a911$var$gc;
                    break;
                case 16:
                    c = $a5a9ed1d43a3a911$var$hc;
                    break;
                case 536870912:
                    c = $a5a9ed1d43a3a911$var$jc;
                    break;
                default:
                    c = $a5a9ed1d43a3a911$var$hc;
            }
            c = $a5a9ed1d43a3a911$var$Gk(c, $a5a9ed1d43a3a911$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $a5a9ed1d43a3a911$var$Hk(a, b) {
    $a5a9ed1d43a3a911$var$Bk = -1;
    $a5a9ed1d43a3a911$var$Ck = 0;
    if (0 !== ($a5a9ed1d43a3a911$var$K & 6)) throw Error($a5a9ed1d43a3a911$var$p(327));
    var c = a.callbackNode;
    if ($a5a9ed1d43a3a911$var$Ik() && a.callbackNode !== c) return null;
    var d = $a5a9ed1d43a3a911$var$uc(a, a === $a5a9ed1d43a3a911$var$R ? $a5a9ed1d43a3a911$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $a5a9ed1d43a3a911$var$Jk(a, d);
    else {
        b = d;
        var e = $a5a9ed1d43a3a911$var$K;
        $a5a9ed1d43a3a911$var$K |= 2;
        var f = $a5a9ed1d43a3a911$var$Kk();
        if ($a5a9ed1d43a3a911$var$R !== a || $a5a9ed1d43a3a911$var$Z !== b) $a5a9ed1d43a3a911$var$vk = null, $a5a9ed1d43a3a911$var$Hj = $a5a9ed1d43a3a911$var$B() + 500, $a5a9ed1d43a3a911$var$Lk(a, b);
        for(;;)try {
            $a5a9ed1d43a3a911$var$Mk();
            break;
        } catch (h) {
            $a5a9ed1d43a3a911$var$Nk(a, h);
        }
        $a5a9ed1d43a3a911$var$Qg();
        $a5a9ed1d43a3a911$var$nk.current = f;
        $a5a9ed1d43a3a911$var$K = e;
        null !== $a5a9ed1d43a3a911$var$Y ? b = 0 : ($a5a9ed1d43a3a911$var$R = null, $a5a9ed1d43a3a911$var$Z = 0, b = $a5a9ed1d43a3a911$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $a5a9ed1d43a3a911$var$xc(a), 0 !== e && (d = e, b = $a5a9ed1d43a3a911$var$Ok(a, e)));
        if (1 === b) throw c = $a5a9ed1d43a3a911$var$qk, $a5a9ed1d43a3a911$var$Lk(a, 0), $a5a9ed1d43a3a911$var$Dk(a, d), $a5a9ed1d43a3a911$var$Ek(a, $a5a9ed1d43a3a911$var$B()), c;
        if (6 === b) $a5a9ed1d43a3a911$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$a5a9ed1d43a3a911$var$Pk(e) && (b = $a5a9ed1d43a3a911$var$Jk(a, d), 2 === b && (f = $a5a9ed1d43a3a911$var$xc(a), 0 !== f && (d = f, b = $a5a9ed1d43a3a911$var$Ok(a, f))), 1 === b)) throw c = $a5a9ed1d43a3a911$var$qk, $a5a9ed1d43a3a911$var$Lk(a, 0), $a5a9ed1d43a3a911$var$Dk(a, d), $a5a9ed1d43a3a911$var$Ek(a, $a5a9ed1d43a3a911$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($a5a9ed1d43a3a911$var$p(345));
                case 2:
                    $a5a9ed1d43a3a911$var$Qk(a, $a5a9ed1d43a3a911$var$uk, $a5a9ed1d43a3a911$var$vk);
                    break;
                case 3:
                    $a5a9ed1d43a3a911$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $a5a9ed1d43a3a911$var$gk + 500 - $a5a9ed1d43a3a911$var$B(), 10 < b)) {
                        if (0 !== $a5a9ed1d43a3a911$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $a5a9ed1d43a3a911$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $a5a9ed1d43a3a911$var$Ff($a5a9ed1d43a3a911$var$Qk.bind(null, a, $a5a9ed1d43a3a911$var$uk, $a5a9ed1d43a3a911$var$vk), b);
                        break;
                    }
                    $a5a9ed1d43a3a911$var$Qk(a, $a5a9ed1d43a3a911$var$uk, $a5a9ed1d43a3a911$var$vk);
                    break;
                case 4:
                    $a5a9ed1d43a3a911$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $a5a9ed1d43a3a911$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $a5a9ed1d43a3a911$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $a5a9ed1d43a3a911$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $a5a9ed1d43a3a911$var$Ff($a5a9ed1d43a3a911$var$Qk.bind(null, a, $a5a9ed1d43a3a911$var$uk, $a5a9ed1d43a3a911$var$vk), d);
                        break;
                    }
                    $a5a9ed1d43a3a911$var$Qk(a, $a5a9ed1d43a3a911$var$uk, $a5a9ed1d43a3a911$var$vk);
                    break;
                case 5:
                    $a5a9ed1d43a3a911$var$Qk(a, $a5a9ed1d43a3a911$var$uk, $a5a9ed1d43a3a911$var$vk);
                    break;
                default:
                    throw Error($a5a9ed1d43a3a911$var$p(329));
            }
        }
    }
    $a5a9ed1d43a3a911$var$Ek(a, $a5a9ed1d43a3a911$var$B());
    return a.callbackNode === c ? $a5a9ed1d43a3a911$var$Hk.bind(null, a) : null;
}
function $a5a9ed1d43a3a911$var$Ok(a, b) {
    var c = $a5a9ed1d43a3a911$var$tk;
    a.current.memoizedState.isDehydrated && ($a5a9ed1d43a3a911$var$Lk(a, b).flags |= 256);
    a = $a5a9ed1d43a3a911$var$Jk(a, b);
    2 !== a && (b = $a5a9ed1d43a3a911$var$uk, $a5a9ed1d43a3a911$var$uk = c, null !== b && $a5a9ed1d43a3a911$var$Gj(b));
    return a;
}
function $a5a9ed1d43a3a911$var$Gj(a) {
    null === $a5a9ed1d43a3a911$var$uk ? $a5a9ed1d43a3a911$var$uk = a : $a5a9ed1d43a3a911$var$uk.push.apply($a5a9ed1d43a3a911$var$uk, a);
}
function $a5a9ed1d43a3a911$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$a5a9ed1d43a3a911$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $a5a9ed1d43a3a911$var$Dk(a, b) {
    b &= ~$a5a9ed1d43a3a911$var$sk;
    b &= ~$a5a9ed1d43a3a911$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $a5a9ed1d43a3a911$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $a5a9ed1d43a3a911$var$Fk(a) {
    if (0 !== ($a5a9ed1d43a3a911$var$K & 6)) throw Error($a5a9ed1d43a3a911$var$p(327));
    $a5a9ed1d43a3a911$var$Ik();
    var b = $a5a9ed1d43a3a911$var$uc(a, 0);
    if (0 === (b & 1)) return $a5a9ed1d43a3a911$var$Ek(a, $a5a9ed1d43a3a911$var$B()), null;
    var c = $a5a9ed1d43a3a911$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $a5a9ed1d43a3a911$var$xc(a);
        0 !== d && (b = d, c = $a5a9ed1d43a3a911$var$Ok(a, d));
    }
    if (1 === c) throw c = $a5a9ed1d43a3a911$var$qk, $a5a9ed1d43a3a911$var$Lk(a, 0), $a5a9ed1d43a3a911$var$Dk(a, b), $a5a9ed1d43a3a911$var$Ek(a, $a5a9ed1d43a3a911$var$B()), c;
    if (6 === c) throw Error($a5a9ed1d43a3a911$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $a5a9ed1d43a3a911$var$Qk(a, $a5a9ed1d43a3a911$var$uk, $a5a9ed1d43a3a911$var$vk);
    $a5a9ed1d43a3a911$var$Ek(a, $a5a9ed1d43a3a911$var$B());
    return null;
}
function $a5a9ed1d43a3a911$var$Rk(a, b) {
    var c = $a5a9ed1d43a3a911$var$K;
    $a5a9ed1d43a3a911$var$K |= 1;
    try {
        return a(b);
    } finally{
        $a5a9ed1d43a3a911$var$K = c, 0 === $a5a9ed1d43a3a911$var$K && ($a5a9ed1d43a3a911$var$Hj = $a5a9ed1d43a3a911$var$B() + 500, $a5a9ed1d43a3a911$var$fg && $a5a9ed1d43a3a911$var$jg());
    }
}
function $a5a9ed1d43a3a911$var$Sk(a) {
    null !== $a5a9ed1d43a3a911$var$xk && 0 === $a5a9ed1d43a3a911$var$xk.tag && 0 === ($a5a9ed1d43a3a911$var$K & 6) && $a5a9ed1d43a3a911$var$Ik();
    var b = $a5a9ed1d43a3a911$var$K;
    $a5a9ed1d43a3a911$var$K |= 1;
    var c = $a5a9ed1d43a3a911$var$pk.transition, d = $a5a9ed1d43a3a911$var$C;
    try {
        if ($a5a9ed1d43a3a911$var$pk.transition = null, $a5a9ed1d43a3a911$var$C = 1, a) return a();
    } finally{
        $a5a9ed1d43a3a911$var$C = d, $a5a9ed1d43a3a911$var$pk.transition = c, $a5a9ed1d43a3a911$var$K = b, 0 === ($a5a9ed1d43a3a911$var$K & 6) && $a5a9ed1d43a3a911$var$jg();
    }
}
function $a5a9ed1d43a3a911$var$Ij() {
    $a5a9ed1d43a3a911$var$gj = $a5a9ed1d43a3a911$var$fj.current;
    $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$fj);
}
function $a5a9ed1d43a3a911$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $a5a9ed1d43a3a911$var$Gf(c));
    if (null !== $a5a9ed1d43a3a911$var$Y) for(c = $a5a9ed1d43a3a911$var$Y.return; null !== c;){
        var d = c;
        $a5a9ed1d43a3a911$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $a5a9ed1d43a3a911$var$$f();
                break;
            case 3:
                $a5a9ed1d43a3a911$var$Jh();
                $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Wf);
                $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$H);
                $a5a9ed1d43a3a911$var$Oh();
                break;
            case 5:
                $a5a9ed1d43a3a911$var$Lh(d);
                break;
            case 4:
                $a5a9ed1d43a3a911$var$Jh();
                break;
            case 13:
                $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$M);
                break;
            case 19:
                $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$M);
                break;
            case 10:
                $a5a9ed1d43a3a911$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $a5a9ed1d43a3a911$var$Ij();
        }
        c = c.return;
    }
    $a5a9ed1d43a3a911$var$R = a;
    $a5a9ed1d43a3a911$var$Y = a = $a5a9ed1d43a3a911$var$wh(a.current, null);
    $a5a9ed1d43a3a911$var$Z = $a5a9ed1d43a3a911$var$gj = b;
    $a5a9ed1d43a3a911$var$T = 0;
    $a5a9ed1d43a3a911$var$qk = null;
    $a5a9ed1d43a3a911$var$sk = $a5a9ed1d43a3a911$var$rk = $a5a9ed1d43a3a911$var$hh = 0;
    $a5a9ed1d43a3a911$var$uk = $a5a9ed1d43a3a911$var$tk = null;
    if (null !== $a5a9ed1d43a3a911$var$Wg) {
        for(b = 0; b < $a5a9ed1d43a3a911$var$Wg.length; b++)if (c = $a5a9ed1d43a3a911$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $a5a9ed1d43a3a911$var$Wg = null;
    }
    return a;
}
function $a5a9ed1d43a3a911$var$Nk(a, b) {
    do {
        var c = $a5a9ed1d43a3a911$var$Y;
        try {
            $a5a9ed1d43a3a911$var$Qg();
            $a5a9ed1d43a3a911$var$Ph.current = $a5a9ed1d43a3a911$var$ai;
            if ($a5a9ed1d43a3a911$var$Sh) {
                for(var d = $a5a9ed1d43a3a911$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $a5a9ed1d43a3a911$var$Sh = !1;
            }
            $a5a9ed1d43a3a911$var$Rh = 0;
            $a5a9ed1d43a3a911$var$P = $a5a9ed1d43a3a911$var$O = $a5a9ed1d43a3a911$var$N = null;
            $a5a9ed1d43a3a911$var$Th = !1;
            $a5a9ed1d43a3a911$var$Uh = 0;
            $a5a9ed1d43a3a911$var$ok.current = null;
            if (null === c || null === c.return) {
                $a5a9ed1d43a3a911$var$T = 1;
                $a5a9ed1d43a3a911$var$qk = b;
                $a5a9ed1d43a3a911$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $a5a9ed1d43a3a911$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $a5a9ed1d43a3a911$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $a5a9ed1d43a3a911$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $a5a9ed1d43a3a911$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $a5a9ed1d43a3a911$var$Ti(f, l, b);
                            $a5a9ed1d43a3a911$var$uj();
                            break a;
                        }
                        k = Error($a5a9ed1d43a3a911$var$p(426));
                    }
                } else if ($a5a9ed1d43a3a911$var$I && h.mode & 1) {
                    var J = $a5a9ed1d43a3a911$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $a5a9ed1d43a3a911$var$Wi(J, g, h, f, b);
                        $a5a9ed1d43a3a911$var$Jg($a5a9ed1d43a3a911$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $a5a9ed1d43a3a911$var$Ki(k, h);
                4 !== $a5a9ed1d43a3a911$var$T && ($a5a9ed1d43a3a911$var$T = 2);
                null === $a5a9ed1d43a3a911$var$tk ? $a5a9ed1d43a3a911$var$tk = [
                    f
                ] : $a5a9ed1d43a3a911$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $a5a9ed1d43a3a911$var$Oi(f, k, b);
                            $a5a9ed1d43a3a911$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $a5a9ed1d43a3a911$var$Si || !$a5a9ed1d43a3a911$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $a5a9ed1d43a3a911$var$Ri(f, h, b);
                                $a5a9ed1d43a3a911$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $a5a9ed1d43a3a911$var$Tk(c);
        } catch (na) {
            b = na;
            $a5a9ed1d43a3a911$var$Y === c && null !== c && ($a5a9ed1d43a3a911$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $a5a9ed1d43a3a911$var$Kk() {
    var a = $a5a9ed1d43a3a911$var$nk.current;
    $a5a9ed1d43a3a911$var$nk.current = $a5a9ed1d43a3a911$var$ai;
    return null === a ? $a5a9ed1d43a3a911$var$ai : a;
}
function $a5a9ed1d43a3a911$var$uj() {
    if (0 === $a5a9ed1d43a3a911$var$T || 3 === $a5a9ed1d43a3a911$var$T || 2 === $a5a9ed1d43a3a911$var$T) $a5a9ed1d43a3a911$var$T = 4;
    null === $a5a9ed1d43a3a911$var$R || 0 === ($a5a9ed1d43a3a911$var$hh & 268435455) && 0 === ($a5a9ed1d43a3a911$var$rk & 268435455) || $a5a9ed1d43a3a911$var$Dk($a5a9ed1d43a3a911$var$R, $a5a9ed1d43a3a911$var$Z);
}
function $a5a9ed1d43a3a911$var$Jk(a, b) {
    var c = $a5a9ed1d43a3a911$var$K;
    $a5a9ed1d43a3a911$var$K |= 2;
    var d = $a5a9ed1d43a3a911$var$Kk();
    if ($a5a9ed1d43a3a911$var$R !== a || $a5a9ed1d43a3a911$var$Z !== b) $a5a9ed1d43a3a911$var$vk = null, $a5a9ed1d43a3a911$var$Lk(a, b);
    for(;;)try {
        $a5a9ed1d43a3a911$var$Uk();
        break;
    } catch (e) {
        $a5a9ed1d43a3a911$var$Nk(a, e);
    }
    $a5a9ed1d43a3a911$var$Qg();
    $a5a9ed1d43a3a911$var$K = c;
    $a5a9ed1d43a3a911$var$nk.current = d;
    if (null !== $a5a9ed1d43a3a911$var$Y) throw Error($a5a9ed1d43a3a911$var$p(261));
    $a5a9ed1d43a3a911$var$R = null;
    $a5a9ed1d43a3a911$var$Z = 0;
    return $a5a9ed1d43a3a911$var$T;
}
function $a5a9ed1d43a3a911$var$Uk() {
    for(; null !== $a5a9ed1d43a3a911$var$Y;)$a5a9ed1d43a3a911$var$Vk($a5a9ed1d43a3a911$var$Y);
}
function $a5a9ed1d43a3a911$var$Mk() {
    for(; null !== $a5a9ed1d43a3a911$var$Y && !$a5a9ed1d43a3a911$var$cc();)$a5a9ed1d43a3a911$var$Vk($a5a9ed1d43a3a911$var$Y);
}
function $a5a9ed1d43a3a911$var$Vk(a) {
    var b = $a5a9ed1d43a3a911$var$Wk(a.alternate, a, $a5a9ed1d43a3a911$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $a5a9ed1d43a3a911$var$Tk(a) : $a5a9ed1d43a3a911$var$Y = b;
    $a5a9ed1d43a3a911$var$ok.current = null;
}
function $a5a9ed1d43a3a911$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $a5a9ed1d43a3a911$var$Fj(c, b, $a5a9ed1d43a3a911$var$gj), null !== c) {
                $a5a9ed1d43a3a911$var$Y = c;
                return;
            }
        } else {
            c = $a5a9ed1d43a3a911$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $a5a9ed1d43a3a911$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $a5a9ed1d43a3a911$var$T = 6;
                $a5a9ed1d43a3a911$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $a5a9ed1d43a3a911$var$Y = b;
            return;
        }
        $a5a9ed1d43a3a911$var$Y = b = a;
    }while (null !== b);
    0 === $a5a9ed1d43a3a911$var$T && ($a5a9ed1d43a3a911$var$T = 5);
}
function $a5a9ed1d43a3a911$var$Qk(a, b, c) {
    var d = $a5a9ed1d43a3a911$var$C, e = $a5a9ed1d43a3a911$var$pk.transition;
    try {
        $a5a9ed1d43a3a911$var$pk.transition = null, $a5a9ed1d43a3a911$var$C = 1, $a5a9ed1d43a3a911$var$Xk(a, b, c, d);
    } finally{
        $a5a9ed1d43a3a911$var$pk.transition = e, $a5a9ed1d43a3a911$var$C = d;
    }
    return null;
}
function $a5a9ed1d43a3a911$var$Xk(a, b, c, d) {
    do $a5a9ed1d43a3a911$var$Ik();
    while (null !== $a5a9ed1d43a3a911$var$xk);
    if (0 !== ($a5a9ed1d43a3a911$var$K & 6)) throw Error($a5a9ed1d43a3a911$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($a5a9ed1d43a3a911$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $a5a9ed1d43a3a911$var$Bc(a, f);
    a === $a5a9ed1d43a3a911$var$R && ($a5a9ed1d43a3a911$var$Y = $a5a9ed1d43a3a911$var$R = null, $a5a9ed1d43a3a911$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $a5a9ed1d43a3a911$var$wk || ($a5a9ed1d43a3a911$var$wk = !0, $a5a9ed1d43a3a911$var$Gk($a5a9ed1d43a3a911$var$hc, function() {
        $a5a9ed1d43a3a911$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $a5a9ed1d43a3a911$var$pk.transition;
        $a5a9ed1d43a3a911$var$pk.transition = null;
        var g = $a5a9ed1d43a3a911$var$C;
        $a5a9ed1d43a3a911$var$C = 1;
        var h = $a5a9ed1d43a3a911$var$K;
        $a5a9ed1d43a3a911$var$K |= 4;
        $a5a9ed1d43a3a911$var$ok.current = null;
        $a5a9ed1d43a3a911$var$Pj(a, c);
        $a5a9ed1d43a3a911$var$ek(c, a);
        $a5a9ed1d43a3a911$var$Oe($a5a9ed1d43a3a911$var$Df);
        $a5a9ed1d43a3a911$var$dd = !!$a5a9ed1d43a3a911$var$Cf;
        $a5a9ed1d43a3a911$var$Df = $a5a9ed1d43a3a911$var$Cf = null;
        a.current = c;
        $a5a9ed1d43a3a911$var$ik(c, a, e);
        $a5a9ed1d43a3a911$var$dc();
        $a5a9ed1d43a3a911$var$K = h;
        $a5a9ed1d43a3a911$var$C = g;
        $a5a9ed1d43a3a911$var$pk.transition = f;
    } else a.current = c;
    $a5a9ed1d43a3a911$var$wk && ($a5a9ed1d43a3a911$var$wk = !1, $a5a9ed1d43a3a911$var$xk = a, $a5a9ed1d43a3a911$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($a5a9ed1d43a3a911$var$Si = null);
    $a5a9ed1d43a3a911$var$mc(c.stateNode, d);
    $a5a9ed1d43a3a911$var$Ek(a, $a5a9ed1d43a3a911$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($a5a9ed1d43a3a911$var$Pi) throw $a5a9ed1d43a3a911$var$Pi = !1, a = $a5a9ed1d43a3a911$var$Qi, $a5a9ed1d43a3a911$var$Qi = null, a;
    0 !== ($a5a9ed1d43a3a911$var$yk & 1) && 0 !== a.tag && $a5a9ed1d43a3a911$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $a5a9ed1d43a3a911$var$Ak ? $a5a9ed1d43a3a911$var$zk++ : ($a5a9ed1d43a3a911$var$zk = 0, $a5a9ed1d43a3a911$var$Ak = a) : $a5a9ed1d43a3a911$var$zk = 0;
    $a5a9ed1d43a3a911$var$jg();
    return null;
}
function $a5a9ed1d43a3a911$var$Ik() {
    if (null !== $a5a9ed1d43a3a911$var$xk) {
        var a = $a5a9ed1d43a3a911$var$Dc($a5a9ed1d43a3a911$var$yk), b = $a5a9ed1d43a3a911$var$pk.transition, c = $a5a9ed1d43a3a911$var$C;
        try {
            $a5a9ed1d43a3a911$var$pk.transition = null;
            $a5a9ed1d43a3a911$var$C = 16 > a ? 16 : a;
            if (null === $a5a9ed1d43a3a911$var$xk) var d = !1;
            else {
                a = $a5a9ed1d43a3a911$var$xk;
                $a5a9ed1d43a3a911$var$xk = null;
                $a5a9ed1d43a3a911$var$yk = 0;
                if (0 !== ($a5a9ed1d43a3a911$var$K & 6)) throw Error($a5a9ed1d43a3a911$var$p(331));
                var e = $a5a9ed1d43a3a911$var$K;
                $a5a9ed1d43a3a911$var$K |= 4;
                for($a5a9ed1d43a3a911$var$V = a.current; null !== $a5a9ed1d43a3a911$var$V;){
                    var f = $a5a9ed1d43a3a911$var$V, g = f.child;
                    if (0 !== ($a5a9ed1d43a3a911$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($a5a9ed1d43a3a911$var$V = l; null !== $a5a9ed1d43a3a911$var$V;){
                                    var m = $a5a9ed1d43a3a911$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $a5a9ed1d43a3a911$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $a5a9ed1d43a3a911$var$V = q;
                                    else for(; null !== $a5a9ed1d43a3a911$var$V;){
                                        m = $a5a9ed1d43a3a911$var$V;
                                        var r = m.sibling, y = m.return;
                                        $a5a9ed1d43a3a911$var$Tj(m);
                                        if (m === l) {
                                            $a5a9ed1d43a3a911$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $a5a9ed1d43a3a911$var$V = r;
                                            break;
                                        }
                                        $a5a9ed1d43a3a911$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $a5a9ed1d43a3a911$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $a5a9ed1d43a3a911$var$V = g;
                    else b: for(; null !== $a5a9ed1d43a3a911$var$V;){
                        f = $a5a9ed1d43a3a911$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $a5a9ed1d43a3a911$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $a5a9ed1d43a3a911$var$V = x;
                            break b;
                        }
                        $a5a9ed1d43a3a911$var$V = f.return;
                    }
                }
                var w = a.current;
                for($a5a9ed1d43a3a911$var$V = w; null !== $a5a9ed1d43a3a911$var$V;){
                    g = $a5a9ed1d43a3a911$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $a5a9ed1d43a3a911$var$V = u;
                    else b: for(g = w; null !== $a5a9ed1d43a3a911$var$V;){
                        h = $a5a9ed1d43a3a911$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $a5a9ed1d43a3a911$var$Rj(9, h);
                            }
                        } catch (na) {
                            $a5a9ed1d43a3a911$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $a5a9ed1d43a3a911$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $a5a9ed1d43a3a911$var$V = F;
                            break b;
                        }
                        $a5a9ed1d43a3a911$var$V = h.return;
                    }
                }
                $a5a9ed1d43a3a911$var$K = e;
                $a5a9ed1d43a3a911$var$jg();
                if ($a5a9ed1d43a3a911$var$lc && "function" === typeof $a5a9ed1d43a3a911$var$lc.onPostCommitFiberRoot) try {
                    $a5a9ed1d43a3a911$var$lc.onPostCommitFiberRoot($a5a9ed1d43a3a911$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $a5a9ed1d43a3a911$var$C = c, $a5a9ed1d43a3a911$var$pk.transition = b;
        }
    }
    return !1;
}
function $a5a9ed1d43a3a911$var$Yk(a, b, c) {
    b = $a5a9ed1d43a3a911$var$Ki(c, b);
    b = $a5a9ed1d43a3a911$var$Oi(a, b, 1);
    a = $a5a9ed1d43a3a911$var$dh(a, b, 1);
    b = $a5a9ed1d43a3a911$var$L();
    null !== a && ($a5a9ed1d43a3a911$var$Ac(a, 1, b), $a5a9ed1d43a3a911$var$Ek(a, b));
}
function $a5a9ed1d43a3a911$var$W(a, b, c) {
    if (3 === a.tag) $a5a9ed1d43a3a911$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $a5a9ed1d43a3a911$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $a5a9ed1d43a3a911$var$Si || !$a5a9ed1d43a3a911$var$Si.has(d))) {
                a = $a5a9ed1d43a3a911$var$Ki(c, a);
                a = $a5a9ed1d43a3a911$var$Ri(b, a, 1);
                b = $a5a9ed1d43a3a911$var$dh(b, a, 1);
                a = $a5a9ed1d43a3a911$var$L();
                null !== b && ($a5a9ed1d43a3a911$var$Ac(b, 1, a), $a5a9ed1d43a3a911$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $a5a9ed1d43a3a911$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $a5a9ed1d43a3a911$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $a5a9ed1d43a3a911$var$R === a && ($a5a9ed1d43a3a911$var$Z & c) === c && (4 === $a5a9ed1d43a3a911$var$T || 3 === $a5a9ed1d43a3a911$var$T && ($a5a9ed1d43a3a911$var$Z & 130023424) === $a5a9ed1d43a3a911$var$Z && 500 > $a5a9ed1d43a3a911$var$B() - $a5a9ed1d43a3a911$var$gk ? $a5a9ed1d43a3a911$var$Lk(a, 0) : $a5a9ed1d43a3a911$var$sk |= c);
    $a5a9ed1d43a3a911$var$Ek(a, b);
}
function $a5a9ed1d43a3a911$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $a5a9ed1d43a3a911$var$sc, $a5a9ed1d43a3a911$var$sc <<= 1, 0 === ($a5a9ed1d43a3a911$var$sc & 130023424) && ($a5a9ed1d43a3a911$var$sc = 4194304)));
    var c = $a5a9ed1d43a3a911$var$L();
    a = $a5a9ed1d43a3a911$var$Zg(a, b);
    null !== a && ($a5a9ed1d43a3a911$var$Ac(a, b, c), $a5a9ed1d43a3a911$var$Ek(a, c));
}
function $a5a9ed1d43a3a911$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $a5a9ed1d43a3a911$var$Zk(a, c);
}
function $a5a9ed1d43a3a911$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($a5a9ed1d43a3a911$var$p(314));
    }
    null !== d && d.delete(b);
    $a5a9ed1d43a3a911$var$Zk(a, c);
}
var $a5a9ed1d43a3a911$var$Wk;
$a5a9ed1d43a3a911$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $a5a9ed1d43a3a911$var$Wf.current) $a5a9ed1d43a3a911$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $a5a9ed1d43a3a911$var$Ug = !1, $a5a9ed1d43a3a911$var$zj(a, b, c);
            $a5a9ed1d43a3a911$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $a5a9ed1d43a3a911$var$Ug = !1, $a5a9ed1d43a3a911$var$I && 0 !== (b.flags & 1048576) && $a5a9ed1d43a3a911$var$ug(b, $a5a9ed1d43a3a911$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $a5a9ed1d43a3a911$var$jj(a, b);
            a = b.pendingProps;
            var e = $a5a9ed1d43a3a911$var$Yf(b, $a5a9ed1d43a3a911$var$H.current);
            $a5a9ed1d43a3a911$var$Tg(b, c);
            e = $a5a9ed1d43a3a911$var$Xh(null, b, d, a, e, c);
            var f = $a5a9ed1d43a3a911$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $a5a9ed1d43a3a911$var$Zf(d) ? (f = !0, $a5a9ed1d43a3a911$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $a5a9ed1d43a3a911$var$ah(b), e.updater = $a5a9ed1d43a3a911$var$nh, b.stateNode = e, e._reactInternals = b, $a5a9ed1d43a3a911$var$rh(b, d, a, c), b = $a5a9ed1d43a3a911$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $a5a9ed1d43a3a911$var$I && f && $a5a9ed1d43a3a911$var$vg(b), $a5a9ed1d43a3a911$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $a5a9ed1d43a3a911$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $a5a9ed1d43a3a911$var$$k(d);
                a = $a5a9ed1d43a3a911$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $a5a9ed1d43a3a911$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $a5a9ed1d43a3a911$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $a5a9ed1d43a3a911$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $a5a9ed1d43a3a911$var$aj(null, b, d, $a5a9ed1d43a3a911$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($a5a9ed1d43a3a911$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a5a9ed1d43a3a911$var$Lg(d, e), $a5a9ed1d43a3a911$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a5a9ed1d43a3a911$var$Lg(d, e), $a5a9ed1d43a3a911$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $a5a9ed1d43a3a911$var$lj(b);
                if (null === a) throw Error($a5a9ed1d43a3a911$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $a5a9ed1d43a3a911$var$bh(a, b);
                $a5a9ed1d43a3a911$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $a5a9ed1d43a3a911$var$Ki(Error($a5a9ed1d43a3a911$var$p(423)), b);
                        b = $a5a9ed1d43a3a911$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $a5a9ed1d43a3a911$var$Ki(Error($a5a9ed1d43a3a911$var$p(424)), b);
                        b = $a5a9ed1d43a3a911$var$mj(a, b, d, c, e);
                        break a;
                    } else for($a5a9ed1d43a3a911$var$yg = $a5a9ed1d43a3a911$var$Lf(b.stateNode.containerInfo.firstChild), $a5a9ed1d43a3a911$var$xg = b, $a5a9ed1d43a3a911$var$I = !0, $a5a9ed1d43a3a911$var$zg = null, c = $a5a9ed1d43a3a911$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $a5a9ed1d43a3a911$var$Ig();
                    if (d === e) {
                        b = $a5a9ed1d43a3a911$var$$i(a, b, c);
                        break a;
                    }
                    $a5a9ed1d43a3a911$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $a5a9ed1d43a3a911$var$Kh(b), null === a && $a5a9ed1d43a3a911$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $a5a9ed1d43a3a911$var$Ef(d, e) ? g = null : null !== f && $a5a9ed1d43a3a911$var$Ef(d, f) && (b.flags |= 32), $a5a9ed1d43a3a911$var$hj(a, b), $a5a9ed1d43a3a911$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $a5a9ed1d43a3a911$var$Eg(b), null;
        case 13:
            return $a5a9ed1d43a3a911$var$pj(a, b, c);
        case 4:
            return $a5a9ed1d43a3a911$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $a5a9ed1d43a3a911$var$Bh(b, null, d, c) : $a5a9ed1d43a3a911$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a5a9ed1d43a3a911$var$Lg(d, e), $a5a9ed1d43a3a911$var$Zi(a, b, d, e, c);
        case 7:
            return $a5a9ed1d43a3a911$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $a5a9ed1d43a3a911$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $a5a9ed1d43a3a911$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($a5a9ed1d43a3a911$var$He(f.value, g)) {
                        if (f.children === e.children && !$a5a9ed1d43a3a911$var$Wf.current) {
                            b = $a5a9ed1d43a3a911$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $a5a9ed1d43a3a911$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $a5a9ed1d43a3a911$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($a5a9ed1d43a3a911$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $a5a9ed1d43a3a911$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $a5a9ed1d43a3a911$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $a5a9ed1d43a3a911$var$Tg(b, c), e = $a5a9ed1d43a3a911$var$Vg(e), d = d(e), b.flags |= 1, $a5a9ed1d43a3a911$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $a5a9ed1d43a3a911$var$Lg(d, b.pendingProps), e = $a5a9ed1d43a3a911$var$Lg(d.type, e), $a5a9ed1d43a3a911$var$aj(a, b, d, e, c);
        case 15:
            return $a5a9ed1d43a3a911$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a5a9ed1d43a3a911$var$Lg(d, e), $a5a9ed1d43a3a911$var$jj(a, b), b.tag = 1, $a5a9ed1d43a3a911$var$Zf(d) ? (a = !0, $a5a9ed1d43a3a911$var$cg(b)) : a = !1, $a5a9ed1d43a3a911$var$Tg(b, c), $a5a9ed1d43a3a911$var$ph(b, d, e), $a5a9ed1d43a3a911$var$rh(b, d, e, c), $a5a9ed1d43a3a911$var$kj(null, b, d, !0, a, c);
        case 19:
            return $a5a9ed1d43a3a911$var$yj(a, b, c);
        case 22:
            return $a5a9ed1d43a3a911$var$ej(a, b, c);
    }
    throw Error($a5a9ed1d43a3a911$var$p(156, b.tag));
};
function $a5a9ed1d43a3a911$var$Gk(a, b) {
    return $a5a9ed1d43a3a911$var$ac(a, b);
}
function $a5a9ed1d43a3a911$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $a5a9ed1d43a3a911$var$Bg(a, b, c, d) {
    return new $a5a9ed1d43a3a911$var$al(a, b, c, d);
}
function $a5a9ed1d43a3a911$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $a5a9ed1d43a3a911$var$$k(a) {
    if ("function" === typeof a) return $a5a9ed1d43a3a911$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $a5a9ed1d43a3a911$var$Da) return 11;
        if (a === $a5a9ed1d43a3a911$var$Ga) return 14;
    }
    return 2;
}
function $a5a9ed1d43a3a911$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $a5a9ed1d43a3a911$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $a5a9ed1d43a3a911$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $a5a9ed1d43a3a911$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $a5a9ed1d43a3a911$var$ya:
            return $a5a9ed1d43a3a911$var$Ah(c.children, e, f, b);
        case $a5a9ed1d43a3a911$var$za:
            g = 8;
            e |= 8;
            break;
        case $a5a9ed1d43a3a911$var$Aa:
            return a = $a5a9ed1d43a3a911$var$Bg(12, c, b, e | 2), a.elementType = $a5a9ed1d43a3a911$var$Aa, a.lanes = f, a;
        case $a5a9ed1d43a3a911$var$Ea:
            return a = $a5a9ed1d43a3a911$var$Bg(13, c, b, e), a.elementType = $a5a9ed1d43a3a911$var$Ea, a.lanes = f, a;
        case $a5a9ed1d43a3a911$var$Fa:
            return a = $a5a9ed1d43a3a911$var$Bg(19, c, b, e), a.elementType = $a5a9ed1d43a3a911$var$Fa, a.lanes = f, a;
        case $a5a9ed1d43a3a911$var$Ia:
            return $a5a9ed1d43a3a911$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $a5a9ed1d43a3a911$var$Ba:
                    g = 10;
                    break a;
                case $a5a9ed1d43a3a911$var$Ca:
                    g = 9;
                    break a;
                case $a5a9ed1d43a3a911$var$Da:
                    g = 11;
                    break a;
                case $a5a9ed1d43a3a911$var$Ga:
                    g = 14;
                    break a;
                case $a5a9ed1d43a3a911$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($a5a9ed1d43a3a911$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $a5a9ed1d43a3a911$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $a5a9ed1d43a3a911$var$Ah(a, b, c, d) {
    a = $a5a9ed1d43a3a911$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $a5a9ed1d43a3a911$var$qj(a, b, c, d) {
    a = $a5a9ed1d43a3a911$var$Bg(22, a, d, b);
    a.elementType = $a5a9ed1d43a3a911$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $a5a9ed1d43a3a911$var$xh(a, b, c) {
    a = $a5a9ed1d43a3a911$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $a5a9ed1d43a3a911$var$zh(a, b, c) {
    b = $a5a9ed1d43a3a911$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $a5a9ed1d43a3a911$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $a5a9ed1d43a3a911$var$zc(0);
    this.expirationTimes = $a5a9ed1d43a3a911$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $a5a9ed1d43a3a911$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $a5a9ed1d43a3a911$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $a5a9ed1d43a3a911$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $a5a9ed1d43a3a911$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $a5a9ed1d43a3a911$var$ah(f);
    return a;
}
function $a5a9ed1d43a3a911$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a5a9ed1d43a3a911$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $a5a9ed1d43a3a911$var$el(a) {
    if (!a) return $a5a9ed1d43a3a911$var$Vf;
    a = a._reactInternals;
    a: {
        if ($a5a9ed1d43a3a911$var$Vb(a) !== a || 1 !== a.tag) throw Error($a5a9ed1d43a3a911$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($a5a9ed1d43a3a911$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($a5a9ed1d43a3a911$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($a5a9ed1d43a3a911$var$Zf(c)) return $a5a9ed1d43a3a911$var$bg(a, c, b);
    }
    return b;
}
function $a5a9ed1d43a3a911$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $a5a9ed1d43a3a911$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $a5a9ed1d43a3a911$var$el(null);
    c = a.current;
    d = $a5a9ed1d43a3a911$var$L();
    e = $a5a9ed1d43a3a911$var$lh(c);
    f = $a5a9ed1d43a3a911$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $a5a9ed1d43a3a911$var$dh(c, f, e);
    a.current.lanes = e;
    $a5a9ed1d43a3a911$var$Ac(a, e, d);
    $a5a9ed1d43a3a911$var$Ek(a, d);
    return a;
}
function $a5a9ed1d43a3a911$var$gl(a, b, c, d) {
    var e = b.current, f = $a5a9ed1d43a3a911$var$L(), g = $a5a9ed1d43a3a911$var$lh(e);
    c = $a5a9ed1d43a3a911$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $a5a9ed1d43a3a911$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $a5a9ed1d43a3a911$var$dh(e, b, g);
    null !== a && ($a5a9ed1d43a3a911$var$mh(a, e, g, f), $a5a9ed1d43a3a911$var$eh(a, e, g));
    return g;
}
function $a5a9ed1d43a3a911$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $a5a9ed1d43a3a911$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $a5a9ed1d43a3a911$var$jl(a, b) {
    $a5a9ed1d43a3a911$var$il(a, b);
    (a = a.alternate) && $a5a9ed1d43a3a911$var$il(a, b);
}
function $a5a9ed1d43a3a911$var$kl() {
    return null;
}
var $a5a9ed1d43a3a911$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $a5a9ed1d43a3a911$var$ml(a) {
    this._internalRoot = a;
}
$a5a9ed1d43a3a911$var$nl.prototype.render = $a5a9ed1d43a3a911$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($a5a9ed1d43a3a911$var$p(409));
    $a5a9ed1d43a3a911$var$gl(a, b, null, null);
};
$a5a9ed1d43a3a911$var$nl.prototype.unmount = $a5a9ed1d43a3a911$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $a5a9ed1d43a3a911$var$Sk(function() {
            $a5a9ed1d43a3a911$var$gl(null, a, null, null);
        });
        b[$a5a9ed1d43a3a911$var$uf] = null;
    }
};
function $a5a9ed1d43a3a911$var$nl(a) {
    this._internalRoot = a;
}
$a5a9ed1d43a3a911$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $a5a9ed1d43a3a911$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $a5a9ed1d43a3a911$var$Qc.length && 0 !== b && b < $a5a9ed1d43a3a911$var$Qc[c].priority; c++);
        $a5a9ed1d43a3a911$var$Qc.splice(c, 0, a);
        0 === c && $a5a9ed1d43a3a911$var$Vc(a);
    }
};
function $a5a9ed1d43a3a911$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $a5a9ed1d43a3a911$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $a5a9ed1d43a3a911$var$ql() {}
function $a5a9ed1d43a3a911$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $a5a9ed1d43a3a911$var$hl(g);
                f.call(a);
            };
        }
        var g = $a5a9ed1d43a3a911$var$fl(b, d, a, 0, null, !1, !1, "", $a5a9ed1d43a3a911$var$ql);
        a._reactRootContainer = g;
        a[$a5a9ed1d43a3a911$var$uf] = g.current;
        $a5a9ed1d43a3a911$var$sf(8 === a.nodeType ? a.parentNode : a);
        $a5a9ed1d43a3a911$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $a5a9ed1d43a3a911$var$hl(k);
            h.call(a);
        };
    }
    var k = $a5a9ed1d43a3a911$var$cl(a, 0, !1, null, null, !1, !1, "", $a5a9ed1d43a3a911$var$ql);
    a._reactRootContainer = k;
    a[$a5a9ed1d43a3a911$var$uf] = k.current;
    $a5a9ed1d43a3a911$var$sf(8 === a.nodeType ? a.parentNode : a);
    $a5a9ed1d43a3a911$var$Sk(function() {
        $a5a9ed1d43a3a911$var$gl(b, k, c, d);
    });
    return k;
}
function $a5a9ed1d43a3a911$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $a5a9ed1d43a3a911$var$hl(g);
                h.call(a);
            };
        }
        $a5a9ed1d43a3a911$var$gl(b, g, a, e);
    } else g = $a5a9ed1d43a3a911$var$rl(c, b, a, e, d);
    return $a5a9ed1d43a3a911$var$hl(g);
}
$a5a9ed1d43a3a911$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $a5a9ed1d43a3a911$var$tc(b.pendingLanes);
                0 !== c && ($a5a9ed1d43a3a911$var$Cc(b, c | 1), $a5a9ed1d43a3a911$var$Ek(b, $a5a9ed1d43a3a911$var$B()), 0 === ($a5a9ed1d43a3a911$var$K & 6) && ($a5a9ed1d43a3a911$var$Hj = $a5a9ed1d43a3a911$var$B() + 500, $a5a9ed1d43a3a911$var$jg()));
            }
            break;
        case 13:
            $a5a9ed1d43a3a911$var$Sk(function() {
                var b = $a5a9ed1d43a3a911$var$Zg(a, 1);
                if (null !== b) {
                    var c = $a5a9ed1d43a3a911$var$L();
                    $a5a9ed1d43a3a911$var$mh(b, a, 1, c);
                }
            }), $a5a9ed1d43a3a911$var$jl(a, 1);
    }
};
$a5a9ed1d43a3a911$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $a5a9ed1d43a3a911$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $a5a9ed1d43a3a911$var$L();
            $a5a9ed1d43a3a911$var$mh(b, a, 134217728, c);
        }
        $a5a9ed1d43a3a911$var$jl(a, 134217728);
    }
};
$a5a9ed1d43a3a911$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $a5a9ed1d43a3a911$var$lh(a), c = $a5a9ed1d43a3a911$var$Zg(a, b);
        if (null !== c) {
            var d = $a5a9ed1d43a3a911$var$L();
            $a5a9ed1d43a3a911$var$mh(c, a, b, d);
        }
        $a5a9ed1d43a3a911$var$jl(a, b);
    }
};
$a5a9ed1d43a3a911$var$Hc = function() {
    return $a5a9ed1d43a3a911$var$C;
};
$a5a9ed1d43a3a911$var$Ic = function(a, b) {
    var c = $a5a9ed1d43a3a911$var$C;
    try {
        return $a5a9ed1d43a3a911$var$C = a, b();
    } finally{
        $a5a9ed1d43a3a911$var$C = c;
    }
};
$a5a9ed1d43a3a911$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $a5a9ed1d43a3a911$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $a5a9ed1d43a3a911$var$Db(d);
                        if (!e) throw Error($a5a9ed1d43a3a911$var$p(90));
                        $a5a9ed1d43a3a911$var$Wa(d);
                        $a5a9ed1d43a3a911$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $a5a9ed1d43a3a911$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $a5a9ed1d43a3a911$var$fb(a, !!c.multiple, b, !1);
    }
};
$a5a9ed1d43a3a911$var$Gb = $a5a9ed1d43a3a911$var$Rk;
$a5a9ed1d43a3a911$var$Hb = $a5a9ed1d43a3a911$var$Sk;
var $a5a9ed1d43a3a911$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $a5a9ed1d43a3a911$var$Cb,
        $a5a9ed1d43a3a911$var$ue,
        $a5a9ed1d43a3a911$var$Db,
        $a5a9ed1d43a3a911$var$Eb,
        $a5a9ed1d43a3a911$var$Fb,
        $a5a9ed1d43a3a911$var$Rk
    ]
}, $a5a9ed1d43a3a911$var$ul = {
    findFiberByHostInstance: $a5a9ed1d43a3a911$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $a5a9ed1d43a3a911$var$vl = {
    bundleType: $a5a9ed1d43a3a911$var$ul.bundleType,
    version: $a5a9ed1d43a3a911$var$ul.version,
    rendererPackageName: $a5a9ed1d43a3a911$var$ul.rendererPackageName,
    rendererConfig: $a5a9ed1d43a3a911$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $a5a9ed1d43a3a911$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $a5a9ed1d43a3a911$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $a5a9ed1d43a3a911$var$ul.findFiberByHostInstance || $a5a9ed1d43a3a911$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $a5a9ed1d43a3a911$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$a5a9ed1d43a3a911$var$wl.isDisabled && $a5a9ed1d43a3a911$var$wl.supportsFiber) try {
        $a5a9ed1d43a3a911$var$kc = $a5a9ed1d43a3a911$var$wl.inject($a5a9ed1d43a3a911$var$vl), $a5a9ed1d43a3a911$var$lc = $a5a9ed1d43a3a911$var$wl;
    } catch (a) {}
}
$a5a9ed1d43a3a911$export$ae55be85d98224ed = $a5a9ed1d43a3a911$var$tl;
$a5a9ed1d43a3a911$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$a5a9ed1d43a3a911$var$ol(b)) throw Error($a5a9ed1d43a3a911$var$p(200));
    return $a5a9ed1d43a3a911$var$dl(a, b, null, c);
};
$a5a9ed1d43a3a911$export$882461b6382ed46c = function(a, b) {
    if (!$a5a9ed1d43a3a911$var$ol(a)) throw Error($a5a9ed1d43a3a911$var$p(299));
    var c = !1, d = "", e = $a5a9ed1d43a3a911$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $a5a9ed1d43a3a911$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$a5a9ed1d43a3a911$var$uf] = b.current;
    $a5a9ed1d43a3a911$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $a5a9ed1d43a3a911$var$ml(b);
};
$a5a9ed1d43a3a911$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($a5a9ed1d43a3a911$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($a5a9ed1d43a3a911$var$p(268, a));
    }
    a = $a5a9ed1d43a3a911$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$a5a9ed1d43a3a911$export$cd75ccfd720a3cd4 = function(a) {
    return $a5a9ed1d43a3a911$var$Sk(a);
};
$a5a9ed1d43a3a911$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$a5a9ed1d43a3a911$var$pl(b)) throw Error($a5a9ed1d43a3a911$var$p(200));
    return $a5a9ed1d43a3a911$var$sl(null, a, b, !0, c);
};
$a5a9ed1d43a3a911$export$757ceba2d55c277e = function(a, b, c) {
    if (!$a5a9ed1d43a3a911$var$ol(a)) throw Error($a5a9ed1d43a3a911$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $a5a9ed1d43a3a911$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $a5a9ed1d43a3a911$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$a5a9ed1d43a3a911$var$uf] = b.current;
    $a5a9ed1d43a3a911$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $a5a9ed1d43a3a911$var$nl(b);
};
$a5a9ed1d43a3a911$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$a5a9ed1d43a3a911$var$pl(b)) throw Error($a5a9ed1d43a3a911$var$p(200));
    return $a5a9ed1d43a3a911$var$sl(null, a, b, !1, c);
};
$a5a9ed1d43a3a911$export$502457920280e6be = function(a) {
    if (!$a5a9ed1d43a3a911$var$pl(a)) throw Error($a5a9ed1d43a3a911$var$p(40));
    return a._reactRootContainer ? ($a5a9ed1d43a3a911$var$Sk(function() {
        $a5a9ed1d43a3a911$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$a5a9ed1d43a3a911$var$uf] = null;
        });
    }), !0) : !1;
};
$a5a9ed1d43a3a911$export$c78a37762a8d58e1 = $a5a9ed1d43a3a911$var$Rk;
$a5a9ed1d43a3a911$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$a5a9ed1d43a3a911$var$pl(c)) throw Error($a5a9ed1d43a3a911$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($a5a9ed1d43a3a911$var$p(38));
    return $a5a9ed1d43a3a911$var$sl(a, b, c, !1, d);
};
$a5a9ed1d43a3a911$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("c22GA", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jpqPB"));

});
parcelRequire.register("jpqPB", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $e2152a3e5622f9e8$export$c4744153514ff05d; }, function (v) { return $e2152a3e5622f9e8$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $e2152a3e5622f9e8$export$3e506c1ccc9cc1a7; }, function (v) { return $e2152a3e5622f9e8$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $e2152a3e5622f9e8$export$e26fe2ed2fa76875; }, function (v) { return $e2152a3e5622f9e8$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $e2152a3e5622f9e8$export$502329bbf4b505b1; }, function (v) { return $e2152a3e5622f9e8$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $e2152a3e5622f9e8$export$6e3807111c4874c4; }, function (v) { return $e2152a3e5622f9e8$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $e2152a3e5622f9e8$export$c27134553091fb3a; }, function (v) { return $e2152a3e5622f9e8$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $e2152a3e5622f9e8$export$33ee1acdc04fd2a2; }, function (v) { return $e2152a3e5622f9e8$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $e2152a3e5622f9e8$export$b00a404bbd5edef2; }, function (v) { return $e2152a3e5622f9e8$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $e2152a3e5622f9e8$export$8352ce38b91d0c62; }, function (v) { return $e2152a3e5622f9e8$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $e2152a3e5622f9e8$export$d66a1c1c77bd778b; }, function (v) { return $e2152a3e5622f9e8$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $e2152a3e5622f9e8$export$d3dfb8e4810cb555; }, function (v) { return $e2152a3e5622f9e8$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $e2152a3e5622f9e8$export$839f9183b0465a69; }, function (v) { return $e2152a3e5622f9e8$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $e2152a3e5622f9e8$export$72fdf0e06517287b; }, function (v) { return $e2152a3e5622f9e8$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $e2152a3e5622f9e8$export$4b844e58a3e414b4; }, function (v) { return $e2152a3e5622f9e8$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $e2152a3e5622f9e8$export$816d2913ae6b83b1; }, function (v) { return $e2152a3e5622f9e8$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $e2152a3e5622f9e8$export$61bcfe829111a1d0; }, function (v) { return $e2152a3e5622f9e8$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $e2152a3e5622f9e8$export$7ee8c9beb337bc3f; }, function (v) { return $e2152a3e5622f9e8$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $e2152a3e5622f9e8$export$b5836b71941fa3ed; }, function (v) { return $e2152a3e5622f9e8$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $e2152a3e5622f9e8$export$cf845f2c119da08a; }, function (v) { return $e2152a3e5622f9e8$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e2152a3e5622f9e8$export$c4744153514ff05d;
var $e2152a3e5622f9e8$export$3e506c1ccc9cc1a7;
var $e2152a3e5622f9e8$export$e26fe2ed2fa76875;
var $e2152a3e5622f9e8$export$502329bbf4b505b1;
var $e2152a3e5622f9e8$export$6e3807111c4874c4;
var $e2152a3e5622f9e8$export$c27134553091fb3a;
var $e2152a3e5622f9e8$export$33ee1acdc04fd2a2;
var $e2152a3e5622f9e8$export$b00a404bbd5edef2;
var $e2152a3e5622f9e8$export$8352ce38b91d0c62;
var $e2152a3e5622f9e8$export$d66a1c1c77bd778b;
var $e2152a3e5622f9e8$export$d3dfb8e4810cb555;
var $e2152a3e5622f9e8$export$839f9183b0465a69;
var $e2152a3e5622f9e8$export$72fdf0e06517287b;
var $e2152a3e5622f9e8$export$4b844e58a3e414b4;
var $e2152a3e5622f9e8$export$816d2913ae6b83b1;
var $e2152a3e5622f9e8$export$61bcfe829111a1d0;
var $e2152a3e5622f9e8$export$7ee8c9beb337bc3f;
var $e2152a3e5622f9e8$export$b5836b71941fa3ed;
var $e2152a3e5622f9e8$export$cf845f2c119da08a;
"use strict";
function $e2152a3e5622f9e8$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $e2152a3e5622f9e8$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $e2152a3e5622f9e8$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $e2152a3e5622f9e8$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $e2152a3e5622f9e8$var$g(C, c)) n < e && 0 > $e2152a3e5622f9e8$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $e2152a3e5622f9e8$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $e2152a3e5622f9e8$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $e2152a3e5622f9e8$var$l = performance;
    $e2152a3e5622f9e8$export$c4744153514ff05d = function() {
        return $e2152a3e5622f9e8$var$l.now();
    };
} else {
    var $e2152a3e5622f9e8$var$p = Date, $e2152a3e5622f9e8$var$q = $e2152a3e5622f9e8$var$p.now();
    $e2152a3e5622f9e8$export$c4744153514ff05d = function() {
        return $e2152a3e5622f9e8$var$p.now() - $e2152a3e5622f9e8$var$q;
    };
}
var $e2152a3e5622f9e8$var$r = [], $e2152a3e5622f9e8$var$t = [], $e2152a3e5622f9e8$var$u = 1, $e2152a3e5622f9e8$var$v = null, $e2152a3e5622f9e8$var$y = 3, $e2152a3e5622f9e8$var$z = !1, $e2152a3e5622f9e8$var$A = !1, $e2152a3e5622f9e8$var$B = !1, $e2152a3e5622f9e8$var$D = "function" === typeof setTimeout ? setTimeout : null, $e2152a3e5622f9e8$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $e2152a3e5622f9e8$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $e2152a3e5622f9e8$var$G(a) {
    for(var b = $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$t); null !== b;){
        if (null === b.callback) $e2152a3e5622f9e8$var$k($e2152a3e5622f9e8$var$t);
        else if (b.startTime <= a) $e2152a3e5622f9e8$var$k($e2152a3e5622f9e8$var$t), b.sortIndex = b.expirationTime, $e2152a3e5622f9e8$var$f($e2152a3e5622f9e8$var$r, b);
        else break;
        b = $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$t);
    }
}
function $e2152a3e5622f9e8$var$H(a) {
    $e2152a3e5622f9e8$var$B = !1;
    $e2152a3e5622f9e8$var$G(a);
    if (!$e2152a3e5622f9e8$var$A) {
        if (null !== $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$r)) $e2152a3e5622f9e8$var$A = !0, $e2152a3e5622f9e8$var$I($e2152a3e5622f9e8$var$J);
        else {
            var b = $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$t);
            null !== b && $e2152a3e5622f9e8$var$K($e2152a3e5622f9e8$var$H, b.startTime - a);
        }
    }
}
function $e2152a3e5622f9e8$var$J(a, b) {
    $e2152a3e5622f9e8$var$A = !1;
    $e2152a3e5622f9e8$var$B && ($e2152a3e5622f9e8$var$B = !1, $e2152a3e5622f9e8$var$E($e2152a3e5622f9e8$var$L), $e2152a3e5622f9e8$var$L = -1);
    $e2152a3e5622f9e8$var$z = !0;
    var c = $e2152a3e5622f9e8$var$y;
    try {
        $e2152a3e5622f9e8$var$G(b);
        for($e2152a3e5622f9e8$var$v = $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$r); null !== $e2152a3e5622f9e8$var$v && (!($e2152a3e5622f9e8$var$v.expirationTime > b) || a && !$e2152a3e5622f9e8$var$M());){
            var d = $e2152a3e5622f9e8$var$v.callback;
            if ("function" === typeof d) {
                $e2152a3e5622f9e8$var$v.callback = null;
                $e2152a3e5622f9e8$var$y = $e2152a3e5622f9e8$var$v.priorityLevel;
                var e = d($e2152a3e5622f9e8$var$v.expirationTime <= b);
                b = $e2152a3e5622f9e8$export$c4744153514ff05d();
                "function" === typeof e ? $e2152a3e5622f9e8$var$v.callback = e : $e2152a3e5622f9e8$var$v === $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$r) && $e2152a3e5622f9e8$var$k($e2152a3e5622f9e8$var$r);
                $e2152a3e5622f9e8$var$G(b);
            } else $e2152a3e5622f9e8$var$k($e2152a3e5622f9e8$var$r);
            $e2152a3e5622f9e8$var$v = $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$r);
        }
        if (null !== $e2152a3e5622f9e8$var$v) var w = !0;
        else {
            var m = $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$t);
            null !== m && $e2152a3e5622f9e8$var$K($e2152a3e5622f9e8$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $e2152a3e5622f9e8$var$v = null, $e2152a3e5622f9e8$var$y = c, $e2152a3e5622f9e8$var$z = !1;
    }
}
var $e2152a3e5622f9e8$var$N = !1, $e2152a3e5622f9e8$var$O = null, $e2152a3e5622f9e8$var$L = -1, $e2152a3e5622f9e8$var$P = 5, $e2152a3e5622f9e8$var$Q = -1;
function $e2152a3e5622f9e8$var$M() {
    return $e2152a3e5622f9e8$export$c4744153514ff05d() - $e2152a3e5622f9e8$var$Q < $e2152a3e5622f9e8$var$P ? !1 : !0;
}
function $e2152a3e5622f9e8$var$R() {
    if (null !== $e2152a3e5622f9e8$var$O) {
        var a = $e2152a3e5622f9e8$export$c4744153514ff05d();
        $e2152a3e5622f9e8$var$Q = a;
        var b = !0;
        try {
            b = $e2152a3e5622f9e8$var$O(!0, a);
        } finally{
            b ? $e2152a3e5622f9e8$var$S() : ($e2152a3e5622f9e8$var$N = !1, $e2152a3e5622f9e8$var$O = null);
        }
    } else $e2152a3e5622f9e8$var$N = !1;
}
var $e2152a3e5622f9e8$var$S;
if ("function" === typeof $e2152a3e5622f9e8$var$F) $e2152a3e5622f9e8$var$S = function() {
    $e2152a3e5622f9e8$var$F($e2152a3e5622f9e8$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $e2152a3e5622f9e8$var$T = new MessageChannel, $e2152a3e5622f9e8$var$U = $e2152a3e5622f9e8$var$T.port2;
    $e2152a3e5622f9e8$var$T.port1.onmessage = $e2152a3e5622f9e8$var$R;
    $e2152a3e5622f9e8$var$S = function() {
        $e2152a3e5622f9e8$var$U.postMessage(null);
    };
} else $e2152a3e5622f9e8$var$S = function() {
    $e2152a3e5622f9e8$var$D($e2152a3e5622f9e8$var$R, 0);
};
function $e2152a3e5622f9e8$var$I(a) {
    $e2152a3e5622f9e8$var$O = a;
    $e2152a3e5622f9e8$var$N || ($e2152a3e5622f9e8$var$N = !0, $e2152a3e5622f9e8$var$S());
}
function $e2152a3e5622f9e8$var$K(a, b) {
    $e2152a3e5622f9e8$var$L = $e2152a3e5622f9e8$var$D(function() {
        a($e2152a3e5622f9e8$export$c4744153514ff05d());
    }, b);
}
$e2152a3e5622f9e8$export$3e506c1ccc9cc1a7 = 5;
$e2152a3e5622f9e8$export$e26fe2ed2fa76875 = 1;
$e2152a3e5622f9e8$export$502329bbf4b505b1 = 4;
$e2152a3e5622f9e8$export$6e3807111c4874c4 = 3;
$e2152a3e5622f9e8$export$c27134553091fb3a = null;
$e2152a3e5622f9e8$export$33ee1acdc04fd2a2 = 2;
$e2152a3e5622f9e8$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$e2152a3e5622f9e8$export$8352ce38b91d0c62 = function() {
    $e2152a3e5622f9e8$var$A || $e2152a3e5622f9e8$var$z || ($e2152a3e5622f9e8$var$A = !0, $e2152a3e5622f9e8$var$I($e2152a3e5622f9e8$var$J));
};
$e2152a3e5622f9e8$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $e2152a3e5622f9e8$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$e2152a3e5622f9e8$export$d3dfb8e4810cb555 = function() {
    return $e2152a3e5622f9e8$var$y;
};
$e2152a3e5622f9e8$export$839f9183b0465a69 = function() {
    return $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$r);
};
$e2152a3e5622f9e8$export$72fdf0e06517287b = function(a) {
    switch($e2152a3e5622f9e8$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $e2152a3e5622f9e8$var$y;
    }
    var c = $e2152a3e5622f9e8$var$y;
    $e2152a3e5622f9e8$var$y = b;
    try {
        return a();
    } finally{
        $e2152a3e5622f9e8$var$y = c;
    }
};
$e2152a3e5622f9e8$export$4b844e58a3e414b4 = function() {};
$e2152a3e5622f9e8$export$816d2913ae6b83b1 = function() {};
$e2152a3e5622f9e8$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $e2152a3e5622f9e8$var$y;
    $e2152a3e5622f9e8$var$y = a;
    try {
        return b();
    } finally{
        $e2152a3e5622f9e8$var$y = c;
    }
};
$e2152a3e5622f9e8$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $e2152a3e5622f9e8$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $e2152a3e5622f9e8$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $e2152a3e5622f9e8$var$f($e2152a3e5622f9e8$var$t, a), null === $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$r) && a === $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$t) && ($e2152a3e5622f9e8$var$B ? ($e2152a3e5622f9e8$var$E($e2152a3e5622f9e8$var$L), $e2152a3e5622f9e8$var$L = -1) : $e2152a3e5622f9e8$var$B = !0, $e2152a3e5622f9e8$var$K($e2152a3e5622f9e8$var$H, c - d))) : (a.sortIndex = e, $e2152a3e5622f9e8$var$f($e2152a3e5622f9e8$var$r, a), $e2152a3e5622f9e8$var$A || $e2152a3e5622f9e8$var$z || ($e2152a3e5622f9e8$var$A = !0, $e2152a3e5622f9e8$var$I($e2152a3e5622f9e8$var$J)));
    return a;
};
$e2152a3e5622f9e8$export$b5836b71941fa3ed = $e2152a3e5622f9e8$var$M;
$e2152a3e5622f9e8$export$cf845f2c119da08a = function(a) {
    var b = $e2152a3e5622f9e8$var$y;
    return function() {
        var c = $e2152a3e5622f9e8$var$y;
        $e2152a3e5622f9e8$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $e2152a3e5622f9e8$var$y = c;
        }
    };
};

});



parcelRequire.register("36SZw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $243c96bcfe8eedda$export$2e2bcd8739ae039; });

var $5Wgfu = parcelRequire("5Wgfu");

var $aOChP = parcelRequire("aOChP");

var $kTVsv = parcelRequire("kTVsv");

var $gMng8 = parcelRequire("gMng8");

var $jymi1 = parcelRequire("jymi1");

var $hOJyT = parcelRequire("hOJyT");
var $7N6WB = parcelRequire("7N6WB");
var $7hR8K = parcelRequire("7hR8K");
var $2J1NG = parcelRequire("2J1NG");
var $3k1mL = parcelRequire("3k1mL");
parcelRequire("6SiPo");
var $aKZsc = parcelRequire("aKZsc");
var $6SiPo = parcelRequire("6SiPo");

var $kWBo5 = parcelRequire("kWBo5");
parcelRequire("9CGYE");
var $jk7Hk = parcelRequire("jk7Hk");
parcelRequire("288NN");
var $cm2x1 = parcelRequire("cm2x1");

var $jqxdk = parcelRequire("jqxdk");

var $6CrLZ = parcelRequire("6CrLZ");

var $kNZvx = parcelRequire("kNZvx");
const $243c96bcfe8eedda$var$Navbar = ()=>{
    // Using Context
    const { loggedInUser: loggedInUser, userName: userName, user: user } = (0, $aOChP.useContext)((0, $kWBo5.default));
    const [profilePic, setProfilePic] = (0, $aOChP.useState)("");
    const [showMenu, setShowMenu] = (0, $aOChP.useState)(false); // State to manage mobile menu visibility
    (0, $aOChP.useEffect)(()=>{
        (0, $jk7Hk.y)((0, $jqxdk.firebaseAuth), (currentUser)=>{
            if (currentUser) setProfilePic(currentUser.photoURL || ""); // Update the profile picture URL
        });
    }, []);
    const navigate = (0, $aKZsc.useNavigate)();
    const handleSignOut = async (e)=>{
        e.preventDefault();
        try {
            await (0, $jk7Hk.C)((0, $jqxdk.firebaseAuth));
            navigate("/");
        } catch (error) {
            navigate("/error");
        }
    };
    const toggleMenu = ()=>{
        setShowMenu(!showMenu);
    };
    const navLinkStyle = ({ isActive: isActive })=>{
        return {
            color: isActive ? "rgb(211,47,47)" : "",
            fontWeight: isActive ? "bolder" : ""
        };
    };
    // Subscribing to the store using Selector
    const cartItems = (0, $cm2x1.useSelector)((store)=>store.items);
    return /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $hOJyT.default), {
        sx: {
            boxShadow: "none"
        },
        children: /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $kNZvx.HeaderBox), {
            children: [
                /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $kNZvx.FoodLogoBox), {
                    children: [
                        /*#__PURE__*/ (0, $5Wgfu.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($kTVsv))),
                            alt: "FoodLogo",
                            onClick: ()=>navigate("/home")
                        }),
                        /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $kNZvx.HeadingBox), {
                            children: [
                                /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                    children: "The Foodie Zone"
                                }),
                                /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                    children: "Taste of Everything"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $kNZvx.NavItems), {
                    children: /*#__PURE__*/ (0, $5Wgfu.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6SiPo.NavLink), {
                                    style: navLinkStyle,
                                    to: "/home",
                                    children: "Home"
                                })
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6SiPo.NavLink), {
                                    style: navLinkStyle,
                                    to: "/restaurants",
                                    children: "Menu"
                                })
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6SiPo.NavLink), {
                                    style: navLinkStyle,
                                    to: "/about",
                                    children: "About"
                                })
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6SiPo.NavLink), {
                                    style: navLinkStyle,
                                    to: "/help",
                                    children: "Help"
                                })
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6SiPo.NavLink), {
                                    style: navLinkStyle,
                                    to: "/cart",
                                    children: /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $kNZvx.MainBox), {
                                        children: [
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $7hR8K.default), {
                                                children: "Cart"
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $kNZvx.CartBox), {
                                                children: [
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gMng8))), {}),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $kNZvx.CartItemBox), {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $kNZvx.Item), {
                                                            children: cartItems?.length
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $kNZvx.LogOutUserBox), {
                    children: [
                        /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $kNZvx.LoggedOutBox), {
                            children: [
                                profilePic && /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $7N6WB.default), {
                                    src: profilePic,
                                    alt: "Profile Picture"
                                }),
                                userName ? loggedInUser : user?.displayName
                            ]
                        }),
                        /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $kNZvx.ButtonBox), {
                            onClick: handleSignOut,
                            variant: "outlined",
                            color: "error",
                            children: [
                                "LogOut",
                                /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jymi1))), {
                                    sx: {
                                        ml: "4px",
                                        fontSize: "18px"
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $2J1NG.default), {
                    color: "inherit",
                    "aria-label": "menu",
                    sx: {
                        display: {
                            xs: "block",
                            md: "none"
                        }
                    },
                    onClick: toggleMenu,
                    children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6CrLZ))), {
                        sx: {
                            color: "black",
                            fontSize: "2rem"
                        }
                    })
                }),
                /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $kNZvx.MobileNavItems), {
                    visible: showMenu,
                    children: [
                        /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $kNZvx.LoggedOutBox), {
                            children: [
                                profilePic && /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $7N6WB.default), {
                                    src: profilePic,
                                    alt: "Profile Picture"
                                }),
                                userName ? loggedInUser : user?.displayName
                            ]
                        }),
                        /*#__PURE__*/ (0, $5Wgfu.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6SiPo.NavLink), {
                                        style: navLinkStyle,
                                        to: "/home",
                                        children: "Home"
                                    })
                                }),
                                /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6SiPo.NavLink), {
                                        style: navLinkStyle,
                                        to: "/restaurants",
                                        children: "Menu"
                                    })
                                }),
                                /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6SiPo.NavLink), {
                                        style: navLinkStyle,
                                        to: "/about",
                                        children: "About"
                                    })
                                }),
                                /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6SiPo.NavLink), {
                                        style: navLinkStyle,
                                        to: "/help",
                                        children: "Help"
                                    })
                                }),
                                /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6SiPo.NavLink), {
                                        style: navLinkStyle,
                                        to: "/cart",
                                        children: /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $kNZvx.MainBox), {
                                            children: [
                                                /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $7hR8K.default), {
                                                    children: "Cart"
                                                }),
                                                /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $kNZvx.CartBox), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gMng8))), {}),
                                                        /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $kNZvx.CartItemBox), {
                                                            children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $kNZvx.Item), {
                                                                children: cartItems?.length
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $kNZvx.ButtonBox), {
                            onClick: handleSignOut,
                            variant: "outlined",
                            color: "error",
                            className: "logout-button",
                            children: [
                                "LogOut",
                                /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jymi1))), {
                                    sx: {
                                        ml: "4px",
                                        fontSize: "18px"
                                    }
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $243c96bcfe8eedda$export$2e2bcd8739ae039 = $243c96bcfe8eedda$var$Navbar;

});
parcelRequire.register("kTVsv", function(module, exports) {

module.exports = new URL((parcelRequire("9wJdH")).resolve("LiiNZ"), import.meta.url).toString();

});

parcelRequire.register("gMng8", function(module, exports) {
"use strict";
"use client";

var $4SO8W = parcelRequire("4SO8W");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3732bd1f3384129$var$_createSvgIcon = $4SO8W((parcelRequire("agsGj")));

var $5Wgfu = parcelRequire("5Wgfu");
var $c3732bd1f3384129$var$_default = (0, $c3732bd1f3384129$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $5Wgfu.jsx)("path", {
    d: "m17.21 9-4.38-6.56c-.19-.28-.51-.42-.83-.42-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
}), "ShoppingBasket");
module.exports.default = $c3732bd1f3384129$var$_default;

});
parcelRequire.register("4SO8W", function(module, exports) {
function $38e319f485b9d0bc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $38e319f485b9d0bc$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("agsGj", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $awJsl.default;
    }
});

var $awJsl = parcelRequire("awJsl");

});
parcelRequire.register("awJsl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7aa027304bb815c5$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");

var $iItGE = parcelRequire("iItGE");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
function $7aa027304bb815c5$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $iItGE.default), (0, $dy3ak.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $iItGE.default).muiName;
    return /*#__PURE__*/ $aOChP.memo(/*#__PURE__*/ $aOChP.forwardRef(Component));
}

});
parcelRequire.register("dy3ak", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9dd0e7fad28ce0e4$export$2e2bcd8739ae039; });
function $9dd0e7fad28ce0e4$export$2e2bcd8739ae039() {
    $9dd0e7fad28ce0e4$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9dd0e7fad28ce0e4$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRequire.register("iItGE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da035d43dd8d3e47$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $4GC5s = parcelRequire("4GC5s");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");

var $dhOhi = parcelRequire("dhOhi");

var $lUjh9 = parcelRequire("lUjh9");

var $6XlHG = parcelRequire("6XlHG");

var $gx04x = parcelRequire("gx04x");

var $iUx46 = parcelRequire("iUx46");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $da035d43dd8d3e47$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $da035d43dd8d3e47$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $lUjh9.default)(color)}`,
            `fontSize${(0, $lUjh9.default)(fontSize)}`
        ]
    };
    return (0, $dhOhi.default)(slots, (0, $iUx46.getSvgIconUtilityClass), classes);
};
const $da035d43dd8d3e47$var$SvgIconRoot = (0, $gx04x.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $lUjh9.default)(ownerState.color)}`],
            styles[`fontSize${(0, $lUjh9.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // e.g. heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $da035d43dd8d3e47$var$SvgIcon = /*#__PURE__*/ $aOChP.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $4GC5s.default)(props, $da035d43dd8d3e47$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $aOChP.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $dy3ak.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $da035d43dd8d3e47$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)($da035d43dd8d3e47$var$SvgIconRoot, (0, $dy3ak.default)({
        as: component,
        className: (0, $gVoqA.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $5Wgfu.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$da035d43dd8d3e47$var$SvgIcon.muiName = "SvgIcon";
var $da035d43dd8d3e47$export$2e2bcd8739ae039 = $da035d43dd8d3e47$var$SvgIcon;

});
parcelRequire.register("4GC5s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3698a0f85aac63d2$export$2e2bcd8739ae039; });
function $3698a0f85aac63d2$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRequire.register("gVoqA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00b82f25e99c43b3$export$2e2bcd8739ae039; });
function $00b82f25e99c43b3$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $00b82f25e99c43b3$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $00b82f25e99c43b3$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $00b82f25e99c43b3$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $00b82f25e99c43b3$export$2e2bcd8739ae039 = $00b82f25e99c43b3$export$4f5d2d50c9deca37;

});

parcelRequire.register("dhOhi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ac3dd08ba495a74$export$2e2bcd8739ae039; });
function $9ac3dd08ba495a74$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRequire.register("lUjh9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff2dc7ab0f806e59$export$2e2bcd8739ae039; });

var $iOMXr = parcelRequire("iOMXr");
var $ff2dc7ab0f806e59$export$2e2bcd8739ae039 = (0, $iOMXr.default);

});
parcelRequire.register("iOMXr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db32df7d2ac94a3f$export$2e2bcd8739ae039; });

var $hBYX0 = parcelRequire("hBYX0");
function $db32df7d2ac94a3f$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $hBYX0.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRequire.register("hBYX0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd252be67f81bd21$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $cd252be67f81bd21$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRequire.register("6XlHG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $510916a0635e774e$export$2e2bcd8739ae039; });

var $dB3nJ = parcelRequire("dB3nJ");

var $fQJH6 = parcelRequire("fQJH6");

var $bsF6d = parcelRequire("bsF6d");
"use client";
function $510916a0635e774e$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $dB3nJ.default)({
        props: props,
        name: name,
        defaultTheme: $fQJH6.default,
        themeId: (0, $bsF6d.default)
    });
}

});
parcelRequire.register("dB3nJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e615a9836c8a980$export$2e2bcd8739ae039; });

var $juLI7 = parcelRequire("juLI7");

var $kwVyI = parcelRequire("kwVyI");
"use client";
function $9e615a9836c8a980$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $kwVyI.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $juLI7.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRequire.register("juLI7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e315d3fffad471f0$export$2e2bcd8739ae039; });

var $f4sog = parcelRequire("f4sog");
function $e315d3fffad471f0$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $f4sog.default)(theme.components[name].defaultProps, props);
}

});
parcelRequire.register("f4sog", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af8d4078a5c3e6e2$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");
function $af8d4078a5c3e6e2$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $dy3ak.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $dy3ak.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $dy3ak.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $af8d4078a5c3e6e2$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRequire.register("kwVyI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef2371cba0adaba0$export$2e2bcd8739ae039; });

var $1N2hm = parcelRequire("1N2hm");

var $7Fmqe = parcelRequire("7Fmqe");
"use client";
const $ef2371cba0adaba0$export$35e57303dbd8a66 = (0, $1N2hm.default)();
function $ef2371cba0adaba0$var$useTheme(defaultTheme = $ef2371cba0adaba0$export$35e57303dbd8a66) {
    return (0, $7Fmqe.default)(defaultTheme);
}
var $ef2371cba0adaba0$export$2e2bcd8739ae039 = $ef2371cba0adaba0$var$useTheme;

});
parcelRequire.register("1N2hm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14dc229ba396e4ad$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $4GC5s = parcelRequire("4GC5s");

var $e45KD = parcelRequire("e45KD");

var $1WMXw = parcelRequire("1WMXw");

var $4sive = parcelRequire("4sive");

var $ceyPN = parcelRequire("ceyPN");

var $fb2C7 = parcelRequire("fb2C7");

var $2gPhR = parcelRequire("2gPhR");
const $14dc229ba396e4ad$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $14dc229ba396e4ad$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $4GC5s.default)(options, $14dc229ba396e4ad$var$_excluded);
    const breakpoints = (0, $1WMXw.default)(breakpointsInput);
    const spacing = (0, $ceyPN.default)(spacingInput);
    let muiTheme = (0, $e45KD.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $dy3ak.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $dy3ak.default)({}, (0, $4sive.default), shapeInput)
    }, other);
    muiTheme = args.reduce((acc, argument)=>(0, $e45KD.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $dy3ak.default)({}, (0, $2gPhR.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $fb2C7.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $14dc229ba396e4ad$export$2e2bcd8739ae039 = $14dc229ba396e4ad$var$createTheme;

});
parcelRequire.register("e45KD", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $a3d5e6774fbc1561$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $a3d5e6774fbc1561$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");
function $a3d5e6774fbc1561$export$53b83ca8eaab0383(item) {
    return item !== null && typeof item === "object" && item.constructor === Object;
}
function $a3d5e6774fbc1561$var$deepClone(source) {
    if (!$a3d5e6774fbc1561$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $a3d5e6774fbc1561$var$deepClone(source[key]);
    });
    return output;
}
function $a3d5e6774fbc1561$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $dy3ak.default)({}, target) : target;
    if ($a3d5e6774fbc1561$export$53b83ca8eaab0383(target) && $a3d5e6774fbc1561$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($a3d5e6774fbc1561$export$53b83ca8eaab0383(source[key]) && key in target && $a3d5e6774fbc1561$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $a3d5e6774fbc1561$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $a3d5e6774fbc1561$export$53b83ca8eaab0383(source[key]) ? $a3d5e6774fbc1561$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRequire.register("1WMXw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16b12f7b473cd99a$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");
const $16b12f7b473cd99a$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $16b12f7b473cd99a$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $16b12f7b473cd99a$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $dy3ak.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $16b12f7b473cd99a$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $4GC5s.default)(breakpoints, $16b12f7b473cd99a$var$_excluded);
    const sortedValues = $16b12f7b473cd99a$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $dy3ak.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRequire.register("4sive", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33e82130c74db43d$export$2e2bcd8739ae039; });
const $33e82130c74db43d$var$shape = {
    borderRadius: 4
};
var $33e82130c74db43d$export$2e2bcd8739ae039 = $33e82130c74db43d$var$shape;

});

parcelRequire.register("ceyPN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e81d039ba70bd5d$export$2e2bcd8739ae039; });

var $f2NEC = parcelRequire("f2NEC");
function $8e81d039ba70bd5d$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $f2NEC.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRequire.register("f2NEC", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $af3d8f34067ede0e$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $af3d8f34067ede0e$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $af3d8f34067ede0e$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $af3d8f34067ede0e$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $af3d8f34067ede0e$export$6f98e8eaf0be1996; });


var $I0S4C = parcelRequire("I0S4C");

var $4eBQW = parcelRequire("4eBQW");

var $giTbH = parcelRequire("giTbH");

var $jKDhE = parcelRequire("jKDhE");
const $af3d8f34067ede0e$var$properties = {
    m: "margin",
    p: "padding"
};
const $af3d8f34067ede0e$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $af3d8f34067ede0e$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $af3d8f34067ede0e$var$getCssProperties = (0, $jKDhE.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($af3d8f34067ede0e$var$aliases[prop]) prop = $af3d8f34067ede0e$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $af3d8f34067ede0e$var$properties[a];
    const direction = $af3d8f34067ede0e$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $af3d8f34067ede0e$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $af3d8f34067ede0e$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $af3d8f34067ede0e$var$spacingKeys = [
    ...$af3d8f34067ede0e$export$aab52a0dde05ad8a,
    ...$af3d8f34067ede0e$export$f8397d44f03ab6ad
];
function $af3d8f34067ede0e$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $4eBQW.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $af3d8f34067ede0e$export$1def6f833384e3d1(theme) {
    return $af3d8f34067ede0e$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $af3d8f34067ede0e$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $af3d8f34067ede0e$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $af3d8f34067ede0e$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $af3d8f34067ede0e$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $af3d8f34067ede0e$var$getCssProperties(prop);
    const styleFromPropValue = $af3d8f34067ede0e$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $I0S4C.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $af3d8f34067ede0e$var$style(props, keys) {
    const transformer = $af3d8f34067ede0e$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$af3d8f34067ede0e$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $giTbH.default), {});
}
function $af3d8f34067ede0e$export$7ede87f9b603dd3c(props) {
    return $af3d8f34067ede0e$var$style(props, $af3d8f34067ede0e$export$aab52a0dde05ad8a);
}
$af3d8f34067ede0e$export$7ede87f9b603dd3c.propTypes = {};
$af3d8f34067ede0e$export$7ede87f9b603dd3c.filterProps = $af3d8f34067ede0e$export$aab52a0dde05ad8a;
function $af3d8f34067ede0e$export$6f98e8eaf0be1996(props) {
    return $af3d8f34067ede0e$var$style(props, $af3d8f34067ede0e$export$f8397d44f03ab6ad);
}
$af3d8f34067ede0e$export$6f98e8eaf0be1996.propTypes = {};
$af3d8f34067ede0e$export$6f98e8eaf0be1996.filterProps = $af3d8f34067ede0e$export$f8397d44f03ab6ad;
function $af3d8f34067ede0e$var$spacing(props) {
    return $af3d8f34067ede0e$var$style(props, $af3d8f34067ede0e$var$spacingKeys);
}
$af3d8f34067ede0e$var$spacing.propTypes = {};
$af3d8f34067ede0e$var$spacing.filterProps = $af3d8f34067ede0e$var$spacingKeys;
var $af3d8f34067ede0e$export$2e2bcd8739ae039 = $af3d8f34067ede0e$var$spacing;

});
parcelRequire.register("I0S4C", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $0844c92b11eb1db5$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $0844c92b11eb1db5$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $0844c92b11eb1db5$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $0844c92b11eb1db5$export$8922c90b6e020726; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $0844c92b11eb1db5$export$980e6a259d807490; });

var $dy3ak = parcelRequire("dy3ak");


var $e45KD = parcelRequire("e45KD");

var $giTbH = parcelRequire("giTbH");
const $0844c92b11eb1db5$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $0844c92b11eb1db5$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$0844c92b11eb1db5$export$68c286be0e7e55b7[key]}px)`
};
function $0844c92b11eb1db5$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $0844c92b11eb1db5$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $0844c92b11eb1db5$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $0844c92b11eb1db5$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $0844c92b11eb1db5$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $0844c92b11eb1db5$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $dy3ak.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $giTbH.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $0844c92b11eb1db5$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $0844c92b11eb1db5$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $0844c92b11eb1db5$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $0844c92b11eb1db5$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $e45KD.default)(prev, next), {});
    return $0844c92b11eb1db5$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $0844c92b11eb1db5$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $0844c92b11eb1db5$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $0844c92b11eb1db5$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $0844c92b11eb1db5$export$2e2bcd8739ae039 = $0844c92b11eb1db5$var$breakpoints;

});
parcelRequire.register("giTbH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bde922e8891b53d5$export$2e2bcd8739ae039; });

var $e45KD = parcelRequire("e45KD");
function $bde922e8891b53d5$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $e45KD.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $bde922e8891b53d5$export$2e2bcd8739ae039 = $bde922e8891b53d5$var$merge;

});


parcelRequire.register("4eBQW", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $3155d501445478bf$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $3155d501445478bf$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $3155d501445478bf$export$2e2bcd8739ae039; });

var $iOMXr = parcelRequire("iOMXr");


var $I0S4C = parcelRequire("I0S4C");
function $3155d501445478bf$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $3155d501445478bf$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $3155d501445478bf$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $3155d501445478bf$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $3155d501445478bf$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $3155d501445478bf$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $3155d501445478bf$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $iOMXr.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $I0S4C.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $3155d501445478bf$export$2e2bcd8739ae039 = $3155d501445478bf$var$style;

});

parcelRequire.register("jKDhE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e610c91efca1ecc3$export$2e2bcd8739ae039; });
function $e610c91efca1ecc3$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRequire.register("fb2C7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0c9e92bd53c8869$export$2e2bcd8739ae039; });

var $iOMXr = parcelRequire("iOMXr");

var $giTbH = parcelRequire("giTbH");

var $4eBQW = parcelRequire("4eBQW");

var $I0S4C = parcelRequire("I0S4C");

var $2gPhR = parcelRequire("2gPhR");
function $b0c9e92bd53c8869$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $b0c9e92bd53c8869$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $b0c9e92bd53c8869$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $4eBQW.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $4eBQW.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $4eBQW.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $iOMXr.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $I0S4C.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $2gPhR.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $I0S4C.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $b0c9e92bd53c8869$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $giTbH.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $I0S4C.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($b0c9e92bd53c8869$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $giTbH.default)(css, breakpointsValues);
                        }
                    } else css = (0, $giTbH.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $I0S4C.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $b0c9e92bd53c8869$var$styleFunctionSx = $b0c9e92bd53c8869$export$7d53d8bf2911e013();
$b0c9e92bd53c8869$var$styleFunctionSx.filterProps = [
    "sx"
];
var $b0c9e92bd53c8869$export$2e2bcd8739ae039 = $b0c9e92bd53c8869$var$styleFunctionSx;

});
parcelRequire.register("2gPhR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a74dbeaeea411b5$export$2e2bcd8739ae039; });

var $f2NEC = parcelRequire("f2NEC");

var $6UJfo = parcelRequire("6UJfo");

var $iYP38 = parcelRequire("iYP38");

var $7ttyQ = parcelRequire("7ttyQ");

var $b5n5q = parcelRequire("b5n5q");
const $1a74dbeaeea411b5$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $6UJfo.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $6UJfo.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $6UJfo.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $6UJfo.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $6UJfo.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $6UJfo.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $7ttyQ.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $7ttyQ.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $7ttyQ.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $f2NEC.padding)
    },
    pt: {
        style: (0, $f2NEC.padding)
    },
    pr: {
        style: (0, $f2NEC.padding)
    },
    pb: {
        style: (0, $f2NEC.padding)
    },
    pl: {
        style: (0, $f2NEC.padding)
    },
    px: {
        style: (0, $f2NEC.padding)
    },
    py: {
        style: (0, $f2NEC.padding)
    },
    padding: {
        style: (0, $f2NEC.padding)
    },
    paddingTop: {
        style: (0, $f2NEC.padding)
    },
    paddingRight: {
        style: (0, $f2NEC.padding)
    },
    paddingBottom: {
        style: (0, $f2NEC.padding)
    },
    paddingLeft: {
        style: (0, $f2NEC.padding)
    },
    paddingX: {
        style: (0, $f2NEC.padding)
    },
    paddingY: {
        style: (0, $f2NEC.padding)
    },
    paddingInline: {
        style: (0, $f2NEC.padding)
    },
    paddingInlineStart: {
        style: (0, $f2NEC.padding)
    },
    paddingInlineEnd: {
        style: (0, $f2NEC.padding)
    },
    paddingBlock: {
        style: (0, $f2NEC.padding)
    },
    paddingBlockStart: {
        style: (0, $f2NEC.padding)
    },
    paddingBlockEnd: {
        style: (0, $f2NEC.padding)
    },
    m: {
        style: (0, $f2NEC.margin)
    },
    mt: {
        style: (0, $f2NEC.margin)
    },
    mr: {
        style: (0, $f2NEC.margin)
    },
    mb: {
        style: (0, $f2NEC.margin)
    },
    ml: {
        style: (0, $f2NEC.margin)
    },
    mx: {
        style: (0, $f2NEC.margin)
    },
    my: {
        style: (0, $f2NEC.margin)
    },
    margin: {
        style: (0, $f2NEC.margin)
    },
    marginTop: {
        style: (0, $f2NEC.margin)
    },
    marginRight: {
        style: (0, $f2NEC.margin)
    },
    marginBottom: {
        style: (0, $f2NEC.margin)
    },
    marginLeft: {
        style: (0, $f2NEC.margin)
    },
    marginX: {
        style: (0, $f2NEC.margin)
    },
    marginY: {
        style: (0, $f2NEC.margin)
    },
    marginInline: {
        style: (0, $f2NEC.margin)
    },
    marginInlineStart: {
        style: (0, $f2NEC.margin)
    },
    marginInlineEnd: {
        style: (0, $f2NEC.margin)
    },
    marginBlock: {
        style: (0, $f2NEC.margin)
    },
    marginBlockStart: {
        style: (0, $f2NEC.margin)
    },
    marginBlockEnd: {
        style: (0, $f2NEC.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $iYP38.gap)
    },
    rowGap: {
        style: (0, $iYP38.rowGap)
    },
    columnGap: {
        style: (0, $iYP38.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $b5n5q.sizingTransform)
    },
    maxWidth: {
        style: (0, $b5n5q.maxWidth)
    },
    minWidth: {
        transform: (0, $b5n5q.sizingTransform)
    },
    height: {
        transform: (0, $b5n5q.sizingTransform)
    },
    maxHeight: {
        transform: (0, $b5n5q.sizingTransform)
    },
    minHeight: {
        transform: (0, $b5n5q.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $1a74dbeaeea411b5$export$2e2bcd8739ae039 = $1a74dbeaeea411b5$var$defaultSxConfig;

});
parcelRequire.register("6UJfo", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $508b1239a1f701d6$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $508b1239a1f701d6$export$7a57f79000377ca2; });


var $4eBQW = parcelRequire("4eBQW");

var $ht7Lp = parcelRequire("ht7Lp");

var $f2NEC = parcelRequire("f2NEC");

var $I0S4C = parcelRequire("I0S4C");
function $508b1239a1f701d6$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
const $508b1239a1f701d6$export$1edee58a52776cd9 = (0, $4eBQW.default)({
    prop: "border",
    themeKey: "borders",
    transform: $508b1239a1f701d6$export$34e2febe53ae29cc
});
const $508b1239a1f701d6$export$f9a7b6bd24892946 = (0, $4eBQW.default)({
    prop: "borderTop",
    themeKey: "borders",
    transform: $508b1239a1f701d6$export$34e2febe53ae29cc
});
const $508b1239a1f701d6$export$5abca33e6be905d2 = (0, $4eBQW.default)({
    prop: "borderRight",
    themeKey: "borders",
    transform: $508b1239a1f701d6$export$34e2febe53ae29cc
});
const $508b1239a1f701d6$export$e2ce9f12a980a822 = (0, $4eBQW.default)({
    prop: "borderBottom",
    themeKey: "borders",
    transform: $508b1239a1f701d6$export$34e2febe53ae29cc
});
const $508b1239a1f701d6$export$47658cca1a909427 = (0, $4eBQW.default)({
    prop: "borderLeft",
    themeKey: "borders",
    transform: $508b1239a1f701d6$export$34e2febe53ae29cc
});
const $508b1239a1f701d6$export$e7fb0694ba2404fc = (0, $4eBQW.default)({
    prop: "borderColor",
    themeKey: "palette"
});
const $508b1239a1f701d6$export$126a92c968acdb85 = (0, $4eBQW.default)({
    prop: "borderTopColor",
    themeKey: "palette"
});
const $508b1239a1f701d6$export$85cc51cb8fbb8c0e = (0, $4eBQW.default)({
    prop: "borderRightColor",
    themeKey: "palette"
});
const $508b1239a1f701d6$export$340b0327727f6d1a = (0, $4eBQW.default)({
    prop: "borderBottomColor",
    themeKey: "palette"
});
const $508b1239a1f701d6$export$60beef91a985b4bf = (0, $4eBQW.default)({
    prop: "borderLeftColor",
    themeKey: "palette"
});
const $508b1239a1f701d6$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $f2NEC.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $f2NEC.getValue)(transformer, propValue)
            });
        return (0, $I0S4C.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$508b1239a1f701d6$export$7a57f79000377ca2.propTypes = {};
$508b1239a1f701d6$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $508b1239a1f701d6$var$borders = (0, $ht7Lp.default)($508b1239a1f701d6$export$1edee58a52776cd9, $508b1239a1f701d6$export$f9a7b6bd24892946, $508b1239a1f701d6$export$5abca33e6be905d2, $508b1239a1f701d6$export$e2ce9f12a980a822, $508b1239a1f701d6$export$47658cca1a909427, $508b1239a1f701d6$export$e7fb0694ba2404fc, $508b1239a1f701d6$export$126a92c968acdb85, $508b1239a1f701d6$export$85cc51cb8fbb8c0e, $508b1239a1f701d6$export$340b0327727f6d1a, $508b1239a1f701d6$export$60beef91a985b4bf, $508b1239a1f701d6$export$7a57f79000377ca2);
var $508b1239a1f701d6$export$2e2bcd8739ae039 = $508b1239a1f701d6$var$borders;

});
parcelRequire.register("ht7Lp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb7b2ac8443794f1$export$2e2bcd8739ae039; });

var $giTbH = parcelRequire("giTbH");
function $cb7b2ac8443794f1$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $giTbH.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $cb7b2ac8443794f1$export$2e2bcd8739ae039 = $cb7b2ac8443794f1$var$compose;

});


parcelRequire.register("iYP38", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $dd156df2d118f608$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $dd156df2d118f608$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $dd156df2d118f608$export$8a833ffa5f5dbeda; });

var $4eBQW = parcelRequire("4eBQW");

var $ht7Lp = parcelRequire("ht7Lp");

var $f2NEC = parcelRequire("f2NEC");

var $I0S4C = parcelRequire("I0S4C");

const $dd156df2d118f608$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $f2NEC.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $f2NEC.getValue)(transformer, propValue)
            });
        return (0, $I0S4C.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$dd156df2d118f608$export$5df9adcb0db95e1e.propTypes = {};
$dd156df2d118f608$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $dd156df2d118f608$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $f2NEC.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $f2NEC.getValue)(transformer, propValue)
            });
        return (0, $I0S4C.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$dd156df2d118f608$export$ec60d70ff941a580.propTypes = {};
$dd156df2d118f608$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $dd156df2d118f608$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $f2NEC.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $f2NEC.getValue)(transformer, propValue)
            });
        return (0, $I0S4C.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$dd156df2d118f608$export$8a833ffa5f5dbeda.propTypes = {};
$dd156df2d118f608$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $dd156df2d118f608$export$baf44164ca3a34e8 = (0, $4eBQW.default)({
    prop: "gridColumn"
});
const $dd156df2d118f608$export$8f7213a1cd01e832 = (0, $4eBQW.default)({
    prop: "gridRow"
});
const $dd156df2d118f608$export$b0e0abbc49ba668 = (0, $4eBQW.default)({
    prop: "gridAutoFlow"
});
const $dd156df2d118f608$export$bcd8b929d4b4142 = (0, $4eBQW.default)({
    prop: "gridAutoColumns"
});
const $dd156df2d118f608$export$e5039a674e14c828 = (0, $4eBQW.default)({
    prop: "gridAutoRows"
});
const $dd156df2d118f608$export$42bd9088661ffb03 = (0, $4eBQW.default)({
    prop: "gridTemplateColumns"
});
const $dd156df2d118f608$export$920682ae05b999bc = (0, $4eBQW.default)({
    prop: "gridTemplateRows"
});
const $dd156df2d118f608$export$1b88fbdd482fd33a = (0, $4eBQW.default)({
    prop: "gridTemplateAreas"
});
const $dd156df2d118f608$export$bdb486e40d52d26f = (0, $4eBQW.default)({
    prop: "gridArea"
});
const $dd156df2d118f608$var$grid = (0, $ht7Lp.default)($dd156df2d118f608$export$5df9adcb0db95e1e, $dd156df2d118f608$export$ec60d70ff941a580, $dd156df2d118f608$export$8a833ffa5f5dbeda, $dd156df2d118f608$export$baf44164ca3a34e8, $dd156df2d118f608$export$8f7213a1cd01e832, $dd156df2d118f608$export$b0e0abbc49ba668, $dd156df2d118f608$export$bcd8b929d4b4142, $dd156df2d118f608$export$e5039a674e14c828, $dd156df2d118f608$export$42bd9088661ffb03, $dd156df2d118f608$export$920682ae05b999bc, $dd156df2d118f608$export$1b88fbdd482fd33a, $dd156df2d118f608$export$bdb486e40d52d26f);
var $dd156df2d118f608$export$2e2bcd8739ae039 = $dd156df2d118f608$var$grid;

});

parcelRequire.register("7ttyQ", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $016784d6f4bd73f3$export$dbaffd4420ea0ac6; });

var $4eBQW = parcelRequire("4eBQW");

var $ht7Lp = parcelRequire("ht7Lp");
function $016784d6f4bd73f3$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $016784d6f4bd73f3$export$35e9368ef982300f = (0, $4eBQW.default)({
    prop: "color",
    themeKey: "palette",
    transform: $016784d6f4bd73f3$export$dbaffd4420ea0ac6
});
const $016784d6f4bd73f3$export$2506f56c10355b33 = (0, $4eBQW.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $016784d6f4bd73f3$export$dbaffd4420ea0ac6
});
const $016784d6f4bd73f3$export$8c5a050822fd698c = (0, $4eBQW.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $016784d6f4bd73f3$export$dbaffd4420ea0ac6
});
const $016784d6f4bd73f3$var$palette = (0, $ht7Lp.default)($016784d6f4bd73f3$export$35e9368ef982300f, $016784d6f4bd73f3$export$2506f56c10355b33, $016784d6f4bd73f3$export$8c5a050822fd698c);
var $016784d6f4bd73f3$export$2e2bcd8739ae039 = $016784d6f4bd73f3$var$palette;

});

parcelRequire.register("b5n5q", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $812211d25663dc62$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $812211d25663dc62$export$488fda99655ff65a; });

var $4eBQW = parcelRequire("4eBQW");

var $ht7Lp = parcelRequire("ht7Lp");

var $I0S4C = parcelRequire("I0S4C");
function $812211d25663dc62$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $812211d25663dc62$export$7e3df82ee760448c = (0, $4eBQW.default)({
    prop: "width",
    transform: $812211d25663dc62$export$8afece71750ec241
});
const $812211d25663dc62$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $I0S4C.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $812211d25663dc62$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $I0S4C.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$812211d25663dc62$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $812211d25663dc62$export$ee148fbbe8357dd2 = (0, $4eBQW.default)({
    prop: "minWidth",
    transform: $812211d25663dc62$export$8afece71750ec241
});
const $812211d25663dc62$export$ac607276a8fe9f0a = (0, $4eBQW.default)({
    prop: "height",
    transform: $812211d25663dc62$export$8afece71750ec241
});
const $812211d25663dc62$export$dc0d8bd0b94f8570 = (0, $4eBQW.default)({
    prop: "maxHeight",
    transform: $812211d25663dc62$export$8afece71750ec241
});
const $812211d25663dc62$export$a43cf604e12f3b17 = (0, $4eBQW.default)({
    prop: "minHeight",
    transform: $812211d25663dc62$export$8afece71750ec241
});
const $812211d25663dc62$export$ffed9f14fb65e276 = (0, $4eBQW.default)({
    prop: "size",
    cssProperty: "width",
    transform: $812211d25663dc62$export$8afece71750ec241
});
const $812211d25663dc62$export$905076ed6620e671 = (0, $4eBQW.default)({
    prop: "size",
    cssProperty: "height",
    transform: $812211d25663dc62$export$8afece71750ec241
});
const $812211d25663dc62$export$6ccc93f785106a58 = (0, $4eBQW.default)({
    prop: "boxSizing"
});
const $812211d25663dc62$var$sizing = (0, $ht7Lp.default)($812211d25663dc62$export$7e3df82ee760448c, $812211d25663dc62$export$488fda99655ff65a, $812211d25663dc62$export$ee148fbbe8357dd2, $812211d25663dc62$export$ac607276a8fe9f0a, $812211d25663dc62$export$dc0d8bd0b94f8570, $812211d25663dc62$export$a43cf604e12f3b17, $812211d25663dc62$export$6ccc93f785106a58);
var $812211d25663dc62$export$2e2bcd8739ae039 = $812211d25663dc62$var$sizing;

});




parcelRequire.register("7Fmqe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $594dc14cc0b3dcf1$export$2e2bcd8739ae039; });

var $aOChP = parcelRequire("aOChP");
parcelRequire("03csL");
var $iJMyi = parcelRequire("iJMyi");
"use client";
function $594dc14cc0b3dcf1$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $594dc14cc0b3dcf1$var$useTheme(defaultTheme = null) {
    const contextTheme = $aOChP.useContext((0, $iJMyi.T));
    return !contextTheme || $594dc14cc0b3dcf1$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $594dc14cc0b3dcf1$export$2e2bcd8739ae039 = $594dc14cc0b3dcf1$var$useTheme;

});
parcelRequire.register("03csL", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $0099f2d51f2b7448$export$98f03c5d19621d70; });
$parcel$export(module.exports, "keyframes", function () { return $0099f2d51f2b7448$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("iJMyi")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("iJMyi")).w; });

var $iJMyi = parcelRequire("iJMyi");

var $aOChP = parcelRequire("aOChP");

var $5Bkr0 = parcelRequire("5Bkr0");

var $enaS9 = parcelRequire("enaS9");

var $gyMrz = parcelRequire("gyMrz");
parcelRequire("i1zxL");
parcelRequire("3hJMF");
parcelRequire("7DpjZ");

parcelRequire("gizNK");
var $0099f2d51f2b7448$var$pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $0099f2d51f2b7448$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $iJMyi.h).call(props, "css")) // $FlowFixMe
    return $aOChP.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $iJMyi.E);
    createElementArgArray[1] = (0, $iJMyi.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $aOChP.createElement.apply(null, createElementArgArray);
};
var $0099f2d51f2b7448$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $0099f2d51f2b7448$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $iJMyi.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $gyMrz.serializeStyles)([
        styles
    ], undefined, $aOChP.useContext((0, $iJMyi.T)));
    if (!(0, $iJMyi.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $aOChP.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $aOChP.useRef();
    (0, $enaS9.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $enaS9.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $5Bkr0.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $0099f2d51f2b7448$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $gyMrz.serializeStyles)(args);
}
var $0099f2d51f2b7448$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $0099f2d51f2b7448$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $0099f2d51f2b7448$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $0099f2d51f2b7448$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $5Bkr0.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $0099f2d51f2b7448$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $enaS9.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $5Bkr0.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $0099f2d51f2b7448$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $iJMyi.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $gyMrz.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $5Bkr0.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $0099f2d51f2b7448$var$merge(cache.registered, css, $0099f2d51f2b7448$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $aOChP.useContext((0, $iJMyi.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $aOChP.createElement($aOChP.Fragment, null, /*#__PURE__*/ $aOChP.createElement($0099f2d51f2b7448$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $0099f2d51f2b7448$var$isBrowser, $0099f2d51f2b7448$var$isTestEnv, $0099f2d51f2b7448$var$globalContext, $0099f2d51f2b7448$var$globalKey;

});
parcelRequire.register("iJMyi", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $da42176d6279c82d$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $da42176d6279c82d$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "w", function () { return $da42176d6279c82d$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $da42176d6279c82d$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $da42176d6279c82d$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $da42176d6279c82d$export$a9c23c6ac3fc3eca; });

var $aOChP = parcelRequire("aOChP");

var $i1zxL = parcelRequire("i1zxL");

var $dy3ak = parcelRequire("dy3ak");

var $7DpjZ = parcelRequire("7DpjZ");

var $kprwP = parcelRequire("kprwP");

var $5Bkr0 = parcelRequire("5Bkr0");

var $gyMrz = parcelRequire("gyMrz");

var $enaS9 = parcelRequire("enaS9");
var $da42176d6279c82d$export$23f2a1d2818174ef = true;
var $da42176d6279c82d$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $da42176d6279c82d$var$EmotionCacheContext = /* #__PURE__ */ $aOChP.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $i1zxL.default)({
    key: "css"
}) : null);
var $da42176d6279c82d$export$e7094788287c5e9b = $da42176d6279c82d$var$EmotionCacheContext.Provider;
var $da42176d6279c82d$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $aOChP.useContext)($da42176d6279c82d$var$EmotionCacheContext);
};
var $da42176d6279c82d$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $aOChP.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $aOChP.useContext)($da42176d6279c82d$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$da42176d6279c82d$export$23f2a1d2818174ef) $da42176d6279c82d$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $aOChP.useContext)($da42176d6279c82d$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $i1zxL.default)({
                key: "css"
            });
            return /*#__PURE__*/ $aOChP.createElement($da42176d6279c82d$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $da42176d6279c82d$export$971d5caa766a69d7 = /* #__PURE__ */ $aOChP.createContext({});
var $da42176d6279c82d$export$3b14a55fb2447963 = function useTheme() {
    return $aOChP.useContext($da42176d6279c82d$export$971d5caa766a69d7);
};
var $da42176d6279c82d$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $dy3ak.default)({}, outerTheme, theme);
};
var $da42176d6279c82d$var$createCacheWithTheme = /* #__PURE__ */ (0, $7DpjZ.default)(function(outerTheme) {
    return (0, $7DpjZ.default)(function(theme) {
        return $da42176d6279c82d$var$getTheme(outerTheme, theme);
    });
});
var $da42176d6279c82d$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $aOChP.useContext($da42176d6279c82d$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $da42176d6279c82d$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $aOChP.createElement($da42176d6279c82d$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $da42176d6279c82d$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $aOChP.useContext($da42176d6279c82d$export$971d5caa766a69d7);
        return /*#__PURE__*/ $aOChP.createElement(Component, (0, $dy3ak.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $aOChP.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $kprwP.default)(WithTheme, Component);
}
var $da42176d6279c82d$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $da42176d6279c82d$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $da42176d6279c82d$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $da42176d6279c82d$var$getLastPart(match[1]);
    return undefined;
};
var $da42176d6279c82d$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $da42176d6279c82d$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $da42176d6279c82d$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $da42176d6279c82d$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($da42176d6279c82d$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $da42176d6279c82d$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $da42176d6279c82d$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $da42176d6279c82d$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $da42176d6279c82d$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($da42176d6279c82d$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$da42176d6279c82d$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $da42176d6279c82d$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $5Bkr0.registerStyles)(cache, serialized, isStringTag);
    (0, $enaS9.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $5Bkr0.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $da42176d6279c82d$var$Emotion = /* #__PURE__ */ $da42176d6279c82d$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$da42176d6279c82d$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $5Bkr0.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $gyMrz.serializeStyles)(registeredStyles, undefined, $aOChP.useContext($da42176d6279c82d$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($da42176d6279c82d$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $da42176d6279c82d$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $aOChP.createElement($aOChP.Fragment, null, /*#__PURE__*/ $aOChP.createElement($da42176d6279c82d$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $aOChP.createElement(WrappedComponent, newProps));
});
var $da42176d6279c82d$export$a9c23c6ac3fc3eca = $da42176d6279c82d$var$Emotion;

});
parcelRequire.register("i1zxL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1f3e432f6208b5c$export$2e2bcd8739ae039; });

var $aa49b = parcelRequire("aa49b");

var $g4H8m = parcelRequire("g4H8m");
parcelRequire("7DpjZ");
parcelRequire("cgP8G");
var $d1f3e432f6208b5c$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $g4H8m.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $g4H8m.token)(character)) break;
        (0, $g4H8m.next)();
    }
    return (0, $g4H8m.slice)(begin, (0, $g4H8m.position));
};
var $d1f3e432f6208b5c$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $g4H8m.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $g4H8m.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $d1f3e432f6208b5c$var$identifierWithPointTracking((0, $g4H8m.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $g4H8m.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $g4H8m.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $g4H8m.from)(character);
    }
    while (character = (0, $g4H8m.next)());
    return parsed;
};
var $d1f3e432f6208b5c$var$getRules = function getRules(value, points) {
    return (0, $g4H8m.dealloc)($d1f3e432f6208b5c$var$toRules((0, $g4H8m.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $d1f3e432f6208b5c$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $d1f3e432f6208b5c$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$d1f3e432f6208b5c$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $d1f3e432f6208b5c$var$fixedElements.set(element, true);
    var points = [];
    var rules = $d1f3e432f6208b5c$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $d1f3e432f6208b5c$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $d1f3e432f6208b5c$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $d1f3e432f6208b5c$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($d1f3e432f6208b5c$var$ignoreFlag) > -1;
};
var $d1f3e432f6208b5c$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($d1f3e432f6208b5c$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $d1f3e432f6208b5c$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $d1f3e432f6208b5c$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$d1f3e432f6208b5c$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $d1f3e432f6208b5c$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $d1f3e432f6208b5c$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$d1f3e432f6208b5c$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $d1f3e432f6208b5c$var$nullifyElement(element);
    } else if ($d1f3e432f6208b5c$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $d1f3e432f6208b5c$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $d1f3e432f6208b5c$var$prefix(value, length) {
    switch((0, $g4H8m.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $g4H8m.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $g4H8m.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $g4H8m.WEBKIT) + value + (0, $g4H8m.MOZ) + value + (0, $g4H8m.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $g4H8m.WEBKIT) + value + (0, $g4H8m.MS) + value + value;
        // order
        case 6165:
            return (0, $g4H8m.WEBKIT) + value + (0, $g4H8m.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $g4H8m.WEBKIT) + value + (0, $g4H8m.replace)(value, /(\w+).+(:[^]+)/, (0, $g4H8m.WEBKIT) + "box-$1$2" + (0, $g4H8m.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $g4H8m.WEBKIT) + value + (0, $g4H8m.MS) + "flex-item-" + (0, $g4H8m.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $g4H8m.WEBKIT) + value + (0, $g4H8m.MS) + "flex-line-pack" + (0, $g4H8m.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $g4H8m.WEBKIT) + value + (0, $g4H8m.MS) + (0, $g4H8m.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $g4H8m.WEBKIT) + value + (0, $g4H8m.MS) + (0, $g4H8m.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $g4H8m.WEBKIT) + "box-" + (0, $g4H8m.replace)(value, "-grow", "") + (0, $g4H8m.WEBKIT) + value + (0, $g4H8m.MS) + (0, $g4H8m.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $g4H8m.WEBKIT) + (0, $g4H8m.replace)(value, /([^-])(transform)/g, "$1" + (0, $g4H8m.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $g4H8m.replace)((0, $g4H8m.replace)((0, $g4H8m.replace)(value, /(zoom-|grab)/, (0, $g4H8m.WEBKIT) + "$1"), /(image-set)/, (0, $g4H8m.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $g4H8m.replace)(value, /(image-set\([^]*)/, (0, $g4H8m.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $g4H8m.replace)((0, $g4H8m.replace)(value, /(.+:)(flex-)?(.*)/, (0, $g4H8m.WEBKIT) + "box-pack:$3" + (0, $g4H8m.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $g4H8m.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $g4H8m.replace)(value, /(.+)-inline(.+)/, (0, $g4H8m.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $g4H8m.strlen)(value) - 1 - length > 6) switch((0, $g4H8m.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $g4H8m.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $g4H8m.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $g4H8m.WEBKIT) + "$2-$3" + "$1" + (0, $g4H8m.MOZ) + ((0, $g4H8m.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $g4H8m.indexof)(value, "stretch") ? $d1f3e432f6208b5c$var$prefix((0, $g4H8m.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $g4H8m.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $g4H8m.charat)(value, (0, $g4H8m.strlen)(value) - 3 - (~(0, $g4H8m.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $g4H8m.replace)(value, ":", ":" + (0, $g4H8m.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $g4H8m.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $g4H8m.WEBKIT) + ((0, $g4H8m.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $g4H8m.WEBKIT) + "$2$3" + "$1" + (0, $g4H8m.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $g4H8m.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $g4H8m.WEBKIT) + value + (0, $g4H8m.MS) + (0, $g4H8m.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $g4H8m.WEBKIT) + value + (0, $g4H8m.MS) + (0, $g4H8m.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $g4H8m.WEBKIT) + value + (0, $g4H8m.MS) + (0, $g4H8m.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $g4H8m.WEBKIT) + value + (0, $g4H8m.MS) + value + value;
    }
    return value;
}
var $d1f3e432f6208b5c$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $g4H8m.DECLARATION:
                element["return"] = $d1f3e432f6208b5c$var$prefix(element.value, element.length);
                break;
            case 0, $g4H8m.KEYFRAMES:
                return (0, $g4H8m.serialize)([
                    (0, $g4H8m.copy)(element, {
                        value: (0, $g4H8m.replace)(element.value, "@", "@" + (0, $g4H8m.WEBKIT))
                    })
                ], callback);
            case 0, $g4H8m.RULESET:
                if (element.length) return (0, $g4H8m.combine)(element.props, function(value) {
                    switch((0, $g4H8m.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $g4H8m.serialize)([
                                (0, $g4H8m.copy)(element, {
                                    props: [
                                        (0, $g4H8m.replace)(value, /:(read-\w+)/, ":" + (0, $g4H8m.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $g4H8m.serialize)([
                                (0, $g4H8m.copy)(element, {
                                    props: [
                                        (0, $g4H8m.replace)(value, /:(plac\w+)/, ":" + (0, $g4H8m.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $g4H8m.copy)(element, {
                                    props: [
                                        (0, $g4H8m.replace)(value, /:(plac\w+)/, ":" + (0, $g4H8m.MOZ) + "$1")
                                    ]
                                }),
                                (0, $g4H8m.copy)(element, {
                                    props: [
                                        (0, $g4H8m.replace)(value, /:(plac\w+)/, (0, $g4H8m.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $d1f3e432f6208b5c$var$defaultStylisPlugins = [
    $d1f3e432f6208b5c$var$prefixer
];
var $d1f3e432f6208b5c$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $d1f3e432f6208b5c$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $d1f3e432f6208b5c$var$compat,
        $d1f3e432f6208b5c$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $g4H8m.stringify),
        (0, $g4H8m.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $g4H8m.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $g4H8m.serialize)((0, $g4H8m.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $aa49b.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRequire.register("aa49b", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $765e0e17d0deb8a7$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $765e0e17d0deb8a7$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $765e0e17d0deb8a7$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $765e0e17d0deb8a7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($765e0e17d0deb8a7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $765e0e17d0deb8a7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRequire.register("g4H8m", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $1a2a649ba168a20d$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $1a2a649ba168a20d$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $1a2a649ba168a20d$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $1a2a649ba168a20d$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $1a2a649ba168a20d$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $1a2a649ba168a20d$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $1a2a649ba168a20d$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $1a2a649ba168a20d$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $1a2a649ba168a20d$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $1a2a649ba168a20d$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $1a2a649ba168a20d$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $1a2a649ba168a20d$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $1a2a649ba168a20d$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $1a2a649ba168a20d$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $1a2a649ba168a20d$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $1a2a649ba168a20d$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $1a2a649ba168a20d$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $1a2a649ba168a20d$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $1a2a649ba168a20d$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $1a2a649ba168a20d$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $1a2a649ba168a20d$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $1a2a649ba168a20d$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $1a2a649ba168a20d$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $1a2a649ba168a20d$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $1a2a649ba168a20d$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $1a2a649ba168a20d$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $1a2a649ba168a20d$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $1a2a649ba168a20d$export$38bcb760f1d4871c; });
var $1a2a649ba168a20d$export$71ad59f2e432cfe8 = "-ms-";
var $1a2a649ba168a20d$export$2c0f367103c8d01c = "-moz-";
var $1a2a649ba168a20d$export$39dfd62a25e0fe93 = "-webkit-";
var $1a2a649ba168a20d$export$a29989082612d0d9 = "comm";
var $1a2a649ba168a20d$export$aa3a2e812ca8570d = "rule";
var $1a2a649ba168a20d$export$527d108ccf083c2b = "decl";
var $1a2a649ba168a20d$export$d3d35020fa5b54f0 = "@page";
var $1a2a649ba168a20d$export$500415a86c544f73 = "@media";
var $1a2a649ba168a20d$export$a763edbf796b780a = "@import";
var $1a2a649ba168a20d$export$2790aeb8b4e5c826 = "@charset";
var $1a2a649ba168a20d$export$1cc683e23b84b133 = "@viewport";
var $1a2a649ba168a20d$export$9447a5efea57e862 = "@supports";
var $1a2a649ba168a20d$export$ef011b4e114b1fba = "@document";
var $1a2a649ba168a20d$export$6aad947bda0f3f46 = "@namespace";
var $1a2a649ba168a20d$export$b44a8529a35fcb60 = "@keyframes";
var $1a2a649ba168a20d$export$2c16de31893252e6 = "@font-face";
var $1a2a649ba168a20d$export$3d846dd52e150c6f = "@counter-style";
var $1a2a649ba168a20d$export$22314bfbb57653fe = "@font-feature-values";
var $1a2a649ba168a20d$export$d773506282b3cfe6 = "@layer";
var $1a2a649ba168a20d$export$2335f513bbd82c6d = Math.abs;
var $1a2a649ba168a20d$export$6788812c4e6611e6 = String.fromCharCode;
var $1a2a649ba168a20d$export$e6e34fd1f2686227 = Object.assign;
function $1a2a649ba168a20d$export$d6af199866bfb566(e, r) {
    return $1a2a649ba168a20d$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $1a2a649ba168a20d$export$a9db5e087081082d(e, 0)) << 2 ^ $1a2a649ba168a20d$export$a9db5e087081082d(e, 1)) << 2 ^ $1a2a649ba168a20d$export$a9db5e087081082d(e, 2)) << 2 ^ $1a2a649ba168a20d$export$a9db5e087081082d(e, 3) : 0;
}
function $1a2a649ba168a20d$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $1a2a649ba168a20d$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $1a2a649ba168a20d$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $1a2a649ba168a20d$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $1a2a649ba168a20d$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $1a2a649ba168a20d$export$36776f635604f274(e) {
    return e.length;
}
function $1a2a649ba168a20d$export$f9084667e487ed46(e) {
    return e.length;
}
function $1a2a649ba168a20d$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $1a2a649ba168a20d$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $1a2a649ba168a20d$export$53f1d5ea8de3d7c = 1;
var $1a2a649ba168a20d$export$4e0c71f277ca26b3 = 1;
var $1a2a649ba168a20d$export$f24224f1c91d8156 = 0;
var $1a2a649ba168a20d$export$5880b8b5730aff45 = 0;
var $1a2a649ba168a20d$export$c0306caf338ac095 = 0;
var $1a2a649ba168a20d$export$30a86d91af8ff6e6 = "";
function $1a2a649ba168a20d$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $1a2a649ba168a20d$export$53f1d5ea8de3d7c,
        column: $1a2a649ba168a20d$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $1a2a649ba168a20d$export$784d13d8ee351f07(e, r) {
    return $1a2a649ba168a20d$export$e6e34fd1f2686227($1a2a649ba168a20d$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $1a2a649ba168a20d$export$eba6f6f03b0a92e7() {
    return $1a2a649ba168a20d$export$c0306caf338ac095;
}
function $1a2a649ba168a20d$export$232faf9add678146() {
    $1a2a649ba168a20d$export$c0306caf338ac095 = $1a2a649ba168a20d$export$5880b8b5730aff45 > 0 ? $1a2a649ba168a20d$export$a9db5e087081082d($1a2a649ba168a20d$export$30a86d91af8ff6e6, --$1a2a649ba168a20d$export$5880b8b5730aff45) : 0;
    if ($1a2a649ba168a20d$export$4e0c71f277ca26b3--, $1a2a649ba168a20d$export$c0306caf338ac095 === 10) $1a2a649ba168a20d$export$4e0c71f277ca26b3 = 1, $1a2a649ba168a20d$export$53f1d5ea8de3d7c--;
    return $1a2a649ba168a20d$export$c0306caf338ac095;
}
function $1a2a649ba168a20d$export$48cfd1e771a65c4f() {
    $1a2a649ba168a20d$export$c0306caf338ac095 = $1a2a649ba168a20d$export$5880b8b5730aff45 < $1a2a649ba168a20d$export$f24224f1c91d8156 ? $1a2a649ba168a20d$export$a9db5e087081082d($1a2a649ba168a20d$export$30a86d91af8ff6e6, $1a2a649ba168a20d$export$5880b8b5730aff45++) : 0;
    if ($1a2a649ba168a20d$export$4e0c71f277ca26b3++, $1a2a649ba168a20d$export$c0306caf338ac095 === 10) $1a2a649ba168a20d$export$4e0c71f277ca26b3 = 1, $1a2a649ba168a20d$export$53f1d5ea8de3d7c++;
    return $1a2a649ba168a20d$export$c0306caf338ac095;
}
function $1a2a649ba168a20d$export$4d3fb11e950abb9e() {
    return $1a2a649ba168a20d$export$a9db5e087081082d($1a2a649ba168a20d$export$30a86d91af8ff6e6, $1a2a649ba168a20d$export$5880b8b5730aff45);
}
function $1a2a649ba168a20d$export$e88cb2efb12ae807() {
    return $1a2a649ba168a20d$export$5880b8b5730aff45;
}
function $1a2a649ba168a20d$export$58adb3bec8346d0f(e, r) {
    return $1a2a649ba168a20d$export$2f35ab04d2335697($1a2a649ba168a20d$export$30a86d91af8ff6e6, e, r);
}
function $1a2a649ba168a20d$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $1a2a649ba168a20d$export$2de70f21292aac9e(e) {
    return $1a2a649ba168a20d$export$53f1d5ea8de3d7c = $1a2a649ba168a20d$export$4e0c71f277ca26b3 = 1, $1a2a649ba168a20d$export$f24224f1c91d8156 = $1a2a649ba168a20d$export$36776f635604f274($1a2a649ba168a20d$export$30a86d91af8ff6e6 = e), $1a2a649ba168a20d$export$5880b8b5730aff45 = 0, [];
}
function $1a2a649ba168a20d$export$45918ac1574455b1(e) {
    return $1a2a649ba168a20d$export$30a86d91af8ff6e6 = "", e;
}
function $1a2a649ba168a20d$export$410ac95b9ec204b8(e) {
    return $1a2a649ba168a20d$export$87c2784dc9fc4ab($1a2a649ba168a20d$export$58adb3bec8346d0f($1a2a649ba168a20d$export$5880b8b5730aff45 - 1, $1a2a649ba168a20d$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $1a2a649ba168a20d$export$660b2ee2d4fb4eff(e) {
    return $1a2a649ba168a20d$export$45918ac1574455b1($1a2a649ba168a20d$export$5f8c09e3ae6f64e1($1a2a649ba168a20d$export$2de70f21292aac9e(e)));
}
function $1a2a649ba168a20d$export$7af1228ff777d175(e) {
    while($1a2a649ba168a20d$export$c0306caf338ac095 = $1a2a649ba168a20d$export$4d3fb11e950abb9e())if ($1a2a649ba168a20d$export$c0306caf338ac095 < 33) $1a2a649ba168a20d$export$48cfd1e771a65c4f();
    else break;
    return $1a2a649ba168a20d$export$9e1725a4cfeada27(e) > 2 || $1a2a649ba168a20d$export$9e1725a4cfeada27($1a2a649ba168a20d$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $1a2a649ba168a20d$export$5f8c09e3ae6f64e1(e) {
    while($1a2a649ba168a20d$export$48cfd1e771a65c4f())switch($1a2a649ba168a20d$export$9e1725a4cfeada27($1a2a649ba168a20d$export$c0306caf338ac095)){
        case 0:
            $1a2a649ba168a20d$export$10d8903dec122b9d($1a2a649ba168a20d$export$c2ab62c7bf24634($1a2a649ba168a20d$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $1a2a649ba168a20d$export$10d8903dec122b9d($1a2a649ba168a20d$export$410ac95b9ec204b8($1a2a649ba168a20d$export$c0306caf338ac095), e);
            break;
        default:
            $1a2a649ba168a20d$export$10d8903dec122b9d($1a2a649ba168a20d$export$6788812c4e6611e6($1a2a649ba168a20d$export$c0306caf338ac095), e);
    }
    return e;
}
function $1a2a649ba168a20d$export$955ba06d119e085e(e, r) {
    while(--r && $1a2a649ba168a20d$export$48cfd1e771a65c4f())if ($1a2a649ba168a20d$export$c0306caf338ac095 < 48 || $1a2a649ba168a20d$export$c0306caf338ac095 > 102 || $1a2a649ba168a20d$export$c0306caf338ac095 > 57 && $1a2a649ba168a20d$export$c0306caf338ac095 < 65 || $1a2a649ba168a20d$export$c0306caf338ac095 > 70 && $1a2a649ba168a20d$export$c0306caf338ac095 < 97) break;
    return $1a2a649ba168a20d$export$58adb3bec8346d0f(e, $1a2a649ba168a20d$export$e88cb2efb12ae807() + (r < 6 && $1a2a649ba168a20d$export$4d3fb11e950abb9e() == 32 && $1a2a649ba168a20d$export$48cfd1e771a65c4f() == 32));
}
function $1a2a649ba168a20d$export$c889f2fcc19dbf12(e) {
    while($1a2a649ba168a20d$export$48cfd1e771a65c4f())switch($1a2a649ba168a20d$export$c0306caf338ac095){
        case e:
            return $1a2a649ba168a20d$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $1a2a649ba168a20d$export$c889f2fcc19dbf12($1a2a649ba168a20d$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $1a2a649ba168a20d$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $1a2a649ba168a20d$export$48cfd1e771a65c4f();
            break;
    }
    return $1a2a649ba168a20d$export$5880b8b5730aff45;
}
function $1a2a649ba168a20d$export$4254d4e2b3745c4c(e, r) {
    while($1a2a649ba168a20d$export$48cfd1e771a65c4f())if (e + $1a2a649ba168a20d$export$c0306caf338ac095 === 57) break;
    else if (e + $1a2a649ba168a20d$export$c0306caf338ac095 === 84 && $1a2a649ba168a20d$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $1a2a649ba168a20d$export$58adb3bec8346d0f(r, $1a2a649ba168a20d$export$5880b8b5730aff45 - 1) + "*" + $1a2a649ba168a20d$export$6788812c4e6611e6(e === 47 ? e : $1a2a649ba168a20d$export$48cfd1e771a65c4f());
}
function $1a2a649ba168a20d$export$c2ab62c7bf24634(e) {
    while(!$1a2a649ba168a20d$export$9e1725a4cfeada27($1a2a649ba168a20d$export$4d3fb11e950abb9e()))$1a2a649ba168a20d$export$48cfd1e771a65c4f();
    return $1a2a649ba168a20d$export$58adb3bec8346d0f(e, $1a2a649ba168a20d$export$5880b8b5730aff45);
}
function $1a2a649ba168a20d$export$ef7acd7185315e22(e) {
    return $1a2a649ba168a20d$export$45918ac1574455b1($1a2a649ba168a20d$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $1a2a649ba168a20d$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $1a2a649ba168a20d$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $1a2a649ba168a20d$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $1a2a649ba168a20d$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($1a2a649ba168a20d$export$f8e21b1e77979a08(j += $1a2a649ba168a20d$export$77ad94ebf1c2b9ed($1a2a649ba168a20d$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $1a2a649ba168a20d$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $1a2a649ba168a20d$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $1a2a649ba168a20d$export$955ba06d119e085e($1a2a649ba168a20d$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($1a2a649ba168a20d$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $1a2a649ba168a20d$export$10d8903dec122b9d($1a2a649ba168a20d$export$4a34f930e789283c($1a2a649ba168a20d$export$4254d4e2b3745c4c($1a2a649ba168a20d$export$48cfd1e771a65c4f(), $1a2a649ba168a20d$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $1a2a649ba168a20d$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $1a2a649ba168a20d$export$36776f635604f274(j) - l) $1a2a649ba168a20d$export$10d8903dec122b9d(p > 32 ? $1a2a649ba168a20d$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $1a2a649ba168a20d$export$f8483753829ec8f3($1a2a649ba168a20d$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $1a2a649ba168a20d$export$10d8903dec122b9d(y = $1a2a649ba168a20d$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $1a2a649ba168a20d$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $1a2a649ba168a20d$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $1a2a649ba168a20d$export$98e6a39c04603d36(e, y, y, n && $1a2a649ba168a20d$export$10d8903dec122b9d($1a2a649ba168a20d$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $1a2a649ba168a20d$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $1a2a649ba168a20d$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $1a2a649ba168a20d$export$232faf9add678146() == 125) continue;
            }
            switch(j += $1a2a649ba168a20d$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($1a2a649ba168a20d$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($1a2a649ba168a20d$export$4d3fb11e950abb9e() === 45) j += $1a2a649ba168a20d$export$410ac95b9ec204b8($1a2a649ba168a20d$export$48cfd1e771a65c4f());
                    v = $1a2a649ba168a20d$export$4d3fb11e950abb9e(), o = l = $1a2a649ba168a20d$export$36776f635604f274(g = j += $1a2a649ba168a20d$export$c2ab62c7bf24634($1a2a649ba168a20d$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $1a2a649ba168a20d$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $1a2a649ba168a20d$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $1a2a649ba168a20d$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $1a2a649ba168a20d$export$2f35ab04d2335697(e, v + 1, v = $1a2a649ba168a20d$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $1a2a649ba168a20d$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $1a2a649ba168a20d$export$35059013cd4a06db(e, r, a, s === 0 ? $1a2a649ba168a20d$export$aa3a2e812ca8570d : i, f, o, l);
}
function $1a2a649ba168a20d$export$4a34f930e789283c(e, r, a) {
    return $1a2a649ba168a20d$export$35059013cd4a06db(e, r, a, $1a2a649ba168a20d$export$a29989082612d0d9, $1a2a649ba168a20d$export$6788812c4e6611e6($1a2a649ba168a20d$export$eba6f6f03b0a92e7()), $1a2a649ba168a20d$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $1a2a649ba168a20d$export$f8483753829ec8f3(e, r, a, n) {
    return $1a2a649ba168a20d$export$35059013cd4a06db(e, r, a, $1a2a649ba168a20d$export$527d108ccf083c2b, $1a2a649ba168a20d$export$2f35ab04d2335697(e, 0, n), $1a2a649ba168a20d$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $1a2a649ba168a20d$export$82e9f45cca5ba907(n, c, s) {
    switch($1a2a649ba168a20d$export$d6af199866bfb566(n, c)){
        case 5103:
            return $1a2a649ba168a20d$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $1a2a649ba168a20d$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $1a2a649ba168a20d$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $1a2a649ba168a20d$export$39dfd62a25e0fe93 + n + $1a2a649ba168a20d$export$2c0f367103c8d01c + n + $1a2a649ba168a20d$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($1a2a649ba168a20d$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $1a2a649ba168a20d$export$39dfd62a25e0fe93 + n + $1a2a649ba168a20d$export$71ad59f2e432cfe8 + $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $1a2a649ba168a20d$export$39dfd62a25e0fe93 + n + $1a2a649ba168a20d$export$71ad59f2e432cfe8 + $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $1a2a649ba168a20d$export$39dfd62a25e0fe93 + n + $1a2a649ba168a20d$export$71ad59f2e432cfe8 + $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $1a2a649ba168a20d$export$39dfd62a25e0fe93 + n + $1a2a649ba168a20d$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $1a2a649ba168a20d$export$39dfd62a25e0fe93 + n + $1a2a649ba168a20d$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $1a2a649ba168a20d$export$39dfd62a25e0fe93 + n + $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $1a2a649ba168a20d$export$39dfd62a25e0fe93 + "box-$1$2" + $1a2a649ba168a20d$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $1a2a649ba168a20d$export$39dfd62a25e0fe93 + n + $1a2a649ba168a20d$export$71ad59f2e432cfe8 + "flex-item-" + $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$1a2a649ba168a20d$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $1a2a649ba168a20d$export$71ad59f2e432cfe8 + "grid-row-" + $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $1a2a649ba168a20d$export$39dfd62a25e0fe93 + n + $1a2a649ba168a20d$export$71ad59f2e432cfe8 + "flex-line-pack" + $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $1a2a649ba168a20d$export$39dfd62a25e0fe93 + n + $1a2a649ba168a20d$export$71ad59f2e432cfe8 + $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $1a2a649ba168a20d$export$39dfd62a25e0fe93 + n + $1a2a649ba168a20d$export$71ad59f2e432cfe8 + $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $1a2a649ba168a20d$export$39dfd62a25e0fe93 + "box-" + $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, "-grow", "") + $1a2a649ba168a20d$export$39dfd62a25e0fe93 + n + $1a2a649ba168a20d$export$71ad59f2e432cfe8 + $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $1a2a649ba168a20d$export$39dfd62a25e0fe93 + $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $1a2a649ba168a20d$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $1a2a649ba168a20d$export$77ad94ebf1c2b9ed($1a2a649ba168a20d$export$77ad94ebf1c2b9ed($1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $1a2a649ba168a20d$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $1a2a649ba168a20d$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $1a2a649ba168a20d$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $1a2a649ba168a20d$export$77ad94ebf1c2b9ed($1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $1a2a649ba168a20d$export$39dfd62a25e0fe93 + "box-pack:$3" + $1a2a649ba168a20d$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $1a2a649ba168a20d$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$1a2a649ba168a20d$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $1a2a649ba168a20d$export$71ad59f2e432cfe8 + "grid-column-align" + $1a2a649ba168a20d$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $1a2a649ba168a20d$export$71ad59f2e432cfe8 + $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $1a2a649ba168a20d$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$1a2a649ba168a20d$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $1a2a649ba168a20d$export$71ad59f2e432cfe8 + $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $1a2a649ba168a20d$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$1a2a649ba168a20d$export$f8e21b1e77979a08(s, "span") ? $1a2a649ba168a20d$export$4659b591c19bdf3d(s, /\d+/) : +$1a2a649ba168a20d$export$4659b591c19bdf3d(s, /\d+/) - +$1a2a649ba168a20d$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $1a2a649ba168a20d$export$71ad59f2e432cfe8 + $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $1a2a649ba168a20d$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $1a2a649ba168a20d$export$71ad59f2e432cfe8 + $1a2a649ba168a20d$export$77ad94ebf1c2b9ed($1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $1a2a649ba168a20d$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($1a2a649ba168a20d$export$36776f635604f274(n) - 1 - c > 6) switch($1a2a649ba168a20d$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($1a2a649ba168a20d$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $1a2a649ba168a20d$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $1a2a649ba168a20d$export$2c0f367103c8d01c + ($1a2a649ba168a20d$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$1a2a649ba168a20d$export$f8e21b1e77979a08(n, "stretch") ? $1a2a649ba168a20d$export$82e9f45cca5ba907($1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $1a2a649ba168a20d$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $1a2a649ba168a20d$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($1a2a649ba168a20d$export$a9db5e087081082d(n, c + 6) === 121) return $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, ":", ":" + $1a2a649ba168a20d$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($1a2a649ba168a20d$export$a9db5e087081082d(n, $1a2a649ba168a20d$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $1a2a649ba168a20d$export$39dfd62a25e0fe93 + ($1a2a649ba168a20d$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $1a2a649ba168a20d$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $1a2a649ba168a20d$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, ":", ":" + $1a2a649ba168a20d$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $1a2a649ba168a20d$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $1a2a649ba168a20d$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $1a2a649ba168a20d$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $1a2a649ba168a20d$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $1a2a649ba168a20d$export$a763edbf796b780a:
        case $1a2a649ba168a20d$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $1a2a649ba168a20d$export$a29989082612d0d9:
            return "";
        case $1a2a649ba168a20d$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $1a2a649ba168a20d$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $1a2a649ba168a20d$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $1a2a649ba168a20d$export$36776f635604f274(a = $1a2a649ba168a20d$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $1a2a649ba168a20d$export$5a7767152ae0305f(e) {
    var r = $1a2a649ba168a20d$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $1a2a649ba168a20d$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $1a2a649ba168a20d$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $1a2a649ba168a20d$export$527d108ccf083c2b:
                n.return = $1a2a649ba168a20d$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $1a2a649ba168a20d$export$b44a8529a35fcb60:
                return $1a2a649ba168a20d$export$dfdc1655ccc5b9cb([
                    $1a2a649ba168a20d$export$784d13d8ee351f07(n, {
                        value: $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $1a2a649ba168a20d$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $1a2a649ba168a20d$export$aa3a2e812ca8570d:
                if (n.length) return $1a2a649ba168a20d$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($1a2a649ba168a20d$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $1a2a649ba168a20d$export$dfdc1655ccc5b9cb([
                                $1a2a649ba168a20d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $1a2a649ba168a20d$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $1a2a649ba168a20d$export$dfdc1655ccc5b9cb([
                                $1a2a649ba168a20d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $1a2a649ba168a20d$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $1a2a649ba168a20d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $1a2a649ba168a20d$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $1a2a649ba168a20d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $1a2a649ba168a20d$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $1a2a649ba168a20d$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $1a2a649ba168a20d$export$76a88f7de6507443(e) {
    switch(e.type){
        case $1a2a649ba168a20d$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $1a2a649ba168a20d$export$1be1fc439b849fdf($1a2a649ba168a20d$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($1a2a649ba168a20d$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $1a2a649ba168a20d$export$2f35ab04d2335697(r, 1, $1a2a649ba168a20d$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $1a2a649ba168a20d$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $1a2a649ba168a20d$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $1a2a649ba168a20d$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRequire.register("7DpjZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58efd134aed6e57d$export$2e2bcd8739ae039; });
var $58efd134aed6e57d$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRequire.register("cgP8G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8eeea5ceb1bf8b05$export$2e2bcd8739ae039; });
function $8eeea5ceb1bf8b05$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRequire.register("kprwP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edbb7f06b0b68f58$export$2e2bcd8739ae039; });

var $gizNK = parcelRequire("gizNK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $edbb7f06b0b68f58$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gizNK)))(targetComponent, sourceComponent);
};

});
parcelRequire.register("gizNK", function(module, exports) {
"use strict";

var $gCblI = parcelRequire("gCblI");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $bdda1934758a2759$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $bdda1934758a2759$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $bdda1934758a2759$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $bdda1934758a2759$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $bdda1934758a2759$var$TYPE_STATICS = {};
$bdda1934758a2759$var$TYPE_STATICS[$gCblI.ForwardRef] = $bdda1934758a2759$var$FORWARD_REF_STATICS;
$bdda1934758a2759$var$TYPE_STATICS[$gCblI.Memo] = $bdda1934758a2759$var$MEMO_STATICS;
function $bdda1934758a2759$var$getStatics(component) {
    // React v16.11 and below
    if ($gCblI.isMemo(component)) return $bdda1934758a2759$var$MEMO_STATICS;
     // React v16.12 and above
    return $bdda1934758a2759$var$TYPE_STATICS[component["$$typeof"]] || $bdda1934758a2759$var$REACT_STATICS;
}
var $bdda1934758a2759$var$defineProperty = Object.defineProperty;
var $bdda1934758a2759$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $bdda1934758a2759$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $bdda1934758a2759$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $bdda1934758a2759$var$getPrototypeOf = Object.getPrototypeOf;
var $bdda1934758a2759$var$objectPrototype = Object.prototype;
function $bdda1934758a2759$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($bdda1934758a2759$var$objectPrototype) {
            var inheritedComponent = $bdda1934758a2759$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $bdda1934758a2759$var$objectPrototype) $bdda1934758a2759$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $bdda1934758a2759$var$getOwnPropertyNames(sourceComponent);
        if ($bdda1934758a2759$var$getOwnPropertySymbols) keys = keys.concat($bdda1934758a2759$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $bdda1934758a2759$var$getStatics(targetComponent);
        var sourceStatics = $bdda1934758a2759$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$bdda1934758a2759$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $bdda1934758a2759$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $bdda1934758a2759$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $bdda1934758a2759$var$hoistNonReactStatics;

});
parcelRequire.register("gCblI", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jkQVH"));

});
parcelRequire.register("jkQVH", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $e138f148f0ffeb9a$export$2b8d127b894957b9; }, function (v) { return $e138f148f0ffeb9a$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $e138f148f0ffeb9a$export$cea3a54a6425200c; }, function (v) { return $e138f148f0ffeb9a$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $e138f148f0ffeb9a$export$a7c73072b1a182ae; }, function (v) { return $e138f148f0ffeb9a$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $e138f148f0ffeb9a$export$9f27bc3417b4524d; }, function (v) { return $e138f148f0ffeb9a$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $e138f148f0ffeb9a$export$db77ccec0bb4ccac; }, function (v) { return $e138f148f0ffeb9a$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $e138f148f0ffeb9a$export$8392c0c9d3dcbd35; }, function (v) { return $e138f148f0ffeb9a$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $e138f148f0ffeb9a$export$ffb0004e005737fa; }, function (v) { return $e138f148f0ffeb9a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $e138f148f0ffeb9a$export$b624eff549462981; }, function (v) { return $e138f148f0ffeb9a$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $e138f148f0ffeb9a$export$7897aa7841a5380c; }, function (v) { return $e138f148f0ffeb9a$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $e138f148f0ffeb9a$export$602eac185826482c; }, function (v) { return $e138f148f0ffeb9a$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $e138f148f0ffeb9a$export$e2c29f18771995cb; }, function (v) { return $e138f148f0ffeb9a$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $e138f148f0ffeb9a$export$5f8d39834fd61797; }, function (v) { return $e138f148f0ffeb9a$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $e138f148f0ffeb9a$export$74bf444e3cd11ea5; }, function (v) { return $e138f148f0ffeb9a$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $e138f148f0ffeb9a$export$92387174baf9b227; }, function (v) { return $e138f148f0ffeb9a$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $e138f148f0ffeb9a$export$ec112efeb987d9c6; }, function (v) { return $e138f148f0ffeb9a$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $e138f148f0ffeb9a$export$b706b080d889d2c9; }, function (v) { return $e138f148f0ffeb9a$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $e138f148f0ffeb9a$export$5be5a87408f70ddc; }, function (v) { return $e138f148f0ffeb9a$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $e138f148f0ffeb9a$export$45a5e7f76e0caa8d; }, function (v) { return $e138f148f0ffeb9a$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $e138f148f0ffeb9a$export$455c2e768291efa6; }, function (v) { return $e138f148f0ffeb9a$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $e138f148f0ffeb9a$export$9522e17588c12572; }, function (v) { return $e138f148f0ffeb9a$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $e138f148f0ffeb9a$export$2110ac352bb060b9; }, function (v) { return $e138f148f0ffeb9a$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $e138f148f0ffeb9a$export$56885ab8b9c456ab; }, function (v) { return $e138f148f0ffeb9a$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $e138f148f0ffeb9a$export$d927fcb6adf8f9de; }, function (v) { return $e138f148f0ffeb9a$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $e138f148f0ffeb9a$export$b82d16f27459e05a; }, function (v) { return $e138f148f0ffeb9a$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $e138f148f0ffeb9a$export$522c17b4f5e123e8; }, function (v) { return $e138f148f0ffeb9a$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $e138f148f0ffeb9a$export$1aabd8a0274ecfd6; }, function (v) { return $e138f148f0ffeb9a$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $e138f148f0ffeb9a$export$9b621391a187a31a; }, function (v) { return $e138f148f0ffeb9a$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $e138f148f0ffeb9a$export$f5bbd400c2f4426f; }, function (v) { return $e138f148f0ffeb9a$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e138f148f0ffeb9a$export$2b8d127b894957b9;
var $e138f148f0ffeb9a$export$cea3a54a6425200c;
var $e138f148f0ffeb9a$export$a7c73072b1a182ae;
var $e138f148f0ffeb9a$export$9f27bc3417b4524d;
var $e138f148f0ffeb9a$export$db77ccec0bb4ccac;
var $e138f148f0ffeb9a$export$8392c0c9d3dcbd35;
var $e138f148f0ffeb9a$export$ffb0004e005737fa;
var $e138f148f0ffeb9a$export$b624eff549462981;
var $e138f148f0ffeb9a$export$7897aa7841a5380c;
var $e138f148f0ffeb9a$export$602eac185826482c;
var $e138f148f0ffeb9a$export$e2c29f18771995cb;
var $e138f148f0ffeb9a$export$5f8d39834fd61797;
var $e138f148f0ffeb9a$export$74bf444e3cd11ea5;
var $e138f148f0ffeb9a$export$92387174baf9b227;
var $e138f148f0ffeb9a$export$ec112efeb987d9c6;
var $e138f148f0ffeb9a$export$b706b080d889d2c9;
var $e138f148f0ffeb9a$export$5be5a87408f70ddc;
var $e138f148f0ffeb9a$export$45a5e7f76e0caa8d;
var $e138f148f0ffeb9a$export$455c2e768291efa6;
var $e138f148f0ffeb9a$export$9522e17588c12572;
var $e138f148f0ffeb9a$export$2110ac352bb060b9;
var $e138f148f0ffeb9a$export$56885ab8b9c456ab;
var $e138f148f0ffeb9a$export$d927fcb6adf8f9de;
var $e138f148f0ffeb9a$export$b82d16f27459e05a;
var $e138f148f0ffeb9a$export$522c17b4f5e123e8;
var $e138f148f0ffeb9a$export$1aabd8a0274ecfd6;
var $e138f148f0ffeb9a$export$9b621391a187a31a;
var $e138f148f0ffeb9a$export$f5bbd400c2f4426f;
"use strict";
var $e138f148f0ffeb9a$var$b = "function" === typeof Symbol && Symbol.for, $e138f148f0ffeb9a$var$c = $e138f148f0ffeb9a$var$b ? Symbol.for("react.element") : 60103, $e138f148f0ffeb9a$var$d = $e138f148f0ffeb9a$var$b ? Symbol.for("react.portal") : 60106, $e138f148f0ffeb9a$var$e = $e138f148f0ffeb9a$var$b ? Symbol.for("react.fragment") : 60107, $e138f148f0ffeb9a$var$f = $e138f148f0ffeb9a$var$b ? Symbol.for("react.strict_mode") : 60108, $e138f148f0ffeb9a$var$g = $e138f148f0ffeb9a$var$b ? Symbol.for("react.profiler") : 60114, $e138f148f0ffeb9a$var$h = $e138f148f0ffeb9a$var$b ? Symbol.for("react.provider") : 60109, $e138f148f0ffeb9a$var$k = $e138f148f0ffeb9a$var$b ? Symbol.for("react.context") : 60110, $e138f148f0ffeb9a$var$l = $e138f148f0ffeb9a$var$b ? Symbol.for("react.async_mode") : 60111, $e138f148f0ffeb9a$var$m = $e138f148f0ffeb9a$var$b ? Symbol.for("react.concurrent_mode") : 60111, $e138f148f0ffeb9a$var$n = $e138f148f0ffeb9a$var$b ? Symbol.for("react.forward_ref") : 60112, $e138f148f0ffeb9a$var$p = $e138f148f0ffeb9a$var$b ? Symbol.for("react.suspense") : 60113, $e138f148f0ffeb9a$var$q = $e138f148f0ffeb9a$var$b ? Symbol.for("react.suspense_list") : 60120, $e138f148f0ffeb9a$var$r = $e138f148f0ffeb9a$var$b ? Symbol.for("react.memo") : 60115, $e138f148f0ffeb9a$var$t = $e138f148f0ffeb9a$var$b ? Symbol.for("react.lazy") : 60116, $e138f148f0ffeb9a$var$v = $e138f148f0ffeb9a$var$b ? Symbol.for("react.block") : 60121, $e138f148f0ffeb9a$var$w = $e138f148f0ffeb9a$var$b ? Symbol.for("react.fundamental") : 60117, $e138f148f0ffeb9a$var$x = $e138f148f0ffeb9a$var$b ? Symbol.for("react.responder") : 60118, $e138f148f0ffeb9a$var$y = $e138f148f0ffeb9a$var$b ? Symbol.for("react.scope") : 60119;
function $e138f148f0ffeb9a$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $e138f148f0ffeb9a$var$c:
                switch(a = a.type, a){
                    case $e138f148f0ffeb9a$var$l:
                    case $e138f148f0ffeb9a$var$m:
                    case $e138f148f0ffeb9a$var$e:
                    case $e138f148f0ffeb9a$var$g:
                    case $e138f148f0ffeb9a$var$f:
                    case $e138f148f0ffeb9a$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $e138f148f0ffeb9a$var$k:
                            case $e138f148f0ffeb9a$var$n:
                            case $e138f148f0ffeb9a$var$t:
                            case $e138f148f0ffeb9a$var$r:
                            case $e138f148f0ffeb9a$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $e138f148f0ffeb9a$var$d:
                return u;
        }
    }
}
function $e138f148f0ffeb9a$var$A(a) {
    return $e138f148f0ffeb9a$var$z(a) === $e138f148f0ffeb9a$var$m;
}
$e138f148f0ffeb9a$export$2b8d127b894957b9 = $e138f148f0ffeb9a$var$l;
$e138f148f0ffeb9a$export$cea3a54a6425200c = $e138f148f0ffeb9a$var$m;
$e138f148f0ffeb9a$export$a7c73072b1a182ae = $e138f148f0ffeb9a$var$k;
$e138f148f0ffeb9a$export$9f27bc3417b4524d = $e138f148f0ffeb9a$var$h;
$e138f148f0ffeb9a$export$db77ccec0bb4ccac = $e138f148f0ffeb9a$var$c;
$e138f148f0ffeb9a$export$8392c0c9d3dcbd35 = $e138f148f0ffeb9a$var$n;
$e138f148f0ffeb9a$export$ffb0004e005737fa = $e138f148f0ffeb9a$var$e;
$e138f148f0ffeb9a$export$b624eff549462981 = $e138f148f0ffeb9a$var$t;
$e138f148f0ffeb9a$export$7897aa7841a5380c = $e138f148f0ffeb9a$var$r;
$e138f148f0ffeb9a$export$602eac185826482c = $e138f148f0ffeb9a$var$d;
$e138f148f0ffeb9a$export$e2c29f18771995cb = $e138f148f0ffeb9a$var$g;
$e138f148f0ffeb9a$export$5f8d39834fd61797 = $e138f148f0ffeb9a$var$f;
$e138f148f0ffeb9a$export$74bf444e3cd11ea5 = $e138f148f0ffeb9a$var$p;
$e138f148f0ffeb9a$export$92387174baf9b227 = function(a) {
    return $e138f148f0ffeb9a$var$A(a) || $e138f148f0ffeb9a$var$z(a) === $e138f148f0ffeb9a$var$l;
};
$e138f148f0ffeb9a$export$ec112efeb987d9c6 = $e138f148f0ffeb9a$var$A;
$e138f148f0ffeb9a$export$b706b080d889d2c9 = function(a) {
    return $e138f148f0ffeb9a$var$z(a) === $e138f148f0ffeb9a$var$k;
};
$e138f148f0ffeb9a$export$5be5a87408f70ddc = function(a) {
    return $e138f148f0ffeb9a$var$z(a) === $e138f148f0ffeb9a$var$h;
};
$e138f148f0ffeb9a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e138f148f0ffeb9a$var$c;
};
$e138f148f0ffeb9a$export$455c2e768291efa6 = function(a) {
    return $e138f148f0ffeb9a$var$z(a) === $e138f148f0ffeb9a$var$n;
};
$e138f148f0ffeb9a$export$9522e17588c12572 = function(a) {
    return $e138f148f0ffeb9a$var$z(a) === $e138f148f0ffeb9a$var$e;
};
$e138f148f0ffeb9a$export$2110ac352bb060b9 = function(a) {
    return $e138f148f0ffeb9a$var$z(a) === $e138f148f0ffeb9a$var$t;
};
$e138f148f0ffeb9a$export$56885ab8b9c456ab = function(a) {
    return $e138f148f0ffeb9a$var$z(a) === $e138f148f0ffeb9a$var$r;
};
$e138f148f0ffeb9a$export$d927fcb6adf8f9de = function(a) {
    return $e138f148f0ffeb9a$var$z(a) === $e138f148f0ffeb9a$var$d;
};
$e138f148f0ffeb9a$export$b82d16f27459e05a = function(a) {
    return $e138f148f0ffeb9a$var$z(a) === $e138f148f0ffeb9a$var$g;
};
$e138f148f0ffeb9a$export$522c17b4f5e123e8 = function(a) {
    return $e138f148f0ffeb9a$var$z(a) === $e138f148f0ffeb9a$var$f;
};
$e138f148f0ffeb9a$export$1aabd8a0274ecfd6 = function(a) {
    return $e138f148f0ffeb9a$var$z(a) === $e138f148f0ffeb9a$var$p;
};
$e138f148f0ffeb9a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $e138f148f0ffeb9a$var$e || a === $e138f148f0ffeb9a$var$m || a === $e138f148f0ffeb9a$var$g || a === $e138f148f0ffeb9a$var$f || a === $e138f148f0ffeb9a$var$p || a === $e138f148f0ffeb9a$var$q || "object" === typeof a && null !== a && (a.$$typeof === $e138f148f0ffeb9a$var$t || a.$$typeof === $e138f148f0ffeb9a$var$r || a.$$typeof === $e138f148f0ffeb9a$var$h || a.$$typeof === $e138f148f0ffeb9a$var$k || a.$$typeof === $e138f148f0ffeb9a$var$n || a.$$typeof === $e138f148f0ffeb9a$var$w || a.$$typeof === $e138f148f0ffeb9a$var$x || a.$$typeof === $e138f148f0ffeb9a$var$y || a.$$typeof === $e138f148f0ffeb9a$var$v);
};
$e138f148f0ffeb9a$export$f5bbd400c2f4426f = $e138f148f0ffeb9a$var$z;

});




parcelRequire.register("5Bkr0", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $41404250303e14b2$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $41404250303e14b2$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $41404250303e14b2$export$6f077d94b33a01aa; });
var $41404250303e14b2$var$isBrowser = true;
function $41404250303e14b2$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $41404250303e14b2$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $41404250303e14b2$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $41404250303e14b2$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $41404250303e14b2$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRequire.register("gyMrz", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $c0e5663f5ace6af2$export$6321afa313b251b5; });

var $i4xiq = parcelRequire("i4xiq");

var $8eNqN = parcelRequire("8eNqN");

var $cgP8G = parcelRequire("cgP8G");
var $c0e5663f5ace6af2$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $c0e5663f5ace6af2$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $c0e5663f5ace6af2$var$hyphenateRegex = /[A-Z]|^ms/g;
var $c0e5663f5ace6af2$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $c0e5663f5ace6af2$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $c0e5663f5ace6af2$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $c0e5663f5ace6af2$var$processStyleName = /* #__PURE__ */ (0, $cgP8G.default)(function(styleName) {
    return $c0e5663f5ace6af2$var$isCustomProperty(styleName) ? styleName : styleName.replace($c0e5663f5ace6af2$var$hyphenateRegex, "-$&").toLowerCase();
});
var $c0e5663f5ace6af2$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($c0e5663f5ace6af2$var$animationRegex, function(match, p1, p2) {
                $c0e5663f5ace6af2$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $c0e5663f5ace6af2$var$cursor
                };
                return p1;
            });
    }
    if ((0, $8eNqN.default)[key] !== 1 && !$c0e5663f5ace6af2$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $c0e5663f5ace6af2$var$contentValuePattern, $c0e5663f5ace6af2$var$contentValues, $c0e5663f5ace6af2$var$oldProcessStyleValue, $c0e5663f5ace6af2$var$msPattern, $c0e5663f5ace6af2$var$hyphenPattern, $c0e5663f5ace6af2$var$hyphenatedCache;
var $c0e5663f5ace6af2$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $c0e5663f5ace6af2$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $c0e5663f5ace6af2$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $c0e5663f5ace6af2$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $c0e5663f5ace6af2$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $c0e5663f5ace6af2$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $c0e5663f5ace6af2$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $c0e5663f5ace6af2$var$cursor;
                var result = interpolation(mergedProps);
                $c0e5663f5ace6af2$var$cursor = previousCursor;
                return $c0e5663f5ace6af2$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $c0e5663f5ace6af2$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $c0e5663f5ace6af2$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($c0e5663f5ace6af2$var$isProcessableValue(value)) string += $c0e5663f5ace6af2$var$processStyleName(_key) + ":" + $c0e5663f5ace6af2$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($c0e5663f5ace6af2$var$isProcessableValue(value[_i])) string += $c0e5663f5ace6af2$var$processStyleName(_key) + ":" + $c0e5663f5ace6af2$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $c0e5663f5ace6af2$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $c0e5663f5ace6af2$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $c0e5663f5ace6af2$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $c0e5663f5ace6af2$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $c0e5663f5ace6af2$var$cursor;
var $c0e5663f5ace6af2$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $c0e5663f5ace6af2$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $c0e5663f5ace6af2$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $c0e5663f5ace6af2$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $c0e5663f5ace6af2$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $c0e5663f5ace6af2$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $i4xiq.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $c0e5663f5ace6af2$var$cursor
    };
};

});
parcelRequire.register("i4xiq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2826da75bbf4b24$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $d2826da75bbf4b24$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRequire.register("8eNqN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ff5f98bd21b2761$export$2e2bcd8739ae039; });
var $5ff5f98bd21b2761$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRequire.register("enaS9", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $a76ba5b9b6bc0bfc$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $a76ba5b9b6bc0bfc$export$811a713a7276cb9d; });

var $aOChP = parcelRequire("aOChP");
var $a76ba5b9b6bc0bfc$var$syncFallback = function syncFallback(create) {
    return create();
};
var $a76ba5b9b6bc0bfc$var$useInsertionEffect = $aOChP.useInsertionEffect ? $aOChP.useInsertionEffect : false;
var $a76ba5b9b6bc0bfc$export$db21c7ffa21794e7 = $a76ba5b9b6bc0bfc$var$useInsertionEffect || $a76ba5b9b6bc0bfc$var$syncFallback;
var $a76ba5b9b6bc0bfc$export$811a713a7276cb9d = $a76ba5b9b6bc0bfc$var$useInsertionEffect || $aOChP.useLayoutEffect;

});


parcelRequire.register("3hJMF", function(module, exports) {
function $2646795927427232$var$_extends() {
    module.exports = $2646795927427232$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $2646795927427232$var$_extends.apply(this, arguments);
}
module.exports = $2646795927427232$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRequire.register("fQJH6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02fa4f19dd2aab80$export$2e2bcd8739ae039; });

var $gGIFv = parcelRequire("gGIFv");
"use client";
const $02fa4f19dd2aab80$var$defaultTheme = (0, $gGIFv.default)();
var $02fa4f19dd2aab80$export$2e2bcd8739ae039 = $02fa4f19dd2aab80$var$defaultTheme;

});
parcelRequire.register("gGIFv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c26337d0f692a9f4$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $4GC5s = parcelRequire("4GC5s");

var $e45KD = parcelRequire("e45KD");
var $hBYX0 = parcelRequire("hBYX0");

var $1N2hm = parcelRequire("1N2hm");
var $2gPhR = parcelRequire("2gPhR");
var $fb2C7 = parcelRequire("fb2C7");


var $jaI1i = parcelRequire("jaI1i");

var $63xnh = parcelRequire("63xnh");

var $1P4IP = parcelRequire("1P4IP");

var $cjeji = parcelRequire("cjeji");

var $i9mNo = parcelRequire("i9mNo");

var $eNYil = parcelRequire("eNYil");
const $c26337d0f692a9f4$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $c26337d0f692a9f4$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $4GC5s.default)(options, $c26337d0f692a9f4$var$_excluded);
    if (options.vars) throw new Error((0, $hBYX0.default)(18));
    const palette = (0, $63xnh.default)(paletteInput);
    const systemTheme = (0, $1N2hm.default)(options);
    let muiTheme = (0, $e45KD.default)(systemTheme, {
        mixins: (0, $jaI1i.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $cjeji.default).slice(),
        typography: (0, $1P4IP.default)(palette, typographyInput),
        transitions: (0, $i9mNo.default)(transitionsInput),
        zIndex: (0, $dy3ak.default)({}, (0, $eNYil.default))
    });
    muiTheme = (0, $e45KD.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $e45KD.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $dy3ak.default)({}, (0, $2gPhR.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $fb2C7.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $c26337d0f692a9f4$var$warnedOnce = false;
function $c26337d0f692a9f4$export$c469355549431d9b(...args) {
    return $c26337d0f692a9f4$var$createTheme(...args);
}
var $c26337d0f692a9f4$export$2e2bcd8739ae039 = $c26337d0f692a9f4$var$createTheme;

});
parcelRequire.register("jaI1i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df5118f0fa737d9c$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");
function $df5118f0fa737d9c$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $dy3ak.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRequire.register("63xnh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $468ce96392d8cfa6$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $4GC5s = parcelRequire("4GC5s");

var $e45KD = parcelRequire("e45KD");
var $hBYX0 = parcelRequire("hBYX0");

var $4qbW1 = parcelRequire("4qbW1");

var $5hroS = parcelRequire("5hroS");

var $2GAx0 = parcelRequire("2GAx0");

var $7OD2X = parcelRequire("7OD2X");

var $eDF6e = parcelRequire("eDF6e");

var $aeuld = parcelRequire("aeuld");

var $1uqik = parcelRequire("1uqik");

var $3v0H4 = parcelRequire("3v0H4");

var $iYDfH = parcelRequire("iYDfH");
const $468ce96392d8cfa6$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $468ce96392d8cfa6$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $5hroS.default).white,
        default: (0, $5hroS.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $468ce96392d8cfa6$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $5hroS.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $5hroS.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $468ce96392d8cfa6$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $4qbW1.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $4qbW1.darken)(intent.main, tonalOffsetDark);
    }
}
function $468ce96392d8cfa6$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $1uqik.default)[200],
        light: (0, $1uqik.default)[50],
        dark: (0, $1uqik.default)[400]
    };
    return {
        main: (0, $1uqik.default)[700],
        light: (0, $1uqik.default)[400],
        dark: (0, $1uqik.default)[800]
    };
}
function $468ce96392d8cfa6$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $7OD2X.default)[200],
        light: (0, $7OD2X.default)[50],
        dark: (0, $7OD2X.default)[400]
    };
    return {
        main: (0, $7OD2X.default)[500],
        light: (0, $7OD2X.default)[300],
        dark: (0, $7OD2X.default)[700]
    };
}
function $468ce96392d8cfa6$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $eDF6e.default)[500],
        light: (0, $eDF6e.default)[300],
        dark: (0, $eDF6e.default)[700]
    };
    return {
        main: (0, $eDF6e.default)[700],
        light: (0, $eDF6e.default)[400],
        dark: (0, $eDF6e.default)[800]
    };
}
function $468ce96392d8cfa6$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $3v0H4.default)[400],
        light: (0, $3v0H4.default)[300],
        dark: (0, $3v0H4.default)[700]
    };
    return {
        main: (0, $3v0H4.default)[700],
        light: (0, $3v0H4.default)[500],
        dark: (0, $3v0H4.default)[900]
    };
}
function $468ce96392d8cfa6$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $iYDfH.default)[400],
        light: (0, $iYDfH.default)[300],
        dark: (0, $iYDfH.default)[700]
    };
    return {
        main: (0, $iYDfH.default)[800],
        light: (0, $iYDfH.default)[500],
        dark: (0, $iYDfH.default)[900]
    };
}
function $468ce96392d8cfa6$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $aeuld.default)[400],
        light: (0, $aeuld.default)[300],
        dark: (0, $aeuld.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $aeuld.default)[500],
        dark: (0, $aeuld.default)[900]
    };
}
function $468ce96392d8cfa6$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $4GC5s.default)(palette, $468ce96392d8cfa6$var$_excluded);
    const primary = palette.primary || $468ce96392d8cfa6$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $468ce96392d8cfa6$var$getDefaultSecondary(mode);
    const error = palette.error || $468ce96392d8cfa6$var$getDefaultError(mode);
    const info = palette.info || $468ce96392d8cfa6$var$getDefaultInfo(mode);
    const success = palette.success || $468ce96392d8cfa6$var$getDefaultSuccess(mode);
    const warning = palette.warning || $468ce96392d8cfa6$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $4qbW1.getContrastRatio)(background, $468ce96392d8cfa6$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $468ce96392d8cfa6$export$55ce6f3a06c59543.text.primary : $468ce96392d8cfa6$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $dy3ak.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $hBYX0.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $hBYX0.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $468ce96392d8cfa6$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $468ce96392d8cfa6$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $468ce96392d8cfa6$export$55ce6f3a06c59543,
        light: $468ce96392d8cfa6$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $e45KD.default)((0, $dy3ak.default)({
        // A collection of common colors.
        common: (0, $dy3ak.default)({}, (0, $5hroS.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $2GAx0.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRequire.register("4qbW1", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $3382d92704bf7554$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $3382d92704bf7554$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "darken", function () { return $3382d92704bf7554$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $3382d92704bf7554$export$c0816ed86df316af; });

var $hBYX0 = parcelRequire("hBYX0");
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $3382d92704bf7554$var$clamp(value, min = 0, max = 1) {
    return Math.min(Math.max(min, value), max);
}
function $3382d92704bf7554$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $3382d92704bf7554$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $3382d92704bf7554$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $3382d92704bf7554$export$677b39864803984e($3382d92704bf7554$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $hBYX0.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $hBYX0.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $3382d92704bf7554$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $3382d92704bf7554$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $3382d92704bf7554$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $3382d92704bf7554$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $3382d92704bf7554$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $3382d92704bf7554$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $3382d92704bf7554$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$3382d92704bf7554$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $3382d92704bf7554$export$29fb7152bd3f781a(color) {
    color = $3382d92704bf7554$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $3382d92704bf7554$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $3382d92704bf7554$export$c852d90bf7403b62(color) {
    color = $3382d92704bf7554$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $3382d92704bf7554$export$677b39864803984e($3382d92704bf7554$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $3382d92704bf7554$export$d061e26956a60b0a(foreground, background) {
    const lumA = $3382d92704bf7554$export$c852d90bf7403b62(foreground);
    const lumB = $3382d92704bf7554$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $3382d92704bf7554$export$58f0f39f63f3cf42(color, value) {
    color = $3382d92704bf7554$export$677b39864803984e(color);
    value = $3382d92704bf7554$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $3382d92704bf7554$export$211a73f2b8c10ce4(color);
}
function $3382d92704bf7554$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $3382d92704bf7554$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $3382d92704bf7554$export$4b073707ff63303(color, coefficient) {
    color = $3382d92704bf7554$export$677b39864803984e(color);
    coefficient = $3382d92704bf7554$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $3382d92704bf7554$export$211a73f2b8c10ce4(color);
}
function $3382d92704bf7554$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $3382d92704bf7554$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $3382d92704bf7554$export$c0816ed86df316af(color, coefficient) {
    color = $3382d92704bf7554$export$677b39864803984e(color);
    coefficient = $3382d92704bf7554$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $3382d92704bf7554$export$211a73f2b8c10ce4(color);
}
function $3382d92704bf7554$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $3382d92704bf7554$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $3382d92704bf7554$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $3382d92704bf7554$export$c852d90bf7403b62(color) > 0.5 ? $3382d92704bf7554$export$4b073707ff63303(color, coefficient) : $3382d92704bf7554$export$c0816ed86df316af(color, coefficient);
}
function $3382d92704bf7554$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $3382d92704bf7554$export$11bb74ba10c85505(color, coefficient);
    } catch (error) {
        return color;
    }
}

});

parcelRequire.register("5hroS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d83cb616848900d$export$2e2bcd8739ae039; });
const $3d83cb616848900d$var$common = {
    black: "#000",
    white: "#fff"
};
var $3d83cb616848900d$export$2e2bcd8739ae039 = $3d83cb616848900d$var$common;

});

parcelRequire.register("2GAx0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f4bd766f2fb0f9f$export$2e2bcd8739ae039; });
const $1f4bd766f2fb0f9f$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $1f4bd766f2fb0f9f$export$2e2bcd8739ae039 = $1f4bd766f2fb0f9f$var$grey;

});

parcelRequire.register("7OD2X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b0b7dca8a456ba5$export$2e2bcd8739ae039; });
const $5b0b7dca8a456ba5$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $5b0b7dca8a456ba5$export$2e2bcd8739ae039 = $5b0b7dca8a456ba5$var$purple;

});

parcelRequire.register("eDF6e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa8496b425fa2feb$export$2e2bcd8739ae039; });
const $aa8496b425fa2feb$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $aa8496b425fa2feb$export$2e2bcd8739ae039 = $aa8496b425fa2feb$var$red;

});

parcelRequire.register("aeuld", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7732bf4e558d679e$export$2e2bcd8739ae039; });
const $7732bf4e558d679e$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $7732bf4e558d679e$export$2e2bcd8739ae039 = $7732bf4e558d679e$var$orange;

});

parcelRequire.register("1uqik", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $115cfd56c4edbb96$export$2e2bcd8739ae039; });
const $115cfd56c4edbb96$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $115cfd56c4edbb96$export$2e2bcd8739ae039 = $115cfd56c4edbb96$var$blue;

});

parcelRequire.register("3v0H4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28c4ce1f7058ff7d$export$2e2bcd8739ae039; });
const $28c4ce1f7058ff7d$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $28c4ce1f7058ff7d$export$2e2bcd8739ae039 = $28c4ce1f7058ff7d$var$lightBlue;

});

parcelRequire.register("iYDfH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd0c474360bd0456$export$2e2bcd8739ae039; });
const $dd0c474360bd0456$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $dd0c474360bd0456$export$2e2bcd8739ae039 = $dd0c474360bd0456$var$green;

});


parcelRequire.register("1P4IP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $153e378ad4d1fab6$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $4GC5s = parcelRequire("4GC5s");

var $e45KD = parcelRequire("e45KD");
const $153e378ad4d1fab6$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $153e378ad4d1fab6$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $153e378ad4d1fab6$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $153e378ad4d1fab6$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $153e378ad4d1fab6$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $153e378ad4d1fab6$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $4GC5s.default)(_ref, $153e378ad4d1fab6$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $dy3ak.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $153e378ad4d1fab6$var$defaultFontFamily ? {
            letterSpacing: `${$153e378ad4d1fab6$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $153e378ad4d1fab6$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $153e378ad4d1fab6$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $e45KD.default)((0, $dy3ak.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRequire.register("cjeji", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f625c197e85800f$export$2e2bcd8739ae039; });
const $8f625c197e85800f$var$shadowKeyUmbraOpacity = 0.2;
const $8f625c197e85800f$var$shadowKeyPenumbraOpacity = 0.14;
const $8f625c197e85800f$var$shadowAmbientShadowOpacity = 0.12;
function $8f625c197e85800f$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$8f625c197e85800f$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$8f625c197e85800f$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$8f625c197e85800f$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $8f625c197e85800f$var$shadows = [
    "none",
    $8f625c197e85800f$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $8f625c197e85800f$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $8f625c197e85800f$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $8f625c197e85800f$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $8f625c197e85800f$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $8f625c197e85800f$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $8f625c197e85800f$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $8f625c197e85800f$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $8f625c197e85800f$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $8f625c197e85800f$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $8f625c197e85800f$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $8f625c197e85800f$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $8f625c197e85800f$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $8f625c197e85800f$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $8f625c197e85800f$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $8f625c197e85800f$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $8f625c197e85800f$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $8f625c197e85800f$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $8f625c197e85800f$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $8f625c197e85800f$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $8f625c197e85800f$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $8f625c197e85800f$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $8f625c197e85800f$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $8f625c197e85800f$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $8f625c197e85800f$export$2e2bcd8739ae039 = $8f625c197e85800f$var$shadows;

});

parcelRequire.register("i9mNo", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $d36abffae3f35161$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $d36abffae3f35161$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");
const $d36abffae3f35161$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $d36abffae3f35161$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $d36abffae3f35161$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $d36abffae3f35161$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $d36abffae3f35161$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $d36abffae3f35161$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $dy3ak.default)({}, $d36abffae3f35161$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $dy3ak.default)({}, $d36abffae3f35161$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $4GC5s.default)(options, $d36abffae3f35161$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $d36abffae3f35161$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $d36abffae3f35161$var$formatMs(delay)}`).join(",");
    };
    return (0, $dy3ak.default)({
        getAutoHeightDuration: $d36abffae3f35161$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRequire.register("eNYil", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac746997ef84e7a6$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $ac746997ef84e7a6$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $ac746997ef84e7a6$export$2e2bcd8739ae039 = $ac746997ef84e7a6$var$zIndex;

});



parcelRequire.register("bsF6d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $858230afc8904614$export$2e2bcd8739ae039; });
var $858230afc8904614$export$2e2bcd8739ae039 = "$$material";

});


parcelRequire.register("gx04x", function(module, exports) {

$parcel$export(module.exports, "rootShouldForwardProp", function () { return $c08fc8bb071af6f9$export$effb20ecdbf4d6aa; });
$parcel$export(module.exports, "slotShouldForwardProp", function () { return $c08fc8bb071af6f9$export$f10c5a10d27438e5; });
$parcel$export(module.exports, "default", function () { return $c08fc8bb071af6f9$export$2e2bcd8739ae039; });

var $f6SmR = parcelRequire("f6SmR");

var $fQJH6 = parcelRequire("fQJH6");

var $bsF6d = parcelRequire("bsF6d");
"use client";
const $c08fc8bb071af6f9$export$effb20ecdbf4d6aa = (prop)=>(0, $f6SmR.shouldForwardProp)(prop) && prop !== "classes";
const $c08fc8bb071af6f9$export$f10c5a10d27438e5 = (0, $f6SmR.shouldForwardProp);
const $c08fc8bb071af6f9$var$styled = (0, $f6SmR.default)({
    themeId: (0, $bsF6d.default),
    defaultTheme: $fQJH6.default,
    rootShouldForwardProp: $c08fc8bb071af6f9$export$effb20ecdbf4d6aa
});
var $c08fc8bb071af6f9$export$2e2bcd8739ae039 = $c08fc8bb071af6f9$var$styled;

});
parcelRequire.register("f6SmR", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", function () { return $b00196d34fd56438$export$3ba67b570e26eea0; });
$parcel$export(module.exports, "default", function () { return $b00196d34fd56438$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $cgzo3 = parcelRequire("cgzo3");


var $1N2hm = parcelRequire("1N2hm");

var $eMhfc = parcelRequire("eMhfc");

var $fb2C7 = parcelRequire("fb2C7");
const $b00196d34fd56438$var$_excluded = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $b00196d34fd56438$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $b00196d34fd56438$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
const $b00196d34fd56438$var$getStyleOverrides = (name, theme)=>{
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) return theme.components[name].styleOverrides;
    return null;
};
const $b00196d34fd56438$var$getVariantStyles = (name, theme)=>{
    let variants = [];
    if (theme && theme.components && theme.components[name] && theme.components[name].variants) variants = theme.components[name].variants;
    const variantsStyles = {};
    variants.forEach((definition)=>{
        const key = (0, $eMhfc.default)(definition.props);
        variantsStyles[key] = definition.style;
    });
    return variantsStyles;
};
const $b00196d34fd56438$var$variantsResolver = (props, styles, theme, name)=>{
    var _theme$components;
    const { ownerState: ownerState = {} } = props;
    const variantsStyles = [];
    const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[name]) == null ? void 0 : _theme$components.variants;
    if (themeVariants) themeVariants.forEach((themeVariant)=>{
        let isMatch = true;
        Object.keys(themeVariant.props).forEach((key)=>{
            if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) isMatch = false;
        });
        if (isMatch) variantsStyles.push(styles[(0, $eMhfc.default)(themeVariant.props)]);
    });
    return variantsStyles;
};
function $b00196d34fd56438$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $b00196d34fd56438$export$35e57303dbd8a66 = (0, $1N2hm.default)();
const $b00196d34fd56438$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $b00196d34fd56438$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $b00196d34fd56438$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $b00196d34fd56438$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $b00196d34fd56438$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $b00196d34fd56438$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $b00196d34fd56438$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $b00196d34fd56438$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $fb2C7.default)((0, $dy3ak.default)({}, props, {
            theme: $b00196d34fd56438$var$resolveTheme((0, $dy3ak.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $cgzo3.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $b00196d34fd56438$var$defaultOverridesResolver($b00196d34fd56438$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $4GC5s.default)(inputOptions, $b00196d34fd56438$var$_excluded);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $b00196d34fd56438$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($b00196d34fd56438$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $cgzo3.default)(tag, (0, $dy3ak.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const muiStyledResolver = (styleArg, ...expressions)=>{
            const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg)=>{
                // On the server Emotion doesn't use React.forwardRef for creating components, so the created
                // component stays as a function. This condition makes sure that we do not interpolate functions
                // which are basically components used as a selectors.
                return typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg ? (props)=>{
                    return stylesArg((0, $dy3ak.default)({}, props, {
                        theme: $b00196d34fd56438$var$resolveTheme((0, $dy3ak.default)({}, props, {
                            defaultTheme: defaultTheme,
                            themeId: themeId
                        }))
                    }));
                } : stylesArg;
            }) : [];
            let transformedStyleArg = styleArg;
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $b00196d34fd56438$var$resolveTheme((0, $dy3ak.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const styleOverrides = $b00196d34fd56438$var$getStyleOverrides(componentName, theme);
                if (styleOverrides) {
                    const resolvedStyleOverrides = {};
                    Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                        resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle((0, $dy3ak.default)({}, props, {
                            theme: theme
                        })) : slotStyle;
                    });
                    return overridesResolver(props, resolvedStyleOverrides);
                }
                return null;
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $b00196d34fd56438$var$resolveTheme((0, $dy3ak.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                return $b00196d34fd56438$var$variantsResolver(props, $b00196d34fd56438$var$getVariantStyles(componentName, theme), theme, componentName);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            } else if (typeof styleArg === "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            styleArg.__emotion_real !== styleArg) // If the type is function, we need to define the default theme.
            transformedStyleArg = (props)=>styleArg((0, $dy3ak.default)({}, props, {
                    theme: $b00196d34fd56438$var$resolveTheme((0, $dy3ak.default)({}, props, {
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    }))
                }));
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRequire.register("cgzo3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ee26dc0b27d108a$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $8ee26dc0b27d108a$export$e00380445f2b9e0c; });
/**
 * @mui/styled-engine v5.14.10
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $l7WOd = parcelRequire("l7WOd");
parcelRequire("03csL");
var $iJMyi = parcelRequire("iJMyi");
var $03csL = parcelRequire("03csL");


var $57r6Z = parcelRequire("57r6Z");
"use client";
function $8ee26dc0b27d108a$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $l7WOd.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $8ee26dc0b27d108a$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRequire.register("l7WOd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f617deaa99ee4258$export$2e2bcd8739ae039; });

var $fq4PH = parcelRequire("fq4PH");
parcelRequire("3hJMF");
parcelRequire("aOChP");
parcelRequire("1qHcS");

parcelRequire("5Bkr0");
parcelRequire("gyMrz");
parcelRequire("enaS9");
var $f617deaa99ee4258$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $f617deaa99ee4258$export$2e2bcd8739ae039 = (0, $fq4PH.default).bind();
$f617deaa99ee4258$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $f617deaa99ee4258$export$2e2bcd8739ae039[tagName] = $f617deaa99ee4258$export$2e2bcd8739ae039(tagName);
});

});
parcelRequire.register("fq4PH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b39d08714c752ba2$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");

var $1qHcS = parcelRequire("1qHcS");
parcelRequire("03csL");
var $iJMyi = parcelRequire("iJMyi");

var $5Bkr0 = parcelRequire("5Bkr0");

var $gyMrz = parcelRequire("gyMrz");

var $enaS9 = parcelRequire("enaS9");
var $b39d08714c752ba2$var$testOmitPropsOnStringTag = (0, $1qHcS.default);
var $b39d08714c752ba2$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $b39d08714c752ba2$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $b39d08714c752ba2$var$testOmitPropsOnStringTag : $b39d08714c752ba2$var$testOmitPropsOnComponent;
};
var $b39d08714c752ba2$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $b39d08714c752ba2$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $b39d08714c752ba2$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $5Bkr0.registerStyles)(cache, serialized, isStringTag);
    (0, $enaS9.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $5Bkr0.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $b39d08714c752ba2$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $b39d08714c752ba2$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $b39d08714c752ba2$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $iJMyi.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $aOChP.useContext((0, $iJMyi.T));
            }
            if (typeof props.className === "string") className = (0, $5Bkr0.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $gyMrz.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $b39d08714c752ba2$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $aOChP.createElement($aOChP.Fragment, null, /*#__PURE__*/ $aOChP.createElement($b39d08714c752ba2$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $aOChP.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $dy3ak.default)({}, options, nextOptions, {
                shouldForwardProp: $b39d08714c752ba2$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRequire.register("1qHcS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10a9bc1a01862509$export$2e2bcd8739ae039; });

var $cgP8G = parcelRequire("cgP8G");
var $10a9bc1a01862509$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $10a9bc1a01862509$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $cgP8G.default)(function(prop) {
    return $10a9bc1a01862509$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRequire.register("57r6Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ba2a302cc56a696$export$2e2bcd8739ae039; });
parcelRequire("aOChP");


var $03csL = parcelRequire("03csL");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
function $3ba2a302cc56a696$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $3ba2a302cc56a696$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($3ba2a302cc56a696$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $03csL.Global), {
        styles: globalStyles
    });
}

});


parcelRequire.register("eMhfc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac22ecbbea1cd854$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $iOMXr = parcelRequire("iOMXr");
const $ac22ecbbea1cd854$var$_excluded = [
    "variant"
];
function $ac22ecbbea1cd854$var$isEmpty(string) {
    return string.length === 0;
}
function $ac22ecbbea1cd854$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $4GC5s.default)(props, $ac22ecbbea1cd854$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $ac22ecbbea1cd854$var$isEmpty(classKey) ? props[key] : (0, $iOMXr.default)(props[key]);
        else classKey += `${$ac22ecbbea1cd854$var$isEmpty(classKey) ? key : (0, $iOMXr.default)(key)}${(0, $iOMXr.default)(props[key].toString())}`;
    });
    return classKey;
}

});



parcelRequire.register("iUx46", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $dc471b032b68ceab$export$c7c50641356bdfa5; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $dc471b032b68ceab$export$c7c50641356bdfa5(slot) {
    return (0, $924xM.default)("MuiSvgIcon", slot);
}
const $dc471b032b68ceab$var$svgIconClasses = (0, $83lmX.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $dc471b032b68ceab$export$2e2bcd8739ae039 = $dc471b032b68ceab$var$svgIconClasses;

});
parcelRequire.register("83lmX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5dcf2e071acfc207$export$2e2bcd8739ae039; });

var $924xM = parcelRequire("924xM");
function $5dcf2e071acfc207$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $924xM.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRequire.register("924xM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6937d3422a2e3318$export$2e2bcd8739ae039; });

var $dZarm = parcelRequire("dZarm");
// If GlobalStateSlot is changed, GLOBAL_STATE_CLASSES in
// \packages\api-docs-builder\utils\parseSlotsAndClasses.ts must be updated accordingly.
const $6937d3422a2e3318$var$globalStateClassesMapping = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $6937d3422a2e3318$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $6937d3422a2e3318$var$globalStateClassesMapping[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $dZarm.default).generate(componentName)}-${slot}`;
}

});
parcelRequire.register("dZarm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2e9121331f64925$export$2e2bcd8739ae039; });
const $a2e9121331f64925$var$defaultGenerator = (componentName)=>componentName;
const $a2e9121331f64925$var$createClassNameGenerator = ()=>{
    let generate = $a2e9121331f64925$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $a2e9121331f64925$var$defaultGenerator;
        }
    };
};
const $a2e9121331f64925$var$ClassNameGenerator = $a2e9121331f64925$var$createClassNameGenerator();
var $a2e9121331f64925$export$2e2bcd8739ae039 = $a2e9121331f64925$var$ClassNameGenerator;

});








parcelRequire.register("jymi1", function(module, exports) {
"use strict";
"use client";

var $4SO8W = parcelRequire("4SO8W");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e3c27b90a0cda85a$var$_createSvgIcon = $4SO8W((parcelRequire("agsGj")));

var $5Wgfu = parcelRequire("5Wgfu");
var $e3c27b90a0cda85a$var$_default = (0, $e3c27b90a0cda85a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $5Wgfu.jsx)("path", {
    d: "M13 3h-2v10h2V3zm4.83 2.17-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z"
}), "PowerSettingsNew");
module.exports.default = $e3c27b90a0cda85a$var$_default;

});

parcelRequire.register("hOJyT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf8a72c6ee7f19c8$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");

var $dhOhi = parcelRequire("dhOhi");

var $gx04x = parcelRequire("gx04x");

var $6XlHG = parcelRequire("6XlHG");

var $lUjh9 = parcelRequire("lUjh9");

var $9C0Ps = parcelRequire("9C0Ps");

var $byLhc = parcelRequire("byLhc");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $cf8a72c6ee7f19c8$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $cf8a72c6ee7f19c8$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $lUjh9.default)(color)}`,
            `position${(0, $lUjh9.default)(position)}`
        ]
    };
    return (0, $dhOhi.default)(slots, (0, $byLhc.getAppBarUtilityClass), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $cf8a72c6ee7f19c8$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(")", "")}, ${var2})` : var2;
const $cf8a72c6ee7f19c8$var$AppBarRoot = (0, $gx04x.default)((0, $9C0Ps.default), {
    name: "MuiAppBar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $lUjh9.default)(ownerState.position)}`],
            styles[`color${(0, $lUjh9.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $dy3ak.default)({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === "fixed" && {
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0,
        "@media print": {
            // Prevent the app bar to be visible on each printed page.
            position: "absolute"
        }
    }, ownerState.position === "absolute" && {
        position: "absolute",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "sticky" && {
        // ⚠️ sticky is not supported by IE11.
        position: "sticky",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "static" && {
        position: "static"
    }, ownerState.position === "relative" && {
        position: "relative"
    }, !theme.vars && (0, $dy3ak.default)({}, ownerState.color === "default" && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== "default" && ownerState.color !== "inherit" && ownerState.color !== "transparent" && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, theme.palette.mode === "dark" && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === "transparent" && (0, $dy3ak.default)({
        backgroundColor: "transparent",
        color: "inherit"
    }, theme.palette.mode === "dark" && {
        backgroundImage: "none"
    })), theme.vars && (0, $dy3ak.default)({}, ownerState.color === "default" && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $cf8a72c6ee7f19c8$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $cf8a72c6ee7f19c8$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $cf8a72c6ee7f19c8$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $cf8a72c6ee7f19c8$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, {
        backgroundColor: "var(--AppBar-background)",
        color: ownerState.color === "inherit" ? "inherit" : "var(--AppBar-color)"
    }, ownerState.color === "transparent" && {
        backgroundImage: "none",
        backgroundColor: "transparent",
        color: "inherit"
    }));
});
const $cf8a72c6ee7f19c8$var$AppBar = /*#__PURE__*/ $aOChP.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiAppBar"
    });
    const { className: className, color: color = "primary", enableColorOnDark: enableColorOnDark = false, position: position = "fixed" } = props, other = (0, $4GC5s.default)(props, $cf8a72c6ee7f19c8$var$_excluded);
    const ownerState = (0, $dy3ak.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $cf8a72c6ee7f19c8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $5Wgfu.jsx)($cf8a72c6ee7f19c8$var$AppBarRoot, (0, $dy3ak.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $gVoqA.default)(classes.root, className, position === "fixed" && "mui-fixed"),
        ref: ref
    }, other));
});
var $cf8a72c6ee7f19c8$export$2e2bcd8739ae039 = $cf8a72c6ee7f19c8$var$AppBar;

});
parcelRequire.register("9C0Ps", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ff84e4a50679e54$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");


var $dhOhi = parcelRequire("dhOhi");

var $4qbW1 = parcelRequire("4qbW1");

var $gx04x = parcelRequire("gx04x");

var $7Qf4W = parcelRequire("7Qf4W");

var $6XlHG = parcelRequire("6XlHG");


var $5itE4 = parcelRequire("5itE4");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $6ff84e4a50679e54$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $6ff84e4a50679e54$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $dhOhi.default)(slots, (0, $5itE4.getPaperUtilityClass), classes);
};
const $6ff84e4a50679e54$var$PaperRoot = (0, $gx04x.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $dy3ak.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $dy3ak.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $4qbW1.alpha)("#fff", (0, $7Qf4W.default)(ownerState.elevation))}, ${(0, $4qbW1.alpha)("#fff", (0, $7Qf4W.default)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $6ff84e4a50679e54$var$Paper = /*#__PURE__*/ $aOChP.forwardRef(function Paper(inProps, ref) {
    const props = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $4GC5s.default)(props, $6ff84e4a50679e54$var$_excluded);
    const ownerState = (0, $dy3ak.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $6ff84e4a50679e54$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $5Wgfu.jsx)($6ff84e4a50679e54$var$PaperRoot, (0, $dy3ak.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $gVoqA.default)(classes.root, className),
        ref: ref
    }, other));
});
var $6ff84e4a50679e54$export$2e2bcd8739ae039 = $6ff84e4a50679e54$var$Paper;

});
parcelRequire.register("7Qf4W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b59160db93f6c4c$export$2e2bcd8739ae039; });
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $5b59160db93f6c4c$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $5b59160db93f6c4c$export$2e2bcd8739ae039 = $5b59160db93f6c4c$var$getOverlayAlpha;

});

parcelRequire.register("5itE4", function(module, exports) {

$parcel$export(module.exports, "getPaperUtilityClass", function () { return $3db5a1216475c6c9$export$29cdb466b9b6f20b; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $3db5a1216475c6c9$export$29cdb466b9b6f20b(slot) {
    return (0, $924xM.default)("MuiPaper", slot);
}
const $3db5a1216475c6c9$var$paperClasses = (0, $83lmX.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $3db5a1216475c6c9$export$2e2bcd8739ae039 = $3db5a1216475c6c9$var$paperClasses;

});


parcelRequire.register("byLhc", function(module, exports) {

$parcel$export(module.exports, "getAppBarUtilityClass", function () { return $86a78ad0bcdcbdb1$export$47a2da616e55e8e9; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $86a78ad0bcdcbdb1$export$47a2da616e55e8e9(slot) {
    return (0, $924xM.default)("MuiAppBar", slot);
}
const $86a78ad0bcdcbdb1$var$appBarClasses = (0, $83lmX.default)("MuiAppBar", [
    "root",
    "positionFixed",
    "positionAbsolute",
    "positionSticky",
    "positionStatic",
    "positionRelative",
    "colorDefault",
    "colorPrimary",
    "colorSecondary",
    "colorInherit",
    "colorTransparent"
]);
var $86a78ad0bcdcbdb1$export$2e2bcd8739ae039 = $86a78ad0bcdcbdb1$var$appBarClasses;

});


parcelRequire.register("7N6WB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0176bffbcd081433$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");

var $dhOhi = parcelRequire("dhOhi");

var $gx04x = parcelRequire("gx04x");

var $6XlHG = parcelRequire("6XlHG");

var $eIyhB = parcelRequire("eIyhB");

var $8MoTe = parcelRequire("8MoTe");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $0176bffbcd081433$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $0176bffbcd081433$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            colorDefault && "colorDefault"
        ],
        img: [
            "img"
        ],
        fallback: [
            "fallback"
        ]
    };
    return (0, $dhOhi.default)(slots, (0, $8MoTe.getAvatarUtilityClass), classes);
};
const $0176bffbcd081433$var$AvatarRoot = (0, $gx04x.default)("div", {
    name: "MuiAvatar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $dy3ak.default)({
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: "50%",
        overflow: "hidden",
        userSelect: "none"
    }, ownerState.variant === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.variant === "square" && {
        borderRadius: 0
    }, ownerState.colorDefault && (0, $dy3ak.default)({
        color: (theme.vars || theme).palette.background.default
    }, theme.vars ? {
        backgroundColor: theme.vars.palette.Avatar.defaultBg
    } : {
        backgroundColor: theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[600]
    })));
const $0176bffbcd081433$var$AvatarImg = (0, $gx04x.default)("img", {
    name: "MuiAvatar",
    slot: "Img",
    overridesResolver: (props, styles)=>styles.img
})({
    width: "100%",
    height: "100%",
    textAlign: "center",
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: "cover",
    // Hide alt text.
    color: "transparent",
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $0176bffbcd081433$var$AvatarFallback = (0, $gx04x.default)((0, $eIyhB.default), {
    name: "MuiAvatar",
    slot: "Fallback",
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: "75%",
    height: "75%"
});
function $0176bffbcd081433$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $aOChP.useState(false);
    $aOChP.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded("loaded");
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded("error");
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $0176bffbcd081433$var$Avatar = /*#__PURE__*/ $aOChP.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiAvatar"
    });
    const { alt: alt, children: childrenProp, className: className, component: component = "div", imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = "circular" } = props, other = (0, $4GC5s.default)(props, $0176bffbcd081433$var$_excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $0176bffbcd081433$var$useLoaded((0, $dy3ak.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== "error";
    const ownerState = (0, $dy3ak.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $0176bffbcd081433$var$useUtilityClasses(ownerState);
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $5Wgfu.jsx)($0176bffbcd081433$var$AvatarImg, (0, $dy3ak.default)({
        alt: alt,
        srcSet: srcSet,
        src: src,
        sizes: sizes,
        ownerState: ownerState,
        className: classes.img
    }, imgProps));
    else if (childrenProp != null) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $5Wgfu.jsx)($0176bffbcd081433$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $5Wgfu.jsx)($0176bffbcd081433$var$AvatarRoot, (0, $dy3ak.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $gVoqA.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $0176bffbcd081433$export$2e2bcd8739ae039 = $0176bffbcd081433$var$Avatar;

});
parcelRequire.register("eIyhB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab6fc4a4e2af7c52$export$2e2bcd8739ae039; });
parcelRequire("aOChP");

var $awJsl = parcelRequire("awJsl");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
var $ab6fc4a4e2af7c52$export$2e2bcd8739ae039 = (0, $awJsl.default)(/*#__PURE__*/ (0, $5Wgfu.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");

});

parcelRequire.register("8MoTe", function(module, exports) {

$parcel$export(module.exports, "getAvatarUtilityClass", function () { return $66461d05774a813c$export$ffd560f22c0ecf04; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $66461d05774a813c$export$ffd560f22c0ecf04(slot) {
    return (0, $924xM.default)("MuiAvatar", slot);
}
const $66461d05774a813c$var$avatarClasses = (0, $83lmX.default)("MuiAvatar", [
    "root",
    "colorDefault",
    "circular",
    "rounded",
    "square",
    "img",
    "fallback"
]);
var $66461d05774a813c$export$2e2bcd8739ae039 = $66461d05774a813c$var$avatarClasses;

});


parcelRequire.register("7hR8K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54e3576cf3db3015$export$2e2bcd8739ae039; });

var $H0IFL = parcelRequire("H0IFL");


var $dZarm = parcelRequire("dZarm");

var $gGIFv = parcelRequire("gGIFv");

var $bsF6d = parcelRequire("bsF6d");
"use client";
const $54e3576cf3db3015$var$defaultTheme = (0, $gGIFv.default)();
const $54e3576cf3db3015$var$Box = (0, $H0IFL.default)({
    themeId: (0, $bsF6d.default),
    defaultTheme: $54e3576cf3db3015$var$defaultTheme,
    defaultClassName: "MuiBox-root",
    generateClassName: (0, $dZarm.default).generate
});
var $54e3576cf3db3015$export$2e2bcd8739ae039 = $54e3576cf3db3015$var$Box;

});
parcelRequire.register("H0IFL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08149326624e4b85$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $4GC5s = parcelRequire("4GC5s");

var $aOChP = parcelRequire("aOChP");

var $gVoqA = parcelRequire("gVoqA");

var $cgzo3 = parcelRequire("cgzo3");

var $fb2C7 = parcelRequire("fb2C7");
var $0ctWP = parcelRequire("0ctWP");

var $kwVyI = parcelRequire("kwVyI");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $08149326624e4b85$var$_excluded = [
    "className",
    "component"
];
function $08149326624e4b85$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $cgzo3.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $fb2C7.default));
    const Box = /*#__PURE__*/ $aOChP.forwardRef(function Box(inProps, ref) {
        const theme = (0, $kwVyI.default)(defaultTheme);
        const _extendSxProp = (0, $0ctWP.default)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $4GC5s.default)(_extendSxProp, $08149326624e4b85$var$_excluded);
        return /*#__PURE__*/ (0, $5Wgfu.jsx)(BoxRoot, (0, $dy3ak.default)({
            as: component,
            ref: ref,
            className: (0, $gVoqA.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}

});
parcelRequire.register("0ctWP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0009aedf7f452ec9$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $4GC5s = parcelRequire("4GC5s");

var $e45KD = parcelRequire("e45KD");

var $2gPhR = parcelRequire("2gPhR");
const $0009aedf7f452ec9$var$_excluded = [
    "sx"
];
const $0009aedf7f452ec9$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $2gPhR.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $0009aedf7f452ec9$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $4GC5s.default)(props, $0009aedf7f452ec9$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $0009aedf7f452ec9$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $e45KD.isPlainObject)(result)) return systemProps;
        return (0, $dy3ak.default)({}, systemProps, result);
    };
    else finalSx = (0, $dy3ak.default)({}, systemProps, inSx);
    return (0, $dy3ak.default)({}, otherProps, {
        sx: finalSx
    });
}

});



parcelRequire.register("2J1NG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fc12e3c28d41fb0$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");


var $dhOhi = parcelRequire("dhOhi");

var $4qbW1 = parcelRequire("4qbW1");

var $gx04x = parcelRequire("gx04x");

var $6XlHG = parcelRequire("6XlHG");

var $d1dx4 = parcelRequire("d1dx4");

var $lUjh9 = parcelRequire("lUjh9");

var $1KOo5 = parcelRequire("1KOo5");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $1fc12e3c28d41fb0$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $1fc12e3c28d41fb0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $lUjh9.default)(color)}`,
            edge && `edge${(0, $lUjh9.default)(edge)}`,
            `size${(0, $lUjh9.default)(size)}`
        ]
    };
    return (0, $dhOhi.default)(slots, (0, $1KOo5.getIconButtonUtilityClass), classes);
};
const $1fc12e3c28d41fb0$var$IconButtonRoot = (0, $gx04x.default)((0, $d1dx4.default), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $lUjh9.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $lUjh9.default)(ownerState.edge)}`],
            styles[`size${(0, $lUjh9.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $dy3ak.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4qbW1.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $dy3ak.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $dy3ak.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $dy3ak.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4qbW1.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $1KOo5.default).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $1fc12e3c28d41fb0$var$IconButton = /*#__PURE__*/ $aOChP.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $4GC5s.default)(props, $1fc12e3c28d41fb0$var$_excluded);
    const ownerState = (0, $dy3ak.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $1fc12e3c28d41fb0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $5Wgfu.jsx)($1fc12e3c28d41fb0$var$IconButtonRoot, (0, $dy3ak.default)({
        className: (0, $gVoqA.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children
    }));
});
var $1fc12e3c28d41fb0$export$2e2bcd8739ae039 = $1fc12e3c28d41fb0$var$IconButton;

});
parcelRequire.register("d1dx4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97a5dd9a02b15774$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $4GC5s = parcelRequire("4GC5s");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");


var $dhOhi = parcelRequire("dhOhi");

var $gx04x = parcelRequire("gx04x");

var $6XlHG = parcelRequire("6XlHG");

var $4w8df = parcelRequire("4w8df");

var $bjOFd = parcelRequire("bjOFd");

var $aAoqW = parcelRequire("aAoqW");

var $5pecE = parcelRequire("5pecE");

var $buoTs = parcelRequire("buoTs");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $97a5dd9a02b15774$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $97a5dd9a02b15774$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $dhOhi.default)(slots, (0, $buoTs.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $97a5dd9a02b15774$export$7ec0dcc5e3cdcd36 = (0, $gx04x.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $buoTs.default).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $97a5dd9a02b15774$var$ButtonBase = /*#__PURE__*/ $aOChP.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $4GC5s.default)(props, $97a5dd9a02b15774$var$_excluded);
    const buttonRef = $aOChP.useRef(null);
    const rippleRef = $aOChP.useRef(null);
    const handleRippleRef = (0, $4w8df.default)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $aAoqW.default)();
    const [focusVisible, setFocusVisible] = $aOChP.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $aOChP.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $aOChP.useState(false);
    $aOChP.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $aOChP.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $bjOFd.default)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $bjOFd.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $aOChP.useRef(false);
    const handleKeyDown = (0, $bjOFd.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $bjOFd.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $4w8df.default)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $dy3ak.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $97a5dd9a02b15774$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)($97a5dd9a02b15774$export$7ec0dcc5e3cdcd36, (0, $dy3ak.default)({
        as: ComponentProp,
        className: (0, $gVoqA.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $5Wgfu.jsx)((0, $5pecE.default), (0, $dy3ak.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $97a5dd9a02b15774$export$2e2bcd8739ae039 = $97a5dd9a02b15774$var$ButtonBase;

});
parcelRequire.register("4w8df", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34a08577478a72a4$export$2e2bcd8739ae039; });

var $bKnSm = parcelRequire("bKnSm");
"use client";
var $34a08577478a72a4$export$2e2bcd8739ae039 = (0, $bKnSm.default);

});
parcelRequire.register("bKnSm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88d682d5f843b8f0$export$2e2bcd8739ae039; });

var $aOChP = parcelRequire("aOChP");

var $hIwMs = parcelRequire("hIwMs");
"use client";
function $88d682d5f843b8f0$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $aOChP.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $hIwMs.default)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});
parcelRequire.register("hIwMs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce5ff94b18f79b2f$export$2e2bcd8739ae039; });
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $ce5ff94b18f79b2f$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}

});



parcelRequire.register("bjOFd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83d8c4d190a9e145$export$2e2bcd8739ae039; });

var $cPD1N = parcelRequire("cPD1N");
"use client";
var $83d8c4d190a9e145$export$2e2bcd8739ae039 = (0, $cPD1N.default);

});
parcelRequire.register("cPD1N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9578859bd242eb1b$export$2e2bcd8739ae039; });

var $aOChP = parcelRequire("aOChP");

var $4Vm6n = parcelRequire("4Vm6n");
"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $9578859bd242eb1b$var$useEventCallback(fn) {
    const ref = $aOChP.useRef(fn);
    (0, $4Vm6n.default)(()=>{
        ref.current = fn;
    });
    return $aOChP.useCallback((...args)=>// @ts-expect-error hide `this`
        // tslint:disable-next-line:ban-comma-operator
        (0, ref.current)(...args), []);
}
var $9578859bd242eb1b$export$2e2bcd8739ae039 = $9578859bd242eb1b$var$useEventCallback;

});
parcelRequire.register("4Vm6n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $395da148d5c480bc$export$2e2bcd8739ae039; });

var $aOChP = parcelRequire("aOChP");
"use client";
const $395da148d5c480bc$var$useEnhancedEffect = typeof window !== "undefined" ? $aOChP.useLayoutEffect : $aOChP.useEffect;
var $395da148d5c480bc$export$2e2bcd8739ae039 = $395da148d5c480bc$var$useEnhancedEffect;

});



parcelRequire.register("aAoqW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b503825e8efdf47$export$2e2bcd8739ae039; });

var $5Tp8Y = parcelRequire("5Tp8Y");
"use client";
var $7b503825e8efdf47$export$2e2bcd8739ae039 = (0, $5Tp8Y.default);

});
parcelRequire.register("5Tp8Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44a597d5b0992dda$export$2e2bcd8739ae039; });

var $aOChP = parcelRequire("aOChP");
"use client";
let $44a597d5b0992dda$var$hadKeyboardEvent = true;
let $44a597d5b0992dda$var$hadFocusVisibleRecently = false;
let $44a597d5b0992dda$var$hadFocusVisibleRecentlyTimeout;
const $44a597d5b0992dda$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $44a597d5b0992dda$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $44a597d5b0992dda$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $44a597d5b0992dda$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $44a597d5b0992dda$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $44a597d5b0992dda$var$handlePointerDown() {
    $44a597d5b0992dda$var$hadKeyboardEvent = false;
}
function $44a597d5b0992dda$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($44a597d5b0992dda$var$hadFocusVisibleRecently) $44a597d5b0992dda$var$hadKeyboardEvent = true;
    }
}
function $44a597d5b0992dda$var$prepare(doc) {
    doc.addEventListener("keydown", $44a597d5b0992dda$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $44a597d5b0992dda$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $44a597d5b0992dda$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $44a597d5b0992dda$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $44a597d5b0992dda$var$handleVisibilityChange, true);
}
function $44a597d5b0992dda$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $44a597d5b0992dda$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $44a597d5b0992dda$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $44a597d5b0992dda$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $44a597d5b0992dda$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $44a597d5b0992dda$var$handleVisibilityChange, true);
}
function $44a597d5b0992dda$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $44a597d5b0992dda$var$hadKeyboardEvent || $44a597d5b0992dda$var$focusTriggersKeyboardModality(target);
}
function $44a597d5b0992dda$export$2e2bcd8739ae039() {
    const ref = $aOChP.useCallback((node)=>{
        if (node != null) $44a597d5b0992dda$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $aOChP.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $44a597d5b0992dda$var$hadFocusVisibleRecently = true;
            window.clearTimeout($44a597d5b0992dda$var$hadFocusVisibleRecentlyTimeout);
            $44a597d5b0992dda$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(()=>{
                $44a597d5b0992dda$var$hadFocusVisibleRecently = false;
            }, 100);
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($44a597d5b0992dda$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}

});


parcelRequire.register("5pecE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3efa4dfeb8115621$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $4GC5s = parcelRequire("4GC5s");

var $aOChP = parcelRequire("aOChP");


var $fUhpw = parcelRequire("fUhpw");

var $gVoqA = parcelRequire("gVoqA");

var $03csL = parcelRequire("03csL");

var $gx04x = parcelRequire("gx04x");

var $6XlHG = parcelRequire("6XlHG");

var $1qhFU = parcelRequire("1qhFU");

var $6kruU = parcelRequire("6kruU");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $3efa4dfeb8115621$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $3efa4dfeb8115621$var$_ = (t)=>t, $3efa4dfeb8115621$var$_t, $3efa4dfeb8115621$var$_t2, $3efa4dfeb8115621$var$_t3, $3efa4dfeb8115621$var$_t4;
const $3efa4dfeb8115621$var$DURATION = 550;
const $3efa4dfeb8115621$export$95d0c9356b2231a3 = 80;
const $3efa4dfeb8115621$var$enterKeyframe = (0, $03csL.keyframes)($3efa4dfeb8115621$var$_t || ($3efa4dfeb8115621$var$_t = $3efa4dfeb8115621$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $3efa4dfeb8115621$var$exitKeyframe = (0, $03csL.keyframes)($3efa4dfeb8115621$var$_t2 || ($3efa4dfeb8115621$var$_t2 = $3efa4dfeb8115621$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $3efa4dfeb8115621$var$pulsateKeyframe = (0, $03csL.keyframes)($3efa4dfeb8115621$var$_t3 || ($3efa4dfeb8115621$var$_t3 = $3efa4dfeb8115621$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $3efa4dfeb8115621$export$f6b7418508c72c25 = (0, $gx04x.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $3efa4dfeb8115621$export$676cfe7b12693c4b = (0, $gx04x.default)((0, $1qhFU.default), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($3efa4dfeb8115621$var$_t4 || ($3efa4dfeb8115621$var$_t4 = $3efa4dfeb8115621$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $6kruU.default).rippleVisible, $3efa4dfeb8115621$var$enterKeyframe, $3efa4dfeb8115621$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $6kruU.default).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $6kruU.default).child, (0, $6kruU.default).childLeaving, $3efa4dfeb8115621$var$exitKeyframe, $3efa4dfeb8115621$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $6kruU.default).childPulsate, $3efa4dfeb8115621$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $3efa4dfeb8115621$var$TouchRipple = /*#__PURE__*/ $aOChP.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $4GC5s.default)(props, $3efa4dfeb8115621$var$_excluded);
    const [ripples, setRipples] = $aOChP.useState([]);
    const nextKey = $aOChP.useRef(0);
    const rippleCallback = $aOChP.useRef(null);
    $aOChP.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $aOChP.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = $aOChP.useRef(0);
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $aOChP.useRef(null);
    const container = $aOChP.useRef(null);
    $aOChP.useEffect(()=>{
        return ()=>{
            if (startTimer.current) clearTimeout(startTimer.current);
        };
    }, []);
    const startCommit = $aOChP.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $5Wgfu.jsx)($3efa4dfeb8115621$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $gVoqA.default)(classes.ripple, (0, $6kruU.default).ripple),
                        rippleVisible: (0, $gVoqA.default)(classes.rippleVisible, (0, $6kruU.default).rippleVisible),
                        ripplePulsate: (0, $gVoqA.default)(classes.ripplePulsate, (0, $6kruU.default).ripplePulsate),
                        child: (0, $gVoqA.default)(classes.child, (0, $6kruU.default).child),
                        childLeaving: (0, $gVoqA.default)(classes.childLeaving, (0, $6kruU.default).childLeaving),
                        childPulsate: (0, $gVoqA.default)(classes.childPulsate, (0, $6kruU.default).childPulsate)
                    },
                    timeout: $3efa4dfeb8115621$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $aOChP.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $3efa4dfeb8115621$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    const pulsate = $aOChP.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $aOChP.useCallback((event, cb)=>{
        clearTimeout(startTimer.current);
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $aOChP.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $5Wgfu.jsx)($3efa4dfeb8115621$export$f6b7418508c72c25, (0, $dy3ak.default)({
        className: (0, $gVoqA.default)((0, $6kruU.default).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $fUhpw.default), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $3efa4dfeb8115621$export$2e2bcd8739ae039 = $3efa4dfeb8115621$var$TouchRipple;

});
parcelRequire.register("fUhpw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9499762d40bcba6$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $ioJlR = parcelRequire("ioJlR");

var $gt0RB = parcelRequire("gt0RB");


var $aOChP = parcelRequire("aOChP");

var $cLCzc = parcelRequire("cLCzc");

var $kngCg = parcelRequire("kngCg");
var $b9499762d40bcba6$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $b9499762d40bcba6$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $b9499762d40bcba6$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $gt0RB.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $ioJlR.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $kngCg.getInitialChildMapping)(nextProps, handleExited) : (0, $kngCg.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $kngCg.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $dy3ak.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $4GC5s.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $b9499762d40bcba6$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement((0, $cLCzc.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement((0, $cLCzc.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).Component);
$b9499762d40bcba6$var$TransitionGroup.propTypes = {};
$b9499762d40bcba6$var$TransitionGroup.defaultProps = $b9499762d40bcba6$var$defaultProps;
var $b9499762d40bcba6$export$2e2bcd8739ae039 = $b9499762d40bcba6$var$TransitionGroup;

});
parcelRequire.register("ioJlR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d64da5c95dfd1b9e$export$2e2bcd8739ae039; });
function $d64da5c95dfd1b9e$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRequire.register("gt0RB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfd00641b3ea9a8c$export$2e2bcd8739ae039; });

var $ii7xU = parcelRequire("ii7xU");
function $bfd00641b3ea9a8c$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $ii7xU.default)(subClass, superClass);
}

});
parcelRequire.register("ii7xU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d50fc2eae9655c5f$export$2e2bcd8739ae039; });
function $d50fc2eae9655c5f$export$2e2bcd8739ae039(o, p) {
    $d50fc2eae9655c5f$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d50fc2eae9655c5f$export$2e2bcd8739ae039(o, p);
}

});


parcelRequire.register("cLCzc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94b7ca65d1339b4c$export$2e2bcd8739ae039; });

var $aOChP = parcelRequire("aOChP");
var $94b7ca65d1339b4c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createContext(null);

});

parcelRequire.register("kngCg", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $ed52d846396a8bb0$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $ed52d846396a8bb0$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $ed52d846396a8bb0$export$36fd1af28d383ec0; });

var $aOChP = parcelRequire("aOChP");
function $ed52d846396a8bb0$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $aOChP.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $aOChP.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $ed52d846396a8bb0$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $ed52d846396a8bb0$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $ed52d846396a8bb0$export$fa71e2345c31d7a2(props, onExited) {
    return $ed52d846396a8bb0$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $aOChP.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $ed52d846396a8bb0$var$getProp(child, "appear", props),
            enter: $ed52d846396a8bb0$var$getProp(child, "enter", props),
            exit: $ed52d846396a8bb0$var$getProp(child, "exit", props)
        });
    });
}
function $ed52d846396a8bb0$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $ed52d846396a8bb0$export$bbc8a025727ea824(nextProps.children);
    var children = $ed52d846396a8bb0$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $aOChP.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $aOChP.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $aOChP.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $ed52d846396a8bb0$var$getProp(child, "exit", nextProps),
            enter: $ed52d846396a8bb0$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $aOChP.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $aOChP.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $aOChP.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $ed52d846396a8bb0$var$getProp(child, "exit", nextProps),
            enter: $ed52d846396a8bb0$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});


parcelRequire.register("1qhFU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1095ee0dcf9d7aee$export$2e2bcd8739ae039; });

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
function $1095ee0dcf9d7aee$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $aOChP.useState(false);
    const rippleClassName = (0, $gVoqA.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $gVoqA.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $aOChP.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $5Wgfu.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $5Wgfu.jsx)("span", {
            className: childClassName
        })
    });
}
var $1095ee0dcf9d7aee$export$2e2bcd8739ae039 = $1095ee0dcf9d7aee$var$Ripple;

});

parcelRequire.register("6kruU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49b9f0c7169556d1$export$2e2bcd8739ae039; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $49b9f0c7169556d1$export$b464606f735ab902(slot) {
    return (0, $924xM.default)("MuiTouchRipple", slot);
}
const $49b9f0c7169556d1$var$touchRippleClasses = (0, $83lmX.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $49b9f0c7169556d1$export$2e2bcd8739ae039 = $49b9f0c7169556d1$var$touchRippleClasses;

});


parcelRequire.register("buoTs", function(module, exports) {

$parcel$export(module.exports, "getButtonBaseUtilityClass", function () { return $85d5ce5e294c3780$export$fccb0498dcd99783; });
$parcel$export(module.exports, "default", function () { return $85d5ce5e294c3780$export$2e2bcd8739ae039; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $85d5ce5e294c3780$export$fccb0498dcd99783(slot) {
    return (0, $924xM.default)("MuiButtonBase", slot);
}
const $85d5ce5e294c3780$var$buttonBaseClasses = (0, $83lmX.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $85d5ce5e294c3780$export$2e2bcd8739ae039 = $85d5ce5e294c3780$var$buttonBaseClasses;

});


parcelRequire.register("1KOo5", function(module, exports) {

$parcel$export(module.exports, "getIconButtonUtilityClass", function () { return $14712c3a3ab2ce40$export$5e8702d71474f093; });
$parcel$export(module.exports, "default", function () { return $14712c3a3ab2ce40$export$2e2bcd8739ae039; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $14712c3a3ab2ce40$export$5e8702d71474f093(slot) {
    return (0, $924xM.default)("MuiIconButton", slot);
}
const $14712c3a3ab2ce40$var$iconButtonClasses = (0, $83lmX.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $14712c3a3ab2ce40$export$2e2bcd8739ae039 = $14712c3a3ab2ce40$var$iconButtonClasses;

});


parcelRequire.register("3k1mL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26b44c9f931726a4$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");

var $0ctWP = parcelRequire("0ctWP");

var $dhOhi = parcelRequire("dhOhi");

var $gx04x = parcelRequire("gx04x");

var $6XlHG = parcelRequire("6XlHG");

var $lUjh9 = parcelRequire("lUjh9");

var $2M2vc = parcelRequire("2M2vc");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $26b44c9f931726a4$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $26b44c9f931726a4$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $lUjh9.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $dhOhi.default)(slots, (0, $2M2vc.getTypographyUtilityClass), classes);
};
const $26b44c9f931726a4$export$140e2f5526d3cad8 = (0, $gx04x.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $lUjh9.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $dy3ak.default)({
        margin: 0
    }, ownerState.variant === "inherit" && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit"
    }, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $26b44c9f931726a4$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $26b44c9f931726a4$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $26b44c9f931726a4$var$transformDeprecatedColors = (color)=>{
    return $26b44c9f931726a4$var$colorTransformations[color] || color;
};
const $26b44c9f931726a4$var$Typography = /*#__PURE__*/ $aOChP.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $26b44c9f931726a4$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $0ctWP.default)((0, $dy3ak.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $26b44c9f931726a4$var$defaultVariantMapping } = props, other = (0, $4GC5s.default)(props, $26b44c9f931726a4$var$_excluded);
    const ownerState = (0, $dy3ak.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $26b44c9f931726a4$var$defaultVariantMapping[variant]) || "span";
    const classes = $26b44c9f931726a4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $5Wgfu.jsx)($26b44c9f931726a4$export$140e2f5526d3cad8, (0, $dy3ak.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $gVoqA.default)(classes.root, className)
    }, other));
});
var $26b44c9f931726a4$export$2e2bcd8739ae039 = $26b44c9f931726a4$var$Typography;

});
parcelRequire.register("2M2vc", function(module, exports) {

$parcel$export(module.exports, "getTypographyUtilityClass", function () { return $205201590933daa7$export$24c1f8f60cbac79e; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $205201590933daa7$export$24c1f8f60cbac79e(slot) {
    return (0, $924xM.default)("MuiTypography", slot);
}
const $205201590933daa7$var$typographyClasses = (0, $83lmX.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $205201590933daa7$export$2e2bcd8739ae039 = $205201590933daa7$var$typographyClasses;

});


parcelRequire.register("6SiPo", function(module, exports) {

$parcel$export(module.exports, "createBrowserRouter", function () { return $5016641478f75324$export$1f3f55432a00e06d; });
$parcel$export(module.exports, "Link", function () { return $5016641478f75324$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "NavLink", function () { return $5016641478f75324$export$b0d92dbee9b5b60d; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("aKZsc")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("aKZsc")).useNavigate; });
/**
 * React Router DOM v6.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aOChP = parcelRequire("aOChP");

var $2ROCz = parcelRequire("2ROCz");
var $aKZsc = parcelRequire("aKZsc");

var $2ROCz = parcelRequire("2ROCz");
function $5016641478f75324$var$_extends() {
    $5016641478f75324$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5016641478f75324$var$_extends.apply(this, arguments);
}
function $5016641478f75324$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $5016641478f75324$var$defaultMethod = "get";
const $5016641478f75324$var$defaultEncType = "application/x-www-form-urlencoded";
function $5016641478f75324$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $5016641478f75324$var$isButtonElement(object) {
    return $5016641478f75324$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $5016641478f75324$var$isFormElement(object) {
    return $5016641478f75324$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $5016641478f75324$var$isInputElement(object) {
    return $5016641478f75324$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $5016641478f75324$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $5016641478f75324$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$5016641478f75324$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $5016641478f75324$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $5016641478f75324$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $5016641478f75324$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $5016641478f75324$var$_formDataSupportsSubmitter = null;
function $5016641478f75324$var$isFormDataSubmitterSupported() {
    if ($5016641478f75324$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $5016641478f75324$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $5016641478f75324$var$_formDataSupportsSubmitter = true;
    }
    return $5016641478f75324$var$_formDataSupportsSubmitter;
}
const $5016641478f75324$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $5016641478f75324$var$getFormEncType(encType) {
    if (encType != null && !$5016641478f75324$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $5016641478f75324$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($5016641478f75324$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $2ROCz.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $5016641478f75324$var$defaultMethod;
        encType = $5016641478f75324$var$getFormEncType(target.getAttribute("enctype")) || $5016641478f75324$var$defaultEncType;
        formData = new FormData(target);
    } else if ($5016641478f75324$var$isButtonElement(target) || $5016641478f75324$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $2ROCz.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $5016641478f75324$var$defaultMethod;
        encType = $5016641478f75324$var$getFormEncType(target.getAttribute("formenctype")) || $5016641478f75324$var$getFormEncType(form.getAttribute("enctype")) || $5016641478f75324$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$5016641478f75324$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($5016641478f75324$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $5016641478f75324$var$defaultMethod;
        action = null;
        encType = $5016641478f75324$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $5016641478f75324$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $5016641478f75324$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $5016641478f75324$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset"
];
function $5016641478f75324$export$1f3f55432a00e06d(routes, opts) {
    return (0, $2ROCz.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $5016641478f75324$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2ROCz.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $5016641478f75324$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aKZsc.UNSAFE_mapRouteProperties)
    }).initialize();
}
function $5016641478f75324$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $2ROCz.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $5016641478f75324$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2ROCz.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $5016641478f75324$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aKZsc.UNSAFE_mapRouteProperties)
    }).initialize();
}
function $5016641478f75324$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $5016641478f75324$var$_extends({}, state, {
        errors: $5016641478f75324$var$deserializeErrors(state.errors)
    });
    return state;
}
function $5016641478f75324$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $2ROCz.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $5016641478f75324$var$START_TRANSITION = "startTransition";
const $5016641478f75324$var$startTransitionImpl = $aOChP[$5016641478f75324$var$START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $5016641478f75324$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref;
    let historyRef = $aOChP.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2ROCz.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aOChP.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aOChP.useCallback((newState)=>{
        v7_startTransition && $5016641478f75324$var$startTransitionImpl ? $5016641478f75324$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aOChP.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $aOChP.createElement((0, $aKZsc.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $5016641478f75324$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref2;
    let historyRef = $aOChP.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2ROCz.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aOChP.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aOChP.useCallback((newState)=>{
        v7_startTransition && $5016641478f75324$var$startTransitionImpl ? $5016641478f75324$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aOChP.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $aOChP.createElement((0, $aKZsc.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $5016641478f75324$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, future: future, history: history } = _ref3;
    let [state, setStateImpl] = $aOChP.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aOChP.useCallback((newState)=>{
        v7_startTransition && $5016641478f75324$var$startTransitionImpl ? $5016641478f75324$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aOChP.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $aOChP.createElement((0, $aKZsc.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $5016641478f75324$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $5016641478f75324$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $5016641478f75324$export$a6c7ac8248d6e38a = /*#__PURE__*/ $aOChP.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $5016641478f75324$var$_objectWithoutPropertiesLoose(_ref4, $5016641478f75324$var$_excluded);
    let { basename: basename } = $aOChP.useContext((0, $aKZsc.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $5016641478f75324$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($5016641478f75324$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $2ROCz.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $aKZsc.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $5016641478f75324$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $aOChP.createElement("a", $5016641478f75324$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $5016641478f75324$export$b0d92dbee9b5b60d = /*#__PURE__*/ $aOChP.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $5016641478f75324$var$_objectWithoutPropertiesLoose(_ref5, $5016641478f75324$var$_excluded2);
    let path = (0, $aKZsc.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $aKZsc.useLocation)();
    let routerState = $aOChP.useContext((0, $aKZsc.UNSAFE_DataRouterStateContext));
    let { navigator: navigator } = $aOChP.useContext((0, $aKZsc.UNSAFE_NavigationContext));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $aOChP.createElement($5016641478f75324$export$a6c7ac8248d6e38a, $5016641478f75324$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $5016641478f75324$export$a7fed597f4b8afd8 = /*#__PURE__*/ $aOChP.forwardRef((props, ref)=>{
    let submit = $5016641478f75324$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $aOChP.createElement($5016641478f75324$var$FormImpl, $5016641478f75324$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
const $5016641478f75324$var$FormImpl = /*#__PURE__*/ $aOChP.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, state: state, method: method = $5016641478f75324$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $5016641478f75324$var$_objectWithoutPropertiesLoose(_ref6, $5016641478f75324$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $5016641478f75324$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $aOChP.createElement("form", $5016641478f75324$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $5016641478f75324$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $5016641478f75324$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $5016641478f75324$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($5016641478f75324$var$DataRouterHook || ($5016641478f75324$var$DataRouterHook = {}));
var $5016641478f75324$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($5016641478f75324$var$DataRouterStateHook || ($5016641478f75324$var$DataRouterStateHook = {}));
function $5016641478f75324$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $5016641478f75324$var$useDataRouterContext(hookName) {
    let ctx = $aOChP.useContext((0, $aKZsc.UNSAFE_DataRouterContext));
    !ctx && (0, $2ROCz.UNSAFE_invariant)(false);
    return ctx;
}
function $5016641478f75324$var$useDataRouterState(hookName) {
    let state = $aOChP.useContext((0, $aKZsc.UNSAFE_DataRouterStateContext));
    !state && (0, $2ROCz.UNSAFE_invariant)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $5016641478f75324$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $aKZsc.useNavigate)();
    let location = (0, $aKZsc.useLocation)();
    let path = (0, $aKZsc.useResolvedPath)(to, {
        relative: relative
    });
    return $aOChP.useCallback((event)=>{
        if ($5016641478f75324$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $2ROCz.createPath)(location) === (0, $2ROCz.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $5016641478f75324$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $aOChP.useRef($5016641478f75324$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $aOChP.useRef(false);
    let location = (0, $aKZsc.useLocation)();
    let searchParams = $aOChP.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $5016641478f75324$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $aKZsc.useNavigate)();
    let setSearchParams = $aOChP.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $5016641478f75324$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $5016641478f75324$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $5016641478f75324$export$47c85c6e3a081d3() {
    let { router: router } = $5016641478f75324$var$useDataRouterContext($5016641478f75324$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $aOChP.useContext((0, $aKZsc.UNSAFE_NavigationContext));
    let currentRouteId = (0, $aKZsc.UNSAFE_useRouteId)();
    return $aOChP.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $5016641478f75324$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $5016641478f75324$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $5016641478f75324$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $5016641478f75324$var$useDataRouterContext($5016641478f75324$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $aOChP.useContext((0, $aKZsc.UNSAFE_NavigationContext));
    return $aOChP.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $5016641478f75324$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $5016641478f75324$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $2ROCz.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $5016641478f75324$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $aOChP.useContext((0, $aKZsc.UNSAFE_NavigationContext));
    let routeContext = $aOChP.useContext((0, $aKZsc.UNSAFE_RouteContext));
    !routeContext && (0, $2ROCz.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $5016641478f75324$var$_extends({}, (0, $aKZsc.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $aKZsc.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2ROCz.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $2ROCz.createPath)(path);
}
function $5016641478f75324$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $aOChP.forwardRef((props, ref)=>{
        let submit = $5016641478f75324$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $aOChP.createElement($5016641478f75324$var$FormImpl, $5016641478f75324$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
let $5016641478f75324$var$fetcherId = 0;
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $5016641478f75324$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $5016641478f75324$var$useDataRouterContext($5016641478f75324$var$DataRouterHook.UseFetcher);
    let route = $aOChP.useContext((0, $aKZsc.UNSAFE_RouteContext));
    !route && (0, $2ROCz.UNSAFE_invariant)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $2ROCz.UNSAFE_invariant)(false);
    let [fetcherKey] = $aOChP.useState(()=>String(++$5016641478f75324$var$fetcherId));
    let [Form] = $aOChP.useState(()=>{
        !routeId && (0, $2ROCz.UNSAFE_invariant)(false);
        return $5016641478f75324$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $aOChP.useState(()=>(href)=>{
            !router && (0, $2ROCz.UNSAFE_invariant)(false);
            !routeId && (0, $2ROCz.UNSAFE_invariant)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $5016641478f75324$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $aOChP.useMemo(()=>$5016641478f75324$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $aOChP.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $5016641478f75324$export$fa996778a3a31087() {
    let state = $5016641478f75324$var$useDataRouterState($5016641478f75324$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $5016641478f75324$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $5016641478f75324$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $5016641478f75324$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $5016641478f75324$var$useDataRouterContext($5016641478f75324$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $5016641478f75324$var$useDataRouterState($5016641478f75324$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $aOChP.useContext((0, $aKZsc.UNSAFE_NavigationContext));
    let location = (0, $aKZsc.useLocation)();
    let matches = (0, $aKZsc.useMatches)();
    let navigation = (0, $aKZsc.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $aOChP.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $5016641478f75324$var$usePageHide($aOChP.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $5016641478f75324$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $5016641478f75324$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($5016641478f75324$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $aOChP.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $5016641478f75324$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $5016641478f75324$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $aOChP.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($5016641478f75324$var$_extends({}, location, {
                    pathname: (0, $2ROCz.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($5016641478f75324$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $aOChP.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $5016641478f75324$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $aOChP.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $5016641478f75324$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $aOChP.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $5016641478f75324$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $aKZsc.unstable_useBlocker)(when);
    $aOChP.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $aOChP.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}

});
parcelRequire.register("2ROCz", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $2167cc54b87f9d14$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $2167cc54b87f9d14$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $2167cc54b87f9d14$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $2167cc54b87f9d14$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $2167cc54b87f9d14$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $2167cc54b87f9d14$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $2167cc54b87f9d14$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $2167cc54b87f9d14$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $2167cc54b87f9d14$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $2167cc54b87f9d14$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $2167cc54b87f9d14$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $2167cc54b87f9d14$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getPathContributingMatches", function () { return $2167cc54b87f9d14$export$90ba53ce1c7fdff2; });
$parcel$export(module.exports, "resolveTo", function () { return $2167cc54b87f9d14$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $2167cc54b87f9d14$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $2167cc54b87f9d14$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $2167cc54b87f9d14$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $2167cc54b87f9d14$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $2167cc54b87f9d14$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.9.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $2167cc54b87f9d14$var$_extends() {
    $2167cc54b87f9d14$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2167cc54b87f9d14$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $2167cc54b87f9d14$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($2167cc54b87f9d14$export$e19cd5f9376f8cee || ($2167cc54b87f9d14$export$e19cd5f9376f8cee = {}));
const $2167cc54b87f9d14$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $2167cc54b87f9d14$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $2167cc54b87f9d14$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $2167cc54b87f9d14$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $2167cc54b87f9d14$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $2167cc54b87f9d14$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $2167cc54b87f9d14$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $2167cc54b87f9d14$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $2167cc54b87f9d14$export$fe53371bee54353d(to);
    }
    return $2167cc54b87f9d14$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $2167cc54b87f9d14$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $2167cc54b87f9d14$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $2167cc54b87f9d14$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $2167cc54b87f9d14$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $2167cc54b87f9d14$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $2167cc54b87f9d14$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $2167cc54b87f9d14$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $2167cc54b87f9d14$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $2167cc54b87f9d14$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $2167cc54b87f9d14$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $2167cc54b87f9d14$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $2167cc54b87f9d14$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $2167cc54b87f9d14$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $2167cc54b87f9d14$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $2167cc54b87f9d14$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $2167cc54b87f9d14$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $2167cc54b87f9d14$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($2167cc54b87f9d14$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Push;
        let location = $2167cc54b87f9d14$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $2167cc54b87f9d14$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Replace;
        let location = $2167cc54b87f9d14$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $2167cc54b87f9d14$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $2167cc54b87f9d14$export$fe53371bee54353d(to);
        $2167cc54b87f9d14$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($2167cc54b87f9d14$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($2167cc54b87f9d14$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $2167cc54b87f9d14$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($2167cc54b87f9d14$var$ResultType || ($2167cc54b87f9d14$var$ResultType = {}));
const $2167cc54b87f9d14$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $2167cc54b87f9d14$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $2167cc54b87f9d14$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $2167cc54b87f9d14$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $2167cc54b87f9d14$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($2167cc54b87f9d14$var$isIndexRoute(route)) {
            let indexRoute = $2167cc54b87f9d14$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $2167cc54b87f9d14$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $2167cc54b87f9d14$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $2167cc54b87f9d14$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $2167cc54b87f9d14$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $2167cc54b87f9d14$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $2167cc54b87f9d14$var$flattenRoutes(routes);
    $2167cc54b87f9d14$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $2167cc54b87f9d14$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $2167cc54b87f9d14$var$safelyDecodeURI(pathname));
    return matches;
}
function $2167cc54b87f9d14$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $2167cc54b87f9d14$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $2167cc54b87f9d14$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $2167cc54b87f9d14$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $2167cc54b87f9d14$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $2167cc54b87f9d14$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $2167cc54b87f9d14$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $2167cc54b87f9d14$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $2167cc54b87f9d14$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $2167cc54b87f9d14$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $2167cc54b87f9d14$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $2167cc54b87f9d14$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $2167cc54b87f9d14$var$paramRe = /^:\w+$/;
const $2167cc54b87f9d14$var$dynamicSegmentValue = 3;
const $2167cc54b87f9d14$var$indexRouteValue = 2;
const $2167cc54b87f9d14$var$emptySegmentValue = 1;
const $2167cc54b87f9d14$var$staticSegmentValue = 10;
const $2167cc54b87f9d14$var$splatPenalty = -2;
const $2167cc54b87f9d14$var$isSplat = (s)=>s === "*";
function $2167cc54b87f9d14$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($2167cc54b87f9d14$var$isSplat)) initialScore += $2167cc54b87f9d14$var$splatPenalty;
    if (index) initialScore += $2167cc54b87f9d14$var$indexRouteValue;
    return segments.filter((s)=>!$2167cc54b87f9d14$var$isSplat(s)).reduce((score, segment)=>score + ($2167cc54b87f9d14$var$paramRe.test(segment) ? $2167cc54b87f9d14$var$dynamicSegmentValue : segment === "" ? $2167cc54b87f9d14$var$emptySegmentValue : $2167cc54b87f9d14$var$staticSegmentValue), initialScore);
}
function $2167cc54b87f9d14$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $2167cc54b87f9d14$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $2167cc54b87f9d14$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $2167cc54b87f9d14$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $2167cc54b87f9d14$export$a5c6d149b50c1d86($2167cc54b87f9d14$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $2167cc54b87f9d14$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $2167cc54b87f9d14$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $2167cc54b87f9d14$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $2167cc54b87f9d14$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $2167cc54b87f9d14$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $2167cc54b87f9d14$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $2167cc54b87f9d14$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $2167cc54b87f9d14$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $2167cc54b87f9d14$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $2167cc54b87f9d14$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $2167cc54b87f9d14$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $2167cc54b87f9d14$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $2167cc54b87f9d14$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $2167cc54b87f9d14$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $2167cc54b87f9d14$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $2167cc54b87f9d14$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $2167cc54b87f9d14$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $2167cc54b87f9d14$var$normalizeSearch(search),
        hash: $2167cc54b87f9d14$var$normalizeHash(hash)
    };
}
function $2167cc54b87f9d14$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $2167cc54b87f9d14$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $2167cc54b87f9d14$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $2167cc54b87f9d14$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $2167cc54b87f9d14$export$8ccf933b0513f8d0(toArg);
    else {
        to = $2167cc54b87f9d14$var$_extends({}, toArg);
        $2167cc54b87f9d14$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $2167cc54b87f9d14$var$getInvalidPathError("?", "pathname", "search", to));
        $2167cc54b87f9d14$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $2167cc54b87f9d14$var$getInvalidPathError("#", "pathname", "hash", to));
        $2167cc54b87f9d14$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $2167cc54b87f9d14$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $2167cc54b87f9d14$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $2167cc54b87f9d14$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $2167cc54b87f9d14$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $2167cc54b87f9d14$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $2167cc54b87f9d14$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $2167cc54b87f9d14$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $2167cc54b87f9d14$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $2167cc54b87f9d14$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $2167cc54b87f9d14$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $2167cc54b87f9d14$export$42a99a7a4bc0e76a extends Error {
}
class $2167cc54b87f9d14$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $2167cc54b87f9d14$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $2167cc54b87f9d14$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $2167cc54b87f9d14$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $2167cc54b87f9d14$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $2167cc54b87f9d14$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $2167cc54b87f9d14$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $2167cc54b87f9d14$var$unwrapTrackedPromise(value) {
    if (!$2167cc54b87f9d14$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $2167cc54b87f9d14$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $2167cc54b87f9d14$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $2167cc54b87f9d14$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $2167cc54b87f9d14$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $2167cc54b87f9d14$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $2167cc54b87f9d14$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $2167cc54b87f9d14$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $2167cc54b87f9d14$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $2167cc54b87f9d14$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $2167cc54b87f9d14$var$validMutationMethods = new Set($2167cc54b87f9d14$var$validMutationMethodsArr);
const $2167cc54b87f9d14$var$validRequestMethodsArr = [
    "get",
    ...$2167cc54b87f9d14$var$validMutationMethodsArr
];
const $2167cc54b87f9d14$var$validRequestMethods = new Set($2167cc54b87f9d14$var$validRequestMethodsArr);
const $2167cc54b87f9d14$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $2167cc54b87f9d14$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $2167cc54b87f9d14$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $2167cc54b87f9d14$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $2167cc54b87f9d14$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $2167cc54b87f9d14$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $2167cc54b87f9d14$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $2167cc54b87f9d14$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $2167cc54b87f9d14$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $2167cc54b87f9d14$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $2167cc54b87f9d14$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $2167cc54b87f9d14$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $2167cc54b87f9d14$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $2167cc54b87f9d14$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $2167cc54b87f9d14$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $2167cc54b87f9d14$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $2167cc54b87f9d14$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $2167cc54b87f9d14$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($2167cc54b87f9d14$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $2167cc54b87f9d14$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $2167cc54b87f9d14$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $2167cc54b87f9d14$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $2167cc54b87f9d14$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $2167cc54b87f9d14$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $2167cc54b87f9d14$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $2167cc54b87f9d14$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $2167cc54b87f9d14$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        updateState($2167cc54b87f9d14$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $2167cc54b87f9d14$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }));
        // Reset stateful navigation vars
        pendingAction = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $2167cc54b87f9d14$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $2167cc54b87f9d14$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $2167cc54b87f9d14$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $2167cc54b87f9d14$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $2167cc54b87f9d14$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $2167cc54b87f9d14$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $2167cc54b87f9d14$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $2167cc54b87f9d14$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $2167cc54b87f9d14$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $2167cc54b87f9d14$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $2167cc54b87f9d14$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $2167cc54b87f9d14$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$2167cc54b87f9d14$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $2167cc54b87f9d14$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $2167cc54b87f9d14$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $2167cc54b87f9d14$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $2167cc54b87f9d14$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $2167cc54b87f9d14$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $2167cc54b87f9d14$var$ResultType.error,
            error: $2167cc54b87f9d14$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $2167cc54b87f9d14$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($2167cc54b87f9d14$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($2167cc54b87f9d14$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $2167cc54b87f9d14$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($2167cc54b87f9d14$var$isDeferredResult(result)) throw $2167cc54b87f9d14$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $2167cc54b87f9d14$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $2167cc54b87f9d14$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $2167cc54b87f9d14$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $2167cc54b87f9d14$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $2167cc54b87f9d14$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($2167cc54b87f9d14$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $2167cc54b87f9d14$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $2167cc54b87f9d14$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $2167cc54b87f9d14$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $2167cc54b87f9d14$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $2167cc54b87f9d14$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $2167cc54b87f9d14$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $2167cc54b87f9d14$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $2167cc54b87f9d14$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $2167cc54b87f9d14$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $2167cc54b87f9d14$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $2167cc54b87f9d14$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $2167cc54b87f9d14$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $2167cc54b87f9d14$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $2167cc54b87f9d14$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($2167cc54b87f9d14$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                let doneFetcher = $2167cc54b87f9d14$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                let loadingFetcher = $2167cc54b87f9d14$var$getLoadingFetcher(submission);
                state.fetchers.set(key, loadingFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($2167cc54b87f9d14$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($2167cc54b87f9d14$var$isDeferredResult(actionResult)) throw $2167cc54b87f9d14$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $2167cc54b87f9d14$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $2167cc54b87f9d14$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $2167cc54b87f9d14$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $2167cc54b87f9d14$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $2167cc54b87f9d14$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $2167cc54b87f9d14$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $2167cc54b87f9d14$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $2167cc54b87f9d14$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $2167cc54b87f9d14$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $2167cc54b87f9d14$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($2167cc54b87f9d14$var$_extends({
                errors: errors,
                loaderData: $2167cc54b87f9d14$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $2167cc54b87f9d14$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $2167cc54b87f9d14$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $2167cc54b87f9d14$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($2167cc54b87f9d14$var$isDeferredResult(result)) result = await $2167cc54b87f9d14$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($2167cc54b87f9d14$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                let doneFetcher = $2167cc54b87f9d14$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($2167cc54b87f9d14$var$isErrorResult(result)) {
            let boundaryMatch = $2167cc54b87f9d14$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $2167cc54b87f9d14$export$3e9cee6b33872309(!$2167cc54b87f9d14$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $2167cc54b87f9d14$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $2167cc54b87f9d14$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $2167cc54b87f9d14$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($2167cc54b87f9d14$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $2167cc54b87f9d14$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $2167cc54b87f9d14$export$e19cd5f9376f8cee.Replace : $2167cc54b87f9d14$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $2167cc54b87f9d14$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($2167cc54b87f9d14$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $2167cc54b87f9d14$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $2167cc54b87f9d14$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $2167cc54b87f9d14$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$2167cc54b87f9d14$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $2167cc54b87f9d14$var$callLoaderOrAction("loader", $2167cc54b87f9d14$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $2167cc54b87f9d14$var$ResultType.error,
                        error: $2167cc54b87f9d14$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $2167cc54b87f9d14$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $2167cc54b87f9d14$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $2167cc54b87f9d14$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $2167cc54b87f9d14$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $2167cc54b87f9d14$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $2167cc54b87f9d14$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $2167cc54b87f9d14$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $2167cc54b87f9d14$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $2167cc54b87f9d14$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $2167cc54b87f9d14$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $2167cc54b87f9d14$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $2167cc54b87f9d14$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$2167cc54b87f9d14$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $2167cc54b87f9d14$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $2167cc54b87f9d14$export$4d0306f8f6a4585b = Symbol("deferred");
function $2167cc54b87f9d14$export$3336b097a6fbc59a(routes, opts) {
    $2167cc54b87f9d14$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $2167cc54b87f9d14$var$defaultMapRouteProperties;
    let dataRoutes = $2167cc54b87f9d14$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $2167cc54b87f9d14$var$createLocation("", $2167cc54b87f9d14$export$fe53371bee54353d(url), null, "default");
        let matches = $2167cc54b87f9d14$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$2167cc54b87f9d14$var$isValidMethod(method) && method !== "HEAD") {
            let error = $2167cc54b87f9d14$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $2167cc54b87f9d14$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $2167cc54b87f9d14$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $2167cc54b87f9d14$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($2167cc54b87f9d14$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $2167cc54b87f9d14$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $2167cc54b87f9d14$var$createLocation("", $2167cc54b87f9d14$export$fe53371bee54353d(url), null, "default");
        let matches = $2167cc54b87f9d14$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$2167cc54b87f9d14$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $2167cc54b87f9d14$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $2167cc54b87f9d14$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $2167cc54b87f9d14$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $2167cc54b87f9d14$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $2167cc54b87f9d14$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($2167cc54b87f9d14$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$2167cc54b87f9d14$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $2167cc54b87f9d14$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($2167cc54b87f9d14$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $2167cc54b87f9d14$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $2167cc54b87f9d14$var$isResponse(result) ? result : $2167cc54b87f9d14$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($2167cc54b87f9d14$var$isQueryRouteResponse(e)) {
                if (e.type === $2167cc54b87f9d14$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($2167cc54b87f9d14$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $2167cc54b87f9d14$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $2167cc54b87f9d14$var$ResultType.error,
                error: error
            };
        } else {
            result = await $2167cc54b87f9d14$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($2167cc54b87f9d14$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($2167cc54b87f9d14$var$isDeferredResult(result)) {
            let error = $2167cc54b87f9d14$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $2167cc54b87f9d14$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($2167cc54b87f9d14$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($2167cc54b87f9d14$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $2167cc54b87f9d14$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $2167cc54b87f9d14$var$_extends({}, context, {
                statusCode: $2167cc54b87f9d14$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $2167cc54b87f9d14$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $2167cc54b87f9d14$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $2167cc54b87f9d14$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $2167cc54b87f9d14$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $2167cc54b87f9d14$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$2167cc54b87f9d14$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $2167cc54b87f9d14$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $2167cc54b87f9d14$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $2167cc54b87f9d14$export$fec11da027c70692(routes, context, error) {
    let newContext = $2167cc54b87f9d14$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $2167cc54b87f9d14$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $2167cc54b87f9d14$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $2167cc54b87f9d14$export$cae722b0cc860f13(to ? to : ".", $2167cc54b87f9d14$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $2167cc54b87f9d14$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$2167cc54b87f9d14$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $2167cc54b87f9d14$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $2167cc54b87f9d14$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $2167cc54b87f9d14$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$2167cc54b87f9d14$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$2167cc54b87f9d14$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $2167cc54b87f9d14$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $2167cc54b87f9d14$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $2167cc54b87f9d14$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$2167cc54b87f9d14$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$2167cc54b87f9d14$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $2167cc54b87f9d14$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $2167cc54b87f9d14$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $2167cc54b87f9d14$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $2167cc54b87f9d14$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $2167cc54b87f9d14$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($2167cc54b87f9d14$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $2167cc54b87f9d14$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $2167cc54b87f9d14$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $2167cc54b87f9d14$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $2167cc54b87f9d14$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $2167cc54b87f9d14$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $2167cc54b87f9d14$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($2167cc54b87f9d14$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $2167cc54b87f9d14$var$shouldRevalidateLoader(match, $2167cc54b87f9d14$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $2167cc54b87f9d14$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $2167cc54b87f9d14$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $2167cc54b87f9d14$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $2167cc54b87f9d14$var$shouldRevalidateLoader(fetcherMatch, $2167cc54b87f9d14$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $2167cc54b87f9d14$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $2167cc54b87f9d14$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $2167cc54b87f9d14$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $2167cc54b87f9d14$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $2167cc54b87f9d14$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $2167cc54b87f9d14$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$2167cc54b87f9d14$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $2167cc54b87f9d14$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $2167cc54b87f9d14$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $2167cc54b87f9d14$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $2167cc54b87f9d14$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $2167cc54b87f9d14$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $2167cc54b87f9d14$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $2167cc54b87f9d14$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $2167cc54b87f9d14$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $2167cc54b87f9d14$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($2167cc54b87f9d14$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($2167cc54b87f9d14$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $2167cc54b87f9d14$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$2167cc54b87f9d14$var$ABSOLUTE_URL_REGEX.test(location)) location = $2167cc54b87f9d14$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $2167cc54b87f9d14$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $2167cc54b87f9d14$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $2167cc54b87f9d14$var$ResultType.error ? $2167cc54b87f9d14$var$ResultType.error : $2167cc54b87f9d14$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $2167cc54b87f9d14$var$ResultType.error) return {
            type: resultType,
            error: new $2167cc54b87f9d14$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $2167cc54b87f9d14$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $2167cc54b87f9d14$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($2167cc54b87f9d14$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $2167cc54b87f9d14$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $2167cc54b87f9d14$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $2167cc54b87f9d14$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($2167cc54b87f9d14$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $2167cc54b87f9d14$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $2167cc54b87f9d14$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $2167cc54b87f9d14$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $2167cc54b87f9d14$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $2167cc54b87f9d14$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $2167cc54b87f9d14$export$3e9cee6b33872309(!$2167cc54b87f9d14$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($2167cc54b87f9d14$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $2167cc54b87f9d14$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $2167cc54b87f9d14$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($2167cc54b87f9d14$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $2167cc54b87f9d14$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $2167cc54b87f9d14$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $2167cc54b87f9d14$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($2167cc54b87f9d14$var$isErrorResult(result)) {
            let boundaryMatch = $2167cc54b87f9d14$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $2167cc54b87f9d14$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($2167cc54b87f9d14$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $2167cc54b87f9d14$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($2167cc54b87f9d14$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $2167cc54b87f9d14$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $2167cc54b87f9d14$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $2167cc54b87f9d14$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $2167cc54b87f9d14$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $2167cc54b87f9d14$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $2167cc54b87f9d14$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $2167cc54b87f9d14$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $2167cc54b87f9d14$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $2167cc54b87f9d14$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($2167cc54b87f9d14$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $2167cc54b87f9d14$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $2167cc54b87f9d14$export$8ccf933b0513f8d0(path) : path;
    return $2167cc54b87f9d14$export$fe53371bee54353d($2167cc54b87f9d14$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $2167cc54b87f9d14$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $2167cc54b87f9d14$var$isDeferredResult(result) {
    return result.type === $2167cc54b87f9d14$var$ResultType.deferred;
}
function $2167cc54b87f9d14$var$isErrorResult(result) {
    return result.type === $2167cc54b87f9d14$var$ResultType.error;
}
function $2167cc54b87f9d14$var$isRedirectResult(result) {
    return (result && result.type) === $2167cc54b87f9d14$var$ResultType.redirect;
}
function $2167cc54b87f9d14$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $2167cc54b87f9d14$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $2167cc54b87f9d14$var$isRedirectResponse(result) {
    if (!$2167cc54b87f9d14$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $2167cc54b87f9d14$var$isQueryRouteResponse(obj) {
    return obj && $2167cc54b87f9d14$var$isResponse(obj.response) && (obj.type === $2167cc54b87f9d14$var$ResultType.data || obj.type === $2167cc54b87f9d14$var$ResultType.error);
}
function $2167cc54b87f9d14$var$isValidMethod(method) {
    return $2167cc54b87f9d14$var$validRequestMethods.has(method.toLowerCase());
}
function $2167cc54b87f9d14$var$isMutationMethod(method) {
    return $2167cc54b87f9d14$var$validMutationMethods.has(method.toLowerCase());
}
async function $2167cc54b87f9d14$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$2167cc54b87f9d14$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($2167cc54b87f9d14$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $2167cc54b87f9d14$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $2167cc54b87f9d14$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $2167cc54b87f9d14$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $2167cc54b87f9d14$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $2167cc54b87f9d14$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $2167cc54b87f9d14$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $2167cc54b87f9d14$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $2167cc54b87f9d14$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $2167cc54b87f9d14$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $2167cc54b87f9d14$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $2167cc54b87f9d14$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $2167cc54b87f9d14$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $2167cc54b87f9d14$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $2167cc54b87f9d14$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $2167cc54b87f9d14$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $2167cc54b87f9d14$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $2167cc54b87f9d14$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}

});

parcelRequire.register("aKZsc", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $7d4ddebaad7c3ba2$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $7d4ddebaad7c3ba2$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $7d4ddebaad7c3ba2$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $7d4ddebaad7c3ba2$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $7d4ddebaad7c3ba2$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $7d4ddebaad7c3ba2$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $7d4ddebaad7c3ba2$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $7d4ddebaad7c3ba2$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $7d4ddebaad7c3ba2$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "useRouteError", function () { return $7d4ddebaad7c3ba2$export$ed527bf60f6e05f2; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $7d4ddebaad7c3ba2$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $7d4ddebaad7c3ba2$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $7d4ddebaad7c3ba2$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "unstable_useBlocker", function () { return $7d4ddebaad7c3ba2$export$2af03a1de5c0910; });
$parcel$export(module.exports, "RouterProvider", function () { return $7d4ddebaad7c3ba2$export$323e4fc2fa4753fb; });
$parcel$export(module.exports, "Router", function () { return $7d4ddebaad7c3ba2$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Outlet", function () { return $7d4ddebaad7c3ba2$export$910ae8079b2c2852; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $7d4ddebaad7c3ba2$export$52b333d321859367; });
/**
 * React Router v6.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aOChP = parcelRequire("aOChP");

var $2ROCz = parcelRequire("2ROCz");
function $7d4ddebaad7c3ba2$var$_extends() {
    $7d4ddebaad7c3ba2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7d4ddebaad7c3ba2$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7d4ddebaad7c3ba2$export$3add0d5dce533e2e = /*#__PURE__*/ $aOChP.createContext(null);
const $7d4ddebaad7c3ba2$export$145dfa71566a64dc = /*#__PURE__*/ $aOChP.createContext(null);
const $7d4ddebaad7c3ba2$var$AwaitContext = /*#__PURE__*/ $aOChP.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7d4ddebaad7c3ba2$export$26749e8557646306 = /*#__PURE__*/ $aOChP.createContext(null);
const $7d4ddebaad7c3ba2$export$c7914228fb69b0f5 = /*#__PURE__*/ $aOChP.createContext(null);
const $7d4ddebaad7c3ba2$export$9072aa6dd1f93057 = /*#__PURE__*/ $aOChP.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7d4ddebaad7c3ba2$var$RouteErrorContext = /*#__PURE__*/ $aOChP.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7d4ddebaad7c3ba2$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7d4ddebaad7c3ba2$export$9c954a9d03d32f4a() && (0, $2ROCz.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $aOChP.useContext($7d4ddebaad7c3ba2$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7d4ddebaad7c3ba2$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $2ROCz.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7d4ddebaad7c3ba2$export$9c954a9d03d32f4a() {
    return $aOChP.useContext($7d4ddebaad7c3ba2$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7d4ddebaad7c3ba2$export$45d76561a5302f2b() {
    !$7d4ddebaad7c3ba2$export$9c954a9d03d32f4a() && (0, $2ROCz.UNSAFE_invariant)(false);
    return $aOChP.useContext($7d4ddebaad7c3ba2$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7d4ddebaad7c3ba2$export$1b3f31771c5d07c() {
    return $aOChP.useContext($7d4ddebaad7c3ba2$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7d4ddebaad7c3ba2$export$6c330e8992e8a295(pattern) {
    !$7d4ddebaad7c3ba2$export$9c954a9d03d32f4a() && (0, $2ROCz.UNSAFE_invariant)(false);
    let { pathname: pathname } = $7d4ddebaad7c3ba2$export$45d76561a5302f2b();
    return $aOChP.useMemo(()=>(0, $2ROCz.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7d4ddebaad7c3ba2$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7d4ddebaad7c3ba2$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $aOChP.useContext($7d4ddebaad7c3ba2$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $aOChP.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7d4ddebaad7c3ba2$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $aOChP.useContext($7d4ddebaad7c3ba2$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7d4ddebaad7c3ba2$var$useNavigateStable() : $7d4ddebaad7c3ba2$var$useNavigateUnstable();
}
function $7d4ddebaad7c3ba2$var$useNavigateUnstable() {
    !$7d4ddebaad7c3ba2$export$9c954a9d03d32f4a() && (0, $2ROCz.UNSAFE_invariant)(false);
    let dataRouterContext = $aOChP.useContext($7d4ddebaad7c3ba2$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $aOChP.useContext($7d4ddebaad7c3ba2$export$26749e8557646306);
    let { matches: matches } = $aOChP.useContext($7d4ddebaad7c3ba2$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7d4ddebaad7c3ba2$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2ROCz.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    let activeRef = $aOChP.useRef(false);
    $7d4ddebaad7c3ba2$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $aOChP.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $2ROCz.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2ROCz.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7d4ddebaad7c3ba2$var$OutletContext = /*#__PURE__*/ $aOChP.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7d4ddebaad7c3ba2$export$4138103a3ae699cc() {
    return $aOChP.useContext($7d4ddebaad7c3ba2$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7d4ddebaad7c3ba2$export$a3be3530d8e40d0b(context) {
    let outlet = $aOChP.useContext($7d4ddebaad7c3ba2$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7d4ddebaad7c3ba2$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $aOChP.useContext($7d4ddebaad7c3ba2$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7d4ddebaad7c3ba2$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $aOChP.useContext($7d4ddebaad7c3ba2$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7d4ddebaad7c3ba2$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2ROCz.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    return $aOChP.useMemo(()=>(0, $2ROCz.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7d4ddebaad7c3ba2$export$5d3fca4a98652595(routes, locationArg) {
    return $7d4ddebaad7c3ba2$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7d4ddebaad7c3ba2$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$7d4ddebaad7c3ba2$export$9c954a9d03d32f4a() && (0, $2ROCz.UNSAFE_invariant)(false);
    let { navigator: navigator } = $aOChP.useContext($7d4ddebaad7c3ba2$export$26749e8557646306);
    let { matches: parentMatches } = $aOChP.useContext($7d4ddebaad7c3ba2$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7d4ddebaad7c3ba2$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $2ROCz.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $2ROCz.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $2ROCz.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7d4ddebaad7c3ba2$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $2ROCz.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $2ROCz.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7d4ddebaad7c3ba2$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $2ROCz.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7d4ddebaad7c3ba2$var$DefaultErrorComponent() {
    let error = $7d4ddebaad7c3ba2$export$ed527bf60f6e05f2();
    let message = (0, $2ROCz.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $aOChP.createElement($aOChP.Fragment, null, /*#__PURE__*/ $aOChP.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $aOChP.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $aOChP.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7d4ddebaad7c3ba2$var$defaultErrorElement = /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$var$DefaultErrorComponent, null);
class $7d4ddebaad7c3ba2$var$RenderErrorBoundary extends $aOChP.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7d4ddebaad7c3ba2$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $aOChP.useContext($7d4ddebaad7c3ba2$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7d4ddebaad7c3ba2$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $2ROCz.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $7d4ddebaad7c3ba2$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $aOChP.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7d4ddebaad7c3ba2$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7d4ddebaad7c3ba2$var$DataRouterHook || {});
var $7d4ddebaad7c3ba2$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7d4ddebaad7c3ba2$var$DataRouterStateHook || {});
function $7d4ddebaad7c3ba2$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7d4ddebaad7c3ba2$var$useDataRouterContext(hookName) {
    let ctx = $aOChP.useContext($7d4ddebaad7c3ba2$export$3add0d5dce533e2e);
    !ctx && (0, $2ROCz.UNSAFE_invariant)(false);
    return ctx;
}
function $7d4ddebaad7c3ba2$var$useDataRouterState(hookName) {
    let state = $aOChP.useContext($7d4ddebaad7c3ba2$export$145dfa71566a64dc);
    !state && (0, $2ROCz.UNSAFE_invariant)(false);
    return state;
}
function $7d4ddebaad7c3ba2$var$useRouteContext(hookName) {
    let route = $aOChP.useContext($7d4ddebaad7c3ba2$export$9072aa6dd1f93057);
    !route && (0, $2ROCz.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7d4ddebaad7c3ba2$var$useCurrentRouteId(hookName) {
    let route = $7d4ddebaad7c3ba2$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $2ROCz.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7d4ddebaad7c3ba2$export$5fc8298006ad9e58() {
    return $7d4ddebaad7c3ba2$var$useCurrentRouteId($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7d4ddebaad7c3ba2$export$d0fd4b7106de2769() {
    let state = $7d4ddebaad7c3ba2$var$useDataRouterState($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7d4ddebaad7c3ba2$export$600dc272ed516c15() {
    let dataRouterContext = $7d4ddebaad7c3ba2$var$useDataRouterContext($7d4ddebaad7c3ba2$var$DataRouterHook.UseRevalidator);
    let state = $7d4ddebaad7c3ba2$var$useDataRouterState($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseRevalidator);
    return $aOChP.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7d4ddebaad7c3ba2$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7d4ddebaad7c3ba2$var$useDataRouterState($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseMatches);
    return $aOChP.useMemo(()=>matches.map((m)=>(0, $2ROCz.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7d4ddebaad7c3ba2$export$1448a5050d252c4d() {
    let state = $7d4ddebaad7c3ba2$var$useDataRouterState($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7d4ddebaad7c3ba2$var$useCurrentRouteId($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7d4ddebaad7c3ba2$export$fd5d37484eab868d(routeId) {
    let state = $7d4ddebaad7c3ba2$var$useDataRouterState($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7d4ddebaad7c3ba2$export$fdc00f3f26066d5e() {
    let state = $7d4ddebaad7c3ba2$var$useDataRouterState($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseActionData);
    let route = $aOChP.useContext($7d4ddebaad7c3ba2$export$9072aa6dd1f93057);
    !route && (0, $2ROCz.UNSAFE_invariant)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7d4ddebaad7c3ba2$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $aOChP.useContext($7d4ddebaad7c3ba2$var$RouteErrorContext);
    let state = $7d4ddebaad7c3ba2$var$useDataRouterState($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseRouteError);
    let routeId = $7d4ddebaad7c3ba2$var$useCurrentRouteId($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $7d4ddebaad7c3ba2$export$78a72ddb39bdd145() {
    let value = $aOChP.useContext($7d4ddebaad7c3ba2$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $7d4ddebaad7c3ba2$export$17f53340677d5831() {
    let value = $aOChP.useContext($7d4ddebaad7c3ba2$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7d4ddebaad7c3ba2$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7d4ddebaad7c3ba2$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $7d4ddebaad7c3ba2$var$useDataRouterContext($7d4ddebaad7c3ba2$var$DataRouterHook.UseBlocker);
    let state = $7d4ddebaad7c3ba2$var$useDataRouterState($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $aOChP.useState("");
    let blockerFunction = $aOChP.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7d4ddebaad7c3ba2$var$_extends({}, currentLocation, {
                pathname: (0, $2ROCz.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7d4ddebaad7c3ba2$var$_extends({}, nextLocation, {
                pathname: (0, $2ROCz.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $aOChP.useEffect(()=>{
        let key = String(++$7d4ddebaad7c3ba2$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $aOChP.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $2ROCz.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7d4ddebaad7c3ba2$var$useNavigateStable() {
    let { router: router } = $7d4ddebaad7c3ba2$var$useDataRouterContext($7d4ddebaad7c3ba2$var$DataRouterHook.UseNavigateStable);
    let id = $7d4ddebaad7c3ba2$var$useCurrentRouteId($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $aOChP.useRef(false);
    $7d4ddebaad7c3ba2$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $aOChP.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7d4ddebaad7c3ba2$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7d4ddebaad7c3ba2$var$alreadyWarned = {};
function $7d4ddebaad7c3ba2$var$warningOnce(key, cond, message) {
    if (!cond && !$7d4ddebaad7c3ba2$var$alreadyWarned[key]) $7d4ddebaad7c3ba2$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7d4ddebaad7c3ba2$var$START_TRANSITION = "startTransition";
const $7d4ddebaad7c3ba2$var$startTransitionImpl = $aOChP[$7d4ddebaad7c3ba2$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7d4ddebaad7c3ba2$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setStateImpl] = $aOChP.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aOChP.useCallback((newState)=>{
        v7_startTransition && $7d4ddebaad7c3ba2$var$startTransitionImpl ? $7d4ddebaad7c3ba2$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aOChP.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $aOChP.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $aOChP.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $aOChP.createElement($aOChP.Fragment, null, /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $7d4ddebaad7c3ba2$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $7d4ddebaad7c3ba2$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7d4ddebaad7c3ba2$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $aOChP.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2ROCz.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aOChP.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aOChP.useCallback((newState)=>{
        v7_startTransition && $7d4ddebaad7c3ba2$var$startTransitionImpl ? $7d4ddebaad7c3ba2$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aOChP.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7d4ddebaad7c3ba2$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7d4ddebaad7c3ba2$export$9c954a9d03d32f4a() && (0, $2ROCz.UNSAFE_invariant)(false);
    let { matches: matches } = $aOChP.useContext($7d4ddebaad7c3ba2$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7d4ddebaad7c3ba2$export$45d76561a5302f2b();
    let navigate = $7d4ddebaad7c3ba2$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $2ROCz.resolveTo)(to, (0, $2ROCz.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $aOChP.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7d4ddebaad7c3ba2$export$910ae8079b2c2852(props) {
    return $7d4ddebaad7c3ba2$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7d4ddebaad7c3ba2$export$e7b0ac011bb776c6(_props) {
    (0, $2ROCz.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7d4ddebaad7c3ba2$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $2ROCz.Action).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$7d4ddebaad7c3ba2$export$9c954a9d03d32f4a() && (0, $2ROCz.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $aOChP.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $2ROCz.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $aOChP.useMemo(()=>{
        let trailingPathname = (0, $2ROCz.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7d4ddebaad7c3ba2$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7d4ddebaad7c3ba2$export$5d3fca4a98652595($7d4ddebaad7c3ba2$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7d4ddebaad7c3ba2$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$var$ResolveAwait, null, children));
}
var $7d4ddebaad7c3ba2$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7d4ddebaad7c3ba2$var$AwaitRenderStatus || {});
const $7d4ddebaad7c3ba2$var$neverSettledPromise = new Promise(()=>{});
class $7d4ddebaad7c3ba2$var$AwaitErrorBoundary extends $aOChP.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7d4ddebaad7c3ba2$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7d4ddebaad7c3ba2$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7d4ddebaad7c3ba2$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7d4ddebaad7c3ba2$var$AwaitRenderStatus.error : promise._data !== undefined ? $7d4ddebaad7c3ba2$var$AwaitRenderStatus.success : $7d4ddebaad7c3ba2$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7d4ddebaad7c3ba2$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7d4ddebaad7c3ba2$var$AwaitRenderStatus.error && promise._error instanceof (0, $2ROCz.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $7d4ddebaad7c3ba2$var$neverSettledPromise;
        if (status === $7d4ddebaad7c3ba2$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7d4ddebaad7c3ba2$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7d4ddebaad7c3ba2$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $7d4ddebaad7c3ba2$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7d4ddebaad7c3ba2$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $aOChP.createElement($aOChP.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7d4ddebaad7c3ba2$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $aOChP.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $aOChP.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $aOChP.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7d4ddebaad7c3ba2$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7d4ddebaad7c3ba2$export$e7b0ac011bb776c6) && (0, $2ROCz.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $2ROCz.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7d4ddebaad7c3ba2$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7d4ddebaad7c3ba2$export$daf73786167a7f72(matches) {
    return $7d4ddebaad7c3ba2$var$_renderMatches(matches);
}
function $7d4ddebaad7c3ba2$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $aOChP.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $aOChP.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7d4ddebaad7c3ba2$export$f30f7e456d254e83(routes, opts) {
    return (0, $2ROCz.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7d4ddebaad7c3ba2$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2ROCz.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7d4ddebaad7c3ba2$export$52b333d321859367
    }).initialize();
}

});


parcelRequire.register("kWBo5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3f639d06b797fa5$export$2e2bcd8739ae039; });

var $aOChP = parcelRequire("aOChP");
// Creating a React Context
const $f3f639d06b797fa5$var$UserContext = /*#__PURE__*/ (0, $aOChP.createContext)({
    loggedInUser: "Default User"
});
var $f3f639d06b797fa5$export$2e2bcd8739ae039 = $f3f639d06b797fa5$var$UserContext;

});

parcelRequire.register("9CGYE", function(module, exports) {
$parcel$export(module.exports, "createUserWithEmailAndPassword", function () { return (parcelRequire("jk7Hk")).a9; });
$parcel$export(module.exports, "getAuth", function () { return (parcelRequire("jk7Hk")).o; });
$parcel$export(module.exports, "GoogleAuthProvider", function () { return (parcelRequire("jk7Hk")).W; });
$parcel$export(module.exports, "onAuthStateChanged", function () { return (parcelRequire("jk7Hk")).y; });
$parcel$export(module.exports, "signInWithEmailAndPassword", function () { return (parcelRequire("jk7Hk")).aa; });
$parcel$export(module.exports, "signInWithPopup", function () { return (parcelRequire("jk7Hk")).c; });
$parcel$export(module.exports, "signOut", function () { return (parcelRequire("jk7Hk")).C; });
parcelRequire("5R61w");

});
parcelRequire.register("5R61w", function(module, exports) {

$parcel$export(module.exports, "GoogleAuthProvider", function () { return (parcelRequire("jk7Hk")).W; });
$parcel$export(module.exports, "createUserWithEmailAndPassword", function () { return (parcelRequire("jk7Hk")).a9; });
$parcel$export(module.exports, "getAuth", function () { return (parcelRequire("jk7Hk")).o; });
$parcel$export(module.exports, "onAuthStateChanged", function () { return (parcelRequire("jk7Hk")).y; });
$parcel$export(module.exports, "signInWithEmailAndPassword", function () { return (parcelRequire("jk7Hk")).aa; });
$parcel$export(module.exports, "signInWithPopup", function () { return (parcelRequire("jk7Hk")).c; });
$parcel$export(module.exports, "signOut", function () { return (parcelRequire("jk7Hk")).C; });

var $jk7Hk = parcelRequire("jk7Hk");
parcelRequire("6S5H6");
parcelRequire("6HgFA");
parcelRequire("5zfDX");

parcelRequire("1jeZY");

});
parcelRequire.register("jk7Hk", function(module, exports) {

$parcel$export(module.exports, "W", function () { return $e115db362685dd25$export$71cec2538cb2c617; });
$parcel$export(module.exports, "a9", function () { return $e115db362685dd25$export$a9c996f45e5784d0; });
$parcel$export(module.exports, "aa", function () { return $e115db362685dd25$export$7910e0436ed8d1de; });
$parcel$export(module.exports, "y", function () { return $e115db362685dd25$export$4a5767248b18ef41; });
$parcel$export(module.exports, "C", function () { return $e115db362685dd25$export$e7094788287c5e9b; });
$parcel$export(module.exports, "c", function () { return $e115db362685dd25$export$db3b6bfb95261072; });
$parcel$export(module.exports, "o", function () { return $e115db362685dd25$export$ae1af26003f05816; });

var $6S5H6 = parcelRequire("6S5H6");

var $6HgFA = parcelRequire("6HgFA");

var $5zfDX = parcelRequire("5zfDX");

var $3fgls = parcelRequire("3fgls");

var $1jeZY = parcelRequire("1jeZY");
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $e115db362685dd25$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: "phone",
    TOTP: "totp"
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $e115db362685dd25$export$ffb5f4729a158638 = {
    /** Facebook provider ID */ FACEBOOK: "facebook.com",
    /** GitHub provider ID */ GITHUB: "github.com",
    /** Google provider ID */ GOOGLE: "google.com",
    /** Password provider */ PASSWORD: "password",
    /** Phone provider */ PHONE: "phone",
    /** Twitter provider ID */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $e115db362685dd25$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: "emailLink",
    /** Email/password sign in method */ EMAIL_PASSWORD: "password",
    /** Facebook sign in method */ FACEBOOK: "facebook.com",
    /** GitHub sign in method */ GITHUB: "github.com",
    /** Google sign in method */ GOOGLE: "google.com",
    /** Phone sign in method */ PHONE: "phone",
    /** Twitter sign in method */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $e115db362685dd25$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: "link",
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: "reauthenticate",
    /** Operation involving signing in a user. */ SIGN_IN: "signIn"
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $e115db362685dd25$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: "EMAIL_SIGNIN",
    /** The password reset action. */ PASSWORD_RESET: "PASSWORD_RESET",
    /** The email revocation action. */ RECOVER_EMAIL: "RECOVER_EMAIL",
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: "REVERT_SECOND_FACTOR_ADDITION",
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: "VERIFY_AND_CHANGE_EMAIL",
    /** The email verification action. */ VERIFY_EMAIL: "VERIFY_EMAIL"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e115db362685dd25$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $e115db362685dd25$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $e115db362685dd25$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = "";
        /**
         * The reCAPTCHA enablement status of the {@link EmailAuthProvider} for the current tenant.
         */ this.emailPasswordEnabled = false;
        if (response.recaptchaKey === undefined) throw new Error("recaptchaKey undefined");
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split("/")[3];
        this.emailPasswordEnabled = response.recaptchaEnforcementState.some((enforcementState)=>enforcementState.provider === "EMAIL_PASSWORD_PROVIDER" && enforcementState.enforcementState !== "OFF");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e115db362685dd25$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: "This operation is restricted to administrators only.",
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: "",
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: "Cordova framework is not ready.",
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: "This browser is not supported.",
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: "This credential is already associated with a different user account.",
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: "The custom token corresponds to a different audience.",
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: "Multi-factor users must always have a verified email.",
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: "The email address is already in use by another account.",
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: "The action code has expired.",
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: "This operation has been cancelled due to another conflicting popup being opened.",
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: "An internal AuthError has occurred.",
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: "The mobile app identifier is not registed for the current project.",
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: "The continue URL provided in the request is invalid.",
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: "The custom token format is incorrect. Please check the documentation.",
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: "The provided dynamic link domain is not configured or authorized for the current project.",
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: "The email address is badly formatted.",
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: "Emulator URL must start with a valid scheme (http:// or https://).",
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: "Your API key is invalid, please check you have copied it correctly.",
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: "The SHA-1 certificate hash provided is invalid.",
        ["invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ]: "The supplied auth credential is malformed or has expired.",
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: "The request does not contain a valid proof of first factor successful sign-in.",
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: "The password is invalid or the user does not have a password.",
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: "The specified persistence type is invalid. It can only be local, session or none.",
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: "The specified provider ID is invalid.",
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: "The verification ID used to create the phone auth credential is invalid.",
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: "Login blocked by user-provided method: {$originalMessage}",
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: "An Android Package Name must be provided if the Android App is required to be installed.",
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: "The phone auth credential was created with an empty SMS verification code.",
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: "A continue URL must be provided in the request.",
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: "An internal AuthError has occurred.",
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: "An iOS Bundle ID must be provided if an App Store ID is provided.",
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: "A non-empty password must be provided",
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: "No second factor identifier is provided.",
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: "The request is missing proof of first factor successful sign-in.",
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: "To send verification codes, provide a phone number for the recipient.",
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: "The phone auth credential was created with an empty verification ID.",
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: "This instance of FirebaseApp has been deleted.",
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: "The user does not have a second factor matching the identifier provided.",
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: "Proof of ownership of a second factor is required to complete sign-in.",
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: "A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.",
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: "User was not linked to an account with the given provider.",
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: "Unable to establish a connection with the popup. It may have been blocked by the browser.",
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: "The popup has been closed by the user before finalizing the operation.",
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: "User can only be linked to one identity for the given provider.",
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: "The redirect operation has been cancelled by the user before finalizing.",
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: "A redirect sign-in operation is already pending.",
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: "The request contains malformed or mismatching credentials.",
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: "The second factor is already enrolled on this account.",
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "The maximum allowed number of second factors on a user has been exceeded.",
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: "The operation has timed out.",
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: "The current environment does not support the specified persistence type.",
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: "This operation is not supported in a multi-tenant context.",
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: "The operation requires a verified email.",
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: "The user did not grant your application the permissions it requested.",
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: "The user account has been disabled by an administrator.",
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: "The supplied credentials do not correspond to the previously signed in user.",
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: "",
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: "The password must be 6 characters long or more.",
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: "This browser is not supported or 3rd party cookies and data may be disabled.",
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is missing when sending request to the backend.",
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is invalid when sending request to the backend.",
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: "The reCAPTCHA action is invalid when sending request to the backend.",
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: "reCAPTCHA Enterprise integration is not enabled for this project.",
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: "The reCAPTCHA client type is missing when sending request to the backend.",
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is missing when sending request to the backend.",
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: "Invalid request parameters.",
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is invalid when sending request to the backend.",
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: "The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.",
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "The password does not meet the requirements."
    };
}
function $e115db362685dd25$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $e115db362685dd25$export$a9c23c6ac3fc3eca = $e115db362685dd25$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $e115db362685dd25$export$2329c99376c9d0a4 = $e115db362685dd25$var$_prodErrorMap;
const $e115db362685dd25$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $6S5H6.ErrorFactory)("auth", "Firebase", $e115db362685dd25$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $e115db362685dd25$export$7f8ddf7c7c20b3cd = {
    ADMIN_ONLY_OPERATION: "auth/admin-restricted-operation",
    ARGUMENT_ERROR: "auth/argument-error",
    APP_NOT_AUTHORIZED: "auth/app-not-authorized",
    APP_NOT_INSTALLED: "auth/app-not-installed",
    CAPTCHA_CHECK_FAILED: "auth/captcha-check-failed",
    CODE_EXPIRED: "auth/code-expired",
    CORDOVA_NOT_READY: "auth/cordova-not-ready",
    CORS_UNSUPPORTED: "auth/cors-unsupported",
    CREDENTIAL_ALREADY_IN_USE: "auth/credential-already-in-use",
    CREDENTIAL_MISMATCH: "auth/custom-token-mismatch",
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "auth/requires-recent-login",
    DEPENDENT_SDK_INIT_BEFORE_AUTH: "auth/dependent-sdk-initialized-before-auth",
    DYNAMIC_LINK_NOT_ACTIVATED: "auth/dynamic-link-not-activated",
    EMAIL_CHANGE_NEEDS_VERIFICATION: "auth/email-change-needs-verification",
    EMAIL_EXISTS: "auth/email-already-in-use",
    EMULATOR_CONFIG_FAILED: "auth/emulator-config-failed",
    EXPIRED_OOB_CODE: "auth/expired-action-code",
    EXPIRED_POPUP_REQUEST: "auth/cancelled-popup-request",
    INTERNAL_ERROR: "auth/internal-error",
    INVALID_API_KEY: "auth/invalid-api-key",
    INVALID_APP_CREDENTIAL: "auth/invalid-app-credential",
    INVALID_APP_ID: "auth/invalid-app-id",
    INVALID_AUTH: "auth/invalid-user-token",
    INVALID_AUTH_EVENT: "auth/invalid-auth-event",
    INVALID_CERT_HASH: "auth/invalid-cert-hash",
    INVALID_CODE: "auth/invalid-verification-code",
    INVALID_CONTINUE_URI: "auth/invalid-continue-uri",
    INVALID_CORDOVA_CONFIGURATION: "auth/invalid-cordova-configuration",
    INVALID_CUSTOM_TOKEN: "auth/invalid-custom-token",
    INVALID_DYNAMIC_LINK_DOMAIN: "auth/invalid-dynamic-link-domain",
    INVALID_EMAIL: "auth/invalid-email",
    INVALID_EMULATOR_SCHEME: "auth/invalid-emulator-scheme",
    INVALID_IDP_RESPONSE: "auth/invalid-credential",
    INVALID_MESSAGE_PAYLOAD: "auth/invalid-message-payload",
    INVALID_MFA_SESSION: "auth/invalid-multi-factor-session",
    INVALID_OAUTH_CLIENT_ID: "auth/invalid-oauth-client-id",
    INVALID_OAUTH_PROVIDER: "auth/invalid-oauth-provider",
    INVALID_OOB_CODE: "auth/invalid-action-code",
    INVALID_ORIGIN: "auth/unauthorized-domain",
    INVALID_PASSWORD: "auth/wrong-password",
    INVALID_PERSISTENCE: "auth/invalid-persistence-type",
    INVALID_PHONE_NUMBER: "auth/invalid-phone-number",
    INVALID_PROVIDER_ID: "auth/invalid-provider-id",
    INVALID_RECIPIENT_EMAIL: "auth/invalid-recipient-email",
    INVALID_SENDER: "auth/invalid-sender",
    INVALID_SESSION_INFO: "auth/invalid-verification-id",
    INVALID_TENANT_ID: "auth/invalid-tenant-id",
    MFA_INFO_NOT_FOUND: "auth/multi-factor-info-not-found",
    MFA_REQUIRED: "auth/multi-factor-auth-required",
    MISSING_ANDROID_PACKAGE_NAME: "auth/missing-android-pkg-name",
    MISSING_APP_CREDENTIAL: "auth/missing-app-credential",
    MISSING_AUTH_DOMAIN: "auth/auth-domain-config-required",
    MISSING_CODE: "auth/missing-verification-code",
    MISSING_CONTINUE_URI: "auth/missing-continue-uri",
    MISSING_IFRAME_START: "auth/missing-iframe-start",
    MISSING_IOS_BUNDLE_ID: "auth/missing-ios-bundle-id",
    MISSING_OR_INVALID_NONCE: "auth/missing-or-invalid-nonce",
    MISSING_MFA_INFO: "auth/missing-multi-factor-info",
    MISSING_MFA_SESSION: "auth/missing-multi-factor-session",
    MISSING_PHONE_NUMBER: "auth/missing-phone-number",
    MISSING_SESSION_INFO: "auth/missing-verification-id",
    MODULE_DESTROYED: "auth/app-deleted",
    NEED_CONFIRMATION: "auth/account-exists-with-different-credential",
    NETWORK_REQUEST_FAILED: "auth/network-request-failed",
    NULL_USER: "auth/null-user",
    NO_AUTH_EVENT: "auth/no-auth-event",
    NO_SUCH_PROVIDER: "auth/no-such-provider",
    OPERATION_NOT_ALLOWED: "auth/operation-not-allowed",
    OPERATION_NOT_SUPPORTED: "auth/operation-not-supported-in-this-environment",
    POPUP_BLOCKED: "auth/popup-blocked",
    POPUP_CLOSED_BY_USER: "auth/popup-closed-by-user",
    PROVIDER_ALREADY_LINKED: "auth/provider-already-linked",
    QUOTA_EXCEEDED: "auth/quota-exceeded",
    REDIRECT_CANCELLED_BY_USER: "auth/redirect-cancelled-by-user",
    REDIRECT_OPERATION_PENDING: "auth/redirect-operation-pending",
    REJECTED_CREDENTIAL: "auth/rejected-credential",
    SECOND_FACTOR_ALREADY_ENROLLED: "auth/second-factor-already-in-use",
    SECOND_FACTOR_LIMIT_EXCEEDED: "auth/maximum-second-factor-count-exceeded",
    TENANT_ID_MISMATCH: "auth/tenant-id-mismatch",
    TIMEOUT: "auth/timeout",
    TOKEN_EXPIRED: "auth/user-token-expired",
    TOO_MANY_ATTEMPTS_TRY_LATER: "auth/too-many-requests",
    UNAUTHORIZED_DOMAIN: "auth/unauthorized-continue-uri",
    UNSUPPORTED_FIRST_FACTOR: "auth/unsupported-first-factor",
    UNSUPPORTED_PERSISTENCE: "auth/unsupported-persistence-type",
    UNSUPPORTED_TENANT_OPERATION: "auth/unsupported-tenant-operation",
    UNVERIFIED_EMAIL: "auth/unverified-email",
    USER_CANCELLED: "auth/user-cancelled",
    USER_DELETED: "auth/user-not-found",
    USER_DISABLED: "auth/user-disabled",
    USER_MISMATCH: "auth/user-mismatch",
    USER_SIGNED_OUT: "auth/user-signed-out",
    WEAK_PASSWORD: "auth/weak-password",
    WEB_STORAGE_UNSUPPORTED: "auth/web-storage-unsupported",
    ALREADY_INITIALIZED: "auth/already-initialized",
    RECAPTCHA_NOT_ENABLED: "auth/recaptcha-not-enabled",
    MISSING_RECAPTCHA_TOKEN: "auth/missing-recaptcha-token",
    INVALID_RECAPTCHA_TOKEN: "auth/invalid-recaptcha-token",
    INVALID_RECAPTCHA_ACTION: "auth/invalid-recaptcha-action",
    MISSING_CLIENT_TYPE: "auth/missing-client-type",
    MISSING_RECAPTCHA_VERSION: "auth/missing-recaptcha-version",
    INVALID_RECAPTCHA_VERSION: "auth/invalid-recaptcha-version",
    INVALID_REQ_TYPE: "auth/invalid-req-type"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e115db362685dd25$var$logClient = new (0, $5zfDX.Logger)("@firebase/auth");
function $e115db362685dd25$var$_logWarn(msg, ...args) {
    if ($e115db362685dd25$var$logClient.logLevel <= (0, $5zfDX.LogLevel).WARN) $e115db362685dd25$var$logClient.warn(`Auth (${(0, $6HgFA.SDK_VERSION)}): ${msg}`, ...args);
}
function $e115db362685dd25$var$_logError(msg, ...args) {
    if ($e115db362685dd25$var$logClient.logLevel <= (0, $5zfDX.LogLevel).ERROR) $e115db362685dd25$var$logClient.error(`Auth (${(0, $6HgFA.SDK_VERSION)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e115db362685dd25$export$92108d983e8ee699(authOrCode, ...rest) {
    throw $e115db362685dd25$var$createErrorInternal(authOrCode, ...rest);
}
function $e115db362685dd25$export$91c6e00c14e7e6fd(authOrCode, ...rest) {
    return $e115db362685dd25$var$createErrorInternal(authOrCode, ...rest);
}
function $e115db362685dd25$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, $e115db362685dd25$export$2329c99376c9d0a4()), {
        [code]: message
    });
    const factory = new (0, $6S5H6.ErrorFactory)("auth", "Firebase", errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $e115db362685dd25$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $e115db362685dd25$export$92108d983e8ee699(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $e115db362685dd25$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $e115db362685dd25$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== "string") {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $e115db362685dd25$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $e115db362685dd25$export$9d398bebfec1c039(assertion, authOrCode, ...rest) {
    if (!assertion) throw $e115db362685dd25$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $e115db362685dd25$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $e115db362685dd25$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $e115db362685dd25$export$493d36ec626b6698(assertion, message) {
    if (!assertion) $e115db362685dd25$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e115db362685dd25$var$_getCurrentUrl() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || "";
}
function $e115db362685dd25$var$_isHttpOrHttps() {
    return $e115db362685dd25$var$_getCurrentScheme() === "http:" || $e115db362685dd25$var$_getCurrentScheme() === "https:";
}
function $e115db362685dd25$var$_getCurrentScheme() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $e115db362685dd25$var$_isOnline() {
    if (typeof navigator !== "undefined" && navigator && "onLine" in navigator && typeof navigator.onLine === "boolean" && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($e115db362685dd25$var$_isHttpOrHttps() || (0, $6S5H6.isBrowserExtension)() || "connection" in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $e115db362685dd25$var$_getUserLanguage() {
    if (typeof navigator === "undefined") return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $e115db362685dd25$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $e115db362685dd25$export$493d36ec626b6698(longDelay > shortDelay, "Short delay should be less than long delay!");
        this.isMobile = (0, $6S5H6.isMobileCordova)() || (0, $6S5H6.isReactNative)();
    }
    get() {
        if (!$e115db362685dd25$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e115db362685dd25$var$_emulatorUrl(config, path) {
    $e115db362685dd25$export$493d36ec626b6698(config.emulator, "Emulator should always be set here");
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith("/") ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e115db362685dd25$export$c03999cb2f36933f {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== "undefined" && "fetch" in self) return self.fetch;
        $e115db362685dd25$var$debugFail("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== "undefined" && "Headers" in self) return self.Headers;
        $e115db362685dd25$var$debugFail("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== "undefined" && "Response" in self) return self.Response;
        $e115db362685dd25$var$debugFail("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $e115db362685dd25$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e115db362685dd25$var$DEFAULT_API_TIMEOUT_MS = new $e115db362685dd25$var$Delay(30000, 60000);
function $e115db362685dd25$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function $e115db362685dd25$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $e115db362685dd25$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $6S5H6.querystring)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/json";
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        return $e115db362685dd25$export$c03999cb2f36933f.fetch()($e115db362685dd25$var$_getFinalTarget(auth, auth.config.apiHost, path, query), Object.assign({
            method: method,
            headers: headers,
            referrerPolicy: "no-referrer"
        }, body));
    });
}
async function $e115db362685dd25$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, $e115db362685dd25$var$SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new $e115db362685dd25$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ("needConfirmation" in json) throw $e115db362685dd25$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !("errorMessage" in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(" : ");
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $e115db362685dd25$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $e115db362685dd25$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $e115db362685dd25$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, "-");
            if (serverErrorMessage) throw $e115db362685dd25$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $e115db362685dd25$export$92108d983e8ee699(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $6S5H6.FirebaseError)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $e115db362685dd25$export$92108d983e8ee699(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            "message": String(e)
        });
    }
}
async function $e115db362685dd25$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $e115db362685dd25$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ("mfaPendingCredential" in serverResponse) $e115db362685dd25$export$92108d983e8ee699(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
function $e115db362685dd25$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    if (!auth.config.emulator) return `${auth.config.apiScheme}://${base}`;
    return $e115db362685dd25$var$_emulatorUrl(auth.config, base);
}
class $e115db362685dd25$var$NetworkTimeout {
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($e115db362685dd25$export$91c6e00c14e7e6fd(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $e115db362685dd25$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
}
function $e115db362685dd25$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $e115db362685dd25$export$91c6e00c14e7e6fd(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e115db362685dd25$var$getRecaptchaParams(auth) {
    return (await $e115db362685dd25$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || "";
}
async function $e115db362685dd25$var$getRecaptchaConfig(auth, request) {
    return $e115db362685dd25$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e115db362685dd25$var$deleteAccount(auth, request) {
    return $e115db362685dd25$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $e115db362685dd25$var$deleteLinkedAccounts(auth, request) {
    return $e115db362685dd25$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $e115db362685dd25$var$getAccountInfo(auth, request) {
    return $e115db362685dd25$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e115db362685dd25$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $e115db362685dd25$export$1a82df3d29112e01(user, forceRefresh = false) {
    return (0, $6S5H6.getModularInstance)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $e115db362685dd25$export$306ddfe3a8403e2(user, forceRefresh = false) {
    const userInternal = (0, $6S5H6.getModularInstance)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $e115db362685dd25$var$_parseToken(token);
    $e115db362685dd25$export$9d398bebfec1c039(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === "object" ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_provider"];
    return {
        claims: claims,
        token: token,
        authTime: $e115db362685dd25$var$utcTimestampToDateString($e115db362685dd25$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $e115db362685dd25$var$utcTimestampToDateString($e115db362685dd25$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $e115db362685dd25$var$utcTimestampToDateString($e115db362685dd25$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_second_factor"]) || null
    };
}
function $e115db362685dd25$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $e115db362685dd25$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split(".");
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $e115db362685dd25$var$_logError("JWT malformed, contained fewer than 3 sections");
        return null;
    }
    try {
        const decoded = (0, $6S5H6.base64Decode)(payload);
        if (!decoded) {
            $e115db362685dd25$var$_logError("Failed to decode base64 JWT payload");
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $e115db362685dd25$var$_logError("Caught error parsing JWT payload as JSON", e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $e115db362685dd25$var$_tokenExpiresIn(token) {
    const parsedToken = $e115db362685dd25$var$_parseToken(token);
    $e115db362685dd25$export$9d398bebfec1c039(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $e115db362685dd25$export$9d398bebfec1c039(typeof parsedToken.exp !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $e115db362685dd25$export$9d398bebfec1c039(typeof parsedToken.iat !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e115db362685dd25$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $6S5H6.FirebaseError) && $e115db362685dd25$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $e115db362685dd25$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e115db362685dd25$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e115db362685dd25$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $e115db362685dd25$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $e115db362685dd25$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e115db362685dd25$var$_reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $e115db362685dd25$var$_logoutIfInvalidated(user, $e115db362685dd25$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $e115db362685dd25$export$9d398bebfec1c039(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $e115db362685dd25$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $e115db362685dd25$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $e115db362685dd25$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $e115db362685dd25$export$8a5498727ef6be21(user) {
    const userInternal = (0, $6S5H6.getModularInstance)(user);
    await $e115db362685dd25$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $e115db362685dd25$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $e115db362685dd25$var$extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId: providerId } = _a, provider = (0, $3fgls.__rest)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || "",
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e115db362685dd25$var$requestStsToken(auth, refreshToken) {
    const response = await $e115db362685dd25$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $6S5H6.querystring)({
            "grant_type": "refresh_token",
            "refresh_token": refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = $e115db362685dd25$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/x-www-form-urlencoded";
        return $e115db362685dd25$export$c03999cb2f36933f.fetch()(url, {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        });
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $e115db362685dd25$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $e115db362685dd25$export$9d398bebfec1c039(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $e115db362685dd25$export$9d398bebfec1c039(typeof response.idToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $e115db362685dd25$export$9d398bebfec1c039(typeof response.refreshToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = "expiresIn" in response && typeof response.expiresIn !== "undefined" ? Number(response.expiresIn) : $e115db362685dd25$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        $e115db362685dd25$export$9d398bebfec1c039(!this.accessToken || this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $e115db362685dd25$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $e115db362685dd25$var$StsTokenManager();
        if (refreshToken) {
            $e115db362685dd25$export$9d398bebfec1c039(typeof refreshToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $e115db362685dd25$export$9d398bebfec1c039(typeof accessToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $e115db362685dd25$export$9d398bebfec1c039(typeof expirationTime === "number", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $e115db362685dd25$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $e115db362685dd25$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e115db362685dd25$var$assertStringOrUndefined(assertion, appName) {
    $e115db362685dd25$export$9d398bebfec1c039(typeof assertion === "string" || typeof assertion === "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $e115db362685dd25$export$a05254e7c3aeba6e {
    constructor(_a){
        var { uid: uid, auth: auth, stsTokenManager: stsTokenManager } = _a, opt = (0, $3fgls.__rest)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $e115db362685dd25$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $e115db362685dd25$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $e115db362685dd25$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $e115db362685dd25$export$9d398bebfec1c039(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $e115db362685dd25$export$306ddfe3a8403e2(this, forceRefresh);
    }
    reload() {
        return $e115db362685dd25$export$8a5498727ef6be21(this);
    }
    _assign(user) {
        if (this === user) return;
        $e115db362685dd25$export$9d398bebfec1c039(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $e115db362685dd25$export$a05254e7c3aeba6e(Object.assign(Object.assign({}, this), {
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $e115db362685dd25$export$9d398bebfec1c039(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $e115db362685dd25$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        const idToken = await this.getIdToken();
        await $e115db362685dd25$var$_logoutIfInvalidated(this, $e115db362685dd25$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || "";
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $e115db362685dd25$export$9d398bebfec1c039(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $e115db362685dd25$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $e115db362685dd25$export$9d398bebfec1c039(typeof uid === "string", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $e115db362685dd25$var$assertStringOrUndefined(displayName, auth.name);
        $e115db362685dd25$var$assertStringOrUndefined(email, auth.name);
        $e115db362685dd25$export$9d398bebfec1c039(typeof emailVerified === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $e115db362685dd25$export$9d398bebfec1c039(typeof isAnonymous === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $e115db362685dd25$var$assertStringOrUndefined(phoneNumber, auth.name);
        $e115db362685dd25$var$assertStringOrUndefined(photoURL, auth.name);
        $e115db362685dd25$var$assertStringOrUndefined(tenantId, auth.name);
        $e115db362685dd25$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $e115db362685dd25$var$assertStringOrUndefined(createdAt, auth.name);
        $e115db362685dd25$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $e115db362685dd25$export$a05254e7c3aeba6e({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $e115db362685dd25$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $e115db362685dd25$export$a05254e7c3aeba6e({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $e115db362685dd25$var$_reloadWithoutSaving(user);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e115db362685dd25$var$instanceCache = new Map();
function $e115db362685dd25$export$24baa2b76016ce0e(cls) {
    $e115db362685dd25$export$493d36ec626b6698(cls instanceof Function, "Expected a class definition");
    let instance = $e115db362685dd25$var$instanceCache.get(cls);
    if (instance) {
        $e115db362685dd25$export$493d36ec626b6698(instance instanceof cls, "Instance stored in cache mismatched with class");
        return instance;
    }
    instance = new cls();
    $e115db362685dd25$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e115db362685dd25$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$e115db362685dd25$var$InMemoryPersistence.type = "NONE";
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $e115db362685dd25$export$3722cfe417b6ed86 = $e115db362685dd25$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e115db362685dd25$export$158acd800e1ef08b(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $e115db362685dd25$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $e115db362685dd25$export$158acd800e1ef08b(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $e115db362685dd25$export$158acd800e1ef08b("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        return blob ? $e115db362685dd25$export$a05254e7c3aeba6e._fromJSON(this.auth, blob) : null;
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $e115db362685dd25$var$PersistenceUserManager($e115db362685dd25$export$24baa2b76016ce0e($e115db362685dd25$export$3722cfe417b6ed86), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $e115db362685dd25$export$24baa2b76016ce0e($e115db362685dd25$export$3722cfe417b6ed86);
        const key = $e115db362685dd25$export$158acd800e1ef08b(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                const user = $e115db362685dd25$export$a05254e7c3aeba6e._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $e115db362685dd25$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new $e115db362685dd25$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $e115db362685dd25$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes("opera/") || ua.includes("opr/") || ua.includes("opios/")) return "Opera" /* BrowserName.OPERA */ ;
    else if ($e115db362685dd25$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes("msie") || ua.includes("trident/")) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes("edge/")) return "Edge" /* BrowserName.EDGE */ ;
    else if ($e115db362685dd25$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes("silk/")) return "Silk" /* BrowserName.SILK */ ;
    else if ($e115db362685dd25$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($e115db362685dd25$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($e115db362685dd25$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes("chrome/") || $e115db362685dd25$var$_isChromeIOS(ua)) && !ua.includes("edge/")) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($e115db362685dd25$export$d66dc83d8cfc8dd(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $e115db362685dd25$var$_isFirefox(ua = (0, $6S5H6.getUA)()) {
    return /firefox\//i.test(ua);
}
function $e115db362685dd25$var$_isSafari(userAgent = (0, $6S5H6.getUA)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes("safari/") && !ua.includes("chrome/") && !ua.includes("crios/") && !ua.includes("android");
}
function $e115db362685dd25$var$_isChromeIOS(ua = (0, $6S5H6.getUA)()) {
    return /crios\//i.test(ua);
}
function $e115db362685dd25$var$_isIEMobile(ua = (0, $6S5H6.getUA)()) {
    return /iemobile/i.test(ua);
}
function $e115db362685dd25$export$d66dc83d8cfc8dd(ua = (0, $6S5H6.getUA)()) {
    return /android/i.test(ua);
}
function $e115db362685dd25$var$_isBlackBerry(ua = (0, $6S5H6.getUA)()) {
    return /blackberry/i.test(ua);
}
function $e115db362685dd25$var$_isWebOS(ua = (0, $6S5H6.getUA)()) {
    return /webos/i.test(ua);
}
function $e115db362685dd25$export$1fbe638ecf81657e(ua = (0, $6S5H6.getUA)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $e115db362685dd25$export$3d12bd131bb975d1(ua = (0, $6S5H6.getUA)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $e115db362685dd25$var$_isIOSStandalone(ua = (0, $6S5H6.getUA)()) {
    var _a;
    return $e115db362685dd25$export$1fbe638ecf81657e(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $e115db362685dd25$var$_isIE10() {
    return (0, $6S5H6.isIE)() && document.documentMode === 10;
}
function $e115db362685dd25$var$_isMobileBrowser(ua = (0, $6S5H6.getUA)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $e115db362685dd25$export$1fbe638ecf81657e(ua) || $e115db362685dd25$export$d66dc83d8cfc8dd(ua) || $e115db362685dd25$var$_isWebOS(ua) || $e115db362685dd25$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $e115db362685dd25$var$_isIEMobile(ua);
}
function $e115db362685dd25$var$_isIframe() {
    try {
        // Check that the current window is not the top window.
        // If so, return true.
        return !!(window && window !== window.top);
    } catch (e) {
        return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $e115db362685dd25$export$91477dc880baac21(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $e115db362685dd25$var$_getBrowserName((0, $6S5H6.getUA)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$e115db362685dd25$var$_getBrowserName((0, $6S5H6.getUA)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(",") : "FirebaseCore-web"; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $6HgFA.SDK_VERSION}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e115db362685dd25$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e === null || e === void 0 ? void 0 : e.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function $e115db362685dd25$var$_getPasswordPolicy(auth, request = {}) {
    return $e115db362685dd25$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const $e115db362685dd25$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class $e115db362685dd25$var$PasswordPolicyImpl {
    constructor(response){
        var _a, _b, _c, _d;
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = (_a = responseOptions.minPasswordLength) !== null && _a !== void 0 ? _a : $e115db362685dd25$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === "ENFORCEMENT_STATE_UNSPECIFIED") this.enforcementState = "OFF";
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = (_c = (_b = response.allowedNonAlphanumericCharacters) === null || _b === void 0 ? void 0 : _b.join("")) !== null && _c !== void 0 ? _c : "";
        this.forceUpgradeOnSignin = (_d = response.forceUpgradeOnSignin) !== null && _d !== void 0 ? _d : false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        var _a, _b, _c, _d, _e, _f;
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = (_a = status.meetsMinPasswordLength) !== null && _a !== void 0 ? _a : true);
        status.isValid && (status.isValid = (_b = status.meetsMaxPasswordLength) !== null && _b !== void 0 ? _b : true);
        status.isValid && (status.isValid = (_c = status.containsLowercaseLetter) !== null && _c !== void 0 ? _c : true);
        status.isValid && (status.isValid = (_d = status.containsUppercaseLetter) !== null && _d !== void 0 ? _d : true);
        status.isValid && (status.isValid = (_e = status.containsNumericCharacter) !== null && _e !== void 0 ? _e : true);
        status.isValid && (status.isValid = (_f = status.containsNonAlphanumericCharacter) !== null && _f !== void 0 ? _f : true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= "a" && passwordChar <= "z", /* containsUppercaseCharacter= */ passwordChar >= "A" && passwordChar <= "Z", /* containsNumericCharacter= */ passwordChar >= "0" && passwordChar <= "9", /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e115db362685dd25$export$23ebac1979863676 {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $e115db362685dd25$var$Subscription(this);
        this.idTokenSubscription = new $e115db362685dd25$var$Subscription(this);
        this.beforeStateQueue = new $e115db362685dd25$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $e115db362685dd25$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $e115db362685dd25$export$24baa2b76016ce0e(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b;
            if (this._deleted) return;
            this.persistenceManager = await $e115db362685dd25$var$PersistenceUserManager.create(this, persistenceHierarchy);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_a = this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $e115db362685dd25$export$9d398bebfec1c039(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $e115db362685dd25$var$_reloadWithoutSaving(user);
        } catch (e) {
            if ((e === null || e === void 0 ? void 0 : e.code) !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $e115db362685dd25$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $6S5H6.getModularInstance)(userExtern) : null;
        if (user) $e115db362685dd25$export$9d398bebfec1c039(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $e115db362685dd25$export$9d398bebfec1c039(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($e115db362685dd25$export$24baa2b76016ce0e(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await $e115db362685dd25$var$_getPasswordPolicy(this);
        const passwordPolicy = new $e115db362685dd25$var$PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence.type;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $6S5H6.ErrorFactory)("auth", "Firebase", errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $e115db362685dd25$export$24baa2b76016ce0e(popupRedirectResolver) || this._popupRedirectResolver;
            $e115db362685dd25$export$9d398bebfec1c039(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $e115db362685dd25$var$PersistenceUserManager.create(this, [
                $e115db362685dd25$export$24baa2b76016ce0e(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === "function" ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $e115db362685dd25$export$9d398bebfec1c039(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === "function") {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $e115db362685dd25$export$9d398bebfec1c039(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $e115db362685dd25$export$91477dc880baac21(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        var _a;
        const appCheckTokenResult = await ((_a = this.appCheckServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getToken());
        if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $e115db362685dd25$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token;
    }
}
/**
 * Method to be used to cast down to our private implmentation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $e115db362685dd25$export$b9a6b53f9be3734(auth) {
    return (0, $6S5H6.getModularInstance)(auth);
}
/** Helper class to wrap subscriber logic */ class $e115db362685dd25$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $6S5H6.createSubscribe)((observer)=>this.observer = observer);
    }
    get next() {
        $e115db362685dd25$export$9d398bebfec1c039(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e115db362685dd25$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName("head")) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
function $e115db362685dd25$var$_loadJS(url) {
    // TODO: consider adding timeout support & cancellation
    return new Promise((resolve, reject)=>{
        const el = document.createElement("script");
        el.setAttribute("src", url);
        el.onload = resolve;
        el.onerror = (e)=>{
            const error = $e115db362685dd25$export$91c6e00c14e7e6fd("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            error.customData = e;
            reject(error);
        };
        el.type = "text/javascript";
        el.charset = "UTF-8";
        $e115db362685dd25$var$getScriptParentElement().appendChild(el);
    });
}
function $e115db362685dd25$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $e115db362685dd25$var$RECAPTCHA_ENTERPRISE_URL = "https://www.google.com/recaptcha/enterprise.js?render=";
const $e115db362685dd25$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = "recaptcha-enterprise";
const $e115db362685dd25$var$FAKE_TOKEN = "NO_RECAPTCHA";
class $e115db362685dd25$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $e115db362685dd25$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $e115db362685dd25$export$b9a6b53f9be3734(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = "verify", forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $e115db362685dd25$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error("recaptcha Enterprise site key undefined"));
                    else {
                        const config = new $e115db362685dd25$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($e115db362685dd25$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($e115db362685dd25$var$FAKE_TOKEN);
                });
            });
            else reject(Error("No reCAPTCHA enterprise script loaded."));
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && $e115db362685dd25$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === "undefined") {
                        reject(new Error("RecaptchaVerifier is only supported in browser"));
                        return;
                    }
                    $e115db362685dd25$var$_loadJS($e115db362685dd25$var$RECAPTCHA_ENTERPRISE_URL + siteKey).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function $e115db362685dd25$var$injectRecaptchaFields(auth, request, action, captchaResp = false) {
    const verifier = new $e115db362685dd25$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = Object.assign({}, request);
    if (!captchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        "captchaResp": captchaResponse
    });
    Object.assign(newRequest, {
        "clientType": "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        "recaptchaVersion": "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function $e115db362685dd25$var$_initializeRecaptchaConfig(auth) {
    const authInternal = $e115db362685dd25$export$b9a6b53f9be3734(auth);
    const response = await $e115db362685dd25$var$getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new $e115db362685dd25$var$RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.emailPasswordEnabled) {
        const verifier = new $e115db362685dd25$var$RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $e115db362685dd25$export$9bb611d729802a56(app, deps) {
    const provider = (0, $6HgFA._getProvider)(app, "auth");
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $6S5H6.deepEqual)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $e115db362685dd25$export$92108d983e8ee699(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $e115db362685dd25$var$_initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($e115db362685dd25$export$24baa2b76016ce0e);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $e115db362685dd25$export$b4171a6734a65d42(auth, url, options) {
    const authInternal = $e115db362685dd25$export$b9a6b53f9be3734(auth);
    $e115db362685dd25$export$9d398bebfec1c039(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
    $e115db362685dd25$export$9d398bebfec1c039(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = $e115db362685dd25$var$extractProtocol(url);
    const { host: host, port: port } = $e115db362685dd25$var$extractHostAndPort(url);
    const portStr = port === null ? "" : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(":", ""),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $e115db362685dd25$var$emitEmulatorWarning();
}
function $e115db362685dd25$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(":");
    return protocolEnd < 0 ? "" : url.substr(0, protocolEnd + 1);
}
function $e115db362685dd25$var$extractHostAndPort(url) {
    const protocol = $e115db362685dd25$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: "",
        port: null
    };
    const hostAndPort = authority[2].split("@").pop() || ""; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $e115db362685dd25$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(":");
        return {
            host: host,
            port: $e115db362685dd25$var$parsePort(port)
        };
    }
}
function $e115db362685dd25$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $e115db362685dd25$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement("p");
        const sty = el.style;
        el.innerText = "Running in emulator mode. Do not use with production credentials.";
        sty.position = "fixed";
        sty.width = "100%";
        sty.backgroundColor = "#ffffff";
        sty.border = ".1em solid #000000";
        sty.color = "#b50000";
        sty.bottom = "0px";
        sty.left = "0px";
        sty.margin = "0px";
        sty.zIndex = "10000";
        sty.textAlign = "center";
        el.classList.add("firebase-emulator-warning");
        document.body.appendChild(el);
    }
    if (typeof console !== "undefined" && typeof console.info === "function") console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== "undefined" && typeof document !== "undefined") {
        if (document.readyState === "loading") window.addEventListener("DOMContentLoaded", attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $e115db362685dd25$export$3466f893ebf79586 {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $e115db362685dd25$var$debugFail("not implemented");
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $e115db362685dd25$var$debugFail("not implemented");
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $e115db362685dd25$var$debugFail("not implemented");
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $e115db362685dd25$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e115db362685dd25$var$resetPassword(auth, request) {
    return $e115db362685dd25$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
async function $e115db362685dd25$var$updateEmailPassword(auth, request) {
    return $e115db362685dd25$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $e115db362685dd25$var$applyActionCode$1(auth, request) {
    return $e115db362685dd25$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e115db362685dd25$var$signInWithPassword(auth, request) {
    return $e115db362685dd25$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
async function $e115db362685dd25$var$sendOobCode(auth, request) {
    return $e115db362685dd25$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
async function $e115db362685dd25$var$sendEmailVerification$1(auth, request) {
    return $e115db362685dd25$var$sendOobCode(auth, request);
}
async function $e115db362685dd25$var$sendPasswordResetEmail$1(auth, request) {
    return $e115db362685dd25$var$sendOobCode(auth, request);
}
async function $e115db362685dd25$var$sendSignInLinkToEmail$1(auth, request) {
    return $e115db362685dd25$var$sendOobCode(auth, request);
}
async function $e115db362685dd25$var$verifyAndChangeEmail(auth, request) {
    return $e115db362685dd25$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e115db362685dd25$var$signInWithEmailLink$1(auth, request) {
    return $e115db362685dd25$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
async function $e115db362685dd25$var$signInWithEmailLinkForLinking(auth, request) {
    return $e115db362685dd25$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $e115db362685dd25$export$61196ced6d74a310 extends $e115db362685dd25$export$3466f893ebf79586 {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $e115db362685dd25$export$61196ced6d74a310(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $e115db362685dd25$export$61196ced6d74a310(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        var _a;
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                if ((_a = auth._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled) {
                    const requestWithRecaptcha = await $e115db362685dd25$var$injectRecaptchaFields(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ );
                    return $e115db362685dd25$var$signInWithPassword(auth, requestWithRecaptcha);
                } else return $e115db362685dd25$var$signInWithPassword(auth, request).catch(async (error)=>{
                    if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                        console.log("Sign-in with email address and password is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-in flow.");
                        const requestWithRecaptcha = await $e115db362685dd25$var$injectRecaptchaFields(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ );
                        return $e115db362685dd25$var$signInWithPassword(auth, requestWithRecaptcha);
                    } else return Promise.reject(error);
                });
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $e115db362685dd25$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $e115db362685dd25$export$92108d983e8ee699(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                return $e115db362685dd25$var$updateEmailPassword(auth, {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password
                });
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $e115db362685dd25$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $e115db362685dd25$export$92108d983e8ee699(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e115db362685dd25$var$signInWithIdp(auth, request) {
    return $e115db362685dd25$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e115db362685dd25$var$IDP_REQUEST_URI$1 = "http://localhost";
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $e115db362685dd25$export$3a1a48c8f6ef640e extends $e115db362685dd25$export$3466f893ebf79586 {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $e115db362685dd25$export$3a1a48c8f6ef640e(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $e115db362685dd25$export$92108d983e8ee699("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod } = obj, rest = (0, $3fgls.__rest)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new $e115db362685dd25$export$3a1a48c8f6ef640e(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $e115db362685dd25$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $e115db362685dd25$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $e115db362685dd25$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $e115db362685dd25$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody["id_token"] = this.idToken;
            if (this.accessToken) postBody["access_token"] = this.accessToken;
            if (this.secret) postBody["oauth_token_secret"] = this.secret;
            postBody["providerId"] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody["nonce"] = this.nonce;
            request.postBody = (0, $6S5H6.querystring)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e115db362685dd25$var$sendPhoneVerificationCode(auth, request) {
    return $e115db362685dd25$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
async function $e115db362685dd25$var$signInWithPhoneNumber$1(auth, request) {
    return $e115db362685dd25$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
async function $e115db362685dd25$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $e115db362685dd25$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $e115db362685dd25$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $e115db362685dd25$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $e115db362685dd25$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: "REAUTH"
    });
    return $e115db362685dd25$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $e115db362685dd25$var$_addTidIfNecessary(auth, apiRequest), $e115db362685dd25$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $e115db362685dd25$export$a07804094c3ecf2d extends $e115db362685dd25$export$3466f893ebf79586 {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $e115db362685dd25$export$a07804094c3ecf2d({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $e115db362685dd25$export$a07804094c3ecf2d({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $e115db362685dd25$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $e115db362685dd25$var$linkWithPhoneNumber$1(auth, Object.assign({
            idToken: idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $e115db362685dd25$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === "string") json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $e115db362685dd25$export$a07804094c3ecf2d({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $e115db362685dd25$var$parseMode(mode) {
    switch(mode){
        case "recoverEmail":
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case "resetPassword":
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case "signIn":
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case "verifyEmail":
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case "verifyAndChangeEmail":
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case "revertSecondFactorAddition":
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $e115db362685dd25$var$parseDeepLink(url) {
    const link = (0, $6S5H6.querystringDecode)((0, $6S5H6.extractQuerystring)(url))["link"];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $6S5H6.querystringDecode)((0, $6S5H6.extractQuerystring)(link))["deep_link_id"] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $6S5H6.querystringDecode)((0, $6S5H6.extractQuerystring)(url))["deep_link_id"];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $6S5H6.querystringDecode)((0, $6S5H6.extractQuerystring)(iOSDeepLink))["link"] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $e115db362685dd25$export$995eb9fca571757 {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, $6S5H6.querystringDecode)((0, $6S5H6.extractQuerystring)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = $e115db362685dd25$var$parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $e115db362685dd25$export$9d398bebfec1c039(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $e115db362685dd25$var$parseDeepLink(link);
        try {
            return new $e115db362685dd25$export$995eb9fca571757(actionLink);
        } catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $e115db362685dd25$export$f38c853ae54ed474(link) {
    return $e115db362685dd25$export$995eb9fca571757.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $e115db362685dd25$export$3a6d5c9ae78a2c08 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $e115db362685dd25$export$3a6d5c9ae78a2c08.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $e115db362685dd25$export$61196ced6d74a310._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $e115db362685dd25$export$995eb9fca571757.parseLink(emailLink);
        $e115db362685dd25$export$9d398bebfec1c039(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $e115db362685dd25$export$61196ced6d74a310._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $e115db362685dd25$export$3a6d5c9ae78a2c08.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $e115db362685dd25$export$3a6d5c9ae78a2c08.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $e115db362685dd25$export$3a6d5c9ae78a2c08.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $e115db362685dd25$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $e115db362685dd25$var$BaseOAuthProvider extends $e115db362685dd25$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $e115db362685dd25$export$8743009a87fcb00f extends $e115db362685dd25$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        $e115db362685dd25$export$9d398bebfec1c039("providerId" in obj && "signInMethod" in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $e115db362685dd25$export$3a1a48c8f6ef640e._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $e115db362685dd25$export$9d398bebfec1c039(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $e115db362685dd25$export$3a1a48c8f6ef640e._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $e115db362685dd25$export$8743009a87fcb00f.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $e115db362685dd25$export$8743009a87fcb00f.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $e115db362685dd25$export$8743009a87fcb00f(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $e115db362685dd25$export$e7c866399fa523f5 extends $e115db362685dd25$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $e115db362685dd25$export$3a1a48c8f6ef640e._fromParams({
            providerId: $e115db362685dd25$export$e7c866399fa523f5.PROVIDER_ID,
            signInMethod: $e115db362685dd25$export$e7c866399fa523f5.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $e115db362685dd25$export$e7c866399fa523f5.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $e115db362685dd25$export$e7c866399fa523f5.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $e115db362685dd25$export$e7c866399fa523f5.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $e115db362685dd25$export$e7c866399fa523f5.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $e115db362685dd25$export$e7c866399fa523f5.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $e115db362685dd25$export$71cec2538cb2c617 extends $e115db362685dd25$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope("profile");
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $e115db362685dd25$export$3a1a48c8f6ef640e._fromParams({
            providerId: $e115db362685dd25$export$71cec2538cb2c617.PROVIDER_ID,
            signInMethod: $e115db362685dd25$export$71cec2538cb2c617.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $e115db362685dd25$export$71cec2538cb2c617.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $e115db362685dd25$export$71cec2538cb2c617.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $e115db362685dd25$export$71cec2538cb2c617.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $e115db362685dd25$export$71cec2538cb2c617.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $e115db362685dd25$export$71cec2538cb2c617.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Github Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Github Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $e115db362685dd25$export$78acf4525d8a74c4 extends $e115db362685dd25$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for Github.
     *
     * @param accessToken - Github access token.
     */ static credential(accessToken) {
        return $e115db362685dd25$export$3a1a48c8f6ef640e._fromParams({
            providerId: $e115db362685dd25$export$78acf4525d8a74c4.PROVIDER_ID,
            signInMethod: $e115db362685dd25$export$78acf4525d8a74c4.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $e115db362685dd25$export$78acf4525d8a74c4.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $e115db362685dd25$export$78acf4525d8a74c4.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $e115db362685dd25$export$78acf4525d8a74c4.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $e115db362685dd25$export$78acf4525d8a74c4.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $e115db362685dd25$export$78acf4525d8a74c4.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e115db362685dd25$var$IDP_REQUEST_URI = "http://localhost";
/**
 * @public
 */ class $e115db362685dd25$export$2ed0fc6709e59212 extends $e115db362685dd25$export$3466f893ebf79586 {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $e115db362685dd25$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $e115db362685dd25$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $e115db362685dd25$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $e115db362685dd25$export$2ed0fc6709e59212(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $e115db362685dd25$export$2ed0fc6709e59212(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $e115db362685dd25$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e115db362685dd25$var$SAML_PROVIDER_PREFIX = "saml.";
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $e115db362685dd25$export$dc98b0b04f4c7758 extends $e115db362685dd25$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $e115db362685dd25$export$9d398bebfec1c039(providerId.startsWith($e115db362685dd25$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $e115db362685dd25$export$dc98b0b04f4c7758.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $e115db362685dd25$export$dc98b0b04f4c7758.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $e115db362685dd25$export$2ed0fc6709e59212.fromJSON(json);
        $e115db362685dd25$export$9d398bebfec1c039(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $e115db362685dd25$export$2ed0fc6709e59212._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $e115db362685dd25$export$71511d61b312f219 extends $e115db362685dd25$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $e115db362685dd25$export$3a1a48c8f6ef640e._fromParams({
            providerId: $e115db362685dd25$export$71511d61b312f219.PROVIDER_ID,
            signInMethod: $e115db362685dd25$export$71511d61b312f219.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $e115db362685dd25$export$71511d61b312f219.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $e115db362685dd25$export$71511d61b312f219.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $e115db362685dd25$export$71511d61b312f219.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $e115db362685dd25$export$71511d61b312f219.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $e115db362685dd25$export$71511d61b312f219.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e115db362685dd25$var$signUp(auth, request) {
    return $e115db362685dd25$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e115db362685dd25$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $e115db362685dd25$export$a05254e7c3aeba6e._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $e115db362685dd25$var$providerIdForResponse(idTokenResponse);
        const userCred = new $e115db362685dd25$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $e115db362685dd25$var$providerIdForResponse(response);
        return new $e115db362685dd25$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $e115db362685dd25$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ("phoneNumber" in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $e115db362685dd25$export$3d8c2f653ac9d0b9(auth) {
    var _a;
    const authInternal = $e115db362685dd25$export$b9a6b53f9be3734(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $e115db362685dd25$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $e115db362685dd25$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $e115db362685dd25$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e115db362685dd25$var$MultiFactorError extends (0, $6S5H6.FirebaseError) {
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $e115db362685dd25$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $e115db362685dd25$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $e115db362685dd25$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $e115db362685dd25$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $e115db362685dd25$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $e115db362685dd25$export$7a38258bbe170828(user, providerId) {
    const userInternal = (0, $6S5H6.getModularInstance)(user);
    await $e115db362685dd25$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $e115db362685dd25$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $e115db362685dd25$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $e115db362685dd25$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $e115db362685dd25$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $e115db362685dd25$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $e115db362685dd25$var$_assertLinkedStatus(expected, user, provider) {
    await $e115db362685dd25$var$_reloadWithoutSaving(user);
    const providerIds = $e115db362685dd25$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $e115db362685dd25$export$9d398bebfec1c039(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e115db362685dd25$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $e115db362685dd25$var$_logoutIfInvalidated(user, $e115db362685dd25$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $e115db362685dd25$export$9d398bebfec1c039(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $e115db362685dd25$var$_parseToken(response.idToken);
        $e115db362685dd25$export$9d398bebfec1c039(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $e115db362685dd25$export$9d398bebfec1c039(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $e115db362685dd25$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $e115db362685dd25$export$92108d983e8ee699(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e115db362685dd25$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $e115db362685dd25$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $e115db362685dd25$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $e115db362685dd25$export$34aec0b863436764(auth, credential) {
    return $e115db362685dd25$var$_signInWithCredential($e115db362685dd25$export$b9a6b53f9be3734(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $e115db362685dd25$export$3c2fa207a37baaea(user, credential) {
    const userInternal = (0, $6S5H6.getModularInstance)(user);
    await $e115db362685dd25$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $e115db362685dd25$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $e115db362685dd25$export$ce26c07117d59d6a(user, credential) {
    return $e115db362685dd25$var$_reauthenticate((0, $6S5H6.getModularInstance)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e115db362685dd25$var$signInWithCustomToken$1(auth, request) {
    return $e115db362685dd25$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $e115db362685dd25$export$6559d589eb85fbb6(auth, customToken) {
    const authInternal = $e115db362685dd25$export$b9a6b53f9be3734(auth);
    const response = await $e115db362685dd25$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $e115db362685dd25$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e115db362685dd25$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ("phoneInfo" in enrollment) return $e115db362685dd25$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ("totpInfo" in enrollment) return $e115db362685dd25$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $e115db362685dd25$export$92108d983e8ee699(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $e115db362685dd25$var$PhoneMultiFactorInfoImpl extends $e115db362685dd25$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $e115db362685dd25$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $e115db362685dd25$var$TotpMultiFactorInfoImpl extends $e115db362685dd25$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $e115db362685dd25$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e115db362685dd25$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $e115db362685dd25$export$9d398bebfec1c039(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $e115db362685dd25$export$9d398bebfec1c039(typeof actionCodeSettings.dynamicLinkDomain === "undefined" || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $e115db362685dd25$export$9d398bebfec1c039(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $e115db362685dd25$export$9d398bebfec1c039(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function $e115db362685dd25$var$recachePasswordPolicy(auth) {
    const authInternal = $e115db362685dd25$export$b9a6b53f9be3734(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $e115db362685dd25$export$efca4cbe5dd06740(auth, email, actionCodeSettings) {
    var _a;
    const authInternal = $e115db362685dd25$export$b9a6b53f9be3734(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if ((_a = authInternal._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled) {
        const requestWithRecaptcha = await $e115db362685dd25$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true);
        if (actionCodeSettings) $e115db362685dd25$var$_setActionCodeSettingsOnRequest(authInternal, requestWithRecaptcha, actionCodeSettings);
        await $e115db362685dd25$var$sendPasswordResetEmail$1(authInternal, requestWithRecaptcha);
    } else {
        if (actionCodeSettings) $e115db362685dd25$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
        await $e115db362685dd25$var$sendPasswordResetEmail$1(authInternal, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log("Password resets are protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the password reset flow.");
                const requestWithRecaptcha = await $e115db362685dd25$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true);
                if (actionCodeSettings) $e115db362685dd25$var$_setActionCodeSettingsOnRequest(authInternal, requestWithRecaptcha, actionCodeSettings);
                await $e115db362685dd25$var$sendPasswordResetEmail$1(authInternal, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    }
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $e115db362685dd25$export$a8550f7dbe79f93a(auth, oobCode, newPassword) {
    await $e115db362685dd25$var$resetPassword((0, $6S5H6.getModularInstance)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $e115db362685dd25$var$recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $e115db362685dd25$export$2e2af4578d910ddf(auth, oobCode) {
    await $e115db362685dd25$var$applyActionCode$1((0, $6S5H6.getModularInstance)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $e115db362685dd25$export$a93c5207d687da10(auth, oobCode) {
    const authModular = (0, $6S5H6.getModularInstance)(auth);
    const response = await $e115db362685dd25$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $e115db362685dd25$export$9d398bebfec1c039(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $e115db362685dd25$export$9d398bebfec1c039(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $e115db362685dd25$export$9d398bebfec1c039(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $e115db362685dd25$export$9d398bebfec1c039(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $e115db362685dd25$var$MultiFactorInfoImpl._fromServerResponse($e115db362685dd25$export$b9a6b53f9be3734(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $e115db362685dd25$export$c3950d9923825c02(auth, code) {
    const { data: data } = await $e115db362685dd25$export$a93c5207d687da10((0, $6S5H6.getModularInstance)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $e115db362685dd25$export$a9c996f45e5784d0(auth, email, password) {
    var _a;
    const authInternal = $e115db362685dd25$export$b9a6b53f9be3734(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    let signUpResponse;
    if ((_a = authInternal._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled) {
        const requestWithRecaptcha = await $e115db362685dd25$var$injectRecaptchaFields(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ );
        signUpResponse = $e115db362685dd25$var$signUp(authInternal, requestWithRecaptcha);
    } else signUpResponse = $e115db362685dd25$var$signUp(authInternal, request).catch(async (error)=>{
        if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
            console.log("Sign-up is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-up flow.");
            const requestWithRecaptcha = await $e115db362685dd25$var$injectRecaptchaFields(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ );
            return $e115db362685dd25$var$signUp(authInternal, requestWithRecaptcha);
        }
        throw error;
    });
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $e115db362685dd25$var$recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await $e115db362685dd25$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $e115db362685dd25$export$7910e0436ed8d1de(auth, email, password) {
    return $e115db362685dd25$export$34aec0b863436764((0, $6S5H6.getModularInstance)(auth), $e115db362685dd25$export$3a6d5c9ae78a2c08.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $e115db362685dd25$var$recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $e115db362685dd25$export$555508cbc6add439(auth, email, actionCodeSettings) {
    var _a;
    const authInternal = $e115db362685dd25$export$b9a6b53f9be3734(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $e115db362685dd25$export$9d398bebfec1c039(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $e115db362685dd25$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    if ((_a = authInternal._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled) {
        const requestWithRecaptcha = await $e115db362685dd25$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true);
        setActionCodeSettings(requestWithRecaptcha, actionCodeSettings);
        await $e115db362685dd25$var$sendSignInLinkToEmail$1(authInternal, requestWithRecaptcha);
    } else {
        setActionCodeSettings(request, actionCodeSettings);
        await $e115db362685dd25$var$sendSignInLinkToEmail$1(authInternal, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log("Email link sign-in is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-in flow.");
                const requestWithRecaptcha = await $e115db362685dd25$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true);
                setActionCodeSettings(requestWithRecaptcha, actionCodeSettings);
                await $e115db362685dd25$var$sendSignInLinkToEmail$1(authInternal, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    }
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $e115db362685dd25$export$2219238a014317b0(auth, emailLink) {
    const actionCodeUrl = $e115db362685dd25$export$995eb9fca571757.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $e115db362685dd25$export$4c3d22f3d993c33f(auth, email, emailLink) {
    const authModular = (0, $6S5H6.getModularInstance)(auth);
    const credential = $e115db362685dd25$export$3a6d5c9ae78a2c08.credentialWithLink(email, emailLink || $e115db362685dd25$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $e115db362685dd25$export$9d398bebfec1c039(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $e115db362685dd25$export$34aec0b863436764(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e115db362685dd25$var$createAuthUri(auth, request) {
    return $e115db362685dd25$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * @public
 */ async function $e115db362685dd25$export$f787f51d84a910ad(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $e115db362685dd25$var$_isHttpOrHttps() ? $e115db362685dd25$var$_getCurrentUrl() : "http://localhost";
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $e115db362685dd25$var$createAuthUri((0, $6S5H6.getModularInstance)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $e115db362685dd25$export$c9170ad7d4cd7e57(user, actionCodeSettings) {
    const userInternal = (0, $6S5H6.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $e115db362685dd25$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $e115db362685dd25$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $e115db362685dd25$export$ee7c8ad385a60b7b(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $6S5H6.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $e115db362685dd25$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $e115db362685dd25$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e115db362685dd25$var$updateProfile$1(auth, request) {
    return $e115db362685dd25$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $e115db362685dd25$export$3b513254972cfc9c(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $6S5H6.getModularInstance)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $e115db362685dd25$var$_logoutIfInvalidated(userInternal, $e115db362685dd25$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * @public
 */ function $e115db362685dd25$export$21579262ef46735b(user, newEmail) {
    return $e115db362685dd25$var$updateEmailOrPassword((0, $6S5H6.getModularInstance)(user), newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $e115db362685dd25$export$ab83b03e4111b1d0(user, newPassword) {
    return $e115db362685dd25$var$updateEmailOrPassword((0, $6S5H6.getModularInstance)(user), null, newPassword);
}
async function $e115db362685dd25$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $e115db362685dd25$var$_logoutIfInvalidated(user, $e115db362685dd25$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $e115db362685dd25$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = $e115db362685dd25$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b["sign_in_provider"];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $e115db362685dd25$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $e115db362685dd25$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $e115db362685dd25$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $e115db362685dd25$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $e115db362685dd25$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $e115db362685dd25$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $e115db362685dd25$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $e115db362685dd25$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $e115db362685dd25$var$FederatedAdditionalUserInfoWithUsername extends $e115db362685dd25$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $e115db362685dd25$var$FacebookAdditionalUserInfo extends $e115db362685dd25$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $e115db362685dd25$var$GithubAdditionalUserInfo extends $e115db362685dd25$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === "string" ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class $e115db362685dd25$var$GoogleAdditionalUserInfo extends $e115db362685dd25$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $e115db362685dd25$var$TwitterAdditionalUserInfo extends $e115db362685dd25$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $e115db362685dd25$export$2f6ca3d3b1f80bf5(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $e115db362685dd25$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $e115db362685dd25$export$9e5f44173e64f162(auth, persistence) {
    return (0, $6S5H6.getModularInstance)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $e115db362685dd25$export$625550452a3fa3ec(auth) {
    return $e115db362685dd25$var$_initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function $e115db362685dd25$export$90a7f3efeed30595(auth, password) {
    const authInternal = $e115db362685dd25$export$b9a6b53f9be3734(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $e115db362685dd25$export$efccba1c4a2ef57b(auth, nextOrObserver, error, completed) {
    return (0, $6S5H6.getModularInstance)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $e115db362685dd25$export$d141bba7fdc215a3(auth, callback, onAbort) {
    return (0, $6S5H6.getModularInstance)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $e115db362685dd25$export$4a5767248b18ef41(auth, nextOrObserver, error, completed) {
    return (0, $6S5H6.getModularInstance)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $e115db362685dd25$export$df995fae86a55f06(auth) {
    (0, $6S5H6.getModularInstance)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $e115db362685dd25$export$ef35774e6d314e91(auth, user) {
    return (0, $6S5H6.getModularInstance)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $e115db362685dd25$export$e7094788287c5e9b(auth) {
    return (0, $6S5H6.getModularInstance)(auth).signOut();
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $e115db362685dd25$export$96f57966bedc81b4(user) {
    return (0, $6S5H6.getModularInstance)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e115db362685dd25$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $e115db362685dd25$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $e115db362685dd25$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? "idToken" : "pendingCredential";
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return $e115db362685dd25$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return $e115db362685dd25$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e115db362685dd25$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $e115db362685dd25$export$b9a6b53f9be3734(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$e115db362685dd25$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $e115db362685dd25$export$9d398bebfec1c039(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $e115db362685dd25$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $e115db362685dd25$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $e115db362685dd25$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $e115db362685dd25$export$9d398bebfec1c039(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $e115db362685dd25$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $e115db362685dd25$export$92108d983e8ee699(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $e115db362685dd25$export$d24c54395ce0c509(auth, error) {
    var _a;
    const authModular = (0, $6S5H6.getModularInstance)(auth);
    const errorInternal = error;
    $e115db362685dd25$export$9d398bebfec1c039(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $e115db362685dd25$export$9d398bebfec1c039((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $e115db362685dd25$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e115db362685dd25$var$startEnrollPhoneMfa(auth, request) {
    return $e115db362685dd25$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
function $e115db362685dd25$var$finalizeEnrollPhoneMfa(auth, request) {
    return $e115db362685dd25$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
function $e115db362685dd25$var$startEnrollTotpMfa(auth, request) {
    return $e115db362685dd25$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
function $e115db362685dd25$var$finalizeEnrollTotpMfa(auth, request) {
    return $e115db362685dd25$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
function $e115db362685dd25$var$withdrawMfa(auth, request) {
    return $e115db362685dd25$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
class $e115db362685dd25$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$e115db362685dd25$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $e115db362685dd25$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $e115db362685dd25$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $e115db362685dd25$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === "string" ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $e115db362685dd25$var$_logoutIfInvalidated(this.user, $e115db362685dd25$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $e115db362685dd25$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $e115db362685dd25$export$6554612db691658e(user) {
    const userModular = (0, $6S5H6.getModularInstance)(user);
    if (!$e115db362685dd25$var$multiFactorUserCache.has(userModular)) $e115db362685dd25$var$multiFactorUserCache.set(userModular, $e115db362685dd25$var$MultiFactorUserImpl._fromUser(userModular));
    return $e115db362685dd25$var$multiFactorUserCache.get(userModular);
}
const $e115db362685dd25$var$STORAGE_AVAILABLE_KEY = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $e115db362685dd25$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($e115db362685dd25$var$STORAGE_AVAILABLE_KEY, "1");
            this.storage.removeItem($e115db362685dd25$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e115db362685dd25$var$_iframeCannotSyncWebStorage() {
    const ua = (0, $6S5H6.getUA)();
    return $e115db362685dd25$var$_isSafari(ua) || $e115db362685dd25$export$1fbe638ecf81657e(ua);
}
// The polling period in case events are not supported
const $e115db362685dd25$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $e115db362685dd25$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $e115db362685dd25$var$BrowserLocalPersistence extends $e115db362685dd25$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Safari or iOS browser and embedded in an iframe.
        this.safariLocalStorageNotSynced = $e115db362685dd25$var$_iframeCannotSyncWebStorage() && $e115db362685dd25$var$_isIframe();
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $e115db362685dd25$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        // Safari embedded iframe. Storage event will trigger with the delta
        // changes but no changes will be applied to the iframe localStorage.
        if (this.safariLocalStorageNotSynced) {
            // Get current iframe page value.
            const storedValue = this.storage.getItem(key);
            // Value not synchronized, synchronize manually.
            if (event.newValue !== storedValue) {
                if (event.newValue !== null) // Value changed from current value.
                this.storage.setItem(key, event.newValue);
                else // Current value deleted.
                this.storage.removeItem(key);
            } else if (this.localCache[key] === event.newValue && !poll) // Already detected and processed, do not trigger listeners again.
            return;
        }
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($e115db362685dd25$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $e115db362685dd25$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent("storage", {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $e115db362685dd25$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener("storage", this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener("storage", this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$e115db362685dd25$var$BrowserLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $e115db362685dd25$export$8b22cf2602fb60ce = $e115db362685dd25$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e115db362685dd25$var$BrowserSessionPersistence extends $e115db362685dd25$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$e115db362685dd25$var$BrowserSessionPersistence.type = "SESSION";
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $e115db362685dd25$export$407448d2b89b1813 = $e115db362685dd25$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $e115db362685dd25$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $e115db362685dd25$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $e115db362685dd25$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $e115db362685dd25$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener("message", this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optinoal event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener("message", this.boundEventHandler);
    }
}
$e115db362685dd25$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e115db362685dd25$export$9f4f30ee63539e24(prefix = "", digits = 10) {
    let random = "";
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $e115db362685dd25$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener("message", handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== "undefined" ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $e115db362685dd25$export$9f4f30ee63539e24("", 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener("message", handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $e115db362685dd25$var$_window() {
    return window;
}
function $e115db362685dd25$var$_setWindowLocation(url) {
    $e115db362685dd25$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e115db362685dd25$var$_isWorker() {
    return typeof $e115db362685dd25$var$_window()["WorkerGlobalScope"] !== "undefined" && typeof $e115db362685dd25$var$_window()["importScripts"] === "function";
}
async function $e115db362685dd25$var$_getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function $e115db362685dd25$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $e115db362685dd25$var$_getWorkerGlobalScope() {
    return $e115db362685dd25$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e115db362685dd25$var$DB_NAME = "firebaseLocalStorageDb";
const $e115db362685dd25$var$DB_VERSION = 1;
const $e115db362685dd25$var$DB_OBJECTSTORE_NAME = "firebaseLocalStorage";
const $e115db362685dd25$var$DB_DATA_KEYPATH = "fbase_key";
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $e115db362685dd25$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener("success", ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener("error", ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $e115db362685dd25$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $e115db362685dd25$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? "readwrite" : "readonly").objectStore($e115db362685dd25$var$DB_OBJECTSTORE_NAME);
}
function $e115db362685dd25$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($e115db362685dd25$var$DB_NAME);
    return new $e115db362685dd25$var$DBPromise(request).toPromise();
}
function $e115db362685dd25$var$_openDatabase() {
    const request = indexedDB.open($e115db362685dd25$var$DB_NAME, $e115db362685dd25$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener("error", ()=>{
            reject(request.error);
        });
        request.addEventListener("upgradeneeded", ()=>{
            const db = request.result;
            try {
                db.createObjectStore($e115db362685dd25$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $e115db362685dd25$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener("success", async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($e115db362685dd25$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $e115db362685dd25$var$_deleteDatabase();
                resolve(await $e115db362685dd25$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $e115db362685dd25$var$_putObject(db, key, value) {
    const request = $e115db362685dd25$var$getObjectStore(db, true).put({
        [$e115db362685dd25$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $e115db362685dd25$var$DBPromise(request).toPromise();
}
async function $e115db362685dd25$var$getObject(db, key) {
    const request = $e115db362685dd25$var$getObjectStore(db, false).get(key);
    const data = await new $e115db362685dd25$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $e115db362685dd25$var$_deleteObject(db, key) {
    const request = $e115db362685dd25$var$getObjectStore(db, true).delete(key);
    return new $e115db362685dd25$var$DBPromise(request).toPromise();
}
const $e115db362685dd25$var$_POLLING_INTERVAL_MS = 800;
const $e115db362685dd25$var$_TRANSACTION_RETRY_COUNT = 3;
class $e115db362685dd25$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $e115db362685dd25$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $e115db362685dd25$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $e115db362685dd25$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $e115db362685dd25$var$Receiver._getInstance($e115db362685dd25$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $e115db362685dd25$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $e115db362685dd25$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $e115db362685dd25$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $e115db362685dd25$var$_openDatabase();
            await $e115db362685dd25$var$_putObject(db, $e115db362685dd25$var$STORAGE_AVAILABLE_KEY, "1");
            await $e115db362685dd25$var$_deleteObject(db, $e115db362685dd25$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$e115db362685dd25$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$e115db362685dd25$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$e115db362685dd25$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $e115db362685dd25$var$getObjectStore(db, false).getAll();
            return new $e115db362685dd25$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $e115db362685dd25$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$e115db362685dd25$var$IndexedDBLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $e115db362685dd25$export$23f2a1d2818174ef = $e115db362685dd25$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e115db362685dd25$var$startSignInPhoneMfa(auth, request) {
    return $e115db362685dd25$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
function $e115db362685dd25$var$finalizeSignInPhoneMfa(auth, request) {
    return $e115db362685dd25$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
function $e115db362685dd25$var$finalizeSignInTotpMfa(auth, request) {
    return $e115db362685dd25$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $e115db362685dd25$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e115db362685dd25$var$_SOLVE_TIME_MS = 500;
const $e115db362685dd25$var$_EXPIRATION_TIME_MS = 60000;
const $e115db362685dd25$var$_WIDGET_ID_START = 1000000000000;
class $e115db362685dd25$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $e115db362685dd25$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $e115db362685dd25$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || $e115db362685dd25$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || $e115db362685dd25$var$_WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || "";
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || $e115db362685dd25$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return "";
    }
}
class $e115db362685dd25$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $e115db362685dd25$export$9d398bebfec1c039(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== "invisible";
        if (this.isVisible) this.execute();
        else this.container.addEventListener("click", this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener("click", this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $e115db362685dd25$var$generateRandomAlphaNumericString(50);
            const { callback: callback, "expired-callback": expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $e115db362685dd25$var$_EXPIRATION_TIME_MS);
        }, $e115db362685dd25$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error("reCAPTCHA mock was already deleted!");
    }
}
function $e115db362685dd25$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join("");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $e115db362685dd25$var$_JSLOAD_CALLBACK = $e115db362685dd25$var$_generateCallbackName("rcb");
const $e115db362685dd25$var$NETWORK_TIMEOUT_DELAY = new $e115db362685dd25$var$Delay(30000, 60000);
const $e115db362685dd25$var$RECAPTCHA_BASE = "https://www.google.com/recaptcha/api.js?";
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $e115db362685dd25$var$ReCaptchaLoaderImpl {
    constructor(){
        var _a;
        this.hostLanguage = "";
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = $e115db362685dd25$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    load(auth, hl = "") {
        $e115db362685dd25$export$9d398bebfec1c039($e115db362685dd25$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $e115db362685dd25$var$isV2($e115db362685dd25$var$_window().grecaptcha)) return Promise.resolve($e115db362685dd25$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $e115db362685dd25$var$_window().setTimeout(()=>{
                reject($e115db362685dd25$export$91c6e00c14e7e6fd(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $e115db362685dd25$var$NETWORK_TIMEOUT_DELAY.get());
            $e115db362685dd25$var$_window()[$e115db362685dd25$var$_JSLOAD_CALLBACK] = ()=>{
                $e115db362685dd25$var$_window().clearTimeout(networkTimeout);
                delete $e115db362685dd25$var$_window()[$e115db362685dd25$var$_JSLOAD_CALLBACK];
                const recaptcha = $e115db362685dd25$var$_window().grecaptcha;
                if (!recaptcha || !$e115db362685dd25$var$isV2(recaptcha)) {
                    reject($e115db362685dd25$export$91c6e00c14e7e6fd(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the greptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$e115db362685dd25$var$RECAPTCHA_BASE}?${(0, $6S5H6.querystring)({
                onload: $e115db362685dd25$var$_JSLOAD_CALLBACK,
                render: "explicit",
                hl: hl
            })}`;
            $e115db362685dd25$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($e115db362685dd25$export$91c6e00c14e7e6fd(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        var _a;
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!((_a = $e115db362685dd25$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $e115db362685dd25$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $e115db362685dd25$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $e115db362685dd25$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e115db362685dd25$var$RECAPTCHA_VERIFIER_TYPE = "recaptcha";
const $e115db362685dd25$var$DEFAULT_PARAMS = {
    theme: "light",
    type: "image"
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $e115db362685dd25$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = Object.assign({}, $e115db362685dd25$var$DEFAULT_PARAMS)){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $e115db362685dd25$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $e115db362685dd25$export$b9a6b53f9be3734(authExtern);
        this.isInvisible = this.parameters.size === "invisible";
        $e115db362685dd25$export$9d398bebfec1c039(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $e115db362685dd25$export$9d398bebfec1c039(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $e115db362685dd25$var$MockReCaptchaLoaderImpl() : new $e115db362685dd25$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $e115db362685dd25$export$9d398bebfec1c039(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $e115db362685dd25$export$9d398bebfec1c039(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $e115db362685dd25$export$9d398bebfec1c039(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === "function") existing(token);
            else if (typeof existing === "string") {
                const globalFunc = $e115db362685dd25$var$_window()[existing];
                if (typeof globalFunc === "function") globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $e115db362685dd25$export$9d398bebfec1c039(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement("div");
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $e115db362685dd25$export$9d398bebfec1c039($e115db362685dd25$var$_isHttpOrHttps() && !$e115db362685dd25$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $e115db362685dd25$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $e115db362685dd25$var$getRecaptchaParams(this.auth);
        $e115db362685dd25$export$9d398bebfec1c039(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $e115db362685dd25$export$9d398bebfec1c039(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $e115db362685dd25$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === "complete") {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener("load", resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener("load", resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e115db362685dd25$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $e115db362685dd25$export$a07804094c3ecf2d._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $e115db362685dd25$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    const authInternal = $e115db362685dd25$export$b9a6b53f9be3734(auth);
    const verificationId = await $e115db362685dd25$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $6S5H6.getModularInstance)(appVerifier));
    return new $e115db362685dd25$var$ConfirmationResultImpl(verificationId, (cred)=>$e115db362685dd25$export$34aec0b863436764(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $e115db362685dd25$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $6S5H6.getModularInstance)(user);
    await $e115db362685dd25$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $e115db362685dd25$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $6S5H6.getModularInstance)(appVerifier));
    return new $e115db362685dd25$var$ConfirmationResultImpl(verificationId, (cred)=>$e115db362685dd25$export$3c2fa207a37baaea(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $e115db362685dd25$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $6S5H6.getModularInstance)(user);
    const verificationId = await $e115db362685dd25$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $6S5H6.getModularInstance)(appVerifier));
    return new $e115db362685dd25$var$ConfirmationResultImpl(verificationId, (cred)=>$e115db362685dd25$export$ce26c07117d59d6a(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $e115db362685dd25$var$_verifyPhoneNumber(auth, options, verifier) {
    var _a;
    const recaptchaToken = await verifier.verify();
    try {
        $e115db362685dd25$export$9d398bebfec1c039(typeof recaptchaToken === "string", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $e115db362685dd25$export$9d398bebfec1c039(verifier.type === $e115db362685dd25$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        let phoneInfoOptions;
        if (typeof options === "string") phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ("session" in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ("phoneNumber" in phoneInfoOptions) {
                $e115db362685dd25$export$9d398bebfec1c039(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const response = await $e115db362685dd25$var$startEnrollPhoneMfa(auth, {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $e115db362685dd25$export$9d398bebfec1c039(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                $e115db362685dd25$export$9d398bebfec1c039(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const response = await $e115db362685dd25$var$startSignInPhoneMfa(auth, {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const { sessionInfo: sessionInfo } = await $e115db362685dd25$var$sendPhoneVerificationCode(auth, {
                phoneNumber: phoneInfoOptions.phoneNumber,
                recaptchaToken: recaptchaToken
            });
            return sessionInfo;
        }
    } finally{
        verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $e115db362685dd25$export$3b14a55fb2447963(user, credential) {
    await $e115db362685dd25$var$_link$1((0, $6S5H6.getModularInstance)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $e115db362685dd25$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $e115db362685dd25$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $e115db362685dd25$export$b9a6b53f9be3734(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $e115db362685dd25$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $6S5H6.getModularInstance)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $e115db362685dd25$export$a07804094c3ecf2d._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $e115db362685dd25$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $e115db362685dd25$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $e115db362685dd25$export$a07804094c3ecf2d._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $e115db362685dd25$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $e115db362685dd25$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $e115db362685dd25$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $e115db362685dd25$export$24baa2b76016ce0e(resolverOverride);
    $e115db362685dd25$export$9d398bebfec1c039(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e115db362685dd25$var$IdpCredential extends $e115db362685dd25$export$3466f893ebf79586 {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $e115db362685dd25$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $e115db362685dd25$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $e115db362685dd25$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $e115db362685dd25$var$_signIn(params) {
    return $e115db362685dd25$var$_signInWithCredential(params.auth, new $e115db362685dd25$var$IdpCredential(params), params.bypassAuthState);
}
function $e115db362685dd25$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $e115db362685dd25$export$9d398bebfec1c039(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $e115db362685dd25$var$_reauthenticate(user, new $e115db362685dd25$var$IdpCredential(params), params.bypassAuthState);
}
async function $e115db362685dd25$var$_link(params) {
    const { auth: auth, user: user } = params;
    $e115db362685dd25$export$9d398bebfec1c039(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $e115db362685dd25$var$_link$1(user, new $e115db362685dd25$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $e115db362685dd25$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $e115db362685dd25$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $e115db362685dd25$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $e115db362685dd25$var$_reauth;
            default:
                $e115db362685dd25$export$92108d983e8ee699(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $e115db362685dd25$export$493d36ec626b6698(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $e115db362685dd25$export$493d36ec626b6698(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e115db362685dd25$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $e115db362685dd25$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $e115db362685dd25$export$db3b6bfb95261072(auth, provider, resolver) {
    const authInternal = $e115db362685dd25$export$b9a6b53f9be3734(auth);
    $e115db362685dd25$var$_assertInstanceOf(auth, provider, $e115db362685dd25$var$FederatedAuthProvider);
    const resolverInternal = $e115db362685dd25$var$_withDefaultResolver(authInternal, resolver);
    const action = new $e115db362685dd25$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $e115db362685dd25$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $6S5H6.getModularInstance)(user);
    $e115db362685dd25$var$_assertInstanceOf(userInternal.auth, provider, $e115db362685dd25$var$FederatedAuthProvider);
    const resolverInternal = $e115db362685dd25$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $e115db362685dd25$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $e115db362685dd25$export$4368d992c4eafac0(user, provider, resolver) {
    const userInternal = (0, $6S5H6.getModularInstance)(user);
    $e115db362685dd25$var$_assertInstanceOf(userInternal.auth, provider, $e115db362685dd25$var$FederatedAuthProvider);
    const resolverInternal = $e115db362685dd25$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $e115db362685dd25$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $e115db362685dd25$var$PopupOperation extends $e115db362685dd25$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($e115db362685dd25$var$PopupOperation.currentPopupAction) $e115db362685dd25$var$PopupOperation.currentPopupAction.cancel();
        $e115db362685dd25$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $e115db362685dd25$export$9d398bebfec1c039(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $e115db362685dd25$export$493d36ec626b6698(this.filter.length === 1, "Popup operations only handle one event");
        const eventId = $e115db362685dd25$export$9f4f30ee63539e24();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($e115db362685dd25$export$91c6e00c14e7e6fd(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject($e115db362685dd25$export$91c6e00c14e7e6fd(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $e115db362685dd25$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($e115db362685dd25$export$91c6e00c14e7e6fd(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $e115db362685dd25$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$e115db362685dd25$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e115db362685dd25$var$PENDING_REDIRECT_KEY = "pendingRedirect";
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $e115db362685dd25$var$redirectOutcomeMap = new Map();
class $e115db362685dd25$var$RedirectAction extends $e115db362685dd25$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $e115db362685dd25$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $e115db362685dd25$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $e115db362685dd25$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $e115db362685dd25$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $e115db362685dd25$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $e115db362685dd25$var$pendingRedirectKey(auth);
    const persistence = $e115db362685dd25$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === "true";
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $e115db362685dd25$var$_setPendingRedirectStatus(resolver, auth) {
    return $e115db362685dd25$var$resolverPersistence(resolver)._set($e115db362685dd25$var$pendingRedirectKey(auth), "true");
}
function $e115db362685dd25$export$a33b77bbdbb8366c() {
    $e115db362685dd25$var$redirectOutcomeMap.clear();
}
function $e115db362685dd25$export$53a70dd1ebbae346(auth, result) {
    $e115db362685dd25$var$redirectOutcomeMap.set(auth._key(), result);
}
function $e115db362685dd25$var$resolverPersistence(resolver) {
    return $e115db362685dd25$export$24baa2b76016ce0e(resolver._redirectPersistence);
}
function $e115db362685dd25$var$pendingRedirectKey(auth) {
    return $e115db362685dd25$export$158acd800e1ef08b($e115db362685dd25$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $e115db362685dd25$export$2d1720544b23b823(auth, provider, resolver) {
    return $e115db362685dd25$var$_signInWithRedirect(auth, provider, resolver);
}
async function $e115db362685dd25$var$_signInWithRedirect(auth, provider, resolver) {
    const authInternal = $e115db362685dd25$export$b9a6b53f9be3734(auth);
    $e115db362685dd25$var$_assertInstanceOf(auth, provider, $e115db362685dd25$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $e115db362685dd25$var$_withDefaultResolver(authInternal, resolver);
    await $e115db362685dd25$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $e115db362685dd25$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $e115db362685dd25$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $e115db362685dd25$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $6S5H6.getModularInstance)(user);
    $e115db362685dd25$var$_assertInstanceOf(userInternal.auth, provider, $e115db362685dd25$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $e115db362685dd25$var$_withDefaultResolver(userInternal.auth, resolver);
    await $e115db362685dd25$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $e115db362685dd25$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $e115db362685dd25$export$39b482c5e57630a8(user, provider, resolver) {
    return $e115db362685dd25$var$_linkWithRedirect(user, provider, resolver);
}
async function $e115db362685dd25$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $6S5H6.getModularInstance)(user);
    $e115db362685dd25$var$_assertInstanceOf(userInternal.auth, provider, $e115db362685dd25$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $e115db362685dd25$var$_withDefaultResolver(userInternal.auth, resolver);
    await $e115db362685dd25$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $e115db362685dd25$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $e115db362685dd25$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $e115db362685dd25$export$35e795649ee09318(auth, resolver) {
    await $e115db362685dd25$export$b9a6b53f9be3734(auth)._initializationPromise;
    return $e115db362685dd25$export$cf2f7c5792f80b46(auth, resolver, false);
}
async function $e115db362685dd25$export$cf2f7c5792f80b46(auth, resolverExtern, bypassAuthState = false) {
    const authInternal = $e115db362685dd25$export$b9a6b53f9be3734(auth);
    const resolver = $e115db362685dd25$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $e115db362685dd25$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $e115db362685dd25$var$prepareUserForRedirect(user) {
    const eventId = $e115db362685dd25$export$9f4f30ee63539e24(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $e115db362685dd25$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $e115db362685dd25$export$890c4ad488842ce7 {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$e115db362685dd25$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !$e115db362685dd25$var$isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split("auth/")[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($e115db362685dd25$export$91c6e00c14e7e6fd(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $e115db362685dd25$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($e115db362685dd25$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($e115db362685dd25$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $e115db362685dd25$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join("-");
}
function $e115db362685dd25$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $e115db362685dd25$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $e115db362685dd25$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e115db362685dd25$export$28f7fcd39efa255(auth, request = {}) {
    return $e115db362685dd25$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e115db362685dd25$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $e115db362685dd25$var$HTTP_REGEX = /^https?/;
async function $e115db362685dd25$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $e115db362685dd25$export$28f7fcd39efa255(auth);
    for (const domain of authorizedDomains)try {
        if ($e115db362685dd25$var$matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $e115db362685dd25$export$92108d983e8ee699(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $e115db362685dd25$var$matchDomain(expected) {
    const currentUrl = $e115db362685dd25$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith("chrome-extension://")) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === "" && hostname === "") // For some reason we're not parsing chrome URLs properly
        return protocol === "chrome-extension:" && expected.replace("chrome-extension://", "") === currentUrl.replace("chrome-extension://", "");
        return protocol === "chrome-extension:" && ceUrl.hostname === hostname;
    }
    if (!$e115db362685dd25$var$HTTP_REGEX.test(protocol)) return false;
    if ($e115db362685dd25$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, "\\.");
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp("^(.+\\." + escapedDomainPattern + "|" + escapedDomainPattern + ")$", "i");
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e115db362685dd25$var$NETWORK_TIMEOUT = new $e115db362685dd25$var$Delay(30000, 60000);
/**
 * Reset unlaoded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $e115db362685dd25$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $e115db362685dd25$var$_window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $e115db362685dd25$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $e115db362685dd25$var$resetUnloadedGapiModules();
            gapi.load("gapi.iframes", {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $e115db362685dd25$var$resetUnloadedGapiModules();
                    reject($e115db362685dd25$export$91c6e00c14e7e6fd(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $e115db362685dd25$var$NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = $e115db362685dd25$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $e115db362685dd25$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $e115db362685dd25$var$_generateCallbackName("iframefcb");
            // GApi loader not available, dynamically load platform.js.
            $e115db362685dd25$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($e115db362685dd25$export$91c6e00c14e7e6fd(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $e115db362685dd25$var$_loadJS(`https://apis.google.com/js/api.js?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $e115db362685dd25$var$cachedGApiLoader = null;
        throw error;
    });
}
let $e115db362685dd25$var$cachedGApiLoader = null;
function $e115db362685dd25$var$_loadGapi(auth) {
    $e115db362685dd25$var$cachedGApiLoader = $e115db362685dd25$var$cachedGApiLoader || $e115db362685dd25$var$loadGapi(auth);
    return $e115db362685dd25$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e115db362685dd25$var$PING_TIMEOUT = new $e115db362685dd25$var$Delay(5000, 15000);
const $e115db362685dd25$var$IFRAME_PATH = "__/auth/iframe";
const $e115db362685dd25$var$EMULATED_IFRAME_PATH = "emulator/auth/iframe";
const $e115db362685dd25$var$IFRAME_ATTRIBUTES = {
    style: {
        position: "absolute",
        top: "-100px",
        width: "1px",
        height: "1px"
    },
    "aria-hidden": "true",
    tabindex: "-1"
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $e115db362685dd25$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        "p"
    ],
    [
        "staging-identitytoolkit.sandbox.googleapis.com",
        "s"
    ],
    [
        "test-identitytoolkit.sandbox.googleapis.com",
        "t"
    ] // test
]);
function $e115db362685dd25$var$getIframeUrl(auth) {
    const config = auth.config;
    $e115db362685dd25$export$9d398bebfec1c039(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $e115db362685dd25$var$_emulatorUrl(config, $e115db362685dd25$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$e115db362685dd25$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $6HgFA.SDK_VERSION)
    };
    const eid = $e115db362685dd25$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(",");
    return `${url}?${(0, $6S5H6.querystring)(params).slice(1)}`;
}
async function $e115db362685dd25$var$_openIframe(auth) {
    const context = await $e115db362685dd25$var$_loadGapi(auth);
    const gapi1 = $e115db362685dd25$var$_window().gapi;
    $e115db362685dd25$export$9d398bebfec1c039(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $e115db362685dd25$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $e115db362685dd25$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $e115db362685dd25$export$91c6e00c14e7e6fd(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $e115db362685dd25$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $e115db362685dd25$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $e115db362685dd25$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e115db362685dd25$var$BASE_POPUP_OPTIONS = {
    location: "yes",
    resizable: "yes",
    statusbar: "yes",
    toolbar: "no"
};
const $e115db362685dd25$var$DEFAULT_WIDTH = 500;
const $e115db362685dd25$var$DEFAULT_HEIGHT = 600;
const $e115db362685dd25$var$TARGET_BLANK = "_blank";
const $e115db362685dd25$var$FIREFOX_EMPTY_URL = "http://localhost";
class $e115db362685dd25$export$faec65b429be379 {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $e115db362685dd25$var$_open(auth, url, name, width = $e115db362685dd25$var$DEFAULT_WIDTH, height = $e115db362685dd25$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = "";
    const options = Object.assign(Object.assign({}, $e115db362685dd25$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $6S5H6.getUA)().toLowerCase();
    if (name) target = $e115db362685dd25$var$_isChromeIOS(ua) ? $e115db362685dd25$var$TARGET_BLANK : name;
    if ($e115db362685dd25$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $e115db362685dd25$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = "yes";
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, "");
    if ($e115db362685dd25$var$_isIOSStandalone(ua) && target !== "_self") {
        $e115db362685dd25$var$openAsNewWindowIOS(url || "", target);
        return new $e115db362685dd25$export$faec65b429be379(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || "", target, optionsString);
    $e115db362685dd25$export$9d398bebfec1c039(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $e115db362685dd25$export$faec65b429be379(newWin);
}
function $e115db362685dd25$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement("a");
    el.href = url;
    el.target = target;
    const click = document.createEvent("MouseEvent");
    click.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $e115db362685dd25$var$WIDGET_PATH = "__/auth/handler";
/**
 * URL for emulated environment
 *
 * @internal
 */ const $e115db362685dd25$var$EMULATOR_WIDGET_PATH = "emulator/auth/handler";
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $e115db362685dd25$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent("fac");
async function $e115db362685dd25$export$9fa96a7d116ea3ce(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $e115db362685dd25$export$9d398bebfec1c039(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $e115db362685dd25$export$9d398bebfec1c039(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $6HgFA.SDK_VERSION),
        eventId: eventId
    };
    if (provider instanceof $e115db362685dd25$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || "";
        if (!(0, $6S5H6.isEmpty)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $e115db362685dd25$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== "");
        if (scopes.length > 0) params.scopes = scopes.join(",");
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endipointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$e115db362685dd25$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : "";
    // Start at index 1 to skip the leading '&' in the query string
    return `${$e115db362685dd25$var$getHandlerBase(auth)}?${(0, $6S5H6.querystring)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $e115db362685dd25$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$e115db362685dd25$var$WIDGET_PATH}`;
    return $e115db362685dd25$var$_emulatorUrl(config, $e115db362685dd25$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $e115db362685dd25$var$WEB_STORAGE_SUPPORT_KEY = "webStorageSupport";
class $e115db362685dd25$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $e115db362685dd25$export$407448d2b89b1813;
        this._completeRedirectFn = $e115db362685dd25$export$cf2f7c5792f80b46;
        this._overrideRedirectResult = $e115db362685dd25$export$53a70dd1ebbae346;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        $e115db362685dd25$export$493d36ec626b6698((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, "_initialize() not called before _openPopup()");
        const url = await $e115db362685dd25$export$9fa96a7d116ea3ce(auth, provider, authType, $e115db362685dd25$var$_getCurrentUrl(), eventId);
        return $e115db362685dd25$var$_open(auth, url, $e115db362685dd25$export$9f4f30ee63539e24());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $e115db362685dd25$export$9fa96a7d116ea3ce(auth, provider, authType, $e115db362685dd25$var$_getCurrentUrl(), eventId);
        $e115db362685dd25$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $e115db362685dd25$export$493d36ec626b6698(promise, "If manager is not set, promise should be");
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $e115db362685dd25$var$_openIframe(auth);
        const manager = new $e115db362685dd25$export$890c4ad488842ce7(auth);
        iframe.register("authEvent", (iframeEvent)=>{
            $e115db362685dd25$export$9d398bebfec1c039(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($e115db362685dd25$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $e115db362685dd25$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$e115db362685dd25$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $e115db362685dd25$export$92108d983e8ee699(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $e115db362685dd25$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $e115db362685dd25$var$_isMobileBrowser() || $e115db362685dd25$var$_isSafari() || $e115db362685dd25$export$1fbe638ecf81657e();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $e115db362685dd25$export$342063e11d6c3cad = $e115db362685dd25$var$BrowserPopupRedirectResolver;
class $e115db362685dd25$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $e115db362685dd25$var$debugFail("unexpected MultiFactorSessionType");
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $e115db362685dd25$var$PhoneMultiFactorAssertionImpl extends $e115db362685dd25$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $e115db362685dd25$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $e115db362685dd25$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $e115db362685dd25$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $e115db362685dd25$export$953cecd6e717a553 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $e115db362685dd25$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $e115db362685dd25$export$953cecd6e717a553.FACTOR_ID = "phone";
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $e115db362685dd25$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $e115db362685dd25$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $e115db362685dd25$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        var _a;
        const mfaSession = session;
        $e115db362685dd25$export$9d398bebfec1c039(typeof ((_a = mfaSession.user) === null || _a === void 0 ? void 0 : _a.auth) !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $e115db362685dd25$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $e115db362685dd25$export$7ccc53e8f1e7dfc5._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $e115db362685dd25$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $e115db362685dd25$var$TotpMultiFactorAssertionImpl extends $e115db362685dd25$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $e115db362685dd25$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $e115db362685dd25$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $e115db362685dd25$export$9d398bebfec1c039(typeof this.secret !== "undefined", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $e115db362685dd25$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $e115db362685dd25$export$9d398bebfec1c039(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $e115db362685dd25$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $e115db362685dd25$export$7ccc53e8f1e7dfc5 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $e115db362685dd25$export$7ccc53e8f1e7dfc5(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        var _a;
        let useDefaults = false;
        if ($e115db362685dd25$var$_isEmptyString(accountName) || $e115db362685dd25$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($e115db362685dd25$var$_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || "unknownuser";
            if ($e115db362685dd25$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $e115db362685dd25$var$_isEmptyString(input) {
    return typeof input === "undefined" || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var $e115db362685dd25$var$name = "@firebase/auth";
var $e115db362685dd25$var$version = "1.3.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e115db362685dd25$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $e115db362685dd25$export$9d398bebfec1c039(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e115db362685dd25$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return "node";
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return "rn";
        case "Worker" /* ClientPlatform.WORKER */ :
            return "webworker";
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return "cordova";
        default:
            return undefined;
    }
}
/** @internal */ function $e115db362685dd25$var$registerAuth(clientPlatform) {
    (0, $6HgFA._registerComponent)(new (0, $1jeZY.Component)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider("app").getImmediate();
        const heartbeatServiceProvider = container.getProvider("heartbeat");
        const appCheckServiceProvider = container.getProvider("app-check-internal");
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $e115db362685dd25$export$9d398bebfec1c039(apiKey && !apiKey.includes(":"), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $e115db362685dd25$export$91477dc880baac21(clientPlatform)
        };
        const authInstance = new $e115db362685dd25$export$23ebac1979863676(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $e115db362685dd25$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $6HgFA._registerComponent)(new (0, $1jeZY.Component)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $e115db362685dd25$export$b9a6b53f9be3734(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $e115db362685dd25$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $6HgFA.registerVersion)($e115db362685dd25$var$name, $e115db362685dd25$var$version, $e115db362685dd25$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $6HgFA.registerVersion)($e115db362685dd25$var$name, $e115db362685dd25$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e115db362685dd25$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $e115db362685dd25$var$authIdTokenMaxAge = (0, $6S5H6.getExperimentalSetting)("authIdTokenMaxAge") || $e115db362685dd25$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $e115db362685dd25$var$lastPostedIdToken = null;
const $e115db362685dd25$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $e115db362685dd25$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
        if ($e115db362685dd25$var$lastPostedIdToken === idToken) return;
        $e115db362685dd25$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? "POST" : "DELETE",
            headers: idToken ? {
                "Authorization": `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $e115db362685dd25$export$ae1af26003f05816(app = (0, $6HgFA.getApp)()) {
    const provider = (0, $6HgFA._getProvider)(app, "auth");
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $e115db362685dd25$export$9bb611d729802a56(app, {
        popupRedirectResolver: $e115db362685dd25$export$342063e11d6c3cad,
        persistence: [
            $e115db362685dd25$export$23f2a1d2818174ef,
            $e115db362685dd25$export$8b22cf2602fb60ce,
            $e115db362685dd25$export$407448d2b89b1813
        ]
    });
    const authTokenSyncUrl = (0, $6S5H6.getExperimentalSetting)("authTokenSyncURL");
    if (authTokenSyncUrl) {
        const mintCookie = $e115db362685dd25$var$mintCookieFactory(authTokenSyncUrl);
        $e115db362685dd25$export$d141bba7fdc215a3(auth, mintCookie, ()=>mintCookie(auth.currentUser));
        $e115db362685dd25$export$efccba1c4a2ef57b(auth, (user)=>mintCookie(user));
    }
    const authEmulatorHost = (0, $6S5H6.getDefaultEmulatorHost)("auth");
    if (authEmulatorHost) $e115db362685dd25$export$b4171a6734a65d42(auth, `http://${authEmulatorHost}`);
    return auth;
}
$e115db362685dd25$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );

});
parcelRequire.register("6S5H6", function(module, exports) {

$parcel$export(module.exports, "base64urlEncodeWithoutPadding", function () { return $500c33f4d2371b87$export$4b5284a3025a455; });
$parcel$export(module.exports, "base64Decode", function () { return $500c33f4d2371b87$export$c62426fdd000a97e; });
$parcel$export(module.exports, "getDefaultEmulatorHost", function () { return $500c33f4d2371b87$export$9c11895284c8adad; });
$parcel$export(module.exports, "getDefaultAppConfig", function () { return $500c33f4d2371b87$export$3dfb6827a9f89756; });
$parcel$export(module.exports, "getExperimentalSetting", function () { return $500c33f4d2371b87$export$5539a1a3afe87d6; });
$parcel$export(module.exports, "Deferred", function () { return $500c33f4d2371b87$export$85f6557964517f1a; });
$parcel$export(module.exports, "getUA", function () { return $500c33f4d2371b87$export$c36915b22ce77c19; });
$parcel$export(module.exports, "isMobileCordova", function () { return $500c33f4d2371b87$export$872f8323f01d7ae0; });
$parcel$export(module.exports, "isBrowserExtension", function () { return $500c33f4d2371b87$export$caa8774a9107a58e; });
$parcel$export(module.exports, "isReactNative", function () { return $500c33f4d2371b87$export$f7a1e23e542d38e3; });
$parcel$export(module.exports, "isIE", function () { return $500c33f4d2371b87$export$7e7b1a9668aaed8; });
$parcel$export(module.exports, "isIndexedDBAvailable", function () { return $500c33f4d2371b87$export$3865db50535c2055; });
$parcel$export(module.exports, "validateIndexedDBOpenable", function () { return $500c33f4d2371b87$export$a8a3018f3d187a4d; });
$parcel$export(module.exports, "FirebaseError", function () { return $500c33f4d2371b87$export$dd24e9cd51226c56; });
$parcel$export(module.exports, "ErrorFactory", function () { return $500c33f4d2371b87$export$3fa6e1b18a3b2d40; });
$parcel$export(module.exports, "isEmpty", function () { return $500c33f4d2371b87$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "deepEqual", function () { return $500c33f4d2371b87$export$9cb4719e2e525b7a; });
$parcel$export(module.exports, "querystring", function () { return $500c33f4d2371b87$export$ac4103b836844853; });
$parcel$export(module.exports, "querystringDecode", function () { return $500c33f4d2371b87$export$c1271ca4c8a70741; });
$parcel$export(module.exports, "extractQuerystring", function () { return $500c33f4d2371b87$export$1a8408415472d8ed; });
$parcel$export(module.exports, "createSubscribe", function () { return $500c33f4d2371b87$export$364097d812234b3f; });
$parcel$export(module.exports, "getModularInstance", function () { return $500c33f4d2371b87$export$4befe9b5fa509a1b; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ 
var $bDPlX = parcelRequire("bDPlX");
const $500c33f4d2371b87$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $500c33f4d2371b87$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $500c33f4d2371b87$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $500c33f4d2371b87$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $500c33f4d2371b87$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $500c33f4d2371b87$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $500c33f4d2371b87$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $500c33f4d2371b87$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($500c33f4d2371b87$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $500c33f4d2371b87$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $500c33f4d2371b87$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $500c33f4d2371b87$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = "DecodeBase64StringError";
    }
}
/**
 * URL-safe base64 encoding
 */ const $500c33f4d2371b87$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $500c33f4d2371b87$var$stringToByteArray$1(str);
    return $500c33f4d2371b87$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $500c33f4d2371b87$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $500c33f4d2371b87$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $500c33f4d2371b87$export$c62426fdd000a97e = function(str) {
    try {
        return $500c33f4d2371b87$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $500c33f4d2371b87$export$6c40052bed430212(value) {
    return $500c33f4d2371b87$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $500c33f4d2371b87$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$500c33f4d2371b87$var$isValidKey(prop)) continue;
        target[prop] = $500c33f4d2371b87$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $500c33f4d2371b87$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $500c33f4d2371b87$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $500c33f4d2371b87$var$getDefaultsFromGlobal = ()=>$500c33f4d2371b87$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $500c33f4d2371b87$var$getDefaultsFromEnvVariable = ()=>{
    if (typeof $bDPlX === "undefined" || typeof $bDPlX.env === "undefined") return;
    const defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
const $500c33f4d2371b87$var$getDefaultsFromCookie = ()=>{
    if (typeof document === "undefined") return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $500c33f4d2371b87$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $500c33f4d2371b87$export$212bb2fc580a90a8 = ()=>{
    try {
        return $500c33f4d2371b87$var$getDefaultsFromGlobal() || $500c33f4d2371b87$var$getDefaultsFromEnvVariable() || $500c33f4d2371b87$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $500c33f4d2371b87$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $500c33f4d2371b87$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $500c33f4d2371b87$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $500c33f4d2371b87$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(":"); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === "[") // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $500c33f4d2371b87$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $500c33f4d2371b87$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $500c33f4d2371b87$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $500c33f4d2371b87$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $500c33f4d2371b87$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $500c33f4d2371b87$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $500c33f4d2371b87$export$4b5284a3025a455(JSON.stringify(header)),
        $500c33f4d2371b87$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $500c33f4d2371b87$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $500c33f4d2371b87$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($500c33f4d2371b87$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $500c33f4d2371b87$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $500c33f4d2371b87$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === "node") return true;
    else if (forceEnvironment === "browser") return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $500c33f4d2371b87$export$4e09c449d6c407f7() {
    return typeof self === "object" && self.self === self;
}
function $500c33f4d2371b87$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $500c33f4d2371b87$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $500c33f4d2371b87$export$f2f6a8999f8ebd30() {
    return $500c33f4d2371b87$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $500c33f4d2371b87$export$7e7b1a9668aaed8() {
    const ua = $500c33f4d2371b87$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $500c33f4d2371b87$export$202944b2d2824246() {
    return $500c33f4d2371b87$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $500c33f4d2371b87$export$5d1d834fbbf8bab7() {
    return $500c33f4d2371b87$export$588c7fdda06fbb0a.NODE_CLIENT === true || $500c33f4d2371b87$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $500c33f4d2371b87$export$95df08bae54cb4df() {
    return !$500c33f4d2371b87$export$8ee0fc9ee280b4ee() && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $500c33f4d2371b87$export$3865db50535c2055() {
    try {
        return typeof indexedDB === "object";
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $500c33f4d2371b87$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $500c33f4d2371b87$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $500c33f4d2371b87$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $500c33f4d2371b87$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $500c33f4d2371b87$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $500c33f4d2371b87$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $500c33f4d2371b87$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $500c33f4d2371b87$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $500c33f4d2371b87$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $500c33f4d2371b87$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $500c33f4d2371b87$var$replaceTemplate(template, data) {
    return template.replace($500c33f4d2371b87$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $500c33f4d2371b87$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $500c33f4d2371b87$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $500c33f4d2371b87$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $500c33f4d2371b87$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $500c33f4d2371b87$export$c5a53ce6a17cf18d($500c33f4d2371b87$export$c62426fdd000a97e(parts[0]) || "");
        claims = $500c33f4d2371b87$export$c5a53ce6a17cf18d($500c33f4d2371b87$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $500c33f4d2371b87$export$5f870fcca7ae6a88 = function(token) {
    const claims = $500c33f4d2371b87$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $500c33f4d2371b87$export$701c661ec91095f2 = function(token) {
    const claims = $500c33f4d2371b87$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $500c33f4d2371b87$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $500c33f4d2371b87$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $500c33f4d2371b87$export$fc970ed23da99565 = function(token) {
    const claims = $500c33f4d2371b87$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $500c33f4d2371b87$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $500c33f4d2371b87$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $500c33f4d2371b87$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $500c33f4d2371b87$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $500c33f4d2371b87$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($500c33f4d2371b87$var$isObject(aProp) && $500c33f4d2371b87$var$isObject(bProp)) {
            if (!$500c33f4d2371b87$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $500c33f4d2371b87$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $500c33f4d2371b87$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $500c33f4d2371b87$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject("timeout!"), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $500c33f4d2371b87$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $500c33f4d2371b87$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $500c33f4d2371b87$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $500c33f4d2371b87$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $500c33f4d2371b87$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $500c33f4d2371b87$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $500c33f4d2371b87$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($500c33f4d2371b87$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $500c33f4d2371b87$var$noop;
        if (observer.error === undefined) observer.error = $500c33f4d2371b87$var$noop;
        if (observer.complete === undefined) observer.complete = $500c33f4d2371b87$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $500c33f4d2371b87$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $500c33f4d2371b87$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $500c33f4d2371b87$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $500c33f4d2371b87$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $500c33f4d2371b87$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $500c33f4d2371b87$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($500c33f4d2371b87$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $500c33f4d2371b87$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($500c33f4d2371b87$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $500c33f4d2371b87$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($500c33f4d2371b87$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $500c33f4d2371b87$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $500c33f4d2371b87$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $500c33f4d2371b87$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $500c33f4d2371b87$export$abe4376e1bf796d6 = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $500c33f4d2371b87$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $500c33f4d2371b87$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $500c33f4d2371b87$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $500c33f4d2371b87$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $500c33f4d2371b87$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $500c33f4d2371b87$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $500c33f4d2371b87$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $500c33f4d2371b87$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($500c33f4d2371b87$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $500c33f4d2371b87$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $500c33f4d2371b87$var$indicator(i);
}
function $500c33f4d2371b87$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $500c33f4d2371b87$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}

});
parcelRequire.register("bDPlX", function(module, exports) {
// shim for using process in browser
var $879b2beb6cc9bacc$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $879b2beb6cc9bacc$var$cachedSetTimeout;
var $879b2beb6cc9bacc$var$cachedClearTimeout;
function $879b2beb6cc9bacc$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $879b2beb6cc9bacc$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $879b2beb6cc9bacc$var$cachedSetTimeout = setTimeout;
        else $879b2beb6cc9bacc$var$cachedSetTimeout = $879b2beb6cc9bacc$var$defaultSetTimout;
    } catch (e) {
        $879b2beb6cc9bacc$var$cachedSetTimeout = $879b2beb6cc9bacc$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $879b2beb6cc9bacc$var$cachedClearTimeout = clearTimeout;
        else $879b2beb6cc9bacc$var$cachedClearTimeout = $879b2beb6cc9bacc$var$defaultClearTimeout;
    } catch (e) {
        $879b2beb6cc9bacc$var$cachedClearTimeout = $879b2beb6cc9bacc$var$defaultClearTimeout;
    }
})();
function $879b2beb6cc9bacc$var$runTimeout(fun) {
    if ($879b2beb6cc9bacc$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($879b2beb6cc9bacc$var$cachedSetTimeout === $879b2beb6cc9bacc$var$defaultSetTimout || !$879b2beb6cc9bacc$var$cachedSetTimeout) && setTimeout) {
        $879b2beb6cc9bacc$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $879b2beb6cc9bacc$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $879b2beb6cc9bacc$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $879b2beb6cc9bacc$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $879b2beb6cc9bacc$var$runClearTimeout(marker) {
    if ($879b2beb6cc9bacc$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($879b2beb6cc9bacc$var$cachedClearTimeout === $879b2beb6cc9bacc$var$defaultClearTimeout || !$879b2beb6cc9bacc$var$cachedClearTimeout) && clearTimeout) {
        $879b2beb6cc9bacc$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $879b2beb6cc9bacc$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $879b2beb6cc9bacc$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $879b2beb6cc9bacc$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $879b2beb6cc9bacc$var$queue = [];
var $879b2beb6cc9bacc$var$draining = false;
var $879b2beb6cc9bacc$var$currentQueue;
var $879b2beb6cc9bacc$var$queueIndex = -1;
function $879b2beb6cc9bacc$var$cleanUpNextTick() {
    if (!$879b2beb6cc9bacc$var$draining || !$879b2beb6cc9bacc$var$currentQueue) return;
    $879b2beb6cc9bacc$var$draining = false;
    if ($879b2beb6cc9bacc$var$currentQueue.length) $879b2beb6cc9bacc$var$queue = $879b2beb6cc9bacc$var$currentQueue.concat($879b2beb6cc9bacc$var$queue);
    else $879b2beb6cc9bacc$var$queueIndex = -1;
    if ($879b2beb6cc9bacc$var$queue.length) $879b2beb6cc9bacc$var$drainQueue();
}
function $879b2beb6cc9bacc$var$drainQueue() {
    if ($879b2beb6cc9bacc$var$draining) return;
    var timeout = $879b2beb6cc9bacc$var$runTimeout($879b2beb6cc9bacc$var$cleanUpNextTick);
    $879b2beb6cc9bacc$var$draining = true;
    var len = $879b2beb6cc9bacc$var$queue.length;
    while(len){
        $879b2beb6cc9bacc$var$currentQueue = $879b2beb6cc9bacc$var$queue;
        $879b2beb6cc9bacc$var$queue = [];
        while(++$879b2beb6cc9bacc$var$queueIndex < len)if ($879b2beb6cc9bacc$var$currentQueue) $879b2beb6cc9bacc$var$currentQueue[$879b2beb6cc9bacc$var$queueIndex].run();
        $879b2beb6cc9bacc$var$queueIndex = -1;
        len = $879b2beb6cc9bacc$var$queue.length;
    }
    $879b2beb6cc9bacc$var$currentQueue = null;
    $879b2beb6cc9bacc$var$draining = false;
    $879b2beb6cc9bacc$var$runClearTimeout(timeout);
}
$879b2beb6cc9bacc$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $879b2beb6cc9bacc$var$queue.push(new $879b2beb6cc9bacc$var$Item(fun, args));
    if ($879b2beb6cc9bacc$var$queue.length === 1 && !$879b2beb6cc9bacc$var$draining) $879b2beb6cc9bacc$var$runTimeout($879b2beb6cc9bacc$var$drainQueue);
};
// v8 likes predictible objects
function $879b2beb6cc9bacc$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$879b2beb6cc9bacc$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$879b2beb6cc9bacc$var$process.title = "browser";
$879b2beb6cc9bacc$var$process.browser = true;
$879b2beb6cc9bacc$var$process.env = {};
$879b2beb6cc9bacc$var$process.argv = [];
$879b2beb6cc9bacc$var$process.version = ""; // empty string to avoid regexp issues
$879b2beb6cc9bacc$var$process.versions = {};
function $879b2beb6cc9bacc$var$noop() {}
$879b2beb6cc9bacc$var$process.on = $879b2beb6cc9bacc$var$noop;
$879b2beb6cc9bacc$var$process.addListener = $879b2beb6cc9bacc$var$noop;
$879b2beb6cc9bacc$var$process.once = $879b2beb6cc9bacc$var$noop;
$879b2beb6cc9bacc$var$process.off = $879b2beb6cc9bacc$var$noop;
$879b2beb6cc9bacc$var$process.removeListener = $879b2beb6cc9bacc$var$noop;
$879b2beb6cc9bacc$var$process.removeAllListeners = $879b2beb6cc9bacc$var$noop;
$879b2beb6cc9bacc$var$process.emit = $879b2beb6cc9bacc$var$noop;
$879b2beb6cc9bacc$var$process.prependListener = $879b2beb6cc9bacc$var$noop;
$879b2beb6cc9bacc$var$process.prependOnceListener = $879b2beb6cc9bacc$var$noop;
$879b2beb6cc9bacc$var$process.listeners = function(name) {
    return [];
};
$879b2beb6cc9bacc$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$879b2beb6cc9bacc$var$process.cwd = function() {
    return "/";
};
$879b2beb6cc9bacc$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$879b2beb6cc9bacc$var$process.umask = function() {
    return 0;
};

});


parcelRequire.register("6HgFA", function(module, exports) {

$parcel$export(module.exports, "_registerComponent", function () { return $4e03b07dec00cfca$export$c930050e7bb63965; });
$parcel$export(module.exports, "_getProvider", function () { return $4e03b07dec00cfca$export$fa0d6da0f5838f50; });
$parcel$export(module.exports, "SDK_VERSION", function () { return $4e03b07dec00cfca$export$31499a9cd224b78c; });
$parcel$export(module.exports, "initializeApp", function () { return $4e03b07dec00cfca$export$c55cfd413944906d; });
$parcel$export(module.exports, "getApp", function () { return $4e03b07dec00cfca$export$f9962582c9e66d99; });
$parcel$export(module.exports, "registerVersion", function () { return $4e03b07dec00cfca$export$d29d5299a7137abc; });

var $1jeZY = parcelRequire("1jeZY");

var $5zfDX = parcelRequire("5zfDX");

var $6S5H6 = parcelRequire("6S5H6");

var $jOhUk = parcelRequire("jOhUk");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $4e03b07dec00cfca$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($4e03b07dec00cfca$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(" ");
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $4e03b07dec00cfca$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $4e03b07dec00cfca$var$name$o = "@firebase/app";
const $4e03b07dec00cfca$var$version$1 = "0.9.19";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4e03b07dec00cfca$var$logger = new (0, $5zfDX.Logger)("@firebase/app");
const $4e03b07dec00cfca$var$name$n = "@firebase/app-compat";
const $4e03b07dec00cfca$var$name$m = "@firebase/analytics-compat";
const $4e03b07dec00cfca$var$name$l = "@firebase/analytics";
const $4e03b07dec00cfca$var$name$k = "@firebase/app-check-compat";
const $4e03b07dec00cfca$var$name$j = "@firebase/app-check";
const $4e03b07dec00cfca$var$name$i = "@firebase/auth";
const $4e03b07dec00cfca$var$name$h = "@firebase/auth-compat";
const $4e03b07dec00cfca$var$name$g = "@firebase/database";
const $4e03b07dec00cfca$var$name$f = "@firebase/database-compat";
const $4e03b07dec00cfca$var$name$e = "@firebase/functions";
const $4e03b07dec00cfca$var$name$d = "@firebase/functions-compat";
const $4e03b07dec00cfca$var$name$c = "@firebase/installations";
const $4e03b07dec00cfca$var$name$b = "@firebase/installations-compat";
const $4e03b07dec00cfca$var$name$a = "@firebase/messaging";
const $4e03b07dec00cfca$var$name$9 = "@firebase/messaging-compat";
const $4e03b07dec00cfca$var$name$8 = "@firebase/performance";
const $4e03b07dec00cfca$var$name$7 = "@firebase/performance-compat";
const $4e03b07dec00cfca$var$name$6 = "@firebase/remote-config";
const $4e03b07dec00cfca$var$name$5 = "@firebase/remote-config-compat";
const $4e03b07dec00cfca$var$name$4 = "@firebase/storage";
const $4e03b07dec00cfca$var$name$3 = "@firebase/storage-compat";
const $4e03b07dec00cfca$var$name$2 = "@firebase/firestore";
const $4e03b07dec00cfca$var$name$1 = "@firebase/firestore-compat";
const $4e03b07dec00cfca$var$name = "firebase";
const $4e03b07dec00cfca$var$version = "10.4.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $4e03b07dec00cfca$export$9f30fa0c10967f7f = "[DEFAULT]";
const $4e03b07dec00cfca$var$PLATFORM_LOG_STRING = {
    [$4e03b07dec00cfca$var$name$o]: "fire-core",
    [$4e03b07dec00cfca$var$name$n]: "fire-core-compat",
    [$4e03b07dec00cfca$var$name$l]: "fire-analytics",
    [$4e03b07dec00cfca$var$name$m]: "fire-analytics-compat",
    [$4e03b07dec00cfca$var$name$j]: "fire-app-check",
    [$4e03b07dec00cfca$var$name$k]: "fire-app-check-compat",
    [$4e03b07dec00cfca$var$name$i]: "fire-auth",
    [$4e03b07dec00cfca$var$name$h]: "fire-auth-compat",
    [$4e03b07dec00cfca$var$name$g]: "fire-rtdb",
    [$4e03b07dec00cfca$var$name$f]: "fire-rtdb-compat",
    [$4e03b07dec00cfca$var$name$e]: "fire-fn",
    [$4e03b07dec00cfca$var$name$d]: "fire-fn-compat",
    [$4e03b07dec00cfca$var$name$c]: "fire-iid",
    [$4e03b07dec00cfca$var$name$b]: "fire-iid-compat",
    [$4e03b07dec00cfca$var$name$a]: "fire-fcm",
    [$4e03b07dec00cfca$var$name$9]: "fire-fcm-compat",
    [$4e03b07dec00cfca$var$name$8]: "fire-perf",
    [$4e03b07dec00cfca$var$name$7]: "fire-perf-compat",
    [$4e03b07dec00cfca$var$name$6]: "fire-rc",
    [$4e03b07dec00cfca$var$name$5]: "fire-rc-compat",
    [$4e03b07dec00cfca$var$name$4]: "fire-gcs",
    [$4e03b07dec00cfca$var$name$3]: "fire-gcs-compat",
    [$4e03b07dec00cfca$var$name$2]: "fire-fst",
    [$4e03b07dec00cfca$var$name$1]: "fire-fst-compat",
    "fire-js": "fire-js",
    [$4e03b07dec00cfca$var$name]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $4e03b07dec00cfca$export$b4e3c36c855b14b5 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4e03b07dec00cfca$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $4e03b07dec00cfca$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $4e03b07dec00cfca$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $4e03b07dec00cfca$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $4e03b07dec00cfca$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($4e03b07dec00cfca$export$9566bce3835c0f28.has(componentName)) {
        $4e03b07dec00cfca$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $4e03b07dec00cfca$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $4e03b07dec00cfca$export$b4e3c36c855b14b5.values())$4e03b07dec00cfca$export$fa5244b94c62d36a(app, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $4e03b07dec00cfca$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $4e03b07dec00cfca$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $4e03b07dec00cfca$export$9f30fa0c10967f7f) {
    $4e03b07dec00cfca$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 * Test only
 *
 * @internal
 */ function $4e03b07dec00cfca$export$3685d89b9c3cdfaf() {
    $4e03b07dec00cfca$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4e03b07dec00cfca$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["no-options" /* AppError.NO_OPTIONS */ ]: "Need to provide options, when not being deployed to hosting via source.",
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: "First argument to `onLog` must be null or a function.",
    ["idb-open" /* AppError.IDB_OPEN */ ]: "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-get" /* AppError.IDB_GET */ ]: "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-set" /* AppError.IDB_WRITE */ ]: "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-delete" /* AppError.IDB_DELETE */ ]: "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}."
};
const $4e03b07dec00cfca$var$ERROR_FACTORY = new (0, $6S5H6.ErrorFactory)("app", "Firebase", $4e03b07dec00cfca$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $4e03b07dec00cfca$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $1jeZY.Component)("app", ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $4e03b07dec00cfca$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $4e03b07dec00cfca$export$31499a9cd224b78c = $4e03b07dec00cfca$var$version;
function $4e03b07dec00cfca$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== "object") {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $4e03b07dec00cfca$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== "string" || !name) throw $4e03b07dec00cfca$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $6S5H6.getDefaultAppConfig)());
    if (!options) throw $4e03b07dec00cfca$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $4e03b07dec00cfca$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $6S5H6.deepEqual)(options, existingApp.options) && (0, $6S5H6.deepEqual)(config, existingApp.config)) return existingApp;
        else throw $4e03b07dec00cfca$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $1jeZY.ComponentContainer)(name);
    for (const component of $4e03b07dec00cfca$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $4e03b07dec00cfca$var$FirebaseAppImpl(options, config, container);
    $4e03b07dec00cfca$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $4e03b07dec00cfca$export$f9962582c9e66d99(name = $4e03b07dec00cfca$export$9f30fa0c10967f7f) {
    const app = $4e03b07dec00cfca$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $4e03b07dec00cfca$export$9f30fa0c10967f7f && (0, $6S5H6.getDefaultAppConfig)()) return $4e03b07dec00cfca$export$c55cfd413944906d();
    if (!app) throw $4e03b07dec00cfca$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $4e03b07dec00cfca$export$68ddedf7d44b3bdf() {
    return Array.from($4e03b07dec00cfca$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $4e03b07dec00cfca$export$6eec44aa53d5ea34(app) {
    const name = app.name;
    if ($4e03b07dec00cfca$export$b4e3c36c855b14b5.has(name)) {
        $4e03b07dec00cfca$export$b4e3c36c855b14b5.delete(name);
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $4e03b07dec00cfca$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $4e03b07dec00cfca$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $4e03b07dec00cfca$var$logger.warn(warning.join(" "));
        return;
    }
    $4e03b07dec00cfca$export$c930050e7bb63965(new (0, $1jeZY.Component)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $4e03b07dec00cfca$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $4e03b07dec00cfca$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $5zfDX.setUserLogHandler)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $4e03b07dec00cfca$export$c622e99c0ce7b1c9(logLevel) {
    (0, $5zfDX.setLogLevel)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4e03b07dec00cfca$var$DB_NAME = "firebase-heartbeat-database";
const $4e03b07dec00cfca$var$DB_VERSION = 1;
const $4e03b07dec00cfca$var$STORE_NAME = "firebase-heartbeat-store";
let $4e03b07dec00cfca$var$dbPromise = null;
function $4e03b07dec00cfca$var$getDbPromise() {
    if (!$4e03b07dec00cfca$var$dbPromise) $4e03b07dec00cfca$var$dbPromise = (0, $jOhUk.openDB)($4e03b07dec00cfca$var$DB_NAME, $4e03b07dec00cfca$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($4e03b07dec00cfca$var$STORE_NAME);
            }
        }
    }).catch((e)=>{
        throw $4e03b07dec00cfca$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $4e03b07dec00cfca$var$dbPromise;
}
async function $4e03b07dec00cfca$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $4e03b07dec00cfca$var$getDbPromise();
        const result = await db.transaction($4e03b07dec00cfca$var$STORE_NAME).objectStore($4e03b07dec00cfca$var$STORE_NAME).get($4e03b07dec00cfca$var$computeKey(app));
        return result;
    } catch (e) {
        if (e instanceof (0, $6S5H6.FirebaseError)) $4e03b07dec00cfca$var$logger.warn(e.message);
        else {
            const idbGetError = $4e03b07dec00cfca$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $4e03b07dec00cfca$var$logger.warn(idbGetError.message);
        }
    }
}
async function $4e03b07dec00cfca$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $4e03b07dec00cfca$var$getDbPromise();
        const tx = db.transaction($4e03b07dec00cfca$var$STORE_NAME, "readwrite");
        const objectStore = tx.objectStore($4e03b07dec00cfca$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $4e03b07dec00cfca$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $6S5H6.FirebaseError)) $4e03b07dec00cfca$var$logger.warn(e.message);
        else {
            const idbGetError = $4e03b07dec00cfca$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $4e03b07dec00cfca$var$logger.warn(idbGetError.message);
        }
    }
}
function $4e03b07dec00cfca$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4e03b07dec00cfca$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $4e03b07dec00cfca$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $4e03b07dec00cfca$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider("app").getImmediate();
        this._storage = new $4e03b07dec00cfca$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        const platformLogger = this.container.getProvider("platform-logger").getImmediate();
        // This is the "Firebase user agent" string from the platform logger
        // service, not the browser user agent.
        const agent = platformLogger.getPlatformInfoString();
        const date = $4e03b07dec00cfca$var$getUTCDateString();
        if (this._heartbeatsCache === null) this._heartbeatsCache = await this._heartbeatsCachePromise;
        // Do not store a heartbeat if one is already stored for this day
        // or if a header has already been sent today.
        if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
        else // There is no entry for this date. Create one.
        this._heartbeatsCache.heartbeats.push({
            date: date,
            agent: agent
        });
        // Remove entries older than 30 days.
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now = Date.now();
            return now - hbTimestamp <= $4e03b07dec00cfca$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
        // If it's still null or the array is empty, there is no data to send.
        if (this._heartbeatsCache === null || this._heartbeatsCache.heartbeats.length === 0) return "";
        const date = $4e03b07dec00cfca$var$getUTCDateString();
        // Extract as many heartbeats from the cache as will fit under the size limit.
        const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $4e03b07dec00cfca$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = (0, $6S5H6.base64urlEncodeWithoutPadding)(JSON.stringify({
            version: 2,
            heartbeats: heartbeatsToSend
        }));
        // Store last sent date to prevent another being logged/sent for the same day.
        this._heartbeatsCache.lastSentHeartbeatDate = date;
        if (unsentEntries.length > 0) {
            // Store any unsent entries if they exist.
            this._heartbeatsCache.heartbeats = unsentEntries;
            // This seems more likely than emptying the array (below) to lead to some odd state
            // since the cache isn't empty and this will be called again on the next request,
            // and is probably safest if we await it.
            await this._storage.overwrite(this._heartbeatsCache);
        } else {
            this._heartbeatsCache.heartbeats = [];
            this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
}
function $4e03b07dec00cfca$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $4e03b07dec00cfca$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $4e03b07dec00cfca$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($4e03b07dec00cfca$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($4e03b07dec00cfca$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $4e03b07dec00cfca$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $6S5H6.isIndexedDBAvailable)()) return false;
        else return (0, $6S5H6.validateIndexedDBOpenable)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $4e03b07dec00cfca$var$readHeartbeatsFromIndexedDB(this.app);
            return idbHeartbeatObject || {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $4e03b07dec00cfca$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $4e03b07dec00cfca$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $4e03b07dec00cfca$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $6S5H6.base64urlEncodeWithoutPadding)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4e03b07dec00cfca$var$registerCoreComponents(variant) {
    $4e03b07dec00cfca$export$c930050e7bb63965(new (0, $1jeZY.Component)("platform-logger", (container)=>new $4e03b07dec00cfca$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $4e03b07dec00cfca$export$c930050e7bb63965(new (0, $1jeZY.Component)("heartbeat", (container)=>new $4e03b07dec00cfca$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $4e03b07dec00cfca$export$d29d5299a7137abc($4e03b07dec00cfca$var$name$o, $4e03b07dec00cfca$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $4e03b07dec00cfca$export$d29d5299a7137abc($4e03b07dec00cfca$var$name$o, $4e03b07dec00cfca$var$version$1, "esm2017");
    // Register platform SDK identifier (no version).
    $4e03b07dec00cfca$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $4e03b07dec00cfca$var$registerCoreComponents("");

});
parcelRequire.register("1jeZY", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $0f433333a0b3056b$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "ComponentContainer", function () { return $0f433333a0b3056b$export$436a80eea5d5c0c5; });

var $6S5H6 = parcelRequire("6S5H6");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $0f433333a0b3056b$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0f433333a0b3056b$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $0f433333a0b3056b$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $6S5H6.Deferred)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($0f433333a0b3056b$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $0f433333a0b3056b$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $0f433333a0b3056b$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $0f433333a0b3056b$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $0f433333a0b3056b$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $0f433333a0b3056b$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $0f433333a0b3056b$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $0f433333a0b3056b$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $0f433333a0b3056b$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $0f433333a0b3056b$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $0f433333a0b3056b$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $0f433333a0b3056b$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $0f433333a0b3056b$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}

});

parcelRequire.register("5zfDX", function(module, exports) {

$parcel$export(module.exports, "LogLevel", function () { return $40dc5b177c049cea$export$243e62d78d3b544d; });
$parcel$export(module.exports, "Logger", function () { return $40dc5b177c049cea$export$efa9a398d6368992; });
$parcel$export(module.exports, "setLogLevel", function () { return $40dc5b177c049cea$export$c622e99c0ce7b1c9; });
$parcel$export(module.exports, "setUserLogHandler", function () { return $40dc5b177c049cea$export$29577d29c84db5f6; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $40dc5b177c049cea$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $40dc5b177c049cea$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($40dc5b177c049cea$export$243e62d78d3b544d || ($40dc5b177c049cea$export$243e62d78d3b544d = {}));
const $40dc5b177c049cea$var$levelStringToEnum = {
    "debug": $40dc5b177c049cea$export$243e62d78d3b544d.DEBUG,
    "verbose": $40dc5b177c049cea$export$243e62d78d3b544d.VERBOSE,
    "info": $40dc5b177c049cea$export$243e62d78d3b544d.INFO,
    "warn": $40dc5b177c049cea$export$243e62d78d3b544d.WARN,
    "error": $40dc5b177c049cea$export$243e62d78d3b544d.ERROR,
    "silent": $40dc5b177c049cea$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $40dc5b177c049cea$var$defaultLogLevel = $40dc5b177c049cea$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $40dc5b177c049cea$var$ConsoleMethod = {
    [$40dc5b177c049cea$export$243e62d78d3b544d.DEBUG]: "log",
    [$40dc5b177c049cea$export$243e62d78d3b544d.VERBOSE]: "log",
    [$40dc5b177c049cea$export$243e62d78d3b544d.INFO]: "info",
    [$40dc5b177c049cea$export$243e62d78d3b544d.WARN]: "warn",
    [$40dc5b177c049cea$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $40dc5b177c049cea$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $40dc5b177c049cea$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $40dc5b177c049cea$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $40dc5b177c049cea$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $40dc5b177c049cea$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $40dc5b177c049cea$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $40dc5b177c049cea$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $40dc5b177c049cea$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $40dc5b177c049cea$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $40dc5b177c049cea$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $40dc5b177c049cea$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $40dc5b177c049cea$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $40dc5b177c049cea$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $40dc5b177c049cea$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $40dc5b177c049cea$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $40dc5b177c049cea$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $40dc5b177c049cea$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $40dc5b177c049cea$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $40dc5b177c049cea$export$c622e99c0ce7b1c9(level) {
    $40dc5b177c049cea$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $40dc5b177c049cea$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $40dc5b177c049cea$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $40dc5b177c049cea$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $40dc5b177c049cea$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}

});

parcelRequire.register("jOhUk", function(module, exports) {

$parcel$export(module.exports, "openDB", function () { return $e6c093e974d0d89d$export$ca0ed41b1a2af7e; });

var $ltueH = parcelRequire("ltueH");
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $e6c093e974d0d89d$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $ltueH.w)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $ltueH.w)(request.result), event.oldVersion, event.newVersion, (0, $ltueH.w)(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $e6c093e974d0d89d$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $ltueH.w)(request).then(()=>undefined);
}
const $e6c093e974d0d89d$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $e6c093e974d0d89d$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $e6c093e974d0d89d$var$cachedMethods = new Map();
function $e6c093e974d0d89d$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($e6c093e974d0d89d$var$cachedMethods.get(prop)) return $e6c093e974d0d89d$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $e6c093e974d0d89d$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $e6c093e974d0d89d$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $e6c093e974d0d89d$var$cachedMethods.set(prop, method);
    return method;
}
(0, $ltueH.r)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$e6c093e974d0d89d$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$e6c093e974d0d89d$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));

});
parcelRequire.register("ltueH", function(module, exports) {

$parcel$export(module.exports, "w", function () { return $fa23c2ad015a3fee$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "r", function () { return $fa23c2ad015a3fee$export$43caf9889c228507; });
const $fa23c2ad015a3fee$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $fa23c2ad015a3fee$var$idbProxyableTypes;
let $fa23c2ad015a3fee$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $fa23c2ad015a3fee$var$getIdbProxyableTypes() {
    return $fa23c2ad015a3fee$var$idbProxyableTypes || ($fa23c2ad015a3fee$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $fa23c2ad015a3fee$var$getCursorAdvanceMethods() {
    return $fa23c2ad015a3fee$var$cursorAdvanceMethods || ($fa23c2ad015a3fee$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $fa23c2ad015a3fee$var$cursorRequestMap = new WeakMap();
const $fa23c2ad015a3fee$var$transactionDoneMap = new WeakMap();
const $fa23c2ad015a3fee$var$transactionStoreNamesMap = new WeakMap();
const $fa23c2ad015a3fee$var$transformCache = new WeakMap();
const $fa23c2ad015a3fee$export$407448d2b89b1813 = new WeakMap();
function $fa23c2ad015a3fee$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($fa23c2ad015a3fee$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $fa23c2ad015a3fee$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $fa23c2ad015a3fee$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $fa23c2ad015a3fee$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($fa23c2ad015a3fee$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $fa23c2ad015a3fee$var$transactionDoneMap.set(tx, done);
}
let $fa23c2ad015a3fee$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $fa23c2ad015a3fee$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $fa23c2ad015a3fee$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $fa23c2ad015a3fee$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $fa23c2ad015a3fee$export$43caf9889c228507(callback) {
    $fa23c2ad015a3fee$var$idbProxyTraps = callback($fa23c2ad015a3fee$var$idbProxyTraps);
}
function $fa23c2ad015a3fee$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($fa23c2ad015a3fee$export$3b14a55fb2447963(this), storeNames, ...args);
        $fa23c2ad015a3fee$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $fa23c2ad015a3fee$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($fa23c2ad015a3fee$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($fa23c2ad015a3fee$export$3b14a55fb2447963(this), args);
        return $fa23c2ad015a3fee$export$efccba1c4a2ef57b($fa23c2ad015a3fee$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $fa23c2ad015a3fee$export$efccba1c4a2ef57b(func.apply($fa23c2ad015a3fee$export$3b14a55fb2447963(this), args));
    };
}
function $fa23c2ad015a3fee$var$transformCachableValue(value) {
    if (typeof value === "function") return $fa23c2ad015a3fee$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $fa23c2ad015a3fee$var$cacheDonePromiseForTransaction(value);
    if ($fa23c2ad015a3fee$export$23f2a1d2818174ef(value, $fa23c2ad015a3fee$var$getIdbProxyableTypes())) return new Proxy(value, $fa23c2ad015a3fee$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $fa23c2ad015a3fee$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $fa23c2ad015a3fee$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($fa23c2ad015a3fee$var$transformCache.has(value)) return $fa23c2ad015a3fee$var$transformCache.get(value);
    const newValue = $fa23c2ad015a3fee$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $fa23c2ad015a3fee$var$transformCache.set(value, newValue);
        $fa23c2ad015a3fee$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $fa23c2ad015a3fee$export$3b14a55fb2447963 = (value)=>$fa23c2ad015a3fee$export$407448d2b89b1813.get(value);

});



parcelRequire.register("3fgls", function(module, exports) {

$parcel$export(module.exports, "__rest", function () { return $25cf7398ba9d4247$export$3c9a16f847548506; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $25cf7398ba9d4247$var$extendStatics = function(d, b) {
    $25cf7398ba9d4247$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $25cf7398ba9d4247$var$extendStatics(d, b);
};
function $25cf7398ba9d4247$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $25cf7398ba9d4247$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $25cf7398ba9d4247$export$18ce0697a983be9b = function() {
    $25cf7398ba9d4247$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $25cf7398ba9d4247$export$18ce0697a983be9b.apply(this, arguments);
};
function $25cf7398ba9d4247$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $25cf7398ba9d4247$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $25cf7398ba9d4247$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $25cf7398ba9d4247$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $25cf7398ba9d4247$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $25cf7398ba9d4247$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $25cf7398ba9d4247$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $25cf7398ba9d4247$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $25cf7398ba9d4247$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $25cf7398ba9d4247$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $25cf7398ba9d4247$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $25cf7398ba9d4247$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $25cf7398ba9d4247$export$45d3717a4c69092e(o, m, p);
}
function $25cf7398ba9d4247$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $25cf7398ba9d4247$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $25cf7398ba9d4247$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($25cf7398ba9d4247$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $25cf7398ba9d4247$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $25cf7398ba9d4247$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $25cf7398ba9d4247$export$10c90e4f7922046c(v) {
    return this instanceof $25cf7398ba9d4247$export$10c90e4f7922046c ? (this.v = v, this) : new $25cf7398ba9d4247$export$10c90e4f7922046c(v);
}
function $25cf7398ba9d4247$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $25cf7398ba9d4247$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $25cf7398ba9d4247$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $25cf7398ba9d4247$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $25cf7398ba9d4247$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $25cf7398ba9d4247$export$19a8beecd37a4c45 === "function" ? $25cf7398ba9d4247$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $25cf7398ba9d4247$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $25cf7398ba9d4247$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $25cf7398ba9d4247$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $25cf7398ba9d4247$export$45d3717a4c69092e(result, mod, k);
    }
    $25cf7398ba9d4247$var$__setModuleDefault(result, mod);
    return result;
}
function $25cf7398ba9d4247$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $25cf7398ba9d4247$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $25cf7398ba9d4247$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $25cf7398ba9d4247$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $25cf7398ba9d4247$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $25cf7398ba9d4247$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $25cf7398ba9d4247$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $25cf7398ba9d4247$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $25cf7398ba9d4247$export$2e2bcd8739ae039 = {
    __extends: $25cf7398ba9d4247$export$a8ba968b8961cb8a,
    __assign: $25cf7398ba9d4247$export$18ce0697a983be9b,
    __rest: $25cf7398ba9d4247$export$3c9a16f847548506,
    __decorate: $25cf7398ba9d4247$export$29e00dfd3077644b,
    __param: $25cf7398ba9d4247$export$d5ad3fd78186038f,
    __metadata: $25cf7398ba9d4247$export$f1db080c865becb9,
    __awaiter: $25cf7398ba9d4247$export$1050f835b63b671e,
    __generator: $25cf7398ba9d4247$export$67ebef60e6f28a6,
    __createBinding: $25cf7398ba9d4247$export$45d3717a4c69092e,
    __exportStar: $25cf7398ba9d4247$export$f33643c0debef087,
    __values: $25cf7398ba9d4247$export$19a8beecd37a4c45,
    __read: $25cf7398ba9d4247$export$8d051b38c9118094,
    __spread: $25cf7398ba9d4247$export$afc72e2116322959,
    __spreadArrays: $25cf7398ba9d4247$export$6388937ca91ccae8,
    __spreadArray: $25cf7398ba9d4247$export$1216008129fb82ed,
    __await: $25cf7398ba9d4247$export$10c90e4f7922046c,
    __asyncGenerator: $25cf7398ba9d4247$export$e427f37a30a4de9b,
    __asyncDelegator: $25cf7398ba9d4247$export$bbd80228419bb833,
    __asyncValues: $25cf7398ba9d4247$export$e3b29a3d6162315f,
    __makeTemplateObject: $25cf7398ba9d4247$export$4fb47efe1390b86f,
    __importStar: $25cf7398ba9d4247$export$c21735bcef00d192,
    __importDefault: $25cf7398ba9d4247$export$da59b14a69baef04,
    __classPrivateFieldGet: $25cf7398ba9d4247$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $25cf7398ba9d4247$export$d40a35129aaff81f,
    __classPrivateFieldIn: $25cf7398ba9d4247$export$81fdc39f203e4e04,
    __addDisposableResource: $25cf7398ba9d4247$export$88ac25d8e944e405,
    __disposeResources: $25cf7398ba9d4247$export$8f076105dc360e92
};

});




parcelRequire.register("288NN", function(module, exports) {
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("aBo2k")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("hulgA")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("cm2x1")).useSelector; });
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $6H6lX = parcelRequire("6H6lX");

var $OFbpQ = parcelRequire("OFbpQ");
parcelRequire("gSfwW");
var $e85sa = parcelRequire("e85sa");

var $c3VCc = parcelRequire("c3VCc");

var $cm2x1 = parcelRequire("cm2x1");

var $7DVmf = parcelRequire("7DVmf");
parcelRequire("ctPk7");
(0, $cm2x1.initializeUseSelector)((0, $OFbpQ.useSyncExternalStoreWithSelector));
(0, $7DVmf.initializeConnect)((0, $6H6lX.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $c3VCc.setBatch)((0, $e85sa.unstable_batchedUpdates));

});
parcelRequire.register("6H6lX", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jc4ym"));

});
parcelRequire.register("jc4ym", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $df92ab7b0e1eb3f1$export$306c0aa65ff9ec16; }, function (v) { return $df92ab7b0e1eb3f1$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $df92ab7b0e1eb3f1$export$306c0aa65ff9ec16;
"use strict";

var $aOChP = parcelRequire("aOChP");
function $df92ab7b0e1eb3f1$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $df92ab7b0e1eb3f1$var$k = "function" === typeof Object.is ? Object.is : $df92ab7b0e1eb3f1$var$h, $df92ab7b0e1eb3f1$var$l = $aOChP.useState, $df92ab7b0e1eb3f1$var$m = $aOChP.useEffect, $df92ab7b0e1eb3f1$var$n = $aOChP.useLayoutEffect, $df92ab7b0e1eb3f1$var$p = $aOChP.useDebugValue;
function $df92ab7b0e1eb3f1$var$q(a, b) {
    var d = b(), f = $df92ab7b0e1eb3f1$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $df92ab7b0e1eb3f1$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $df92ab7b0e1eb3f1$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $df92ab7b0e1eb3f1$var$m(function() {
        $df92ab7b0e1eb3f1$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $df92ab7b0e1eb3f1$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $df92ab7b0e1eb3f1$var$p(d);
    return d;
}
function $df92ab7b0e1eb3f1$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$df92ab7b0e1eb3f1$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $df92ab7b0e1eb3f1$var$t(a, b) {
    return b();
}
var $df92ab7b0e1eb3f1$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $df92ab7b0e1eb3f1$var$t : $df92ab7b0e1eb3f1$var$q;
$df92ab7b0e1eb3f1$export$306c0aa65ff9ec16 = void 0 !== $aOChP.useSyncExternalStore ? $aOChP.useSyncExternalStore : $df92ab7b0e1eb3f1$var$u;

});


parcelRequire.register("OFbpQ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bosrM"));

});
parcelRequire.register("bosrM", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $84b80099bcfc1038$export$bf730a2d8bf68b42; }, function (v) { return $84b80099bcfc1038$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $84b80099bcfc1038$export$bf730a2d8bf68b42;
"use strict";

var $aOChP = parcelRequire("aOChP");

var $6H6lX = parcelRequire("6H6lX");
function $84b80099bcfc1038$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $84b80099bcfc1038$var$q = "function" === typeof Object.is ? Object.is : $84b80099bcfc1038$var$p, $84b80099bcfc1038$var$r = $6H6lX.useSyncExternalStore, $84b80099bcfc1038$var$t = $aOChP.useRef, $84b80099bcfc1038$var$u = $aOChP.useEffect, $84b80099bcfc1038$var$v = $aOChP.useMemo, $84b80099bcfc1038$var$w = $aOChP.useDebugValue;
$84b80099bcfc1038$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $84b80099bcfc1038$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $84b80099bcfc1038$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($84b80099bcfc1038$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $84b80099bcfc1038$var$r(a, c[0], c[1]);
    $84b80099bcfc1038$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $84b80099bcfc1038$var$w(d);
    return d;
};

});


parcelRequire.register("gSfwW", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", function () { return (parcelRequire("e85sa")).unstable_batchedUpdates; });

var $e85sa = parcelRequire("e85sa");

});
parcelRequire.register("e85sa", function(module, exports) {
"use strict";
function $a4960af4154d3849$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a4960af4154d3849$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a4960af4154d3849$var$checkDCE();

module.exports = (parcelRequire("edP6V"));

});


parcelRequire.register("c3VCc", function(module, exports) {

$parcel$export(module.exports, "setBatch", function () { return $8c82750516a44a4d$export$4b9874722d0da7bc; });
$parcel$export(module.exports, "getBatch", function () { return $8c82750516a44a4d$export$fc47d4c0ba3bd2c6; });
// Default to a dummy "batch" implementation that just runs the callback
function $8c82750516a44a4d$var$defaultNoopBatch(callback) {
    callback();
}
let $8c82750516a44a4d$var$batch = $8c82750516a44a4d$var$defaultNoopBatch; // Allow injecting another batching function later
const $8c82750516a44a4d$export$4b9874722d0da7bc = (newBatch)=>$8c82750516a44a4d$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $8c82750516a44a4d$export$fc47d4c0ba3bd2c6 = ()=>$8c82750516a44a4d$var$batch;

});

parcelRequire.register("cm2x1", function(module, exports) {

$parcel$export(module.exports, "initializeUseSelector", function () { return $8fe980d479ae56e6$export$e2e6e3f3f3b782e3; });
$parcel$export(module.exports, "useSelector", function () { return $8fe980d479ae56e6$export$2105062e25df4afe; });

var $aOChP = parcelRequire("aOChP");

var $flZJp = parcelRequire("flZJp");

var $fc1n7 = parcelRequire("fc1n7");

var $1yTbY = parcelRequire("1yTbY");
let $8fe980d479ae56e6$var$useSyncExternalStoreWithSelector = (0, $1yTbY.notInitialized);
const $8fe980d479ae56e6$export$e2e6e3f3f3b782e3 = (fn)=>{
    $8fe980d479ae56e6$var$useSyncExternalStoreWithSelector = fn;
};
const $8fe980d479ae56e6$var$refEquality = (a, b)=>a === b;
function $8fe980d479ae56e6$export$2b53f90d2bd1cbfb(context = (0, $fc1n7.ReactReduxContext)) {
    const useReduxContext = context === (0, $fc1n7.ReactReduxContext) ? (0, $flZJp.useReduxContext) : (0, $flZJp.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $8fe980d479ae56e6$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $aOChP.useRef)(true);
        const wrappedSelector = (0, $aOChP.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $8fe980d479ae56e6$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $aOChP.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $8fe980d479ae56e6$export$2105062e25df4afe = /*#__PURE__*/ $8fe980d479ae56e6$export$2b53f90d2bd1cbfb();

});
parcelRequire.register("flZJp", function(module, exports) {

$parcel$export(module.exports, "createReduxContextHook", function () { return $b2d8b3c03141afe6$export$d4d6226d5fc61558; });
$parcel$export(module.exports, "useReduxContext", function () { return $b2d8b3c03141afe6$export$c1275ca9a6fd3ec5; });

var $aOChP = parcelRequire("aOChP");

var $fc1n7 = parcelRequire("fc1n7");
function $b2d8b3c03141afe6$export$d4d6226d5fc61558(context = (0, $fc1n7.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $aOChP.useContext)(context);
        return contextValue;
    };
}
const $b2d8b3c03141afe6$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $b2d8b3c03141afe6$export$d4d6226d5fc61558();

});
parcelRequire.register("fc1n7", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", function () { return $b0f90a73ae81d1c0$export$cc80c08dc91f1c00; });

var $aOChP = parcelRequire("aOChP");
const $b0f90a73ae81d1c0$var$ContextKey = Symbol.for(`react-redux-context`);
const $b0f90a73ae81d1c0$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $b0f90a73ae81d1c0$var$getContext() {
    var _gT$ContextKey;
    if (!$aOChP.createContext) return {};
    const contextMap = (_gT$ContextKey = $b0f90a73ae81d1c0$var$gT[$b0f90a73ae81d1c0$var$ContextKey]) != null ? _gT$ContextKey : $b0f90a73ae81d1c0$var$gT[$b0f90a73ae81d1c0$var$ContextKey] = new Map();
    let realContext = contextMap.get($aOChP.createContext);
    if (!realContext) {
        realContext = $aOChP.createContext(null);
        contextMap.set($aOChP.createContext, realContext);
    }
    return realContext;
}
const $b0f90a73ae81d1c0$export$cc80c08dc91f1c00 = /*#__PURE__*/ $b0f90a73ae81d1c0$var$getContext();
var $b0f90a73ae81d1c0$export$2e2bcd8739ae039 = $b0f90a73ae81d1c0$export$cc80c08dc91f1c00;

});


parcelRequire.register("1yTbY", function(module, exports) {

$parcel$export(module.exports, "notInitialized", function () { return $1233c772bb2ff507$export$20656a4825650bd0; });
const $1233c772bb2ff507$export$20656a4825650bd0 = ()=>{
    throw new Error("uSES not initialized!");
};

});


parcelRequire.register("7DVmf", function(module, exports) {

$parcel$export(module.exports, "initializeConnect", function () { return $5908aaf818dfa28d$export$36d45daa6a4925b8; });

var $dy3ak = parcelRequire("dy3ak");

var $4GC5s = parcelRequire("4GC5s");

var $gizNK = parcelRequire("gizNK");

var $aOChP = parcelRequire("aOChP");

var $cZMZb = parcelRequire("cZMZb");

var $kF0Kd = parcelRequire("kF0Kd");

var $hSofF = parcelRequire("hSofF");

var $7MSOp = parcelRequire("7MSOp");

var $j5aJr = parcelRequire("j5aJr");

var $6fXdg = parcelRequire("6fXdg");

var $lJh36 = parcelRequire("lJh36");

var $felMU = parcelRequire("felMU");
parcelRequire("ey1kL");

var $fc1n7 = parcelRequire("fc1n7");

var $1yTbY = parcelRequire("1yTbY");
const $5908aaf818dfa28d$var$_excluded = [
    "reactReduxForwardedRef"
];
let $5908aaf818dfa28d$var$useSyncExternalStore = (0, $1yTbY.notInitialized);
const $5908aaf818dfa28d$export$36d45daa6a4925b8 = (fn)=>{
    $5908aaf818dfa28d$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $5908aaf818dfa28d$var$EMPTY_ARRAY = [
    null,
    0
];
const $5908aaf818dfa28d$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $5908aaf818dfa28d$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $5908aaf818dfa28d$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $lJh36.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $5908aaf818dfa28d$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $5908aaf818dfa28d$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $5908aaf818dfa28d$var$initStateUpdates = ()=>$5908aaf818dfa28d$var$EMPTY_ARRAY;
function $5908aaf818dfa28d$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $5908aaf818dfa28d$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $5908aaf818dfa28d$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $5908aaf818dfa28d$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $felMU.default), areStatePropsEqual: areStatePropsEqual = (0, $felMU.default), areMergedPropsEqual: areMergedPropsEqual = (0, $felMU.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $fc1n7.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $7MSOp.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $hSofF.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $j5aJr.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $aOChP.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $4GC5s.default)(props, $5908aaf818dfa28d$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $aOChP.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $cZMZb.isContextConsumer)(/*#__PURE__*/ $aOChP.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $aOChP.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $aOChP.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $kF0Kd.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $aOChP.useMemo(()=>{
                if (!shouldHandleStateChanges) return $5908aaf818dfa28d$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $6fXdg.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $aOChP.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $dy3ak.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $aOChP.useRef();
            const lastWrapperProps = $aOChP.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $aOChP.useRef();
            const renderIsScheduled = $aOChP.useRef(false);
            const isProcessingDispatch = $aOChP.useRef(false);
            const isMounted = $aOChP.useRef(false);
            const latestSubscriptionCallbackError = $aOChP.useRef();
            (0, $lJh36.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $aOChP.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $aOChP.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $5908aaf818dfa28d$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $5908aaf818dfa28d$var$useIsomorphicLayoutEffectWithArgs($5908aaf818dfa28d$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $5908aaf818dfa28d$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $lJh36.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $aOChP.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $aOChP.createElement(WrappedComponent, (0, $dy3ak.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $aOChP.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $aOChP.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $aOChP.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $aOChP.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $aOChP.createElement(Connect, (0, $dy3ak.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($gizNK)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($gizNK)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $5908aaf818dfa28d$export$2e2bcd8739ae039 = $5908aaf818dfa28d$var$connect;

});
parcelRequire.register("cZMZb", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fKKvG"));

});
parcelRequire.register("fKKvG", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $b77f3ad58ee789fd$export$a7c73072b1a182ae; }, function (v) { return $b77f3ad58ee789fd$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $b77f3ad58ee789fd$export$9f27bc3417b4524d; }, function (v) { return $b77f3ad58ee789fd$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $b77f3ad58ee789fd$export$db77ccec0bb4ccac; }, function (v) { return $b77f3ad58ee789fd$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $b77f3ad58ee789fd$export$8392c0c9d3dcbd35; }, function (v) { return $b77f3ad58ee789fd$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b77f3ad58ee789fd$export$ffb0004e005737fa; }, function (v) { return $b77f3ad58ee789fd$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $b77f3ad58ee789fd$export$b624eff549462981; }, function (v) { return $b77f3ad58ee789fd$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $b77f3ad58ee789fd$export$7897aa7841a5380c; }, function (v) { return $b77f3ad58ee789fd$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $b77f3ad58ee789fd$export$602eac185826482c; }, function (v) { return $b77f3ad58ee789fd$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $b77f3ad58ee789fd$export$e2c29f18771995cb; }, function (v) { return $b77f3ad58ee789fd$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b77f3ad58ee789fd$export$5f8d39834fd61797; }, function (v) { return $b77f3ad58ee789fd$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b77f3ad58ee789fd$export$74bf444e3cd11ea5; }, function (v) { return $b77f3ad58ee789fd$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $b77f3ad58ee789fd$export$998bcd577473dd93; }, function (v) { return $b77f3ad58ee789fd$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $b77f3ad58ee789fd$export$92387174baf9b227; }, function (v) { return $b77f3ad58ee789fd$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $b77f3ad58ee789fd$export$ec112efeb987d9c6; }, function (v) { return $b77f3ad58ee789fd$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $b77f3ad58ee789fd$export$b706b080d889d2c9; }, function (v) { return $b77f3ad58ee789fd$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $b77f3ad58ee789fd$export$5be5a87408f70ddc; }, function (v) { return $b77f3ad58ee789fd$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $b77f3ad58ee789fd$export$45a5e7f76e0caa8d; }, function (v) { return $b77f3ad58ee789fd$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $b77f3ad58ee789fd$export$455c2e768291efa6; }, function (v) { return $b77f3ad58ee789fd$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $b77f3ad58ee789fd$export$9522e17588c12572; }, function (v) { return $b77f3ad58ee789fd$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $b77f3ad58ee789fd$export$2110ac352bb060b9; }, function (v) { return $b77f3ad58ee789fd$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $b77f3ad58ee789fd$export$56885ab8b9c456ab; }, function (v) { return $b77f3ad58ee789fd$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $b77f3ad58ee789fd$export$d927fcb6adf8f9de; }, function (v) { return $b77f3ad58ee789fd$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $b77f3ad58ee789fd$export$b82d16f27459e05a; }, function (v) { return $b77f3ad58ee789fd$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $b77f3ad58ee789fd$export$522c17b4f5e123e8; }, function (v) { return $b77f3ad58ee789fd$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $b77f3ad58ee789fd$export$1aabd8a0274ecfd6; }, function (v) { return $b77f3ad58ee789fd$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $b77f3ad58ee789fd$export$3d6c20d97e46b957; }, function (v) { return $b77f3ad58ee789fd$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $b77f3ad58ee789fd$export$9b621391a187a31a; }, function (v) { return $b77f3ad58ee789fd$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $b77f3ad58ee789fd$export$f5bbd400c2f4426f; }, function (v) { return $b77f3ad58ee789fd$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b77f3ad58ee789fd$export$a7c73072b1a182ae;
var $b77f3ad58ee789fd$export$9f27bc3417b4524d;
var $b77f3ad58ee789fd$export$db77ccec0bb4ccac;
var $b77f3ad58ee789fd$export$8392c0c9d3dcbd35;
var $b77f3ad58ee789fd$export$ffb0004e005737fa;
var $b77f3ad58ee789fd$export$b624eff549462981;
var $b77f3ad58ee789fd$export$7897aa7841a5380c;
var $b77f3ad58ee789fd$export$602eac185826482c;
var $b77f3ad58ee789fd$export$e2c29f18771995cb;
var $b77f3ad58ee789fd$export$5f8d39834fd61797;
var $b77f3ad58ee789fd$export$74bf444e3cd11ea5;
var $b77f3ad58ee789fd$export$998bcd577473dd93;
var $b77f3ad58ee789fd$export$92387174baf9b227;
var $b77f3ad58ee789fd$export$ec112efeb987d9c6;
var $b77f3ad58ee789fd$export$b706b080d889d2c9;
var $b77f3ad58ee789fd$export$5be5a87408f70ddc;
var $b77f3ad58ee789fd$export$45a5e7f76e0caa8d;
var $b77f3ad58ee789fd$export$455c2e768291efa6;
var $b77f3ad58ee789fd$export$9522e17588c12572;
var $b77f3ad58ee789fd$export$2110ac352bb060b9;
var $b77f3ad58ee789fd$export$56885ab8b9c456ab;
var $b77f3ad58ee789fd$export$d927fcb6adf8f9de;
var $b77f3ad58ee789fd$export$b82d16f27459e05a;
var $b77f3ad58ee789fd$export$522c17b4f5e123e8;
var $b77f3ad58ee789fd$export$1aabd8a0274ecfd6;
var $b77f3ad58ee789fd$export$3d6c20d97e46b957;
var $b77f3ad58ee789fd$export$9b621391a187a31a;
var $b77f3ad58ee789fd$export$f5bbd400c2f4426f;
"use strict";
var $b77f3ad58ee789fd$var$b = Symbol.for("react.element"), $b77f3ad58ee789fd$var$c = Symbol.for("react.portal"), $b77f3ad58ee789fd$var$d = Symbol.for("react.fragment"), $b77f3ad58ee789fd$var$e = Symbol.for("react.strict_mode"), $b77f3ad58ee789fd$var$f = Symbol.for("react.profiler"), $b77f3ad58ee789fd$var$g = Symbol.for("react.provider"), $b77f3ad58ee789fd$var$h = Symbol.for("react.context"), $b77f3ad58ee789fd$var$k = Symbol.for("react.server_context"), $b77f3ad58ee789fd$var$l = Symbol.for("react.forward_ref"), $b77f3ad58ee789fd$var$m = Symbol.for("react.suspense"), $b77f3ad58ee789fd$var$n = Symbol.for("react.suspense_list"), $b77f3ad58ee789fd$var$p = Symbol.for("react.memo"), $b77f3ad58ee789fd$var$q = Symbol.for("react.lazy"), $b77f3ad58ee789fd$var$t = Symbol.for("react.offscreen"), $b77f3ad58ee789fd$var$u;
$b77f3ad58ee789fd$var$u = Symbol.for("react.module.reference");
function $b77f3ad58ee789fd$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $b77f3ad58ee789fd$var$b:
                switch(a = a.type, a){
                    case $b77f3ad58ee789fd$var$d:
                    case $b77f3ad58ee789fd$var$f:
                    case $b77f3ad58ee789fd$var$e:
                    case $b77f3ad58ee789fd$var$m:
                    case $b77f3ad58ee789fd$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $b77f3ad58ee789fd$var$k:
                            case $b77f3ad58ee789fd$var$h:
                            case $b77f3ad58ee789fd$var$l:
                            case $b77f3ad58ee789fd$var$q:
                            case $b77f3ad58ee789fd$var$p:
                            case $b77f3ad58ee789fd$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $b77f3ad58ee789fd$var$c:
                return r;
        }
    }
}
$b77f3ad58ee789fd$export$a7c73072b1a182ae = $b77f3ad58ee789fd$var$h;
$b77f3ad58ee789fd$export$9f27bc3417b4524d = $b77f3ad58ee789fd$var$g;
$b77f3ad58ee789fd$export$db77ccec0bb4ccac = $b77f3ad58ee789fd$var$b;
$b77f3ad58ee789fd$export$8392c0c9d3dcbd35 = $b77f3ad58ee789fd$var$l;
$b77f3ad58ee789fd$export$ffb0004e005737fa = $b77f3ad58ee789fd$var$d;
$b77f3ad58ee789fd$export$b624eff549462981 = $b77f3ad58ee789fd$var$q;
$b77f3ad58ee789fd$export$7897aa7841a5380c = $b77f3ad58ee789fd$var$p;
$b77f3ad58ee789fd$export$602eac185826482c = $b77f3ad58ee789fd$var$c;
$b77f3ad58ee789fd$export$e2c29f18771995cb = $b77f3ad58ee789fd$var$f;
$b77f3ad58ee789fd$export$5f8d39834fd61797 = $b77f3ad58ee789fd$var$e;
$b77f3ad58ee789fd$export$74bf444e3cd11ea5 = $b77f3ad58ee789fd$var$m;
$b77f3ad58ee789fd$export$998bcd577473dd93 = $b77f3ad58ee789fd$var$n;
$b77f3ad58ee789fd$export$92387174baf9b227 = function() {
    return !1;
};
$b77f3ad58ee789fd$export$ec112efeb987d9c6 = function() {
    return !1;
};
$b77f3ad58ee789fd$export$b706b080d889d2c9 = function(a) {
    return $b77f3ad58ee789fd$var$v(a) === $b77f3ad58ee789fd$var$h;
};
$b77f3ad58ee789fd$export$5be5a87408f70ddc = function(a) {
    return $b77f3ad58ee789fd$var$v(a) === $b77f3ad58ee789fd$var$g;
};
$b77f3ad58ee789fd$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b77f3ad58ee789fd$var$b;
};
$b77f3ad58ee789fd$export$455c2e768291efa6 = function(a) {
    return $b77f3ad58ee789fd$var$v(a) === $b77f3ad58ee789fd$var$l;
};
$b77f3ad58ee789fd$export$9522e17588c12572 = function(a) {
    return $b77f3ad58ee789fd$var$v(a) === $b77f3ad58ee789fd$var$d;
};
$b77f3ad58ee789fd$export$2110ac352bb060b9 = function(a) {
    return $b77f3ad58ee789fd$var$v(a) === $b77f3ad58ee789fd$var$q;
};
$b77f3ad58ee789fd$export$56885ab8b9c456ab = function(a) {
    return $b77f3ad58ee789fd$var$v(a) === $b77f3ad58ee789fd$var$p;
};
$b77f3ad58ee789fd$export$d927fcb6adf8f9de = function(a) {
    return $b77f3ad58ee789fd$var$v(a) === $b77f3ad58ee789fd$var$c;
};
$b77f3ad58ee789fd$export$b82d16f27459e05a = function(a) {
    return $b77f3ad58ee789fd$var$v(a) === $b77f3ad58ee789fd$var$f;
};
$b77f3ad58ee789fd$export$522c17b4f5e123e8 = function(a) {
    return $b77f3ad58ee789fd$var$v(a) === $b77f3ad58ee789fd$var$e;
};
$b77f3ad58ee789fd$export$1aabd8a0274ecfd6 = function(a) {
    return $b77f3ad58ee789fd$var$v(a) === $b77f3ad58ee789fd$var$m;
};
$b77f3ad58ee789fd$export$3d6c20d97e46b957 = function(a) {
    return $b77f3ad58ee789fd$var$v(a) === $b77f3ad58ee789fd$var$n;
};
$b77f3ad58ee789fd$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $b77f3ad58ee789fd$var$d || a === $b77f3ad58ee789fd$var$f || a === $b77f3ad58ee789fd$var$e || a === $b77f3ad58ee789fd$var$m || a === $b77f3ad58ee789fd$var$n || a === $b77f3ad58ee789fd$var$t || "object" === typeof a && null !== a && (a.$$typeof === $b77f3ad58ee789fd$var$q || a.$$typeof === $b77f3ad58ee789fd$var$p || a.$$typeof === $b77f3ad58ee789fd$var$g || a.$$typeof === $b77f3ad58ee789fd$var$h || a.$$typeof === $b77f3ad58ee789fd$var$l || a.$$typeof === $b77f3ad58ee789fd$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$b77f3ad58ee789fd$export$f5bbd400c2f4426f = $b77f3ad58ee789fd$var$v;

});


parcelRequire.register("kF0Kd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0a836ce59a96924$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");
parcelRequire("9FsNn");
const $f0a836ce59a96924$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $f0a836ce59a96924$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $f0a836ce59a96924$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $4GC5s.default)(_ref, $f0a836ce59a96924$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $f0a836ce59a96924$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRequire.register("9FsNn", function(module, exports) {

var $ey1kL = parcelRequire("ey1kL");
function $709e4789c39db027$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $ey1kL.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $709e4789c39db027$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $709e4789c39db027$var$verify(mapStateToProps, "mapStateToProps");
    $709e4789c39db027$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $709e4789c39db027$var$verify(mergeProps, "mergeProps");
}

});
parcelRequire.register("ey1kL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a975469313804a6f$export$2e2bcd8739ae039; });
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $a975469313804a6f$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRequire.register("hSofF", function(module, exports) {

$parcel$export(module.exports, "mapDispatchToPropsFactory", function () { return $d03a4ab274eaa88a$export$b69a785ceac019a6; });

var $1WjEQ = parcelRequire("1WjEQ");

var $7eyZc = parcelRequire("7eyZc");

var $kgi3q = parcelRequire("kgi3q");
function $d03a4ab274eaa88a$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $7eyZc.wrapMapToPropsConstant)((dispatch)=>(0, $1WjEQ.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $7eyZc.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, $7eyZc.wrapMapToPropsFunc)(mapDispatchToProps, "mapDispatchToProps") : (0, $kgi3q.createInvalidArgFactory)(mapDispatchToProps, "mapDispatchToProps");
}

});
parcelRequire.register("1WjEQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $169a74d44c4f81af$export$2e2bcd8739ae039; });
function $169a74d44c4f81af$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRequire.register("7eyZc", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", function () { return $5444fab25f2b05ad$export$710f7c60f68acd3e; });
$parcel$export(module.exports, "wrapMapToPropsFunc", function () { return $5444fab25f2b05ad$export$8d46c7f53c8c602f; });
parcelRequire("iV715");
function $5444fab25f2b05ad$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $5444fab25f2b05ad$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $5444fab25f2b05ad$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $5444fab25f2b05ad$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $5444fab25f2b05ad$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRequire.register("iV715", function(module, exports) {

var $bFefJ = parcelRequire("bFefJ");

var $ey1kL = parcelRequire("ey1kL");
function $dc62fe2f424e600c$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $bFefJ.default)(value)) (0, $ey1kL.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRequire.register("bFefJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87de9452cd4a60cc$export$2e2bcd8739ae039; });
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $87de9452cd4a60cc$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRequire.register("kgi3q", function(module, exports) {

$parcel$export(module.exports, "createInvalidArgFactory", function () { return $ec034e75c04e330e$export$19ef7b929f7e2559; });
function $ec034e75c04e330e$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRequire.register("7MSOp", function(module, exports) {

$parcel$export(module.exports, "mapStateToPropsFactory", function () { return $5ab7889c02bac3db$export$e00e93951827eda7; });

var $7eyZc = parcelRequire("7eyZc");

var $kgi3q = parcelRequire("kgi3q");
function $5ab7889c02bac3db$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $7eyZc.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === "function" ? (0, $7eyZc.wrapMapToPropsFunc)(mapStateToProps, "mapStateToProps") : (0, $kgi3q.createInvalidArgFactory)(mapStateToProps, "mapStateToProps");
}

});

parcelRequire.register("j5aJr", function(module, exports) {

$parcel$export(module.exports, "mergePropsFactory", function () { return $de46cf10da35fdee$export$17457cf6fa742f84; });

var $dy3ak = parcelRequire("dy3ak");
parcelRequire("iV715");

var $kgi3q = parcelRequire("kgi3q");
function $de46cf10da35fdee$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $dy3ak.default)({}, ownProps, stateProps, dispatchProps);
}
function $de46cf10da35fdee$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $de46cf10da35fdee$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$de46cf10da35fdee$export$691c327fc30bc857 : typeof mergeProps === "function" ? $de46cf10da35fdee$export$5b105939c84b5234(mergeProps) : (0, $kgi3q.createInvalidArgFactory)(mergeProps, "mergeProps");
}

});

parcelRequire.register("6fXdg", function(module, exports) {

$parcel$export(module.exports, "createSubscription", function () { return $48e2133c5d29c037$export$d567d2b9af322f8f; });

var $c3VCc = parcelRequire("c3VCc");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $48e2133c5d29c037$var$createListenerCollection() {
    const batch = (0, $c3VCc.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $48e2133c5d29c037$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $48e2133c5d29c037$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $48e2133c5d29c037$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $48e2133c5d29c037$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $48e2133c5d29c037$var$nullListeners;
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRequire.register("lJh36", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $fd1b068cc985b232$export$700979bc83e7db82; });

var $aOChP = parcelRequire("aOChP");
const $fd1b068cc985b232$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $fd1b068cc985b232$export$700979bc83e7db82 = $fd1b068cc985b232$export$71594e8a50f746f4 ? $aOChP.useLayoutEffect : $aOChP.useEffect;

});

parcelRequire.register("felMU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b169106c20f67e8e$export$2e2bcd8739ae039; });
function $b169106c20f67e8e$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $b169106c20f67e8e$export$2e2bcd8739ae039(objA, objB) {
    if ($b169106c20f67e8e$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$b169106c20f67e8e$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRequire.register("ctPk7", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return (parcelRequire("aBo2k")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("hulgA")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("cm2x1")).useSelector; });

var $aBo2k = parcelRequire("aBo2k");

var $7DVmf = parcelRequire("7DVmf");

var $fc1n7 = parcelRequire("fc1n7");

var $hulgA = parcelRequire("hulgA");

var $cm2x1 = parcelRequire("cm2x1");

var $hgxJ6 = parcelRequire("hgxJ6");

var $felMU = parcelRequire("felMU");
parcelRequire("1yvL4");

});
parcelRequire.register("aBo2k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b80013948951087$export$2e2bcd8739ae039; });

var $aOChP = parcelRequire("aOChP");

var $fc1n7 = parcelRequire("fc1n7");

var $6fXdg = parcelRequire("6fXdg");

var $lJh36 = parcelRequire("lJh36");
function $7b80013948951087$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", noopCheck: noopCheck = "once" }) {
    const contextValue = $aOChP.useMemo(()=>{
        const subscription = (0, $6fXdg.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $aOChP.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $lJh36.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $fc1n7.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $aOChP.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $7b80013948951087$export$2e2bcd8739ae039 = $7b80013948951087$var$Provider;

});

parcelRequire.register("hulgA", function(module, exports) {

$parcel$export(module.exports, "useDispatch", function () { return $cbb5bc1d8fa9b083$export$8ad76b76a4c905f8; });

var $fc1n7 = parcelRequire("fc1n7");

var $hgxJ6 = parcelRequire("hgxJ6");
function $cbb5bc1d8fa9b083$export$bc9b55530897c558(context = (0, $fc1n7.ReactReduxContext)) {
    const useStore = context === (0, $fc1n7.ReactReduxContext) ? (0, $hgxJ6.useStore) : (0, $hgxJ6.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $cbb5bc1d8fa9b083$export$8ad76b76a4c905f8 = /*#__PURE__*/ $cbb5bc1d8fa9b083$export$bc9b55530897c558();

});
parcelRequire.register("hgxJ6", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", function () { return $c91e17aee6d73970$export$671dba69185d0304; });
$parcel$export(module.exports, "useStore", function () { return $c91e17aee6d73970$export$6ccbb43953eebf8; });

var $fc1n7 = parcelRequire("fc1n7");

var $flZJp = parcelRequire("flZJp");
function $c91e17aee6d73970$export$671dba69185d0304(context = (0, $fc1n7.ReactReduxContext)) {
    const useReduxContext = context === (0, $fc1n7.ReactReduxContext) ? (0, $flZJp.useReduxContext) : (0, $flZJp.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $c91e17aee6d73970$export$6ccbb43953eebf8 = /*#__PURE__*/ $c91e17aee6d73970$export$671dba69185d0304();

});


parcelRequire.register("1yvL4", function(module, exports) {

});



parcelRequire.register("jqxdk", function(module, exports) {

$parcel$export(module.exports, "firebaseAuth", function () { return $e24a35a44fa00295$export$b4ae2c1c09f3f2c6; });
$parcel$export(module.exports, "provider", function () { return $e24a35a44fa00295$export$ca328f169d304df4; });
// Import the functions you need from the SDKs you need
parcelRequire("MOjXA");
var $6HgFA = parcelRequire("6HgFA");
parcelRequire("9CGYE");
var $jk7Hk = parcelRequire("jk7Hk");
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const $e24a35a44fa00295$var$firebaseConfig = {
    apiKey: "AIzaSyBIUufdeZnBeSc2YJrQa2LkmuBI3VTe5Ho",
    authDomain: "food-ordering-app-e67d6.firebaseapp.com",
    projectId: "food-ordering-app-e67d6",
    storageBucket: "food-ordering-app-e67d6.appspot.com",
    messagingSenderId: "501970189881",
    appId: "1:501970189881:web:83f1c60ad9666d619817e8",
    measurementId: "G-EL54LY0TPL"
};
// Initialize Firebase
const $e24a35a44fa00295$var$app = (0, $6HgFA.initializeApp)($e24a35a44fa00295$var$firebaseConfig);
const $e24a35a44fa00295$export$b4ae2c1c09f3f2c6 = (0, $jk7Hk.o)($e24a35a44fa00295$var$app);
const $e24a35a44fa00295$export$ca328f169d304df4 = new (0, $jk7Hk.W)();

});
parcelRequire.register("MOjXA", function(module, exports) {
$parcel$export(module.exports, "initializeApp", function () { return (parcelRequire("6HgFA")).initializeApp; });
$parcel$export(module.exports, "registerVersion", function () { return (parcelRequire("6HgFA")).registerVersion; });

var $6HgFA = parcelRequire("6HgFA");
var $092b847fe46ea3ad$var$name = "firebase";
var $092b847fe46ea3ad$var$version = "10.4.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $6HgFA.registerVersion)($092b847fe46ea3ad$var$name, $092b847fe46ea3ad$var$version, "app");

});


parcelRequire.register("6CrLZ", function(module, exports) {
"use strict";
"use client";

var $4SO8W = parcelRequire("4SO8W");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4d1bd5cf54f085c2$var$_createSvgIcon = $4SO8W((parcelRequire("agsGj")));

var $5Wgfu = parcelRequire("5Wgfu");
var $4d1bd5cf54f085c2$var$_default = (0, $4d1bd5cf54f085c2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $5Wgfu.jsx)("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), "Menu");
module.exports.default = $4d1bd5cf54f085c2$var$_default;

});

parcelRequire.register("kNZvx", function(module, exports) {

$parcel$export(module.exports, "HeaderBox", function () { return $f258185fa1af1d38$export$a0d9662ebc657c0c; });
$parcel$export(module.exports, "FoodLogoBox", function () { return $f258185fa1af1d38$export$568aa225dd6161e3; });
$parcel$export(module.exports, "HeadingBox", function () { return $f258185fa1af1d38$export$b4e5e09251522c2c; });
$parcel$export(module.exports, "NavItems", function () { return $f258185fa1af1d38$export$698668688a6e8f34; });
$parcel$export(module.exports, "MobileNavItems", function () { return $f258185fa1af1d38$export$15b8720343e2187; });
$parcel$export(module.exports, "MainBox", function () { return $f258185fa1af1d38$export$45c0d0d85148c88c; });
$parcel$export(module.exports, "CartBox", function () { return $f258185fa1af1d38$export$7f1044b3738ac27d; });
$parcel$export(module.exports, "CartItemBox", function () { return $f258185fa1af1d38$export$a4fc62f641efeb55; });
$parcel$export(module.exports, "Item", function () { return $f258185fa1af1d38$export$6d08773d2e66f8f2; });
$parcel$export(module.exports, "ButtonBox", function () { return $f258185fa1af1d38$export$5e37f977ae0514c2; });
$parcel$export(module.exports, "LogOutUserBox", function () { return $f258185fa1af1d38$export$ff518633db7baeb7; });
$parcel$export(module.exports, "LoggedOutBox", function () { return $f258185fa1af1d38$export$6a1570a405c3c095; });
// src/components/Navbar/NavbarStyles.js

var $7hR8K = parcelRequire("7hR8K");
var $8qBhC = parcelRequire("8qBhC");
var $gx04x = parcelRequire("gx04x");
var $1bGCG = parcelRequire("1bGCG");
const $f258185fa1af1d38$export$a0d9662ebc657c0c = (0, $gx04x.default)((0, $1bGCG.default))(({ theme: theme })=>({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        height: "15vh",
        padding: "10px 0",
        border: "none",
        backgroundColor: "#ffffff",
        backgroundImage: "linear-gradient(to top, rgba(238,194,174,0) 0%, rgba(230,99,103,0.1) 100%)",
        [theme.breakpoints.down("sm")]: {
            padding: "0 5px",
            height: "10vh"
        },
        [theme.breakpoints.between("sm", "md")]: {
            padding: "5px 15px",
            height: "12vh"
        }
    }));
const $f258185fa1af1d38$export$568aa225dd6161e3 = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "20px",
        marginLeft: "38px",
        "& > img": {
            cursor: "pointer",
            background: "none",
            width: "5vw",
            [theme.breakpoints.down("sm")]: {
                width: "10vw"
            }
        },
        [theme.breakpoints.down("sm")]: {
            marginLeft: "5px",
            gap: "15px"
        }
    }));
const $f258185fa1af1d38$export$b4e5e09251522c2c = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        [theme.breakpoints.up("md")]: {
            display: "flex",
            flexDirection: "column",
            "& > p:nth-child(1), & > p:nth-child(2)": {
                fontFamily: "ubuntu",
                fontSize: "26px",
                color: "rgb(211,47,47)",
                fontWeight: "bolder",
                letterSpacing: ".1rem"
            },
            "& > p:nth-child(2)": {
                fontSize: "12px",
                marginLeft: "2.5rem",
                marginBottom: "3px"
            }
        },
        [theme.breakpoints.down("sm")]: {
            fontFamily: "ubuntu",
            fontSize: "26px",
            color: "rgb(211,47,47)",
            fontWeight: "bolder",
            display: "flex",
            flexDirection: "column",
            "& > p:nth-child(1)": {
                fontFamily: "ubuntu",
                fontSize: "26px",
                color: "rgb(211,47,47)",
                fontWeight: "bolder",
                letterSpacing: ".1rem"
            },
            "& > p:nth-child(2)": {
                fontSize: "12px",
                marginLeft: "3rem",
                marginBottom: "3px"
            }
        },
        [theme.breakpoints.down("md")]: {
            fontFamily: "ubuntu",
            fontSize: "26px",
            color: "rgb(211,47,47)",
            fontWeight: "bolder",
            display: "flex",
            flexDirection: "column",
            "& > p:nth-child(1)": {
                fontFamily: "ubuntu",
                fontSize: "26px",
                color: "rgb(211,47,47)",
                fontWeight: "bolder"
            },
            "& > p:nth-child(2)": {
                fontSize: "12px",
                marginLeft: "3rem",
                marginBottom: "3px"
            }
        }
    }));
const $f258185fa1af1d38$export$698668688a6e8f34 = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        gap: "2rem",
        "& > ul": {
            display: "flex",
            alignItems: "center",
            gap: "2rem",
            color: "black",
            fontWeight: "bold",
            fontSize: "16px",
            listStyleType: "none",
            "& a": {
                textDecoration: "none",
                color: "black"
            },
            "& > li > a:hover": {
                color: "rgba(211,47,47,0.5)",
                cursor: "pointer"
            }
        },
        [theme.breakpoints.down("sm")]: {
            display: "none"
        },
        [theme.breakpoints.down("md")]: {
            display: "none"
        }
    }));
const $f258185fa1af1d38$export$15b8720343e2187 = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme, visible: visible })=>({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        letterSpacing: ".1rem",
        gap: "2rem",
        backgroundColor: "#ffffff",
        padding: "2rem 1.4rem",
        fontSize: "16px",
        position: "absolute",
        top: "100%",
        left: 0,
        right: 0,
        zIndex: 1000,
        boxShadow: "0px 5px 6px rgba(0, 0, 0, 0.3)",
        transition: "opacity 0.5s ease-in-out, transform 0.5s ease-in-out, visibility 0.3s ease-in-out",
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(-10px)",
        visibility: visible ? "visible" : "hidden",
        [theme.breakpoints.down("sm")]: {
            display: "flex"
        },
        "& > ul": {
            display: "flex",
            flexDirection: "column",
            gap: "2rem",
            color: "black",
            fontWeight: "bold",
            listStyleType: "none",
            "& a": {
                textDecoration: "none",
                color: "black"
            },
            "& > li > a:hover": {
                color: "rgba(211,47,47,0.5)",
                cursor: "pointer"
            }
        }
    }));
const $f258185fa1af1d38$export$45c0d0d85148c88c = (0, $gx04x.default)((0, $7hR8K.default))`
  display: flex;
  align-items: center;
  gap: 2px;

  :hover {
    color: rgb(211,47,47);
  }
`;
const $f258185fa1af1d38$export$7f1044b3738ac27d = (0, $gx04x.default)((0, $7hR8K.default))`
  position: relative;
  display: flex;
  align-items: center;
  gap: 3px;

  & > svg {
    margin-bottom: 3px;
    font-size: 25px;
  }
`;
const $f258185fa1af1d38$export$a4fc62f641efeb55 = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgb(211,47,47)",
        width: "1.5vw",
        height: "1.5vw",
        borderRadius: "50%",
        top: 0,
        left: "15px",
        [theme.breakpoints.down("sm")]: {
            width: "5vw",
            height: "5vw",
            borderRadius: "50%",
            fontSize: "15px"
        }
    }));
const $f258185fa1af1d38$export$6d08773d2e66f8f2 = (0, $gx04x.default)((0, $7hR8K.default))`
  color: white;
  font-family: "Trebuchet MS";
`;
const $f258185fa1af1d38$export$5e37f977ae0514c2 = (0, $gx04x.default)((0, $8qBhC.default))(({ theme: theme })=>({
        padding: "3px 10px",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        fontWeight: "bolder",
        border: "1.5px solid rgb(211,47,47)",
        textTransform: "capitalize",
        "&:hover": {
            background: "rgb(211,47,47)",
            color: "white",
            boxShadow: "3px 3px 6px rgb(211,47,47)"
        },
        [theme.breakpoints.down("sm")]: {
            padding: "8px 50px"
        }
    }));
const $f258185fa1af1d38$export$ff518633db7baeb7 = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        alignItems: "center",
        gap: "25px",
        marginRight: "3rem",
        [theme.breakpoints.down("sm")]: {
            display: "none"
        },
        [theme.breakpoints.down("md")]: {
            display: "none"
        }
    }));
const $f258185fa1af1d38$export$6a1570a405c3c095 = (0, $gx04x.default)((0, $7hR8K.default))`
  display: flex;
  align-items: center;
  color: rgb(211,47,47);
  gap: 5px;
  font-weight: bolder;
`;

});
parcelRequire.register("8qBhC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $622dac1bcf1815ff$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");

var $f4sog = parcelRequire("f4sog");

var $dhOhi = parcelRequire("dhOhi");

var $4qbW1 = parcelRequire("4qbW1");

var $gx04x = parcelRequire("gx04x");

var $6XlHG = parcelRequire("6XlHG");

var $d1dx4 = parcelRequire("d1dx4");

var $lUjh9 = parcelRequire("lUjh9");

var $dZDh9 = parcelRequire("dZDh9");

var $2dfM7 = parcelRequire("2dfM7");

var $1RZmW = parcelRequire("1RZmW");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $622dac1bcf1815ff$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $622dac1bcf1815ff$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $lUjh9.default)(color)}`,
            `size${(0, $lUjh9.default)(size)}`,
            `${variant}Size${(0, $lUjh9.default)(size)}`,
            color === "inherit" && "colorInherit",
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "startIcon",
            `iconSize${(0, $lUjh9.default)(size)}`
        ],
        endIcon: [
            "endIcon",
            `iconSize${(0, $lUjh9.default)(size)}`
        ]
    };
    const composedClasses = (0, $dhOhi.default)(slots, (0, $dZDh9.getButtonUtilityClass), classes);
    return (0, $dy3ak.default)({}, classes, composedClasses);
};
const $622dac1bcf1815ff$var$commonIconStyles = (ownerState)=>(0, $dy3ak.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $622dac1bcf1815ff$var$ButtonRoot = (0, $gx04x.default)((0, $d1dx4.default), {
    shouldForwardProp: (prop)=>(0, $gx04x.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $lUjh9.default)(ownerState.color)}`],
            styles[`size${(0, $lUjh9.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $lUjh9.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $dy3ak.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $dy3ak.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4qbW1.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4qbW1.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $4qbW1.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $dy3ak.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $dZDh9.default).focusVisible}`]: (0, $dy3ak.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $dZDh9.default).disabled}`]: (0, $dy3ak.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $4qbW1.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $dZDh9.default).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $dZDh9.default).disabled}`]: {
            boxShadow: "none"
        }
    });
const $622dac1bcf1815ff$var$ButtonStartIcon = (0, $gx04x.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $lUjh9.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $dy3ak.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $622dac1bcf1815ff$var$commonIconStyles(ownerState)));
const $622dac1bcf1815ff$var$ButtonEndIcon = (0, $gx04x.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $lUjh9.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $dy3ak.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $622dac1bcf1815ff$var$commonIconStyles(ownerState)));
const $622dac1bcf1815ff$var$Button = /*#__PURE__*/ $aOChP.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $aOChP.useContext((0, $2dfM7.default));
    const buttonGroupButtonContextPositionClassName = $aOChP.useContext((0, $1RZmW.default));
    const resolvedProps = (0, $f4sog.default)(contextProps, inProps);
    const props = (0, $6XlHG.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $4GC5s.default)(props, $622dac1bcf1815ff$var$_excluded);
    const ownerState = (0, $dy3ak.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $622dac1bcf1815ff$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $5Wgfu.jsx)($622dac1bcf1815ff$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $5Wgfu.jsx)($622dac1bcf1815ff$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || "";
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)($622dac1bcf1815ff$var$ButtonRoot, (0, $dy3ak.default)({
        ownerState: ownerState,
        className: (0, $gVoqA.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $gVoqA.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $622dac1bcf1815ff$export$2e2bcd8739ae039 = $622dac1bcf1815ff$var$Button;

});
parcelRequire.register("dZDh9", function(module, exports) {

$parcel$export(module.exports, "getButtonUtilityClass", function () { return $a2ff702aa1e293e5$export$5a6f9035944c8119; });
$parcel$export(module.exports, "default", function () { return $a2ff702aa1e293e5$export$2e2bcd8739ae039; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $a2ff702aa1e293e5$export$5a6f9035944c8119(slot) {
    return (0, $924xM.default)("MuiButton", slot);
}
const $a2ff702aa1e293e5$var$buttonClasses = (0, $83lmX.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $a2ff702aa1e293e5$export$2e2bcd8739ae039 = $a2ff702aa1e293e5$var$buttonClasses;

});

parcelRequire.register("2dfM7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19c90840ce1a72ef$export$2e2bcd8739ae039; });

var $aOChP = parcelRequire("aOChP");
/**
 * @ignore - internal component.
 */ const $19c90840ce1a72ef$var$ButtonGroupContext = /*#__PURE__*/ $aOChP.createContext({});
var $19c90840ce1a72ef$export$2e2bcd8739ae039 = $19c90840ce1a72ef$var$ButtonGroupContext;

});

parcelRequire.register("1RZmW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15ca584764940fc0$export$2e2bcd8739ae039; });

var $aOChP = parcelRequire("aOChP");
/**
 * @ignore - internal component.
 */ const $15ca584764940fc0$var$ButtonGroupButtonContext = /*#__PURE__*/ $aOChP.createContext(undefined);
var $15ca584764940fc0$export$2e2bcd8739ae039 = $15ca584764940fc0$var$ButtonGroupButtonContext;

});


parcelRequire.register("1bGCG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0dd7e18d066469e4$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");

var $dhOhi = parcelRequire("dhOhi");

var $6XlHG = parcelRequire("6XlHG");

var $gx04x = parcelRequire("gx04x");

var $2GakU = parcelRequire("2GakU");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $0dd7e18d066469e4$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $0dd7e18d066469e4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            !disableGutters && "gutters",
            variant
        ]
    };
    return (0, $dhOhi.default)(slots, (0, $2GakU.getToolbarUtilityClass), classes);
};
const $0dd7e18d066469e4$var$ToolbarRoot = (0, $gx04x.default)("div", {
    name: "MuiToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $dy3ak.default)({
        position: "relative",
        display: "flex",
        alignItems: "center"
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === "dense" && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === "regular" && theme.mixins.toolbar);
const $0dd7e18d066469e4$var$Toolbar = /*#__PURE__*/ $aOChP.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiToolbar"
    });
    const { className: className, component: component = "div", disableGutters: disableGutters = false, variant: variant = "regular" } = props, other = (0, $4GC5s.default)(props, $0dd7e18d066469e4$var$_excluded);
    const ownerState = (0, $dy3ak.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $0dd7e18d066469e4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $5Wgfu.jsx)($0dd7e18d066469e4$var$ToolbarRoot, (0, $dy3ak.default)({
        as: component,
        className: (0, $gVoqA.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $0dd7e18d066469e4$export$2e2bcd8739ae039 = $0dd7e18d066469e4$var$Toolbar;

});
parcelRequire.register("2GakU", function(module, exports) {

$parcel$export(module.exports, "getToolbarUtilityClass", function () { return $1f37858ffb2051bb$export$b12cb262231eef32; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $1f37858ffb2051bb$export$b12cb262231eef32(slot) {
    return (0, $924xM.default)("MuiToolbar", slot);
}
const $1f37858ffb2051bb$var$toolbarClasses = (0, $83lmX.default)("MuiToolbar", [
    "root",
    "gutters",
    "regular",
    "dense"
]);
var $1f37858ffb2051bb$export$2e2bcd8739ae039 = $1f37858ffb2051bb$var$toolbarClasses;

});




parcelRequire.register("f11yQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aee828fd1733c228$export$2e2bcd8739ae039; });
parcelRequire("aOChP");

var $kwVyI = parcelRequire("kwVyI");

var $fQJH6 = parcelRequire("fQJH6");

var $bsF6d = parcelRequire("bsF6d");
"use client";
function $aee828fd1733c228$export$2e2bcd8739ae039() {
    const theme = (0, $kwVyI.default)((0, $fQJH6.default));
    return theme[0, $bsF6d.default] || theme;
}

});

parcelRequire.register("alVam", function(module, exports) {
"use strict";
"use client";

var $4SO8W = parcelRequire("4SO8W");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7898358a390e1546$var$React = $7898358a390e1546$var$_interopRequireWildcard((parcelRequire("aOChP")));

var $7898358a390e1546$var$_createSvgIcon = $4SO8W((parcelRequire("agsGj")));

var $5Wgfu = parcelRequire("5Wgfu");
function $7898358a390e1546$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($7898358a390e1546$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $7898358a390e1546$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $7898358a390e1546$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $7898358a390e1546$var$_default = (0, $7898358a390e1546$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $5Wgfu.jsx)("path", {
    d: "M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z"
}), "Instagram");
module.exports.default = $7898358a390e1546$var$_default;

});

parcelRequire.register("dyk5Z", function(module, exports) {
"use strict";
"use client";

var $4SO8W = parcelRequire("4SO8W");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9dde09e6afdf3392$var$React = $9dde09e6afdf3392$var$_interopRequireWildcard((parcelRequire("aOChP")));

var $9dde09e6afdf3392$var$_createSvgIcon = $4SO8W((parcelRequire("agsGj")));

var $5Wgfu = parcelRequire("5Wgfu");
function $9dde09e6afdf3392$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($9dde09e6afdf3392$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $9dde09e6afdf3392$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $9dde09e6afdf3392$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $9dde09e6afdf3392$var$_default = (0, $9dde09e6afdf3392$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $5Wgfu.jsx)("path", {
    d: "M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"
}), "LinkedIn");
module.exports.default = $9dde09e6afdf3392$var$_default;

});

parcelRequire.register("dZlV3", function(module, exports) {
"use strict";
"use client";

var $4SO8W = parcelRequire("4SO8W");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2f1f98cb014c22b$var$React = $a2f1f98cb014c22b$var$_interopRequireWildcard((parcelRequire("aOChP")));

var $a2f1f98cb014c22b$var$_createSvgIcon = $4SO8W((parcelRequire("agsGj")));

var $5Wgfu = parcelRequire("5Wgfu");
function $a2f1f98cb014c22b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a2f1f98cb014c22b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a2f1f98cb014c22b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a2f1f98cb014c22b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $a2f1f98cb014c22b$var$_default = (0, $a2f1f98cb014c22b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $5Wgfu.jsx)("path", {
    d: "M12 1.27a11 11 0 00-3.48 21.46c.55.09.73-.28.73-.55v-1.84c-3.03.64-3.67-1.46-3.67-1.46-.55-1.29-1.28-1.65-1.28-1.65-.92-.65.1-.65.1-.65 1.1 0 1.73 1.1 1.73 1.1.92 1.65 2.57 1.2 3.21.92a2 2 0 01.64-1.47c-2.47-.27-5.04-1.19-5.04-5.5 0-1.1.46-2.1 1.2-2.84a3.76 3.76 0 010-2.93s.91-.28 3.11 1.1c1.8-.49 3.7-.49 5.5 0 2.1-1.38 3.02-1.1 3.02-1.1a3.76 3.76 0 010 2.93c.83.74 1.2 1.74 1.2 2.94 0 4.21-2.57 5.13-5.04 5.4.45.37.82.92.82 2.02v3.03c0 .27.1.64.73.55A11 11 0 0012 1.27"
}), "GitHub");
module.exports.default = $a2f1f98cb014c22b$var$_default;

});

parcelRequire.register("6ppXP", function(module, exports) {
"use strict";
"use client";

var $4SO8W = parcelRequire("4SO8W");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4aa937ce5ed3f47f$var$_createSvgIcon = $4SO8W((parcelRequire("agsGj")));

var $5Wgfu = parcelRequire("5Wgfu");
var $4aa937ce5ed3f47f$var$_default = (0, $4aa937ce5ed3f47f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $5Wgfu.jsx)("path", {
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
}), "MailOutline");
module.exports.default = $4aa937ce5ed3f47f$var$_default;

});

parcelRequire.register("f8Jhy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b05aba75c1b8e56c$export$2e2bcd8739ae039; });

var $5Wgfu = parcelRequire("5Wgfu");
parcelRequire("aOChP");

var $7hR8K = parcelRequire("7hR8K");
var $iQrjA = parcelRequire("iQrjA");
var $6ETRI = parcelRequire("6ETRI");
var $gx04x = parcelRequire("gx04x");
var $3k1mL = parcelRequire("3k1mL");
var $f11yQ = parcelRequire("f11yQ");

var $1q6PJ = parcelRequire("1q6PJ");

var $l35nU = parcelRequire("l35nU");

var $5igUh = parcelRequire("5igUh");
const $b05aba75c1b8e56c$var$AppBox = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "rgb(240,240,245)",
        width: "100%",
        gap: "4rem",
        height: "18vh",
        padding: "0 5rem",
        marginTop: "5rem",
        "& > div": {
            "& p": {
                fontFamily: "Trebuchet MS",
                fontSize: "28px",
                fontWeight: "900",
                [theme.breakpoints.down("sm")]: {
                    fontSize: "22px",
                    fontWeight: "900",
                    textAlign: "center"
                }
            },
            "& img": {
                cursor: "pointer",
                width: "16vw",
                height: "12vh",
                [theme.breakpoints.down("sm")]: {
                    width: "25vw",
                    height: "5vh"
                }
            }
        },
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            height: "auto",
            gap: "1rem",
            width: "100%",
            padding: "0 1rem"
        }
    }));
const $b05aba75c1b8e56c$var$FooterContainer = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        background: "rgb(2,6,12)",
        color: "#838787",
        width: "100%",
        minHeight: "60vh",
        textAlign: "center",
        padding: "2rem 0",
        [theme.breakpoints.down("sm")]: {
            height: "auto",
            width: "100%",
            padding: "1rem"
        },
        [theme.breakpoints.down("md")]: {
            height: "auto",
            padding: "1rem"
        }
    }));
const $b05aba75c1b8e56c$var$GridContainer = (0, $gx04x.default)((0, $iQrjA.default))(({ theme: theme })=>({
        display: "flex",
        margin: "2rem 0 0 2rem",
        "& > p": {
            fontWeight: "bold"
        },
        "& ul": {
            listStyle: "none"
        },
        [theme.breakpoints.down("sm", "md")]: {
            flexDirection: "column",
            margin: "0"
        }
    }));
const $b05aba75c1b8e56c$var$Panel = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        gap: "6rem",
        flexWrap: "wrap",
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            gap: "2rem"
        }
    }));
const $b05aba75c1b8e56c$var$LeftPanel = (0, $gx04x.default)($b05aba75c1b8e56c$var$Panel)(({ theme: theme })=>({
        display: "flex",
        gap: "6rem",
        marginRight: "3rem",
        "& > div": {
            "& p": {
                fontFamily: '"Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande", "Lucida Sans", Arial, sans-serif',
                color: "white",
                marginBottom: "8px",
                fontSize: "14px"
            },
            "& a": {
                color: "#838787",
                "&:hover": {
                    color: "white"
                }
            },
            "& li": {
                marginBottom: "8px",
                fontSize: "14px"
            }
        }
    }));
const $b05aba75c1b8e56c$var$RightPanel = (0, $gx04x.default)($b05aba75c1b8e56c$var$Panel)(({ theme: theme })=>({
        borderLeft: "1px solid grey",
        paddingLeft: "25px",
        marginRight: "3rem",
        "& > div": {
            "& p": {
                fontFamily: '"Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande", "Lucida Sans", Arial, sans-serif',
                color: "white",
                marginBottom: "8px",
                fontSize: "14px"
            },
            "ul > li": {
                marginBottom: "8px"
            }
        },
        [theme.breakpoints.down("md")]: {
            borderLeft: "none",
            paddingLeft: "0"
        }
    }));
const $b05aba75c1b8e56c$var$Footer = ()=>{
    const theme = (0, $f11yQ.default)();
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $5Wgfu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsxs)($b05aba75c1b8e56c$var$AppBox, {
                children: [
                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $7hR8K.default), {
                        sx: {
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                            children: "For better experience, download the app now"
                        })
                    }),
                    /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $7hR8K.default), {
                        sx: {
                            display: "flex",
                            gap: "20px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("a", {
                                href: "https://play.google.com/store/apps/details?id=in.swiggy.android&hl=en&gl=US",
                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($l35nU))),
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("a", {
                                href: "https://apps.apple.com/in/app/swiggy-food-grocery-delivery/id989540920",
                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1q6PJ))),
                                    alt: ""
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)($b05aba75c1b8e56c$var$FooterContainer, {
                children: /*#__PURE__*/ (0, $5Wgfu.jsxs)($b05aba75c1b8e56c$var$GridContainer, {
                    container: true,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $iQrjA.default), {
                            item: true,
                            xs: 12,
                            sm: 12,
                            md: 12,
                            lg: 7,
                            children: /*#__PURE__*/ (0, $5Wgfu.jsxs)($b05aba75c1b8e56c$var$LeftPanel, {
                                children: [
                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $7hR8K.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                                children: "COMPANY"
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ETRI.default), {
                                                            href: "#",
                                                            children: "About Us"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ETRI.default), {
                                                            href: "#",
                                                            children: "Team"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ETRI.default), {
                                                            href: "#",
                                                            children: "Careers"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ETRI.default), {
                                                            href: "#",
                                                            children: "Blog"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ETRI.default), {
                                                            href: "#",
                                                            children: "Instamart"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ETRI.default), {
                                                            href: "#",
                                                            children: "Corporate"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ETRI.default), {
                                                            href: "#",
                                                            children: "Bounty"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $7hR8K.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                                children: "CONTACT US"
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ETRI.default), {
                                                            href: "#",
                                                            children: "Help & Support"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ETRI.default), {
                                                            href: "#",
                                                            children: "Partner With Us"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ETRI.default), {
                                                            href: "#",
                                                            children: "Ride With Us"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $7hR8K.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                                children: "HELP"
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ETRI.default), {
                                                            href: "#",
                                                            children: "Payments"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ETRI.default), {
                                                            href: "#",
                                                            children: "Shipping"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ETRI.default), {
                                                            href: "#",
                                                            children: "Cancellation & Returns"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ETRI.default), {
                                                            href: "#",
                                                            children: "FAQ"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ETRI.default), {
                                                            href: "#",
                                                            children: "Report"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $7hR8K.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                                children: "SOCIAL"
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ETRI.default), {
                                                            href: "#",
                                                            children: "Facebook"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ETRI.default), {
                                                            href: "#",
                                                            children: "Twitter"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ETRI.default), {
                                                            href: "#",
                                                            children: "Instagram"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ETRI.default), {
                                                            href: "#",
                                                            children: "YouTube"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $iQrjA.default), {
                            item: true,
                            xs: 12,
                            sm: 12,
                            md: 5,
                            lg: 5,
                            children: /*#__PURE__*/ (0, $5Wgfu.jsxs)($b05aba75c1b8e56c$var$RightPanel, {
                                children: [
                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $7hR8K.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                                children: "LEGAL"
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $7hR8K.default), {
                                                sx: {
                                                    fontSize: "14px"
                                                },
                                                children: /*#__PURE__*/ (0, $5Wgfu.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                            children: "Terms & Conditions"
                                                        }),
                                                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                            children: "Refund & Cancellation"
                                                        }),
                                                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                            children: "Privacy Policy"
                                                        }),
                                                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                            children: "Cookie Policy"
                                                        }),
                                                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                            children: "Offer Terms"
                                                        }),
                                                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                            children: "Phishing & Fraud"
                                                        }),
                                                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                            children: "FV Instamart"
                                                        }),
                                                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                            children: "FV Money Codes"
                                                        }),
                                                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                            children: "FV Discount Voucher"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $7hR8K.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                                children: "WE DELIVER TO:"
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $7hR8K.default), {
                                                sx: {
                                                    fontSize: "14px"
                                                },
                                                children: /*#__PURE__*/ (0, $5Wgfu.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                            children: "Bangalore"
                                                        }),
                                                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                            children: "Gurgaon"
                                                        }),
                                                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                            children: "Hyderabad"
                                                        }),
                                                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                            children: "Kolkata"
                                                        }),
                                                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                            children: "Delhi"
                                                        }),
                                                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                            children: "Mumbai"
                                                        }),
                                                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                            children: "Pune"
                                                        }),
                                                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                                            children: "& other 588 Cities in India"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $5igUh.default), {})
        ]
    });
};
var $b05aba75c1b8e56c$export$2e2bcd8739ae039 = $b05aba75c1b8e56c$var$Footer;

});
parcelRequire.register("iQrjA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db82457e1cae9c96$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");

var $I0S4C = parcelRequire("I0S4C");
var $0ctWP = parcelRequire("0ctWP");

var $dhOhi = parcelRequire("dhOhi");


var $gx04x = parcelRequire("gx04x");

var $6XlHG = parcelRequire("6XlHG");

var $f11yQ = parcelRequire("f11yQ");

var $l3b0o = parcelRequire("l3b0o");

var $GOETA = parcelRequire("GOETA");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $db82457e1cae9c96$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $db82457e1cae9c96$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), "") || "px"}`;
}
function $db82457e1cae9c96$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        else if (size === "auto") styles = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        else {
            const columnsBreakpointValues = (0, $I0S4C.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === "object" ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== "0px") {
                    const fullWidth = `calc(${width} + ${$db82457e1cae9c96$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $dy3ak.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $db82457e1cae9c96$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $I0S4C.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $I0S4C.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf("column") === 0) output[`& > .${(0, $GOETA.default).item}`] = {
            maxWidth: "none"
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $db82457e1cae9c96$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = "";
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== "") return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $db82457e1cae9c96$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $I0S4C.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === "object") zeroValueBreakpointKeys = $db82457e1cae9c96$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $I0S4C.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                marginTop: `-${$db82457e1cae9c96$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $GOETA.default).item}`]: {
                    paddingTop: $db82457e1cae9c96$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $GOETA.default).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $db82457e1cae9c96$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $I0S4C.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === "object") zeroValueBreakpointKeys = $db82457e1cae9c96$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $I0S4C.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                width: `calc(100% + ${$db82457e1cae9c96$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$db82457e1cae9c96$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $GOETA.default).item}`]: {
                    paddingLeft: $db82457e1cae9c96$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: "100%",
                marginLeft: 0,
                [`& > .${(0, $GOETA.default).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $db82457e1cae9c96$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $db82457e1cae9c96$var$GridRoot = (0, $gx04x.default)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $db82457e1cae9c96$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== "row" && styles[`direction-xs-${String(direction)}`],
            wrap !== "wrap" && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $dy3ak.default)({
        boxSizing: "border-box"
    }, ownerState.container && {
        display: "flex",
        flexWrap: "wrap",
        width: "100%"
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    }), $db82457e1cae9c96$export$71d4225eeb1bc13e, $db82457e1cae9c96$export$380604d7c79f9e8f, $db82457e1cae9c96$export$4315fba5128fb4a1, $db82457e1cae9c96$export$ca2a698f6020fda);
function $db82457e1cae9c96$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $db82457e1cae9c96$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $db82457e1cae9c96$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            "root",
            container && "container",
            item && "item",
            zeroMinWidth && "zeroMinWidth",
            ...spacingClasses,
            direction !== "row" && `direction-xs-${String(direction)}`,
            wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $dhOhi.default)(slots, (0, $GOETA.getGridUtilityClass), classes);
};
const $db82457e1cae9c96$var$Grid = /*#__PURE__*/ $aOChP.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiGrid"
    });
    const { breakpoints: breakpoints } = (0, $f11yQ.default)();
    const props = (0, $0ctWP.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = "div", container: container = false, direction: direction = "row", item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = "wrap", zeroMinWidth: zeroMinWidth = false } = props, other = (0, $4GC5s.default)(props, $db82457e1cae9c96$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $aOChP.useContext((0, $l3b0o.default));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $dy3ak.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $dy3ak.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $db82457e1cae9c96$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $l3b0o.default).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $5Wgfu.jsx)($db82457e1cae9c96$var$GridRoot, (0, $dy3ak.default)({
            ownerState: ownerState,
            className: (0, $gVoqA.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $db82457e1cae9c96$export$2e2bcd8739ae039 = $db82457e1cae9c96$var$Grid;

});
parcelRequire.register("l3b0o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5326a399cdbb917$export$2e2bcd8739ae039; });

var $aOChP = parcelRequire("aOChP");
"use client";
/**
 * @ignore - internal component.
 */ const $f5326a399cdbb917$var$GridContext = /*#__PURE__*/ $aOChP.createContext();
var $f5326a399cdbb917$export$2e2bcd8739ae039 = $f5326a399cdbb917$var$GridContext;

});

parcelRequire.register("GOETA", function(module, exports) {

$parcel$export(module.exports, "getGridUtilityClass", function () { return $080b381a4a05ddd2$export$9973ac5fd0181f33; });
$parcel$export(module.exports, "default", function () { return $080b381a4a05ddd2$export$2e2bcd8739ae039; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $080b381a4a05ddd2$export$9973ac5fd0181f33(slot) {
    return (0, $924xM.default)("MuiGrid", slot);
}
const $080b381a4a05ddd2$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $080b381a4a05ddd2$var$DIRECTIONS = [
    "column-reverse",
    "column",
    "row-reverse",
    "row"
];
const $080b381a4a05ddd2$var$WRAPS = [
    "nowrap",
    "wrap-reverse",
    "wrap"
];
const $080b381a4a05ddd2$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $080b381a4a05ddd2$var$gridClasses = (0, $83lmX.default)("MuiGrid", [
    "root",
    "container",
    "item",
    "zeroMinWidth",
    // spacings
    ...$080b381a4a05ddd2$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$080b381a4a05ddd2$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$080b381a4a05ddd2$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$080b381a4a05ddd2$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$080b381a4a05ddd2$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$080b381a4a05ddd2$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$080b381a4a05ddd2$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$080b381a4a05ddd2$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $080b381a4a05ddd2$export$2e2bcd8739ae039 = $080b381a4a05ddd2$var$gridClasses;

});


parcelRequire.register("6ETRI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d91d035e08f3df2$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");


var $dhOhi = parcelRequire("dhOhi");

var $lUjh9 = parcelRequire("lUjh9");

var $gx04x = parcelRequire("gx04x");

var $6XlHG = parcelRequire("6XlHG");

var $aAoqW = parcelRequire("aAoqW");

var $4w8df = parcelRequire("4w8df");

var $3k1mL = parcelRequire("3k1mL");

var $6R0za = parcelRequire("6R0za");

var $eDvLN = parcelRequire("eDvLN");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $4d91d035e08f3df2$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $4d91d035e08f3df2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            "root",
            `underline${(0, $lUjh9.default)(underline)}`,
            component === "button" && "button",
            focusVisible && "focusVisible"
        ]
    };
    return (0, $dhOhi.default)(slots, (0, $6R0za.getLinkUtilityClass), classes);
};
const $4d91d035e08f3df2$var$LinkRoot = (0, $gx04x.default)((0, $3k1mL.default), {
    name: "MuiLink",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $lUjh9.default)(ownerState.underline)}`],
            ownerState.component === "button" && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $dy3ak.default)({}, ownerState.underline === "none" && {
        textDecoration: "none"
    }, ownerState.underline === "hover" && {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    }, ownerState.underline === "always" && (0, $dy3ak.default)({
        textDecoration: "underline"
    }, ownerState.color !== "inherit" && {
        textDecorationColor: (0, $eDvLN.default)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        "&:hover": {
            textDecorationColor: "inherit"
        }
    }), ownerState.component === "button" && {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        [`&.${(0, $6R0za.default).focusVisible}`]: {
            outline: "auto"
        }
    });
});
const $4d91d035e08f3df2$var$Link = /*#__PURE__*/ $aOChP.forwardRef(function Link(inProps, ref) {
    const props = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiLink"
    });
    const { className: className, color: color = "primary", component: component = "a", onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = "always", variant: variant = "inherit", sx: sx } = props, other = (0, $4GC5s.default)(props, $4d91d035e08f3df2$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $aAoqW.default)();
    const [focusVisible, setFocusVisible] = $aOChP.useState(false);
    const handlerRef = (0, $4w8df.default)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $dy3ak.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $4d91d035e08f3df2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $5Wgfu.jsx)($4d91d035e08f3df2$var$LinkRoot, (0, $dy3ak.default)({
        color: color,
        className: (0, $gVoqA.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $eDvLN.colorTransformations)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
var $4d91d035e08f3df2$export$2e2bcd8739ae039 = $4d91d035e08f3df2$var$Link;

});
parcelRequire.register("6R0za", function(module, exports) {

$parcel$export(module.exports, "getLinkUtilityClass", function () { return $4fd821bee1839d6c$export$d6efab9620b78fec; });
$parcel$export(module.exports, "default", function () { return $4fd821bee1839d6c$export$2e2bcd8739ae039; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $4fd821bee1839d6c$export$d6efab9620b78fec(slot) {
    return (0, $924xM.default)("MuiLink", slot);
}
const $4fd821bee1839d6c$var$linkClasses = (0, $83lmX.default)("MuiLink", [
    "root",
    "underlineNone",
    "underlineHover",
    "underlineAlways",
    "button",
    "focusVisible"
]);
var $4fd821bee1839d6c$export$2e2bcd8739ae039 = $4fd821bee1839d6c$var$linkClasses;

});

parcelRequire.register("eDvLN", function(module, exports) {

$parcel$export(module.exports, "colorTransformations", function () { return $aa7d5a0faedf5aa4$export$c4e140d5d351182b; });
$parcel$export(module.exports, "default", function () { return $aa7d5a0faedf5aa4$export$2e2bcd8739ae039; });

var $4qbW1 = parcelRequire("4qbW1");
var $4eBQW = parcelRequire("4eBQW");
const $aa7d5a0faedf5aa4$export$c4e140d5d351182b = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $aa7d5a0faedf5aa4$var$transformDeprecatedColors = (color)=>{
    return $aa7d5a0faedf5aa4$export$c4e140d5d351182b[color] || color;
};
const $aa7d5a0faedf5aa4$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $aa7d5a0faedf5aa4$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $4eBQW.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $4eBQW.getPath)(theme, `palette.${transformedColor}Channel`);
    if ("vars" in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $4qbW1.alpha)(color, 0.4);
};
var $aa7d5a0faedf5aa4$export$2e2bcd8739ae039 = $aa7d5a0faedf5aa4$var$getTextDecoration;

});


parcelRequire.register("1q6PJ", function(module, exports) {

module.exports = new URL((parcelRequire("9wJdH")).resolve("bYLRz"), import.meta.url).toString();

});

parcelRequire.register("l35nU", function(module, exports) {

module.exports = new URL((parcelRequire("9wJdH")).resolve("6ooWt"), import.meta.url).toString();

});

parcelRequire.register("5igUh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3dabbf8aa35b1fa7$export$2e2bcd8739ae039; });

var $5Wgfu = parcelRequire("5Wgfu");
parcelRequire("aOChP");

var $7hR8K = parcelRequire("7hR8K");
var $gx04x = parcelRequire("gx04x");
var $3k1mL = parcelRequire("3k1mL");

var $kTVsv = parcelRequire("kTVsv");

var $alVam = parcelRequire("alVam");

var $dyk5Z = parcelRequire("dyk5Z");

var $dZlV3 = parcelRequire("dZlV3");

var $6ppXP = parcelRequire("6ppXP");
const $3dabbf8aa35b1fa7$var$MainContainer = (0, $gx04x.default)((0, $7hR8K.default))`
  display: flex;
  flex-direction: column;
`;
const $3dabbf8aa35b1fa7$var$Container = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        background: "rgb(2, 6, 12)",
        width: "100%",
        height: "15vh",
        padding: "1rem 3rem",
        color: "white",
        marginTop: "0.1rem",
        [theme.breakpoints.down("sm")]: {
            padding: "1rem 2rem",
            flexDirection: "column",
            alignItems: "center",
            height: "auto",
            gap: "15px"
        },
        [theme.breakpoints.down("md")]: {
            padding: "1rem 2rem",
            flexDirection: "column",
            alignItems: "center",
            height: "auto",
            gap: "20px"
        }
    }));
const $3dabbf8aa35b1fa7$var$LogoImage = (0, $gx04x.default)("img")(({ theme: theme })=>({
        width: "6vw",
        [theme.breakpoints.down("md")]: {
            width: "15vw",
            marginBottom: "1rem"
        }
    }));
const $3dabbf8aa35b1fa7$var$FooterText = (0, $gx04x.default)((0, $3k1mL.default))(({ theme: theme })=>({
        fontFamily: "Trebuchet MS",
        fontSize: "18px",
        fontWeight: 900,
        [theme.breakpoints.down("md")]: {
            textAlign: "center"
        }
    }));
const $3dabbf8aa35b1fa7$var$IconContainer = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        gap: "20px",
        alignItems: "center",
        justifyContent: "center",
        "& > a:hover": {
            transform: "scale(1.2)",
            transition: "0.3s"
        }
    }));
const $3dabbf8aa35b1fa7$var$SubContainer = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        height: "14vh",
        backgroundImage: "linear-gradient(to bottom, rgba(238,194,174,0) 0%, rgba(230,99,103,0.3) 100%)",
        "& > p > span": {
            fontWeight: "900",
            color: "rgb(211,47,47)"
        },
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "center",
            padding: "5px"
        },
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            alignItems: "center",
            padding: "8px"
        }
    }));
const $3dabbf8aa35b1fa7$var$SubFooter = ()=>{
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)($3dabbf8aa35b1fa7$var$MainContainer, {
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsxs)($3dabbf8aa35b1fa7$var$Container, {
                children: [
                    /*#__PURE__*/ (0, $5Wgfu.jsx)($3dabbf8aa35b1fa7$var$LogoImage, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($kTVsv))),
                        alt: ""
                    }),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)($3dabbf8aa35b1fa7$var$FooterText, {
                        children: "\xa9 2023 The Foodie Zone"
                    }),
                    /*#__PURE__*/ (0, $5Wgfu.jsxs)($3dabbf8aa35b1fa7$var$IconContainer, {
                        children: [
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("a", {
                                href: "https://www.instagram.com/o_n_k_a_r_0895/",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($alVam))), {
                                    sx: {
                                        cursor: "pointer",
                                        color: "white"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("a", {
                                href: "https://github.com/onkar895/FOOD-ORDERING-APP",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dZlV3))), {
                                    sx: {
                                        cursor: "pointer",
                                        color: "white"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("a", {
                                href: "https://www.linkedin.com/in/omkarkarale541/",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dyk5Z))), {
                                    sx: {
                                        cursor: "pointer",
                                        color: "white"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("a", {
                                href: "mailto:onkarkarale4@gmail.com",
                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6ppXP))), {
                                    sx: {
                                        cursor: "pointer",
                                        color: "white"
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)($3dabbf8aa35b1fa7$var$SubContainer, {
                children: /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $3k1mL.default), {
                    children: [
                        "Made with ❤️ by ",
                        /*#__PURE__*/ (0, $5Wgfu.jsx)("span", {
                            children: " Onkar Karale \uD83D\uDE0A"
                        })
                    ]
                })
            })
        ]
    });
};
var $3dabbf8aa35b1fa7$export$2e2bcd8739ae039 = $3dabbf8aa35b1fa7$var$SubFooter;

});


parcelRequire.register("5RJCF", function(module, exports) {

(()=>{
    var e = {
        181: (e, t, r)=>{
            var o = /^\s+|\s+$/g, n = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, u = /^0o[0-7]+$/i, c = parseInt, s = "object" == typeof r.g && r.g && r.g.Object === Object && r.g, l = "object" == typeof self && self && self.Object === Object && self, a = s || l || Function("return this")(), f = Object.prototype.toString, p = Math.max, y = Math.min, b = function() {
                return a.Date.now();
            };
            function d(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function h(e) {
                if ("number" == typeof e) return e;
                if (function(e) {
                    return "symbol" == typeof e || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && "[object Symbol]" == f.call(e);
                }(e)) return NaN;
                if (d(e)) {
                    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                    e = d(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = e.replace(o, "");
                var r = i.test(e);
                return r || u.test(e) ? c(e.slice(2), r ? 2 : 8) : n.test(e) ? NaN : +e;
            }
            e.exports = function(e, t, r) {
                var o, n, i, u, c, s, l = 0, a = !1, f = !1, v = !0;
                if ("function" != typeof e) throw new TypeError("Expected a function");
                function m(t) {
                    var r = o, i = n;
                    return o = n = void 0, l = t, u = e.apply(i, r);
                }
                function O(e) {
                    var r = e - s;
                    return void 0 === s || r >= t || r < 0 || f && e - l >= i;
                }
                function w() {
                    var e = b();
                    if (O(e)) return g(e);
                    c = setTimeout(w, function(e) {
                        var r = t - (e - s);
                        return f ? y(r, i - (e - l)) : r;
                    }(e));
                }
                function g(e) {
                    return c = void 0, v && o ? m(e) : (o = n = void 0, u);
                }
                function P() {
                    var e = b(), r = O(e);
                    if (o = arguments, n = this, s = e, r) {
                        if (void 0 === c) return function(e) {
                            return l = e, c = setTimeout(w, t), a ? m(e) : u;
                        }(s);
                        if (f) return c = setTimeout(w, t), m(s);
                    }
                    return void 0 === c && (c = setTimeout(w, t)), u;
                }
                return t = h(t) || 0, d(r) && (a = !!r.leading, i = (f = "maxWait" in r) ? p(h(r.maxWait) || 0, t) : i, v = "trailing" in r ? !!r.trailing : v), P.cancel = function() {
                    void 0 !== c && clearTimeout(c), l = 0, o = s = n = c = void 0;
                }, P.flush = function() {
                    return void 0 === c ? u : g(b());
                }, P;
            };
        },
        858: (e, t, r)=>{
            var o = "Expected a function", n = NaN, i = "[object Symbol]", u = /^\s+|\s+$/g, c = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, l = /^0o[0-7]+$/i, a = parseInt, f = "object" == typeof r.g && r.g && r.g.Object === Object && r.g, p = "object" == typeof self && self && self.Object === Object && self, y = f || p || Function("return this")(), b = Object.prototype.toString, d = Math.max, h = Math.min, v = function() {
                return y.Date.now();
            };
            function m(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function O(e) {
                if ("number" == typeof e) return e;
                if (function(e) {
                    return "symbol" == typeof e || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && b.call(e) == i;
                }(e)) return n;
                if (m(e)) {
                    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                    e = m(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = e.replace(u, "");
                var r = s.test(e);
                return r || l.test(e) ? a(e.slice(2), r ? 2 : 8) : c.test(e) ? n : +e;
            }
            e.exports = function(e, t, r) {
                var n = !0, i = !0;
                if ("function" != typeof e) throw new TypeError(o);
                return m(r) && (n = "leading" in r ? !!r.leading : n, i = "trailing" in r ? !!r.trailing : i), function(e, t, r) {
                    var n, i, u, c, s, l, a = 0, f = !1, p = !1, y = !0;
                    if ("function" != typeof e) throw new TypeError(o);
                    function b(t) {
                        var r = n, o = i;
                        return n = i = void 0, a = t, c = e.apply(o, r);
                    }
                    function w(e) {
                        var r = e - l;
                        return void 0 === l || r >= t || r < 0 || p && e - a >= u;
                    }
                    function g() {
                        var e = v();
                        if (w(e)) return P(e);
                        s = setTimeout(g, function(e) {
                            var r = t - (e - l);
                            return p ? h(r, u - (e - a)) : r;
                        }(e));
                    }
                    function P(e) {
                        return s = void 0, y && n ? b(e) : (n = i = void 0, c);
                    }
                    function j() {
                        var e = v(), r = w(e);
                        if (n = arguments, i = this, l = e, r) {
                            if (void 0 === s) return function(e) {
                                return a = e, s = setTimeout(g, t), f ? b(e) : c;
                            }(l);
                            if (p) return s = setTimeout(g, t), b(l);
                        }
                        return void 0 === s && (s = setTimeout(g, t)), c;
                    }
                    return t = O(t) || 0, m(r) && (f = !!r.leading, u = (p = "maxWait" in r) ? d(O(r.maxWait) || 0, t) : u, y = "trailing" in r ? !!r.trailing : y), j.cancel = function() {
                        void 0 !== s && clearTimeout(s), a = 0, n = l = i = s = void 0;
                    }, j.flush = function() {
                        return void 0 === s ? c : P(v());
                    }, j;
                }(e, t, {
                    leading: n,
                    maxWait: t,
                    trailing: i
                });
            };
        },
        694: (e, t, r)=>{
            "use strict";
            var o = r(925);
            function n() {}
            function i() {}
            i.resetWarningCache = n, e.exports = function() {
                function e(e, t, r, n, i, u) {
                    if (u !== o) {
                        var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                        throw c.name = "Invariant Violation", c;
                    }
                }
                function t() {
                    return e;
                }
                e.isRequired = e;
                var r = {
                    array: e,
                    bigint: e,
                    bool: e,
                    func: e,
                    number: e,
                    object: e,
                    string: e,
                    symbol: e,
                    any: e,
                    arrayOf: t,
                    element: e,
                    elementType: e,
                    instanceOf: t,
                    node: e,
                    objectOf: t,
                    oneOf: t,
                    oneOfType: t,
                    shape: t,
                    exact: t,
                    checkPropTypes: i,
                    resetWarningCache: n
                };
                return r.PropTypes = r, r;
            };
        },
        556: (e, t, r)=>{
            e.exports = r(694)();
        },
        925: (e)=>{
            "use strict";
            e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        }
    }, t = {};
    function r(o) {
        var n = t[o];
        if (void 0 !== n) return n.exports;
        var i = t[o] = {
            exports: {}
        };
        return e[o](i, i.exports, r), i.exports;
    }
    r.n = (e)=>{
        var t = e && e.__esModule ? ()=>e.default : ()=>e;
        return r.d(t, {
            a: t
        }), t;
    }, r.d = (e, t)=>{
        for(var o in t)r.o(t, o) && !r.o(e, o) && Object.defineProperty(e, o, {
            enumerable: !0,
            get: t[o]
        });
    }, r.g = function() {
        if ("object" == typeof globalThis) return globalThis;
        try {
            return this || new Function("return this")();
        } catch (e) {
            if ("object" == typeof window) return window;
        }
    }(), r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r.r = (e)=>{
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    };
    var o = {};
    (()=>{
        "use strict";
        r.r(o), r.d(o, {
            LazyLoadComponent: ()=>te,
            LazyLoadImage: ()=>de,
            trackWindowScroll: ()=>N
        });
        const e = (parcelRequire("aOChP"));
        var t = r.n(e), n = r(556);
        function i() {
            return "undefined" != typeof window && "IntersectionObserver" in window && "isIntersecting" in window.IntersectionObserverEntry.prototype;
        }
        function u(e) {
            return u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, u(e);
        }
        function c(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                t && (o = o.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), r.push.apply(r, o);
            }
            return r;
        }
        function s(e, t, r) {
            return (t = a(t)) in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r, e;
        }
        function l(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, a(o.key), o);
            }
        }
        function a(e) {
            var t = function(e, t) {
                if ("object" != u(e) || !e) return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var o = r.call(e, "string");
                    if ("object" != u(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
            }(e);
            return "symbol" == u(t) ? t : t + "";
        }
        function f(e, t, r) {
            return t = y(t), function(e, t) {
                if (t && ("object" == u(t) || "function" == typeof t)) return t;
                if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                return function(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }(e);
            }(e, p() ? Reflect.construct(t, r || [], y(e).constructor) : t.apply(e, r));
        }
        function p() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (p = function() {
                return !!e;
            })();
        }
        function y(e) {
            return y = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, y(e);
        }
        function b(e, t) {
            return b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, b(e, t);
        }
        var d = function(e) {
            e.forEach(function(e) {
                e.isIntersecting && e.target.onVisible();
            });
        }, h = {}, v = function(e) {
            function r(e) {
                var t;
                if (function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, r), (t = f(this, r, [
                    e
                ])).supportsObserver = !e.scrollPosition && e.useIntersectionObserver && i(), t.supportsObserver) {
                    var o = e.threshold;
                    t.observer = function(e) {
                        return h[e] = h[e] || new IntersectionObserver(d, {
                            rootMargin: e + "px"
                        }), h[e];
                    }(o);
                }
                return t;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && b(e, t);
            }(r, e), o = r, n = [
                {
                    key: "componentDidMount",
                    value: function() {
                        this.placeholder && this.observer && (this.placeholder.onVisible = this.props.onVisible, this.observer.observe(this.placeholder)), this.supportsObserver || this.updateVisibility();
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function() {
                        this.observer && this.placeholder && this.observer.unobserve(this.placeholder);
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function() {
                        this.supportsObserver || this.updateVisibility();
                    }
                },
                {
                    key: "getPlaceholderBoundingBox",
                    value: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props.scrollPosition, t = this.placeholder.getBoundingClientRect(), r = this.placeholder.style, o = parseInt(r.getPropertyValue("margin-left"), 10) || 0, n = parseInt(r.getPropertyValue("margin-top"), 10) || 0;
                        return {
                            bottom: e.y + t.bottom + n,
                            left: e.x + t.left + o,
                            right: e.x + t.right + o,
                            top: e.y + t.top + n
                        };
                    }
                },
                {
                    key: "isPlaceholderInViewport",
                    value: function() {
                        if ("undefined" == typeof window || !this.placeholder) return !1;
                        var e = this.props, t = e.scrollPosition, r = e.threshold, o = this.getPlaceholderBoundingBox(t), n = t.y + window.innerHeight, i = t.x, u = t.x + window.innerWidth, c = t.y;
                        return Boolean(c - r <= o.bottom && n + r >= o.top && i - r <= o.right && u + r >= o.left);
                    }
                },
                {
                    key: "updateVisibility",
                    value: function() {
                        this.isPlaceholderInViewport() && this.props.onVisible();
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this, r = this.props, o = r.className, n = r.height, i = r.placeholder, u = r.style, l = r.width;
                        if (i && "function" != typeof i.type) return t().cloneElement(i, {
                            ref: function(t) {
                                return e.placeholder = t;
                            }
                        });
                        var a = function(e) {
                            for(var t = 1; t < arguments.length; t++){
                                var r = null != arguments[t] ? arguments[t] : {};
                                t % 2 ? c(Object(r), !0).forEach(function(t) {
                                    s(e, t, r[t]);
                                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : c(Object(r)).forEach(function(t) {
                                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                                });
                            }
                            return e;
                        }({
                            display: "inline-block"
                        }, u);
                        return void 0 !== l && (a.width = l), void 0 !== n && (a.height = n), t().createElement("span", {
                            className: o,
                            ref: function(t) {
                                return e.placeholder = t;
                            },
                            style: a
                        }, i);
                    }
                }
            ], n && l(o.prototype, n), Object.defineProperty(o, "prototype", {
                writable: !1
            }), o;
        }(t().Component);
        v.propTypes = {
            onVisible: n.PropTypes.func.isRequired,
            className: n.PropTypes.string,
            height: n.PropTypes.oneOfType([
                n.PropTypes.number,
                n.PropTypes.string
            ]),
            placeholder: n.PropTypes.element,
            threshold: n.PropTypes.number,
            useIntersectionObserver: n.PropTypes.bool,
            scrollPosition: n.PropTypes.shape({
                x: n.PropTypes.number.isRequired,
                y: n.PropTypes.number.isRequired
            }),
            width: n.PropTypes.oneOfType([
                n.PropTypes.number,
                n.PropTypes.string
            ])
        }, v.defaultProps = {
            className: "",
            placeholder: null,
            threshold: 100,
            useIntersectionObserver: !0
        };
        const m = v;
        var O = r(181), w = r.n(O), g = r(858), P = r.n(g), j = function(e) {
            var t = getComputedStyle(e, null);
            return t.getPropertyValue("overflow") + t.getPropertyValue("overflow-y") + t.getPropertyValue("overflow-x");
        };
        const T = function(e) {
            if (!(e instanceof HTMLElement)) return window;
            for(var t = e; t && t instanceof HTMLElement;){
                if (/(scroll|auto)/.test(j(t))) return t;
                t = t.parentNode;
            }
            return window;
        };
        function S(e) {
            return S = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, S(e);
        }
        var E = [
            "delayMethod",
            "delayTime"
        ];
        function L() {
            return L = Object.assign ? Object.assign.bind() : function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var o in r)({}).hasOwnProperty.call(r, o) && (e[o] = r[o]);
                }
                return e;
            }, L.apply(null, arguments);
        }
        function _(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, I(o.key), o);
            }
        }
        function I(e) {
            var t = function(e, t) {
                if ("object" != S(e) || !e) return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var o = r.call(e, "string");
                    if ("object" != S(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
            }(e);
            return "symbol" == S(t) ? t : t + "";
        }
        function x(e, t, r) {
            return t = R(t), k(e, D() ? Reflect.construct(t, r || [], R(e).constructor) : t.apply(e, r));
        }
        function k(e, t) {
            if (t && ("object" == S(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e);
        }
        function D() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (D = function() {
                return !!e;
            })();
        }
        function R(e) {
            return R = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, R(e);
        }
        function C(e, t) {
            return C = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, C(e, t);
        }
        var B = function() {
            return "undefined" == typeof window ? 0 : window.scrollX || window.pageXOffset;
        }, M = function() {
            return "undefined" == typeof window ? 0 : window.scrollY || window.pageYOffset;
        };
        const N = function(e) {
            var r = function(r) {
                function o(e) {
                    var r;
                    if (function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, o), (r = x(this, o, [
                        e
                    ])).useIntersectionObserver = e.useIntersectionObserver && i(), r.useIntersectionObserver) return k(r);
                    var n = r.onChangeScroll.bind(r);
                    return "debounce" === e.delayMethod ? r.delayedScroll = w()(n, e.delayTime) : "throttle" === e.delayMethod && (r.delayedScroll = P()(n, e.delayTime)), r.state = {
                        scrollPosition: {
                            x: B(),
                            y: M()
                        }
                    }, r.baseComponentRef = t().createRef(), r;
                }
                var n, u;
                return function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), t && C(e, t);
                }(o, r), n = o, u = [
                    {
                        key: "componentDidMount",
                        value: function() {
                            this.addListeners();
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.removeListeners();
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function() {
                            "undefined" == typeof window || this.useIntersectionObserver || T(this.baseComponentRef.current) !== this.scrollElement && (this.removeListeners(), this.addListeners());
                        }
                    },
                    {
                        key: "addListeners",
                        value: function() {
                            "undefined" == typeof window || this.useIntersectionObserver || (this.scrollElement = T(this.baseComponentRef.current), this.scrollElement.addEventListener("scroll", this.delayedScroll, {
                                passive: !0
                            }), window.addEventListener("resize", this.delayedScroll, {
                                passive: !0
                            }), this.scrollElement !== window && window.addEventListener("scroll", this.delayedScroll, {
                                passive: !0
                            }));
                        }
                    },
                    {
                        key: "removeListeners",
                        value: function() {
                            "undefined" == typeof window || this.useIntersectionObserver || (this.scrollElement.removeEventListener("scroll", this.delayedScroll), window.removeEventListener("resize", this.delayedScroll), this.scrollElement !== window && window.removeEventListener("scroll", this.delayedScroll));
                        }
                    },
                    {
                        key: "onChangeScroll",
                        value: function() {
                            this.useIntersectionObserver || this.setState({
                                scrollPosition: {
                                    x: B(),
                                    y: M()
                                }
                            });
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var r = this.props, o = (r.delayMethod, r.delayTime, function(e, t) {
                                if (null == e) return {};
                                var r, o, n = function(e, t) {
                                    if (null == e) return {};
                                    var r = {};
                                    for(var o in e)if (({}).hasOwnProperty.call(e, o)) {
                                        if (t.indexOf(o) >= 0) continue;
                                        r[o] = e[o];
                                    }
                                    return r;
                                }(e, t);
                                if (Object.getOwnPropertySymbols) {
                                    var i = Object.getOwnPropertySymbols(e);
                                    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || ({}).propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
                                }
                                return n;
                            }(r, E)), n = this.useIntersectionObserver ? null : this.state.scrollPosition;
                            return t().createElement(e, L({
                                forwardRef: this.baseComponentRef,
                                scrollPosition: n
                            }, o));
                        }
                    }
                ], u && _(n.prototype, u), Object.defineProperty(n, "prototype", {
                    writable: !1
                }), n;
            }(t().Component);
            return r.propTypes = {
                delayMethod: n.PropTypes.oneOf([
                    "debounce",
                    "throttle"
                ]),
                delayTime: n.PropTypes.number,
                useIntersectionObserver: n.PropTypes.bool
            }, r.defaultProps = {
                delayMethod: "throttle",
                delayTime: 300,
                useIntersectionObserver: !0
            }, r;
        };
        function V(e) {
            return V = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, V(e);
        }
        function W(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, z(o.key), o);
            }
        }
        function z(e) {
            var t = function(e, t) {
                if ("object" != V(e) || !e) return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var o = r.call(e, "string");
                    if ("object" != V(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
            }(e);
            return "symbol" == V(t) ? t : t + "";
        }
        function $(e, t, r) {
            return t = F(t), function(e, t) {
                if (t && ("object" == V(t) || "function" == typeof t)) return t;
                if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                return function(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }(e);
            }(e, U() ? Reflect.construct(t, r || [], F(e).constructor) : t.apply(e, r));
        }
        function U() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (U = function() {
                return !!e;
            })();
        }
        function F(e) {
            return F = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, F(e);
        }
        function q(e, t) {
            return q = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, q(e, t);
        }
        var H = function(e) {
            function r(e) {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, r), $(this, r, [
                    e
                ]);
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && q(e, t);
            }(r, e), o = r, n = [
                {
                    key: "render",
                    value: function() {
                        return t().createElement(m, this.props);
                    }
                }
            ], W(o.prototype, n), Object.defineProperty(o, "prototype", {
                writable: !1
            }), o;
        }(t().Component);
        const Y = N(H);
        function X(e) {
            return X = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, X(e);
        }
        function A(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, G(o.key), o);
            }
        }
        function G(e) {
            var t = function(e, t) {
                if ("object" != X(e) || !e) return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var o = r.call(e, "string");
                    if ("object" != X(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
            }(e);
            return "symbol" == X(t) ? t : t + "";
        }
        function J(e, t, r) {
            return t = Q(t), function(e, t) {
                if (t && ("object" == X(t) || "function" == typeof t)) return t;
                if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                return function(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }(e);
            }(e, K() ? Reflect.construct(t, r || [], Q(e).constructor) : t.apply(e, r));
        }
        function K() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (K = function() {
                return !!e;
            })();
        }
        function Q(e) {
            return Q = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Q(e);
        }
        function Z(e, t) {
            return Z = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, Z(e, t);
        }
        var ee = function(e) {
            function r(e) {
                var t;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, r), t = J(this, r, [
                    e
                ]);
                var o = e.afterLoad, n = e.beforeLoad, i = e.scrollPosition, u = e.visibleByDefault;
                return t.state = {
                    visible: u
                }, u && (n(), o()), t.onVisible = t.onVisible.bind(t), t.isScrollTracked = Boolean(i && Number.isFinite(i.x) && i.x >= 0 && Number.isFinite(i.y) && i.y >= 0), t;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && Z(e, t);
            }(r, e), o = r, n = [
                {
                    key: "componentDidUpdate",
                    value: function(e, t) {
                        t.visible !== this.state.visible && this.props.afterLoad();
                    }
                },
                {
                    key: "onVisible",
                    value: function() {
                        this.props.beforeLoad(), this.setState({
                            visible: !0
                        });
                    }
                },
                {
                    key: "render",
                    value: function() {
                        if (this.state.visible) return this.props.children;
                        var e = this.props, r = e.className, o = e.delayMethod, n = e.delayTime, u = e.height, c = e.placeholder, s = e.scrollPosition, l = e.style, a = e.threshold, f = e.useIntersectionObserver, p = e.width;
                        return this.isScrollTracked || f && i() ? t().createElement(m, {
                            className: r,
                            height: u,
                            onVisible: this.onVisible,
                            placeholder: c,
                            scrollPosition: s,
                            style: l,
                            threshold: a,
                            useIntersectionObserver: f,
                            width: p
                        }) : t().createElement(Y, {
                            className: r,
                            delayMethod: o,
                            delayTime: n,
                            height: u,
                            onVisible: this.onVisible,
                            placeholder: c,
                            style: l,
                            threshold: a,
                            width: p
                        });
                    }
                }
            ], A(o.prototype, n), Object.defineProperty(o, "prototype", {
                writable: !1
            }), o;
        }(t().Component);
        ee.propTypes = {
            afterLoad: n.PropTypes.func,
            beforeLoad: n.PropTypes.func,
            useIntersectionObserver: n.PropTypes.bool,
            visibleByDefault: n.PropTypes.bool
        }, ee.defaultProps = {
            afterLoad: function() {
                return {};
            },
            beforeLoad: function() {
                return {};
            },
            useIntersectionObserver: !0,
            visibleByDefault: !1
        };
        const te = ee;
        function re(e) {
            return re = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, re(e);
        }
        var oe = [
            "afterLoad",
            "beforeLoad",
            "delayMethod",
            "delayTime",
            "effect",
            "placeholder",
            "placeholderSrc",
            "scrollPosition",
            "threshold",
            "useIntersectionObserver",
            "visibleByDefault",
            "wrapperClassName",
            "wrapperProps"
        ];
        function ne(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                t && (o = o.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), r.push.apply(r, o);
            }
            return r;
        }
        function ie(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? ne(Object(r), !0).forEach(function(t) {
                    ue(e, t, r[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ne(Object(r)).forEach(function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                });
            }
            return e;
        }
        function ue(e, t, r) {
            return (t = le(t)) in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r, e;
        }
        function ce() {
            return ce = Object.assign ? Object.assign.bind() : function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var o in r)({}).hasOwnProperty.call(r, o) && (e[o] = r[o]);
                }
                return e;
            }, ce.apply(null, arguments);
        }
        function se(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, le(o.key), o);
            }
        }
        function le(e) {
            var t = function(e, t) {
                if ("object" != re(e) || !e) return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var o = r.call(e, "string");
                    if ("object" != re(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
            }(e);
            return "symbol" == re(t) ? t : t + "";
        }
        function ae(e, t, r) {
            return t = pe(t), function(e, t) {
                if (t && ("object" == re(t) || "function" == typeof t)) return t;
                if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                return function(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }(e);
            }(e, fe() ? Reflect.construct(t, r || [], pe(e).constructor) : t.apply(e, r));
        }
        function fe() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (fe = function() {
                return !!e;
            })();
        }
        function pe(e) {
            return pe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, pe(e);
        }
        function ye(e, t) {
            return ye = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, ye(e, t);
        }
        var be = function(e) {
            function r(e) {
                var t;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, r), (t = ae(this, r, [
                    e
                ])).state = {
                    loaded: !1
                }, t;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && ye(e, t);
            }(r, e), o = r, n = [
                {
                    key: "onImageLoad",
                    value: function() {
                        var e = this;
                        return this.state.loaded ? null : function(t) {
                            e.props.onLoad(t), e.props.afterLoad(), e.setState({
                                loaded: !0
                            });
                        };
                    }
                },
                {
                    key: "getImg",
                    value: function() {
                        var e = this.props, r = (e.afterLoad, e.beforeLoad, e.delayMethod, e.delayTime, e.effect, e.placeholder, e.placeholderSrc, e.scrollPosition, e.threshold, e.useIntersectionObserver, e.visibleByDefault, e.wrapperClassName, e.wrapperProps, function(e, t) {
                            if (null == e) return {};
                            var r, o, n = function(e, t) {
                                if (null == e) return {};
                                var r = {};
                                for(var o in e)if (({}).hasOwnProperty.call(e, o)) {
                                    if (t.indexOf(o) >= 0) continue;
                                    r[o] = e[o];
                                }
                                return r;
                            }(e, t);
                            if (Object.getOwnPropertySymbols) {
                                var i = Object.getOwnPropertySymbols(e);
                                for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || ({}).propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
                            }
                            return n;
                        }(e, oe));
                        return t().createElement("img", ce({}, r, {
                            onLoad: this.onImageLoad()
                        }));
                    }
                },
                {
                    key: "getLazyLoadImage",
                    value: function() {
                        var e = this.props, r = e.beforeLoad, o = e.className, n = e.delayMethod, i = e.delayTime, u = e.height, c = e.placeholder, s = e.scrollPosition, l = e.style, a = e.threshold, f = e.useIntersectionObserver, p = e.visibleByDefault, y = e.width;
                        return t().createElement(te, {
                            beforeLoad: r,
                            className: o,
                            delayMethod: n,
                            delayTime: i,
                            height: u,
                            placeholder: c,
                            scrollPosition: s,
                            style: l,
                            threshold: a,
                            useIntersectionObserver: f,
                            visibleByDefault: p,
                            width: y
                        }, this.getImg());
                    }
                },
                {
                    key: "getWrappedLazyLoadImage",
                    value: function(e) {
                        var r = this.props, o = r.effect, n = r.height, i = r.placeholderSrc, u = r.width, c = r.wrapperClassName, s = r.wrapperProps, l = this.state.loaded, a = l ? " lazy-load-image-loaded" : "", f = l || !i ? {} : {
                            backgroundImage: "url(".concat(i, ")"),
                            backgroundSize: "100% 100%"
                        };
                        return t().createElement("span", ce({
                            className: c + " lazy-load-image-background " + o + a,
                            style: ie(ie({}, f), {}, {
                                color: "transparent",
                                display: "inline-block",
                                height: n,
                                width: u
                            })
                        }, s), e);
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.effect, r = e.placeholderSrc, o = e.visibleByDefault, n = e.wrapperClassName, i = e.wrapperProps, u = this.getLazyLoadImage();
                        return (t || r) && !o || n || i ? this.getWrappedLazyLoadImage(u) : u;
                    }
                }
            ], n && se(o.prototype, n), Object.defineProperty(o, "prototype", {
                writable: !1
            }), o;
        }(t().Component);
        be.propTypes = {
            onLoad: n.PropTypes.func,
            afterLoad: n.PropTypes.func,
            beforeLoad: n.PropTypes.func,
            delayMethod: n.PropTypes.string,
            delayTime: n.PropTypes.number,
            effect: n.PropTypes.string,
            placeholderSrc: n.PropTypes.string,
            threshold: n.PropTypes.number,
            useIntersectionObserver: n.PropTypes.bool,
            visibleByDefault: n.PropTypes.bool,
            wrapperClassName: n.PropTypes.string,
            wrapperProps: n.PropTypes.object
        }, be.defaultProps = {
            onLoad: function() {},
            afterLoad: function() {
                return {};
            },
            beforeLoad: function() {
                return {};
            },
            delayMethod: "throttle",
            delayTime: 300,
            effect: "",
            placeholderSrc: null,
            threshold: 100,
            useIntersectionObserver: !0,
            visibleByDefault: !1,
            wrapperClassName: ""
        };
        const de = be;
    })(), module.exports = o;
})();

});

parcelRequire.register("e15QL", function(module, exports) {
"use strict";
"use client";

var $4SO8W = parcelRequire("4SO8W");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a345b261c68dc207$var$_createSvgIcon = $4SO8W((parcelRequire("agsGj")));

var $5Wgfu = parcelRequire("5Wgfu");
var $a345b261c68dc207$var$_default = (0, $a345b261c68dc207$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $5Wgfu.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");
module.exports.default = $a345b261c68dc207$var$_default;

});

parcelRequire.register("c6qc5", function(module, exports) {

$parcel$export(module.exports, "SWIGGY_CDN_LINK", function () { return $8cfa5d1ec237831f$export$41dea6a689c665f7; });
$parcel$export(module.exports, "SWIGGY_API_URL", function () { return $8cfa5d1ec237831f$export$28758bffe9e46c7e; });
$parcel$export(module.exports, "SWIGGY_MENU_API", function () { return $8cfa5d1ec237831f$export$dfea971c0e349374; });
$parcel$export(module.exports, "SWIGGY_MENU_IMG_API", function () { return $8cfa5d1ec237831f$export$fc9614a9a7541a63; });
$parcel$export(module.exports, "FAQ", function () { return $8cfa5d1ec237831f$export$690878eeeaffbdc8; });
// Image CDN URL for Restaurant card
const $8cfa5d1ec237831f$export$41dea6a689c665f7 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";
const $8cfa5d1ec237831f$export$28758bffe9e46c7e = "https://food-ordering-app-server.vercel.app/api/proxy/swiggy/dapi/restaurants/list/v5?lat=18.5204303&lng=73.8567437&&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING";
const $8cfa5d1ec237831f$export$dfea971c0e349374 = "https://food-ordering-app-server.vercel.app/api/proxy/swiggy/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=18.5204303&lng=73.8567437&restaurantId=";
const $8cfa5d1ec237831f$export$fc9614a9a7541a63 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,c_fit/";
const $8cfa5d1ec237831f$export$690878eeeaffbdc8 = [
    {
        id: 1,
        title: "What is Swiggy Customer Care Number?",
        description: "We value our customer’s time and hence moved away from a single customer care number to a comprehensive chat-based support system for quick and easy resolution. You no longer have to go through the maze of an IVRS call support. Just search for your issue in the help section on this page and initiate a chat with us. A customer care executive will be assigned to you shortly. You can also email us your issue on support@swiggy.in Note: We value your privacy and your information is safe with us. Please do not reveal any personal information, bank account number, OTP etc. to another person. A Swiggy representative will never ask you for these details. Please do not reveal these details to fraudsters and imposters claiming to be calling on our behalf. Be vigilant and do not entertain phishing calls or emails."
    },
    {
        id: 2,
        title: "I want to explore career opportunities with Swiggy",
        description: "https://www.swiggy.com/careers?hide_header=ios_android"
    },
    {
        id: 3,
        title: "Can I edit my order?",
        description: "Your order can be edited before it reaches the restaurant. You could contact customer support team via chat or call to do so. Once order is placed and restaurant starts preparing your food, you may not edit its contents."
    },
    {
        id: 4,
        title: "I want to cancel my order",
        description: "We will do our best to accommodate your request if the order is not placed to the restaurant (Customer service number: 080-67466729). Please note that we will have a right to charge a cancellation fee up to full order value to compensate our restaurant and delivery partners if your order has been confirmed."
    },
    {
        id: 5,
        title: "Will Swiggy be accountable for quality/quantity?",
        description: "Quantity and quality of the food is the restaurants' responsibility. However in case of issues with the quality or quantity, kindly submit your feedback and we will pass it on to the restaurant."
    },
    {
        id: 6,
        title: "Is there a minimum order value?",
        description: "We have no minimum order value and you can order for any amount."
    },
    {
        id: 7,
        title: "Do you charge for delivery?",
        description: "Delivery fee varies from city to city and is applicable if order value is below a certain amount. Additionally, certain restaurants might have fixed delivery fees. Delivery fee (if any) is specified on the Review Order page."
    },
    {
        id: 8,
        title: "How long do you take to deliver?",
        description: "Standard delivery times vary by the location selected and prevailing conditions. Once you select your location, an estimated delivery time is mentioned for each restaurant."
    },
    {
        id: 9,
        title: "What are your delivery hours?",
        description: "Our delivery hours vary for different locations and depends on availability of supply from restaurant partners."
    },
    {
        id: 10,
        title: "Can I order from any location?",
        description: "We will deliver from any restaurant listed on the search results for your location. We recommend enabling your GPS location finder and letting the app auto-detect your location."
    },
    {
        id: 11,
        title: "Is single order from many restaurants possible?",
        description: "We currently do not support this functionality. However, you can place orders for individual items from different restaurants."
    },
    {
        id: 12,
        title: "Do you support bulk orders?",
        description: "In order to provide all customers with a great selection and to ensure on time delivery of your meal, we reserve the right to limit the quantities depending on supply."
    },
    {
        id: 13,
        title: "Can I order in advance?",
        description: "We currently do not support this functionality. All our orders are placed and executed on-demand."
    },
    {
        id: 14,
        title: "Can I change the address / number?",
        description: "Any major change in delivery address is not possible after you have placed an order with us. However, slight modifications like changing the flat number, street name, landmark etc. are allowed. If you have received delivery executive details, you can directly call him, else you could contact our customer service team."
    },
    {
        id: 15,
        title: "Did not receive referral coupon?",
        description: "Referral coupon is given upon the first successful transaction of the referred person. If you still have not received it, kindly send us your details at support@swiggy.in. We will contact you within 48 hours."
    },
    {
        id: 16,
        title: "Deactivate my account",
        description: "Please write to us at support@swiggy.in in the event that you want to deactivate your account."
    }
];

});

parcelRequire.register("jiXbw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0dd9ba790f0b24b$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $gt0RB = parcelRequire("gt0RB");


var $aOChP = parcelRequire("aOChP");

var $e85sa = parcelRequire("e85sa");

var $bXHqh = parcelRequire("bXHqh");


var $cLCzc = parcelRequire("cLCzc");

var $gOdFq = parcelRequire("gOdFq");
var $e0dd9ba790f0b24b$export$bb38bb9a1161268 = "unmounted";
var $e0dd9ba790f0b24b$export$84cbff306f539230 = "exited";
var $e0dd9ba790f0b24b$export$df38205c966be359 = "entering";
var $e0dd9ba790f0b24b$export$78e9e6e3e014d60a = "entered";
var $e0dd9ba790f0b24b$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $e0dd9ba790f0b24b$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $gt0RB.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $e0dd9ba790f0b24b$export$84cbff306f539230;
                _this.appearStatus = $e0dd9ba790f0b24b$export$df38205c966be359;
            } else initialStatus = $e0dd9ba790f0b24b$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $e0dd9ba790f0b24b$export$bb38bb9a1161268;
        else initialStatus = $e0dd9ba790f0b24b$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $e0dd9ba790f0b24b$export$bb38bb9a1161268) return {
            status: $e0dd9ba790f0b24b$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $e0dd9ba790f0b24b$export$df38205c966be359 && status !== $e0dd9ba790f0b24b$export$78e9e6e3e014d60a) nextStatus = $e0dd9ba790f0b24b$export$df38205c966be359;
            } else if (status === $e0dd9ba790f0b24b$export$df38205c966be359 || status === $e0dd9ba790f0b24b$export$78e9e6e3e014d60a) nextStatus = $e0dd9ba790f0b24b$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $e0dd9ba790f0b24b$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($e85sa))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $gOdFq.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $e0dd9ba790f0b24b$export$84cbff306f539230) this.setState({
            status: $e0dd9ba790f0b24b$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($e85sa))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $bXHqh.default).disabled) {
            this.safeSetState({
                status: $e0dd9ba790f0b24b$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $e0dd9ba790f0b24b$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $e0dd9ba790f0b24b$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($e85sa))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $bXHqh.default).disabled) {
            this.safeSetState({
                status: $e0dd9ba790f0b24b$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $e0dd9ba790f0b24b$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $e0dd9ba790f0b24b$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($e85sa))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $e0dd9ba790f0b24b$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $4GC5s.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement((0, $cLCzc.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).Component);
$e0dd9ba790f0b24b$var$Transition.contextType = (0, $cLCzc.default);
$e0dd9ba790f0b24b$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $e0dd9ba790f0b24b$var$noop() {}
$e0dd9ba790f0b24b$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $e0dd9ba790f0b24b$var$noop,
    onEntering: $e0dd9ba790f0b24b$var$noop,
    onEntered: $e0dd9ba790f0b24b$var$noop,
    onExit: $e0dd9ba790f0b24b$var$noop,
    onExiting: $e0dd9ba790f0b24b$var$noop,
    onExited: $e0dd9ba790f0b24b$var$noop
};
$e0dd9ba790f0b24b$var$Transition.UNMOUNTED = $e0dd9ba790f0b24b$export$bb38bb9a1161268;
$e0dd9ba790f0b24b$var$Transition.EXITED = $e0dd9ba790f0b24b$export$84cbff306f539230;
$e0dd9ba790f0b24b$var$Transition.ENTERING = $e0dd9ba790f0b24b$export$df38205c966be359;
$e0dd9ba790f0b24b$var$Transition.ENTERED = $e0dd9ba790f0b24b$export$78e9e6e3e014d60a;
$e0dd9ba790f0b24b$var$Transition.EXITING = $e0dd9ba790f0b24b$export$4aacc83d4d59139f;
var $e0dd9ba790f0b24b$export$2e2bcd8739ae039 = $e0dd9ba790f0b24b$var$Transition;

});
parcelRequire.register("bXHqh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b56e34cbd5db232$export$2e2bcd8739ae039; });
var $8b56e34cbd5db232$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRequire.register("gOdFq", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $c3cbeae30b2915bb$export$7d26bbb1236dafd6; });
var $c3cbeae30b2915bb$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRequire.register("cMLqV", function(module, exports) {

$parcel$export(module.exports, "reflow", function () { return $94eec2fcb71bb895$export$b7a864e1eaef9de5; });
$parcel$export(module.exports, "getTransitionProps", function () { return $94eec2fcb71bb895$export$8cb1e9b404609ae9; });
const $94eec2fcb71bb895$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $94eec2fcb71bb895$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}

});

parcelRequire.register("6ymNf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $013b382696fde846$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $4GC5s = parcelRequire("4GC5s");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");

var $dhOhi = parcelRequire("dhOhi");

var $iBOiW = parcelRequire("iBOiW");

var $gx04x = parcelRequire("gx04x");

var $6XlHG = parcelRequire("6XlHG");

var $cWSVQ = parcelRequire("cWSVQ");

var $kRNA7 = parcelRequire("kRNA7");

var $iCMmK = parcelRequire("iCMmK");

var $k8zs2 = parcelRequire("k8zs2");

var $e22rl = parcelRequire("e22rl");

var $jY9H6 = parcelRequire("jY9H6");

var $d82gU = parcelRequire("d82gU");

var $b5yh1 = parcelRequire("b5yh1");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $013b382696fde846$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $013b382696fde846$var$variantComponent = {
    standard: (0, $cWSVQ.default),
    filled: (0, $kRNA7.default),
    outlined: (0, $iCMmK.default)
};
const $013b382696fde846$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $dhOhi.default)(slots, (0, $b5yh1.getTextFieldUtilityClass), classes);
};
const $013b382696fde846$var$TextFieldRoot = (0, $gx04x.default)((0, $e22rl.default), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $013b382696fde846$var$TextField = /*#__PURE__*/ $aOChP.forwardRef(function TextField(inProps, ref) {
    const props = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = "primary", defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = "outlined" } = props, other = (0, $4GC5s.default)(props, $013b382696fde846$var$_excluded);
    const ownerState = (0, $dy3ak.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $013b382696fde846$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    const id = (0, $iBOiW.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $013b382696fde846$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $5Wgfu.jsx)(InputComponent, (0, $dy3ak.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)($013b382696fde846$var$TextFieldRoot, (0, $dy3ak.default)({
        className: (0, $gVoqA.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $k8zs2.default), (0, $dy3ak.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $d82gU.default), (0, $dy3ak.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $jY9H6.default), (0, $dy3ak.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $013b382696fde846$export$2e2bcd8739ae039 = $013b382696fde846$var$TextField;

});
parcelRequire.register("iBOiW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8c2b41fd8cfb0ef$export$2e2bcd8739ae039; });

var $aOChP = parcelRequire("aOChP");
"use client";
let $d8c2b41fd8cfb0ef$var$globalId = 0;
function $d8c2b41fd8cfb0ef$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $aOChP.useState(idOverride);
    const id = idOverride || defaultId;
    $aOChP.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $d8c2b41fd8cfb0ef$var$globalId += 1;
            setDefaultId(`mui-${$d8c2b41fd8cfb0ef$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $d8c2b41fd8cfb0ef$var$maybeReactUseId = $aOChP["useId".toString()];
function $d8c2b41fd8cfb0ef$export$2e2bcd8739ae039(idOverride) {
    if ($d8c2b41fd8cfb0ef$var$maybeReactUseId !== undefined) {
        const reactId = $d8c2b41fd8cfb0ef$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $d8c2b41fd8cfb0ef$var$useGlobalId(idOverride);
}

});

parcelRequire.register("cWSVQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96d5832fe94d50de$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");


var $dhOhi = parcelRequire("dhOhi");

var $e45KD = parcelRequire("e45KD");

var $8vPDm = parcelRequire("8vPDm");

var $gx04x = parcelRequire("gx04x");

var $6XlHG = parcelRequire("6XlHG");

var $a1Wyx = parcelRequire("a1Wyx");

var $8vPDm = parcelRequire("8vPDm");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $96d5832fe94d50de$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $96d5832fe94d50de$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $dhOhi.default)(slots, (0, $a1Wyx.getInputUtilityClass), classes);
    return (0, $dy3ak.default)({}, classes, composedClasses);
};
const $96d5832fe94d50de$var$InputRoot = (0, $gx04x.default)((0, $8vPDm.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $gx04x.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $8vPDm.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $dy3ak.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $a1Wyx.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $a1Wyx.default).error}`]: {
            "&:before, &:after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&:before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $a1Wyx.default).disabled}, .${(0, $a1Wyx.default).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $a1Wyx.default).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $96d5832fe94d50de$var$InputInput = (0, $gx04x.default)((0, $8vPDm.InputBaseComponent), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $8vPDm.inputOverridesResolver)
})({});
const $96d5832fe94d50de$var$Input = /*#__PURE__*/ $aOChP.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $4GC5s.default)(props, $96d5832fe94d50de$var$_excluded);
    const classes = $96d5832fe94d50de$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $e45KD.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $96d5832fe94d50de$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $96d5832fe94d50de$var$InputInput;
    return /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $8vPDm.default), (0, $dy3ak.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$96d5832fe94d50de$var$Input.muiName = "Input";
var $96d5832fe94d50de$export$2e2bcd8739ae039 = $96d5832fe94d50de$var$Input;

});
parcelRequire.register("8vPDm", function(module, exports) {

$parcel$export(module.exports, "rootOverridesResolver", function () { return $632945698c47920a$export$965edad20a84fa75; });
$parcel$export(module.exports, "inputOverridesResolver", function () { return $632945698c47920a$export$cf507b112810e72d; });
$parcel$export(module.exports, "InputBaseRoot", function () { return $632945698c47920a$export$298a043133d72a38; });
$parcel$export(module.exports, "InputBaseComponent", function () { return $632945698c47920a$export$a1ad29c901026019; });
$parcel$export(module.exports, "default", function () { return $632945698c47920a$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $hBYX0 = parcelRequire("hBYX0");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");

var $cvlvc = parcelRequire("cvlvc");
var $4q57I = parcelRequire("4q57I");
var $dhOhi = parcelRequire("dhOhi");

var $7Kcml = parcelRequire("7Kcml");

var $754jb = parcelRequire("754jb");

var $4Oe4k = parcelRequire("4Oe4k");

var $gx04x = parcelRequire("gx04x");

var $6XlHG = parcelRequire("6XlHG");

var $lUjh9 = parcelRequire("lUjh9");

var $4w8df = parcelRequire("4w8df");

var $aiwZF = parcelRequire("aiwZF");

var $ke8it = parcelRequire("ke8it");

var $f96jy = parcelRequire("f96jy");

var $6I5Yx = parcelRequire("6I5Yx");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $632945698c47920a$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $632945698c47920a$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $lUjh9.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $632945698c47920a$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $632945698c47920a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $lUjh9.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size && size !== "medium" && `size${(0, $lUjh9.default)(size)}`,
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $dhOhi.default)(slots, (0, $6I5Yx.getInputBaseUtilityClass), classes);
};
const $632945698c47920a$export$298a043133d72a38 = (0, $gx04x.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $632945698c47920a$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $dy3ak.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $6I5Yx.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $dy3ak.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $632945698c47920a$export$a1ad29c901026019 = (0, $gx04x.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $632945698c47920a$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, $dy3ak.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $dy3ak.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $6I5Yx.default).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $6I5Yx.default).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $632945698c47920a$var$inputGlobalStyles = /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $ke8it.default), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $632945698c47920a$var$InputBase = /*#__PURE__*/ $aOChP.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = "text", value: valueProp } = props, other = (0, $4GC5s.default)(props, $632945698c47920a$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $aOChP.useRef(value != null);
    const inputRef = $aOChP.useRef();
    const handleInputRefWarning = $aOChP.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $4w8df.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $aOChP.useState(false);
    const muiFormControl = (0, $4Oe4k.default)();
    const fcs = (0, $7Kcml.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $aOChP.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $aOChP.useCallback((obj)=>{
        if ((0, $f96jy.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $aiwZF.default)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $hBYX0.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $aOChP.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $dy3ak.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $dy3ak.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $4q57I.TextareaAutosize);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $aOChP.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $dy3ak.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $632945698c47920a$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $632945698c47920a$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $632945698c47920a$export$a1ad29c901026019;
    inputProps = (0, $dy3ak.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)($aOChP.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $632945698c47920a$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $5Wgfu.jsxs)(Root, (0, $dy3ak.default)({}, rootProps, !(0, $cvlvc.isHostComponent)(Root) && {
                ownerState: (0, $dy3ak.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $gVoqA.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $754jb.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)(Input, (0, $dy3ak.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $cvlvc.isHostComponent)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $dy3ak.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $gVoqA.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $dy3ak.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $632945698c47920a$export$2e2bcd8739ae039 = $632945698c47920a$var$InputBase;

});
parcelRequire.register("cvlvc", function(module, exports) {

$parcel$export(module.exports, "isHostComponent", function () { return $91a90f2ca98b0443$export$e28348cc2430497; });
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $91a90f2ca98b0443$export$e28348cc2430497(element) {
    return typeof element === "string";
}

});

parcelRequire.register("4q57I", function(module, exports) {

$parcel$export(module.exports, "TextareaAutosize", function () { return $337d908f8971ed55$export$d1710922ecaf577a; });

var $dy3ak = parcelRequire("dy3ak");

var $4GC5s = parcelRequire("4GC5s");

var $aOChP = parcelRequire("aOChP");


var $e85sa = parcelRequire("e85sa");

var $fbLA1 = parcelRequire("fbLA1");
var $5J7Nc = parcelRequire("5J7Nc");
var $4Vm6n = parcelRequire("4Vm6n");
var $bKnSm = parcelRequire("bKnSm");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $337d908f8971ed55$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $337d908f8971ed55$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $337d908f8971ed55$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $337d908f8971ed55$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflow;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base-ui/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base-ui/react-textarea-autosize/components-api/#textarea-autosize)
 */ const $337d908f8971ed55$export$d1710922ecaf577a = /*#__PURE__*/ $aOChP.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $4GC5s.default)(props, $337d908f8971ed55$var$_excluded);
    const { current: isControlled } = $aOChP.useRef(value != null);
    const inputRef = $aOChP.useRef(null);
    const handleRef = (0, $bKnSm.default)(forwardedRef, inputRef);
    const shadowRef = $aOChP.useRef(null);
    const renders = $aOChP.useRef(0);
    const [state, setState] = $aOChP.useState({
        outerHeightStyle: 0
    });
    const getUpdatedState = $aOChP.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $5J7Nc.default)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $337d908f8971ed55$var$getStyleValue(computedStyle.paddingBottom) + $337d908f8971ed55$var$getStyleValue(computedStyle.paddingTop);
        const border = $337d908f8971ed55$var$getStyleValue(computedStyle.borderBottomWidth) + $337d908f8971ed55$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflow = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflow: overflow
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const updateState = (prevState, newState)=>{
        const { outerHeightStyle: outerHeightStyle, overflow: overflow } = newState;
        // Need a large enough difference to update the height.
        // This prevents infinite rendering loop.
        if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
            renders.current += 1;
            return {
                overflow: overflow,
                outerHeightStyle: outerHeightStyle
            };
        }
        return prevState;
    };
    const syncHeight = $aOChP.useCallback(()=>{
        const newState = getUpdatedState();
        if ($337d908f8971ed55$var$isEmpty(newState)) return;
        setState((prevState)=>{
            return updateState(prevState, newState);
        });
    }, [
        getUpdatedState
    ]);
    const syncHeightWithFlushSync = ()=>{
        const newState = getUpdatedState();
        if ($337d908f8971ed55$var$isEmpty(newState)) return;
        // In React 18, state updates in a ResizeObserver's callback are happening after the paint which causes flickering
        // when doing some visual updates in it. Using flushSync ensures that the dom will be painted after the states updates happen
        // Related issue - https://github.com/facebook/react/issues/24331
        $e85sa.flushSync(()=>{
            setState((prevState)=>{
                return updateState(prevState, newState);
            });
        });
    };
    $aOChP.useEffect(()=>{
        const handleResize = ()=>{
            renders.current = 0;
            // If the TextareaAutosize component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/32640
            if (inputRef.current) syncHeightWithFlushSync();
        };
        const handleResizeWindow = (0, $fbLA1.default)(()=>{
            renders.current = 0;
            // If the TextareaAutosize component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/32640
            if (inputRef.current) syncHeightWithFlushSync();
        });
        let resizeObserver;
        const input = inputRef.current;
        const containerWindow = (0, $5J7Nc.default)(input);
        containerWindow.addEventListener("resize", handleResizeWindow);
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            handleResizeWindow.clear();
            containerWindow.removeEventListener("resize", handleResizeWindow);
            if (resizeObserver) resizeObserver.disconnect();
        };
    });
    (0, $4Vm6n.default)(()=>{
        syncHeight();
    });
    $aOChP.useEffect(()=>{
        renders.current = 0;
    }, [
        value
    ]);
    const handleChange = (event)=>{
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)($aOChP.Fragment, {
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsx)("textarea", (0, $dy3ak.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: (0, $dy3ak.default)({
                    height: state.outerHeightStyle,
                    // Need a large enough difference to allow scrolling.
                    // This prevents infinite rendering loop.
                    overflow: state.overflow ? "hidden" : undefined
                }, style)
            }, other)),
            /*#__PURE__*/ (0, $5Wgfu.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $dy3ak.default)({}, $337d908f8971ed55$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});

});
parcelRequire.register("fbLA1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0ecca83e299d518$export$2e2bcd8739ae039; });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $b0ecca83e299d518$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});

parcelRequire.register("5J7Nc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42b7332224ef84eb$export$2e2bcd8739ae039; });

var $2bZGc = parcelRequire("2bZGc");
function $42b7332224ef84eb$export$2e2bcd8739ae039(node) {
    const doc = (0, $2bZGc.default)(node);
    return doc.defaultView || window;
}

});
parcelRequire.register("2bZGc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $198c7425cc3266f3$export$2e2bcd8739ae039; });
function $198c7425cc3266f3$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});



parcelRequire.register("7Kcml", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a366a9828c5baf6$export$2e2bcd8739ae039; });
function $5a366a9828c5baf6$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRequire.register("754jb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $527c5796c3d2c328$export$2e2bcd8739ae039; });

var $aOChP = parcelRequire("aOChP");
/**
 * @ignore - internal component.
 */ const $527c5796c3d2c328$var$FormControlContext = /*#__PURE__*/ $aOChP.createContext(undefined);
var $527c5796c3d2c328$export$2e2bcd8739ae039 = $527c5796c3d2c328$var$FormControlContext;

});

parcelRequire.register("4Oe4k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3806beb338a42299$export$2e2bcd8739ae039; });

var $aOChP = parcelRequire("aOChP");

var $754jb = parcelRequire("754jb");
"use client";
function $3806beb338a42299$export$2e2bcd8739ae039() {
    return $aOChP.useContext((0, $754jb.default));
}

});

parcelRequire.register("aiwZF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77f52daae8fc522b$export$2e2bcd8739ae039; });

var $4Vm6n = parcelRequire("4Vm6n");
"use client";
var $77f52daae8fc522b$export$2e2bcd8739ae039 = (0, $4Vm6n.default);

});

parcelRequire.register("ke8it", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb9b8d0a3bedb12d$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");
parcelRequire("aOChP");


var $gI4wi = parcelRequire("gI4wi");

var $fQJH6 = parcelRequire("fQJH6");

var $bsF6d = parcelRequire("bsF6d");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
function $eb9b8d0a3bedb12d$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $gI4wi.default), (0, $dy3ak.default)({}, props, {
        defaultTheme: (0, $fQJH6.default),
        themeId: (0, $bsF6d.default)
    }));
}
var $eb9b8d0a3bedb12d$export$2e2bcd8739ae039 = $eb9b8d0a3bedb12d$var$GlobalStyles;

});
parcelRequire.register("gI4wi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2a442f47d9a0fb1$export$2e2bcd8739ae039; });
parcelRequire("aOChP");


var $57r6Z = parcelRequire("57r6Z");

var $kwVyI = parcelRequire("kwVyI");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
function $c2a442f47d9a0fb1$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $kwVyI.default)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $57r6Z.default), {
        styles: globalStyles
    });
}
var $c2a442f47d9a0fb1$export$2e2bcd8739ae039 = $c2a442f47d9a0fb1$var$GlobalStyles;

});


parcelRequire.register("f96jy", function(module, exports) {

$parcel$export(module.exports, "isFilled", function () { return $b06c9831eeb94a25$export$d652b828d7fdeff8; });
$parcel$export(module.exports, "isAdornedStart", function () { return $b06c9831eeb94a25$export$1b68bdfa56faeb5d; });
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $b06c9831eeb94a25$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $b06c9831eeb94a25$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($b06c9831eeb94a25$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $b06c9831eeb94a25$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $b06c9831eeb94a25$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});

parcelRequire.register("6I5Yx", function(module, exports) {

$parcel$export(module.exports, "getInputBaseUtilityClass", function () { return $4e2b7cbc11a216b2$export$ef57d5c8ca2278f6; });
$parcel$export(module.exports, "default", function () { return $4e2b7cbc11a216b2$export$2e2bcd8739ae039; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $4e2b7cbc11a216b2$export$ef57d5c8ca2278f6(slot) {
    return (0, $924xM.default)("MuiInputBase", slot);
}
const $4e2b7cbc11a216b2$var$inputBaseClasses = (0, $83lmX.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $4e2b7cbc11a216b2$export$2e2bcd8739ae039 = $4e2b7cbc11a216b2$var$inputBaseClasses;

});


parcelRequire.register("a1Wyx", function(module, exports) {

$parcel$export(module.exports, "getInputUtilityClass", function () { return $74d76b61d0f6bb3a$export$cdb270390122322b; });
$parcel$export(module.exports, "default", function () { return $74d76b61d0f6bb3a$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");

var $6I5Yx = parcelRequire("6I5Yx");
function $74d76b61d0f6bb3a$export$cdb270390122322b(slot) {
    return (0, $924xM.default)("MuiInput", slot);
}
const $74d76b61d0f6bb3a$var$inputClasses = (0, $dy3ak.default)({}, (0, $6I5Yx.default), (0, $83lmX.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $74d76b61d0f6bb3a$export$2e2bcd8739ae039 = $74d76b61d0f6bb3a$var$inputClasses;

});


parcelRequire.register("kRNA7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f30f37ba13d2cac9$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");

var $e45KD = parcelRequire("e45KD");


var $dhOhi = parcelRequire("dhOhi");

var $8vPDm = parcelRequire("8vPDm");

var $gx04x = parcelRequire("gx04x");

var $6XlHG = parcelRequire("6XlHG");

var $i4DTE = parcelRequire("i4DTE");

var $8vPDm = parcelRequire("8vPDm");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $f30f37ba13d2cac9$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $f30f37ba13d2cac9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $dhOhi.default)(slots, (0, $i4DTE.getFilledInputUtilityClass), classes);
    return (0, $dy3ak.default)({}, classes, composedClasses);
};
const $f30f37ba13d2cac9$var$FilledInputRoot = (0, $gx04x.default)((0, $8vPDm.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $gx04x.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $8vPDm.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, $dy3ak.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $i4DTE.default).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $i4DTE.default).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $i4DTE.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $i4DTE.default).error}`]: {
            "&:before, &:after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&:before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $i4DTE.default).disabled}, .${(0, $i4DTE.default).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $i4DTE.default).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $dy3ak.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }));
});
const $f30f37ba13d2cac9$var$FilledInputInput = (0, $gx04x.default)((0, $8vPDm.InputBaseComponent), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $8vPDm.inputOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>(0, $dy3ak.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
const $f30f37ba13d2cac9$var$FilledInput = /*#__PURE__*/ $aOChP.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $4GC5s.default)(props, $f30f37ba13d2cac9$var$_excluded);
    const ownerState = (0, $dy3ak.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $f30f37ba13d2cac9$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $e45KD.default)(slotProps != null ? slotProps : componentsPropsProp, filledInputComponentsProps) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $f30f37ba13d2cac9$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $f30f37ba13d2cac9$var$FilledInputInput;
    return /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $8vPDm.default), (0, $dy3ak.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$f30f37ba13d2cac9$var$FilledInput.muiName = "Input";
var $f30f37ba13d2cac9$export$2e2bcd8739ae039 = $f30f37ba13d2cac9$var$FilledInput;

});
parcelRequire.register("i4DTE", function(module, exports) {

$parcel$export(module.exports, "getFilledInputUtilityClass", function () { return $d2878c5dbbf5645f$export$3331e419f1a48437; });
$parcel$export(module.exports, "default", function () { return $d2878c5dbbf5645f$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");

var $6I5Yx = parcelRequire("6I5Yx");
function $d2878c5dbbf5645f$export$3331e419f1a48437(slot) {
    return (0, $924xM.default)("MuiFilledInput", slot);
}
const $d2878c5dbbf5645f$var$filledInputClasses = (0, $dy3ak.default)({}, (0, $6I5Yx.default), (0, $83lmX.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $d2878c5dbbf5645f$export$2e2bcd8739ae039 = $d2878c5dbbf5645f$var$filledInputClasses;

});


parcelRequire.register("iCMmK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8f14b113668f5ae$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");



var $dhOhi = parcelRequire("dhOhi");

var $6UQdY = parcelRequire("6UQdY");

var $4Oe4k = parcelRequire("4Oe4k");

var $7Kcml = parcelRequire("7Kcml");

var $gx04x = parcelRequire("gx04x");

var $bQN0K = parcelRequire("bQN0K");

var $8vPDm = parcelRequire("8vPDm");

var $6XlHG = parcelRequire("6XlHG");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $d8f14b113668f5ae$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $d8f14b113668f5ae$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $dhOhi.default)(slots, (0, $bQN0K.getOutlinedInputUtilityClass), classes);
    return (0, $dy3ak.default)({}, classes, composedClasses);
};
const $d8f14b113668f5ae$var$OutlinedInputRoot = (0, $gx04x.default)((0, $8vPDm.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $gx04x.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $8vPDm.rootOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $dy3ak.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $bQN0K.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $bQN0K.default).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $bQN0K.default).focused} .${(0, $bQN0K.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $bQN0K.default).error} .${(0, $bQN0K.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $bQN0K.default).disabled} .${(0, $bQN0K.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $dy3ak.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $d8f14b113668f5ae$var$NotchedOutlineRoot = (0, $gx04x.default)((0, $6UQdY.default), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $d8f14b113668f5ae$var$OutlinedInputInput = (0, $gx04x.default)((0, $8vPDm.InputBaseComponent), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $8vPDm.inputOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>(0, $dy3ak.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $d8f14b113668f5ae$var$OutlinedInput = /*#__PURE__*/ $aOChP.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = "text" } = props, other = (0, $4GC5s.default)(props, $d8f14b113668f5ae$var$_excluded);
    const classes = $d8f14b113668f5ae$var$useUtilityClasses(props);
    const muiFormControl = (0, $4Oe4k.default)();
    const fcs = (0, $7Kcml.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "focused",
            "hiddenLabel",
            "size",
            "required"
        ]
    });
    const ownerState = (0, $dy3ak.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $d8f14b113668f5ae$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $d8f14b113668f5ae$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $8vPDm.default), (0, $dy3ak.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $5Wgfu.jsx)($d8f14b113668f5ae$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $5Wgfu.jsxs)($aOChP.Fragment, {
                    children: [
                        label,
                        " ",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $dy3ak.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$d8f14b113668f5ae$var$OutlinedInput.muiName = "Input";
var $d8f14b113668f5ae$export$2e2bcd8739ae039 = $d8f14b113668f5ae$var$OutlinedInput;

});
parcelRequire.register("6UQdY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50907bb7607b632e$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");
parcelRequire("aOChP");


var $gx04x = parcelRequire("gx04x");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
var $50907bb7607b632e$var$_span;
const $50907bb7607b632e$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $50907bb7607b632e$var$NotchedOutlineRoot = (0, $gx04x.default)("fieldset")({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $50907bb7607b632e$var$NotchedOutlineLegend = (0, $gx04x.default)("legend")(({ ownerState: ownerState, theme: theme })=>(0, $dy3ak.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $dy3ak.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $50907bb7607b632e$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $4GC5s.default)(props, $50907bb7607b632e$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $dy3ak.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $5Wgfu.jsx)($50907bb7607b632e$var$NotchedOutlineRoot, (0, $dy3ak.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $5Wgfu.jsx)($50907bb7607b632e$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $5Wgfu.jsx)("span", {
                children: label
            }) : $50907bb7607b632e$var$_span || ($50907bb7607b632e$var$_span = /*#__PURE__*/ (0, $5Wgfu.jsx)("span", {
                className: "notranslate",
                children: "​"
            }))
        })
    }));
}

});

parcelRequire.register("bQN0K", function(module, exports) {

$parcel$export(module.exports, "getOutlinedInputUtilityClass", function () { return $8a0a919fb533d895$export$89922944c7227687; });
$parcel$export(module.exports, "default", function () { return $8a0a919fb533d895$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");

var $6I5Yx = parcelRequire("6I5Yx");
function $8a0a919fb533d895$export$89922944c7227687(slot) {
    return (0, $924xM.default)("MuiOutlinedInput", slot);
}
const $8a0a919fb533d895$var$outlinedInputClasses = (0, $dy3ak.default)({}, (0, $6I5Yx.default), (0, $83lmX.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $8a0a919fb533d895$export$2e2bcd8739ae039 = $8a0a919fb533d895$var$outlinedInputClasses;

});


parcelRequire.register("k8zs2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea900de21f8df1c9$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");


var $dhOhi = parcelRequire("dhOhi");

var $gVoqA = parcelRequire("gVoqA");

var $7Kcml = parcelRequire("7Kcml");

var $4Oe4k = parcelRequire("4Oe4k");

var $iQZ2M = parcelRequire("iQZ2M");
var $538Fi = parcelRequire("538Fi");

var $6XlHG = parcelRequire("6XlHG");

var $lUjh9 = parcelRequire("lUjh9");

var $gx04x = parcelRequire("gx04x");

var $5bqMU = parcelRequire("5bqMU");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $ea900de21f8df1c9$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $ea900de21f8df1c9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size && size !== "normal" && `size${(0, $lUjh9.default)(size)}`,
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $dhOhi.default)(slots, (0, $5bqMU.getInputLabelUtilityClasses), classes);
    return (0, $dy3ak.default)({}, classes, composedClasses);
};
const $ea900de21f8df1c9$var$InputLabelRoot = (0, $gx04x.default)((0, $iQZ2M.default), {
    shouldForwardProp: (prop)=>(0, $gx04x.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $538Fi.default).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $dy3ak.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, $dy3ak.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, $dy3ak.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, $dy3ak.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: "calc(133% - 32px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const $ea900de21f8df1c9$var$InputLabel = /*#__PURE__*/ $aOChP.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $6XlHG.default)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $4GC5s.default)(props, $ea900de21f8df1c9$var$_excluded);
    const muiFormControl = (0, $4Oe4k.default)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $7Kcml.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required"
        ]
    });
    const ownerState = (0, $dy3ak.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required
    });
    const classes = $ea900de21f8df1c9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $5Wgfu.jsx)($ea900de21f8df1c9$var$InputLabelRoot, (0, $dy3ak.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $gVoqA.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $ea900de21f8df1c9$export$2e2bcd8739ae039 = $ea900de21f8df1c9$var$InputLabel;

});
parcelRequire.register("iQZ2M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db9c6f5864f71f03$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");

var $dhOhi = parcelRequire("dhOhi");

var $7Kcml = parcelRequire("7Kcml");

var $4Oe4k = parcelRequire("4Oe4k");

var $lUjh9 = parcelRequire("lUjh9");

var $6XlHG = parcelRequire("6XlHG");

var $gx04x = parcelRequire("gx04x");

var $538Fi = parcelRequire("538Fi");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $db9c6f5864f71f03$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $db9c6f5864f71f03$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $lUjh9.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $dhOhi.default)(slots, (0, $538Fi.getFormLabelUtilityClasses), classes);
};
const $db9c6f5864f71f03$export$aa5bc7f8a4705b27 = (0, $gx04x.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $dy3ak.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $dy3ak.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, $538Fi.default).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $538Fi.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $538Fi.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $db9c6f5864f71f03$var$AsteriskComponent = (0, $gx04x.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $538Fi.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $db9c6f5864f71f03$var$FormLabel = /*#__PURE__*/ $aOChP.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children, className: className, component: component = "label" } = props, other = (0, $4GC5s.default)(props, $db9c6f5864f71f03$var$_excluded);
    const muiFormControl = (0, $4Oe4k.default)();
    const fcs = (0, $7Kcml.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, $dy3ak.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $db9c6f5864f71f03$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)($db9c6f5864f71f03$export$aa5bc7f8a4705b27, (0, $dy3ak.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $gVoqA.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $5Wgfu.jsxs)($db9c6f5864f71f03$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    " ",
                    "*"
                ]
            })
        ]
    }));
});
var $db9c6f5864f71f03$export$2e2bcd8739ae039 = $db9c6f5864f71f03$var$FormLabel;

});
parcelRequire.register("538Fi", function(module, exports) {

$parcel$export(module.exports, "getFormLabelUtilityClasses", function () { return $3ad3f4477a65200d$export$f7d501e40371cd17; });
$parcel$export(module.exports, "default", function () { return $3ad3f4477a65200d$export$2e2bcd8739ae039; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $3ad3f4477a65200d$export$f7d501e40371cd17(slot) {
    return (0, $924xM.default)("MuiFormLabel", slot);
}
const $3ad3f4477a65200d$var$formLabelClasses = (0, $83lmX.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $3ad3f4477a65200d$export$2e2bcd8739ae039 = $3ad3f4477a65200d$var$formLabelClasses;

});


parcelRequire.register("5bqMU", function(module, exports) {

$parcel$export(module.exports, "getInputLabelUtilityClasses", function () { return $3c62c2567d8fbaf4$export$c1c4b4545ad2ea5f; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $3c62c2567d8fbaf4$export$c1c4b4545ad2ea5f(slot) {
    return (0, $924xM.default)("MuiInputLabel", slot);
}
const $3c62c2567d8fbaf4$var$inputLabelClasses = (0, $83lmX.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $3c62c2567d8fbaf4$export$2e2bcd8739ae039 = $3c62c2567d8fbaf4$var$inputLabelClasses;

});


parcelRequire.register("e22rl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a373251e8b9383a4$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");

var $dhOhi = parcelRequire("dhOhi");

var $6XlHG = parcelRequire("6XlHG");

var $gx04x = parcelRequire("gx04x");

var $f96jy = parcelRequire("f96jy");

var $lUjh9 = parcelRequire("lUjh9");

var $kMiKN = parcelRequire("kMiKN");

var $754jb = parcelRequire("754jb");

var $1x6N5 = parcelRequire("1x6N5");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $a373251e8b9383a4$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $a373251e8b9383a4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $lUjh9.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $dhOhi.default)(slots, (0, $1x6N5.getFormControlUtilityClasses), classes);
};
const $a373251e8b9383a4$var$FormControlRoot = (0, $gx04x.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $dy3ak.default)({}, styles.root, styles[`margin${(0, $lUjh9.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $dy3ak.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $a373251e8b9383a4$var$FormControl = /*#__PURE__*/ $aOChP.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = "none", required: required = false, size: size = "medium", variant: variant = "outlined" } = props, other = (0, $4GC5s.default)(props, $a373251e8b9383a4$var$_excluded);
    const ownerState = (0, $dy3ak.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $a373251e8b9383a4$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $aOChP.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $aOChP.Children.forEach(children, (child)=>{
            if (!(0, $kMiKN.default)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $kMiKN.default)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $f96jy.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $aOChP.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $aOChP.Children.forEach(children, (child)=>{
            if (!(0, $kMiKN.default)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $f96jy.isFilled)(child.props, true) || (0, $f96jy.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $aOChP.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $aOChP.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $754jb.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $5Wgfu.jsx)($a373251e8b9383a4$var$FormControlRoot, (0, $dy3ak.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $gVoqA.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $a373251e8b9383a4$export$2e2bcd8739ae039 = $a373251e8b9383a4$var$FormControl;

});
parcelRequire.register("kMiKN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f206d676d682fb47$export$2e2bcd8739ae039; });

var $2cnKU = parcelRequire("2cnKU");
var $f206d676d682fb47$export$2e2bcd8739ae039 = (0, $2cnKU.default);

});
parcelRequire.register("2cnKU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $199f21204b2ff796$export$2e2bcd8739ae039; });

var $aOChP = parcelRequire("aOChP");
function $199f21204b2ff796$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $aOChP.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

});


parcelRequire.register("1x6N5", function(module, exports) {

$parcel$export(module.exports, "getFormControlUtilityClasses", function () { return $11de2405f48ed42f$export$149c8b8bab2289d1; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $11de2405f48ed42f$export$149c8b8bab2289d1(slot) {
    return (0, $924xM.default)("MuiFormControl", slot);
}
const $11de2405f48ed42f$var$formControlClasses = (0, $83lmX.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $11de2405f48ed42f$export$2e2bcd8739ae039 = $11de2405f48ed42f$var$formControlClasses;

});


parcelRequire.register("jY9H6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e89b23fe5081e243$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");

var $dhOhi = parcelRequire("dhOhi");

var $7Kcml = parcelRequire("7Kcml");

var $4Oe4k = parcelRequire("4Oe4k");

var $gx04x = parcelRequire("gx04x");

var $lUjh9 = parcelRequire("lUjh9");

var $9GeUS = parcelRequire("9GeUS");

var $6XlHG = parcelRequire("6XlHG");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
var $e89b23fe5081e243$var$_span;
const $e89b23fe5081e243$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $e89b23fe5081e243$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, $lUjh9.default)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $dhOhi.default)(slots, (0, $9GeUS.getFormHelperTextUtilityClasses), classes);
};
const $e89b23fe5081e243$var$FormHelperTextRoot = (0, $gx04x.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $lUjh9.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $dy3ak.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $9GeUS.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $9GeUS.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $e89b23fe5081e243$var$FormHelperText = /*#__PURE__*/ $aOChP.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children: children, className: className, component: component = "p" } = props, other = (0, $4GC5s.default)(props, $e89b23fe5081e243$var$_excluded);
    const muiFormControl = (0, $4Oe4k.default)();
    const fcs = (0, $7Kcml.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = (0, $dy3ak.default)({}, props, {
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $e89b23fe5081e243$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $5Wgfu.jsx)($e89b23fe5081e243$var$FormHelperTextRoot, (0, $dy3ak.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $gVoqA.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? $e89b23fe5081e243$var$_span || ($e89b23fe5081e243$var$_span = /*#__PURE__*/ (0, $5Wgfu.jsx)("span", {
            className: "notranslate",
            children: "​"
        })) : children
    }));
});
var $e89b23fe5081e243$export$2e2bcd8739ae039 = $e89b23fe5081e243$var$FormHelperText;

});
parcelRequire.register("9GeUS", function(module, exports) {

$parcel$export(module.exports, "getFormHelperTextUtilityClasses", function () { return $70c39b67e1788d37$export$a394fa61b1d583a9; });
$parcel$export(module.exports, "default", function () { return $70c39b67e1788d37$export$2e2bcd8739ae039; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $70c39b67e1788d37$export$a394fa61b1d583a9(slot) {
    return (0, $924xM.default)("MuiFormHelperText", slot);
}
const $70c39b67e1788d37$var$formHelperTextClasses = (0, $83lmX.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $70c39b67e1788d37$export$2e2bcd8739ae039 = $70c39b67e1788d37$var$formHelperTextClasses;

});


parcelRequire.register("d82gU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98edc8da7d9f4993$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $4GC5s = parcelRequire("4GC5s");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");

var $e45KD = parcelRequire("e45KD");

var $d32iF = parcelRequire("d32iF");

var $7Kcml = parcelRequire("7Kcml");

var $4Oe4k = parcelRequire("4Oe4k");

var $gmrf0 = parcelRequire("gmrf0");

var $cWSVQ = parcelRequire("cWSVQ");

var $lmxoO = parcelRequire("lmxoO");

var $kRNA7 = parcelRequire("kRNA7");

var $iCMmK = parcelRequire("iCMmK");

var $6XlHG = parcelRequire("6XlHG");

var $4w8df = parcelRequire("4w8df");

var $gx04x = parcelRequire("gx04x");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $98edc8da7d9f4993$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $98edc8da7d9f4993$var$_excluded2 = [
    "root"
];
const $98edc8da7d9f4993$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $98edc8da7d9f4993$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $gx04x.rootShouldForwardProp)(prop) && prop !== "variant",
    slot: "Root"
};
const $98edc8da7d9f4993$var$StyledInput = (0, $gx04x.default)((0, $cWSVQ.default), $98edc8da7d9f4993$var$styledRootConfig)("");
const $98edc8da7d9f4993$var$StyledOutlinedInput = (0, $gx04x.default)((0, $iCMmK.default), $98edc8da7d9f4993$var$styledRootConfig)("");
const $98edc8da7d9f4993$var$StyledFilledInput = (0, $gx04x.default)((0, $kRNA7.default), $98edc8da7d9f4993$var$styledRootConfig)("");
const $98edc8da7d9f4993$var$Select = /*#__PURE__*/ $aOChP.forwardRef(function Select(inProps, ref) {
    const props = (0, $6XlHG.default)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $gmrf0.default), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = "outlined" } = props, other = (0, $4GC5s.default)(props, $98edc8da7d9f4993$var$_excluded);
    const inputComponent = native ? (0, $lmxoO.default) : (0, $d32iF.default);
    const muiFormControl = (0, $4Oe4k.default)();
    const fcs = (0, $7Kcml.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $dy3ak.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $98edc8da7d9f4993$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $4GC5s.default)(classes, $98edc8da7d9f4993$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $5Wgfu.jsx)($98edc8da7d9f4993$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $5Wgfu.jsx)($98edc8da7d9f4993$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $5Wgfu.jsx)($98edc8da7d9f4993$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $4w8df.default)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $5Wgfu.jsx)($aOChP.Fragment, {
        children: /*#__PURE__*/ $aOChP.cloneElement(InputComponent, (0, $dy3ak.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $dy3ak.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $dy3ak.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $e45KD.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, multiple && native && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $gVoqA.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$98edc8da7d9f4993$var$Select.muiName = "Select";
var $98edc8da7d9f4993$export$2e2bcd8739ae039 = $98edc8da7d9f4993$var$Select;

});
parcelRequire.register("d32iF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97fd56ec54bec5df$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $4GC5s = parcelRequire("4GC5s");

var $hBYX0 = parcelRequire("hBYX0");

var $aOChP = parcelRequire("aOChP");
parcelRequire("cZMZb");


var $gVoqA = parcelRequire("gVoqA");

var $dhOhi = parcelRequire("dhOhi");

var $4DSoH = parcelRequire("4DSoH");

var $lUjh9 = parcelRequire("lUjh9");

var $j8jSN = parcelRequire("j8jSN");

var $lmxoO = parcelRequire("lmxoO");

var $f96jy = parcelRequire("f96jy");

var $gx04x = parcelRequire("gx04x");

var $4w8df = parcelRequire("4w8df");

var $j6dVK = parcelRequire("j6dVK");

var $bX9GF = parcelRequire("bX9GF");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
var $97fd56ec54bec5df$var$_span;
const $97fd56ec54bec5df$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $97fd56ec54bec5df$var$SelectSelect = (0, $gx04x.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $bX9GF.default).select}`]: styles.select
            },
            {
                [`&.${(0, $bX9GF.default).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $bX9GF.default).error}`]: styles.error
            },
            {
                [`&.${(0, $bX9GF.default).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $lmxoO.nativeSelectSelectStyles), {
    // Win specificity over the input base
    [`&.${(0, $bX9GF.default).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $97fd56ec54bec5df$var$SelectIcon = (0, $gx04x.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $lUjh9.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $lmxoO.nativeSelectIconStyles));
const $97fd56ec54bec5df$var$SelectNativeInput = (0, $gx04x.default)("input", {
    shouldForwardProp: (prop)=>(0, $gx04x.slotShouldForwardProp)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $97fd56ec54bec5df$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $97fd56ec54bec5df$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $97fd56ec54bec5df$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $lUjh9.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $dhOhi.default)(slots, (0, $bX9GF.getSelectUtilityClasses), classes);
};
/**
 * @ignore - internal component.
 */ const $97fd56ec54bec5df$var$SelectInput = /*#__PURE__*/ $aOChP.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = "standard" } = props, other = (0, $4GC5s.default)(props, $97fd56ec54bec5df$var$_excluded);
    const [value, setValueState] = (0, $j6dVK.default)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $j6dVK.default)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $aOChP.useRef(null);
    const displayRef = $aOChP.useRef(null);
    const [displayNode, setDisplayNode] = $aOChP.useState(null);
    const { current: isOpenControlled } = $aOChP.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $aOChP.useState();
    const handleRef = (0, $4w8df.default)(ref, inputRefProp);
    const handleDisplayRef = $aOChP.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $aOChP.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $aOChP.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $aOChP.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $aOChP.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $4DSoH.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $aOChP.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $f96jy.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $aOChP.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $hBYX0.default)(2));
            selected = value.some((v)=>$97fd56ec54bec5df$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $97fd56ec54bec5df$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $aOChP.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $dy3ak.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $97fd56ec54bec5df$var$useUtilityClasses(ownerState);
    const paperProps = (0, $dy3ak.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)($aOChP.Fragment, {
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsx)($97fd56ec54bec5df$var$SelectSelect, (0, $dy3ak.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "button",
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $gVoqA.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $97fd56ec54bec5df$var$isEmpty(display) ? $97fd56ec54bec5df$var$_span || ($97fd56ec54bec5df$var$_span = /*#__PURE__*/ (0, $5Wgfu.jsx)("span", {
                    className: "notranslate",
                    children: "​"
                })) : display
            })),
            /*#__PURE__*/ (0, $5Wgfu.jsx)($97fd56ec54bec5df$var$SelectNativeInput, (0, $dy3ak.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $5Wgfu.jsx)($97fd56ec54bec5df$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $j8jSN.default), (0, $dy3ak.default)({
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $dy3ak.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    disableListWrap: true
                }, MenuProps.MenuListProps),
                slotProps: {
                    paper: (0, $dy3ak.default)({}, paperProps, {
                        style: (0, $dy3ak.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                },
                children: items
            }))
        ]
    });
});
var $97fd56ec54bec5df$export$2e2bcd8739ae039 = $97fd56ec54bec5df$var$SelectInput;

});
parcelRequire.register("4DSoH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36150025ddab633e$export$2e2bcd8739ae039; });

var $2bZGc = parcelRequire("2bZGc");
var $36150025ddab633e$export$2e2bcd8739ae039 = (0, $2bZGc.default);

});

parcelRequire.register("j8jSN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dede2ff82959b458$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $4GC5s = parcelRequire("4GC5s");

var $aOChP = parcelRequire("aOChP");
parcelRequire("cZMZb");


var $gVoqA = parcelRequire("gVoqA");

var $dhOhi = parcelRequire("dhOhi");

var $bNrje = parcelRequire("bNrje");


var $gF94Y = parcelRequire("gF94Y");

var $cifRB = parcelRequire("cifRB");

var $gx04x = parcelRequire("gx04x");

var $f11yQ = parcelRequire("f11yQ");

var $6XlHG = parcelRequire("6XlHG");

var $3xMT2 = parcelRequire("3xMT2");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $dede2ff82959b458$var$_excluded = [
    "onEntering"
], $dede2ff82959b458$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $dede2ff82959b458$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $dede2ff82959b458$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $dede2ff82959b458$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $dhOhi.default)(slots, (0, $3xMT2.getMenuUtilityClass), classes);
};
const $dede2ff82959b458$var$MenuRoot = (0, $gx04x.default)((0, $cifRB.default), {
    shouldForwardProp: (prop)=>(0, $gx04x.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $dede2ff82959b458$export$4f7c51a5920c9f33 = (0, $gx04x.default)((0, $cifRB.PopoverPaper), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $dede2ff82959b458$var$MenuMenuList = (0, $gx04x.default)((0, $gF94Y.default), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $dede2ff82959b458$var$Menu = /*#__PURE__*/ $aOChP.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering } = {}, variant: variant = "selectedMenu", slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $4GC5s.default)(props.TransitionProps, $dede2ff82959b458$var$_excluded), other = (0, $4GC5s.default)(props, $dede2ff82959b458$var$_excluded2);
    const theme = (0, $f11yQ.default)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $dy3ak.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $dede2ff82959b458$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $aOChP.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $aOChP.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $aOChP.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $dede2ff82959b458$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $bNrje.useSlotProps)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $bNrje.useSlotProps)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $5Wgfu.jsx)($dede2ff82959b458$var$MenuRoot, (0, $dy3ak.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $dede2ff82959b458$var$RTL_ORIGIN : $dede2ff82959b458$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $dy3ak.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $5Wgfu.jsx)($dede2ff82959b458$var$MenuMenuList, (0, $dy3ak.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $gVoqA.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $dede2ff82959b458$export$2e2bcd8739ae039 = $dede2ff82959b458$var$Menu;

});
parcelRequire.register("bNrje", function(module, exports) {

$parcel$export(module.exports, "useSlotProps", function () { return $89697456f2564acd$export$1e5c9e6e4e15efe3; });

var $dy3ak = parcelRequire("dy3ak");

var $4GC5s = parcelRequire("4GC5s");

var $bKnSm = parcelRequire("bKnSm");

var $fjt7t = parcelRequire("fjt7t");

var $lNlsI = parcelRequire("lNlsI");

var $k6zUn = parcelRequire("k6zUn");
"use client";
const $89697456f2564acd$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function $89697456f2564acd$export$1e5c9e6e4e15efe3(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $4GC5s.default)(parameters, $89697456f2564acd$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $k6zUn.resolveComponentProps)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $lNlsI.mergeSlotProps)((0, $dy3ak.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $bKnSm.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $fjt7t.appendOwnerState)(elementType, (0, $dy3ak.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}

});
parcelRequire.register("fjt7t", function(module, exports) {

$parcel$export(module.exports, "appendOwnerState", function () { return $b25f37eb5d65b5d6$export$b089efb01a7bdf50; });

var $dy3ak = parcelRequire("dy3ak");

var $cvlvc = parcelRequire("cvlvc");
function $b25f37eb5d65b5d6$export$b089efb01a7bdf50(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $cvlvc.isHostComponent)(elementType)) return otherProps;
    return (0, $dy3ak.default)({}, otherProps, {
        ownerState: (0, $dy3ak.default)({}, otherProps.ownerState, ownerState)
    });
}

});

parcelRequire.register("lNlsI", function(module, exports) {

$parcel$export(module.exports, "mergeSlotProps", function () { return $fdded288dee45036$export$b01d1e419b049226; });

var $dy3ak = parcelRequire("dy3ak");

var $gVoqA = parcelRequire("gVoqA");

var $3AIHW = parcelRequire("3AIHW");

var $bIxos = parcelRequire("bIxos");
function $fdded288dee45036$export$b01d1e419b049226(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $gVoqA.default)(externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className, className, additionalProps == null ? void 0 : additionalProps.className);
        const mergedStyle = (0, $dy3ak.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $dy3ak.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $3AIHW.extractEventHandlers)((0, $dy3ak.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $bIxos.omitEventHandlers)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $bIxos.omitEventHandlers)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $gVoqA.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $dy3ak.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $dy3ak.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}

});
parcelRequire.register("3AIHW", function(module, exports) {

$parcel$export(module.exports, "extractEventHandlers", function () { return $29d769e5c09996a1$export$24d5698b57eff81c; });
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $29d769e5c09996a1$export$24d5698b57eff81c(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}

});

parcelRequire.register("bIxos", function(module, exports) {

$parcel$export(module.exports, "omitEventHandlers", function () { return $887db507f87e236d$export$2ac0fa4d3a39be45; });
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $887db507f87e236d$export$2ac0fa4d3a39be45(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}

});


parcelRequire.register("k6zUn", function(module, exports) {

$parcel$export(module.exports, "resolveComponentProps", function () { return $ea3038d41f7f408b$export$308c24034cde71de; });
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $ea3038d41f7f408b$export$308c24034cde71de(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}

});


parcelRequire.register("gF94Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c21784a219a3a8e3$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $4GC5s = parcelRequire("4GC5s");

var $aOChP = parcelRequire("aOChP");
parcelRequire("cZMZb");


var $4DSoH = parcelRequire("4DSoH");

var $a90DB = parcelRequire("a90DB");

var $engYw = parcelRequire("engYw");

var $4w8df = parcelRequire("4w8df");

var $aiwZF = parcelRequire("aiwZF");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $c21784a219a3a8e3$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $c21784a219a3a8e3$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $c21784a219a3a8e3$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $c21784a219a3a8e3$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $c21784a219a3a8e3$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$c21784a219a3a8e3$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $c21784a219a3a8e3$var$MenuList = /*#__PURE__*/ $aOChP.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu" } = props, other = (0, $4GC5s.default)(props, $c21784a219a3a8e3$var$_excluded);
    const listRef = $aOChP.useRef(null);
    const textCriteriaRef = $aOChP.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $aiwZF.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $aOChP.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $engYw.default)((0, $4DSoH.default)(containerElement))}px`;
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $4DSoH.default)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $c21784a219a3a8e3$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $c21784a219a3a8e3$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $c21784a219a3a8e3$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $c21784a219a3a8e3$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $c21784a219a3a8e3$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $c21784a219a3a8e3$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $c21784a219a3a8e3$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $c21784a219a3a8e3$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $c21784a219a3a8e3$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $c21784a219a3a8e3$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $c21784a219a3a8e3$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $4w8df.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $aOChP.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $aOChP.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $aOChP.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $aOChP.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $a90DB.default), (0, $dy3ak.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $c21784a219a3a8e3$export$2e2bcd8739ae039 = $c21784a219a3a8e3$var$MenuList;

});
parcelRequire.register("a90DB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $762b3d4597179a36$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");

var $dhOhi = parcelRequire("dhOhi");

var $gx04x = parcelRequire("gx04x");

var $6XlHG = parcelRequire("6XlHG");

var $FMsmd = parcelRequire("FMsmd");

var $4AUl5 = parcelRequire("4AUl5");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $762b3d4597179a36$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $762b3d4597179a36$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $dhOhi.default)(slots, (0, $4AUl5.getListUtilityClass), classes);
};
const $762b3d4597179a36$var$ListRoot = (0, $gx04x.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $dy3ak.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $762b3d4597179a36$var$List = /*#__PURE__*/ $aOChP.forwardRef(function List(inProps, ref) {
    const props = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $4GC5s.default)(props, $762b3d4597179a36$var$_excluded);
    const context = $aOChP.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $dy3ak.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $762b3d4597179a36$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $FMsmd.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $5Wgfu.jsxs)($762b3d4597179a36$var$ListRoot, (0, $dy3ak.default)({
            as: component,
            className: (0, $gVoqA.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $762b3d4597179a36$export$2e2bcd8739ae039 = $762b3d4597179a36$var$List;

});
parcelRequire.register("FMsmd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07d96ae0867e20c8$export$2e2bcd8739ae039; });

var $aOChP = parcelRequire("aOChP");
"use client";
/**
 * @ignore - internal component.
 */ const $07d96ae0867e20c8$var$ListContext = /*#__PURE__*/ $aOChP.createContext({});
var $07d96ae0867e20c8$export$2e2bcd8739ae039 = $07d96ae0867e20c8$var$ListContext;

});

parcelRequire.register("4AUl5", function(module, exports) {

$parcel$export(module.exports, "getListUtilityClass", function () { return $358639ffc61ae997$export$c6bd6795ed6e3203; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $358639ffc61ae997$export$c6bd6795ed6e3203(slot) {
    return (0, $924xM.default)("MuiList", slot);
}
const $358639ffc61ae997$var$listClasses = (0, $83lmX.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $358639ffc61ae997$export$2e2bcd8739ae039 = $358639ffc61ae997$var$listClasses;

});


parcelRequire.register("engYw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7706197b80701e8$export$2e2bcd8739ae039; });

var $jFN3h = parcelRequire("jFN3h");
var $a7706197b80701e8$export$2e2bcd8739ae039 = (0, $jFN3h.default);

});
parcelRequire.register("jFN3h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e527e55ce071d51f$export$2e2bcd8739ae039; });
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $e527e55ce071d51f$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}

});



parcelRequire.register("cifRB", function(module, exports) {

$parcel$export(module.exports, "PopoverPaper", function () { return $8f3378a73c7cef93$export$821346c38a2d9390; });
$parcel$export(module.exports, "default", function () { return $8f3378a73c7cef93$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $4GC5s = parcelRequire("4GC5s");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");

var $cvlvc = parcelRequire("cvlvc");
var $dhOhi = parcelRequire("dhOhi");
var $bNrje = parcelRequire("bNrje");


var $gx04x = parcelRequire("gx04x");

var $6XlHG = parcelRequire("6XlHG");

var $vCb7d = parcelRequire("vCb7d");

var $4DSoH = parcelRequire("4DSoH");

var $jMdGn = parcelRequire("jMdGn");

var $4w8df = parcelRequire("4w8df");

var $5rZSx = parcelRequire("5rZSx");

var $jTVHP = parcelRequire("jTVHP");

var $9C0Ps = parcelRequire("9C0Ps");

var $bo5qc = parcelRequire("bo5qc");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $8f3378a73c7cef93$var$_excluded = [
    "onEntering"
], $8f3378a73c7cef93$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $8f3378a73c7cef93$var$_excluded3 = [
    "slotProps"
];
function $8f3378a73c7cef93$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $8f3378a73c7cef93$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $8f3378a73c7cef93$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $8f3378a73c7cef93$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $8f3378a73c7cef93$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $dhOhi.default)(slots, (0, $bo5qc.getPopoverUtilityClass), classes);
};
const $8f3378a73c7cef93$export$bcce13685275fc99 = (0, $gx04x.default)((0, $jTVHP.default), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $8f3378a73c7cef93$export$821346c38a2d9390 = (0, $gx04x.default)((0, $9C0Ps.default), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $8f3378a73c7cef93$var$Popover = /*#__PURE__*/ $aOChP.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $5rZSx.default), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $4GC5s.default)(props.TransitionProps, $8f3378a73c7cef93$var$_excluded), other = (0, $4GC5s.default)(props, $8f3378a73c7cef93$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $aOChP.useRef();
    const handlePaperRef = (0, $4w8df.default)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $dy3ak.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $8f3378a73c7cef93$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $aOChP.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $8f3378a73c7cef93$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $4DSoH.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $8f3378a73c7cef93$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $8f3378a73c7cef93$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $aOChP.useCallback((elemRect)=>{
        return {
            vertical: $8f3378a73c7cef93$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $8f3378a73c7cef93$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $aOChP.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $8f3378a73c7cef93$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $jMdGn.default)($8f3378a73c7cef93$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $8f3378a73c7cef93$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $aOChP.useState(open);
    const setPositioningStyles = $aOChP.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $aOChP.useEffect(()=>{
        if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
        return ()=>window.removeEventListener("scroll", setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $aOChP.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $aOChP.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $aOChP.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $vCb7d.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $jMdGn.default)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $4DSoH.default)($8f3378a73c7cef93$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $8f3378a73c7cef93$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $8f3378a73c7cef93$export$821346c38a2d9390;
    const paperProps = (0, $bNrje.useSlotProps)({
        elementType: PaperSlot,
        externalSlotProps: (0, $dy3ak.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $dy3ak.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $gVoqA.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $bNrje.useSlotProps)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $gVoqA.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $4GC5s.default)(_useSlotProps, $8f3378a73c7cef93$var$_excluded3);
    return /*#__PURE__*/ (0, $5Wgfu.jsx)(RootSlot, (0, $dy3ak.default)({}, rootProps, !(0, $cvlvc.isHostComponent)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $5Wgfu.jsx)(TransitionComponent, (0, $dy3ak.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $5Wgfu.jsx)(PaperSlot, (0, $dy3ak.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $8f3378a73c7cef93$export$2e2bcd8739ae039 = $8f3378a73c7cef93$var$Popover;

});
parcelRequire.register("vCb7d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05f082c6ac1b8ea5$export$2e2bcd8739ae039; });

var $fbLA1 = parcelRequire("fbLA1");
var $05f082c6ac1b8ea5$export$2e2bcd8739ae039 = (0, $fbLA1.default);

});

parcelRequire.register("jMdGn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e65d1d0e9326bb33$export$2e2bcd8739ae039; });

var $5J7Nc = parcelRequire("5J7Nc");
var $e65d1d0e9326bb33$export$2e2bcd8739ae039 = (0, $5J7Nc.default);

});

parcelRequire.register("5rZSx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f7f792e2a6ab932$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $4GC5s = parcelRequire("4GC5s");

var $aOChP = parcelRequire("aOChP");



var $jiXbw = parcelRequire("jiXbw");

var $f11yQ = parcelRequire("f11yQ");

var $cMLqV = parcelRequire("cMLqV");

var $4w8df = parcelRequire("4w8df");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $3f7f792e2a6ab932$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $3f7f792e2a6ab932$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $3f7f792e2a6ab932$var$styles = {
    entering: {
        opacity: 1,
        transform: $3f7f792e2a6ab932$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $3f7f792e2a6ab932$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $3f7f792e2a6ab932$var$Grow = /*#__PURE__*/ $aOChP.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $jiXbw.default) } = props, other = (0, $4GC5s.default)(props, $3f7f792e2a6ab932$var$_excluded);
    const timer = $aOChP.useRef();
    const autoTimeout = $aOChP.useRef();
    const theme = (0, $f11yQ.default)();
    const nodeRef = $aOChP.useRef(null);
    const handleRef = (0, $4w8df.default)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $cMLqV.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $cMLqV.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $3f7f792e2a6ab932$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $cMLqV.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $3f7f792e2a6ab932$var$isWebKit154 ? duration : duration * 0.666,
                delay: $3f7f792e2a6ab932$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $3f7f792e2a6ab932$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    $aOChP.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $5Wgfu.jsx)(TransitionComponent, (0, $dy3ak.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $aOChP.cloneElement(children, (0, $dy3ak.default)({
                style: (0, $dy3ak.default)({
                    opacity: 0,
                    transform: $3f7f792e2a6ab932$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $3f7f792e2a6ab932$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$3f7f792e2a6ab932$var$Grow.muiSupportAuto = true;
var $3f7f792e2a6ab932$export$2e2bcd8739ae039 = $3f7f792e2a6ab932$var$Grow;

});

parcelRequire.register("jTVHP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7cfea91bdbe59c4$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");


var $bNrje = parcelRequire("bNrje");

var $7RLyU = parcelRequire("7RLyU");

var $dhOhi = parcelRequire("dhOhi");

var $dG4v6 = parcelRequire("dG4v6");

var $ckIrh = parcelRequire("ckIrh");

var $gx04x = parcelRequire("gx04x");

var $6XlHG = parcelRequire("6XlHG");

var $395kt = parcelRequire("395kt");

var $e17jj = parcelRequire("e17jj");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $e7cfea91bdbe59c4$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $e7cfea91bdbe59c4$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $dhOhi.default)(slots, (0, $e17jj.getModalUtilityClass), classes);
};
const $e7cfea91bdbe59c4$var$ModalRoot = (0, $gx04x.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $dy3ak.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $e7cfea91bdbe59c4$var$ModalBackdrop = (0, $gx04x.default)((0, $395kt.default), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $e7cfea91bdbe59c4$var$Modal = /*#__PURE__*/ $aOChP.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $6XlHG.default)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $e7cfea91bdbe59c4$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $4GC5s.default)(props, $e7cfea91bdbe59c4$var$_excluded);
    const propsWithDefaults = (0, $dy3ak.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $7RLyU.useModal)((0, $dy3ak.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $dy3ak.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $e7cfea91bdbe59c4$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $e7cfea91bdbe59c4$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $bNrje.useSlotProps)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $gVoqA.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $bNrje.useSlotProps)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $dy3ak.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $gVoqA.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $ckIrh.Portal), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $5Wgfu.jsxs)(RootSlot, (0, $dy3ak.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $5Wgfu.jsx)(BackdropSlot, (0, $dy3ak.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $dG4v6.FocusTrap), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $aOChP.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $e7cfea91bdbe59c4$export$2e2bcd8739ae039 = $e7cfea91bdbe59c4$var$Modal;

});
parcelRequire.register("7RLyU", function(module, exports) {

$parcel$export(module.exports, "useModal", function () { return $5ba2607aea3b1a6c$export$33ffd74ebf07f060; });

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");

var $dJuTv = parcelRequire("dJuTv");
var $2bZGc = parcelRequire("2bZGc");
var $cPD1N = parcelRequire("cPD1N");
var $bKnSm = parcelRequire("bKnSm");

var $3AIHW = parcelRequire("3AIHW");

var $9tmLP = parcelRequire("9tmLP");
"use client";
function $5ba2607aea3b1a6c$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $5ba2607aea3b1a6c$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $5ba2607aea3b1a6c$var$defaultManager = new (0, $9tmLP.ModalManager)();
function $5ba2607aea3b1a6c$export$33ffd74ebf07f060(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $5ba2607aea3b1a6c$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $aOChP.useRef({});
    const mountNodeRef = $aOChP.useRef(null);
    const modalRef = $aOChP.useRef(null);
    const handleRef = (0, $bKnSm.default)(modalRef, rootRef);
    const [exited, setExited] = $aOChP.useState(!open);
    const hasTransition = $5ba2607aea3b1a6c$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $2bZGc.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $cPD1N.default)(()=>{
        const resolvedContainer = $5ba2607aea3b1a6c$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $aOChP.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $cPD1N.default)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $9tmLP.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $aOChP.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $aOChP.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $aOChP.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== "Escape" || !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, "escapeKeyDown");
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, "backdropClick");
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $3AIHW.extractEventHandlers)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $dy3ak.default)({}, propsEventHandlers, otherHandlers);
        return (0, $dy3ak.default)({
            role: "presentation"
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $dy3ak.default)({
            "aria-hidden": true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $dJuTv.default)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $dJuTv.default)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}

});
parcelRequire.register("dJuTv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ff7714bdc2b9481$export$2e2bcd8739ae039; });
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $9ff7714bdc2b9481$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});

parcelRequire.register("9tmLP", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", function () { return $6e587c38413a73e2$export$e1bd0c6150f13d96; });
$parcel$export(module.exports, "ModalManager", function () { return $6e587c38413a73e2$export$ce11c4ecd08cea67; });

var $jFN3h = parcelRequire("jFN3h");
var $2bZGc = parcelRequire("2bZGc");
var $5J7Nc = parcelRequire("5J7Nc");
// Is a vertical scrollbar displayed?
function $6e587c38413a73e2$var$isOverflowing(container) {
    const doc = (0, $2bZGc.default)(container);
    if (doc.body === container) return (0, $5J7Nc.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $6e587c38413a73e2$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $6e587c38413a73e2$var$getPaddingRight(element) {
    return parseInt((0, $5J7Nc.default)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $6e587c38413a73e2$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $6e587c38413a73e2$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$6e587c38413a73e2$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $6e587c38413a73e2$export$e1bd0c6150f13d96(element, show);
    });
}
function $6e587c38413a73e2$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $6e587c38413a73e2$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($6e587c38413a73e2$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $jFN3h.default)((0, $2bZGc.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$6e587c38413a73e2$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $2bZGc.default)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$6e587c38413a73e2$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $2bZGc.default)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $5J7Nc.default)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $6e587c38413a73e2$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $6e587c38413a73e2$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $6e587c38413a73e2$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $6e587c38413a73e2$var$getHiddenSiblings(container);
        $6e587c38413a73e2$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $6e587c38413a73e2$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $6e587c38413a73e2$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $6e587c38413a73e2$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $6e587c38413a73e2$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $6e587c38413a73e2$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $6e587c38413a73e2$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $6e587c38413a73e2$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}

});


parcelRequire.register("dG4v6", function(module, exports) {

$parcel$export(module.exports, "FocusTrap", function () { return $9f52b056f904d3d9$export$34eba2437817a67b; });

var $aOChP = parcelRequire("aOChP");


var $2bZGc = parcelRequire("2bZGc");
var $bKnSm = parcelRequire("bKnSm");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const $9f52b056f904d3d9$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $9f52b056f904d3d9$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $9f52b056f904d3d9$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $9f52b056f904d3d9$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $9f52b056f904d3d9$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $9f52b056f904d3d9$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($9f52b056f904d3d9$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $9f52b056f904d3d9$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$9f52b056f904d3d9$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $9f52b056f904d3d9$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */ function $9f52b056f904d3d9$export$34eba2437817a67b(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $9f52b056f904d3d9$var$defaultGetTabbable, isEnabled: isEnabled = $9f52b056f904d3d9$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $aOChP.useRef(false);
    const sentinelStart = $aOChP.useRef(null);
    const sentinelEnd = $aOChP.useRef(null);
    const nodeToRestore = $aOChP.useRef(null);
    const reactFocusEventTarget = $aOChP.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $aOChP.useRef(false);
    const rootRef = $aOChP.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $bKnSm.default)(children.ref, rootRef);
    const lastKeydown = $aOChP.useRef(null);
    $aOChP.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $aOChP.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $2bZGc.default)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $aOChP.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $2bZGc.default)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)($aOChP.Fragment, {
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $aOChP.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}

});

parcelRequire.register("ckIrh", function(module, exports) {

$parcel$export(module.exports, "Portal", function () { return $8fa9d2f25701097f$export$602eac185826482c; });

var $aOChP = parcelRequire("aOChP");

var $e85sa = parcelRequire("e85sa");


var $hIwMs = parcelRequire("hIwMs");
var $4Vm6n = parcelRequire("4Vm6n");
var $bKnSm = parcelRequire("bKnSm");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
function $8fa9d2f25701097f$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ const $8fa9d2f25701097f$export$602eac185826482c = /*#__PURE__*/ $aOChP.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $aOChP.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $bKnSm.default)(/*#__PURE__*/ $aOChP.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $4Vm6n.default)(()=>{
        if (!disablePortal) setMountNode($8fa9d2f25701097f$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $4Vm6n.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $hIwMs.default)(forwardedRef, mountNode);
            return ()=>{
                (0, $hIwMs.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $aOChP.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $aOChP.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $5Wgfu.jsx)($aOChP.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $5Wgfu.jsx)($aOChP.Fragment, {
        children: mountNode ? /*#__PURE__*/ $e85sa.createPortal(children, mountNode) : mountNode
    });
});

});

parcelRequire.register("395kt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24a658a524abb625$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");

var $dhOhi = parcelRequire("dhOhi");

var $gx04x = parcelRequire("gx04x");

var $6XlHG = parcelRequire("6XlHG");

var $kYBmd = parcelRequire("kYBmd");

var $dhvrj = parcelRequire("dhvrj");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $24a658a524abb625$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $24a658a524abb625$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $dhOhi.default)(slots, (0, $dhvrj.getBackdropUtilityClass), classes);
};
const $24a658a524abb625$var$BackdropRoot = (0, $gx04x.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $dy3ak.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $24a658a524abb625$var$Backdrop = /*#__PURE__*/ $aOChP.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $6XlHG.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $kYBmd.default), transitionDuration: transitionDuration } = props, other = (0, $4GC5s.default)(props, $24a658a524abb625$var$_excluded);
    const ownerState = (0, $dy3ak.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $24a658a524abb625$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $5Wgfu.jsx)(TransitionComponent, (0, $dy3ak.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $5Wgfu.jsx)($24a658a524abb625$var$BackdropRoot, (0, $dy3ak.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $gVoqA.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $dy3ak.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $24a658a524abb625$export$2e2bcd8739ae039 = $24a658a524abb625$var$Backdrop;

});
parcelRequire.register("kYBmd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f456639b9f223444$export$2e2bcd8739ae039; });

var $dy3ak = parcelRequire("dy3ak");

var $4GC5s = parcelRequire("4GC5s");

var $aOChP = parcelRequire("aOChP");


var $jiXbw = parcelRequire("jiXbw");


var $f11yQ = parcelRequire("f11yQ");

var $cMLqV = parcelRequire("cMLqV");

var $4w8df = parcelRequire("4w8df");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $f456639b9f223444$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $f456639b9f223444$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $f456639b9f223444$var$Fade = /*#__PURE__*/ $aOChP.forwardRef(function Fade(props, ref) {
    const theme = (0, $f11yQ.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $jiXbw.default) } = props, other = (0, $4GC5s.default)(props, $f456639b9f223444$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $aOChP.useRef(null);
    const handleRef = (0, $4w8df.default)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $cMLqV.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $cMLqV.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $cMLqV.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $5Wgfu.jsx)(TransitionComponent, (0, $dy3ak.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $aOChP.cloneElement(children, (0, $dy3ak.default)({
                style: (0, $dy3ak.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $f456639b9f223444$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $f456639b9f223444$export$2e2bcd8739ae039 = $f456639b9f223444$var$Fade;

});

parcelRequire.register("dhvrj", function(module, exports) {

$parcel$export(module.exports, "getBackdropUtilityClass", function () { return $9ab5401cd0451528$export$9927a91fd93152bd; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $9ab5401cd0451528$export$9927a91fd93152bd(slot) {
    return (0, $924xM.default)("MuiBackdrop", slot);
}
const $9ab5401cd0451528$var$backdropClasses = (0, $83lmX.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $9ab5401cd0451528$export$2e2bcd8739ae039 = $9ab5401cd0451528$var$backdropClasses;

});


parcelRequire.register("e17jj", function(module, exports) {

$parcel$export(module.exports, "getModalUtilityClass", function () { return $a346d460acbcbebe$export$67960e22b12a638d; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $a346d460acbcbebe$export$67960e22b12a638d(slot) {
    return (0, $924xM.default)("MuiModal", slot);
}
const $a346d460acbcbebe$var$modalClasses = (0, $83lmX.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $a346d460acbcbebe$export$2e2bcd8739ae039 = $a346d460acbcbebe$var$modalClasses;

});


parcelRequire.register("bo5qc", function(module, exports) {

$parcel$export(module.exports, "getPopoverUtilityClass", function () { return $84a624316d1233d5$export$88f455dd56c95edb; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $84a624316d1233d5$export$88f455dd56c95edb(slot) {
    return (0, $924xM.default)("MuiPopover", slot);
}
const $84a624316d1233d5$var$popoverClasses = (0, $83lmX.default)("MuiPopover", [
    "root",
    "paper"
]);
var $84a624316d1233d5$export$2e2bcd8739ae039 = $84a624316d1233d5$var$popoverClasses;

});


parcelRequire.register("3xMT2", function(module, exports) {

$parcel$export(module.exports, "getMenuUtilityClass", function () { return $294a60072af1c669$export$2cf86a63a84fe23d; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $294a60072af1c669$export$2cf86a63a84fe23d(slot) {
    return (0, $924xM.default)("MuiMenu", slot);
}
const $294a60072af1c669$var$menuClasses = (0, $83lmX.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $294a60072af1c669$export$2e2bcd8739ae039 = $294a60072af1c669$var$menuClasses;

});


parcelRequire.register("lmxoO", function(module, exports) {

$parcel$export(module.exports, "nativeSelectSelectStyles", function () { return $f8d58f6e6b3d4308$export$c1eccd1617458c87; });
$parcel$export(module.exports, "nativeSelectIconStyles", function () { return $f8d58f6e6b3d4308$export$e7a817afd12a40d0; });
$parcel$export(module.exports, "default", function () { return $f8d58f6e6b3d4308$export$2e2bcd8739ae039; });

var $4GC5s = parcelRequire("4GC5s");

var $dy3ak = parcelRequire("dy3ak");

var $aOChP = parcelRequire("aOChP");


var $gVoqA = parcelRequire("gVoqA");


var $dhOhi = parcelRequire("dhOhi");

var $lUjh9 = parcelRequire("lUjh9");

var $9BqlG = parcelRequire("9BqlG");

var $gx04x = parcelRequire("gx04x");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
const $f8d58f6e6b3d4308$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $f8d58f6e6b3d4308$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $lUjh9.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $dhOhi.default)(slots, (0, $9BqlG.getNativeSelectUtilityClasses), classes);
};
const $f8d58f6e6b3d4308$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $dy3ak.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, $dy3ak.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $9BqlG.default).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $f8d58f6e6b3d4308$var$NativeSelectSelect = (0, $gx04x.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $gx04x.rootShouldForwardProp),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $9BqlG.default).multiple}`]: styles.multiple
            }
        ];
    }
})($f8d58f6e6b3d4308$export$c1eccd1617458c87);
const $f8d58f6e6b3d4308$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $dy3ak.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $9BqlG.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $f8d58f6e6b3d4308$var$NativeSelectIcon = (0, $gx04x.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $lUjh9.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($f8d58f6e6b3d4308$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $f8d58f6e6b3d4308$var$NativeSelectInput = /*#__PURE__*/ $aOChP.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = "standard" } = props, other = (0, $4GC5s.default)(props, $f8d58f6e6b3d4308$var$_excluded);
    const ownerState = (0, $dy3ak.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $f8d58f6e6b3d4308$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)($aOChP.Fragment, {
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsx)($f8d58f6e6b3d4308$var$NativeSelectSelect, (0, $dy3ak.default)({
                ownerState: ownerState,
                className: (0, $gVoqA.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $5Wgfu.jsx)($f8d58f6e6b3d4308$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $f8d58f6e6b3d4308$export$2e2bcd8739ae039 = $f8d58f6e6b3d4308$var$NativeSelectInput;

});
parcelRequire.register("9BqlG", function(module, exports) {

$parcel$export(module.exports, "getNativeSelectUtilityClasses", function () { return $6fdc0213aa661b2e$export$1ee13051fd9e2ab5; });
$parcel$export(module.exports, "default", function () { return $6fdc0213aa661b2e$export$2e2bcd8739ae039; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $6fdc0213aa661b2e$export$1ee13051fd9e2ab5(slot) {
    return (0, $924xM.default)("MuiNativeSelect", slot);
}
const $6fdc0213aa661b2e$var$nativeSelectClasses = (0, $83lmX.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $6fdc0213aa661b2e$export$2e2bcd8739ae039 = $6fdc0213aa661b2e$var$nativeSelectClasses;

});


parcelRequire.register("j6dVK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de7962262208bca1$export$2e2bcd8739ae039; });

var $7ZTcK = parcelRequire("7ZTcK");
"use client";
var $de7962262208bca1$export$2e2bcd8739ae039 = (0, $7ZTcK.default);

});
parcelRequire.register("7ZTcK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d290d699b793440$export$2e2bcd8739ae039; });

var $aOChP = parcelRequire("aOChP");
"use client";
function $5d290d699b793440$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $aOChP.useRef(controlled !== undefined);
    const [valueState, setValue] = $aOChP.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $aOChP.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRequire.register("bX9GF", function(module, exports) {

$parcel$export(module.exports, "getSelectUtilityClasses", function () { return $8b3cb8168390ee45$export$2c0c1ee5a3392e; });
$parcel$export(module.exports, "default", function () { return $8b3cb8168390ee45$export$2e2bcd8739ae039; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $8b3cb8168390ee45$export$2c0c1ee5a3392e(slot) {
    return (0, $924xM.default)("MuiSelect", slot);
}
const $8b3cb8168390ee45$var$selectClasses = (0, $83lmX.default)("MuiSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $8b3cb8168390ee45$export$2e2bcd8739ae039 = $8b3cb8168390ee45$var$selectClasses;

});


parcelRequire.register("gmrf0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be93d4e6d8fa6dd2$export$2e2bcd8739ae039; });
parcelRequire("aOChP");

var $awJsl = parcelRequire("awJsl");

var $5Wgfu = parcelRequire("5Wgfu");
"use client";
var $be93d4e6d8fa6dd2$export$2e2bcd8739ae039 = (0, $awJsl.default)(/*#__PURE__*/ (0, $5Wgfu.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");

});


parcelRequire.register("b5yh1", function(module, exports) {

$parcel$export(module.exports, "getTextFieldUtilityClass", function () { return $812abf56f0b15464$export$c1bdcbaf0596aeda; });

var $83lmX = parcelRequire("83lmX");

var $924xM = parcelRequire("924xM");
function $812abf56f0b15464$export$c1bdcbaf0596aeda(slot) {
    return (0, $924xM.default)("MuiTextField", slot);
}
const $812abf56f0b15464$var$textFieldClasses = (0, $83lmX.default)("MuiTextField", [
    "root"
]);
var $812abf56f0b15464$export$2e2bcd8739ae039 = $812abf56f0b15464$var$textFieldClasses;

});


parcelRequire.register("kYFRN", function(module, exports) {

$parcel$export(module.exports, "ToastContainer", function () { return $8197fedcdf4bc40d$export$f2815235e76a62b9; });
$parcel$export(module.exports, "toast", function () { return $8197fedcdf4bc40d$export$b410431fab84fa58; });

var $aOChP = parcelRequire("aOChP");

var $jDfgb = parcelRequire("jDfgb");
"use client";
const $8197fedcdf4bc40d$var$u = (t)=>"number" == typeof t && !isNaN(t), $8197fedcdf4bc40d$var$d = (t)=>"string" == typeof t, $8197fedcdf4bc40d$var$p = (t)=>"function" == typeof t, $8197fedcdf4bc40d$var$m = (t)=>$8197fedcdf4bc40d$var$d(t) || $8197fedcdf4bc40d$var$p(t) ? t : null, $8197fedcdf4bc40d$var$f = (t)=>(0, $aOChP.isValidElement)(t) || $8197fedcdf4bc40d$var$d(t) || $8197fedcdf4bc40d$var$p(t) || $8197fedcdf4bc40d$var$u(t);
function $8197fedcdf4bc40d$export$184cca501f1aed7f(t, e, n) {
    void 0 === n && (n = 300);
    const { scrollHeight: o, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = o + "px", s.transition = `all ${n}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(e, n);
        });
    });
}
function $8197fedcdf4bc40d$export$3ff7dc44d332d222(e) {
    let { enter: a, exit: r, appendPosition: i = !1, collapse: l = !0, collapseDuration: c = 300 } = e;
    return function(e) {
        let { children: u, position: d, preventExitTransition: p, done: m, nodeRef: f, isIn: h } = e;
        const y = i ? `${a}--${d}` : a, v = i ? `${r}--${d}` : r, T = (0, $aOChP.useRef)(0);
        return (0, $aOChP.useLayoutEffect)(()=>{
            const t = f.current, e = y.split(" "), n = (o)=>{
                o.target === f.current && (t.dispatchEvent(new Event("d")), t.removeEventListener("animationend", n), t.removeEventListener("animationcancel", n), 0 === T.current && "animationcancel" !== o.type && t.classList.remove(...e));
            };
            t.classList.add(...e), t.addEventListener("animationend", n), t.addEventListener("animationcancel", n);
        }, []), (0, $aOChP.useEffect)(()=>{
            const t = f.current, e = ()=>{
                t.removeEventListener("animationend", e), l ? $8197fedcdf4bc40d$export$184cca501f1aed7f(t, m, c) : m();
            };
            h || (p ? e() : (T.current = 1, t.className += ` ${v}`, t.addEventListener("animationend", e)));
        }, [
            h
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).Fragment, null, u);
    };
}
function $8197fedcdf4bc40d$var$y(t, e) {
    return null != t ? {
        content: t.content,
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        status: e
    } : {};
}
const $8197fedcdf4bc40d$var$v = {
    list: new Map,
    emitQueue: new Map,
    on (t, e) {
        return this.list.has(t) || this.list.set(t, []), this.list.get(t).push(e), this;
    },
    off (t, e) {
        if (e) {
            const n = this.list.get(t).filter((t)=>t !== e);
            return this.list.set(t, n), this;
        }
        return this.list.delete(t), this;
    },
    cancelEmit (t) {
        const e = this.emitQueue.get(t);
        return e && (e.forEach(clearTimeout), this.emitQueue.delete(t)), this;
    },
    emit (t) {
        this.list.has(t) && this.list.get(t).forEach((e)=>{
            const n = setTimeout(()=>{
                e(...[].slice.call(arguments, 1));
            }, 0);
            this.emitQueue.has(t) || this.emitQueue.set(t, []), this.emitQueue.get(t).push(n);
        });
    }
}, $8197fedcdf4bc40d$var$T = (e)=>{
    let { theme: n, type: o, ...s } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: "colored" === n ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...s
    });
}, $8197fedcdf4bc40d$export$4f13f83fd8bb1dac = {
    info: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement($8197fedcdf4bc40d$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
        }));
    },
    warning: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement($8197fedcdf4bc40d$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement("path", {
            d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
        }));
    },
    success: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement($8197fedcdf4bc40d$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
        }));
    },
    error: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement($8197fedcdf4bc40d$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement("path", {
            d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
        }));
    },
    spinner: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement("div", {
            className: "Toastify__spinner"
        });
    }
};
function $8197fedcdf4bc40d$export$b262e13ca2dd2381(t) {
    const [, o] = (0, $aOChP.useReducer)((t)=>t + 1, 0), [l, c] = (0, $aOChP.useState)([]), g = (0, $aOChP.useRef)(null), h = (0, $aOChP.useRef)(new Map).current, T = (t)=>-1 !== l.indexOf(t), C = (0, $aOChP.useRef)({
        toastKey: 1,
        displayedToast: 0,
        count: 0,
        queue: [],
        props: t,
        containerId: null,
        isToastActive: T,
        getToast: (t)=>h.get(t)
    }).current;
    function b(t) {
        let { containerId: e } = t;
        const { limit: n } = C.props;
        !n || e && C.containerId !== e || (C.count -= C.queue.length, C.queue = []);
    }
    function I(t) {
        c((e)=>null == t ? [] : e.filter((e)=>e !== t));
    }
    function _() {
        const { toastContent: t, toastProps: e, staleId: n } = C.queue.shift();
        O(t, e, n);
    }
    function L(t, n) {
        let { delay: s, staleId: r, ...i } = n;
        if (!$8197fedcdf4bc40d$var$f(t) || function(t) {
            return !g.current || C.props.enableMultiContainer && t.containerId !== C.props.containerId || h.has(t.toastId) && null == t.updateId;
        }(i)) return;
        const { toastId: l, updateId: c, data: T } = i, { props: b } = C, L = ()=>I(l), N = null == c;
        N && C.count++;
        const M = {
            ...b,
            style: b.toastStyle,
            key: C.toastKey++,
            ...Object.fromEntries(Object.entries(i).filter((t)=>{
                let [e, n] = t;
                return null != n;
            })),
            toastId: l,
            updateId: c,
            data: T,
            closeToast: L,
            isIn: !1,
            className: $8197fedcdf4bc40d$var$m(i.className || b.toastClassName),
            bodyClassName: $8197fedcdf4bc40d$var$m(i.bodyClassName || b.bodyClassName),
            progressClassName: $8197fedcdf4bc40d$var$m(i.progressClassName || b.progressClassName),
            autoClose: !i.isLoading && (R = i.autoClose, w = b.autoClose, !1 === R || $8197fedcdf4bc40d$var$u(R) && R > 0 ? R : w),
            deleteToast () {
                const t = $8197fedcdf4bc40d$var$y(h.get(l), "removed");
                h.delete(l), $8197fedcdf4bc40d$var$v.emit(4, t);
                const e = C.queue.length;
                if (C.count = null == l ? C.count - C.displayedToast : C.count - 1, C.count < 0 && (C.count = 0), e > 0) {
                    const t = null == l ? C.props.limit : 1;
                    if (1 === e || 1 === t) C.displayedToast++, _();
                    else {
                        const n = t > e ? e : t;
                        C.displayedToast = n;
                        for(let t = 0; t < n; t++)_();
                    }
                } else o();
            }
        };
        var R, w;
        M.iconOut = function(t) {
            let { theme: n, type: o, isLoading: s, icon: r } = t, i = null;
            const l = {
                theme: n,
                type: o
            };
            return !1 === r || ($8197fedcdf4bc40d$var$p(r) ? i = r(l) : (0, $aOChP.isValidElement)(r) ? i = (0, $aOChP.cloneElement)(r, l) : $8197fedcdf4bc40d$var$d(r) || $8197fedcdf4bc40d$var$u(r) ? i = r : s ? i = $8197fedcdf4bc40d$export$4f13f83fd8bb1dac.spinner() : ((t)=>t in $8197fedcdf4bc40d$export$4f13f83fd8bb1dac)(o) && (i = $8197fedcdf4bc40d$export$4f13f83fd8bb1dac[o](l))), i;
        }(M), $8197fedcdf4bc40d$var$p(i.onOpen) && (M.onOpen = i.onOpen), $8197fedcdf4bc40d$var$p(i.onClose) && (M.onClose = i.onClose), M.closeButton = b.closeButton, !1 === i.closeButton || $8197fedcdf4bc40d$var$f(i.closeButton) ? M.closeButton = i.closeButton : !0 === i.closeButton && (M.closeButton = !$8197fedcdf4bc40d$var$f(b.closeButton) || b.closeButton);
        let x = t;
        (0, $aOChP.isValidElement)(t) && !$8197fedcdf4bc40d$var$d(t.type) ? x = (0, $aOChP.cloneElement)(t, {
            closeToast: L,
            toastProps: M,
            data: T
        }) : $8197fedcdf4bc40d$var$p(t) && (x = t({
            closeToast: L,
            toastProps: M,
            data: T
        })), b.limit && b.limit > 0 && C.count > b.limit && N ? C.queue.push({
            toastContent: x,
            toastProps: M,
            staleId: r
        }) : $8197fedcdf4bc40d$var$u(s) ? setTimeout(()=>{
            O(x, M, r);
        }, s) : O(x, M, r);
    }
    function O(t, e, n) {
        const { toastId: o } = e;
        n && h.delete(n);
        const s = {
            content: t,
            props: e
        };
        h.set(o, s), c((t)=>[
                ...t,
                o
            ].filter((t)=>t !== n)), $8197fedcdf4bc40d$var$v.emit(4, $8197fedcdf4bc40d$var$y(s, null == s.props.updateId ? "added" : "updated"));
    }
    return (0, $aOChP.useEffect)(()=>(C.containerId = t.containerId, $8197fedcdf4bc40d$var$v.cancelEmit(3).on(0, L).on(1, (t)=>g.current && I(t)).on(5, b).emit(2, C), ()=>{
            h.clear(), $8197fedcdf4bc40d$var$v.emit(3, C);
        }), []), (0, $aOChP.useEffect)(()=>{
        C.props = t, C.isToastActive = T, C.displayedToast = l.length;
    }), {
        getToastToRender: function(e) {
            const n = new Map, o = Array.from(h.values());
            return t.newestOnTop && o.reverse(), o.forEach((t)=>{
                const { position: e } = t.props;
                n.has(e) || n.set(e, []), n.get(e).push(t);
            }), Array.from(n, (t)=>e(t[0], t[1]));
        },
        containerRef: g,
        isToastActive: T
    };
}
function $8197fedcdf4bc40d$var$b(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientX : t.clientX;
}
function $8197fedcdf4bc40d$var$I(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientY : t.clientY;
}
function $8197fedcdf4bc40d$export$a407b657d3044108(t) {
    const [o, a] = (0, $aOChP.useState)(!1), [r, l] = (0, $aOChP.useState)(!1), c = (0, $aOChP.useRef)(null), u = (0, $aOChP.useRef)({
        start: 0,
        x: 0,
        y: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        boundingRect: null,
        didMove: !1
    }).current, d = (0, $aOChP.useRef)(t), { autoClose: m, pauseOnHover: f, closeToast: g, onClick: h, closeOnClick: y } = t;
    function v(e) {
        if (t.draggable) {
            "touchstart" === e.nativeEvent.type && e.nativeEvent.preventDefault(), u.didMove = !1, document.addEventListener("mousemove", _), document.addEventListener("mouseup", L), document.addEventListener("touchmove", _), document.addEventListener("touchend", L);
            const n = c.current;
            u.canCloseOnClick = !0, u.canDrag = !0, u.boundingRect = n.getBoundingClientRect(), n.style.transition = "", u.x = $8197fedcdf4bc40d$var$b(e.nativeEvent), u.y = $8197fedcdf4bc40d$var$I(e.nativeEvent), "x" === t.draggableDirection ? (u.start = u.x, u.removalDistance = n.offsetWidth * (t.draggablePercent / 100)) : (u.start = u.y, u.removalDistance = n.offsetHeight * (80 === t.draggablePercent ? 1.5 * t.draggablePercent : t.draggablePercent / 100));
        }
    }
    function T(e) {
        if (u.boundingRect) {
            const { top: n, bottom: o, left: s, right: a } = u.boundingRect;
            "touchend" !== e.nativeEvent.type && t.pauseOnHover && u.x >= s && u.x <= a && u.y >= n && u.y <= o ? C() : E();
        }
    }
    function E() {
        a(!0);
    }
    function C() {
        a(!1);
    }
    function _(e) {
        const n = c.current;
        u.canDrag && n && (u.didMove = !0, o && C(), u.x = $8197fedcdf4bc40d$var$b(e), u.y = $8197fedcdf4bc40d$var$I(e), u.delta = "x" === t.draggableDirection ? u.x - u.start : u.y - u.start, u.start !== u.x && (u.canCloseOnClick = !1), n.style.transform = `translate${t.draggableDirection}(${u.delta}px)`, n.style.opacity = "" + (1 - Math.abs(u.delta / u.removalDistance)));
    }
    function L() {
        document.removeEventListener("mousemove", _), document.removeEventListener("mouseup", L), document.removeEventListener("touchmove", _), document.removeEventListener("touchend", L);
        const e = c.current;
        if (u.canDrag && u.didMove && e) {
            if (u.canDrag = !1, Math.abs(u.delta) > u.removalDistance) return l(!0), void t.closeToast();
            e.style.transition = "transform 0.2s, opacity 0.2s", e.style.transform = `translate${t.draggableDirection}(0)`, e.style.opacity = "1";
        }
    }
    (0, $aOChP.useEffect)(()=>{
        d.current = t;
    }), (0, $aOChP.useEffect)(()=>(c.current && c.current.addEventListener("d", E, {
            once: !0
        }), $8197fedcdf4bc40d$var$p(t.onOpen) && t.onOpen((0, $aOChP.isValidElement)(t.children) && t.children.props), ()=>{
            const t = d.current;
            $8197fedcdf4bc40d$var$p(t.onClose) && t.onClose((0, $aOChP.isValidElement)(t.children) && t.children.props);
        }), []), (0, $aOChP.useEffect)(()=>(t.pauseOnFocusLoss && (document.hasFocus() || C(), window.addEventListener("focus", E), window.addEventListener("blur", C)), ()=>{
            t.pauseOnFocusLoss && (window.removeEventListener("focus", E), window.removeEventListener("blur", C));
        }), [
        t.pauseOnFocusLoss
    ]);
    const O = {
        onMouseDown: v,
        onTouchStart: v,
        onMouseUp: T,
        onTouchEnd: T
    };
    return m && f && (O.onMouseEnter = C, O.onMouseLeave = E), y && (O.onClick = (t)=>{
        h && h(t), u.canCloseOnClick && g();
    }), {
        playToast: E,
        pauseToast: C,
        isRunning: o,
        preventExitTransition: r,
        toastRef: c,
        eventHandlers: O
    };
}
function $8197fedcdf4bc40d$var$L(e) {
    let { closeToast: n, theme: o, ariaLabel: s = "close" } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (t)=>{
            t.stopPropagation(), n(t);
        },
        "aria-label": s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $8197fedcdf4bc40d$var$O(e) {
    let { delay: n, isRunning: o, closeToast: s, type: a = "default", hide: r, className: i, style: l, controlledProgress: u, progress: d, rtl: m, isIn: f, theme: g } = e;
    const h = r || u && 0 === d, y = {
        ...l,
        animationDuration: `${n}ms`,
        animationPlayState: o ? "running" : "paused",
        opacity: h ? 0 : 1
    };
    u && (y.transform = `scaleX(${d})`);
    const v = (0, $jDfgb.default)("Toastify__progress-bar", u ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${a}`, {
        "Toastify__progress-bar--rtl": m
    }), T = $8197fedcdf4bc40d$var$p(i) ? i({
        rtl: m,
        type: a,
        defaultClassName: v
    }) : (0, $jDfgb.default)(v, i);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement("div", {
        role: "progressbar",
        "aria-hidden": h ? "true" : "false",
        "aria-label": "notification timer",
        className: T,
        style: y,
        [u && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: u && d < 1 ? null : ()=>{
            f && s();
        }
    });
}
const $8197fedcdf4bc40d$var$N = (n)=>{
    const { isRunning: o, preventExitTransition: s, toastRef: r, eventHandlers: i } = $8197fedcdf4bc40d$export$a407b657d3044108(n), { closeButton: l, children: u, autoClose: d, onClick: m, type: f, hideProgressBar: g, closeToast: h, transition: y, position: v, className: T, style: E, bodyClassName: C, bodyStyle: b, progressClassName: I, progressStyle: N, updateId: M, role: R, progress: w, rtl: x, toastId: $, deleteToast: k, isIn: P, isLoading: B, iconOut: D, closeOnClick: A, theme: z } = n, F = (0, $jDfgb.default)("Toastify__toast", `Toastify__toast-theme--${z}`, `Toastify__toast--${f}`, {
        "Toastify__toast--rtl": x
    }, {
        "Toastify__toast--close-on-click": A
    }), H = $8197fedcdf4bc40d$var$p(T) ? T({
        rtl: x,
        position: v,
        type: f,
        defaultClassName: F
    }) : (0, $jDfgb.default)(F, T), S = !!w || !d, q = {
        closeToast: h,
        type: f,
        theme: z
    };
    let Q = null;
    return !1 === l || (Q = $8197fedcdf4bc40d$var$p(l) ? l(q) : (0, $aOChP.isValidElement)(l) ? (0, $aOChP.cloneElement)(l, q) : $8197fedcdf4bc40d$var$L(q)), (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement(y, {
        isIn: P,
        done: k,
        position: v,
        preventExitTransition: s,
        nodeRef: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement("div", {
        id: $,
        onClick: m,
        className: H,
        ...i,
        style: E,
        ref: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement("div", {
        ...P && {
            role: R
        },
        className: $8197fedcdf4bc40d$var$p(C) ? C({
            type: f
        }) : (0, $jDfgb.default)("Toastify__toast-body", C),
        style: b
    }, null != D && (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement("div", {
        className: (0, $jDfgb.default)("Toastify__toast-icon", {
            "Toastify--animate-icon Toastify__zoom-enter": !B
        })
    }, D), (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement("div", null, u)), Q, (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement($8197fedcdf4bc40d$var$O, {
        ...M && !S ? {
            key: `pb-${M}`
        } : {},
        rtl: x,
        theme: z,
        delay: d,
        isRunning: o,
        isIn: P,
        closeToast: h,
        hide: g,
        type: f,
        style: N,
        className: I,
        controlledProgress: S,
        progress: w || 0
    })));
}, $8197fedcdf4bc40d$var$M = function(t, e) {
    return void 0 === e && (e = !1), {
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: e
    };
}, $8197fedcdf4bc40d$export$d20e79fdc3899e95 = $8197fedcdf4bc40d$export$3ff7dc44d332d222($8197fedcdf4bc40d$var$M("bounce", !0)), $8197fedcdf4bc40d$export$d8dc01b5c85a37b9 = $8197fedcdf4bc40d$export$3ff7dc44d332d222($8197fedcdf4bc40d$var$M("slide", !0)), $8197fedcdf4bc40d$export$65cfd44a2050f99 = $8197fedcdf4bc40d$export$3ff7dc44d332d222($8197fedcdf4bc40d$var$M("zoom")), $8197fedcdf4bc40d$export$4d2fae537bd90431 = $8197fedcdf4bc40d$export$3ff7dc44d332d222($8197fedcdf4bc40d$var$M("flip")), $8197fedcdf4bc40d$export$f2815235e76a62b9 = (0, $aOChP.forwardRef)((e, n)=>{
    const { getToastToRender: o, containerRef: a, isToastActive: r } = $8197fedcdf4bc40d$export$b262e13ca2dd2381(e), { className: i, style: l, rtl: u, containerId: d } = e;
    function f(t) {
        const e = (0, $jDfgb.default)("Toastify__toast-container", `Toastify__toast-container--${t}`, {
            "Toastify__toast-container--rtl": u
        });
        return $8197fedcdf4bc40d$var$p(i) ? i({
            position: t,
            rtl: u,
            defaultClassName: e
        }) : (0, $jDfgb.default)(e, $8197fedcdf4bc40d$var$m(i));
    }
    return (0, $aOChP.useEffect)(()=>{
        n && (n.current = a.current);
    }, []), (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement("div", {
        ref: a,
        className: "Toastify",
        id: d
    }, o((e, n)=>{
        const o = n.length ? {
            ...l
        } : {
            ...l,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement("div", {
            className: f(e),
            style: o,
            key: `container-${e}`
        }, n.map((e, o)=>{
            let { content: s, props: a } = e;
            return (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement($8197fedcdf4bc40d$var$N, {
                ...a,
                isIn: r(a.toastId),
                style: {
                    ...a.style,
                    "--nth": o + 1,
                    "--len": n.length
                },
                key: `toast-${a.key}`
            }, s);
        }));
    }));
});
$8197fedcdf4bc40d$export$f2815235e76a62b9.displayName = "ToastContainer", $8197fedcdf4bc40d$export$f2815235e76a62b9.defaultProps = {
    position: "top-right",
    transition: $8197fedcdf4bc40d$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: $8197fedcdf4bc40d$var$L,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    closeOnClick: !0,
    draggable: !0,
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light"
};
let $8197fedcdf4bc40d$var$P, $8197fedcdf4bc40d$var$B = new Map, $8197fedcdf4bc40d$var$D = [], $8197fedcdf4bc40d$var$A = 1;
function $8197fedcdf4bc40d$var$z() {
    return "" + $8197fedcdf4bc40d$var$A++;
}
function $8197fedcdf4bc40d$var$F(t) {
    return t && ($8197fedcdf4bc40d$var$d(t.toastId) || $8197fedcdf4bc40d$var$u(t.toastId)) ? t.toastId : $8197fedcdf4bc40d$var$z();
}
function $8197fedcdf4bc40d$var$H(t, e) {
    return $8197fedcdf4bc40d$var$B.size > 0 ? $8197fedcdf4bc40d$var$v.emit(0, t, e) : $8197fedcdf4bc40d$var$D.push({
        content: t,
        options: e
    }), e.toastId;
}
function $8197fedcdf4bc40d$var$S(t, e) {
    return {
        ...e,
        type: e && e.type || t,
        toastId: $8197fedcdf4bc40d$var$F(e)
    };
}
function $8197fedcdf4bc40d$var$q(t) {
    return (e, n)=>$8197fedcdf4bc40d$var$H(e, $8197fedcdf4bc40d$var$S(t, n));
}
function $8197fedcdf4bc40d$export$b410431fab84fa58(t, e) {
    return $8197fedcdf4bc40d$var$H(t, $8197fedcdf4bc40d$var$S("default", e));
}
$8197fedcdf4bc40d$export$b410431fab84fa58.loading = (t, e)=>$8197fedcdf4bc40d$var$H(t, $8197fedcdf4bc40d$var$S("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...e
    })), $8197fedcdf4bc40d$export$b410431fab84fa58.promise = function(t, e, n) {
    let o, { pending: s, error: a, success: r } = e;
    s && (o = $8197fedcdf4bc40d$var$d(s) ? $8197fedcdf4bc40d$export$b410431fab84fa58.loading(s, n) : $8197fedcdf4bc40d$export$b410431fab84fa58.loading(s.render, {
        ...n,
        ...s
    }));
    const i = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, l = (t, e, s)=>{
        if (null == e) return void $8197fedcdf4bc40d$export$b410431fab84fa58.dismiss(o);
        const a = {
            type: t,
            ...i,
            ...n,
            data: s
        }, r = $8197fedcdf4bc40d$var$d(e) ? {
            render: e
        } : e;
        return o ? $8197fedcdf4bc40d$export$b410431fab84fa58.update(o, {
            ...a,
            ...r
        }) : $8197fedcdf4bc40d$export$b410431fab84fa58(r.render, {
            ...a,
            ...r
        }), s;
    }, c = $8197fedcdf4bc40d$var$p(t) ? t() : t;
    return c.then((t)=>l("success", r, t)).catch((t)=>l("error", a, t)), c;
}, $8197fedcdf4bc40d$export$b410431fab84fa58.success = $8197fedcdf4bc40d$var$q("success"), $8197fedcdf4bc40d$export$b410431fab84fa58.info = $8197fedcdf4bc40d$var$q("info"), $8197fedcdf4bc40d$export$b410431fab84fa58.error = $8197fedcdf4bc40d$var$q("error"), $8197fedcdf4bc40d$export$b410431fab84fa58.warning = $8197fedcdf4bc40d$var$q("warning"), $8197fedcdf4bc40d$export$b410431fab84fa58.warn = $8197fedcdf4bc40d$export$b410431fab84fa58.warning, $8197fedcdf4bc40d$export$b410431fab84fa58.dark = (t, e)=>$8197fedcdf4bc40d$var$H(t, $8197fedcdf4bc40d$var$S("default", {
        theme: "dark",
        ...e
    })), $8197fedcdf4bc40d$export$b410431fab84fa58.dismiss = (t)=>{
    $8197fedcdf4bc40d$var$B.size > 0 ? $8197fedcdf4bc40d$var$v.emit(1, t) : $8197fedcdf4bc40d$var$D = $8197fedcdf4bc40d$var$D.filter((e)=>null != t && e.options.toastId !== t);
}, $8197fedcdf4bc40d$export$b410431fab84fa58.clearWaitingQueue = function(t) {
    return void 0 === t && (t = {}), $8197fedcdf4bc40d$var$v.emit(5, t);
}, $8197fedcdf4bc40d$export$b410431fab84fa58.isActive = (t)=>{
    let e = !1;
    return $8197fedcdf4bc40d$var$B.forEach((n)=>{
        n.isToastActive && n.isToastActive(t) && (e = !0);
    }), e;
}, $8197fedcdf4bc40d$export$b410431fab84fa58.update = function(t, e) {
    void 0 === e && (e = {}), setTimeout(()=>{
        const n = function(t, e) {
            let { containerId: n } = e;
            const o = $8197fedcdf4bc40d$var$B.get(n || $8197fedcdf4bc40d$var$P);
            return o && o.getToast(t);
        }(t, e);
        if (n) {
            const { props: o, content: s } = n, a = {
                delay: 100,
                ...o,
                ...e,
                toastId: e.toastId || t,
                updateId: $8197fedcdf4bc40d$var$z()
            };
            a.toastId !== t && (a.staleId = t);
            const r = a.render || s;
            delete a.render, $8197fedcdf4bc40d$var$H(r, a);
        }
    }, 0);
}, $8197fedcdf4bc40d$export$b410431fab84fa58.done = (t)=>{
    $8197fedcdf4bc40d$export$b410431fab84fa58.update(t, {
        progress: 1
    });
}, $8197fedcdf4bc40d$export$b410431fab84fa58.onChange = (t)=>($8197fedcdf4bc40d$var$v.on(4, t), ()=>{
        $8197fedcdf4bc40d$var$v.off(4, t);
    }), $8197fedcdf4bc40d$export$b410431fab84fa58.POSITION = {
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right",
    TOP_CENTER: "top-center",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    BOTTOM_CENTER: "bottom-center"
}, $8197fedcdf4bc40d$export$b410431fab84fa58.TYPE = {
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error",
    DEFAULT: "default"
}, $8197fedcdf4bc40d$var$v.on(2, (t)=>{
    $8197fedcdf4bc40d$var$P = t.containerId || t, $8197fedcdf4bc40d$var$B.set($8197fedcdf4bc40d$var$P, t), $8197fedcdf4bc40d$var$D.forEach((t)=>{
        $8197fedcdf4bc40d$var$v.emit(0, t.content, t.options);
    }), $8197fedcdf4bc40d$var$D = [];
}).on(3, (t)=>{
    $8197fedcdf4bc40d$var$B.delete(t.containerId || t), 0 === $8197fedcdf4bc40d$var$B.size && $8197fedcdf4bc40d$var$v.off(0).off(1).off(5);
});

});
parcelRequire.register("jDfgb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4ad7f2d002355d2$export$2e2bcd8739ae039; });
function $e4ad7f2d002355d2$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $e4ad7f2d002355d2$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $e4ad7f2d002355d2$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $e4ad7f2d002355d2$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $e4ad7f2d002355d2$export$2e2bcd8739ae039 = $e4ad7f2d002355d2$export$4f5d2d50c9deca37;

});


parcelRequire.register("aITiR", function(module, exports) {

$parcel$export(module.exports, "addToCart", function () { return $7ce8e986601d6898$export$576b6dd9d68b37bc; });
$parcel$export(module.exports, "removeItem", function () { return $7ce8e986601d6898$export$fe2d9b4e03920b4c; });
$parcel$export(module.exports, "clearCart", function () { return $7ce8e986601d6898$export$810121176e3e3671; });
$parcel$export(module.exports, "cartReducer", function () { return $7ce8e986601d6898$export$458f39dd68da7b3f; });

var $id5hj = parcelRequire("id5hj");
const $7ce8e986601d6898$var$cartSlice = (0, $id5hj.createSlice)({
    name: "cart",
    initialState: {
        items: []
    },
    reducers: {
        addToCart: (state, action)=>{
            state.items.push(action.payload);
        },
        removeItem: (state, action)=>{
            const indexToRemove = state.items.findIndex((item)=>item.id === action.payload.id);
            if (indexToRemove !== -1) state.items.splice(indexToRemove, 1);
        },
        clearCart: (state)=>{
            state.items = [];
        }
    }
});
const { addToCart: $7ce8e986601d6898$export$576b6dd9d68b37bc, removeItem: $7ce8e986601d6898$export$fe2d9b4e03920b4c, clearCart: $7ce8e986601d6898$export$810121176e3e3671 } = $7ce8e986601d6898$var$cartSlice.actions;
const $7ce8e986601d6898$export$458f39dd68da7b3f = $7ce8e986601d6898$var$cartSlice.reducer;

});
parcelRequire.register("id5hj", function(module, exports) {
$parcel$export(module.exports, "applyMiddleware", function () { return (parcelRequire("eUXBH")).applyMiddleware; }, function (v) { return (parcelRequire("eUXBH")).applyMiddleware = v; });
$parcel$export(module.exports, "combineReducers", function () { return (parcelRequire("eUXBH")).combineReducers; }, function (v) { return (parcelRequire("eUXBH")).combineReducers = v; });
$parcel$export(module.exports, "compose", function () { return (parcelRequire("eUXBH")).compose; }, function (v) { return (parcelRequire("eUXBH")).compose = v; });
$parcel$export(module.exports, "createStore", function () { return (parcelRequire("eUXBH")).createStore; }, function (v) { return (parcelRequire("eUXBH")).createStore = v; });

$parcel$export(module.exports, "configureStore", function () { return $d41d890d6e8fb1db$export$7d8a5b498da695ac; });
$parcel$export(module.exports, "createSlice", function () { return $d41d890d6e8fb1db$export$4d8d9bd83c24ae8b; });

var $jAkSf = parcelRequire("jAkSf");

var $eUXBH = parcelRequire("eUXBH");

var $aeozL = parcelRequire("aeozL");

var $2LjeY = parcelRequire("2LjeY");

var $bDPlX = parcelRequire("bDPlX");
var $d41d890d6e8fb1db$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d41d890d6e8fb1db$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $d41d890d6e8fb1db$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $d41d890d6e8fb1db$var$__defProp = Object.defineProperty;
var $d41d890d6e8fb1db$var$__defProps = Object.defineProperties;
var $d41d890d6e8fb1db$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d41d890d6e8fb1db$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d41d890d6e8fb1db$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d41d890d6e8fb1db$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d41d890d6e8fb1db$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $d41d890d6e8fb1db$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $d41d890d6e8fb1db$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($d41d890d6e8fb1db$var$__hasOwnProp.call(b, prop)) $d41d890d6e8fb1db$var$__defNormalProp(a, prop, b[prop]);
    if ($d41d890d6e8fb1db$var$__getOwnPropSymbols) for(var _i = 0, _c = $d41d890d6e8fb1db$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($d41d890d6e8fb1db$var$__propIsEnum.call(b, prop)) $d41d890d6e8fb1db$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d41d890d6e8fb1db$var$__spreadProps = function(a, b) {
    return $d41d890d6e8fb1db$var$__defProps(a, $d41d890d6e8fb1db$var$__getOwnPropDescs(b));
};
var $d41d890d6e8fb1db$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $d41d890d6e8fb1db$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $aeozL.createSelector).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $d41d890d6e8fb1db$var$__spreadArray([
            (0, $jAkSf.isDraft)(value) ? (0, $jAkSf.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $d41d890d6e8fb1db$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $eUXBH.compose;
    return (0, $eUXBH.compose).apply(null, arguments);
};
var $d41d890d6e8fb1db$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $d41d890d6e8fb1db$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
function $d41d890d6e8fb1db$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $d41d890d6e8fb1db$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $d41d890d6e8fb1db$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $d41d890d6e8fb1db$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $d41d890d6e8fb1db$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $d41d890d6e8fb1db$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $d41d890d6e8fb1db$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $d41d890d6e8fb1db$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $d41d890d6e8fb1db$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $d41d890d6e8fb1db$var$freezeDraftable(val) {
    return (0, $jAkSf.isDraftable)(val) ? (0, $jAkSf.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $d41d890d6e8fb1db$var$isProduction = true;
var $d41d890d6e8fb1db$var$prefix = "Invariant failed";
function $d41d890d6e8fb1db$var$invariant(condition, message) {
    if (condition) return;
    if ($d41d890d6e8fb1db$var$isProduction) throw new Error($d41d890d6e8fb1db$var$prefix);
    throw new Error($d41d890d6e8fb1db$var$prefix + ": " + (message || ""));
}
function $d41d890d6e8fb1db$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $d41d890d6e8fb1db$var$getSerialize(serializer, decycler), indent);
}
function $d41d890d6e8fb1db$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $d41d890d6e8fb1db$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $d41d890d6e8fb1db$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $d41d890d6e8fb1db$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $d41d890d6e8fb1db$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $d41d890d6e8fb1db$var$trackProperties(isImmutable, ignorePaths, obj, path) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $d41d890d6e8fb1db$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $d41d890d6e8fb1db$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $d41d890d6e8fb1db$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $d41d890d6e8fb1db$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $d41d890d6e8fb1db$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $d41d890d6e8fb1db$export$53b83ca8eaab0383(val);
}
function $d41d890d6e8fb1db$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $d41d890d6e8fb1db$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $d41d890d6e8fb1db$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $d41d890d6e8fb1db$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $d41d890d6e8fb1db$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$d41d890d6e8fb1db$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $d41d890d6e8fb1db$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $d41d890d6e8fb1db$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $d41d890d6e8fb1db$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $d41d890d6e8fb1db$export$36c1185aeee5b0a6(options);
    };
}
function $d41d890d6e8fb1db$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e;
    var middlewareArray = new $d41d890d6e8fb1db$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($d41d890d6e8fb1db$var$isBoolean(thunk)) middlewareArray.push((0, $2LjeY.default));
        else middlewareArray.push((0, $2LjeY.default).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $d41d890d6e8fb1db$var$IS_PRODUCTION = true;
function $d41d890d6e8fb1db$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $d41d890d6e8fb1db$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($d41d890d6e8fb1db$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $eUXBH.combineReducers)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$d41d890d6e8fb1db$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$d41d890d6e8fb1db$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $eUXBH.applyMiddleware).apply(void 0, finalMiddleware);
    var finalCompose = (0, $eUXBH.compose);
    if (devTools) finalCompose = $d41d890d6e8fb1db$var$composeWithDevTools($d41d890d6e8fb1db$var$__spreadValues({
        trace: !$d41d890d6e8fb1db$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $d41d890d6e8fb1db$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $d41d890d6e8fb1db$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $eUXBH.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/createAction.ts
function $d41d890d6e8fb1db$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $d41d890d6e8fb1db$var$__spreadValues($d41d890d6e8fb1db$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $d41d890d6e8fb1db$export$b956e38827fca970(action) {
    return $d41d890d6e8fb1db$export$53b83ca8eaab0383(action) && "type" in action;
}
function $d41d890d6e8fb1db$export$ebd532f9034651f3(action) {
    return $d41d890d6e8fb1db$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($d41d890d6e8fb1db$var$isValidKey);
}
function $d41d890d6e8fb1db$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $d41d890d6e8fb1db$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/mapBuilders.ts
function $d41d890d6e8fb1db$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (type in actionsMap) throw new Error("addCase cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $d41d890d6e8fb1db$var$isStateFunction(x) {
    return typeof x === "function";
}
var $d41d890d6e8fb1db$var$hasWarnedAboutObjectNotation = false;
function $d41d890d6e8fb1db$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $d41d890d6e8fb1db$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($d41d890d6e8fb1db$var$isStateFunction(initialState)) getInitialState = function() {
        return $d41d890d6e8fb1db$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $d41d890d6e8fb1db$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $d41d890d6e8fb1db$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $jAkSf.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $jAkSf.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $jAkSf.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $d41d890d6e8fb1db$var$hasWarnedAboutObjectNotation2 = false;
function $d41d890d6e8fb1db$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $d41d890d6e8fb1db$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $bDPlX;
    var initialState = typeof options.initialState == "function" ? options.initialState : $d41d890d6e8fb1db$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $d41d890d6e8fb1db$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $d41d890d6e8fb1db$export$309c7a02b0b0bc62(type, prepareCallback) : $d41d890d6e8fb1db$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $d41d890d6e8fb1db$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $d41d890d6e8fb1db$var$__spreadValues($d41d890d6e8fb1db$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $d41d890d6e8fb1db$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $d41d890d6e8fb1db$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $d41d890d6e8fb1db$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($d41d890d6e8fb1db$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $d41d890d6e8fb1db$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $d41d890d6e8fb1db$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $d41d890d6e8fb1db$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $d41d890d6e8fb1db$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $d41d890d6e8fb1db$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $d41d890d6e8fb1db$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $d41d890d6e8fb1db$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $d41d890d6e8fb1db$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $d41d890d6e8fb1db$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $d41d890d6e8fb1db$var$createSingleArgumentStateOperator(mutator) {
    var operator = $d41d890d6e8fb1db$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $d41d890d6e8fb1db$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $d41d890d6e8fb1db$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $jAkSf.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $jAkSf.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $d41d890d6e8fb1db$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $d41d890d6e8fb1db$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $d41d890d6e8fb1db$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $d41d890d6e8fb1db$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $d41d890d6e8fb1db$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $d41d890d6e8fb1db$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $d41d890d6e8fb1db$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $d41d890d6e8fb1db$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $d41d890d6e8fb1db$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d41d890d6e8fb1db$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d41d890d6e8fb1db$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $d41d890d6e8fb1db$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $d41d890d6e8fb1db$var$__spreadValues($d41d890d6e8fb1db$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $d41d890d6e8fb1db$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $d41d890d6e8fb1db$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $d41d890d6e8fb1db$var$createStateOperator(addOneMutably),
        addMany: $d41d890d6e8fb1db$var$createStateOperator(addManyMutably),
        setOne: $d41d890d6e8fb1db$var$createStateOperator(setOneMutably),
        setMany: $d41d890d6e8fb1db$var$createStateOperator(setManyMutably),
        setAll: $d41d890d6e8fb1db$var$createStateOperator(setAllMutably),
        updateOne: $d41d890d6e8fb1db$var$createStateOperator(updateOneMutably),
        updateMany: $d41d890d6e8fb1db$var$createStateOperator(updateManyMutably),
        upsertOne: $d41d890d6e8fb1db$var$createStateOperator(upsertOneMutably),
        upsertMany: $d41d890d6e8fb1db$var$createStateOperator(upsertManyMutably),
        removeOne: $d41d890d6e8fb1db$var$createStateOperator(removeOneMutably),
        removeMany: $d41d890d6e8fb1db$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $d41d890d6e8fb1db$var$createSortedStateAdapter(selectId, sort) {
    var _c = $d41d890d6e8fb1db$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $d41d890d6e8fb1db$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($d41d890d6e8fb1db$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d41d890d6e8fb1db$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d41d890d6e8fb1db$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $d41d890d6e8fb1db$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $d41d890d6e8fb1db$var$createStateOperator(addOneMutably),
        updateOne: $d41d890d6e8fb1db$var$createStateOperator(updateOneMutably),
        upsertOne: $d41d890d6e8fb1db$var$createStateOperator(upsertOneMutably),
        setOne: $d41d890d6e8fb1db$var$createStateOperator(setOneMutably),
        setMany: $d41d890d6e8fb1db$var$createStateOperator(setManyMutably),
        setAll: $d41d890d6e8fb1db$var$createStateOperator(setAllMutably),
        addMany: $d41d890d6e8fb1db$var$createStateOperator(addManyMutably),
        updateMany: $d41d890d6e8fb1db$var$createStateOperator(updateManyMutably),
        upsertMany: $d41d890d6e8fb1db$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $d41d890d6e8fb1db$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $d41d890d6e8fb1db$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $d41d890d6e8fb1db$var$createInitialStateFactory();
    var selectorsFactory = $d41d890d6e8fb1db$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $d41d890d6e8fb1db$var$createSortedStateAdapter(selectId, sortComparer) : $d41d890d6e8fb1db$var$createUnsortedStateAdapter(selectId);
    return $d41d890d6e8fb1db$var$__spreadValues($d41d890d6e8fb1db$var$__spreadValues($d41d890d6e8fb1db$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $d41d890d6e8fb1db$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $d41d890d6e8fb1db$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $d41d890d6e8fb1db$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $d41d890d6e8fb1db$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $d41d890d6e8fb1db$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $d41d890d6e8fb1db$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $d41d890d6e8fb1db$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $d41d890d6e8fb1db$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $d41d890d6e8fb1db$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $d41d890d6e8fb1db$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $d41d890d6e8fb1db$var$__spreadProps($d41d890d6e8fb1db$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $d41d890d6e8fb1db$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $d41d890d6e8fb1db$var$__spreadProps($d41d890d6e8fb1db$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $d41d890d6e8fb1db$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $d41d890d6e8fb1db$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $d41d890d6e8fb1db$var$__spreadProps($d41d890d6e8fb1db$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $d41d890d6e8fb1db$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $d41d890d6e8fb1db$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $d41d890d6e8fb1db$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$d41d890d6e8fb1db$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $d41d890d6e8fb1db$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $d41d890d6e8fb1db$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $d41d890d6e8fb1db$var$RejectWithValue) throw result;
                                                if (result instanceof $d41d890d6e8fb1db$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $d41d890d6e8fb1db$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($d41d890d6e8fb1db$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $d41d890d6e8fb1db$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $d41d890d6e8fb1db$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/tsHelpers.ts
var $d41d890d6e8fb1db$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/matchers.ts
var $d41d890d6e8fb1db$var$matches = function(matcher, action) {
    if ($d41d890d6e8fb1db$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $d41d890d6e8fb1db$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $d41d890d6e8fb1db$var$matches(matcher, action);
        });
    };
}
function $d41d890d6e8fb1db$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $d41d890d6e8fb1db$var$matches(matcher, action);
        });
    };
}
function $d41d890d6e8fb1db$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $d41d890d6e8fb1db$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $d41d890d6e8fb1db$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $d41d890d6e8fb1db$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$d41d890d6e8fb1db$var$isAsyncThunkArray(asyncThunks)) return $d41d890d6e8fb1db$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $d41d890d6e8fb1db$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $d41d890d6e8fb1db$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $d41d890d6e8fb1db$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$d41d890d6e8fb1db$var$isAsyncThunkArray(asyncThunks)) return $d41d890d6e8fb1db$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $d41d890d6e8fb1db$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $d41d890d6e8fb1db$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $d41d890d6e8fb1db$export$9dd1fb32974da385($d41d890d6e8fb1db$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$d41d890d6e8fb1db$var$isAsyncThunkArray(asyncThunks)) return $d41d890d6e8fb1db$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $d41d890d6e8fb1db$export$9dd1fb32974da385($d41d890d6e8fb1db$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $d41d890d6e8fb1db$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $d41d890d6e8fb1db$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$d41d890d6e8fb1db$var$isAsyncThunkArray(asyncThunks)) return $d41d890d6e8fb1db$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $d41d890d6e8fb1db$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $d41d890d6e8fb1db$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $d41d890d6e8fb1db$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$d41d890d6e8fb1db$var$isAsyncThunkArray(asyncThunks)) return $d41d890d6e8fb1db$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $d41d890d6e8fb1db$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $d41d890d6e8fb1db$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $d41d890d6e8fb1db$var$noop = function() {};
var $d41d890d6e8fb1db$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $d41d890d6e8fb1db$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $d41d890d6e8fb1db$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $d41d890d6e8fb1db$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $d41d890d6e8fb1db$var$task = "task";
var $d41d890d6e8fb1db$var$listener = "listener";
var $d41d890d6e8fb1db$var$completed = "completed";
var $d41d890d6e8fb1db$var$cancelled = "cancelled";
var $d41d890d6e8fb1db$var$taskCancelled = "task-" + $d41d890d6e8fb1db$var$cancelled;
var $d41d890d6e8fb1db$var$taskCompleted = "task-" + $d41d890d6e8fb1db$var$completed;
var $d41d890d6e8fb1db$var$listenerCancelled = $d41d890d6e8fb1db$var$listener + "-" + $d41d890d6e8fb1db$var$cancelled;
var $d41d890d6e8fb1db$var$listenerCompleted = $d41d890d6e8fb1db$var$listener + "-" + $d41d890d6e8fb1db$var$completed;
var $d41d890d6e8fb1db$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $d41d890d6e8fb1db$var$task + " " + $d41d890d6e8fb1db$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $d41d890d6e8fb1db$var$validateActive = function(signal) {
    if (signal.aborted) throw new $d41d890d6e8fb1db$export$cb1bdac908fed7f(signal.reason);
};
function $d41d890d6e8fb1db$var$raceWithSignal(signal, promise2) {
    var cleanup = $d41d890d6e8fb1db$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $d41d890d6e8fb1db$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $d41d890d6e8fb1db$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $d41d890d6e8fb1db$var$noop;
    });
}
var $d41d890d6e8fb1db$var$runTask = function(task2, cleanUp) {
    return $d41d890d6e8fb1db$var$__async(void 0, null, function() {
        var value, error_1;
        return $d41d890d6e8fb1db$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $d41d890d6e8fb1db$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $d41d890d6e8fb1db$var$createPause = function(signal) {
    return function(promise2) {
        return $d41d890d6e8fb1db$var$catchRejection($d41d890d6e8fb1db$var$raceWithSignal(signal, promise2).then(function(output) {
            $d41d890d6e8fb1db$var$validateActive(signal);
            return output;
        }));
    };
};
var $d41d890d6e8fb1db$var$createDelay = function(signal) {
    var pause = $d41d890d6e8fb1db$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $d41d890d6e8fb1db$var$assign = Object.assign;
var $d41d890d6e8fb1db$var$INTERNAL_NIL_TOKEN = {};
var $d41d890d6e8fb1db$var$alm = "listenerMiddleware";
var $d41d890d6e8fb1db$var$createFork = function(parentAbortSignal) {
    var linkControllers = function(controller) {
        return $d41d890d6e8fb1db$var$addAbortSignalListener(parentAbortSignal, function() {
            return $d41d890d6e8fb1db$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor) {
        $d41d890d6e8fb1db$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $d41d890d6e8fb1db$var$runTask(function() {
            return $d41d890d6e8fb1db$var$__async(void 0, null, function() {
                var result2;
                return $d41d890d6e8fb1db$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $d41d890d6e8fb1db$var$validateActive(parentAbortSignal);
                            $d41d890d6e8fb1db$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $d41d890d6e8fb1db$var$createPause(childAbortController.signal),
                                    delay: $d41d890d6e8fb1db$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $d41d890d6e8fb1db$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $d41d890d6e8fb1db$var$abortControllerWithReason(childAbortController, $d41d890d6e8fb1db$var$taskCompleted);
        });
        return {
            result: $d41d890d6e8fb1db$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $d41d890d6e8fb1db$var$abortControllerWithReason(childAbortController, $d41d890d6e8fb1db$var$taskCancelled);
            }
        };
    };
};
var $d41d890d6e8fb1db$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $d41d890d6e8fb1db$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $d41d890d6e8fb1db$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $d41d890d6e8fb1db$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $d41d890d6e8fb1db$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $d41d890d6e8fb1db$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $d41d890d6e8fb1db$var$catchRejection(take(predicate, timeout));
    };
};
var $d41d890d6e8fb1db$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $d41d890d6e8fb1db$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $d41d890d6e8fb1db$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $d41d890d6e8fb1db$var$createListenerEntry = function(options) {
    var _c = $d41d890d6e8fb1db$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $d41d890d6e8fb1db$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $d41d890d6e8fb1db$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $d41d890d6e8fb1db$var$abortControllerWithReason(controller, $d41d890d6e8fb1db$var$listenerCancelled);
    });
};
var $d41d890d6e8fb1db$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($d41d890d6e8fb1db$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $d41d890d6e8fb1db$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $d41d890d6e8fb1db$export$f03a6b845d3fb58b = $d41d890d6e8fb1db$export$309c7a02b0b0bc62($d41d890d6e8fb1db$var$alm + "/add");
var $d41d890d6e8fb1db$export$b1b8022855fb2b71 = $d41d890d6e8fb1db$export$309c7a02b0b0bc62($d41d890d6e8fb1db$var$alm + "/removeAll");
var $d41d890d6e8fb1db$export$b03e9483f936dccb = $d41d890d6e8fb1db$export$309c7a02b0b0bc62($d41d890d6e8fb1db$var$alm + "/remove");
var $d41d890d6e8fb1db$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $d41d890d6e8fb1db$var$__spreadArray([
        $d41d890d6e8fb1db$var$alm + "/error"
    ], args));
};
function $d41d890d6e8fb1db$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $d41d890d6e8fb1db$var$defaultErrorHandler : _c;
    $d41d890d6e8fb1db$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $d41d890d6e8fb1db$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $d41d890d6e8fb1db$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $d41d890d6e8fb1db$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $d41d890d6e8fb1db$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $d41d890d6e8fb1db$var$__async(_this, null, function() {
            var internalTaskController, take, listenerError_1;
            return $d41d890d6e8fb1db$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $d41d890d6e8fb1db$var$createTakePattern(startListening, internalTaskController.signal);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $d41d890d6e8fb1db$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $d41d890d6e8fb1db$var$createDelay(internalTaskController.signal),
                                pause: $d41d890d6e8fb1db$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $d41d890d6e8fb1db$var$createFork(internalTaskController.signal),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $d41d890d6e8fb1db$var$abortControllerWithReason(controller, $d41d890d6e8fb1db$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $d41d890d6e8fb1db$export$cb1bdac908fed7f)) $d41d890d6e8fb1db$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        $d41d890d6e8fb1db$var$abortControllerWithReason(internalTaskController, $d41d890d6e8fb1db$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $d41d890d6e8fb1db$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$d41d890d6e8fb1db$export$b956e38827fca970(action)) return next(action);
                if ($d41d890d6e8fb1db$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($d41d890d6e8fb1db$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($d41d890d6e8fb1db$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $d41d890d6e8fb1db$var$INTERNAL_NIL_TOKEN) throw new Error($d41d890d6e8fb1db$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $d41d890d6e8fb1db$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $d41d890d6e8fb1db$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $d41d890d6e8fb1db$export$8fb31c0f05df007b = "RTK_autoBatch";
var $d41d890d6e8fb1db$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$d41d890d6e8fb1db$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $d41d890d6e8fb1db$var$promise;
var $d41d890d6e8fb1db$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($d41d890d6e8fb1db$var$promise || ($d41d890d6e8fb1db$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $d41d890d6e8fb1db$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $d41d890d6e8fb1db$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $d41d890d6e8fb1db$var$createQueueWithTimer(10);
var $d41d890d6e8fb1db$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $d41d890d6e8fb1db$var$queueMicrotaskShim : options.type === "raf" ? $d41d890d6e8fb1db$var$rAF : options.type === "callback" ? options.queueNotification : $d41d890d6e8fb1db$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$d41d890d6e8fb1db$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $jAkSf.enableES5)();

});
parcelRequire.register("jAkSf", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return $e421923b698260e6$export$541ac630993a4c84; });
$parcel$export(module.exports, "isDraftable", function () { return $e421923b698260e6$export$16e3aed3edb85946; });
$parcel$export(module.exports, "current", function () { return $e421923b698260e6$export$97aac956da55dae9; });
$parcel$export(module.exports, "enableES5", function () { return $e421923b698260e6$export$56771cf63ee491f5; });
$parcel$export(module.exports, "default", function () { return $e421923b698260e6$export$2e2bcd8739ae039; });
function $e421923b698260e6$var$n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function $e421923b698260e6$export$541ac630993a4c84(n) {
    return !!n && !!n[$e421923b698260e6$var$Q];
}
function $e421923b698260e6$export$16e3aed3edb85946(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === $e421923b698260e6$var$Z;
    }(n) || Array.isArray(n) || !!n[$e421923b698260e6$export$6ee2082928bcb0ee] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[$e421923b698260e6$export$6ee2082928bcb0ee]) || $e421923b698260e6$var$s(n) || $e421923b698260e6$var$v(n));
}
function $e421923b698260e6$export$22e8af3f75a010e3(t) {
    return $e421923b698260e6$export$541ac630993a4c84(t) || $e421923b698260e6$var$n(23, t), t[$e421923b698260e6$var$Q].t;
}
function $e421923b698260e6$var$i(n, r, t) {
    void 0 === t && (t = !1), 0 === $e421923b698260e6$var$o(n) ? (t ? Object.keys : $e421923b698260e6$var$nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function $e421923b698260e6$var$o(n) {
    var r = n[$e421923b698260e6$var$Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : $e421923b698260e6$var$s(n) ? 2 : $e421923b698260e6$var$v(n) ? 3 : 0;
}
function $e421923b698260e6$var$u(n, r) {
    return 2 === $e421923b698260e6$var$o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function $e421923b698260e6$var$a(n, r) {
    return 2 === $e421923b698260e6$var$o(n) ? n.get(r) : n[r];
}
function $e421923b698260e6$var$f(n, r, t) {
    var e = $e421923b698260e6$var$o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function $e421923b698260e6$var$c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function $e421923b698260e6$var$s(n) {
    return $e421923b698260e6$var$X && n instanceof Map;
}
function $e421923b698260e6$var$v(n) {
    return $e421923b698260e6$var$q && n instanceof Set;
}
function $e421923b698260e6$var$p(n) {
    return n.o || n.t;
}
function $e421923b698260e6$var$l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = $e421923b698260e6$var$rn(n);
    delete r[$e421923b698260e6$var$Q];
    for(var t = $e421923b698260e6$var$nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function $e421923b698260e6$export$792f3d81ea979f55(n, e) {
    return void 0 === e && (e = !1), $e421923b698260e6$var$y(n) || $e421923b698260e6$export$541ac630993a4c84(n) || !$e421923b698260e6$export$16e3aed3edb85946(n) || ($e421923b698260e6$var$o(n) > 1 && (n.set = n.add = n.clear = n.delete = $e421923b698260e6$var$h), Object.freeze(n), e && $e421923b698260e6$var$i(n, function(n, r) {
        return $e421923b698260e6$export$792f3d81ea979f55(r, !0);
    }, !0)), n;
}
function $e421923b698260e6$var$h() {
    $e421923b698260e6$var$n(2);
}
function $e421923b698260e6$var$y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function $e421923b698260e6$var$b(r) {
    var t = $e421923b698260e6$var$tn[r];
    return t || $e421923b698260e6$var$n(18, r), t;
}
function $e421923b698260e6$var$m(n, r) {
    $e421923b698260e6$var$tn[n] || ($e421923b698260e6$var$tn[n] = r);
}
function $e421923b698260e6$var$_() {
    return $e421923b698260e6$var$U;
}
function $e421923b698260e6$var$j(n, r) {
    r && ($e421923b698260e6$var$b("Patches"), n.u = [], n.s = [], n.v = r);
}
function $e421923b698260e6$var$g(n) {
    $e421923b698260e6$var$O(n), n.p.forEach($e421923b698260e6$var$S), n.p = null;
}
function $e421923b698260e6$var$O(n) {
    n === $e421923b698260e6$var$U && ($e421923b698260e6$var$U = n.l);
}
function $e421923b698260e6$var$w(n) {
    return $e421923b698260e6$var$U = {
        p: [],
        l: $e421923b698260e6$var$U,
        h: n,
        m: !0,
        _: 0
    };
}
function $e421923b698260e6$var$S(n) {
    var r = n[$e421923b698260e6$var$Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function $e421923b698260e6$var$P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || $e421923b698260e6$var$b("ES5").S(e, r, o), o ? (i[$e421923b698260e6$var$Q].P && ($e421923b698260e6$var$g(e), $e421923b698260e6$var$n(4)), $e421923b698260e6$export$16e3aed3edb85946(r) && (r = $e421923b698260e6$var$M(e, r), e.l || $e421923b698260e6$var$x(e, r)), e.u && $e421923b698260e6$var$b("Patches").M(i[$e421923b698260e6$var$Q].t, r, e.u, e.s)) : r = $e421923b698260e6$var$M(e, i, []), $e421923b698260e6$var$g(e), e.u && e.v(e.u, e.s), r !== $e421923b698260e6$export$45b790e32b2810ee ? r : void 0;
}
function $e421923b698260e6$var$M(n, r, t) {
    if ($e421923b698260e6$var$y(r)) return r;
    var e = r[$e421923b698260e6$var$Q];
    if (!e) return $e421923b698260e6$var$i(r, function(i, o) {
        return $e421923b698260e6$var$A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return $e421923b698260e6$var$x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = $e421923b698260e6$var$l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), $e421923b698260e6$var$i(u, function(r, i) {
            return $e421923b698260e6$var$A(n, e, o, r, i, t, a);
        }), $e421923b698260e6$var$x(n, o, !1), t && n.u && $e421923b698260e6$var$b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function $e421923b698260e6$var$A(e, i, o, a, c, s, v) {
    if ($e421923b698260e6$export$541ac630993a4c84(c)) {
        var p = $e421923b698260e6$var$M(e, c, s && i && 3 !== i.i && !$e421923b698260e6$var$u(i.R, a) ? s.concat(a) : void 0);
        if ($e421923b698260e6$var$f(o, a, p), !$e421923b698260e6$export$541ac630993a4c84(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if ($e421923b698260e6$export$16e3aed3edb85946(c) && !$e421923b698260e6$var$y(c)) {
        if (!e.h.D && e._ < 1) return;
        $e421923b698260e6$var$M(e, c), i && i.A.l || $e421923b698260e6$var$x(e, c);
    }
}
function $e421923b698260e6$var$x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && $e421923b698260e6$export$792f3d81ea979f55(r, t);
}
function $e421923b698260e6$var$z(n, r) {
    var t = n[$e421923b698260e6$var$Q];
    return (t ? $e421923b698260e6$var$p(t) : n)[r];
}
function $e421923b698260e6$var$I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function $e421923b698260e6$var$k(n) {
    n.P || (n.P = !0, n.l && $e421923b698260e6$var$k(n.l));
}
function $e421923b698260e6$var$E(n) {
    n.o || (n.o = $e421923b698260e6$var$l(n.t));
}
function $e421923b698260e6$var$N(n, r, t) {
    var e = $e421923b698260e6$var$s(r) ? $e421923b698260e6$var$b("MapSet").F(r, t) : $e421923b698260e6$var$v(r) ? $e421923b698260e6$var$b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : $e421923b698260e6$var$_(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = $e421923b698260e6$var$en;
        t && (i = [
            e
        ], o = $e421923b698260e6$var$on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : $e421923b698260e6$var$b("ES5").J(r, t);
    return (t ? t.A : $e421923b698260e6$var$_()).p.push(e), e;
}
function $e421923b698260e6$export$97aac956da55dae9(e) {
    return $e421923b698260e6$export$541ac630993a4c84(e) || $e421923b698260e6$var$n(22, e), function n(r) {
        if (!$e421923b698260e6$export$16e3aed3edb85946(r)) return r;
        var e, u = r[$e421923b698260e6$var$Q], c = $e421923b698260e6$var$o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !$e421923b698260e6$var$b("ES5").K(u))) return u.t;
            u.I = !0, e = $e421923b698260e6$var$D(r, c), u.I = !1;
        } else e = $e421923b698260e6$var$D(r, c);
        return $e421923b698260e6$var$i(e, function(r, t) {
            u && $e421923b698260e6$var$a(u.t, r) === t || $e421923b698260e6$var$f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function $e421923b698260e6$var$D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return $e421923b698260e6$var$l(n);
}
function $e421923b698260e6$export$56771cf63ee491f5() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[$e421923b698260e6$var$Q];
                return $e421923b698260e6$var$en.get(r, n);
            },
            set: function(r) {
                var t = this[$e421923b698260e6$var$Q];
                $e421923b698260e6$var$en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][$e421923b698260e6$var$Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && $e421923b698260e6$var$k(t);
                    break;
                case 4:
                    o(t) && $e421923b698260e6$var$k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = $e421923b698260e6$var$nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== $e421923b698260e6$var$Q) {
                var a = r[o];
                if (void 0 === a && !$e421923b698260e6$var$u(r, o)) return !0;
                var f = t[o], s = f && f[$e421923b698260e6$var$Q];
                if (s ? s.t !== a : !$e421923b698260e6$var$c(f, a)) return !0;
            }
        }
        var v = !!r[$e421923b698260e6$var$Q];
        return e.length !== $e421923b698260e6$var$nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && $e421923b698260e6$var$n(3, JSON.stringify($e421923b698260e6$var$p(r)));
    }
    var s = {};
    $e421923b698260e6$var$m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = $e421923b698260e6$var$rn(r);
                delete o[$e421923b698260e6$var$Q];
                for(var u = $e421923b698260e6$var$nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : $e421923b698260e6$var$_(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, $e421923b698260e6$var$Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? $e421923b698260e6$export$541ac630993a4c84(t) && t[$e421923b698260e6$var$Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[$e421923b698260e6$var$Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) $e421923b698260e6$var$i(o, function(r) {
                            r !== $e421923b698260e6$var$Q && (void 0 !== e[r] || $e421923b698260e6$var$u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, $e421923b698260e6$var$k(t)));
                        }), $e421923b698260e6$var$i(e, function(n) {
                            void 0 !== o[n] || $e421923b698260e6$var$u(o, n) || (f[n] = !1, $e421923b698260e6$var$k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && ($e421923b698260e6$var$k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function $e421923b698260e6$export$d3a6659991a0696c() {
    function e(n) {
        if (!$e421923b698260e6$export$16e3aed3edb85946(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if ($e421923b698260e6$var$s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if ($e421923b698260e6$var$v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return $e421923b698260e6$var$u(n, $e421923b698260e6$export$6ee2082928bcb0ee) && (r[$e421923b698260e6$export$6ee2082928bcb0ee] = n[$e421923b698260e6$export$6ee2082928bcb0ee]), r;
    }
    function f(n) {
        return $e421923b698260e6$export$541ac630993a4c84(n) ? e(n) : n;
    }
    var c = "add";
    $e421923b698260e6$var$m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = $e421923b698260e6$var$o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || $e421923b698260e6$var$n(24), "function" == typeof f && "prototype" === p && $e421923b698260e6$var$n(24), "object" != typeof (f = $e421923b698260e6$var$a(f, p)) && $e421923b698260e6$var$n(15, i.join("/"));
                }
                var l = $e421923b698260e6$var$o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                $e421923b698260e6$var$n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        $e421923b698260e6$var$n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        $e421923b698260e6$var$i(n.R, function(n, i) {
                            var v = $e421923b698260e6$var$a(o, n), p = $e421923b698260e6$var$a(s, n), l = i ? $e421923b698260e6$var$u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === $e421923b698260e6$export$45b790e32b2810ee ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function $e421923b698260e6$export$7d9f65390203b435() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if ($e421923b698260e6$export$16e3aed3edb85946(r)) {
                var e = $e421923b698260e6$var$N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && $e421923b698260e6$var$n(3, JSON.stringify($e421923b698260e6$var$p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[$e421923b698260e6$var$Q] = {
                i: 2,
                l: r,
                A: r ? r.A : $e421923b698260e6$var$_(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return $e421923b698260e6$var$p(this[$e421923b698260e6$var$Q]).size;
            }
        }), o.has = function(n) {
            return $e421923b698260e6$var$p(this[$e421923b698260e6$var$Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[$e421923b698260e6$var$Q];
            return u(t), $e421923b698260e6$var$p(t).has(n) && $e421923b698260e6$var$p(t).get(n) === r || (e(t), $e421923b698260e6$var$k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[$e421923b698260e6$var$Q];
            return u(r), e(r), $e421923b698260e6$var$k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[$e421923b698260e6$var$Q];
            u(n), $e421923b698260e6$var$p(n).size && (e(n), $e421923b698260e6$var$k(n), n.R = new Map, $e421923b698260e6$var$i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            $e421923b698260e6$var$p(this[$e421923b698260e6$var$Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[$e421923b698260e6$var$Q];
            u(r);
            var i = $e421923b698260e6$var$p(r).get(n);
            if (r.I || !$e421923b698260e6$export$16e3aed3edb85946(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = $e421923b698260e6$var$N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return $e421923b698260e6$var$p(this[$e421923b698260e6$var$Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[$e421923b698260e6$var$V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[$e421923b698260e6$var$V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[$e421923b698260e6$var$V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[$e421923b698260e6$var$Q] = {
                i: 3,
                l: r,
                A: r ? r.A : $e421923b698260e6$var$_(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return $e421923b698260e6$var$p(this[$e421923b698260e6$var$Q]).size;
            }
        }), t.has = function(n) {
            var r = this[$e421923b698260e6$var$Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[$e421923b698260e6$var$Q];
            return u(r), this.has(n) || (o(r), $e421923b698260e6$var$k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[$e421923b698260e6$var$Q];
            return u(r), o(r), $e421923b698260e6$var$k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[$e421923b698260e6$var$Q];
            u(n), $e421923b698260e6$var$p(n).size && (o(n), $e421923b698260e6$var$k(n), n.o.clear());
        }, t.values = function() {
            var n = this[$e421923b698260e6$var$Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[$e421923b698260e6$var$Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[$e421923b698260e6$var$V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    $e421923b698260e6$var$m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function $e421923b698260e6$export$cae049b67c7d1bc9() {
    $e421923b698260e6$export$56771cf63ee491f5(), $e421923b698260e6$export$7d9f65390203b435(), $e421923b698260e6$export$d3a6659991a0696c();
}
function $e421923b698260e6$export$c05b21e3257751e5(n) {
    return n;
}
function $e421923b698260e6$export$20f911b3f8cf0b74(n) {
    return n;
}
var $e421923b698260e6$var$G, $e421923b698260e6$var$U, $e421923b698260e6$var$W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), $e421923b698260e6$var$X = "undefined" != typeof Map, $e421923b698260e6$var$q = "undefined" != typeof Set, $e421923b698260e6$var$B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, $e421923b698260e6$export$45b790e32b2810ee = $e421923b698260e6$var$W ? Symbol.for("immer-nothing") : (($e421923b698260e6$var$G = {})["immer-nothing"] = !0, $e421923b698260e6$var$G), $e421923b698260e6$export$6ee2082928bcb0ee = $e421923b698260e6$var$W ? Symbol.for("immer-draftable") : "__$immer_draftable", $e421923b698260e6$var$Q = $e421923b698260e6$var$W ? Symbol.for("immer-state") : "__$immer_state", $e421923b698260e6$var$V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", $e421923b698260e6$var$Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, $e421923b698260e6$var$Z = "" + Object.prototype.constructor, $e421923b698260e6$var$nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, $e421923b698260e6$var$rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return $e421923b698260e6$var$nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, $e421923b698260e6$var$tn = {}, $e421923b698260e6$var$en = {
    get: function(n, r) {
        if (r === $e421923b698260e6$var$Q) return n;
        var e = $e421923b698260e6$var$p(n);
        if (!$e421923b698260e6$var$u(e, r)) return function(n, r, t) {
            var e, i = $e421923b698260e6$var$I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !$e421923b698260e6$export$16e3aed3edb85946(i) ? i : i === $e421923b698260e6$var$z(n.t, r) ? ($e421923b698260e6$var$E(n), n.o[r] = $e421923b698260e6$var$N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in $e421923b698260e6$var$p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys($e421923b698260e6$var$p(n));
    },
    set: function(n, r, t) {
        var e = $e421923b698260e6$var$I($e421923b698260e6$var$p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = $e421923b698260e6$var$z($e421923b698260e6$var$p(n), r), o = null == i ? void 0 : i[$e421923b698260e6$var$Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if ($e421923b698260e6$var$c(t, i) && (void 0 !== t || $e421923b698260e6$var$u(n.t, r))) return !0;
            $e421923b698260e6$var$E(n), $e421923b698260e6$var$k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== $e421923b698260e6$var$z(n.t, r) || r in n.t ? (n.R[r] = !1, $e421923b698260e6$var$E(n), $e421923b698260e6$var$k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = $e421923b698260e6$var$p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        $e421923b698260e6$var$n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        $e421923b698260e6$var$n(12);
    }
}, $e421923b698260e6$var$on = {};
$e421923b698260e6$var$i($e421923b698260e6$var$en, function(n, r) {
    $e421923b698260e6$var$on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), $e421923b698260e6$var$on.deleteProperty = function(r, t) {
    return $e421923b698260e6$var$on.set.call(this, r, t, void 0);
}, $e421923b698260e6$var$on.set = function(r, t, e) {
    return $e421923b698260e6$var$en.set.call(this, r[0], t, e, r[0]);
};
var $e421923b698260e6$export$aaadc6ff0f822719 = function() {
    function e(r) {
        var e = this;
        this.O = $e421923b698260e6$var$B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && $e421923b698260e6$var$n(6), void 0 !== o && "function" != typeof o && $e421923b698260e6$var$n(7), $e421923b698260e6$export$16e3aed3edb85946(r)) {
                var c = $e421923b698260e6$var$w(e), s = $e421923b698260e6$var$N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? $e421923b698260e6$var$g(c) : $e421923b698260e6$var$O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return $e421923b698260e6$var$j(c, o), $e421923b698260e6$var$P(n, c);
                }, function(n) {
                    throw $e421923b698260e6$var$g(c), n;
                }) : ($e421923b698260e6$var$j(c, o), $e421923b698260e6$var$P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === $e421923b698260e6$export$45b790e32b2810ee && (f = void 0), e.D && $e421923b698260e6$export$792f3d81ea979f55(f, !0), o) {
                    var p = [], l = [];
                    $e421923b698260e6$var$b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            $e421923b698260e6$var$n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        $e421923b698260e6$export$16e3aed3edb85946(e) || $e421923b698260e6$var$n(8), $e421923b698260e6$export$541ac630993a4c84(e) && (e = $e421923b698260e6$export$97aac956da55dae9(e));
        var i = $e421923b698260e6$var$w(this), o = $e421923b698260e6$var$N(this, e, void 0);
        return o[$e421923b698260e6$var$Q].C = !0, $e421923b698260e6$var$O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[$e421923b698260e6$var$Q];
        var i = e.A;
        return $e421923b698260e6$var$j(i, t), $e421923b698260e6$var$P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !$e421923b698260e6$var$B && $e421923b698260e6$var$n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = $e421923b698260e6$var$b("Patches").$;
        return $e421923b698260e6$export$541ac630993a4c84(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), $e421923b698260e6$var$an = new $e421923b698260e6$export$aaadc6ff0f822719, $e421923b698260e6$export$b46cabe22e78bc00 = $e421923b698260e6$var$an.produce, $e421923b698260e6$export$4da66d41c9492c78 = $e421923b698260e6$var$an.produceWithPatches.bind($e421923b698260e6$var$an), $e421923b698260e6$export$573f26f60825c493 = $e421923b698260e6$var$an.setAutoFreeze.bind($e421923b698260e6$var$an), $e421923b698260e6$export$36ccd207ae29b74e = $e421923b698260e6$var$an.setUseProxies.bind($e421923b698260e6$var$an), $e421923b698260e6$export$a8b8e03e6bbe5473 = $e421923b698260e6$var$an.applyPatches.bind($e421923b698260e6$var$an), $e421923b698260e6$export$3c3214997190395f = $e421923b698260e6$var$an.createDraft.bind($e421923b698260e6$var$an), $e421923b698260e6$export$c60f5e69c521b528 = $e421923b698260e6$var$an.finishDraft.bind($e421923b698260e6$var$an);
var $e421923b698260e6$export$2e2bcd8739ae039 = $e421923b698260e6$export$b46cabe22e78bc00;

});

parcelRequire.register("eUXBH", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $adc4885eb532d74c$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combineReducers", function () { return $adc4885eb532d74c$export$66e4520cdb265d18; });
$parcel$export(module.exports, "compose", function () { return $adc4885eb532d74c$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $adc4885eb532d74c$export$9ff26e0402cc7b7; });

var $hvMPk = parcelRequire("hvMPk");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $adc4885eb532d74c$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $adc4885eb532d74c$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $adc4885eb532d74c$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $adc4885eb532d74c$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $adc4885eb532d74c$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $adc4885eb532d74c$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $adc4885eb532d74c$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $adc4885eb532d74c$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $adc4885eb532d74c$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($adc4885eb532d74c$var$isDate(val)) return "date";
    if ($adc4885eb532d74c$var$isError(val)) return "error";
    var constructorName = $adc4885eb532d74c$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $adc4885eb532d74c$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $adc4885eb532d74c$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $adc4885eb532d74c$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $adc4885eb532d74c$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $adc4885eb532d74c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($adc4885eb532d74c$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($adc4885eb532d74c$var$formatProdErrorMessage(1));
        return enhancer($adc4885eb532d74c$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($adc4885eb532d74c$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($adc4885eb532d74c$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($adc4885eb532d74c$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($adc4885eb532d74c$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($adc4885eb532d74c$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$adc4885eb532d74c$var$isPlainObject(action)) throw new Error($adc4885eb532d74c$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($adc4885eb532d74c$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($adc4885eb532d74c$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($adc4885eb532d74c$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $adc4885eb532d74c$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($adc4885eb532d74c$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$adc4885eb532d74c$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $adc4885eb532d74c$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$adc4885eb532d74c$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $adc4885eb532d74c$export$8928921ea2d3b126 = $adc4885eb532d74c$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $adc4885eb532d74c$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $adc4885eb532d74c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $adc4885eb532d74c$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$adc4885eb532d74c$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $adc4885eb532d74c$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $adc4885eb532d74c$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $adc4885eb532d74c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $adc4885eb532d74c$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($adc4885eb532d74c$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $adc4885eb532d74c$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($adc4885eb532d74c$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $adc4885eb532d74c$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $adc4885eb532d74c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($adc4885eb532d74c$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $adc4885eb532d74c$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $adc4885eb532d74c$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $adc4885eb532d74c$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($adc4885eb532d74c$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $adc4885eb532d74c$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $adc4885eb532d74c$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $adc4885eb532d74c$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($adc4885eb532d74c$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $adc4885eb532d74c$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $hvMPk.default)((0, $hvMPk.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRequire.register("hvMPk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $034a3eca021a7420$export$2e2bcd8739ae039; });

var $7Wyp9 = parcelRequire("7Wyp9");
function $034a3eca021a7420$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $034a3eca021a7420$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $034a3eca021a7420$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $7Wyp9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $034a3eca021a7420$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRequire.register("7Wyp9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c88a335f90dc821$export$2e2bcd8739ae039; });

var $jzQmP = parcelRequire("jzQmP");
function $5c88a335f90dc821$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $jzQmP.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});
parcelRequire.register("jzQmP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e409e8423cc1026d$export$2e2bcd8739ae039; });

var $r6Q03 = parcelRequire("r6Q03");

var $hqAYY = parcelRequire("hqAYY");
function $e409e8423cc1026d$export$2e2bcd8739ae039(arg) {
    var key = (0, $hqAYY.default)(arg, "string");
    return (0, $r6Q03.default)(key) === "symbol" ? key : String(key);
}

});
parcelRequire.register("r6Q03", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0517d38eb6ac6da9$export$2e2bcd8739ae039; });
function $0517d38eb6ac6da9$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $0517d38eb6ac6da9$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0517d38eb6ac6da9$export$2e2bcd8739ae039(o);
}

});

parcelRequire.register("hqAYY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb018d4f29a0339f$export$2e2bcd8739ae039; });

var $r6Q03 = parcelRequire("r6Q03");
function $cb018d4f29a0339f$export$2e2bcd8739ae039(input, hint) {
    if ((0, $r6Q03.default)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $r6Q03.default)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

});





parcelRequire.register("aeozL", function(module, exports) {

$parcel$export(module.exports, "createSelector", function () { return $772e46761d060aa1$export$595d22ed68ca2841; });

var $03xoP = parcelRequire("03xoP");
function $772e46761d060aa1$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $772e46761d060aa1$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $772e46761d060aa1$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $772e46761d060aa1$export$595d22ed68ca2841 = /* #__PURE__ */ $772e46761d060aa1$export$5943f4447f6ef248((0, $03xoP.defaultMemoize));
var $772e46761d060aa1$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $772e46761d060aa1$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRequire.register("03xoP", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", function () { return $00aa30635a2ee31c$export$281bff7f05488aa2; });
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $00aa30635a2ee31c$var$NOT_FOUND = "NOT_FOUND";
function $00aa30635a2ee31c$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $00aa30635a2ee31c$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $00aa30635a2ee31c$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $00aa30635a2ee31c$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $00aa30635a2ee31c$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $00aa30635a2ee31c$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $00aa30635a2ee31c$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $00aa30635a2ee31c$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $00aa30635a2ee31c$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $00aa30635a2ee31c$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $00aa30635a2ee31c$var$createSingletonCache(comparator) : $00aa30635a2ee31c$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $00aa30635a2ee31c$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRequire.register("2LjeY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $202ee558a2cc2152$export$2e2bcd8739ae039; });
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $202ee558a2cc2152$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $202ee558a2cc2152$var$thunk = $202ee558a2cc2152$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$202ee558a2cc2152$var$thunk.withExtraArgument = $202ee558a2cc2152$var$createThunkMiddleware;
var $202ee558a2cc2152$export$2e2bcd8739ae039 = $202ee558a2cc2152$var$thunk;

});



parcelRequire.register("bCERf", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("cyfpf"))(new URL((parcelRequire("9wJdH")).resolve("jf007"), import.meta.url).toString()),
    import("./" + (parcelRequire("9wJdH")).resolve("6CTFQ"))
]).then(()=>parcelRequire("3kV6L"));

});
parcelRequire.register("cyfpf", function(module, exports) {
"use strict";

var $8MrkR = parcelRequire("8MrkR");
module.exports = $8MrkR(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRequire.register("8MrkR", function(module, exports) {
"use strict";
var $664802affb815bb3$var$cachedBundles = {};
var $664802affb815bb3$var$cachedPreloads = {};
var $664802affb815bb3$var$cachedPrefetches = {};
function $664802affb815bb3$var$getCache(type) {
    switch(type){
        case "preload":
            return $664802affb815bb3$var$cachedPreloads;
        case "prefetch":
            return $664802affb815bb3$var$cachedPrefetches;
        default:
            return $664802affb815bb3$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $664802affb815bb3$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRequire.register("e868g", function(module, exports) {

module.exports = import("./" + (parcelRequire("9wJdH")).resolve("doDm0")).then(()=>parcelRequire("7eRLk"));

});

parcelRequire.register("e5apb", function(module, exports) {

module.exports = import("./" + (parcelRequire("9wJdH")).resolve("fnYTQ")).then(()=>parcelRequire("8ojqw"));

});


var $5Wgfu = parcelRequire("5Wgfu");

var $aOChP = parcelRequire("aOChP");
var $3ffba8a88cb861dc$exports = {};

$parcel$export($3ffba8a88cb861dc$exports, "createRoot", function () { return $3ffba8a88cb861dc$export$882461b6382ed46c; }, function (v) { return $3ffba8a88cb861dc$export$882461b6382ed46c = v; });
$parcel$export($3ffba8a88cb861dc$exports, "hydrateRoot", function () { return $3ffba8a88cb861dc$export$757ceba2d55c277e; }, function (v) { return $3ffba8a88cb861dc$export$757ceba2d55c277e = v; });
var $3ffba8a88cb861dc$export$882461b6382ed46c;
var $3ffba8a88cb861dc$export$757ceba2d55c277e;
"use strict";

var $e85sa = parcelRequire("e85sa");
var $3ffba8a88cb861dc$var$i;
$3ffba8a88cb861dc$export$882461b6382ed46c = $e85sa.createRoot;
$3ffba8a88cb861dc$export$757ceba2d55c277e = $e85sa.hydrateRoot;


parcelRequire("36SZw");

var $5Wgfu = parcelRequire("5Wgfu");
parcelRequire("aOChP");

var $aKZsc = parcelRequire("aKZsc");
const $13be670d0ce4716d$var$Style = {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    color: "red",
    textAlign: "center",
    backgroundImage: "linear-gradient(toBottom, rgba(238, 194, 174, 0) 0%, rgba(230, 99, 103, 0.1) 100%)"
};
const $13be670d0ce4716d$var$Error = ()=>{
    const err = (0, $aKZsc.useRouteError)();
    console.log(err);
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
        style: $13be670d0ce4716d$var$Style,
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsx)("h1", {
                children: "OOPS..!!!"
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)("h2", {
                children: "Sorry, an unexpected error has occurred."
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsxs)("h3", {
                children: [
                    err?.status,
                    " : ",
                    err?.statusText || err?.message
                ]
            })
        ]
    });
};
var $13be670d0ce4716d$export$2e2bcd8739ae039 = $13be670d0ce4716d$var$Error;



var $5Wgfu = parcelRequire("5Wgfu");
parcelRequire("aOChP");

var $7hR8K = parcelRequire("7hR8K");
var $gx04x = parcelRequire("gx04x");
var $3k1mL = parcelRequire("3k1mL");

var $alVam = parcelRequire("alVam");

var $dyk5Z = parcelRequire("dyk5Z");

var $dZlV3 = parcelRequire("dZlV3");
var $6b1e737af5abd686$exports = {};
"use strict";
"use client";

var $4SO8W = parcelRequire("4SO8W");
Object.defineProperty($6b1e737af5abd686$exports, "__esModule", {
    value: true
});
$6b1e737af5abd686$exports.default = void 0;

var $6b1e737af5abd686$var$_createSvgIcon = $4SO8W((parcelRequire("agsGj")));

var $5Wgfu = parcelRequire("5Wgfu");
var $6b1e737af5abd686$var$_default = (0, $6b1e737af5abd686$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $5Wgfu.jsx)("path", {
    d: "m23 12-2.44-2.79.34-3.69-3.61-.82-1.89-3.2L12 2.96 8.6 1.5 6.71 4.69 3.1 5.5l.34 3.7L1 12l2.44 2.79-.34 3.7 3.61.82L8.6 22.5l3.4-1.47 3.4 1.46 1.89-3.19 3.61-.82-.34-3.69L23 12zm-12.91 4.72-3.8-3.81 1.48-1.48 2.32 2.33 5.85-5.87 1.48 1.48-7.33 7.35z"
}), "Verified");
$6b1e737af5abd686$exports.default = $6b1e737af5abd686$var$_default;



var $6ppXP = parcelRequire("6ppXP");

var $36SZw = parcelRequire("36SZw");
var $f169544dcbaaf311$exports = {};

$f169544dcbaaf311$exports = new URL((parcelRequire("9wJdH")).resolve("7lZjb"), import.meta.url).toString();



var $f8Jhy = parcelRequire("f8Jhy");

var $5RJCF = parcelRequire("5RJCF");

const $d44a9c33f81e9675$var$MainContainer = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
    }));
const $d44a9c33f81e9675$var$WelcomeBox = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "6rem",
        background: "linear-gradient(to right, #f32170, #ff6b08, #f32170, #cf23cf,#ff6b08, #f32170, #ff6b08)",
        WebkitTextFillColor: "transparent",
        WebkitBackgroundClip: "text",
        [theme.breakpoints.down("sm")]: {
            marginTop: "6rem",
            textAlign: "center"
        },
        [theme.breakpoints.between("sm", "md")]: {
            marginTop: "10rem",
            textAlign: "center"
        }
    }));
const $d44a9c33f81e9675$var$HeaderBox = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        justifyContent: "center",
        alignItems: "center",
        margin: "1rem 4rem",
        padding: "20px 0",
        boxShadow: "1px 1px 5px grey",
        borderRadius: "15px",
        "& > h2": {
            borderRadius: "5px",
            padding: "5px 20px",
            color: "rgb(211,47,47)",
            fontFamily: "Trebuchet MS"
        },
        "& p": {
            fontSize: "20px",
            fontFamily: "Trebuchet MS"
        },
        [theme.breakpoints.down("sm")]: {
            margin: "1rem 0.5rem",
            padding: "10px 5px",
            "& p": {
                fontSize: "16px",
                textAlign: "center"
            }
        },
        [theme.breakpoints.between("sm", "md")]: {
            margin: "1rem 3rem",
            padding: "10px 20px",
            "& p": {
                fontSize: "16px",
                textAlign: "center"
            }
        }
    }));
const $d44a9c33f81e9675$var$Container = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "center",
        marginTop: "15px"
    }));
const $d44a9c33f81e9675$var$ImageBox = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        "& img": {
            borderRadius: "10px",
            width: "75vw",
            height: "80vh",
            marginBottom: "10px",
            [theme.breakpoints.down("sm")]: {
                width: "90vw",
                height: "50vh"
            }
        }
    }));
const $d44a9c33f81e9675$var$StoryBox = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        "& p": {
            fontSize: "18px"
        }
    }));
const $d44a9c33f81e9675$var$SubContainer = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        "& > div": {
            display: "flex",
            alignItems: "center",
            gap: "10px"
        },
        "& svg": {
            color: "#228B22"
        },
        "& p": {
            fontFamily: "Trebuchet MS",
            fontSize: "18px"
        }
    }));
const $d44a9c33f81e9675$var$IconContainer = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        gap: "20px",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "2rem",
        "& > a:hover": {
            transform: "scale(1.2)",
            transition: "0.3s"
        },
        [theme.breakpoints.down("sm")]: {
            gap: "10px"
        }
    }));
const $d44a9c33f81e9675$var$About = ()=>{
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $5Wgfu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $36SZw.default), {}),
            /*#__PURE__*/ (0, $5Wgfu.jsxs)($d44a9c33f81e9675$var$MainContainer, {
                children: [
                    /*#__PURE__*/ (0, $5Wgfu.jsx)($d44a9c33f81e9675$var$WelcomeBox, {
                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)("h1", {
                            children: "WELCOME TO FOODIE ZONE!!!"
                        })
                    }),
                    /*#__PURE__*/ (0, $5Wgfu.jsxs)($d44a9c33f81e9675$var$HeaderBox, {
                        children: [
                            /*#__PURE__*/ (0, $5Wgfu.jsx)($d44a9c33f81e9675$var$ImageBox, {
                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $5RJCF.LazyLoadImage), {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f169544dcbaaf311$exports))),
                                    alt: "AboutImage",
                                    effect: "blur"
                                })
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("h2", {
                                children: "OUR STORY"
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsxs)($d44a9c33f81e9675$var$StoryBox, {
                                children: [
                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                        children: "Everything we do is a celebration of fresh food - from how we source our restaurants and quality food"
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                        sx: {
                                            textAlign: "center"
                                        },
                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)("strong", {
                                            children: "to serving up new ways for you to enjoy it. Since, 2018 we've been  committed to"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                        children: "bringing you the best restaurants and food experience on our website you won't find anywhere else."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsxs)($d44a9c33f81e9675$var$Container, {
                                children: [
                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)($d44a9c33f81e9675$var$SubContainer, {
                                        children: [
                                            /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $7hR8K.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6b1e737af5abd686$exports))), {}),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $3k1mL.default), {
                                                        children: [
                                                            "The Foodie Zone offers delivery of ",
                                                            /*#__PURE__*/ (0, $5Wgfu.jsx)("strong", {
                                                                children: "delicious and healthy food."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $7hR8K.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6b1e737af5abd686$exports))), {}),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $3k1mL.default), {
                                                        children: [
                                                            "Our focus is on satisfying hunger with tasty meals and quick, ",
                                                            /*#__PURE__*/ (0, $5Wgfu.jsx)("strong", {
                                                                children: "free delivery."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $7hR8K.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6b1e737af5abd686$exports))), {}),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $3k1mL.default), {
                                                        children: [
                                                            "Customers can order online and receive a ",
                                                            /*#__PURE__*/ (0, $5Wgfu.jsx)("strong", {
                                                                children: " 40% discount "
                                                            }),
                                                            " on their orders."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $7hR8K.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6b1e737af5abd686$exports))), {}),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $3k1mL.default), {
                                                        children: [
                                                            "The service combines ",
                                                            /*#__PURE__*/ (0, $5Wgfu.jsx)("strong", {
                                                                children: "taste and health"
                                                            }),
                                                            " in its food offerings."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $7hR8K.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6b1e737af5abd686$exports))), {}),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $3k1mL.default), {
                                                        children: [
                                                            "The emphasis is on ",
                                                            /*#__PURE__*/ (0, $5Wgfu.jsx)("strong", {
                                                                children: "convenience, taste, and affordability"
                                                            }),
                                                            " for customers."
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)($d44a9c33f81e9675$var$IconContainer, {
                                        children: [
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)("a", {
                                                href: "https://www.instagram.com/o_n_k_a_r_0895/",
                                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($alVam))), {
                                                    sx: {
                                                        cursor: "pointer",
                                                        color: "rgb(211,47,47)"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)("a", {
                                                href: "https://github.com/onkar895/FOOD-ORDERING-APP",
                                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dZlV3))), {
                                                    sx: {
                                                        cursor: "pointer",
                                                        color: "black"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)("a", {
                                                href: "https://www.linkedin.com/in/omkarkarale541/",
                                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dyk5Z))), {
                                                    sx: {
                                                        cursor: "pointer",
                                                        color: "#0A66C2"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)("a", {
                                                href: "mailto:onkarkarale4@gmail.com",
                                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6ppXP))), {
                                                    sx: {
                                                        cursor: "pointer",
                                                        color: "red"
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $f8Jhy.default), {})
        ]
    });
};
var $d44a9c33f81e9675$export$2e2bcd8739ae039 = $d44a9c33f81e9675$var$About;



var $5Wgfu = parcelRequire("5Wgfu");

var $aOChP = parcelRequire("aOChP");

var $7hR8K = parcelRequire("7hR8K");
var $8qBhC = parcelRequire("8qBhC");
var $9C0Ps = parcelRequire("9C0Ps");
var $gx04x = parcelRequire("gx04x");
var $3k1mL = parcelRequire("3k1mL");

var $e15QL = parcelRequire("e15QL");
var $92c07cf103600d8f$exports = {};
"use strict";
"use client";

var $4SO8W = parcelRequire("4SO8W");
Object.defineProperty($92c07cf103600d8f$exports, "__esModule", {
    value: true
});
$92c07cf103600d8f$exports.default = void 0;

var $92c07cf103600d8f$var$_createSvgIcon = $4SO8W((parcelRequire("agsGj")));

var $5Wgfu = parcelRequire("5Wgfu");
var $92c07cf103600d8f$var$_default = (0, $92c07cf103600d8f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $5Wgfu.jsx)("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), "ExpandLess");
$92c07cf103600d8f$exports.default = $92c07cf103600d8f$var$_default;



var $36SZw = parcelRequire("36SZw");

var $5Wgfu = parcelRequire("5Wgfu");
parcelRequire("aOChP");

var $7hR8K = parcelRequire("7hR8K");
var $gx04x = parcelRequire("gx04x");
const $8d16aff8ec660c5d$var$HeaderBox = (0, $gx04x.default)((0, $7hR8K.default))`
width : 55.6%;
height : 50px;
margin: 7rem 0 0 18rem;
background-color: #E5E4E2;
border-radius : 10px;
`;
const $8d16aff8ec660c5d$var$ShimmerBox = (0, $gx04x.default)((0, $7hR8K.default))`
display : flex;
gap : 12px;
flex-direction : column;
margin: 1.8rem 0 0 18rem;

& > div {
width : 72%;
height : 80px;
background-color: #E5E4E2;
border-radius : 10px;
}
`;
const $8d16aff8ec660c5d$var$MenuShimmer = ()=>{
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $5Wgfu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsx)($8d16aff8ec660c5d$var$HeaderBox, {}),
            /*#__PURE__*/ (0, $5Wgfu.jsx)($8d16aff8ec660c5d$var$ShimmerBox, {
                children: // creating a new Array instance using Array() constructor and map through every element of array 
                Array(10).fill("").map((_, index)=>/*#__PURE__*/ (0, $5Wgfu.jsx)((0, $7hR8K.default), {}, index))
            })
        ]
    });
};
var $8d16aff8ec660c5d$export$2e2bcd8739ae039 = $8d16aff8ec660c5d$var$MenuShimmer;


var $32764ff4308aca34$exports = {};
"use strict";
"use client";

var $4SO8W = parcelRequire("4SO8W");
Object.defineProperty($32764ff4308aca34$exports, "__esModule", {
    value: true
});
$32764ff4308aca34$exports.default = void 0;

var $32764ff4308aca34$var$_createSvgIcon = $4SO8W((parcelRequire("agsGj")));

var $5Wgfu = parcelRequire("5Wgfu");
var $32764ff4308aca34$var$_default = (0, $32764ff4308aca34$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $5Wgfu.jsx)("path", {
    d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), "ArrowForward");
$32764ff4308aca34$exports.default = $32764ff4308aca34$var$_default;



var $f8Jhy = parcelRequire("f8Jhy");

var $c6qc5 = parcelRequire("c6qc5");
const $5c95efe8ebc9847d$var$MainContainer = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        paddingBottom: theme.spacing(0)
    }));
const $5c95efe8ebc9847d$var$MainBox = (0, $gx04x.default)((0, $9C0Ps.default))(({ theme: theme })=>({
        width: "80%",
        margin: "8rem auto",
        padding: theme.spacing(4),
        boxShadow: "0 0 4px 0 grey",
        borderRadius: "10px",
        backgroundImage: "linear-gradient(to left, rgba(238, 194, 174, 0) 0%, rgba(230, 99, 103, 0.1) 100%)",
        [theme.breakpoints.down("sm")]: {
            width: "95%",
            margin: "6rem auto",
            padding: theme.spacing(0.5)
        }
    }));
const $5c95efe8ebc9847d$var$ContentBox = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2)
        }
    }));
const $5c95efe8ebc9847d$var$HeadingBox = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "2rem",
        "& > p": {
            fontWeight: "bold",
            fontSize: "2rem"
        },
        [theme.breakpoints.down("sm")]: {
            justifyContent: "start",
            "& > p": {
                fontWeight: "bold",
                fontSize: "1.2rem"
            }
        }
    }));
const $5c95efe8ebc9847d$var$TitleBox = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        "& > p": {
            fontSize: "16px",
            fontWeight: "bold"
        },
        [theme.breakpoints.down("sm")]: {
            "& > p": {
                fontSize: "14px",
                fontWeight: "bold"
            }
        }
    }));
const $5c95efe8ebc9847d$var$InfoBox = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        border: "1.3px solid rgb(208,208,208)",
        borderRadius: "6.5px",
        padding: theme.spacing(3),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2)
        }
    }));
const $5c95efe8ebc9847d$var$DropDownContent = (0, $gx04x.default)((0, $7hR8K.default))({
    "& > p": {
        fontFamily: "Trebuchet MS",
        color: "grey",
        textAlign: "justify",
        fontSize: "14px"
    }
});
const $5c95efe8ebc9847d$var$Help = ()=>{
    const [activeIndex, setActiveIndex] = (0, $aOChP.useState)(null);
    const handleClick = (index)=>{
        setActiveIndex(activeIndex === index ? null : index);
    };
    if (!(0, $c6qc5.FAQ)) return /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $8d16aff8ec660c5d$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $5Wgfu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $36SZw.default), {}),
            /*#__PURE__*/ (0, $5Wgfu.jsx)($5c95efe8ebc9847d$var$MainContainer, {
                children: (0, $c6qc5.FAQ) && /*#__PURE__*/ (0, $5Wgfu.jsx)($5c95efe8ebc9847d$var$MainBox, {
                    children: /*#__PURE__*/ (0, $5Wgfu.jsxs)($5c95efe8ebc9847d$var$ContentBox, {
                        children: [
                            /*#__PURE__*/ (0, $5Wgfu.jsxs)($5c95efe8ebc9847d$var$HeadingBox, {
                                sx: {
                                    display: "flex",
                                    gap: "6px",
                                    alignItems: "center",
                                    textAlign: "start",
                                    color: "rgb(211,47,47)"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                        children: "WE ARE ALWAYS READY TO HELP"
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($32764ff4308aca34$exports))), {
                                        sx: {
                                            fontSize: "36px"
                                        }
                                    })
                                ]
                            }),
                            (0, $c6qc5.FAQ).map((item, index)=>(item.description || item.hyperLink) && /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $7hR8K.default), {
                                    children: /*#__PURE__*/ (0, $5Wgfu.jsxs)($5c95efe8ebc9847d$var$InfoBox, {
                                        children: [
                                            /*#__PURE__*/ (0, $5Wgfu.jsxs)($5c95efe8ebc9847d$var$TitleBox, {
                                                onClick: ()=>handleClick(index),
                                                sx: {
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    cursor: "pointer"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                                        children: item.title
                                                    }),
                                                    activeIndex !== index && /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $8qBhC.default), {
                                                        color: "error",
                                                        children: activeIndex ? /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($92c07cf103600d8f$exports))), {}) : /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e15QL))), {})
                                                    })
                                                ]
                                            }),
                                            activeIndex === index && /*#__PURE__*/ (0, $5Wgfu.jsxs)($5c95efe8ebc9847d$var$DropDownContent, {
                                                children: [
                                                    item.description && /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                                        children: item.description
                                                    }),
                                                    item.hyperLink && /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)("a", {
                                                            href: "#",
                                                            style: {
                                                                color: "rgb(211,47,47)"
                                                            },
                                                            children: item.hyperLink
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, item.title))
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $f8Jhy.default), {})
        ]
    });
};
var $5c95efe8ebc9847d$export$2e2bcd8739ae039 = $5c95efe8ebc9847d$var$Help;



var $5Wgfu = parcelRequire("5Wgfu");

var $aOChP = parcelRequire("aOChP");

var $hOJyT = parcelRequire("hOJyT");
var $7hR8K = parcelRequire("7hR8K");
var $8qBhC = parcelRequire("8qBhC");
var $jTVHP = parcelRequire("jTVHP");
var $6ymNf = parcelRequire("6ymNf");
var $3k1mL = parcelRequire("3k1mL");

var $kWBo5 = parcelRequire("kWBo5");
const $20006c46e7672e83$export$c42cff54156f85d7 = (email, password)=>{
    const isEmailValid = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/.test(email);
    const isPasswordValid = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(password);
    if (!isEmailValid) return "Please enter a valid email address.";
    if (!isPasswordValid) return "Password must contain at least 8 characters, including at least one uppercase letter, one lowercase letter, one number and special character";
    return null;
};



var $kTVsv = parcelRequire("kTVsv");

var $jqxdk = parcelRequire("jqxdk");
parcelRequire("9CGYE");
var $jk7Hk = parcelRequire("jk7Hk");

var $kYFRN = parcelRequire("kYFRN");

parcelRequire("6SiPo");
var $aKZsc = parcelRequire("aKZsc");
var $5ba5f7448d5a17d5$exports = {};

$5ba5f7448d5a17d5$exports = new URL((parcelRequire("9wJdH")).resolve("b5l0J"), import.meta.url).toString();


var $793a0bbd7e54353b$exports = {};

$793a0bbd7e54353b$exports = new URL((parcelRequire("9wJdH")).resolve("6rLAE"), import.meta.url).toString();


var $b469f4e7653dcce2$exports = {};

$b469f4e7653dcce2$exports = new URL((parcelRequire("9wJdH")).resolve("gDxht"), import.meta.url).toString();



var $bae140b659caeb24$exports = {};
"use strict";
"use client";

var $4SO8W = parcelRequire("4SO8W");
Object.defineProperty($bae140b659caeb24$exports, "__esModule", {
    value: true
});
$bae140b659caeb24$exports.default = void 0;

var $bae140b659caeb24$var$_createSvgIcon = $4SO8W((parcelRequire("agsGj")));

var $5Wgfu = parcelRequire("5Wgfu");
var $bae140b659caeb24$var$_default = (0, $bae140b659caeb24$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $5Wgfu.jsx)("circle", {
        cx: "15.5",
        cy: "9.5",
        r: "1.5"
    }, "0"),
    /*#__PURE__*/ (0, $5Wgfu.jsx)("circle", {
        cx: "8.5",
        cy: "9.5",
        r: "1.5"
    }, "1"),
    /*#__PURE__*/ (0, $5Wgfu.jsx)("circle", {
        cx: "15.5",
        cy: "9.5",
        r: "1.5"
    }, "2"),
    /*#__PURE__*/ (0, $5Wgfu.jsx)("circle", {
        cx: "8.5",
        cy: "9.5",
        r: "1.5"
    }, "3"),
    /*#__PURE__*/ (0, $5Wgfu.jsx)("path", {
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-2.5c2.33 0 4.32-1.45 5.12-3.5h-1.67c-.69 1.19-1.97 2-3.45 2s-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5z"
    }, "4")
], "SentimentSatisfiedAlt");
$bae140b659caeb24$exports.default = $bae140b659caeb24$var$_default;




var $a9c73652323c58a0$exports = {};
"use strict";
"use client";

var $4SO8W = parcelRequire("4SO8W");
Object.defineProperty($a9c73652323c58a0$exports, "__esModule", {
    value: true
});
$a9c73652323c58a0$exports.default = void 0;

var $a9c73652323c58a0$var$_createSvgIcon = $4SO8W((parcelRequire("agsGj")));

var $5Wgfu = parcelRequire("5Wgfu");
var $a9c73652323c58a0$var$_default = (0, $a9c73652323c58a0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $5Wgfu.jsx)("path", {
    d: "M17 1H7c-1.1 0-1.99.85-1.99 1.95v18C5.01 22.05 5.9 23 7 23h10c1.1 0 2-.95 2-2.05v-18C19 1.85 18.1 1 17 1zm0 18H7V5h10v14zm-4.2-5.76v1.75L16 12l-3.2-2.98v1.7c-3.11.43-4.35 2.56-4.8 4.7 1.11-1.5 2.58-2.18 4.8-2.18z"
}), "MobileScreenShareOutlined");
$a9c73652323c58a0$exports.default = $a9c73652323c58a0$var$_default;



var $7hR8K = parcelRequire("7hR8K");
var $8qBhC = parcelRequire("8qBhC");
var $6ETRI = parcelRequire("6ETRI");
var $9C0Ps = parcelRequire("9C0Ps");
var $gx04x = parcelRequire("gx04x");
var $1bGCG = parcelRequire("1bGCG");
const $b750eb4127dd414a$export$a0d9662ebc657c0c = (0, $gx04x.default)((0, $1bGCG.default))(({ theme: theme })=>({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "14vh",
        backgroundColor: "#ffffff",
        backgroundImage: "linear-gradient(to bottom, rgba(238,194,174,0) 0%, rgba(230,99,103,0.1) 100%)",
        [theme.breakpoints.down("sm")]: {
            height: "10vh",
            backgroundImage: "linear-gradient(to bottom, rgba(238,194,174,0) 0%, rgba(230,99,103,0.1) 100%)"
        },
        [theme.breakpoints.between("sm", "md")]: {
            height: "12vh"
        }
    }));
const $b750eb4127dd414a$export$9dbabbc541f56009 = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        backgroundColor: "#ffffff",
        backgroundImage: "linear-gradient(to top, rgba(238,194,174,0) 0%, rgba(230,99,103,0.1) 100%)",
        position: "fixed",
        width: "100vw",
        height: "100vh",
        [theme.breakpoints.between("sm", "md")]: {
            position: "static"
        }
    }));
const $b750eb4127dd414a$export$568aa225dd6161e3 = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        alignItems: "center",
        gap: "20px",
        marginLeft: "38px",
        "& > img": {
            cursor: "pointer",
            background: "none",
            width: "5vw",
            [theme.breakpoints.down("sm")]: {
                width: "12vw"
            },
            [theme.breakpoints.between("sm", "md")]: {
                width: "8vw"
            }
        },
        [theme.breakpoints.down("sm")]: {
            margin: "10px auto"
        }
    }));
const $b750eb4127dd414a$export$b4e5e09251522c2c = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        flexDirection: "column",
        "& > p": {
            fontFamily: "Trebuchet MS",
            fontSize: "26px",
            color: "rgb(211,47,47)",
            fontWeight: "bolder",
            [theme.breakpoints.down("sm")]: {
                fontFamily: "Trebuchet MS",
                fontSize: "18px",
                color: "rgb(211,47,47)",
                fontWeight: "bolder"
            },
            [theme.breakpoints.between("sm", "md")]: {
                fontFamily: "Trebuchet MS",
                fontSize: "32px",
                color: "rgb(211,47,47)",
                fontWeight: "bolder"
            }
        },
        "& > p:nth-child(2)": {
            fontFamily: "Trebuchet MS",
            fontSize: "12px",
            marginLeft: "3rem",
            marginBottom: "6px",
            color: "rgb(211,47,47)",
            fontWeight: "bolder",
            [theme.breakpoints.down("sm")]: {
                marginLeft: "1rem"
            },
            [theme.breakpoints.between("sm", "md")]: {
                marginLeft: "4rem"
            }
        },
        [theme.breakpoints.down("sm")]: {
            width: "40vw"
        },
        [theme.breakpoints.between("sm", "md")]: {
            width: "60vw"
        }
    }));
const $b750eb4127dd414a$export$698668688a6e8f34 = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        gap: "2rem",
        marginRight: "2.4rem",
        "& > ul": {
            display: "flex",
            alignItems: "center",
            gap: "2rem",
            color: "black",
            fontWeight: "bold",
            fontSize: "16px",
            listStyleType: "none"
        },
        [theme.breakpoints.down("sm")]: {
            margin: "10px auto"
        }
    }));
const $b750eb4127dd414a$export$5e37f977ae0514c2 = (0, $gx04x.default)((0, $8qBhC.default))(({ theme: theme })=>({
        padding: "3px 15px",
        alignItems: "center",
        cursor: "pointer",
        border: "1.5px solid rgb(211,47,47)",
        textTransform: "capitalize",
        fontWeight: "bold",
        "&:hover": {
            background: "rgb(211,47,47)",
            color: "white",
            boxShadow: "3px 3px 6px rgb(211,47,47)"
        },
        [theme.breakpoints.down("sm")]: {
            padding: "3px 12px",
            margin: "3rem"
        },
        [theme.breakpoints.between("sm", "md")]: {
            padding: "6px 20px",
            marginLeft: "3rem"
        }
    }));
const $b750eb4127dd414a$export$17cf5552e668a4ed = (0, $gx04x.default)((0, $8qBhC.default))(({ theme: theme })=>({
        display: "flex",
        alignItems: "center",
        gap: "10px",
        fontFamily: "Trebuchet MS",
        background: "white",
        color: "black",
        padding: "8px",
        textTransform: "capitalize",
        "& p": {
            fontSize: "15px",
            fontWeight: "bolder"
        },
        "&:hover": {
            background: "white",
            color: "black"
        },
        "& > img": {
            width: "2vw"
        },
        [theme.breakpoints.down("sm")]: {
            padding: "12px",
            "& p": {
                fontSize: "12px"
            },
            "& > img": {
                width: "5vw"
            }
        }
    }));
const $b750eb4127dd414a$export$6a1570a405c3c095 = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        alignItems: "center",
        color: "rgb(211,47,47)",
        gap: "2px",
        fontWeight: "bolder",
        "& > svg": {
            fontSize: "25px",
            color: "rgb(211,47,47)",
            cursor: "pointer"
        },
        [theme.breakpoints.down("sm")]: {
            display: "none"
        },
        [theme.breakpoints.between("sm", "md")]: {
            display: "none"
        }
    }));
const $b750eb4127dd414a$export$d63af35ad2e48287 = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        gap: "2px",
        "& > a": {
            textDecoration: "none",
            color: "rgb(211,47,47)"
        },
        "& > svg": {
            fontSize: "25px",
            color: "rgb(211,47,47)",
            cursor: "pointer"
        },
        [theme.breakpoints.down("sm")]: {
            display: "none"
        },
        [theme.breakpoints.between("sm", "md")]: {
            display: "none"
        }
    }));
const $b750eb4127dd414a$export$7f1044b3738ac27d = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        alignItems: "center",
        "& > svg": {
            marginBottom: "3px",
            fontSize: "28px",
            color: "rgb(211,47,47)",
            cursor: "pointer"
        },
        [theme.breakpoints.down("sm")]: {
            display: "none"
        },
        [theme.breakpoints.between("sm", "md")]: {
            display: "none"
        }
    }));
const $b750eb4127dd414a$export$d653589df987fd93 = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "3.5%",
        [theme.breakpoints.down("sm")]: {
            marginTop: "30%"
        },
        [theme.breakpoints.between("sm", "md")]: {
            marginTop: "30%"
        }
    }));
const $b750eb4127dd414a$export$68a3906f6694d512 = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        minHeight: "100vh",
        "& > img": {
            width: "45%",
            height: "auto"
        },
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column-reverse",
            minHeight: "100vh",
            gap: "3rem",
            "& img": {
                width: "100%",
                height: "auto"
            }
        },
        [theme.breakpoints.between("sm", "md")]: {
            flexDirection: "column-reverse",
            "& img": {
                width: "100%",
                height: "auto",
                marginTop: "4.5rem"
            }
        },
        [theme.breakpoints.between("md", "lg")]: {
            width: "90%",
            minHeight: "80vh"
        }
    }));
const $b750eb4127dd414a$export$16223cbffe6527a6 = (0, $gx04x.default)((0, $9C0Ps.default))(({ theme: theme })=>({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "3rem",
        justifyContent: "center",
        width: "28%",
        backgroundColor: "rgba(0,0,0,0.4)",
        height: "85vh",
        filter: "drop-shadow(2px 2px 6px black)",
        borderRadius: "10px",
        [theme.breakpoints.down("sm")]: {
            width: "90%",
            height: "auto",
            padding: "2rem"
        },
        [theme.breakpoints.between("sm", "md")]: {
            width: "50%",
            height: "auto",
            padding: "2rem"
        },
        [theme.breakpoints.between("md", "lg")]: {
            width: "50%",
            height: "50vh",
            margin: "10rem auto",
            padding: "2rem"
        }
    }));
const $b750eb4127dd414a$export$8b251419efc915eb = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        flexDirection: "column",
        gap: "5px",
        fontFamily: "Trebuchet MS",
        marginRight: "35px",
        "& > p": {
            color: "darkgray",
            fontFamily: "Trebuchet MS",
            fontSize: "12px"
        },
        [theme.breakpoints.down("sm")]: {
            margin: "10px auto"
        }
    }));
const $b750eb4127dd414a$export$5ac7b85d728a3568 = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "center",
        gap: "1rem",
        width: "80%",
        "& input": {
            fontSize: "12.5px",
            color: "white",
            border: "1px solid white",
            borderRadius: "5px",
            "&:hover": {
                borderBottom: "2px solid white"
            }
        },
        "& > h3": {
            color: "white"
        },
        "& label": {
            color: "darkgray",
            fontSize: "14px",
            fontFamily: "Trebuchet MS"
        },
        "& p": {
            fontFamily: "Trebuchet MS",
            fontSize: "12px",
            cursor: "pointer"
        },
        [theme.breakpoints.down("sm")]: {
            width: "100%"
        }
    }));
const $b750eb4127dd414a$export$9baf404e9c6f7a66 = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        alignItems: "center",
        gap: "10px"
    }));
const $b750eb4127dd414a$export$45a71fef754c4939 = (0, $gx04x.default)((0, $6ETRI.default))(({ theme: theme })=>({
        fontFamily: "Trebuchet MS",
        cursor: "pointer",
        fontWeight: "bolder",
        fontSize: "12px",
        color: "darkgray",
        textDecoration: "none",
        marginTop: "0.5rem",
        "&:hover": {
            color: "white"
        }
    }));



var $5RJCF = parcelRequire("5RJCF");

const $cce9f670e97b3efc$var$Login = ()=>{
    const { setUserName: setUserName, loggedInUser: loggedInUser, userName: userName } = (0, $aOChP.useContext)((0, $kWBo5.default));
    const [isSignIn, setIsSignIn] = (0, $aOChP.useState)(true);
    const [errMessage, setErrMessage] = (0, $aOChP.useState)("");
    const [open, setOpen] = (0, $aOChP.useState)(false);
    const navigate = (0, $aKZsc.useNavigate)();
    const email = (0, $aOChP.useRef)(null);
    const password = (0, $aOChP.useRef)(null);
    const handleUserNameChange = (e)=>{
        setUserName(e.target.value);
    };
    const handleOpen = ()=>setOpen(true);
    const handleClose = ()=>setOpen(false);
    const handleClick = async (e)=>{
        e.preventDefault();
        const message = (0, $20006c46e7672e83$export$c42cff54156f85d7)(email.current.value, password.current.value);
        setErrMessage(message);
        if (message) return;
        if (!isSignIn) try {
            await (0, $jk7Hk.a9)((0, $jqxdk.firebaseAuth), email.current.value, password.current.value);
            navigate("/");
            (0, $kYFRN.toast).success(/*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                        style: {
                            fontSize: "14px",
                            textAlign: "center",
                            color: "black"
                        },
                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)("strong", {
                            children: "Congratulations! Your account has been successfully created."
                        })
                    }),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                        style: {
                            fontSize: "12px",
                            textAlign: "center",
                            color: "rgb(211,47,47)",
                            fontWeight: "bold",
                            marginTop: "10px"
                        },
                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)("strong", {
                            children: 'Click on the "Sign In Now" below to Sign In.'
                        })
                    })
                ]
            }), {
                position: "top-center",
                newestOnTop: true,
                autoClose: 2000,
                closeButton: true,
                closeOnClick: true,
                pauseOnHover: true
            });
        } catch (err) {
            setErrMessage(err.message);
        }
        else try {
            await (0, $jk7Hk.aa)((0, $jqxdk.firebaseAuth), email.current.value, password.current.value);
            navigate("/home");
        } catch (err) {
            setErrMessage(err.message);
        }
    };
    const handleGoogleSignIn = async (e)=>{
        e.preventDefault();
        try {
            await (0, $jk7Hk.c)((0, $jqxdk.firebaseAuth), (0, $jqxdk.provider));
            navigate("/home");
        } catch (error) {
            console.log(error);
        }
    };
    const toggleSignInForm = ()=>{
        setIsSignIn(!isSignIn);
    };
    return /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $5Wgfu.Fragment), {
        children: /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $b750eb4127dd414a$export$9dbabbc541f56009), {
            children: [
                /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $hOJyT.default), {
                    sx: {
                        boxShadow: "none"
                    },
                    children: /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $b750eb4127dd414a$export$a0d9662ebc657c0c), {
                        children: [
                            /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $b750eb4127dd414a$export$568aa225dd6161e3), {
                                children: [
                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($kTVsv))),
                                        alt: "FoodLogo",
                                        onClick: ()=>navigate("/")
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $b750eb4127dd414a$export$b4e5e09251522c2c), {
                                        children: [
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                                children: "Zra Foods"
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                                children: "Taste of Everything"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $b750eb4127dd414a$export$698668688a6e8f34), {
                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)("ul", {
                                    children: /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $b750eb4127dd414a$export$d63af35ad2e48287), {
                                            children: [
                                                /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a9c73652323c58a0$exports))), {}),
                                                /*#__PURE__*/ (0, $5Wgfu.jsx)("a", {
                                                    href: "https://play.google.com/store/apps/details?id=in.swiggy.android&referrer=utm_source%3Dswiggy%26utm_medium%3Dheader",
                                                    children: "Get The App"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $b750eb4127dd414a$export$68a3906f6694d512), {
                    children: [
                        /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $5RJCF.LazyLoadImage), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($5ba5f7448d5a17d5$exports))),
                            alt: "FoodImage",
                            effect: "blur"
                        }),
                        /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $5RJCF.LazyLoadImage), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($b469f4e7653dcce2$exports))),
                            alt: "Image",
                            effect: "blur"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $jTVHP.default), {
                    open: open,
                    onClose: handleClose,
                    "aria-labelledby": "modal-modal-title",
                    "aria-describedby": "modal-modal-description",
                    children: /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $b750eb4127dd414a$export$d653589df987fd93), {
                        children: [
                            /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $b750eb4127dd414a$export$16223cbffe6527a6), {
                                children: [
                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $b750eb4127dd414a$export$8b251419efc915eb), {
                                        children: [
                                            /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $7hR8K.default), {
                                                sx: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "10px",
                                                    color: "white"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("h2", {
                                                        children: "Welcome Back"
                                                    }),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bae140b659caeb24$exports))), {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                                children: isSignIn ? "Sign In with your email address and password" : "Sign Up with your email address and password"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $b750eb4127dd414a$export$5ac7b85d728a3568), {
                                        children: [
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)("h3", {
                                                children: isSignIn ? "Sign In" : "Sign Up"
                                            }),
                                            !isSignIn && /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ymNf.default), {
                                                type: "text",
                                                variant: "filled",
                                                color: "warning",
                                                label: "UserName",
                                                required: true,
                                                fullWidth: true,
                                                value: userName,
                                                onChange: handleUserNameChange
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ymNf.default), {
                                                inputRef: email,
                                                type: "email",
                                                variant: "filled",
                                                color: "warning",
                                                label: "Email",
                                                required: true,
                                                fullWidth: true
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6ymNf.default), {
                                                inputRef: password,
                                                type: "password",
                                                color: "warning",
                                                variant: "filled",
                                                label: "Password",
                                                required: true,
                                                fullWidth: true
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                                sx: {
                                                    color: "red",
                                                    fontSize: "14px",
                                                    fontFamily: "Trebuchet MS",
                                                    fontWeight: "bold"
                                                },
                                                children: errMessage
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $8qBhC.default), {
                                                sx: {
                                                    fontFamily: "Trebuchet MS",
                                                    padding: "8px 0"
                                                },
                                                variant: "contained",
                                                size: "medium",
                                                color: "error",
                                                required: true,
                                                fullWidth: true,
                                                onClick: handleClick,
                                                children: isSignIn ? "Sign In" : "Sign Up"
                                            }),
                                            isSignIn && /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $7hR8K.default), {
                                                sx: {
                                                    color: "white"
                                                },
                                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)("h5", {
                                                    children: "OR Sign In Using"
                                                })
                                            }),
                                            isSignIn && /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $b750eb4127dd414a$export$17cf5552e668a4ed), {
                                                onClick: handleGoogleSignIn,
                                                fullWidth: true,
                                                children: [
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($793a0bbd7e54353b$exports))),
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                                        children: "Sign In With Google"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $b750eb4127dd414a$export$9baf404e9c6f7a66), {
                                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $b750eb4127dd414a$export$45a71fef754c4939), {
                                                    onClick: toggleSignInForm,
                                                    children: isSignIn ? "New User? Sign Up Now" : "Already Registered? Sign In Now"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $kYFRN.ToastContainer), {})
                        ]
                    })
                })
            ]
        })
    });
};
var $cce9f670e97b3efc$export$2e2bcd8739ae039 = $cce9f670e97b3efc$var$Login;



var $5Wgfu = parcelRequire("5Wgfu");

var $aOChP = parcelRequire("aOChP");

var $7hR8K = parcelRequire("7hR8K");
var $8qBhC = parcelRequire("8qBhC");
var $gx04x = parcelRequire("gx04x");
var $3k1mL = parcelRequire("3k1mL");

var $5Wgfu = parcelRequire("5Wgfu");
parcelRequire("aOChP");

var $7hR8K = parcelRequire("7hR8K");
var $8qBhC = parcelRequire("8qBhC");
var $gx04x = parcelRequire("gx04x");
var $3k1mL = parcelRequire("3k1mL");
parcelRequire("288NN");
var $hulgA = parcelRequire("hulgA");
parcelRequire("6SiPo");
var $aKZsc = parcelRequire("aKZsc");

var $aITiR = parcelRequire("aITiR");

var $kYFRN = parcelRequire("kYFRN");


var $c6qc5 = parcelRequire("c6qc5");
var $58b10a6e01db91d9$exports = {};

$58b10a6e01db91d9$exports = new URL((parcelRequire("9wJdH")).resolve("4II5v"), import.meta.url).toString();


const $21375b375eea55b0$var$HeaderBox = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        alignItems: "start",
        gap: theme.spacing(6),
        marginLeft: theme.spacing(6),
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            gap: theme.spacing(4),
            marginLeft: 0,
            alignItems: "center"
        }
    }));
const $21375b375eea55b0$var$MainContainer = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(3),
        width: "45vw",
        padding: theme.spacing(3),
        boxShadow: "0 0 4px 0 rgba(208,208,208,0.8)",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            width: "96vw",
            gap: "30px",
            padding: "15px 5px"
        }
    }));
const $21375b375eea55b0$var$CardContent = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        [theme.breakpoints.down("sm")]: {
            gap: "5px"
        }
    }));
const $21375b375eea55b0$var$PriceBox = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        gap: "10px",
        alignItems: "center",
        "& h6": {
            fontWeight: "bold",
            color: "red",
            backgroundColor: "rgba(211,47,47,0.1)",
            padding: "2px 5px",
            "& > span": {
                fontSize: "10px"
            }
        },
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "start",
            "& h6": {
                fontSize: "10px",
                "& > span": {
                    fontSize: "10px"
                }
            }
        }
    }));
const $21375b375eea55b0$var$MenuImageBox = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        position: "relative",
        "& > img": {
            objectFit: "cover",
            borderRadius: "5px",
            width: "10vw",
            height: "15vh",
            [theme.breakpoints.down("sm")]: {
                width: "40vw",
                height: "12vh"
            }
        }
    }));
const $21375b375eea55b0$var$RemoveItemBox = (0, $gx04x.default)((0, $7hR8K.default))({
    cursor: "pointer",
    marginLeft: "1.5rem",
    color: "grey",
    color: "rgb(211,47,47)",
    fontWeight: 500
});
const $21375b375eea55b0$var$ButtonBox = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        gap: "10px",
        fontWeight: "bold",
        margin: "0 auto",
        "& button:nth-child(1)": {
            fontFamily: "Trebuchet MS",
            textTransform: "capitalize",
            backgroundColor: "rgba(55,118,210,0.1)",
            "&:hover": {
                color: "white",
                backgroundColor: "rgb(55,118,210)",
                fontWeight: "bold"
            }
        },
        "& button:nth-child(2)": {
            fontFamily: "Trebuchet MS",
            textTransform: "capitalize",
            backgroundColor: "rgba(211,47,47,0.1)",
            padding: "5px 38px",
            "&:hover": {
                color: "white",
                fontWeight: "bold",
                backgroundColor: "rgb(211,47,47)"
            }
        },
        [theme.breakpoints.down("sm")]: {
            gap: "20px",
            margin: "0 auto",
            "& button:nth-child(2)": {
                padding: "6px 30px"
            }
        }
    }));
const $21375b375eea55b0$var$ImgBox = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        [theme.breakpoints.down("sm")]: {}
    }));
const $21375b375eea55b0$var$InfoBox = (0, $gx04x.default)((0, $7hR8K.default))({
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    margin: "10px 0",
    borderTop: "1px solid lightgray",
    borderBottom: "1px solid lightgray",
    padding: "10px 0 15px 0",
    "& > div": {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        color: "#71797E",
        "& p": {
            fontFamily: "Trebuchet MS",
            fontSize: "14px",
            color: "black"
        },
        "& h4": {
            fontFamily: "Trebuchet MS",
            color: "black"
        },
        "& span": {
            fontSize: "13px",
            color: "rgb(211,47,47)"
        }
    }
});
const $21375b375eea55b0$var$TotalBox = (0, $gx04x.default)((0, $7hR8K.default))({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 0 15px 0",
    borderBottom: "1px solid lightgray",
    "& h3": {
        fontFamily: "Trebuchet MS"
    }
});
const $21375b375eea55b0$var$SummaryContainer = (0, $gx04x.default)((0, $7hR8K.default))({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "20px"
});
const $21375b375eea55b0$var$Container = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        padding: theme.spacing(3),
        width: "28vw",
        boxShadow: "0 0 6px 0 rgba(208,208,208,0.8)",
        height: "60vh",
        [theme.breakpoints.down("sm")]: {
            width: "98vw"
        }
    }));
const $21375b375eea55b0$var$CartItemList = ({ items: items })=>{
    const dispatch = (0, $hulgA.useDispatch)();
    const navigate = (0, $aKZsc.useNavigate)();
    const handleRemove = (item)=>{
        dispatch((0, $aITiR.removeItem)({
            item: item
        })) ? (0, $kYFRN.toast).success("Removed from Cart", {
            position: "top-center",
            newestOnTop: true,
            autoClose: 1000
        }) : (0, $kYFRN.toast).error("Not Removed", {
            position: "top-center",
            newestOnTop: true,
            autoClose: 1000
        });
    };
    const handleClearCart = ()=>{
        dispatch((0, $aITiR.clearCart)()) ? (0, $kYFRN.toast).success("All Items Removed", {
            position: "top-center",
            newestOnTop: true,
            autoClose: 1000
        }) : (0, $kYFRN.toast).error("Items Not Removed", {
            position: "top-center",
            newestOnTop: true,
            autoClose: 1000
        });
    };
    const handleClick = ()=>{
        (0, $kYFRN.toast).success("Order Placed Successfully", {
            position: "top-center",
            newestOnTop: true,
            autoClose: 5000
        });
    };
    const TotalAmount = items.length > 0 ? items.map((x)=>x.card.info.price > 0 ? x.card.info.price / 100 : x.card.info.defaultPrice / 100).reduce((sum, a)=>sum + a, 0) : 0;
    const DeliveryCharges = TotalAmount * 0.5 / 10;
    const Discount = TotalAmount * 10 / 100;
    const FinalAmount = TotalAmount + DeliveryCharges - Discount;
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $5Wgfu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                variant: "h4",
                style: {
                    textAlign: "center",
                    marginBottom: "1rem",
                    color: "rgb(211,47,47)"
                },
                children: "Cart"
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsxs)($21375b375eea55b0$var$HeaderBox, {
                children: [
                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $7hR8K.default), {
                        children: items && items.map((item)=>/*#__PURE__*/ (0, $5Wgfu.jsxs)($21375b375eea55b0$var$MainContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)($21375b375eea55b0$var$ImgBox, {
                                        sx: {
                                            display: "flex",
                                            gap: "20px",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)($21375b375eea55b0$var$MenuImageBox, {
                                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)("img", {
                                                    src: item.card.info.imageId ? (0, $c6qc5.SWIGGY_MENU_IMG_API) + item.card.info.imageId : (0, (/*@__PURE__*/$parcel$interopDefault($58b10a6e01db91d9$exports))),
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsxs)($21375b375eea55b0$var$CardContent, {
                                                children: [
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $7hR8K.default), {
                                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                                            sx: {
                                                                fontFamily: "Trebuchet MS"
                                                            },
                                                            children: item.card.info.name
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)($21375b375eea55b0$var$PriceBox, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $3k1mL.default), {
                                                                sx: {
                                                                    fontFamily: "Trebuchet MS"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("strong", {
                                                                        children: "Price :"
                                                                    }),
                                                                    " ₹ ",
                                                                    (item.card.info.price / 100 || item.card.info.defaultPrice / 100).toFixed(2)
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $3k1mL.default), {
                                                                variant: "subtitle2",
                                                                children: [
                                                                    "50% OFF | ",
                                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("span", {
                                                                        children: "USE FOODIEIT"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, item.card.info.id)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsx)($21375b375eea55b0$var$RemoveItemBox, {
                                        onClick: ()=>handleRemove(item),
                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                            variant: "body2",
                                            children: /*#__PURE__*/ (0, $5Wgfu.jsx)("strong", {
                                                children: "Remove"
                                            })
                                        })
                                    })
                                ]
                            }, item.card.info.id))
                    }),
                    /*#__PURE__*/ (0, $5Wgfu.jsxs)($21375b375eea55b0$var$SummaryContainer, {
                        children: [
                            /*#__PURE__*/ (0, $5Wgfu.jsxs)($21375b375eea55b0$var$Container, {
                                children: [
                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $7hR8K.default), {
                                        sx: {
                                            textAlign: "center",
                                            fontWeight: "bolder"
                                        },
                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                            variant: "h5",
                                            children: "Order Summary"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)($21375b375eea55b0$var$InfoBox, {
                                        children: [
                                            /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $7hR8K.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $3k1mL.default), {
                                                        variant: "body1",
                                                        children: [
                                                            "Price: (",
                                                            items.length,
                                                            " Items)"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                                        variant: "h6",
                                                        children: `₹ ${parseFloat(TotalAmount).toFixed(2)}`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $7hR8K.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                                        variant: "body1",
                                                        children: "Discount (10%):"
                                                    }),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $3k1mL.default), {
                                                        variant: "h6",
                                                        children: [
                                                            "- ₹ ",
                                                            parseFloat(Discount).toFixed(2)
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $7hR8K.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                                        variant: "body1",
                                                        children: "Delivery Charges (5%):"
                                                    }),
                                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $3k1mL.default), {
                                                        variant: "h6",
                                                        children: [
                                                            "+ ₹ ",
                                                            parseFloat(DeliveryCharges).toFixed(2)
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $7hR8K.default), {
                                                children: /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $3k1mL.default), {
                                                    children: [
                                                        "You have saved ",
                                                        /*#__PURE__*/ (0, $5Wgfu.jsxs)("strong", {
                                                            children: [
                                                                "₹ ",
                                                                parseFloat(Discount).toFixed(2)
                                                            ]
                                                        }),
                                                        " on this order \uD83D\uDE0A"
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)($21375b375eea55b0$var$TotalBox, {
                                        children: [
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                                variant: "h6",
                                                sx: {
                                                    fontFamily: "Trebuchet MS"
                                                },
                                                children: "Total Amount :"
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $3k1mL.default), {
                                                variant: "h6",
                                                sx: {
                                                    fontFamily: "Trebuchet MS"
                                                },
                                                children: [
                                                    "₹ ",
                                                    parseFloat(FinalAmount).toFixed(2)
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $7hR8K.default), {
                                        sx: {
                                            marginTop: "5px"
                                        },
                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $8qBhC.default), {
                                            onClick: handleClick,
                                            variant: "contained",
                                            color: "error",
                                            size: "large",
                                            fullWidth: true,
                                            children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                                sx: {
                                                    fontWeight: "bold"
                                                },
                                                children: "Place Order"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsxs)($21375b375eea55b0$var$ButtonBox, {
                                children: [
                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $8qBhC.default), {
                                        variant: "outlined",
                                        size: "small",
                                        onClick: ()=>navigate(-1),
                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                            variant: "h6",
                                            children: "Continue Ordering"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $8qBhC.default), {
                                        variant: "outlined",
                                        size: "small",
                                        color: "error",
                                        onClick: handleClearCart,
                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                            variant: "h6",
                                            children: "Clear Cart"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $kYFRN.ToastContainer), {})
                ]
            })
        ]
    });
};
var $21375b375eea55b0$export$2e2bcd8739ae039 = $21375b375eea55b0$var$CartItemList;


parcelRequire("288NN");
var $cm2x1 = parcelRequire("cm2x1");
var $5fd788917eba55ef$exports = {};

$5fd788917eba55ef$exports = new URL((parcelRequire("9wJdH")).resolve("gzrhQ"), import.meta.url).toString();


parcelRequire("6SiPo");
var $aKZsc = parcelRequire("aKZsc");

var $36SZw = parcelRequire("36SZw");

var $f8Jhy = parcelRequire("f8Jhy");

var $5RJCF = parcelRequire("5RJCF");

const $3443972c976e6e83$var$MainContainer = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        paddingBottom: theme.spacing(0)
    }));
const $3443972c976e6e83$var$MainCartBox = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(4),
        alignItems: "center",
        justifyContent: "center",
        [theme.breakpoints.down("sm")]: {
            gap: theme.spacing(2),
            marginTop: "8rem"
        },
        [theme.breakpoints.between("sm", "md")]: {
            gap: theme.spacing(2),
            marginTop: "8rem"
        }
    }));
const $3443972c976e6e83$var$CartBox = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(4),
        alignItems: "center",
        justifyContent: "center",
        marginTop: theme.spacing(6),
        [theme.breakpoints.down("sm")]: {
            marginTop: theme.spacing(4)
        }
    }));
const $3443972c976e6e83$var$ItemsBox = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        width: "100%"
    }));
const $3443972c976e6e83$var$EmptyBox = (0, $gx04x.default)((0, $7hR8K.default))(({ theme: theme })=>({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: theme.spacing(3),
        "& img": {
            width: "40vw",
            marginTop: "3rem"
        },
        "& p": {
            fontFamily: "Trebuchet MS",
            color: "rgb(211,47,47)",
            fontWeight: "900",
            fontSize: "2rem",
            textAlign: "center"
        },
        "& button": {
            fontFamily: "Trebuchet MS",
            textTransform: "capitalize"
        },
        [theme.breakpoints.down("sm")]: {
            "& img": {
                width: "80vw"
            }
        }
    }));
const $3443972c976e6e83$var$Cart = ()=>{
    const cartItems = (0, $cm2x1.useSelector)((store)=>store.items);
    const navigate = (0, $aKZsc.useNavigate)();
    const location = (0, $aKZsc.useLocation)();
    (0, $aOChP.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, [
        location
    ]);
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $5Wgfu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $36SZw.default), {}),
            /*#__PURE__*/ (0, $5Wgfu.jsx)($3443972c976e6e83$var$MainContainer, {
                children: /*#__PURE__*/ (0, $5Wgfu.jsx)($3443972c976e6e83$var$MainCartBox, {
                    children: cartItems.length === 0 ? /*#__PURE__*/ (0, $5Wgfu.jsxs)($3443972c976e6e83$var$EmptyBox, {
                        children: [
                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $5RJCF.LazyLoadImage), {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($5fd788917eba55ef$exports))),
                                alt: "EmptyCart",
                                effect: "blur"
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3k1mL.default), {
                                children: "Your Cart is Empty."
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $8qBhC.default), {
                                onClick: ()=>navigate("/restaurants"),
                                variant: "contained",
                                size: "large",
                                color: "error",
                                children: "Explore the Restaurants"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $5Wgfu.jsx)($3443972c976e6e83$var$CartBox, {
                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)($3443972c976e6e83$var$ItemsBox, {
                            children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $21375b375eea55b0$export$2e2bcd8739ae039), {
                                items: cartItems
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $f8Jhy.default), {})
        ]
    });
};
var $3443972c976e6e83$export$2e2bcd8739ae039 = $3443972c976e6e83$var$Cart;



var $7hR8K = parcelRequire("7hR8K");

var $kWBo5 = parcelRequire("kWBo5");

var $6SiPo = parcelRequire("6SiPo");
var $aKZsc = parcelRequire("aKZsc");
parcelRequire("9CGYE");
var $jk7Hk = parcelRequire("jk7Hk");

var $jqxdk = parcelRequire("jqxdk");
parcelRequire("288NN");
var $aBo2k = parcelRequire("aBo2k");

var $id5hj = parcelRequire("id5hj");

var $aITiR = parcelRequire("aITiR");
const $fddd0ecc158bce60$var$appStore = (0, $id5hj.configureStore)({
    reducer: (0, $aITiR.cartReducer)
});
var $fddd0ecc158bce60$export$2e2bcd8739ae039 = $fddd0ecc158bce60$var$appStore;





// * Modularity is also known as:
// * Chunking
// * Code Splitting
// * Dynamic Bundling
// * Lazy Loading
// * On-Demand Loading
// * Dynamic Import
// const Grocery = lazy(() => import('./Components/Grocery/Grocery'));
const $b33bb22541d9cb53$var$HomePage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).memo(/*#__PURE__*/ (0, $aOChP.lazy)(()=>(parcelRequire("bCERf"))));

const $b33bb22541d9cb53$var$Menu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).memo(/*#__PURE__*/ (0, $aOChP.lazy)(()=>(parcelRequire("e868g"))));

const $b33bb22541d9cb53$var$RestaurantMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).memo(/*#__PURE__*/ (0, $aOChP.lazy)(()=>(parcelRequire("e5apb"))));
const $b33bb22541d9cb53$var$MainComponent = ()=>{
    const [userName, setUserName] = (0, $aOChP.useState)();
    const [user, setUser] = (0, $aOChP.useState)({});
    const Area = "Pune";
    (0, $aOChP.useEffect)(()=>{
        const unSubscribe = (0, $jk7Hk.y)((0, $jqxdk.firebaseAuth), (currentUser)=>{
            setUser(currentUser);
            console.log("user", currentUser);
        });
        return ()=>{
            unSubscribe();
        };
    }, []);
    (0, $aOChP.useEffect)(()=>{
        const data = {
            name: "User"
        };
        setUserName(data.name);
    }, []);
    return /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $5Wgfu.Fragment), {
        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $aBo2k.default), {
            store: (0, $fddd0ecc158bce60$export$2e2bcd8739ae039),
            children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $kWBo5.default).Provider, {
                value: {
                    loggedInUser: userName,
                    setUserName: setUserName,
                    user: user,
                    Area: Area
                },
                children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $7hR8K.default), {
                    style: {
                        marginTop: "3rem"
                    },
                    children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $aKZsc.Outlet), {})
                })
            })
        })
    });
};
const $b33bb22541d9cb53$var$appRouter = (0, $6SiPo.createBrowserRouter)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $5Wgfu.jsx)($b33bb22541d9cb53$var$MainComponent, {}),
        children: [
            {
                path: "/home",
                element: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $aOChP.Suspense), {
                    fallback: /*#__PURE__*/ (0, $5Wgfu.jsx)("h1", {
                        children: "Loading HomePage..."
                    }),
                    children: /*#__PURE__*/ (0, $5Wgfu.jsx)($b33bb22541d9cb53$var$HomePage, {})
                })
            },
            {
                path: "/restaurants",
                element: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $aOChP.Suspense), {
                    fallback: /*#__PURE__*/ (0, $5Wgfu.jsx)("h1", {
                        children: "Loading Restaurants..."
                    }),
                    children: /*#__PURE__*/ (0, $5Wgfu.jsx)($b33bb22541d9cb53$var$Menu, {})
                })
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $d44a9c33f81e9675$export$2e2bcd8739ae039), {})
            },
            {
                path: "/help",
                element: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $5c95efe8ebc9847d$export$2e2bcd8739ae039), {})
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $3443972c976e6e83$export$2e2bcd8739ae039), {})
            },
            // {
            //   path: '/grocery',
            //   element: (
            //     <Suspense fallback={<h1>Loading...</h1>}>
            //       <Grocery />
            //     </Suspense>
            //   )
            // },
            {
                path: "/restaurantmenu/:resId",
                element: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $aOChP.Suspense), {
                    fallback: /*#__PURE__*/ (0, $5Wgfu.jsx)("h1", {
                        children: "Loading Restaurant Menu..."
                    }),
                    children: /*#__PURE__*/ (0, $5Wgfu.jsx)($b33bb22541d9cb53$var$RestaurantMenu, {})
                })
            },
            {
                path: "/",
                element: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $cce9f670e97b3efc$export$2e2bcd8739ae039), {})
            },
            {
                path: "/error",
                element: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $13be670d0ce4716d$export$2e2bcd8739ae039), {})
            }
        ]
    }
]);
const $b33bb22541d9cb53$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($3ffba8a88cb861dc$exports))).createRoot(document.getElementById("root"));
$b33bb22541d9cb53$var$root.render(/*#__PURE__*/ (0, $5Wgfu.jsx)((0, $aKZsc.RouterProvider), {
    router: $b33bb22541d9cb53$var$appRouter
}));


//# sourceMappingURL=index.d1a39a62.js.map
